/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createUntypedNodeFromDiscriminatorValue, type AdditionalDataHolder, type ApiError, type DateOnly, type Parsable, type ParseNode, type SerializationWriter, type UntypedNode } from '@microsoft/kiota-abstractions';

export interface AbandonedImageAssetsJobRequest extends Parsable {
    /**
     * When true (the default) the job only reports findings; nothing is deleted.
     */
    dryRun?: boolean | null;
    /**
     * Optional scope. When empty, every organization is reconciled. Assets underorganizations outside the scope are reported as unclassified and never touched.
     */
    organizationIds?: string[] | null;
}
/**
 * Represents the response containing the status of the Abandoned Image Assets Job.
 */
export interface AbandonedImageAssetsJobStatusResponse extends Parsable {
    /**
     * Whether this run only reported findings without deleting anything.
     */
    dryRun?: boolean | null;
    /**
     * The errorMessage property
     */
    errorMessage?: string | null;
    /**
     * The isSuccessfull property
     */
    isSuccessfull?: boolean | null;
    /**
     * Per-organization findings; only organizations with at least one asset appear.
     */
    organizations?: AbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages[] | null;
    /**
     * Assets whose id maps to an in-scope organization but has no Image document.
     */
    totalAbandoned?: number | null;
    /**
     * Abandoned assets actually deleted (always 0 on a dry run).
     */
    totalDeleted?: number | null;
    /**
     * Gets or sets the total number of organizations processed during the job.
     */
    totalOrganizations?: number | null;
    /**
     * How many assets the image CDN holds in total.
     */
    totalStoredAssets?: number | null;
    /**
     * Assets whose id maps to an in-scope organization and has an Image document.
     */
    totalTracked?: number | null;
    /**
     * Assets the job will never touch: ids without an organization prefix (logos, the 404placeholder, samples) or under an organization outside this run's scope.
     */
    unclassifiedAssets?: number | null;
    /**
     * A capped sample of the unclassified ids, for eyeballing what is being left alone.
     */
    unclassifiedSampleIds?: string[] | null;
}
/**
 * The stored-asset findings for one organization.
 */
export interface AbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages extends Parsable {
    /**
     * Assets with no Image document — candidates for deletion.
     */
    abandonedAssets?: number | null;
    /**
     * The abandoned asset ids, exactly as stored at the CDN.
     */
    abandonedImageIds?: string[] | null;
    /**
     * Abandoned assets actually deleted in this run.
     */
    deletedAssets?: number | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * Assets with a matching Image document.
     */
    trackedAssets?: number | null;
}
export interface AccessRequest extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * The accessRequestId property
     */
    accessRequestId?: string | null;
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The address1 property
     */
    address1?: string | null;
    /**
     * The address2 property
     */
    address2?: string | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The emailAddress property
     */
    emailAddress?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The postalCode property
     */
    postalCode?: string | null;
    /**
     * The research property
     */
    research?: AccessRequestResearch | null;
    /**
     * The stateProvince property
     */
    stateProvince?: string | null;
    /**
     * The status property
     */
    status?: AccessRequestStatus | null;
    /**
     * The statusChangedOn property
     */
    statusChangedOn?: Date | null;
    /**
     * The taxIdEIN property
     */
    taxIdEIN?: string | null;
}
export interface AccessRequestResearch extends Parsable {
    /**
     * The content property
     */
    content?: string | null;
    /**
     * The eligibilityScore property
     */
    eligibilityScore?: number | null;
    /**
     * The generatedAt property
     */
    generatedAt?: Date | null;
    /**
     * The generatedBy property
     */
    generatedBy?: string | null;
}
export interface AccessRequestResearchSettings extends Parsable {
    /**
     * The approvalCriteria property
     */
    approvalCriteria?: string | null;
    /**
     * The industryDescription property
     */
    industryDescription?: string | null;
}
export interface AccessRequestsPageSummary extends Parsable {
    /**
     * The approvedLast30Days property
     */
    approvedLast30Days?: number | null;
    /**
     * The approvedPrior30Days property
     */
    approvedPrior30Days?: number | null;
    /**
     * The asOf property
     */
    asOf?: Date | null;
    /**
     * The averageResponseDays property
     */
    averageResponseDays?: number | null;
    /**
     * The firstOrderRate property
     */
    firstOrderRate?: number | null;
    /**
     * The firstOrderRatePrior property
     */
    firstOrderRatePrior?: number | null;
    /**
     * The oldestPendingDays property
     */
    oldestPendingDays?: number | null;
    /**
     * The pending property
     */
    pending?: number | null;
    /**
     * The responseGoalDays property
     */
    responseGoalDays?: number | null;
}
export type AccessRequestStatus = (typeof AccessRequestStatusObject)[keyof typeof AccessRequestStatusObject];
export interface AccountSetup extends Parsable {
    /**
     * The isComplete property
     */
    isComplete?: boolean | null;
    /**
     * The nextStep property
     */
    nextStep?: Step | null;
    /**
     * The percentageComplete property
     */
    percentageComplete?: number | null;
    /**
     * The steps property
     */
    steps?: Step[] | null;
}
export interface ActivateCommissionPlanRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface ActivateSalesRepRequest extends Parsable {
    /**
     * OrganizationSalesRepId 
     */
    organizationSalesRepId?: string | null;
}
export interface ActiveCustomersKpi extends Parsable {
    /**
     * The activeCustomerCount property
     */
    activeCustomerCount?: number | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
}
export interface AddAdminUserRequest extends Parsable {
    /**
     * The email address of the user to assign the admin role to
     */
    email?: string | null;
}
export interface AddAdminUserResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface AddCustomerAttributeRequest extends Parsable {
    /**
     * The attribute property
     */
    attribute?: string | null;
}
export interface AddFulfillmentMethodRequest extends Parsable {
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
}
export interface AddItemRequest extends Parsable {
    /**
     * Append a new line even though the cart already holds this SKU (CU-86bcpta0t). A productflagged separateLines always gets its own line; for any other product the default keeps theusual rule, where a repeated SKU is refused and the client changes the existing line instead.
     */
    newLine?: boolean | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
}
export interface AddItemToListRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional product name captured alongside the SKU so the list can be rendered without acatalog lookup. It is a snapshot and does not track later catalog renames.
     */
    productName?: string | null;
    /**
     * Units to record against the SKU. Must be greater than zero, with at most two decimal places.
     */
    quantity?: number | null;
    /**
     * Product SKU to add. Stored as sent and matched against the list without regard to case;it is not validated against the product catalog.
     */
    sku?: string | null;
    /**
     * Optional free-form tag recording which client added the item, stored as sent and neverinterpreted by the API (the sales app sends "SalesApp").
     */
    source?: string | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface AddMarketCodeRequest extends Parsable {
    /**
     * The marketCode property
     */
    marketCode?: string | null;
}
export interface AddOrderStatusRequest extends Parsable {
    /**
     * The orderStatus property
     */
    orderStatus?: string | null;
}
export interface AddOrderTypeRequest extends Parsable {
    /**
     * The platform kind this order type maps to. Required: an organization names the type, but thekind is what the platform keys behaviour off, so a new one cannot be created without it.Read the available kinds from GET /api/organizations/order-kinds.
     */
    kind?: OrderKind | null;
    /**
     * The organization's own name for this order type — what reps and customers see.
     */
    orderType?: string | null;
}
export interface AddPriceTierRequest extends Parsable {
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface AddProductAttributeRequest extends Parsable {
    /**
     * The attribute property
     */
    attribute?: string | null;
}
export interface Address extends Parsable {
    /**
     * The address1 property
     */
    address1?: string | null;
    /**
     * The address2 property
     */
    address2?: string | null;
    /**
     * The addressType property
     */
    addressType?: AddressType | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The default property
     */
    defaultEscaped?: boolean | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The latitude property
     */
    latitude?: number | null;
    /**
     * The longitude property
     */
    longitude?: number | null;
    /**
     * The stateProvince property
     */
    stateProvince?: string | null;
    /**
     * The zipPostalCode property
     */
    zipPostalCode?: string | null;
}
export interface AddressComponent extends Parsable {
    /**
     * The long_name property
     */
    longName?: string | null;
    /**
     * The short_name property
     */
    shortName?: string | null;
    /**
     * The types property
     */
    types?: string[] | null;
}
export interface AddressDto extends Parsable {
    /**
     * The address1 property
     */
    address1?: string | null;
    /**
     * The address2 property
     */
    address2?: string | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The stateProvince property
     */
    stateProvince?: string | null;
    /**
     * The zipPostalCode property
     */
    zipPostalCode?: string | null;
}
export interface AddressInput extends Parsable {
    /**
     * The address1 property
     */
    address1?: string | null;
    /**
     * The address2 property
     */
    address2?: string | null;
    /**
     * The addressType property
     */
    addressType?: string | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The default property
     */
    defaultEscaped?: boolean | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The latitude property
     */
    latitude?: number | null;
    /**
     * The longitude property
     */
    longitude?: number | null;
    /**
     * The stateProvince property
     */
    stateProvince?: string | null;
    /**
     * The zipPostalCode property
     */
    zipPostalCode?: string | null;
}
export type AddressType = (typeof AddressTypeObject)[keyof typeof AddressTypeObject];
export interface AddSubscriptionItemRequest extends Parsable {
    /**
     * The price's catalog lookup key, e.g. storefront_monthly. A lookup key rather than a price idfor the same reason checkout takes one: it survives a price being replaced, and resolving itserver-side means the client never chooses what it will be charged.
     */
    lookupKey?: string | null;
}
export interface AddSubscriptionItemResponse extends Parsable {
    /**
     * What the organization is entitled to now the item is on the subscription.
     */
    entitlements?: string[] | null;
    /**
     * The subscription the item was added to.
     */
    subscriptionId?: string | null;
}
export interface AddTermRequest extends Parsable {
    /**
     * The payment term to add — free-form (e.g. NET30, COD, or a custom "2% 10 NET 30").
     */
    term?: string | null;
}
/**
 * The organization-scoping members every vendor request carries, in the shape the rest of the APIuses for sales-rep organization switching. RequireAgencyOrganization`1 readsthem to decide which organization the request is for.
 */
export interface AgencyScopedRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
}
export interface AiUsageBreakdownItem extends Parsable {
    /**
     * The callCount property
     */
    callCount?: number | null;
    /**
     * The costUsd property
     */
    costUsd?: number | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The operation property
     */
    operation?: string | null;
    /**
     * The tokens property
     */
    tokens?: number | null;
}
/**
 * Represents a request for API authentication.
 */
export interface ApiAuthenticationRequest extends Parsable {
    /**
     * The clientId property
     */
    clientId?: string | null;
    /**
     * The clientSecret property
     */
    clientSecret?: string | null;
    /**
     * The orgCode property
     */
    orgCode?: string | null;
}
export interface ApiAuthenticationResponse extends Parsable {
    /**
     * The accessToken property
     */
    accessToken?: string | null;
    /**
     * The expiresIn property
     */
    expiresIn?: number | null;
    /**
     * The tokenType property
     */
    tokenType?: string | null;
}
export interface ApiKey extends Parsable {
    /**
     * The accessScope property
     */
    accessScope?: string | null;
    /**
     * The key property
     */
    key?: string | null;
}
export interface AppliedPromotion extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The appliedVia property
     */
    appliedVia?: string | null;
    /**
     * The automatic property
     */
    automatic?: boolean | null;
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The campaignName property
     */
    campaignName?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The kind property
     */
    kind?: BenefitKind | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
    /**
     * The promotionName property
     */
    promotionName?: string | null;
    /**
     * The tierThreshold property
     */
    tierThreshold?: number | null;
}
export interface ApplyCartCodeRequest extends Parsable {
    /**
     * The code as typed; trimmed and matched case-insensitively.
     */
    code?: string | null;
}
export interface ApplyDiscountRequest extends Parsable {
    /**
     * The discount property
     */
    discount?: DiscountInput | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface ApproveAccessRequestRequest extends Parsable {
    /**
     * Indicates whether to create a new customer for this access request. Refused when therequester's account already has storefront access to a customer in this organization.
     */
    createCustomer?: boolean | null;
    /**
     * The customer number to associate the requester with. Required when CreateCustomeris false; optional when it is true (a new number is generated if not provided, and a suppliednumber is refused when a customer in the organization already has it, matchedcase-insensitively). Associating the requester with a customer they can already shop for isaccepted and changes nothing.
     */
    customerNumber?: string | null;
    /**
     * The organization price tier to put the new customer on. Only used when CreateCustomeris true; ignored otherwise. Must name one of the organization's price tiers (matchedcase-insensitively) or the built-in default tier. Omitted or blank means default.
     */
    priceTier?: string | null;
    /**
     * The payment terms to put on the new customer. Only used when CreateCustomer istrue; ignored otherwise. Must be one of the organization's terms (matched case-insensitively).Omitted or blank leaves the customer's terms empty.
     */
    terms?: string | null;
}
export interface ApproveAccessRequestResponse extends Parsable {
    /**
     * The ID of the approved access request
     */
    accessRequestId?: string | null;
    /**
     * True when the requester could already shop for the chosen customer, so the approval recordedthe decision but granted nothing new and sent no approval email.
     */
    alreadyHadAccess?: boolean | null;
    /**
     * The customer number that was created or used during approval
     */
    customerNumber?: string | null;
    /**
     * True when the approval email reached the mail provider. False when the approval itselfsucceeded but the notice could not be sent (renderer or provider unavailable); the adminshould tell the requester another way. Always false when AlreadyHadAccess.
     */
    emailSent?: boolean | null;
    /**
     * The ID of the user in the identity provider. Carries the same value asUserId — the identity provider's user id is the platform's user id.
     */
    identityProviderUserId?: string | null;
    /**
     * The ID of the approved user
     */
    userId?: string | null;
}
export interface ApproveCommissionStatementRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
    /**
     * The user property
     */
    user?: string | null;
}
/**
 * Makes existing products variants of a family.
 */
export interface AssignProductFamilyVariantsRequest extends Parsable {
    /**
     * The SKUs to assign, each with its option values.
     */
    variants?: AssignProductFamilyVariantsRequest_VariantAssignment[] | null;
}
export interface AssignProductFamilyVariantsRequest_VariantAssignment extends Parsable {
    /**
     * Option values keyed by option, e.g. { "Color": "Solid Black", "Size": "2XL" }.Display names or slugs; unknown ones are registered in the organization's product options.
     */
    optionValues?: AssignProductFamilyVariantsRequest_VariantAssignment_optionValues | null;
    /**
     * The sku property
     */
    sku?: string | null;
}
/**
 * Option values keyed by option, e.g. { "Color": "Solid Black", "Size": "2XL" }.Display names or slugs; unknown ones are registered in the organization's product options.
 */
export interface AssignProductFamilyVariantsRequest_VariantAssignment_optionValues extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface AssignProductFamilyVariantsResponse extends Parsable {
    /**
     * The family after the assignment, with its summary recomputed.
     */
    family?: ProductFamily | null;
    /**
     * SKUs that had no product to assign. Nothing is created for them.
     */
    missingSkus?: string[] | null;
}
/**
 * Grants one storefront user access to one customer in the caller's organization.
 */
export interface AssociateCustomerRequest extends Parsable {
    /**
     * The customer the user should be able to shop for. Must resolve to a real customer in thisorganization.
     */
    customerNumber?: string | null;
    /**
     * The identity provider user id to grant access to — the UserId the storefront-users listingreturns.
     */
    userId?: string | null;
}
export interface AssociateCustomerResponse extends Parsable {
    /**
     * The association property
     */
    association?: UserCustomer | null;
}
/**
 * A custom export format that can be enabled for an organization.
 */
export interface AvailableExportFormatDto extends Parsable {
    /**
     * What an admin sees in the export menu once enabled (e.g. SAP B1 (DTW)).
     */
    displayName?: string | null;
    /**
     * The key to send when enabling this format (e.g. sap-b1-dtw).
     */
    key?: string | null;
}
export interface AverageOrderValueKpi extends Parsable {
    /**
     * The averageOrderValue property
     */
    averageOrderValue?: number | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
}
/**
 * Request to record an organization's earlier cart shares on their carts' Activity.
 */
export interface BackfillCartShareEventsRequest extends Parsable {
    /**
     * Report what would be recorded without writing. Defaults to true, so a caller has to opt into writing — run it once to read the counts, then again with false.
     */
    dryRun?: boolean | null;
}
/**
 * What one run of the cart share backfill found and did.
 */
export interface BackfillCartShareEventsResponse extends Parsable {
    /**
     * Shares already on their cart's Activity: recorded when sent, or by an earlier run.
     */
    alreadyRecorded?: number | null;
    /**
     * True when nothing was written; Recorded then counts what would have been.
     */
    dryRun?: boolean | null;
    /**
     * Message ids of the shares whose event could not be stored; re-running retries them.
     */
    failed?: string[] | null;
    /**
     * Shares whose snapshot names no cart, so there is no Activity to put them on.
     */
    noCart?: number | null;
    /**
     * Shares that reached no one (no email or text went out), which are never recorded.
     */
    notSent?: number | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * Shares recorded on their cart's Activity by this run (or that would be, in a dry run).
     */
    recorded?: number | null;
    /**
     * Cart shares in the organization.
     */
    sharesExamined?: number | null;
    /**
     * True when every share that needed recording was recorded.
     */
    success?: boolean | null;
}
/**
 * Request to re-resolve the sales-rep snapshots on an organization's existing orders.
 */
export interface BackfillOrderSalesRepsRequest extends Parsable {
    /**
     * Report what would change without writing. Defaults to true, so a caller has to opt in tomutating orders — run it once to read the counters and the unresolvable rep numbers, thenagain with false.
     */
    dryRun?: boolean | null;
    /**
     * Also rewrite snapshots carrying neither a sales rep id nor a rep number, stamping the"notassigned" sentinel on them. There is nothing to resolve on those orders, so this is theonly thing it can do.
     */
    normalizeMissingReps?: boolean | null;
}
/**
 * Counters describing what a backfill run did (or, on a dry run, would have done).
 */
export interface BackfillOrderSalesRepsResponse extends Parsable {
    /**
     * Whether this run only reported. True means nothing was written.
     */
    dryRun?: boolean | null;
    /**
     * Document ids whose write failed; re-running heals them.
     */
    failed?: string[] | null;
    /**
     * Orders matching the "snapshot needs work" filter that were considered.
     */
    ordersExamined?: number | null;
    /**
     * Orders whose snapshot gained a real sales rep id.
     */
    ordersHealed?: number | null;
    /**
     * Orders whose snapshot was set to the "notassigned" sentinel because its rep number matchedno rep in the organization. These are the ones to look at: each is revenue filed under a repwho has not been onboarded, and a re-run upgrades them once that happens.
     */
    ordersSetNotAssigned?: number | null;
    /**
     * Orders already correct, left untouched — a re-run should report only these.
     */
    ordersUnchanged?: number | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The success property
     */
    success?: boolean | null;
    /**
     * Distinct rep numbers that matched no rep in this organization.
     */
    unresolvableRepNumbers?: string[] | null;
}
export interface BackfillSubscriptionsResponse extends Parsable {
    /**
     * The activeReps property
     */
    activeReps?: number | null;
    /**
     * Seats the organization allows after the backfill.
     */
    seats?: number | null;
    /**
     * Subscriptions found in the billing provider for this organization.
     */
    subscriptionsFound?: number | null;
    /**
     * Subscriptions recorded or updated on the organization.
     */
    subscriptionsRecorded?: number | null;
}
/**
 * Represents the outcome of a per-identity sync channel backfill run.
 */
export interface BackfillUserChannelsResponse extends Parsable {
    /**
     * Gets or sets the number of reps whose sync user was granted the channel. Granting isidempotent, so a rep who already held it is still counted here.
     */
    channelsGranted?: number | null;
    /**
     * Gets or sets the email addresses whose grant failed. The run continues past a failure, sothese can be healed by re-running the backfill.
     */
    failed?: string[] | null;
    /**
     * Gets or sets the organization the backfill ran against.
     */
    organizationId?: string | null;
    /**
     * Gets or sets the number of Sales Representatives examined.
     */
    repsExamined?: number | null;
    /**
     * Gets or sets the number of reps skipped because they carry no identity provider user id.
     */
    skippedBlankIdentity?: number | null;
    /**
     * Gets or sets whether every examined rep was either granted or deliberately skipped.
     */
    success?: boolean | null;
}
export interface BaseEntity extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface Benefit extends Parsable {
    /**
     * The discountType property
     */
    discountType?: DiscountType | null;
    /**
     * The kind property
     */
    kind?: BenefitKind | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The tiers property
     */
    tiers?: BenefitTier[] | null;
    /**
     * The value property
     */
    value?: number | null;
}
export interface BenefitInput extends Parsable {
    /**
     * Order and line discounts: Amount or Percentage.
     */
    discountType?: DiscountType | null;
    /**
     * The kind property
     */
    kind?: BenefitKind | null;
    /**
     * Free gift: how many units.
     */
    quantity?: number | null;
    /**
     * Free gift: the catalog SKU.
     */
    sku?: string | null;
    /**
     * Order discounts only: ascending thresholds, each with its own value.
     */
    tiers?: BenefitTierInput[] | null;
    /**
     * Order and line discounts: the amount (per unit on a line) or percentage. An order discount with tiers may omit it.
     */
    value?: number | null;
}
export type BenefitKind = (typeof BenefitKindObject)[keyof typeof BenefitKindObject];
export interface BenefitTier extends Parsable {
    /**
     * The threshold property
     */
    threshold?: number | null;
    /**
     * The value property
     */
    value?: number | null;
}
export interface BenefitTierInput extends Parsable {
    /**
     * The threshold property
     */
    threshold?: number | null;
    /**
     * The value property
     */
    value?: number | null;
}
export interface BillingAddress extends Parsable {
    /**
     * The address1 property
     */
    address1?: string | null;
    /**
     * The address2 property
     */
    address2?: string | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The company property
     */
    company?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The state property
     */
    state?: string | null;
    /**
     * The zipCode property
     */
    zipCode?: string | null;
}
/**
 * One invoice the organization has been billed by us for its subscription.            Not to be confused with /api/invoices, which is the organization invoicing its own customers fororders. These are the opposite direction — money the organization owes, not money owed to it.
 */
export interface BillingInvoice extends Parsable {
    /**
     * The amountDue property
     */
    amountDue?: number | null;
    /**
     * The amountPaid property
     */
    amountPaid?: number | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The date property
     */
    date?: Date | null;
    /**
     * The dueDate property
     */
    dueDate?: Date | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * Invoice status: draft, open, paid, uncollectible or void.
     */
    status?: string | null;
    /**
     * Amounts in the currency's minor unit (4500 = $45.00).
     */
    total?: number | null;
}
export interface BillingInvoicePdfResponse extends Parsable {
    /**
     * Stripe's hosted PDF link. Not stored — request a fresh one each time.
     */
    url?: string | null;
    /**
     * The validUntil property
     */
    validUntil?: Date | null;
}
export interface BillingInvoicesResponse extends Parsable {
    /**
     * The invoices property
     */
    invoices?: BillingInvoice[] | null;
}
export interface BulkDeleteDocumentsRequest extends Parsable {
    /**
     * The documents to delete: at least one id and at most 100. Every id must still exist — onethat does not fails the whole call, after the rest have already been deleted.
     */
    documentIds?: string[] | null;
}
export type BulkImportCustomerUserOutcome = (typeof BulkImportCustomerUserOutcomeObject)[keyof typeof BulkImportCustomerUserOutcomeObject];
/**
 * The outcome of one row, so an operator can reconcile the import against their export file.
 */
export interface BulkImportCustomerUserResult extends Parsable {
    /**
     * The row's customer number, trimmed.
     */
    customerNumber?: string | null;
    /**
     * The row's email address, trimmed.
     */
    email?: string | null;
    /**
     * Why the row failed. Null unless Outcome is Failed.
     */
    errorEscaped?: string | null;
    /**
     * Whether the identity was created, already existed, or the row failed.
     */
    outcome?: BulkImportCustomerUserOutcome | null;
    /**
     * 1-based position of the row in the submitted batch.
     */
    rowNumber?: number | null;
    /**
     * The temporary password set for this user, populated only when the import ran inGenerated. Returned once — it is not stored anywhere andcannot be recovered from a later call, so an operator who loses it has to re-run the importfor that user.It is reported on a failed row too, whenever the password reached the identity providerbefore the row went wrong. The credential is live on that identity either way, so withholding it would leave theoperator unable to reconcile a user who really does have a working password.
     */
    temporaryPassword?: string | null;
    /**
     * The id of the UserCustomer association backing the CustomerNumber claim. Populated on anyrow that did not fail — that association is what lets the user through storefront login.
     */
    userCustomerId?: string | null;
    /**
     * The identity provider user id, set on any row that did not fail.
     */
    userId?: string | null;
}
/**
 * One row of a legacy-site user export: the person to provision a storefront login for,and the customer account they placed orders against on the old site.
 */
export interface BulkImportCustomerUserRow extends Parsable {
    /**
     * The customer this user buys on behalf of. Must already exist in the organization —import customers first (PUT /api/customers/bulk).
     */
    customerNumber?: string | null;
    /**
     * The user's email address. This is their sign-in identity and the natural key for the row —rows sharing an email resolve to a single identity.
     */
    email?: string | null;
    /**
     * The user's given name. Optional; blank is accepted.
     */
    firstName?: string | null;
    /**
     * The user's family name. Optional; blank is accepted.
     */
    lastName?: string | null;
    /**
     * The user's phone number. Optional; blank is accepted.
     */
    phoneNumber?: string | null;
    /**
     * The temporary password to set for this user. Required when the import runs inSupplied, and rejected in any other mode so that apassword can never be supplied and then silently ignored.
     */
    temporaryPassword?: string | null;
}
/**
 * A batch of legacy users to provision. The target organization comes from the caller's ownclaims — there is deliberately no OrgCodes switching here, because the identity providerorganization the identities are created in (OrgCode) has to stay in step withthe platform organization the associations are written to.
 */
export interface BulkImportCustomerUsersRequest extends Parsable {
    /**
     * How to provision passwords. Defaults to None, so anexisting caller that omits it gets exactly the behaviour it had before this option existed.
     */
    temporaryPasswordMode?: TemporaryPasswordMode | null;
    /**
     * The users to provision. Chunk larger exports across several requests.
     */
    users?: BulkImportCustomerUserRow[] | null;
}
/**
 * Per-row outcomes for a bulk customer-user import, plus totals for a quick read.
 */
export interface BulkImportCustomerUsersResponse extends Parsable {
    /**
     * How many rows matched an identity that already existed.
     */
    alreadyExisted?: number | null;
    /**
     * How many rows created a new sign-in identity.
     */
    created?: number | null;
    /**
     * How many rows failed. Inspect Results for the reasons.
     */
    failed?: number | null;
    /**
     * One entry per submitted row, in submission order.
     */
    results?: BulkImportCustomerUserResult[] | null;
    /**
     * How many rows were submitted.
     */
    totalRows?: number | null;
}
export interface BulkMoveDocumentsRequest extends Parsable {
    /**
     * The documents to move: at least one id and at most 100. Ids that no longer exist are skippedrather than reported.
     */
    documentIds?: string[] | null;
    /**
     * The folder to file them all under. Send null to move them to the top level. The id is notchecked, so take it from the folders endpoints rather than composing one.
     */
    targetFolderId?: string | null;
}
/**
 * Bulk write totals for one endpoint on one UTC day. Doubles as a summary query row and a response item.
 */
export interface BulkWriteDailyTotal extends Parsable {
    /**
     * Calls received, successful or not.
     */
    callCount?: number | null;
    /**
     * The UTC day, as yyyy-MM-dd.
     */
    day?: string | null;
    /**
     * Documents received across all calls, whether or not they were written.
     */
    documentCount?: number | null;
    /**
     * The endpoint's operation id, e.g. CreateManyProducts.
     */
    endpoint?: string | null;
    /**
     * Calls that did not succeed. Their documents are still counted in DocumentCount.
     */
    failedCallCount?: number | null;
}
/**
 * A postal address read from a card, line by line.
 */
export interface BusinessCardAddress extends Parsable {
    /**
     * The street line: number and street.
     */
    address1?: BusinessCardField | null;
    /**
     * Suite, unit, floor or PO box.
     */
    address2?: BusinessCardField | null;
    /**
     * The city or town.
     */
    city?: BusinessCardField | null;
    /**
     * The country, as its English name (e.g. United States).
     */
    country?: BusinessCardField | null;
    /**
     * The state or province, as its postal abbreviation where the country has one (e.g. CA, ON).
     */
    stateProvince?: BusinessCardField | null;
    /**
     * The ZIP or postal code.
     */
    zipPostalCode?: BusinessCardField | null;
}
/**
 * One value read from a card and how sure the reading is.
 */
export interface BusinessCardField extends Parsable {
    /**
     * From 0 to 1: how confident the reading is that the value is legible, correctly transcribedand belongs in this field. 0 when there is no value. Below about 0.7 deserves a second look.
     */
    confidence?: number | null;
    /**
     * The value, or null when the card does not show one.
     */
    value?: string | null;
}
export interface Campaign extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * The activatedAt property
     */
    activatedAt?: Date | null;
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The channels property
     */
    channels?: string[] | null;
    /**
     * The customerNumbers property
     */
    customerNumbers?: string[] | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The marketCodes property
     */
    marketCodes?: string[] | null;
    /**
     * The maxRedemptions property
     */
    maxRedemptions?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The orderTypes property
     */
    orderTypes?: string[] | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The promotions property
     */
    promotions?: Promotion[] | null;
    /**
     * The redemptionCount property
     */
    redemptionCount?: number | null;
    /**
     * The trigger property
     */
    trigger?: CampaignTrigger | null;
    /**
     * The validFrom property
     */
    validFrom?: Date | null;
    /**
     * The validTo property
     */
    validTo?: Date | null;
}
/**
 * A campaign as the Web Admin builder sends it: the audience, the trigger, the cap and theembedded promotions. Counters (redemptionCount) are never part of the input — they areserver-managed (D11).
 */
export interface CampaignInput extends Parsable {
    /**
     * Channels the campaign is limited to ("SalesApp", "Web"); empty or null for every channel.
     */
    channels?: string[] | null;
    /**
     * Customers the campaign is limited to; empty or null for everyone.
     */
    customerNumbers?: string[] | null;
    /**
     * Optional description, up to 2000 characters.
     */
    description?: string | null;
    /**
     * Market codes the campaign is limited to; empty or null for every market.
     */
    marketCodes?: string[] | null;
    /**
     * How many orders may redeem the campaign in total; null for unlimited.
     */
    maxRedemptions?: number | null;
    /**
     * Display name, up to 200 characters.
     */
    name?: string | null;
    /**
     * Order type slugs the campaign is limited to; empty or null for every type.
     */
    orderTypes?: string[] | null;
    /**
     * The promotions, each with its conditions and exactly one benefit.
     */
    promotions?: PromotionInput[] | null;
    /**
     * Automatic (applies with no code) or Code (needs one of its discount codes).
     */
    trigger?: CampaignTrigger | null;
    /**
     * Start of the window, inclusive; null for no start.
     */
    validFrom?: Date | null;
    /**
     * End of the window, inclusive; null for no end.
     */
    validTo?: Date | null;
}
export type CampaignTrigger = (typeof CampaignTriggerObject)[keyof typeof CampaignTriggerObject];
export interface CancelInvoiceRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface CartActor extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The syncUser property
     */
    syncUser?: string | null;
    /**
     * The type property
     */
    type?: CartActorType | null;
}
export type CartActorType = (typeof CartActorTypeObject)[keyof typeof CartActorTypeObject];
export interface CartEvent extends Parsable {
    /**
     * The action property
     */
    action?: CartEventAction | null;
    /**
     * The actor property
     */
    actor?: CartActor | null;
    /**
     * The after property
     */
    after?: string | null;
    /**
     * The before property
     */
    before?: string | null;
    /**
     * The cartEventId property
     */
    cartEventId?: string | null;
    /**
     * The cartId property
     */
    cartId?: string | null;
    /**
     * The note property
     */
    note?: string | null;
    /**
     * The occurredAt property
     */
    occurredAt?: Date | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The recordedAt property
     */
    recordedAt?: Date | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The surface property
     */
    surface?: string | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
}
export type CartEventAction = (typeof CartEventActionObject)[keyof typeof CartEventActionObject];
export interface CartItem extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The categoryPaths property
     */
    categoryPaths?: string[] | null;
    /**
     * The discount property
     */
    discount?: Discount | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * The gift property
     */
    gift?: GiftMarker | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The lineId property
     */
    lineId?: string | null;
    /**
     * The minimumOrderQuantity property
     */
    minimumOrderQuantity?: number | null;
    /**
     * The note property
     */
    note?: string | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * The priceOverride property
     */
    priceOverride?: PriceOverride | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The quantityIncrement property
     */
    quantityIncrement?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The subTotal property
     */
    subTotal?: number | null;
    /**
     * The subTotalFormatted property
     */
    subTotalFormatted?: string | null;
    /**
     * The taxCategory property
     */
    taxCategory?: string | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
}
export interface CartLine extends Parsable {
    /**
     * The cancelDate property
     */
    cancelDate?: DateOnly | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountPercent property
     */
    discountPercent?: number | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The isOpeningOrder property
     */
    isOpeningOrder?: boolean | null;
    /**
     * The minimumAmount property
     */
    minimumAmount?: number | null;
    /**
     * The noteToVendor property
     */
    noteToVendor?: string | null;
    /**
     * The orderType property
     */
    orderType?: string | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The priceLevel property
     */
    priceLevel?: string | null;
    /**
     * The savedForLater property
     */
    savedForLater?: boolean | null;
    /**
     * The shipDate property
     */
    shipDate?: DateOnly | null;
    /**
     * The shipWindowName property
     */
    shipWindowName?: string | null;
    /**
     * The status property
     */
    status?: CartLineStatus | null;
    /**
     * The subtotal property
     */
    subtotal?: number | null;
    /**
     * The terms property
     */
    terms?: string | null;
    /**
     * The total property
     */
    total?: number | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
}
export type CartLineStatus = (typeof CartLineStatusObject)[keyof typeof CartLineStatusObject];
export interface CartPriceChange extends Parsable {
    /**
     * The lineId property
     */
    lineId?: string | null;
    /**
     * The newPrice property
     */
    newPrice?: number | null;
    /**
     * The oldPrice property
     */
    oldPrice?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
}
export interface CartPriceRefreshSummary extends Parsable {
    /**
     * The changes property
     */
    changes?: CartPriceChange[] | null;
    /**
     * The priceAgeDays property
     */
    priceAgeDays?: number | null;
    /**
     * The refreshedAtUtc property
     */
    refreshedAtUtc?: Date | null;
}
export interface CartPricingSettings extends Parsable {
    /**
     * The allowDecimalQuantities property
     */
    allowDecimalQuantities?: boolean | null;
    /**
     * The allowLineItemDiscounts property
     */
    allowLineItemDiscounts?: boolean | null;
    /**
     * The allowOrderDiscounts property
     */
    allowOrderDiscounts?: boolean | null;
    /**
     * The allowPriceOverride property
     */
    allowPriceOverride?: boolean | null;
    /**
     * The refreshStalePrices property
     */
    refreshStalePrices?: boolean | null;
    /**
     * The stalePriceAgeDays property
     */
    stalePriceAgeDays?: number | null;
}
export interface CartPromotionSummary extends Parsable {
    /**
     * The applied property
     */
    applied?: AppliedPromotion[] | null;
    /**
     * The appliedAmount property
     */
    appliedAmount?: number | null;
    /**
     * The appliedCode property
     */
    appliedCode?: string | null;
    /**
     * The appliedCodeSkip property
     */
    appliedCodeSkip?: PromotionSkip | null;
    /**
     * The codeCampaigns property
     */
    codeCampaigns?: CodeCampaignSummary[] | null;
    /**
     * The lineCount property
     */
    lineCount?: number | null;
    /**
     * The pending property
     */
    pending?: PendingPromotion[] | null;
}
export interface CartReview extends Parsable {
    /**
     * The customerNote property
     */
    customerNote?: string | null;
    /**
     * The repNote property
     */
    repNote?: string | null;
    /**
     * The requestedAtUtc property
     */
    requestedAtUtc?: Date | null;
    /**
     * The returnedAtUtc property
     */
    returnedAtUtc?: Date | null;
    /**
     * The status property
     */
    status?: string | null;
}
/**
 * One line of a shared cart.
 */
export interface CartShareLine extends Parsable {
    /**
     * The money taken off the line, as on the cart: its discount plus the value of any free giftunits, so LineTotal is the unit price × quantity less this. Null on a sharethat did not say.
     */
    discountAmount?: number | null;
    /**
     * The line's discount record, a promotion's or the rep's; null when the line has none.
     */
    discountDetail?: DiscountDto | null;
    /**
     * Free units a promotion put on the line, or null.
     */
    gift?: GiftMarkerDto | null;
    /**
     * The lineTotal property
     */
    lineTotal?: number | null;
    /**
     * The note property
     */
    note?: string | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The unitPrice property
     */
    unitPrice?: number | null;
}
/**
 * One line of the shared cart.
 */
export interface CartShareLineRequest extends Parsable {
    /**
     * The money taken off the line, as on the cart: its discount plus the value of any free giftunits, so LineTotal is the unit price × quantity less this. Null when thesender did not say.
     */
    discountAmount?: number | null;
    /**
     * The line's discount record: a promotion's or the rep's. Null when the line has none.
     */
    discountDetail?: DiscountDto | null;
    /**
     * Free units a promotion put on the line, or null.
     */
    gift?: GiftMarkerDto | null;
    /**
     * The lineTotal property
     */
    lineTotal?: number | null;
    /**
     * Optional rep note for this line.
     */
    note?: string | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The unitPrice property
     */
    unitPrice?: number | null;
}
/**
 * The cart exactly as the sales rep shared it. Copied onto the message at send time rather thanreferenced, so the customer sees what the rep sent even after the cart is edited, checked out,or deleted — and so a cart built offline on the rep's device can be shared before it hasreplicated to the server. Amounts are raw decimals in CurrencyCode; consumersformat them.
 */
export interface CartShareSnapshot extends Parsable {
    /**
     * The discount code the cart held, normalized (trimmed, upper-cased); null when none.
     */
    appliedCode?: string | null;
    /**
     * One row per promotion applied to the cart, in the evaluator's order; empty when none.
     */
    appliedPromotions?: AppliedPromotion[] | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The order-level discount amount; DiscountDetail says what it was.
     */
    discount?: number | null;
    /**
     * The order-level discount record behind Discount. A promotion's carries itscampaign and promotion ids, with the promotion's name as the description; a rep's carriesneither. Null when there is no order-level discount, or the sender did not say.
     */
    discountDetail?: DiscountDto | null;
    /**
     * Set when a promotion waived shipping. Shipping is then zero, and this keepswhat it was before the waiver.
     */
    freeShipping?: FreeShippingEntitlement | null;
    /**
     * Total units across every line. Fractional once any line is; whole values keep serializing as integers.
     */
    itemCount?: number | null;
    /**
     * The lines property
     */
    lines?: CartShareLine[] | null;
    /**
     * The cart's order note as shared; null when the cart had none. Distinct from the rep's message on the message itself.
     */
    notes?: string | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The shipping property
     */
    shipping?: number | null;
    /**
     * The shoppingCartId property
     */
    shoppingCartId?: string | null;
    /**
     * The subtotal property
     */
    subtotal?: number | null;
    /**
     * The tax property
     */
    tax?: number | null;
    /**
     * The total property
     */
    total?: number | null;
}
/**
 * The shared cart. Amounts are in CurrencyCode.
 */
export interface CartShareSnapshotRequest extends Parsable {
    /**
     * The discount code the cart holds, whether or not it currently applies.
     */
    appliedCode?: string | null;
    /**
     * One row per promotion applied to the cart, in the evaluator's order.
     */
    appliedPromotions?: AppliedPromotion[] | null;
    /**
     * The customer's company name as shown on the cart.
     */
    companyName?: string | null;
    /**
     * ISO 4217 currency code the amounts are in, e.g. USD.
     */
    currencyCode?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The order-level discount amount; DiscountDetail says what it was.
     */
    discount?: number | null;
    /**
     * The cart's order-level discount record behind Discount: a promotion's (withits campaign and promotion ids, and the promotion's name as the description) or one the repentered by hand. Null when the cart has no order-level discount.
     */
    discountDetail?: DiscountDto | null;
    /**
     * Set when a promotion waived shipping, with what shipping was before the waiver.
     */
    freeShipping?: FreeShippingEntitlement | null;
    /**
     * At least one line is required.
     */
    lines?: CartShareLineRequest[] | null;
    /**
     * The cart's order note, as the rep entered it on the cart. Optional; shown in the email and theonline view under its own heading, separate from the rep's message in Body.Not included in the text message.
     */
    notes?: string | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The shipping property
     */
    shipping?: number | null;
    /**
     * Identifier of the cart on the rep's device; recorded for reference, never looked up.
     */
    shoppingCartId?: string | null;
    /**
     * The subtotal property
     */
    subtotal?: number | null;
    /**
     * The tax property
     */
    tax?: number | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface CartsPageSummary extends Parsable {
    /**
     * The asOf property
     */
    asOf?: Date | null;
    /**
     * The checkedOutLast30Days property
     */
    checkedOutLast30Days?: number | null;
    /**
     * The conversionGoal property
     */
    conversionGoal?: number | null;
    /**
     * The conversionRate property
     */
    conversionRate?: number | null;
    /**
     * The openCarts property
     */
    openCarts?: number | null;
    /**
     * The openValue property
     */
    openValue?: number | null;
    /**
     * The overFourteenDays property
     */
    overFourteenDays?: number | null;
    /**
     * The overFourteenDaysValue property
     */
    overFourteenDaysValue?: number | null;
    /**
     * The sevenToFourteenDays property
     */
    sevenToFourteenDays?: number | null;
    /**
     * The stillOpenFromLast30Days property
     */
    stillOpenFromLast30Days?: number | null;
    /**
     * The underSevenDays property
     */
    underSevenDays?: number | null;
}
/**
 * A sellable product from the billing catalog with its available prices — one entry per catalogproduct, each carrying the recurring prices it can be bought on.
 */
export interface CatalogItem extends Parsable {
    /**
     * Always empty on the current catalog: nothing restricts what may be bought together, so anycombination of products is valid. Retained for backward compatibility.
     */
    applicableItemIds?: string[] | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The prices property
     */
    prices?: CatalogItemPrice[] | null;
    /**
     * Unused on the current catalog, which has no plan/add-on distinction — every product isindependently sellable. Retained for backward compatibility.
     */
    type?: string | null;
    /**
     * What one unit represents on a per-seat product, e.g. rep — the catalog's own unit label,and what a quantity control should say. Null when the product doesn't set one.
     */
    unit?: string | null;
}
export interface CatalogItemPrice extends Parsable {
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * Billing period length, paired with PeriodUnit (e.g. 1 month).
     */
    period?: number | null;
    /**
     * The periodUnit property
     */
    periodUnit?: string | null;
    /**
     * Price in the currency's minor unit (e.g. 4500 = $45.00).
     */
    price?: number | null;
    /**
     * per_unit when the quantity is a number of seats, flat_fee otherwise. This is ourown wire value rather than the billing provider's, whose equivalent reports per_unit forevery standard recurring price — flat-rate ones included — so it cannot tell the two apart.
     */
    pricingModel?: string | null;
    /**
     * Quantity limits for this price. The billing provider enforces a minimum only in its own hostedportal, never on its API, so surfacing the limit here is what keeps a plan picker from offering aquantity our checkout will then refuse.
     */
    quantityLimits?: QuantityLimits | null;
}
export interface Category extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The breadcrumb property
     */
    breadcrumb?: string | null;
    /**
     * The categoryId property
     */
    categoryId?: string | null;
    /**
     * The imageUpdatedAt property
     */
    imageUpdatedAt?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The sortOrder property
     */
    sortOrder?: number | null;
    /**
     * The subCategories property
     */
    subCategories?: Category[] | null;
}
export interface CategoryDto extends AdditionalDataHolder, Category, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The imageUrl property
     */
    imageUrl?: string | null;
}
export interface CategoryRevenueRanking extends Parsable {
    /**
     * The category property
     */
    category?: string | null;
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The productCount property
     */
    productCount?: number | null;
    /**
     * The totalRevenue property
     */
    totalRevenue?: number | null;
}
export interface ChangeTaskStatusRequest extends Parsable {
    /**
     * Display name of whoever completed the task, up to 200 characters. Required when the status isCompleted and ignored otherwise. Client-stamped, like the creator's name; the completer'sidentity is taken from the token.
     */
    completedByName?: string | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * The status to move to: Open (reopens a task that is in progress, completed or cancelled),InProgress (starts an open task), Completed or Cancelled (either from Open or InProgress).
     */
    status?: TaskItemStatus | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface ChannelTrendPoint extends Parsable {
    /**
     * The otherOrders property
     */
    otherOrders?: number | null;
    /**
     * The periodStart property
     */
    periodStart?: string | null;
    /**
     * The repAssistedOrders property
     */
    repAssistedOrders?: number | null;
    /**
     * The salesAppOrders property
     */
    salesAppOrders?: number | null;
    /**
     * The storefrontOrders property
     */
    storefrontOrders?: number | null;
}
export interface CheckAccessRequestExistsResponse extends Parsable {
    /**
     * Indicates whether an access request exists for the given email address in the organization
     */
    exists?: boolean | null;
}
export interface CheckInSalesRepDeviceRequest extends Parsable {
    /**
     * The appVersion property
     */
    appVersion?: string | null;
    /**
     * Corroborates the reported AppVersion; the app sends it on every call.
     */
    appVersionHeader?: string | null;
    /**
     * The buildNumber property
     */
    buildNumber?: string | null;
    /**
     * Stable per-install device id (Keychain-backed on the app side).
     */
    deviceId?: string | null;
    /**
     * The deviceModel property
     */
    deviceModel?: string | null;
    /**
     * When the app last completed a login, read from its own storage — the API never sees the login itself.
     */
    lastLoginAt?: Date | null;
    /**
     * Optional by convention — a required OrgCodes binding 400s every caller that doesn't send the header.
     */
    orgCodes?: string[] | null;
    /**
     * The osVersion property
     */
    osVersion?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface CheckInSalesRepDeviceResponse extends Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The lastSeenAt property
     */
    lastSeenAt?: Date | null;
}
export interface CheckoutBillingAddress extends Parsable {
    /**
     * The address1 property
     */
    address1?: string | null;
    /**
     * The address2 property
     */
    address2?: string | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The stateProvince property
     */
    stateProvince?: string | null;
    /**
     * The zipPostalCode property
     */
    zipPostalCode?: string | null;
}
export interface CheckoutItem extends Parsable {
    /**
     * The price's Stripe lookup key, e.g. sales_monthly. Deliberately not a price id: a lookup keysurvives a price being replaced, and resolving it server-side means the client never chooses whatit will be charged.
     */
    lookupKey?: string | null;
    /**
     * How many units. Ignored for a flat-rate price, which is always bought as one.
     */
    quantity?: number | null;
}
export interface CheckoutPageResponse extends Parsable {
    /**
     * The createdAt property
     */
    createdAt?: number | null;
    /**
     * The embed property
     */
    embed?: boolean | null;
    /**
     * The expiresAt property
     */
    expiresAt?: number | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The state property
     */
    state?: string | null;
    /**
     * Chargebee's hosted page type (checkout_new_for_items), or PortalSessionTypewhen the organization already has a subscription and Url points at the self-serviceportal instead of a new checkout.
     */
    type?: string | null;
    /**
     * Where to send the browser. Callers can redirect to this without inspecting Type.
     */
    url?: string | null;
}
export interface CodeCampaignSummary extends Parsable {
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The validTo property
     */
    validTo?: Date | null;
}
export interface ColumnMappingSuggestion extends Parsable {
    /**
     * The next most likely targets, most likely first, with their probabilities.
     */
    alternates?: MappingAlternate[] | null;
    /**
     * 0 (no preference between the targets) to 1 (certain). The client pre-selects by band.
     */
    confidence?: number | null;
    /**
     * Set exactly when Suggested is new-attribute or new-price-tier: what tocreate before the column can be mapped. Creating it changes the organization for every laterimport, so offer it for the admin to confirm rather than applying it, whatever the confidence.
     */
    create?: MappingCreateProposal | null;
    /**
     * The column's header, echoed from the request.
     */
    header?: string | null;
    /**
     * The suggested target name; skip when the column should stay unmapped; or, on Products andCustomers imports, new-attribute / new-price-tier (Products only) when the columnholds an attribute or tier price the organization does not have yet — see Create.
     */
    suggested?: string | null;
}
/**
 * One row on a commission statement: the commission earned from a single invoice, broken down byline. Only invoices credited to the statement's sales rep, dated inside the statement period,issued or (partly) paid, and carrying a payment appear as entries.
 */
export interface CommissionEntryDto extends Parsable {
    /**
     * How much of the invoice had been paid when the statement was generated.
     */
    amountPaid?: number | null;
    /**
     * The invoice's currency. Amounts on this entry are in it.
     */
    currencyCode?: string | null;
    /**
     * The invoice's customer. This is what a customer override is matched against, so it decideswhether the plan's own rules or an override's rules were used for these lines.
     */
    customerNumber?: string | null;
    /**
     * Identifies this entry within the statement.
     */
    entryId?: string | null;
    /**
     * The invoice date. Both the statement period and the effective range of any customer overrideare tested against this date.
     */
    invoiceDate?: Date | null;
    /**
     * The invoice this commission was earned on.
     */
    invoiceId?: string | null;
    /**
     * The invoice's human-readable number, where the invoice carries one.
     */
    invoiceNumber?: string | null;
    /**
     * The invoice's total, recorded when the statement was generated.
     */
    invoiceTotal?: number | null;
    /**
     * One entry per line item on the invoice, each with its own rate and rule.
     */
    lines?: CommissionLineEntryDto[] | null;
    /**
     * Computed, not stored: amountPaid / invoiceTotal, clamped to between 0 and 1. Every lineon this entry is scaled by it.
     */
    percentagePaid?: number | null;
    /**
     * Computed, not stored: the sum of the lines' adjustedCommission — the commission thisinvoice contributes to the statement.
     */
    subtotal?: number | null;
}
/**
 * The commission computed for a single invoice line.
 */
export interface CommissionLineEntryDto extends Parsable {
    /**
     * Computed, not stored: commissionDue * appliedPercentagePaid. This is the figure thatcounts toward the statement — commission is earned in proportion to what the customer hasactually paid, so a half-paid invoice yields half its commission.
     */
    adjustedCommission?: number | null;
    /**
     * The proportion of the parent invoice that had been paid, copied down from the entry so eachline records the figure it was scaled by. Between 0 and 1.
     */
    appliedPercentagePaid?: number | null;
    /**
     * Computed, not stored: lineSubtotal * rate. The full commission this line would earn ifthe invoice were paid in full.
     */
    commissionDue?: number | null;
    /**
     * The line's subtotal (price times quantity, less any line discount) as it stood when thestatement was generated. Commission is calculated from this, not from the invoice total.
     */
    lineSubtotal?: number | null;
    /**
     * The product name on the invoice line at the time the statement was generated.
     */
    productName?: string | null;
    /**
     * The quantity on the invoice line.
     */
    quantity?: number | null;
    /**
     * The commission rate applied to this line, as a fraction between 0 and 1 — 0.05 is 5%,not 5. Either the rate of the rule named by ruleAppliedId, or the default rate when norule matched.
     */
    rate?: number | null;
    /**
     * The rule that matched this line, or null when no rule matched and the default rate wasused instead. Matches a ruleId on the plan, or on the customer override when one applied.
     */
    ruleAppliedId?: string | null;
    /**
     * The SKU on the invoice line at the time the statement was generated.
     */
    sku?: string | null;
}
/**
 * The commission terms for one sales rep: a default rate, plus optional rules and per-customeroverrides that displace it.
 */
export interface CommissionPlanDto extends Parsable {
    /**
     * Whether the plan is in use. Only an active plan whose effective range covers the date inquestion can be selected for a new statement; an inactive one is still readable and can beswitched back on. Statements already generated are unaffected either way.
     */
    active?: boolean | null;
    /**
     * Identifies the plan. Derived from the sales rep and the name given at creation, so those twotogether are what make a plan unique. Renaming the plan does not change it.
     */
    commissionPlanId?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * Per-customer terms that replace the plan's rules for the customers they name. Fixed once theplan is created.
     */
    customerOverrides?: CustomerOverrideDto[] | null;
    /**
     * The rate for lines that match no rule, as a fraction between 0 and 1 — 0.05 is 5%, not5. Values outside that range are rejected.
     */
    defaultRate?: number | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * Latest date the plan covers, inclusive. Null leaves it open-ended into the future.
     */
    effectiveEndDate?: Date | null;
    /**
     * Earliest date the plan covers, inclusive. Null leaves it open-ended into the past. Togetherwith the end date and active, this decides whether the plan is the one picked when astatement is generated.
     */
    effectiveStartDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * Rate rules, in the order they were added rather than in priority order — sort bypriority to see which is tried first. Fixed once the plan is created.
     */
    rules?: CommissionRuleDto[] | null;
    /**
     * The sales rep this plan pays. A plan belongs to exactly one rep.
     */
    salesRepId?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
/**
 * A rate that applies to the invoice lines a rule matches, in place of the default rate.
 */
export interface CommissionRuleDto extends Parsable {
    /**
     * Which lines the rule applies to. Absent or empty means every line, making the rule a catch-all.
     */
    match?: CommissionRuleMatchDto | null;
    /**
     * Display name, for example Premium widget rate.
     */
    name?: string | null;
    /**
     * Evaluation order — lower numbers are tried first, and ties keep the order the rules were addedin. The first rule that matches a line wins and the rest are not considered, so a broadcatch-all belongs at the highest number.
     */
    priority?: number | null;
    /**
     * The rate for matching lines, as a fraction between 0 and 1 — 0.05 is 5%, not 5.
     */
    rate?: number | null;
    /**
     * Identifies the rule. A line's ruleAppliedId points back here, so a statement shows whichrule set each line's rate.
     */
    ruleId?: string | null;
}
/**
 * The criteria an invoice line must meet for a rule to apply to it.
 */
export interface CommissionRuleMatchDto extends Parsable {
    /**
     * Customer numbers matched against the invoice's customer, exactly and case-insensitively. Unlikea customer override, this narrows a rule without replacing the rest of the plan.
     */
    customerNumbers?: string[] | null;
    /**
     * Highest line subtotal the rule applies to, inclusive.
     */
    maxLineAmount?: number | null;
    /**
     * Lowest line subtotal the rule applies to, inclusive.
     */
    minLineAmount?: number | null;
    /**
     * Patterns matched against the line's product name, with the same wildcards.
     */
    productNamePatterns?: string[] | null;
    /**
     * Patterns matched against the line's SKU. * stands for any run of characters and ?for a single one, so WIDGET-* matches every widget SKU. Case-insensitive.
     */
    skuPatterns?: string[] | null;
}
/**
 * A sales rep's commission for one period: what was earned, on which invoices, and where thestatement has got to in its review-and-payment workflow.
 */
export interface CommissionStatementDto extends Parsable {
    /**
     * False once the statement has been deleted. Deletion is reversible in the data but notthrough this API: a deleted statement keeps its status and is still returned by id, but dropsout of the per-rep listing.
     */
    active?: boolean | null;
    /**
     * The plan whose rates were used. Recorded for traceability — the statement holds the rates itwas calculated with, so it does not follow later changes to that plan.
     */
    commissionPlanId?: string | null;
    /**
     * Identifies the statement. Set on generation, but only resolvable once the statement has been saved.
     */
    commissionStatementId?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * End of the period covered. Only invoices dated on or before this are included, and it isalso the date the plan's effective range was tested against when the plan was chosen.
     */
    endDate?: Date | null;
    /**
     * One entry per commissionable invoice in the period. Empty when the rep had no qualifying invoices.
     */
    entries?: CommissionEntryDto[] | null;
    /**
     * The audit trail, oldest first. Always carries at least the generation event, and gains oneentry for every status change.
     */
    history?: StatementEventDto[] | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The reference captured when the statement was marked paid — a cheque or transfer number, forexample. Null until then, and null afterwards if none was supplied.
     */
    paymentReference?: string | null;
    /**
     * The sales rep the commission is owed to.
     */
    salesRepId?: string | null;
    /**
     * Start of the period covered. Only invoices dated on or after this are included.
     */
    startDate?: Date | null;
    /**
     * Where the statement is in its workflow. One of:Pending — generated and saved, not yet submitted. The starting status.InReview — submitted, awaiting approval or dispute.Approved — approved, awaiting payment.Disputed — challenged, awaiting adjustment before it can go back to review.Paid — paid. Terminal: no further transition is accepted.Each status accepts only certain moves, and a call that does not fit the current status isrejected. See the individual workflow endpoints for which move each one makes.
     */
    status?: string | null;
    /**
     * Computed, not stored: the sum of the entries' subtotals, before tax.
     */
    subtotal?: number | null;
    /**
     * Computed, not stored: the sum of the tax items' amounts.
     */
    tax?: number | null;
    /**
     * Tax lines supplied when the statement was generated. Empty when none were sent.
     */
    taxItems?: CommissionTaxItemDto[] | null;
    /**
     * Computed, not stored: subtotal + tax. The amount owed to the rep.
     */
    total?: number | null;
    /**
     * Last modified — moves on every status change, note, and deletion.
     */
    updatedAt?: Date | null;
}
/**
 * A tax line on a commission statement. Tax is supplied by the caller when the statement isgenerated rather than derived from the entries, so the jurisdictions and rates that apply arethe caller's to decide.
 */
export interface CommissionTaxItemDto extends Parsable {
    /**
     * The tax amount, as supplied by the caller. It is added to the statement's subtotal as-is and isnever recalculated from ratePercent.
     */
    amount?: number | null;
    /**
     * The rate as a whole-number percentage — 13 is 13%. Note this is the opposite conventionto commission rates, which are fractions. It is recorded for display only; it is not used toderive amount.
     */
    ratePercent?: number | null;
    /**
     * Display name of the tax, for example HST.
     */
    taxName?: string | null;
}
/**
 * A file in the organization's document library.
 */
export interface CompanyDocumentDto extends Parsable {
    /**
     * A time-limited link to the file. It expires, and this is whatever link was issued last, so itmay already have stopped working — ask for a new one with the refresh-url endpoint, or streamthe file through the download endpoint, which never expires.
     */
    cdnUrl?: string | null;
    /**
     * When the document was uploaded (UTC).
     */
    createdAt?: Date | null;
    /**
     * Identifies the document in every other call. Replacing a document by uploading a file of thesame name into the same folder issues a new id, so a stored id can stop resolving.
     */
    documentId?: string | null;
    /**
     * The document's identifier in the system it came from, for records brought in from elsewhere.Empty for anything uploaded through this API.
     */
    externalId?: string | null;
    /**
     * The file's extension, leading dot included (for example .pdf).
     */
    fileExtension?: string | null;
    /**
     * The folder the document is filed under, or null when it sits at the top level.
     */
    folderId?: string | null;
    /**
     * The content type the file is served with when downloaded.
     */
    mimeType?: string | null;
    /**
     * The file name as uploaded, including its extension.
     */
    name?: string | null;
    /**
     * The organization the document belongs to.
     */
    organizationId?: string | null;
    /**
     * The document's display path, built from its folder and file name. Recalculated when thedocument is moved; it is a label rather than an address, and nothing is addressed by it.
     */
    path?: string | null;
    /**
     * The file's size in bytes. Counts against the organization's 1 GB allowance.
     */
    size?: number | null;
    /**
     * When the document was last changed — moved, or issued a new link (UTC).
     */
    updatedAt?: Date | null;
}
/**
 * A folder in the organization's document library.
 */
export interface CompanyFolderDto extends Parsable {
    /**
     * When the folder was created (UTC).
     */
    createdAt?: Date | null;
    /**
     * The folder's identifier in the system it came from, for records brought in from elsewhere.Empty for anything created through this API.
     */
    externalId?: string | null;
    /**
     * Identifies the folder in every other call.
     */
    folderId?: string | null;
    /**
     * The folder's name. Not unique — two sibling folders may share one.
     */
    name?: string | null;
    /**
     * The organization the folder belongs to.
     */
    organizationId?: string | null;
    /**
     * The folder this one sits inside, or null when it is at the top level.
     */
    parentId?: string | null;
    /**
     * The folder's display path, built from its parent's path when it was created. It is notrecalculated afterwards, and nothing is addressed by it — use FolderId to file documents.
     */
    path?: string | null;
    /**
     * When the folder was last changed (UTC).
     */
    updatedAt?: Date | null;
}
export interface CompleteCheckoutRequest extends Parsable {
    /**
     * The channel property
     */
    channel?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The payment property
     */
    payment?: Payment2 | null;
    /**
     * The paymentProfileId property
     */
    paymentProfileId?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
    /**
     * The userType property
     */
    userType?: UserTypes | null;
}
export interface CompleteCheckoutResponse extends Parsable {
    /**
     * The confirmationId property
     */
    confirmationId?: string | null;
    /**
     * The orderNumber property
     */
    orderNumber?: string | null;
}
export interface CompletePaymentRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface ConfigResponse extends Parsable {
    /**
     * The mapsApiKey property
     */
    mapsApiKey?: string | null;
}
/**
 * One non-secret setting a provider accepts, described well enough to render a form field for it.
 */
export interface ConfigurationField extends Parsable {
    /**
     * What to use when the operator supplies nothing.
     */
    defaultValue?: string | null;
    /**
     * Help text explaining what to enter.
     */
    description?: string | null;
    /**
     * The field's label. Validation messages refer to the field by this name.
     */
    displayName?: string | null;
    /**
     * The key to use in a create or update request's configuration.
     */
    key?: string | null;
    /**
     * Placeholder text for the input.
     */
    placeholderText?: string | null;
    /**
     * Whether the integration is incomplete without it.
     */
    required?: boolean | null;
    /**
     * What kind of input this is, so a form can render the right control.
     */
    type?: FieldType | null;
    /**
     * A regular expression the value must match, where the field constrains its format.
     */
    validationPattern?: string | null;
    /**
     * The only accepted values, when the field is a fixed choice. Empty when it is free-form.
     */
    validValues?: string[] | null;
}
export interface ConnectIntegrationRequest extends Parsable {
    /**
     * Where to return the user once the provider calls back — an absolute URL on one of theconfigured application origins. A URL outside those origins is ignored and the callbackanswers with JSON instead of redirecting. Maximum 500 characters.
     */
    state?: string | null;
}
export interface ConnectIntegrationResponse extends Parsable {
    /**
     * Send the user's browser here to authorise. It already carries the encoded state, so use itas returned rather than rebuilding it.
     */
    authorizationUrl?: string | null;
    /**
     * When the authorisation URL stops being usable, roughly fifteen minutes out. Hand the URLstraight to the browser rather than storing it.
     */
    expiresAt?: Date | null;
    /**
     * The integration being authorised.
     */
    integrationId?: string | null;
    /**
     * What the integration is for, e.g. Accounting.
     */
    integrationType?: IntegrationType | null;
    /**
     * The provider the user will authorise with, e.g. QuickBooks.
     */
    provider?: string | null;
    /**
     * The return URL as supplied, echoed back so a caller can correlate the response.
     */
    state?: string | null;
}
/**
 * One configured sync on a connector: the query that reads from the source system, the fieldmappings that reshape each row, and the schedule that runs it.
 */
export interface ConnectorEndpointDto extends Parsable {
    /**
     * The API path the mapped rows are posted to.
     */
    apiPath?: string | null;
    /**
     * The stored data mapping this configuration uses, when it draws on one.
     */
    dataMappingApiId?: string | null;
    /**
     * The kind of record this configuration syncs, e.g. "Customers" or "Products".
     */
    endpointType?: string | null;
    /**
     * How each source column becomes a field on the outgoing record.
     */
    fieldMappings?: ConnectorFieldMappingDto[] | null;
    /**
     * The connector's own id for this configuration. Sync runs reference it.
     */
    id?: string | null;
    /**
     * Whether the schedule runs this configuration. Disabled ones are still reported.
     */
    isEnabled?: boolean | null;
    /**
     * Operator-chosen label, e.g. "Customers".
     */
    name?: string | null;
    /**
     * When the configuration runs.
     */
    schedule?: ConnectorScheduleDto | null;
    /**
     * The query the connector runs against the source database to select rows.
     */
    sqlQuery?: string | null;
    /**
     * How the query selects rows, e.g. "Full" or "Incremental".
     */
    syncMode?: string | null;
}
export interface ConnectorEndpointsDocument extends Parsable {
    /**
     * The connectorId property
     */
    connectorId?: string | null;
    /**
     * The endpoints property
     */
    endpoints?: ConnectorEndpointDto[] | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The pushedAt property
     */
    pushedAt?: Date | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
/**
 * Maps one source column onto one field of the outgoing record.
 */
export interface ConnectorFieldMappingDto extends Parsable {
    /**
     * Used when the source column is null or absent.
     */
    defaultValue?: string | null;
    /**
     * Whether a row missing this value is rejected rather than sent.
     */
    isRequired?: boolean | null;
    /**
     * The column name as the query returns it.
     */
    sourceColumn?: string | null;
    /**
     * The field it becomes on the outgoing record.
     */
    targetField?: string | null;
    /**
     * The transformation applied on the way across, e.g. "None" or "Trim".
     */
    transformation?: string | null;
    /**
     * An argument for the transformation, where it takes one.
     */
    transformationParameter?: string | null;
}
/**
 * When a configured sync runs. One of the two forms is set, not both.
 */
export interface ConnectorScheduleDto extends Parsable {
    /**
     * A cron expression, for schedules tied to particular times.
     */
    cronExpression?: string | null;
    /**
     * A fixed gap between runs, in minutes.
     */
    intervalMinutes?: number | null;
}
export type ConnectorStatusType = (typeof ConnectorStatusTypeObject)[keyof typeof ConnectorStatusTypeObject];
export interface Contact extends Parsable {
    /**
     * The contactId property
     */
    contactId?: string | null;
    /**
     * The contactType property
     */
    contactType?: ContactType | null;
    /**
     * The default property
     */
    defaultEscaped?: boolean | null;
    /**
     * The emailAddress property
     */
    emailAddress?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The fax property
     */
    fax?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The fullName property
     */
    fullName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The phone property
     */
    phone?: string | null;
    /**
     * The title property
     */
    title?: string | null;
}
/**
 * One row of the organization-wide contacts list: a contact and the customer it belongs to.
 */
export interface ContactListItemDto extends Parsable {
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * Identifies this contact within its customer's contact list. To edit or remove a contact,load its customer, change or drop the contact carrying this id, and update the customer.An edit that changes the email address or name of a contact that has no external idchanges its id; read the new one from the updated customer.
     */
    contactId?: string | null;
    /**
     * The contactType property
     */
    contactType?: ContactType | null;
    /**
     * Whether the customer is active. Contacts of inactive customers are listed so a person canstill be found after their company is deactivated.
     */
    customerActive?: boolean | null;
    /**
     * The customerId property
     */
    customerId?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * Whether this is the customer's main contact.
     */
    defaultEscaped?: boolean | null;
    /**
     * The emailAddress property
     */
    emailAddress?: string | null;
    /**
     * The contact's key in the organization's own systems, when it was imported.
     */
    externalId?: string | null;
    /**
     * The fax property
     */
    fax?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The fullName property
     */
    fullName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The phone property
     */
    phone?: string | null;
    /**
     * The title property
     */
    title?: string | null;
}
export type ContactType = (typeof ContactTypeObject)[keyof typeof ContactTypeObject];
export interface Content extends Parsable {
    /**
     * The customer property
     */
    customer?: SubscriptionCreatedCustomer | null;
    /**
     * The subscription property
     */
    subscription?: Subscription | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AbandonedImageAssetsJobRequest}
 */
// @ts-ignore
export function createAbandonedImageAssetsJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAbandonedImageAssetsJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages}
 */
// @ts-ignore
export function createAbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImagesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AbandonedImageAssetsJobStatusResponse}
 */
// @ts-ignore
export function createAbandonedImageAssetsJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAbandonedImageAssetsJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccessRequest}
 */
// @ts-ignore
export function createAccessRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccessRequest;
}
export interface CreateAccessRequestRequest extends Parsable {
    /**
     * The primary address line
     */
    address1?: string | null;
    /**
     * The secondary address line (optional)
     */
    address2?: string | null;
    /**
     * The city name
     */
    city?: string | null;
    /**
     * The company email address for the request
     */
    companyEmail?: string | null;
    /**
     * The company name requesting access
     */
    companyName?: string | null;
    /**
     * The country name (will be validated against known values)
     */
    country?: string | null;
    /**
     * The email address for the request
     */
    emailAddress?: string | null;
    /**
     * The first name of the person requesting access
     */
    firstName?: string | null;
    /**
     * The last name of the person requesting access
     */
    lastName?: string | null;
    /**
     * The phone number for the request (will be formatted as (123) 456-7890)
     */
    phoneNumber?: string | null;
    /**
     * The postal/zip code
     */
    postalCode?: string | null;
    /**
     * The state or province (will be validated against known values)
     */
    stateProvince?: string | null;
    /**
     * The company's tax ID/EIN
     */
    taxIdEIN?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccessRequestResearch}
 */
// @ts-ignore
export function createAccessRequestResearchFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccessRequestResearch;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccessRequestResearchSettings}
 */
// @ts-ignore
export function createAccessRequestResearchSettingsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccessRequestResearchSettings;
}
export interface CreateAccessRequestResponse extends Parsable {
    /**
     * The unique identifier for the access request
     */
    accessRequestId?: string | null;
    /**
     * The primary address line
     */
    address1?: string | null;
    /**
     * The secondary address line
     */
    address2?: string | null;
    /**
     * The city name
     */
    city?: string | null;
    /**
     * The company email address 
     */
    companyEmail?: string | null;
    /**
     * The company name requesting access
     */
    companyName?: string | null;
    /**
     * The country name
     */
    country?: string | null;
    /**
     * When the request was created
     */
    createdAt?: Date | null;
    /**
     * The email address for the request
     */
    emailAddress?: string | null;
    /**
     * The first and last name of the requester            
     */
    firstName?: string | null;
    /**
     * The last name of the requester 
     */
    lastName?: string | null;
    /**
     * The organization ID the request is associated with
     */
    organizationId?: string | null;
    /**
     * The formatted phone number
     */
    phoneNumber?: string | null;
    /**
     * The postal/zip code
     */
    postalCode?: string | null;
    /**
     * The state or province
     */
    stateProvince?: string | null;
    /**
     * The company's tax ID/EIN
     */
    taxIdEIN?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccessRequestsPageSummary}
 */
// @ts-ignore
export function createAccessRequestsPageSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccessRequestsPageSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountSetup}
 */
// @ts-ignore
export function createAccountSetupFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountSetup;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ActivateCommissionPlanRequest}
 */
// @ts-ignore
export function createActivateCommissionPlanRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoActivateCommissionPlanRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ActivateSalesRepRequest}
 */
// @ts-ignore
export function createActivateSalesRepRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoActivateSalesRepRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ActiveCustomersKpi}
 */
// @ts-ignore
export function createActiveCustomersKpiFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoActiveCustomersKpi;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddAdminUserRequest}
 */
// @ts-ignore
export function createAddAdminUserRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddAdminUserRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddAdminUserResponse}
 */
// @ts-ignore
export function createAddAdminUserResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddAdminUserResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddCustomerAttributeRequest}
 */
// @ts-ignore
export function createAddCustomerAttributeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddCustomerAttributeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddFulfillmentMethodRequest}
 */
// @ts-ignore
export function createAddFulfillmentMethodRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddFulfillmentMethodRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddItemRequest}
 */
// @ts-ignore
export function createAddItemRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddItemRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddItemToListRequest}
 */
// @ts-ignore
export function createAddItemToListRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddItemToListRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddMarketCodeRequest}
 */
// @ts-ignore
export function createAddMarketCodeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddMarketCodeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddOrderStatusRequest}
 */
// @ts-ignore
export function createAddOrderStatusRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddOrderStatusRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddOrderTypeRequest}
 */
// @ts-ignore
export function createAddOrderTypeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddOrderTypeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddPriceTierRequest}
 */
// @ts-ignore
export function createAddPriceTierRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddPriceTierRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddProductAttributeRequest}
 */
// @ts-ignore
export function createAddProductAttributeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddProductAttributeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddressComponent}
 */
// @ts-ignore
export function createAddressComponentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddressComponent;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddressDto}
 */
// @ts-ignore
export function createAddressDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddressDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Address}
 */
// @ts-ignore
export function createAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddressInput}
 */
// @ts-ignore
export function createAddressInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddressInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddSubscriptionItemRequest}
 */
// @ts-ignore
export function createAddSubscriptionItemRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddSubscriptionItemRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddSubscriptionItemResponse}
 */
// @ts-ignore
export function createAddSubscriptionItemResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddSubscriptionItemResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddTermRequest}
 */
// @ts-ignore
export function createAddTermRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddTermRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AgencyScopedRequest}
 */
// @ts-ignore
export function createAgencyScopedRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAgencyScopedRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AiUsageBreakdownItem}
 */
// @ts-ignore
export function createAiUsageBreakdownItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAiUsageBreakdownItem;
}
export interface CreateApiAccessResponse extends Parsable {
    /**
     * The apiKey property
     */
    apiKey?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ApiAuthenticationRequest}
 */
// @ts-ignore
export function createApiAuthenticationRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoApiAuthenticationRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ApiAuthenticationResponse}
 */
// @ts-ignore
export function createApiAuthenticationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoApiAuthenticationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ApiKey}
 */
// @ts-ignore
export function createApiKeyFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoApiKey;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AppliedPromotion}
 */
// @ts-ignore
export function createAppliedPromotionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAppliedPromotion;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ApplyCartCodeRequest}
 */
// @ts-ignore
export function createApplyCartCodeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoApplyCartCodeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ApplyDiscountRequest}
 */
// @ts-ignore
export function createApplyDiscountRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoApplyDiscountRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ApproveAccessRequestRequest}
 */
// @ts-ignore
export function createApproveAccessRequestRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoApproveAccessRequestRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ApproveAccessRequestResponse}
 */
// @ts-ignore
export function createApproveAccessRequestResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoApproveAccessRequestResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ApproveCommissionStatementRequest}
 */
// @ts-ignore
export function createApproveCommissionStatementRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoApproveCommissionStatementRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AssignProductFamilyVariantsRequest_VariantAssignment_optionValues}
 */
// @ts-ignore
export function createAssignProductFamilyVariantsRequest_VariantAssignment_optionValuesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAssignProductFamilyVariantsRequest_VariantAssignment_optionValues;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AssignProductFamilyVariantsRequest_VariantAssignment}
 */
// @ts-ignore
export function createAssignProductFamilyVariantsRequest_VariantAssignmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAssignProductFamilyVariantsRequest_VariantAssignment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AssignProductFamilyVariantsRequest}
 */
// @ts-ignore
export function createAssignProductFamilyVariantsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAssignProductFamilyVariantsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AssignProductFamilyVariantsResponse}
 */
// @ts-ignore
export function createAssignProductFamilyVariantsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAssignProductFamilyVariantsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AssociateCustomerRequest}
 */
// @ts-ignore
export function createAssociateCustomerRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAssociateCustomerRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AssociateCustomerResponse}
 */
// @ts-ignore
export function createAssociateCustomerResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAssociateCustomerResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AvailableExportFormatDto}
 */
// @ts-ignore
export function createAvailableExportFormatDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAvailableExportFormatDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AverageOrderValueKpi}
 */
// @ts-ignore
export function createAverageOrderValueKpiFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAverageOrderValueKpi;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillCartShareEventsRequest}
 */
// @ts-ignore
export function createBackfillCartShareEventsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillCartShareEventsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillCartShareEventsResponse}
 */
// @ts-ignore
export function createBackfillCartShareEventsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillCartShareEventsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillOrderSalesRepsRequest}
 */
// @ts-ignore
export function createBackfillOrderSalesRepsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillOrderSalesRepsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillOrderSalesRepsResponse}
 */
// @ts-ignore
export function createBackfillOrderSalesRepsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillOrderSalesRepsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillSubscriptionsResponse}
 */
// @ts-ignore
export function createBackfillSubscriptionsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillSubscriptionsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillUserChannelsResponse}
 */
// @ts-ignore
export function createBackfillUserChannelsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillUserChannelsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BaseEntity}
 */
// @ts-ignore
export function createBaseEntityFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBaseEntity;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Benefit}
 */
// @ts-ignore
export function createBenefitFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBenefit;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BenefitInput}
 */
// @ts-ignore
export function createBenefitInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBenefitInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BenefitTier}
 */
// @ts-ignore
export function createBenefitTierFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBenefitTier;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BenefitTierInput}
 */
// @ts-ignore
export function createBenefitTierInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBenefitTierInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BillingAddress}
 */
// @ts-ignore
export function createBillingAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBillingAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BillingInvoice}
 */
// @ts-ignore
export function createBillingInvoiceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBillingInvoice;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BillingInvoicePdfResponse}
 */
// @ts-ignore
export function createBillingInvoicePdfResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBillingInvoicePdfResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BillingInvoicesResponse}
 */
// @ts-ignore
export function createBillingInvoicesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBillingInvoicesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BulkDeleteDocumentsRequest}
 */
// @ts-ignore
export function createBulkDeleteDocumentsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBulkDeleteDocumentsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BulkImportCustomerUserResult}
 */
// @ts-ignore
export function createBulkImportCustomerUserResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBulkImportCustomerUserResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BulkImportCustomerUserRow}
 */
// @ts-ignore
export function createBulkImportCustomerUserRowFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBulkImportCustomerUserRow;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BulkImportCustomerUsersRequest}
 */
// @ts-ignore
export function createBulkImportCustomerUsersRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBulkImportCustomerUsersRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BulkImportCustomerUsersResponse}
 */
// @ts-ignore
export function createBulkImportCustomerUsersResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBulkImportCustomerUsersResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BulkMoveDocumentsRequest}
 */
// @ts-ignore
export function createBulkMoveDocumentsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBulkMoveDocumentsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BulkWriteDailyTotal}
 */
// @ts-ignore
export function createBulkWriteDailyTotalFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBulkWriteDailyTotal;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BusinessCardAddress}
 */
// @ts-ignore
export function createBusinessCardAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBusinessCardAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BusinessCardField}
 */
// @ts-ignore
export function createBusinessCardFieldFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBusinessCardField;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Campaign}
 */
// @ts-ignore
export function createCampaignFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCampaign;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CampaignInput}
 */
// @ts-ignore
export function createCampaignInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCampaignInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CancelInvoiceRequest}
 */
// @ts-ignore
export function createCancelInvoiceRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCancelInvoiceRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartActor}
 */
// @ts-ignore
export function createCartActorFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartActor;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartEvent}
 */
// @ts-ignore
export function createCartEventFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartEvent;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartItem}
 */
// @ts-ignore
export function createCartItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartLine}
 */
// @ts-ignore
export function createCartLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartPriceChange}
 */
// @ts-ignore
export function createCartPriceChangeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartPriceChange;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartPriceRefreshSummary}
 */
// @ts-ignore
export function createCartPriceRefreshSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartPriceRefreshSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartPricingSettings}
 */
// @ts-ignore
export function createCartPricingSettingsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartPricingSettings;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartPromotionSummary}
 */
// @ts-ignore
export function createCartPromotionSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartPromotionSummary;
}
export interface CreateCartRequest extends Parsable {
    /**
     * The orderType property
     */
    orderType?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartReview}
 */
// @ts-ignore
export function createCartReviewFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartReview;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartShareLine}
 */
// @ts-ignore
export function createCartShareLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartShareLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartShareLineRequest}
 */
// @ts-ignore
export function createCartShareLineRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartShareLineRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartShareSnapshot}
 */
// @ts-ignore
export function createCartShareSnapshotFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartShareSnapshot;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartShareSnapshotRequest}
 */
// @ts-ignore
export function createCartShareSnapshotRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartShareSnapshotRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CartsPageSummary}
 */
// @ts-ignore
export function createCartsPageSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCartsPageSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CatalogItem}
 */
// @ts-ignore
export function createCatalogItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCatalogItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CatalogItemPrice}
 */
// @ts-ignore
export function createCatalogItemPriceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCatalogItemPrice;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CategoryDto}
 */
// @ts-ignore
export function createCategoryDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCategoryDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Category}
 */
// @ts-ignore
export function createCategoryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCategory;
}
export interface CreateCategoryRequest extends Parsable {
    /**
     * The full category path to create, e.g. "/Business/Premium". A leading '/' is optionaland a trailing '/' is stripped, so "Business/Premium" and "/Business/Premium/" are thesame category. Nested paths do not require the parent to exist first.
     */
    name?: string | null;
}
export interface CreateCategoryResponse extends Parsable {
    /**
     * The normalized category path that was created, e.g. "/Business/Premium". This matches thebreadcrumb of the corresponding node in GET api/categories, so a client can useit to select the new category without re-deriving the normalization itself.
     */
    name?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CategoryRevenueRanking}
 */
// @ts-ignore
export function createCategoryRevenueRankingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCategoryRevenueRanking;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChangeTaskStatusRequest}
 */
// @ts-ignore
export function createChangeTaskStatusRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChangeTaskStatusRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChannelTrendPoint}
 */
// @ts-ignore
export function createChannelTrendPointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChannelTrendPoint;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CheckAccessRequestExistsResponse}
 */
// @ts-ignore
export function createCheckAccessRequestExistsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCheckAccessRequestExistsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CheckInSalesRepDeviceRequest}
 */
// @ts-ignore
export function createCheckInSalesRepDeviceRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCheckInSalesRepDeviceRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CheckInSalesRepDeviceResponse}
 */
// @ts-ignore
export function createCheckInSalesRepDeviceResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCheckInSalesRepDeviceResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CheckoutBillingAddress}
 */
// @ts-ignore
export function createCheckoutBillingAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCheckoutBillingAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CheckoutItem}
 */
// @ts-ignore
export function createCheckoutItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCheckoutItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CheckoutPageResponse}
 */
// @ts-ignore
export function createCheckoutPageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCheckoutPageResponse;
}
export interface CreateCheckoutRequest extends Parsable {
    /**
     * What to subscribe to. At least one item; the customer may buy the sales plan, the storefront, orboth, and nothing here assumes which is which.
     */
    items?: CheckoutItem[] | null;
}
export interface CreateCheckoutResponse extends Parsable {
    /**
     * The secret the admin app mounts Stripe's embedded checkout with. Short-lived, and tied to this onesession.
     */
    clientSecret?: string | null;
    /**
     * The sessionId property
     */
    sessionId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CodeCampaignSummary}
 */
// @ts-ignore
export function createCodeCampaignSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCodeCampaignSummary;
}
export interface CreateCodeRequest extends Parsable {
    /**
     * The code as the customer will type it: 3 to 40 letters, digits, hyphens or underscores. Stored upper-case, matched case-insensitively.
     */
    code?: string | null;
    /**
     * The code's own restrictions on top of the campaign's; omit for none.
     */
    options?: DiscountCodeOptionsInput | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ColumnMappingSuggestion}
 */
// @ts-ignore
export function createColumnMappingSuggestionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoColumnMappingSuggestion;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CommissionEntryDto}
 */
// @ts-ignore
export function createCommissionEntryDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCommissionEntryDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CommissionLineEntryDto}
 */
// @ts-ignore
export function createCommissionLineEntryDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCommissionLineEntryDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CommissionPlanDto}
 */
// @ts-ignore
export function createCommissionPlanDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCommissionPlanDto;
}
export interface CreateCommissionPlanRequest extends Parsable {
    /**
     * The customerOverrides property
     */
    customerOverrides?: CreateCommissionPlanRequest_CustomerOverrideInput[] | null;
    /**
     * The defaultRate property
     */
    defaultRate?: number | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The effectiveEndDate property
     */
    effectiveEndDate?: Date | null;
    /**
     * The effectiveStartDate property
     */
    effectiveStartDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The rules property
     */
    rules?: CreateCommissionPlanRequest_RuleInput[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface CreateCommissionPlanRequest_CustomerOverrideInput extends Parsable {
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The defaultRate property
     */
    defaultRate?: number | null;
    /**
     * The effectiveEndDate property
     */
    effectiveEndDate?: Date | null;
    /**
     * The effectiveStartDate property
     */
    effectiveStartDate?: Date | null;
    /**
     * The rules property
     */
    rules?: CreateCommissionPlanRequest_RuleInput[] | null;
}
export interface CreateCommissionPlanRequest_RuleInput extends Parsable {
    /**
     * The match property
     */
    match?: CreateCommissionPlanRequest_RuleMatchInput | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The priority property
     */
    priority?: number | null;
    /**
     * The rate property
     */
    rate?: number | null;
}
export interface CreateCommissionPlanRequest_RuleMatchInput extends Parsable {
    /**
     * The customerNumbers property
     */
    customerNumbers?: string[] | null;
    /**
     * The maxLineAmount property
     */
    maxLineAmount?: number | null;
    /**
     * The minLineAmount property
     */
    minLineAmount?: number | null;
    /**
     * The productNamePatterns property
     */
    productNamePatterns?: string[] | null;
    /**
     * The skuPatterns property
     */
    skuPatterns?: string[] | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CommissionRuleDto}
 */
// @ts-ignore
export function createCommissionRuleDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCommissionRuleDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CommissionRuleMatchDto}
 */
// @ts-ignore
export function createCommissionRuleMatchDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCommissionRuleMatchDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CommissionStatementDto}
 */
// @ts-ignore
export function createCommissionStatementDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCommissionStatementDto;
}
export interface CreateCommissionStatementRequest extends Parsable {
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The generatedByUser property
     */
    generatedByUser?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The taxItems property
     */
    taxItems?: CreateCommissionStatementRequest_TaxItemInput[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface CreateCommissionStatementRequest_TaxItemInput extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The ratePercent property
     */
    ratePercent?: number | null;
    /**
     * The taxName property
     */
    taxName?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CommissionTaxItemDto}
 */
// @ts-ignore
export function createCommissionTaxItemDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCommissionTaxItemDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CompanyDocumentDto}
 */
// @ts-ignore
export function createCompanyDocumentDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCompanyDocumentDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CompanyFolderDto}
 */
// @ts-ignore
export function createCompanyFolderDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCompanyFolderDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CompleteCheckoutRequest}
 */
// @ts-ignore
export function createCompleteCheckoutRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCompleteCheckoutRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CompleteCheckoutResponse}
 */
// @ts-ignore
export function createCompleteCheckoutResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCompleteCheckoutResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CompletePaymentRequest}
 */
// @ts-ignore
export function createCompletePaymentRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCompletePaymentRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConfigResponse}
 */
// @ts-ignore
export function createConfigResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConfigResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConfigurationField}
 */
// @ts-ignore
export function createConfigurationFieldFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConfigurationField;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConnectIntegrationRequest}
 */
// @ts-ignore
export function createConnectIntegrationRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConnectIntegrationRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConnectIntegrationResponse}
 */
// @ts-ignore
export function createConnectIntegrationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConnectIntegrationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConnectorEndpointDto}
 */
// @ts-ignore
export function createConnectorEndpointDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConnectorEndpointDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConnectorEndpointsDocument}
 */
// @ts-ignore
export function createConnectorEndpointsDocumentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConnectorEndpointsDocument;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConnectorFieldMappingDto}
 */
// @ts-ignore
export function createConnectorFieldMappingDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConnectorFieldMappingDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConnectorScheduleDto}
 */
// @ts-ignore
export function createConnectorScheduleDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConnectorScheduleDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Contact}
 */
// @ts-ignore
export function createContactFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContact;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContactListItemDto}
 */
// @ts-ignore
export function createContactListItemDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContactListItemDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Content}
 */
// @ts-ignore
export function createContentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContent;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateAccessRequestRequest}
 */
// @ts-ignore
export function createCreateAccessRequestRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateAccessRequestRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateAccessRequestResponse}
 */
// @ts-ignore
export function createCreateAccessRequestResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateAccessRequestResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateApiAccessResponse}
 */
// @ts-ignore
export function createCreateApiAccessResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateApiAccessResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCartRequest}
 */
// @ts-ignore
export function createCreateCartRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCartRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCategoryRequest}
 */
// @ts-ignore
export function createCreateCategoryRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCategoryRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCategoryResponse}
 */
// @ts-ignore
export function createCreateCategoryResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCategoryResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCheckoutRequest}
 */
// @ts-ignore
export function createCreateCheckoutRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCheckoutRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCheckoutResponse}
 */
// @ts-ignore
export function createCreateCheckoutResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCheckoutResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCodeRequest}
 */
// @ts-ignore
export function createCreateCodeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCodeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCommissionPlanRequest_CustomerOverrideInput}
 */
// @ts-ignore
export function createCreateCommissionPlanRequest_CustomerOverrideInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCommissionPlanRequest_CustomerOverrideInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCommissionPlanRequest_RuleInput}
 */
// @ts-ignore
export function createCreateCommissionPlanRequest_RuleInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCommissionPlanRequest_RuleInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCommissionPlanRequest_RuleMatchInput}
 */
// @ts-ignore
export function createCreateCommissionPlanRequest_RuleMatchInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCommissionPlanRequest_RuleMatchInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCommissionPlanRequest}
 */
// @ts-ignore
export function createCreateCommissionPlanRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCommissionPlanRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCommissionStatementRequest_TaxItemInput}
 */
// @ts-ignore
export function createCreateCommissionStatementRequest_TaxItemInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCommissionStatementRequest_TaxItemInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCommissionStatementRequest}
 */
// @ts-ignore
export function createCreateCommissionStatementRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCommissionStatementRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCustomerNoteRequest}
 */
// @ts-ignore
export function createCreateCustomerNoteRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCustomerNoteRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCustomerRequest_customerAttributes}
 */
// @ts-ignore
export function createCreateCustomerRequest_customerAttributesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCustomerRequest_customerAttributes;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCustomerRequest}
 */
// @ts-ignore
export function createCreateCustomerRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCustomerRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateFavoriteListRequest}
 */
// @ts-ignore
export function createCreateFavoriteListRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateFavoriteListRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateFlipbookFromPdfResponse}
 */
// @ts-ignore
export function createCreateFlipbookFromPdfResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateFlipbookFromPdfResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateFolderRequest}
 */
// @ts-ignore
export function createCreateFolderRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateFolderRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateIntegrationRequest_configuration}
 */
// @ts-ignore
export function createCreateIntegrationRequest_configurationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateIntegrationRequest_configuration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateIntegrationRequest_secrets}
 */
// @ts-ignore
export function createCreateIntegrationRequest_secretsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateIntegrationRequest_secrets;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateIntegrationRequest}
 */
// @ts-ignore
export function createCreateIntegrationRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateIntegrationRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateIntegrationResponse}
 */
// @ts-ignore
export function createCreateIntegrationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateIntegrationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateInvoiceRequest}
 */
// @ts-ignore
export function createCreateInvoiceRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateInvoiceRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateManyCustomersRequest}
 */
// @ts-ignore
export function createCreateManyCustomersRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateManyCustomersRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateManyInvoicesRequest}
 */
// @ts-ignore
export function createCreateManyInvoicesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateManyInvoicesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateManyOrdersRequest}
 */
// @ts-ignore
export function createCreateManyOrdersRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateManyOrdersRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateManyProductsRequest}
 */
// @ts-ignore
export function createCreateManyProductsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateManyProductsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateOrderItemRequest}
 */
// @ts-ignore
export function createCreateOrderItemRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateOrderItemRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateOrganizationApiKeyRequest}
 */
// @ts-ignore
export function createCreateOrganizationApiKeyRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateOrganizationApiKeyRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateOrganizationApiKeyResponse}
 */
// @ts-ignore
export function createCreateOrganizationApiKeyResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateOrganizationApiKeyResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateOrganizationRequest}
 */
// @ts-ignore
export function createCreateOrganizationRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateOrganizationRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateOrganizationResponse}
 */
// @ts-ignore
export function createCreateOrganizationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateOrganizationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping}
 */
// @ts-ignore
export function createCreateOrUpdateDataMappingRequest_HeaderMappingField_MappingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateOrUpdateDataMappingRequest_HeaderMappingField}
 */
// @ts-ignore
export function createCreateOrUpdateDataMappingRequest_HeaderMappingFieldFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateOrUpdateDataMappingRequest_HeaderMappingField;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateOrUpdateDataMappingRequest}
 */
// @ts-ignore
export function createCreateOrUpdateDataMappingRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateOrUpdateDataMappingRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateProductRequest_optionValues}
 */
// @ts-ignore
export function createCreateProductRequest_optionValuesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateProductRequest_optionValues;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateProductRequest_productAttributes}
 */
// @ts-ignore
export function createCreateProductRequest_productAttributesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateProductRequest_productAttributes;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateProductRequest_ProductPriceDto}
 */
// @ts-ignore
export function createCreateProductRequest_ProductPriceDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateProductRequest_ProductPriceDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateProductRequest}
 */
// @ts-ignore
export function createCreateProductRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateProductRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateSalesRepRequest}
 */
// @ts-ignore
export function createCreateSalesRepRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateSalesRepRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateSalesRepResponse}
 */
// @ts-ignore
export function createCreateSalesRepResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateSalesRepResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateTaskRequest}
 */
// @ts-ignore
export function createCreateTaskRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateTaskRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateTransactionSetupRequest}
 */
// @ts-ignore
export function createCreateTransactionSetupRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateTransactionSetupRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateTransactionSetupResponse}
 */
// @ts-ignore
export function createCreateTransactionSetupResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateTransactionSetupResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateUserRequest}
 */
// @ts-ignore
export function createCreateUserRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateUserRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateUserResponse}
 */
// @ts-ignore
export function createCreateUserResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateUserResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateVendorRequest}
 */
// @ts-ignore
export function createCreateVendorRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateVendorRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateWebsiteApiKeyResponse}
 */
// @ts-ignore
export function createCreateWebsiteApiKeyResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateWebsiteApiKeyResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreditCard}
 */
// @ts-ignore
export function createCreditCardFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreditCard;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Customer_customerAttributes}
 */
// @ts-ignore
export function createCustomer_customerAttributesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomer_customerAttributes;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Customer2}
 */
// @ts-ignore
export function createCustomer2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomer2;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Customer3}
 */
// @ts-ignore
export function createCustomer3FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomer3;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerAttribute}
 */
// @ts-ignore
export function createCustomerAttributeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerAttribute;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerDto}
 */
// @ts-ignore
export function createCustomerDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Customer}
 */
// @ts-ignore
export function createCustomerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerHealth}
 */
// @ts-ignore
export function createCustomerHealthFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerHealth;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerInput}
 */
// @ts-ignore
export function createCustomerInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerNote}
 */
// @ts-ignore
export function createCustomerNoteFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerNote;
}
export interface CreateCustomerNoteRequest extends Parsable {
    /**
     * Display name of the note author, shown on the timeline, up to 200 characters. Client-stamped —the offline sync path stamps it the same way, so the API mirrors that trust model. It is alabel only: which caller may later edit the note is decided by the token, not by this value.
     */
    authorName?: string | null;
    /**
     * The note text, up to 4000 characters. Stored and returned as plain text.
     */
    body?: string | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: the sales rep the note is recorded against.
     */
    salesRepId?: string | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerOverrideDto}
 */
// @ts-ignore
export function createCustomerOverrideDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerOverrideDto;
}
export interface CreateCustomerRequest extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The addresses property
     */
    addresses?: Address[] | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The contacts property
     */
    contacts?: Contact[] | null;
    /**
     * The customerAttributes property
     */
    customerAttributes?: CreateCustomerRequest_customerAttributes | null;
    /**
     * Leave blank on PUT /api/customers to have one assigned (CUST- followed by eightuppercase letters and digits). Each row of PUT /api/customers/bulk must carry one.
     */
    customerNumber?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The pricing property
     */
    pricing?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The terms property
     */
    terms?: string | null;
}
export interface CreateCustomerRequest_customerAttributes extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerRevenueRanking}
 */
// @ts-ignore
export function createCustomerRevenueRankingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerRevenueRanking;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomersPageSummary}
 */
// @ts-ignore
export function createCustomersPageSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomersPageSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerUserImportJobSummary}
 */
// @ts-ignore
export function createCustomerUserImportJobSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerUserImportJobSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerVendorAccountDto}
 */
// @ts-ignore
export function createCustomerVendorAccountDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerVendorAccountDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerVendorAccountRequest}
 */
// @ts-ignore
export function createCustomerVendorAccountRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerVendorAccountRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DanglingAssignmentsCleanUpJobRequest}
 */
// @ts-ignore
export function createDanglingAssignmentsCleanUpJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDanglingAssignmentsCleanUpJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments}
 */
// @ts-ignore
export function createDanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignmentsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DanglingAssignmentsCleanUpJobStatusResponse}
 */
// @ts-ignore
export function createDanglingAssignmentsCleanUpJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDanglingAssignmentsCleanUpJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DataExport}
 */
// @ts-ignore
export function createDataExportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDataExport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DataExportResult}
 */
// @ts-ignore
export function createDataExportResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDataExportResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DataMapping}
 */
// @ts-ignore
export function createDataMappingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDataMapping;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeactivateCommissionPlanRequest}
 */
// @ts-ignore
export function createDeactivateCommissionPlanRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeactivateCommissionPlanRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeactivateSalesRepRequest}
 */
// @ts-ignore
export function createDeactivateSalesRepRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeactivateSalesRepRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeactivateVendorRequest}
 */
// @ts-ignore
export function createDeactivateVendorRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeactivateVendorRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeclineAccessRequestRequest}
 */
// @ts-ignore
export function createDeclineAccessRequestRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeclineAccessRequestRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeclineAccessRequestResponse}
 */
// @ts-ignore
export function createDeclineAccessRequestResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeclineAccessRequestResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteAdminUserRequest}
 */
// @ts-ignore
export function createDeleteAdminUserRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteAdminUserRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteAdminUserResponse}
 */
// @ts-ignore
export function createDeleteAdminUserResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteAdminUserResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteCommissionPlanRequest}
 */
// @ts-ignore
export function createDeleteCommissionPlanRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteCommissionPlanRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteCommissionStatementRequest}
 */
// @ts-ignore
export function createDeleteCommissionStatementRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteCommissionStatementRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteCustomerAttributeRequest}
 */
// @ts-ignore
export function createDeleteCustomerAttributeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteCustomerAttributeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteCustomerNoteRequest}
 */
// @ts-ignore
export function createDeleteCustomerNoteRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteCustomerNoteRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteCustomerVendorAccountRequest}
 */
// @ts-ignore
export function createDeleteCustomerVendorAccountRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteCustomerVendorAccountRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteEmptyCategoriesResponse}
 */
// @ts-ignore
export function createDeleteEmptyCategoriesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteEmptyCategoriesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteFulfillmentMethodRequest}
 */
// @ts-ignore
export function createDeleteFulfillmentMethodRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteFulfillmentMethodRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteIntegrationResponse}
 */
// @ts-ignore
export function createDeleteIntegrationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteIntegrationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteInvoiceRequest}
 */
// @ts-ignore
export function createDeleteInvoiceRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteInvoiceRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteListRequest}
 */
// @ts-ignore
export function createDeleteListRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteListRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteManyImagesRequest}
 */
// @ts-ignore
export function createDeleteManyImagesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteManyImagesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteMarketCodeRequest}
 */
// @ts-ignore
export function createDeleteMarketCodeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteMarketCodeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteOrderStatusRequest}
 */
// @ts-ignore
export function createDeleteOrderStatusRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteOrderStatusRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteOrderTypeRequest}
 */
// @ts-ignore
export function createDeleteOrderTypeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteOrderTypeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeletePriceTierRequest}
 */
// @ts-ignore
export function createDeletePriceTierRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeletePriceTierRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteProductAttributeRequest}
 */
// @ts-ignore
export function createDeleteProductAttributeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteProductAttributeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteSalesRepRequest}
 */
// @ts-ignore
export function createDeleteSalesRepRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteSalesRepRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteSalesRepResponse}
 */
// @ts-ignore
export function createDeleteSalesRepResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteSalesRepResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteTaskRequest}
 */
// @ts-ignore
export function createDeleteTaskRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteTaskRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeleteTermRequest}
 */
// @ts-ignore
export function createDeleteTermRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeleteTermRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DeliveryStatus}
 */
// @ts-ignore
export function createDeliveryStatusFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDeliveryStatus;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DisconnectIntegrationRequest}
 */
// @ts-ignore
export function createDisconnectIntegrationRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDisconnectIntegrationRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DisconnectIntegrationResponse}
 */
// @ts-ignore
export function createDisconnectIntegrationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDisconnectIntegrationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DiscountCode}
 */
// @ts-ignore
export function createDiscountCodeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDiscountCode;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DiscountCodeOptionsInput}
 */
// @ts-ignore
export function createDiscountCodeOptionsInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDiscountCodeOptionsInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DiscountDto}
 */
// @ts-ignore
export function createDiscountDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDiscountDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Discount}
 */
// @ts-ignore
export function createDiscountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDiscount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DiscountInput}
 */
// @ts-ignore
export function createDiscountInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDiscountInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DisputeCommissionStatementRequest}
 */
// @ts-ignore
export function createDisputeCommissionStatementRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDisputeCommissionStatementRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DocumentListResponse}
 */
// @ts-ignore
export function createDocumentListResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDocumentListResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DocumentResponse2}
 */
// @ts-ignore
export function createDocumentResponse2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDocumentResponse2;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DocumentResponse}
 */
// @ts-ignore
export function createDocumentResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDocumentResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DocumentStorageStatsDto}
 */
// @ts-ignore
export function createDocumentStorageStatsDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDocumentStorageStatsDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EditCustomerAttributeRequest}
 */
// @ts-ignore
export function createEditCustomerAttributeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEditCustomerAttributeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EditOrderTypeRequest}
 */
// @ts-ignore
export function createEditOrderTypeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEditOrderTypeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EditProductAttributeRequest}
 */
// @ts-ignore
export function createEditProductAttributeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEditProductAttributeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EmailInvoiceRequest}
 */
// @ts-ignore
export function createEmailInvoiceRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEmailInvoiceRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EmailStatsCounts}
 */
// @ts-ignore
export function createEmailStatsCountsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEmailStatsCounts;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EmailStatsDay}
 */
// @ts-ignore
export function createEmailStatsDayFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEmailStatsDay;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EnrichCustomerRequest}
 */
// @ts-ignore
export function createEnrichCustomerRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEnrichCustomerRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EnrichCustomerResponse}
 */
// @ts-ignore
export function createEnrichCustomerResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEnrichCustomerResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EnrichM2MResponse}
 */
// @ts-ignore
export function createEnrichM2MResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEnrichM2MResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EnrichUserAccessTokenResponse}
 */
// @ts-ignore
export function createEnrichUserAccessTokenResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEnrichUserAccessTokenResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EntitlementOffer}
 */
// @ts-ignore
export function createEntitlementOfferFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEntitlementOffer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EntitlementsResponse}
 */
// @ts-ignore
export function createEntitlementsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEntitlementsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EntityDetailsResponseOfImageDetail}
 */
// @ts-ignore
export function createEntityDetailsResponseOfImageDetailFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEntityDetailsResponseOfImageDetail;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EntityDetailsResponseOfOrder}
 */
// @ts-ignore
export function createEntityDetailsResponseOfOrderFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEntityDetailsResponseOfOrder;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ErrorResponse_errors}
 */
// @ts-ignore
export function createErrorResponse_errorsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoErrorResponse_errors;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ErrorResponse}
 */
// @ts-ignore
export function createErrorResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoErrorResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExistingAccessCustomerResponse}
 */
// @ts-ignore
export function createExistingAccessCustomerResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExistingAccessCustomerResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExistingAccessResponse}
 */
// @ts-ignore
export function createExistingAccessResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExistingAccessResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExistsResponse}
 */
// @ts-ignore
export function createExistsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExistsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExportCustomersRequest}
 */
// @ts-ignore
export function createExportCustomersRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExportCustomersRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExportedOrderDto}
 */
// @ts-ignore
export function createExportedOrderDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExportedOrderDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExportFormatDto}
 */
// @ts-ignore
export function createExportFormatDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExportFormatDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExportOrdersByDateRequest}
 */
// @ts-ignore
export function createExportOrdersByDateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExportOrdersByDateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExportOrdersByIdRequest}
 */
// @ts-ignore
export function createExportOrdersByIdRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExportOrdersByIdRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExportProductsRequest}
 */
// @ts-ignore
export function createExportProductsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExportProductsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ExtractBusinessCardResponse}
 */
// @ts-ignore
export function createExtractBusinessCardResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoExtractBusinessCardResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FailedLine}
 */
// @ts-ignore
export function createFailedLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFailedLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FailPaymentRequest}
 */
// @ts-ignore
export function createFailPaymentRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFailPaymentRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FavoriteList}
 */
// @ts-ignore
export function createFavoriteListFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFavoriteList;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FavoriteListItem}
 */
// @ts-ignore
export function createFavoriteListItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFavoriteListItem;
}
export interface CreateFavoriteListRequest extends Parsable {
    /**
     * Make this the customer's default list. Only one list per customer can hold the flag, sosetting it here clears it on the previous default.
     */
    isDefault?: boolean | null;
    /**
     * Display name for the list, up to 100 characters. Unique per customer — a name thatcustomer already uses is rejected.
     */
    name?: string | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: the sales rep the list is being created on behalf of.
     */
    salesRepId?: string | null;
    /**
     * Optional free-form tag recording which client created the list, stored as sent and neverinterpreted by the API (the sales app sends "SalesApp").
     */
    source?: string | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
    /**
     * Optional: the user the list is being created for.
     */
    userId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Flipbook}
 */
// @ts-ignore
export function createFlipbookFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFlipbook;
}
export interface CreateFlipbookFromPdfResponse extends Parsable {
    /**
     * The flipbookId property
     */
    flipbookId?: string | null;
    /**
     * The pageCount property
     */
    pageCount?: number | null;
    /**
     * The pages property
     */
    pages?: PageInfo[] | null;
    /**
     * The title property
     */
    title?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FlipbookPagesResponse}
 */
// @ts-ignore
export function createFlipbookPagesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFlipbookPagesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FolderListResponse}
 */
// @ts-ignore
export function createFolderListResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFolderListResponse;
}
export interface CreateFolderRequest extends Parsable {
    /**
     * The folder's name. Required, up to 255 characters, and it may not contain '/' or '/' —nesting comes from ParentId, not from a name. Names are not checked for uniqueness.
     */
    name?: string | null;
    /**
     * The folder to create this one inside. Leave it out for a top-level folder. A parent thatdoes not exist is rejected.
     */
    parentId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FolderResponse2}
 */
// @ts-ignore
export function createFolderResponse2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFolderResponse2;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FolderResponse}
 */
// @ts-ignore
export function createFolderResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFolderResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ForecastModelDto}
 */
// @ts-ignore
export function createForecastModelDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoForecastModelDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ForecastModelSettings}
 */
// @ts-ignore
export function createForecastModelSettingsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoForecastModelSettings;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FreeShippingEntitlement}
 */
// @ts-ignore
export function createFreeShippingEntitlementFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFreeShippingEntitlement;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GenerateCodesRequest}
 */
// @ts-ignore
export function createGenerateCodesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGenerateCodesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GenerateCommissionStatementRequest_TaxItemInput}
 */
// @ts-ignore
export function createGenerateCommissionStatementRequest_TaxItemInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGenerateCommissionStatementRequest_TaxItemInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GenerateCommissionStatementRequest}
 */
// @ts-ignore
export function createGenerateCommissionStatementRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGenerateCommissionStatementRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetAccessRequestNotificationSettingsResponse}
 */
// @ts-ignore
export function createGetAccessRequestNotificationSettingsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetAccessRequestNotificationSettingsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetAccessRequestResponse}
 */
// @ts-ignore
export function createGetAccessRequestResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetAccessRequestResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetActivePaymentGatewayResponse}
 */
// @ts-ignore
export function createGetActivePaymentGatewayResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetActivePaymentGatewayResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetAddressDetailsRequest}
 */
// @ts-ignore
export function createGetAddressDetailsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetAddressDetailsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetAddressDetailsResponse}
 */
// @ts-ignore
export function createGetAddressDetailsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetAddressDetailsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetAiUsageResponse}
 */
// @ts-ignore
export function createGetAiUsageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetAiUsageResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetApiAccessResponse}
 */
// @ts-ignore
export function createGetApiAccessResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetApiAccessResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetAvailableIntegrationsResponse_integrationsByType}
 */
// @ts-ignore
export function createGetAvailableIntegrationsResponse_integrationsByTypeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetAvailableIntegrationsResponse_integrationsByType;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetAvailableIntegrationsResponse}
 */
// @ts-ignore
export function createGetAvailableIntegrationsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetAvailableIntegrationsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetBulkWriteSummaryResponse}
 */
// @ts-ignore
export function createGetBulkWriteSummaryResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetBulkWriteSummaryResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetCartPricingSettingsResponse}
 */
// @ts-ignore
export function createGetCartPricingSettingsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetCartPricingSettingsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetCustomerSalesRepResponse}
 */
// @ts-ignore
export function createGetCustomerSalesRepResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetCustomerSalesRepResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetEmailStatsResponse}
 */
// @ts-ignore
export function createGetEmailStatsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetEmailStatsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetExportDownloadUrlResponse}
 */
// @ts-ignore
export function createGetExportDownloadUrlResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetExportDownloadUrlResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetFeatureFlagsResponse_flags}
 */
// @ts-ignore
export function createGetFeatureFlagsResponse_flagsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetFeatureFlagsResponse_flags;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetFeatureFlagsResponse}
 */
// @ts-ignore
export function createGetFeatureFlagsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetFeatureFlagsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetForecastModelResponse}
 */
// @ts-ignore
export function createGetForecastModelResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetForecastModelResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetIntegrationResponse_availableFields}
 */
// @ts-ignore
export function createGetIntegrationResponse_availableFieldsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetIntegrationResponse_availableFields;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetIntegrationResponse_configuration}
 */
// @ts-ignore
export function createGetIntegrationResponse_configurationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetIntegrationResponse_configuration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetIntegrationResponse}
 */
// @ts-ignore
export function createGetIntegrationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetIntegrationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetIntegrationTemplatesByTypeResponse}
 */
// @ts-ignore
export function createGetIntegrationTemplatesByTypeResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetIntegrationTemplatesByTypeResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetInvoicesByIdsRequest}
 */
// @ts-ignore
export function createGetInvoicesByIdsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetInvoicesByIdsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetMapsTokenResponse}
 */
// @ts-ignore
export function createGetMapsTokenResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetMapsTokenResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetOrderExportSettingsResponse}
 */
// @ts-ignore
export function createGetOrderExportSettingsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetOrderExportSettingsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetOrderInvoiceSummaryRequest_orderedQuantitiesBySku}
 */
// @ts-ignore
export function createGetOrderInvoiceSummaryRequest_orderedQuantitiesBySkuFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetOrderInvoiceSummaryRequest_orderedQuantitiesBySku;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetOrderInvoiceSummaryRequest}
 */
// @ts-ignore
export function createGetOrderInvoiceSummaryRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetOrderInvoiceSummaryRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetOrderKindsResponse}
 */
// @ts-ignore
export function createGetOrderKindsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetOrderKindsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetOrderVolumeForecastResponse}
 */
// @ts-ignore
export function createGetOrderVolumeForecastResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetOrderVolumeForecastResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetOrderVolumeHistoryResponse}
 */
// @ts-ignore
export function createGetOrderVolumeHistoryResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetOrderVolumeHistoryResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetOrganizationProfileResponse}
 */
// @ts-ignore
export function createGetOrganizationProfileResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetOrganizationProfileResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetOrganizationResponse}
 */
// @ts-ignore
export function createGetOrganizationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetOrganizationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetProductsBySkusRequest}
 */
// @ts-ignore
export function createGetProductsBySkusRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetProductsBySkusRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetResearchSettingsResponse}
 */
// @ts-ignore
export function createGetResearchSettingsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetResearchSettingsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetSeatsResponse}
 */
// @ts-ignore
export function createGetSeatsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetSeatsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetSkuForecastResponse}
 */
// @ts-ignore
export function createGetSkuForecastResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetSkuForecastResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetSkuHistoryResponse}
 */
// @ts-ignore
export function createGetSkuHistoryResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetSkuHistoryResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetTemplatesResponse}
 */
// @ts-ignore
export function createGetTemplatesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetTemplatesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GetUserProfileResponse}
 */
// @ts-ignore
export function createGetUserProfileResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGetUserProfileResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GiftInstruction}
 */
// @ts-ignore
export function createGiftInstructionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGiftInstruction;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GiftMarkerDto}
 */
// @ts-ignore
export function createGiftMarkerDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGiftMarkerDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GiftMarker}
 */
// @ts-ignore
export function createGiftMarkerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGiftMarker;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {GiftProductSnapshot}
 */
// @ts-ignore
export function createGiftProductSnapshotFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoGiftProductSnapshot;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {HeaderColumnMap}
 */
// @ts-ignore
export function createHeaderColumnMapFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoHeaderColumnMap;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {HeaderMapping}
 */
// @ts-ignore
export function createHeaderMappingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoHeaderMapping;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {HeartbeatSqlConnectorRequest_metadata}
 */
// @ts-ignore
export function createHeartbeatSqlConnectorRequest_metadataFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoHeartbeatSqlConnectorRequest_metadata;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {HeartbeatSqlConnectorRequest}
 */
// @ts-ignore
export function createHeartbeatSqlConnectorRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoHeartbeatSqlConnectorRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {HomeEndpoint_HomeResponse}
 */
// @ts-ignore
export function createHomeEndpoint_HomeResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoHomeEndpoint_HomeResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageDetail}
 */
// @ts-ignore
export function createImageDetailFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageDetail;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Image}
 */
// @ts-ignore
export function createImageFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImage;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageHousekeepingCleanUpRequest}
 */
// @ts-ignore
export function createImageHousekeepingCleanUpRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageHousekeepingCleanUpRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageHousekeepingCleanUpStatusResponse}
 */
// @ts-ignore
export function createImageHousekeepingCleanUpStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageHousekeepingCleanUpStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageHousekeepingScanStatusResponse_TrashedAsset}
 */
// @ts-ignore
export function createImageHousekeepingScanStatusResponse_TrashedAssetFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageHousekeepingScanStatusResponse_TrashedAsset;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageHousekeepingScanStatusResponse}
 */
// @ts-ignore
export function createImageHousekeepingScanStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageHousekeepingScanStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImagesCleanUpJobStatusResponse}
 */
// @ts-ignore
export function createImagesCleanUpJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImagesCleanUpJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageTrashPurgeJobRequest}
 */
// @ts-ignore
export function createImageTrashPurgeJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageTrashPurgeJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageTrashPurgeJobStatusResponse}
 */
// @ts-ignore
export function createImageTrashPurgeJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageTrashPurgeJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageUploadItem}
 */
// @ts-ignore
export function createImageUploadItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageUploadItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageUploadResponse}
 */
// @ts-ignore
export function createImageUploadResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageUploadResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImportColumnSample}
 */
// @ts-ignore
export function createImportColumnSampleFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImportColumnSample;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IntegrationOAuthCallbackResponse}
 */
// @ts-ignore
export function createIntegrationOAuthCallbackResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIntegrationOAuthCallbackResponse;
}
export interface CreateIntegrationRequest extends Parsable {
    /**
     * Non-secret settings, keyed as the provider's template names them. Readable afterwards onevery GET, so never put a credential here.
     */
    configuration?: CreateIntegrationRequest_configuration | null;
    /**
     * What operators will see this integration called. Maximum 100 characters.
     */
    displayName?: string | null;
    /**
     * What the integration is for. Must match the template's type for this provider.
     */
    integrationType?: IntegrationType | null;
    /**
     * Whether the integration is live once created. Defaults to true.
     */
    isEnabled?: boolean | null;
    /**
     * The provider to connect, named exactly as GET /api/integration-templates reports it, e.g.AuthorizeNet or QuickBooks.
     */
    provider?: string | null;
    /**
     * Credentials, keyed as the provider's template names them. Write-only: they are stored apartfrom the integration record and no endpoint in this API ever returns them, so keep your owncopy. Leave empty for a provider that authorises by OAuth.
     */
    secrets?: CreateIntegrationRequest_secrets | null;
}
/**
 * Non-secret settings, keyed as the provider's template names them. Readable afterwards onevery GET, so never put a credential here.
 */
export interface CreateIntegrationRequest_configuration extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * Credentials, keyed as the provider's template names them. Write-only: they are stored apartfrom the integration record and no endpoint in this API ever returns them, so keep your owncopy. Leave empty for a provider that authorises by OAuth.
 */
export interface CreateIntegrationRequest_secrets extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface CreateIntegrationResponse extends Parsable {
    /**
     * When the integration was created.
     */
    createdAt?: Date | null;
    /**
     * The name operators will see.
     */
    displayName?: string | null;
    /**
     * The new integration's identifier. Every other integration endpoint is addressed by it.
     */
    integrationId?: string | null;
    /**
     * What the integration is for.
     */
    integrationType?: IntegrationType | null;
    /**
     * Whether the integration is live. Enabled is not the same as working — test it.
     */
    isEnabled?: boolean | null;
    /**
     * The organisation the integration belongs to.
     */
    organizationId?: string | null;
    /**
     * The provider that was connected.
     */
    provider?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IntegrationSummary_configuration}
 */
// @ts-ignore
export function createIntegrationSummary_configurationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIntegrationSummary_configuration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IntegrationSummary}
 */
// @ts-ignore
export function createIntegrationSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIntegrationSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IntegrationTemplate}
 */
// @ts-ignore
export function createIntegrationTemplateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIntegrationTemplate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InternalErrorResponse}
 */
// @ts-ignore
export function createInternalErrorResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInternalErrorResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceAddressDto}
 */
// @ts-ignore
export function createInvoiceAddressDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceAddressDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceCustomerDto}
 */
// @ts-ignore
export function createInvoiceCustomerDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceCustomerDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceDiscountDto}
 */
// @ts-ignore
export function createInvoiceDiscountDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceDiscountDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceDto}
 */
// @ts-ignore
export function createInvoiceDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Invoice}
 */
// @ts-ignore
export function createInvoiceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoice;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceItemDto}
 */
// @ts-ignore
export function createInvoiceItemDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceItemDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceItem}
 */
// @ts-ignore
export function createInvoiceItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceItemInput}
 */
// @ts-ignore
export function createInvoiceItemInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceItemInput;
}
export interface CreateInvoiceRequest extends Parsable {
    /**
     * Whether the invoice is active. Defaults to true, and is stored on the invoice as sent.It is not a soft delete: no invoice endpoint filters on it, so an invoice set inactive isstill returned by get, list, by-ids and by-order exactly as before. Map the column on importif your source system carries it, but do not rely on it to hide anything — use the deleteendpoint for that.
     */
    active?: boolean | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customer property
     */
    customer?: CustomerInput | null;
    /**
     * The discount property
     */
    discount?: DiscountInput | null;
    /**
     * The dueDate property
     */
    dueDate?: Date | null;
    /**
     * Optional warehouse that fulfilled the invoice.
     */
    fulfillmentCenter?: string | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * Optional imported outstanding balance. Normally supplied together withImportedInvoiceTotal. When supplied, it is stored directly rather than computed.
     */
    importedBalance?: number | null;
    /**
     * Optional imported invoice total, for invoices whose payments are tracked in another system.When supplied, this total is authoritative (used instead of the line-item computation) and theamount paid is derived as this total minus ImportedBalance.
     */
    importedInvoiceTotal?: number | null;
    /**
     * The invoiceDate property
     */
    invoiceDate?: Date | null;
    /**
     * Optional invoice number. Supply this to import an invoice that already has a numberfrom another system. When omitted, a number is generated following the standard pattern.
     */
    invoiceNumber?: string | null;
    /**
     * The items property
     */
    items?: InvoiceItemInput[] | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * Optional number of packages in the shipment this invoice covers. Left null when the importdoesn't supply one, which stays distinct from a supplied zero.
     */
    numberOfPackages?: number | null;
    /**
     * The orderId property
     */
    orderId?: string | null;
    /**
     * The orderNumber property
     */
    orderNumber?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The primarySalesRep property
     */
    primarySalesRep?: SalesRepInput | null;
    /**
     * Optional freight cost and carrier. Supplying this removes the need to smuggle freight in asa pseudo line item (sku: FREIGHT), which is how imports carried it before.
     */
    shippingDetails?: ShippingDetailsInput | null;
    /**
     * The tax property
     */
    tax?: number | null;
    /**
     * The terms property
     */
    terms?: string | null;
    /**
     * Optional carrier tracking number for the shipment this invoice covers.
     */
    trackingNumber?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceSalesRepDto}
 */
// @ts-ignore
export function createInvoiceSalesRepDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceSalesRepDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceShippingDetailsDto}
 */
// @ts-ignore
export function createInvoiceShippingDetailsDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceShippingDetailsDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoicesPageSummary}
 */
// @ts-ignore
export function createInvoicesPageSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoicesPageSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IssueInvoiceRequest}
 */
// @ts-ignore
export function createIssueInvoiceRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIssueInvoiceRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobAcceptedResponse}
 */
// @ts-ignore
export function createJobAcceptedResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobAcceptedResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobResultOfAbandonedImageAssetsJobStatusResponse}
 */
// @ts-ignore
export function createJobResultOfAbandonedImageAssetsJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobResultOfAbandonedImageAssetsJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobResultOfBulkImportCustomerUsersResponse}
 */
// @ts-ignore
export function createJobResultOfBulkImportCustomerUsersResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobResultOfBulkImportCustomerUsersResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobResultOfDanglingAssignmentsCleanUpJobStatusResponse}
 */
// @ts-ignore
export function createJobResultOfDanglingAssignmentsCleanUpJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobResultOfDanglingAssignmentsCleanUpJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobResultOfImageHousekeepingCleanUpStatusResponse}
 */
// @ts-ignore
export function createJobResultOfImageHousekeepingCleanUpStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobResultOfImageHousekeepingCleanUpStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobResultOfImageHousekeepingScanStatusResponse}
 */
// @ts-ignore
export function createJobResultOfImageHousekeepingScanStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobResultOfImageHousekeepingScanStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobResultOfImagesCleanUpJobStatusResponse}
 */
// @ts-ignore
export function createJobResultOfImagesCleanUpJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobResultOfImagesCleanUpJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobResultOfImageTrashPurgeJobStatusResponse}
 */
// @ts-ignore
export function createJobResultOfImageTrashPurgeJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobResultOfImageTrashPurgeJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LineDiscountInstruction}
 */
// @ts-ignore
export function createLineDiscountInstructionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLineDiscountInstruction;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Link}
 */
// @ts-ignore
export function createLinkFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLink;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListApiAccessResponse}
 */
// @ts-ignore
export function createListApiAccessResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListApiAccessResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListCategoriesResponse}
 */
// @ts-ignore
export function createListCategoriesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListCategoriesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListCustomerUserImportJobsResponse}
 */
// @ts-ignore
export function createListCustomerUserImportJobsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListCustomerUserImportJobsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListEmptyCategoriesResponse}
 */
// @ts-ignore
export function createListEmptyCategoriesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListEmptyCategoriesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListExportFormatsResponse}
 */
// @ts-ignore
export function createListExportFormatsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListExportFormatsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListForecastModelsResponse}
 */
// @ts-ignore
export function createListForecastModelsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListForecastModelsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListIntegrationsResponse}
 */
// @ts-ignore
export function createListIntegrationsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListIntegrationsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListOfEntitlements}
 */
// @ts-ignore
export function createListOfEntitlementsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListOfEntitlements;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListOrderEmailsResponse}
 */
// @ts-ignore
export function createListOrderEmailsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListOrderEmailsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListOrganizationApiKeysResponse}
 */
// @ts-ignore
export function createListOrganizationApiKeysResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListOrganizationApiKeysResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListOrganizationSalesRepsResponse}
 */
// @ts-ignore
export function createListOrganizationSalesRepsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListOrganizationSalesRepsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListProductTagsResponse_ProductTagDto}
 */
// @ts-ignore
export function createListProductTagsResponse_ProductTagDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListProductTagsResponse_ProductTagDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListProductTagsResponse}
 */
// @ts-ignore
export function createListProductTagsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListProductTagsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListSalesRepDevicesResponse}
 */
// @ts-ignore
export function createListSalesRepDevicesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListSalesRepDevicesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListSalesRepOrganizationsResponse}
 */
// @ts-ignore
export function createListSalesRepOrganizationsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListSalesRepOrganizationsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListSqlConnectorsResponse}
 */
// @ts-ignore
export function createListSqlConnectorsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListSqlConnectorsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListSubCategoriesResponse}
 */
// @ts-ignore
export function createListSubCategoriesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListSubCategoriesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ListUserOrganizationsResponse}
 */
// @ts-ignore
export function createListUserOrganizationsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoListUserOrganizationsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LookupAddressRequest}
 */
// @ts-ignore
export function createLookupAddressRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLookupAddressRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LookupAddressResponse}
 */
// @ts-ignore
export function createLookupAddressResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLookupAddressResponse;
}
export interface CreateManyCustomersRequest extends Parsable {
    /**
     * The customers property
     */
    customers?: CreateCustomerRequest[] | null;
}
export interface CreateManyInvoicesRequest extends Parsable {
    /**
     * The invoices property
     */
    invoices?: CreateInvoiceRequest[] | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface CreateManyOrdersRequest extends Parsable {
    /**
     * The orders property
     */
    orders?: CreateOrderItemRequest[] | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface CreateManyProductsRequest extends Parsable {
    /**
     * The ignoreCategory property
     */
    ignoreCategory?: boolean | null;
    /**
     * The products property
     */
    products?: CreateProductRequest[] | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MappingAlternate}
 */
// @ts-ignore
export function createMappingAlternateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMappingAlternate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MappingCreateProposal}
 */
// @ts-ignore
export function createMappingCreateProposalFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMappingCreateProposal;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MappingOutcomeColumn}
 */
// @ts-ignore
export function createMappingOutcomeColumnFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMappingOutcomeColumn;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MarkOrdersExportedRequest}
 */
// @ts-ignore
export function createMarkOrdersExportedRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMarkOrdersExportedRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MarkOrdersExportedResponse}
 */
// @ts-ignore
export function createMarkOrdersExportedResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMarkOrdersExportedResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MarkPaidRequest}
 */
// @ts-ignore
export function createMarkPaidRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMarkPaidRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MatchedSubstring}
 */
// @ts-ignore
export function createMatchedSubstringFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMatchedSubstring;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MessageAttachment}
 */
// @ts-ignore
export function createMessageAttachmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMessageAttachment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MessageMetadata}
 */
// @ts-ignore
export function createMessageMetadataFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMessageMetadata;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ModelMetrics}
 */
// @ts-ignore
export function createModelMetricsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoModelMetrics;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MonthlyForecastPointDto}
 */
// @ts-ignore
export function createMonthlyForecastPointDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMonthlyForecastPointDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MonthlyOrderTrend}
 */
// @ts-ignore
export function createMonthlyOrderTrendFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMonthlyOrderTrend;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MonthlyRevenueTrend}
 */
// @ts-ignore
export function createMonthlyRevenueTrendFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMonthlyRevenueTrend;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MoveDocumentRequest}
 */
// @ts-ignore
export function createMoveDocumentRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMoveDocumentRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Ok}
 */
// @ts-ignore
export function createOkFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOk;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OpenPipeline}
 */
// @ts-ignore
export function createOpenPipelineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOpenPipeline;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderBatchResponse}
 */
// @ts-ignore
export function createOrderBatchResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderBatchResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderDto}
 */
// @ts-ignore
export function createOrderDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderExportSettings}
 */
// @ts-ignore
export function createOrderExportSettingsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderExportSettings;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Order}
 */
// @ts-ignore
export function createOrderFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrder;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderInvoiceLineSummaryDto}
 */
// @ts-ignore
export function createOrderInvoiceLineSummaryDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderInvoiceLineSummaryDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderInvoiceSummaryDto}
 */
// @ts-ignore
export function createOrderInvoiceSummaryDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderInvoiceSummaryDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderItemDto}
 */
// @ts-ignore
export function createOrderItemDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderItemDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderItem}
 */
// @ts-ignore
export function createOrderItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderItemInput}
 */
// @ts-ignore
export function createOrderItemInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderItemInput;
}
/**
 * A single order in a bulk-create request. Uses the Orders domain records directly where theybind cleanly (Customer, SalesRep, ShippingDetails); line items bind asOrderItemInput because the domain OrderItem cannot be deserialized bySystem.Text.Json (two public constructors, Newtonsoft-only [JsonConstructor]).
 */
export interface CreateOrderItemRequest extends Parsable {
    /**
     * Whether the order is active. Defaults to true. Set to false to bulk soft-delete the matchingorder on import (the order number is updated to inactive).
     */
    active?: boolean | null;
    /**
     * The channel property
     */
    channel?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customer property
     */
    customer?: Customer2 | null;
    /**
     * Optional id of the order in the system it was imported from, stored as the order's externalid. Omitted or blank leaves the order without one. Re-importing the same order numberreplaces it.
     */
    externalId?: string | null;
    /**
     * Optional warehouse fulfilling the order. ERP pass-through; re-importing the same ordernumber updates it.
     */
    fulfillmentCenter?: string | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The items property
     */
    items?: OrderItemInput[] | null;
    /**
     * Optional market code for reporting and ERP. Taken as given — it is not derived fromPrimarySalesRep, so a row that omits it imports as an order with no code.
     */
    marketCode?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * Optional historical order date. Defaults to now when omitted.
     */
    orderDate?: Date | null;
    /**
     * Optional supplied order number. Imported orders keep it (preserved); when omitted a number isgenerated. Re-importing the same number updates the existing order rather than duplicating it.
     */
    orderNumber?: string | null;
    /**
     * The orderStatus property
     */
    orderStatus?: string | null;
    /**
     * The orderType property
     */
    orderType?: string | null;
    /**
     * The originationCartId property
     */
    originationCartId?: string | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The priceTier property
     */
    priceTier?: string | null;
    /**
     * The primarySalesRep property
     */
    primarySalesRep?: SalesRep | null;
    /**
     * The shippingDetails property
     */
    shippingDetails?: ShippingDetails | null;
    /**
     * The takenBySalesRep property
     */
    takenBySalesRep?: SalesRep | null;
    /**
     * The tax property
     */
    tax?: number | null;
    /**
     * The terms property
     */
    terms?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderKindDto}
 */
// @ts-ignore
export function createOrderKindDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderKindDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderReceiptSettings}
 */
// @ts-ignore
export function createOrderReceiptSettingsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderReceiptSettings;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderReceiptSettingsResponse}
 */
// @ts-ignore
export function createOrderReceiptSettingsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderReceiptSettingsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderReceiptSubjectDto}
 */
// @ts-ignore
export function createOrderReceiptSubjectDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderReceiptSubjectDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderRhythmCell}
 */
// @ts-ignore
export function createOrderRhythmCellFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderRhythmCell;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderRhythm}
 */
// @ts-ignore
export function createOrderRhythmFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderRhythm;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrdersKpi}
 */
// @ts-ignore
export function createOrdersKpiFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrdersKpi;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrdersPageSummary}
 */
// @ts-ignore
export function createOrdersPageSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrdersPageSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderType}
 */
// @ts-ignore
export function createOrderTypeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderType;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderTypeProfileDto}
 */
// @ts-ignore
export function createOrderTypeProfileDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderTypeProfileDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderTypeResponse}
 */
// @ts-ignore
export function createOrderTypeResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderTypeResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderVolumeHistoryPointDto}
 */
// @ts-ignore
export function createOrderVolumeHistoryPointDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderVolumeHistoryPointDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrderWithInvoiceNumbersDto}
 */
// @ts-ignore
export function createOrderWithInvoiceNumbersDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrderWithInvoiceNumbersDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Organization2}
 */
// @ts-ignore
export function createOrganization2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrganization2;
}
export interface CreateOrganizationApiKeyRequest extends Parsable {
    /**
     * A label so the key can be told apart from the organization's others.
     */
    name?: string | null;
    /**
     * The access the key grants: admin, storefront, or sql-connector.
     */
    scope?: string | null;
}
export interface CreateOrganizationApiKeyResponse extends Parsable {
    /**
     * The key value. Returned only here — it cannot be retrieved afterwards, so it has to bestored or handed on immediately.
     */
    apiKey?: string | null;
    /**
     * The durable identifier used to rotate or revoke this key later.
     */
    keyId?: string | null;
    /**
     * The access the key was granted.
     */
    scope?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrganizationApiKeySummary}
 */
// @ts-ignore
export function createOrganizationApiKeySummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrganizationApiKeySummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrganizationFeatures}
 */
// @ts-ignore
export function createOrganizationFeaturesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrganizationFeatures;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Organization}
 */
// @ts-ignore
export function createOrganizationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrganization;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrganizationInfo}
 */
// @ts-ignore
export function createOrganizationInfoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrganizationInfo;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrganizationProfileDto}
 */
// @ts-ignore
export function createOrganizationProfileDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrganizationProfileDto;
}
export interface CreateOrganizationRequest extends Parsable {
    /**
     * The organization property
     */
    organization?: Organization2 | null;
    /**
     * The user property
     */
    user?: User | null;
}
export interface CreateOrganizationResponse extends Parsable {
    /**
     * The identityOrganizationId property
     */
    identityOrganizationId?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The slug property
     */
    slug?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrganizationSalesRep}
 */
// @ts-ignore
export function createOrganizationSalesRepFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrganizationSalesRep;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OrganizationUser}
 */
// @ts-ignore
export function createOrganizationUserFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOrganizationUser;
}
export interface CreateOrUpdateDataMappingRequest extends Parsable {
    /**
     * The headerMappingFields property
     */
    headerMappingFields?: CreateOrUpdateDataMappingRequest_HeaderMappingField[] | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The invertActiveProperty property
     */
    invertActiveProperty?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface CreateOrUpdateDataMappingRequest_HeaderMappingField extends Parsable {
    /**
     * The header property
     */
    header?: string | null;
    /**
     * The mapping property
     */
    mapping?: CreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping | null;
}
export interface CreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping extends Parsable {
    /**
     * The mappedHeaderName property
     */
    mappedHeaderName?: string | null;
    /**
     * The uploadedHeaderName property
     */
    uploadedHeaderName?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfAccessRequest}
 */
// @ts-ignore
export function createPagedResultOfAccessRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfAccessRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfCampaign}
 */
// @ts-ignore
export function createPagedResultOfCampaignFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfCampaign;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfCommissionPlanDto}
 */
// @ts-ignore
export function createPagedResultOfCommissionPlanDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfCommissionPlanDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfCommissionStatementDto}
 */
// @ts-ignore
export function createPagedResultOfCommissionStatementDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfCommissionStatementDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfContactListItemDto}
 */
// @ts-ignore
export function createPagedResultOfContactListItemDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfContactListItemDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfCustomer}
 */
// @ts-ignore
export function createPagedResultOfCustomerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfCustomer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfCustomerNote}
 */
// @ts-ignore
export function createPagedResultOfCustomerNoteFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfCustomerNote;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfDataExport}
 */
// @ts-ignore
export function createPagedResultOfDataExportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfDataExport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfDiscountCode}
 */
// @ts-ignore
export function createPagedResultOfDiscountCodeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfDiscountCode;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfEntityDetailsResponseOfImageDetail}
 */
// @ts-ignore
export function createPagedResultOfEntityDetailsResponseOfImageDetailFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfEntityDetailsResponseOfImageDetail;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfFlipbook}
 */
// @ts-ignore
export function createPagedResultOfFlipbookFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfFlipbook;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfInvoiceDto}
 */
// @ts-ignore
export function createPagedResultOfInvoiceDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfInvoiceDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfInvoice}
 */
// @ts-ignore
export function createPagedResultOfInvoiceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfInvoice;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfOrderDto}
 */
// @ts-ignore
export function createPagedResultOfOrderDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfOrderDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfOrder}
 */
// @ts-ignore
export function createPagedResultOfOrderFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfOrder;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfOrderWithInvoiceNumbersDto}
 */
// @ts-ignore
export function createPagedResultOfOrderWithInvoiceNumbersDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfOrderWithInvoiceNumbersDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfProductFamily}
 */
// @ts-ignore
export function createPagedResultOfProductFamilyFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfProductFamily;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfProduct}
 */
// @ts-ignore
export function createPagedResultOfProductFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfProduct;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfSentEmailDto}
 */
// @ts-ignore
export function createPagedResultOfSentEmailDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfSentEmailDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfShoppingCart}
 */
// @ts-ignore
export function createPagedResultOfShoppingCartFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfShoppingCart;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfStorefrontUserResponse}
 */
// @ts-ignore
export function createPagedResultOfStorefrontUserResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfStorefrontUserResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfTaskItem}
 */
// @ts-ignore
export function createPagedResultOfTaskItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfTaskItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfTearSheet}
 */
// @ts-ignore
export function createPagedResultOfTearSheetFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfTearSheet;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfUserCustomer}
 */
// @ts-ignore
export function createPagedResultOfUserCustomerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfUserCustomer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfVendorCustomerDto}
 */
// @ts-ignore
export function createPagedResultOfVendorCustomerDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfVendorCustomerDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagedResultOfVendor}
 */
// @ts-ignore
export function createPagedResultOfVendorFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagedResultOfVendor;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Page}
 */
// @ts-ignore
export function createPageFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPage;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PageInfo}
 */
// @ts-ignore
export function createPageInfoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPageInfo;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PageUpdateInfo}
 */
// @ts-ignore
export function createPageUpdateInfoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPageUpdateInfo;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Payment2}
 */
// @ts-ignore
export function createPayment2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPayment2;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaymentDto}
 */
// @ts-ignore
export function createPaymentDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaymentDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Payment}
 */
// @ts-ignore
export function createPaymentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPayment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaymentMethod}
 */
// @ts-ignore
export function createPaymentMethodFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaymentMethod;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaymentProfile}
 */
// @ts-ignore
export function createPaymentProfileFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaymentProfile;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaymentRefundDto}
 */
// @ts-ignore
export function createPaymentRefundDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaymentRefundDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaymentRefund}
 */
// @ts-ignore
export function createPaymentRefundFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaymentRefund;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PendingPromotion}
 */
// @ts-ignore
export function createPendingPromotionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPendingPromotion;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PipelineStage}
 */
// @ts-ignore
export function createPipelineStageFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPipelineStage;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PlacedLine}
 */
// @ts-ignore
export function createPlacedLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPlacedLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PlaceLinesRequest}
 */
// @ts-ignore
export function createPlaceLinesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPlaceLinesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PlaceLinesResponse}
 */
// @ts-ignore
export function createPlaceLinesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPlaceLinesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PlansResponse}
 */
// @ts-ignore
export function createPlansResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPlansResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PortalSessionLinkResponse}
 */
// @ts-ignore
export function createPortalSessionLinkResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPortalSessionLinkResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Prediction}
 */
// @ts-ignore
export function createPredictionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPrediction;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PrefillVendorRequest}
 */
// @ts-ignore
export function createPrefillVendorRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPrefillVendorRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PriceOverrideDto}
 */
// @ts-ignore
export function createPriceOverrideDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPriceOverrideDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PriceOverride}
 */
// @ts-ignore
export function createPriceOverrideFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPriceOverride;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PriceTier}
 */
// @ts-ignore
export function createPriceTierFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPriceTier;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Product_categorySortOrders}
 */
// @ts-ignore
export function createProduct_categorySortOrdersFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProduct_categorySortOrders;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Product_optionValues}
 */
// @ts-ignore
export function createProduct_optionValuesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProduct_optionValues;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Product_productAttributeLabels}
 */
// @ts-ignore
export function createProduct_productAttributeLabelsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProduct_productAttributeLabels;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Product_productAttributes}
 */
// @ts-ignore
export function createProduct_productAttributesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProduct_productAttributes;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductAttribute}
 */
// @ts-ignore
export function createProductAttributeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductAttribute;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductFamily_imagesByOption}
 */
// @ts-ignore
export function createProductFamily_imagesByOptionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductFamily_imagesByOption;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductFamily}
 */
// @ts-ignore
export function createProductFamilyFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductFamily;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductFamilyOption}
 */
// @ts-ignore
export function createProductFamilyOptionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductFamilyOption;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductFamilyOptionValue}
 */
// @ts-ignore
export function createProductFamilyOptionValueFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductFamilyOptionValue;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductFamilySummary_pricesByTier}
 */
// @ts-ignore
export function createProductFamilySummary_pricesByTierFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductFamilySummary_pricesByTier;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductFamilySummary}
 */
// @ts-ignore
export function createProductFamilySummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductFamilySummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Product}
 */
// @ts-ignore
export function createProductFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProduct;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductOptionDefinition}
 */
// @ts-ignore
export function createProductOptionDefinitionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductOptionDefinition;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductOptionProfileDto}
 */
// @ts-ignore
export function createProductOptionProfileDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductOptionProfileDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductOptionValue}
 */
// @ts-ignore
export function createProductOptionValueFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductOptionValue;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductOptionValueProfileDto}
 */
// @ts-ignore
export function createProductOptionValueProfileDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductOptionValueProfileDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductPrice}
 */
// @ts-ignore
export function createProductPriceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductPrice;
}
export interface CreateProductRequest extends Parsable {
    /**
     * Whether the product is active. Omit it and an existing product keeps the flag it alreadyhad — an import can switch a product on or off, but a data sheet with no Active column canno longer take a whole catalog offline. A SKU that does not exist yet is created active.
     */
    active?: boolean | null;
    /**
     * The category property
     */
    category?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The dimensions property
     */
    dimensions?: string | null;
    /**
     * The dimensionsUnit property
     */
    dimensionsUnit?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The family's description, used when the family is created from this row.
     */
    familyDescription?: string | null;
    /**
     * Group this product into a family (requires product variants to be enabled for theorganization). A stable key for the style — a style code, a source system's product id.The family is created from this row if it does not exist. Omit for a standalone product.
     */
    familyKey?: string | null;
    /**
     * The family's display name, used when the family is created from this row.
     */
    familyName?: string | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The images property
     */
    images?: string[] | null;
    /**
     * The minimumOrderQuantity property
     */
    minimumOrderQuantity?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * This variant's option values keyed by option, e.g. { "Color": "Solid Black", "Size": "2XL" }.Display names or slugs are accepted; options and values not yet in the organization'sproduct options are registered at the end of their order.
     */
    optionValues?: CreateProductRequest_optionValues | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The prices property
     */
    prices?: CreateProductRequest_ProductPriceDto[] | null;
    /**
     * The productAttributes property
     */
    productAttributes?: CreateProductRequest_productAttributes | null;
    /**
     * The quantityIncrement property
     */
    quantityIncrement?: number | null;
    /**
     * The quantityOnHand property
     */
    quantityOnHand?: number | null;
    /**
     * Every add of this product to a cart creates a new line (jewelry sold by weight, custompieces). Omit it and an existing product keeps the flag it already has; a SKU that does notexist yet is created with it off. (CU-86bcpta0t)
     */
    separateLines?: boolean | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The upc property
     */
    upc?: string | null;
    /**
     * For agency organizations: the code of the vendor (line) this product belongs to, e.g. "HAL".The SKU is then stored as "{vendorCode}-{sku}" by the system; a value already carrying theprefix is left alone, so re-sending an exported SKU does not double it. Must name one of theorganization's vendors. Omit for the organization's own catalog. Refused for a Supplierorganization.
     */
    vendorCode?: string | null;
    /**
     * The weight property
     */
    weight?: number | null;
    /**
     * The weightUnit property
     */
    weightUnit?: string | null;
}
/**
 * This variant's option values keyed by option, e.g. { "Color": "Solid Black", "Size": "2XL" }.Display names or slugs are accepted; options and values not yet in the organization'sproduct options are registered at the end of their order.
 */
export interface CreateProductRequest_optionValues extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface CreateProductRequest_productAttributes extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface CreateProductRequest_ProductPriceDto extends Parsable {
    /**
     * The atQuantity property
     */
    atQuantity?: number | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The tier property
     */
    tier?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductRevenueRanking}
 */
// @ts-ignore
export function createProductRevenueRankingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductRevenueRanking;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProductsPageSummary}
 */
// @ts-ignore
export function createProductsPageSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProductsPageSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Promotion}
 */
// @ts-ignore
export function createPromotionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotion;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PromotionInput}
 */
// @ts-ignore
export function createPromotionInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotionInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PromotionPlan}
 */
// @ts-ignore
export function createPromotionPlanFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotionPlan;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PromotionProgress}
 */
// @ts-ignore
export function createPromotionProgressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotionProgress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PromotionSkip}
 */
// @ts-ignore
export function createPromotionSkipFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotionSkip;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PushEndpointsRequest}
 */
// @ts-ignore
export function createPushEndpointsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPushEndpointsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PushSyncRunRequest}
 */
// @ts-ignore
export function createPushSyncRunRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPushSyncRunRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {QuantityLimits}
 */
// @ts-ignore
export function createQuantityLimitsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoQuantityLimits;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {QueryFilter}
 */
// @ts-ignore
export function createQueryFilterFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoQueryFilter;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {QuickBooksAuthResponse}
 */
// @ts-ignore
export function createQuickBooksAuthResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoQuickBooksAuthResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {QuickBooksCompanyInfoResponse_CompanyInfo}
 */
// @ts-ignore
export function createQuickBooksCompanyInfoResponse_CompanyInfoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoQuickBooksCompanyInfoResponse_CompanyInfo;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {QuickbooksConnectedResponse}
 */
// @ts-ignore
export function createQuickbooksConnectedResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoQuickbooksConnectedResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {QuickBooksTokenRequest}
 */
// @ts-ignore
export function createQuickBooksTokenRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoQuickBooksTokenRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {QuickBooksTokenResponse}
 */
// @ts-ignore
export function createQuickBooksTokenResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoQuickBooksTokenResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {QuietAccount}
 */
// @ts-ignore
export function createQuietAccountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoQuietAccount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RawBodyRequest}
 */
// @ts-ignore
export function createRawBodyRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRawBodyRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReactivateVendorRequest}
 */
// @ts-ignore
export function createReactivateVendorRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReactivateVendorRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReadmeAuthResponse}
 */
// @ts-ignore
export function createReadmeAuthResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReadmeAuthResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReassignCustomerRequest}
 */
// @ts-ignore
export function createReassignCustomerRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReassignCustomerRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReassignCustomerResponse}
 */
// @ts-ignore
export function createReassignCustomerResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReassignCustomerResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReconcileRepNumberChannelsRequest}
 */
// @ts-ignore
export function createReconcileRepNumberChannelsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReconcileRepNumberChannelsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReconcileRepNumberChannelsResponse}
 */
// @ts-ignore
export function createReconcileRepNumberChannelsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReconcileRepNumberChannelsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RecordPaymentRequest}
 */
// @ts-ignore
export function createRecordPaymentRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRecordPaymentRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RefreshProductFamilySummariesResponse}
 */
// @ts-ignore
export function createRefreshProductFamilySummariesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRefreshProductFamilySummariesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RefreshUrlResponse}
 */
// @ts-ignore
export function createRefreshUrlResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRefreshUrlResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RefundPaymentRequest}
 */
// @ts-ignore
export function createRefundPaymentRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRefundPaymentRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RegisterSqlConnectorRequest_metadata}
 */
// @ts-ignore
export function createRegisterSqlConnectorRequest_metadataFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRegisterSqlConnectorRequest_metadata;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RegisterSqlConnectorRequest}
 */
// @ts-ignore
export function createRegisterSqlConnectorRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRegisterSqlConnectorRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RemoveDiscountRequest}
 */
// @ts-ignore
export function createRemoveDiscountRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRemoveDiscountRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RemoveItemFromListRequest}
 */
// @ts-ignore
export function createRemoveItemFromListRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRemoveItemFromListRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RemoveVendorImageRequest}
 */
// @ts-ignore
export function createRemoveVendorImageRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRemoveVendorImageRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RenameListRequest}
 */
// @ts-ignore
export function createRenameListRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRenameListRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderCategoriesRequest}
 */
// @ts-ignore
export function createReorderCategoriesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderCategoriesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderCategoriesResponse}
 */
// @ts-ignore
export function createReorderCategoriesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderCategoriesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderCustomerAttributesRequest}
 */
// @ts-ignore
export function createReorderCustomerAttributesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderCustomerAttributesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderCustomerAttributesResponse}
 */
// @ts-ignore
export function createReorderCustomerAttributesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderCustomerAttributesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderFulfillmentMethodsRequest}
 */
// @ts-ignore
export function createReorderFulfillmentMethodsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderFulfillmentMethodsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderFulfillmentMethodsResponse}
 */
// @ts-ignore
export function createReorderFulfillmentMethodsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderFulfillmentMethodsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderOrderStatusesRequest}
 */
// @ts-ignore
export function createReorderOrderStatusesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderOrderStatusesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderOrderStatusesResponse}
 */
// @ts-ignore
export function createReorderOrderStatusesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderOrderStatusesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderOrderTypesRequest}
 */
// @ts-ignore
export function createReorderOrderTypesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderOrderTypesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderOrderTypesResponse}
 */
// @ts-ignore
export function createReorderOrderTypesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderOrderTypesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderProductAttributesRequest}
 */
// @ts-ignore
export function createReorderProductAttributesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderProductAttributesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderProductAttributesResponse}
 */
// @ts-ignore
export function createReorderProductAttributesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderProductAttributesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderProductsRequest}
 */
// @ts-ignore
export function createReorderProductsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderProductsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderProductsResponse}
 */
// @ts-ignore
export function createReorderProductsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderProductsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderTasksRequest}
 */
// @ts-ignore
export function createReorderTasksRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderTasksRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderTermsRequest}
 */
// @ts-ignore
export function createReorderTermsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderTermsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReorderTermsResponse}
 */
// @ts-ignore
export function createReorderTermsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReorderTermsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Rep}
 */
// @ts-ignore
export function createRepFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRep;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReplaceProductOptionsRequest_ProductOptionInput}
 */
// @ts-ignore
export function createReplaceProductOptionsRequest_ProductOptionInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReplaceProductOptionsRequest_ProductOptionInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReplaceProductOptionsRequest_ProductOptionValueInput}
 */
// @ts-ignore
export function createReplaceProductOptionsRequest_ProductOptionValueInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReplaceProductOptionsRequest_ProductOptionValueInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReplaceProductOptionsRequest}
 */
// @ts-ignore
export function createReplaceProductOptionsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReplaceProductOptionsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReportMappingOutcomeRequest}
 */
// @ts-ignore
export function createReportMappingOutcomeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReportMappingOutcomeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResearchAccessRequestResponse}
 */
// @ts-ignore
export function createResearchAccessRequestResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResearchAccessRequestResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResearchedAddress}
 */
// @ts-ignore
export function createResearchedAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResearchedAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResearchedValue}
 */
// @ts-ignore
export function createResearchedValueFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResearchedValue;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResendSalesRepWelcomeRequest}
 */
// @ts-ignore
export function createResendSalesRepWelcomeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResendSalesRepWelcomeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResendSalesRepWelcomeResponse}
 */
// @ts-ignore
export function createResendSalesRepWelcomeResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResendSalesRepWelcomeResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResendWelcomeEmailRequest}
 */
// @ts-ignore
export function createResendWelcomeEmailRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResendWelcomeEmailRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResendWelcomeEmailResponse}
 */
// @ts-ignore
export function createResendWelcomeEmailResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResendWelcomeEmailResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RestoreAccessRequestResponse}
 */
// @ts-ignore
export function createRestoreAccessRequestResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRestoreAccessRequestResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RestoreTrashedImagesRequest}
 */
// @ts-ignore
export function createRestoreTrashedImagesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRestoreTrashedImagesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RestoreTrashedImagesResponse}
 */
// @ts-ignore
export function createRestoreTrashedImagesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRestoreTrashedImagesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Result}
 */
// @ts-ignore
export function createResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ReturnToReviewRequest}
 */
// @ts-ignore
export function createReturnToReviewRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoReturnToReviewRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevenueKpi}
 */
// @ts-ignore
export function createRevenueKpiFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevenueKpi;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevokeCustomerAccessResponse}
 */
// @ts-ignore
export function createRevokeCustomerAccessResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevokeCustomerAccessResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevokeOrganizationApiKeyResponse}
 */
// @ts-ignore
export function createRevokeOrganizationApiKeyResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevokeOrganizationApiKeyResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RotateIntegrationSecretsRequest_newSecrets}
 */
// @ts-ignore
export function createRotateIntegrationSecretsRequest_newSecretsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRotateIntegrationSecretsRequest_newSecrets;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RotateIntegrationSecretsRequest}
 */
// @ts-ignore
export function createRotateIntegrationSecretsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRotateIntegrationSecretsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RotateIntegrationSecretsResponse}
 */
// @ts-ignore
export function createRotateIntegrationSecretsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRotateIntegrationSecretsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RotateOrganizationApiKeyResponse}
 */
// @ts-ignore
export function createRotateOrganizationApiKeyResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRotateOrganizationApiKeyResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SalesRep2}
 */
// @ts-ignore
export function createSalesRep2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSalesRep2;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SalesRepDeviceDto}
 */
// @ts-ignore
export function createSalesRepDeviceDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSalesRepDeviceDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SalesRepDto}
 */
// @ts-ignore
export function createSalesRepDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSalesRepDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SalesRep}
 */
// @ts-ignore
export function createSalesRepFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSalesRep;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SalesRepInput}
 */
// @ts-ignore
export function createSalesRepInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSalesRepInput;
}
/**
 * Represents a request to create a Sales Representative.
 */
export interface CreateSalesRepRequest extends Parsable {
    /**
     * Gets or sets the email of the sales representative.
     */
    email?: string | null;
    /**
     * Gets or sets the first name of the sales representative.
     */
    firstName?: string | null;
    /**
     * Gets or sets the last name of the sales representative.
     */
    lastName?: string | null;
    /**
     * Gets or sets the market code used to group this rep's carts and orders for reporting and ERP.Optional and free text; a non-empty value is also remembered on the organization as asuggestion for other reps.
     */
    marketCode?: string | null;
    /**
     * Gets or sets the phone number of the sales representative.
     */
    phoneNumber?: string | null;
    /**
     * Gets or sets the representative number of the sales representative. WhenRepNumbers is provided this is ignored — the rep's default number is thefirst entry of that list.
     */
    repNumber?: string | null;
    /**
     * Gets or sets the ordered representative numbers for the rep. The first entry is thedefault; each number grants the rep the matching customer sync channel. Optional — omitto create the rep with the single RepNumber.
     */
    repNumbers?: string[] | null;
    /**
     * Gets or sets the roles of the sales representative.
     */
    roles?: string[] | null;
}
export interface CreateSalesRepResponse extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The identityOrganizationId property
     */
    identityOrganizationId?: string | null;
    /**
     * The identityProvider property
     */
    identityProvider?: string | null;
    /**
     * The identityProviderUserId property
     */
    identityProviderUserId?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The marketCode property
     */
    marketCode?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The organizationName property
     */
    organizationName?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * Ordered rep numbers; the first entry is the default and equals RepNumber.
     */
    repNumbers?: string[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SalesRepRevenueRanking}
 */
// @ts-ignore
export function createSalesRepRevenueRankingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSalesRepRevenueRanking;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SalesRepTrend}
 */
// @ts-ignore
export function createSalesRepTrendFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSalesRepTrend;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SalesTrendPoint}
 */
// @ts-ignore
export function createSalesTrendPointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSalesTrendPoint;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SavePaymentMethodRequest}
 */
// @ts-ignore
export function createSavePaymentMethodRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSavePaymentMethodRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SavePaymentMethodResponse}
 */
// @ts-ignore
export function createSavePaymentMethodResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSavePaymentMethodResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SaveProductFamilyRequest_imagesByOption}
 */
// @ts-ignore
export function createSaveProductFamilyRequest_imagesByOptionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSaveProductFamilyRequest_imagesByOption;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SaveProductFamilyRequest_SaveProductFamilyOption}
 */
// @ts-ignore
export function createSaveProductFamilyRequest_SaveProductFamilyOptionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSaveProductFamilyRequest_SaveProductFamilyOption;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SaveProductFamilyRequest}
 */
// @ts-ignore
export function createSaveProductFamilyRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSaveProductFamilyRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SaveSignupProgressRequest}
 */
// @ts-ignore
export function createSaveSignupProgressRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSaveSignupProgressRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SecretField}
 */
// @ts-ignore
export function createSecretFieldFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSecretField;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SendCartShareMessageRequest}
 */
// @ts-ignore
export function createSendCartShareMessageRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSendCartShareMessageRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SendCartShareMessageResponse}
 */
// @ts-ignore
export function createSendCartShareMessageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSendCartShareMessageResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SendCompanyDocsMessageRequest}
 */
// @ts-ignore
export function createSendCompanyDocsMessageRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSendCompanyDocsMessageRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SendCompanyDocsMessageResponse}
 */
// @ts-ignore
export function createSendCompanyDocsMessageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSendCompanyDocsMessageResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SendTearSheetsMessageRequest}
 */
// @ts-ignore
export function createSendTearSheetsMessageRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSendTearSheetsMessageRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SendTearSheetsMessageResponse}
 */
// @ts-ignore
export function createSendTearSheetsMessageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSendTearSheetsMessageResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SentEmailDetailDto}
 */
// @ts-ignore
export function createSentEmailDetailDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSentEmailDetailDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SentEmailDto}
 */
// @ts-ignore
export function createSentEmailDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSentEmailDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SentEmailEventDto}
 */
// @ts-ignore
export function createSentEmailEventDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSentEmailEventDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetAsDefaultRequest}
 */
// @ts-ignore
export function createSetAsDefaultRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetAsDefaultRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetCampaignActiveRequest}
 */
// @ts-ignore
export function createSetCampaignActiveRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetCampaignActiveRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetCodeActiveRequest}
 */
// @ts-ignore
export function createSetCodeActiveRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetCodeActiveRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetCustomerVendorAccountRequest}
 */
// @ts-ignore
export function createSetCustomerVendorAccountRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetCustomerVendorAccountRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetDiscountPermissionsRequest}
 */
// @ts-ignore
export function createSetDiscountPermissionsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetDiscountPermissionsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetDiscountPermissionsResponse}
 */
// @ts-ignore
export function createSetDiscountPermissionsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetDiscountPermissionsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetVendorLineDiscountRequest}
 */
// @ts-ignore
export function createSetVendorLineDiscountRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetVendorLineDiscountRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetVendorLineShipWindowRequest}
 */
// @ts-ignore
export function createSetVendorLineShipWindowRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetVendorLineShipWindowRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetViewAllCustomersRequest}
 */
// @ts-ignore
export function createSetViewAllCustomersRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetViewAllCustomersRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetViewAllCustomersResponse}
 */
// @ts-ignore
export function createSetViewAllCustomersResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetViewAllCustomersResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ShippingDetailsDto}
 */
// @ts-ignore
export function createShippingDetailsDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoShippingDetailsDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ShippingDetails}
 */
// @ts-ignore
export function createShippingDetailsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoShippingDetails;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ShippingDetailsInput}
 */
// @ts-ignore
export function createShippingDetailsInputFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoShippingDetailsInput;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ShoppingCart}
 */
// @ts-ignore
export function createShoppingCartFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoShoppingCart;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SimulateRequest}
 */
// @ts-ignore
export function createSimulateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSimulateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SimulateResponse}
 */
// @ts-ignore
export function createSimulateResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSimulateResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SkippedLine}
 */
// @ts-ignore
export function createSkippedLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSkippedLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SkuHistoryPointDto}
 */
// @ts-ignore
export function createSkuHistoryPointDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSkuHistoryPointDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SplitVendorLineResponse}
 */
// @ts-ignore
export function createSplitVendorLineResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSplitVendorLineResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SqlConnectorStatus_metadata}
 */
// @ts-ignore
export function createSqlConnectorStatus_metadataFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSqlConnectorStatus_metadata;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SqlConnectorStatus}
 */
// @ts-ignore
export function createSqlConnectorStatusFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSqlConnectorStatus;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StatementEventDto}
 */
// @ts-ignore
export function createStatementEventDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStatementEventDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Step}
 */
// @ts-ignore
export function createStepFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStep;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StorageStatsResponse}
 */
// @ts-ignore
export function createStorageStatsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStorageStatsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StorefrontUserCustomerResponse}
 */
// @ts-ignore
export function createStorefrontUserCustomerResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStorefrontUserCustomerResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StorefrontUserResponse}
 */
// @ts-ignore
export function createStorefrontUserResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStorefrontUserResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StructuredFormatting}
 */
// @ts-ignore
export function createStructuredFormattingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStructuredFormatting;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubmitForReviewRequest2}
 */
// @ts-ignore
export function createSubmitForReviewRequest2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubmitForReviewRequest2;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubmitForReviewRequest}
 */
// @ts-ignore
export function createSubmitForReviewRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubmitForReviewRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Subscription2}
 */
// @ts-ignore
export function createSubscription2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscription2;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubscriptionCreatedCustomer}
 */
// @ts-ignore
export function createSubscriptionCreatedCustomerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscriptionCreatedCustomer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubscriptionCreatedRequest}
 */
// @ts-ignore
export function createSubscriptionCreatedRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscriptionCreatedRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubscriptionDiscountLine}
 */
// @ts-ignore
export function createSubscriptionDiscountLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscriptionDiscountLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubscriptionEntitlement}
 */
// @ts-ignore
export function createSubscriptionEntitlementFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscriptionEntitlement;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Subscription}
 */
// @ts-ignore
export function createSubscriptionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscription;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubscriptionItem}
 */
// @ts-ignore
export function createSubscriptionItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscriptionItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubscriptionPlanLine}
 */
// @ts-ignore
export function createSubscriptionPlanLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscriptionPlanLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SuggestMappingsRequest}
 */
// @ts-ignore
export function createSuggestMappingsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSuggestMappingsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SuggestMappingsResponse}
 */
// @ts-ignore
export function createSuggestMappingsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSuggestMappingsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SuggestResearchSettingsRequest}
 */
// @ts-ignore
export function createSuggestResearchSettingsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSuggestResearchSettingsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SuggestResearchSettingsResponse}
 */
// @ts-ignore
export function createSuggestResearchSettingsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSuggestResearchSettingsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SyncBatchResultDto}
 */
// @ts-ignore
export function createSyncBatchResultDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSyncBatchResultDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SyncRunDocument}
 */
// @ts-ignore
export function createSyncRunDocumentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSyncRunDocument;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Tag}
 */
// @ts-ignore
export function createTagFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTag;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TagInfo}
 */
// @ts-ignore
export function createTagInfoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTagInfo;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TaskItem}
 */
// @ts-ignore
export function createTaskItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTaskItem;
}
export interface CreateTaskRequest extends Parsable {
    /**
     * Display name of whoever is creating the task, up to 200 characters. Client-stamped, the sameway a note's author name is; the caller's identity is taken from the token and governsnothing beyond attribution.
     */
    createdByName?: string | null;
    /**
     * Optional: the customer number of the customer the task is about.
     */
    customerNumber?: string | null;
    /**
     * Optional detail, plain text up to 4000 characters.
     */
    description?: string | null;
    /**
     * When the task is due, date and time, as an ISO 8601 instant with its offset. Stored andreturned in UTC; send the time zone it was entered in separately.
     */
    dueAt?: Date | null;
    /**
     * Optional: the IANA time zone the due time was entered in, such as America/Toronto. Kept fordisplay and for reminders; it does not change the instant.
     */
    dueTimeZoneId?: string | null;
    /**
     * Optional: the organization sales rep id of the rep the task is assigned to. The rep must bean active member of the organization.
     */
    organizationSalesRepId?: string | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Low, Normal, High or Urgent. Normal when omitted.
     */
    priority?: TaskPriority | null;
    /**
     * What needs doing, up to 200 characters.
     */
    title?: string | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TasksSummaryResponse}
 */
// @ts-ignore
export function createTasksSummaryResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTasksSummaryResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TaxLineItem}
 */
// @ts-ignore
export function createTaxLineItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTaxLineItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TaxRule}
 */
// @ts-ignore
export function createTaxRuleFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTaxRule;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TaxSettings}
 */
// @ts-ignore
export function createTaxSettingsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTaxSettings;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TearSheet}
 */
// @ts-ignore
export function createTearSheetFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTearSheet;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Term}
 */
// @ts-ignore
export function createTermFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTerm;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TestIntegrationResponse}
 */
// @ts-ignore
export function createTestIntegrationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTestIntegrationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TestJobRequest}
 */
// @ts-ignore
export function createTestJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTestJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TrainOrderVolumeForecastModelRequest}
 */
// @ts-ignore
export function createTrainOrderVolumeForecastModelRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTrainOrderVolumeForecastModelRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TrainOrderVolumeForecastModelResponse}
 */
// @ts-ignore
export function createTrainOrderVolumeForecastModelResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTrainOrderVolumeForecastModelResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TrainSkuForecastModelRequest}
 */
// @ts-ignore
export function createTrainSkuForecastModelRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTrainSkuForecastModelRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TrainSkuForecastModelResponse}
 */
// @ts-ignore
export function createTrainSkuForecastModelResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTrainSkuForecastModelResponse;
}
/**
 * Request to create a WorldPay transaction setup for hosted payments
 */
export interface CreateTransactionSetupRequest extends Parsable {
    /**
     * Return URL for the application that initialed this request, called after the WorldPay Callback Endpoint is called
     */
    applicationReturnUrl?: string | null;
    /**
     * Customer number for the transaction
     */
    customerNumber?: string | null;
    /**
     * Whether this payment method should be set as the default
     */
    isDefault?: boolean | null;
    /**
     * Market code (defaults to "Default")
     */
    marketCode?: string | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching
     */
    orgCodes?: string[] | null;
    /**
     * Transaction amount (use 0.00 for saving payment method only)
     */
    transactionAmount?: number | null;
    /**
     * Optional: OrganizationId to switch to (must be in user's OrgCodes)
     */
    useOrganizationId?: string | null;
}
/**
 * Response from creating a WorldPay transaction setup
 */
export interface CreateTransactionSetupResponse extends Parsable {
    /**
     * The complete hosted payment URL where the user should be redirected
     */
    hostedPaymentUrl?: string | null;
    /**
     * The transaction setup ID from WorldPay (valid for 10 minutes)
     */
    transactionSetupId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateAccessRequestNotificationSettingsRequest}
 */
// @ts-ignore
export function createUpdateAccessRequestNotificationSettingsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateAccessRequestNotificationSettingsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCartPoNumberRequest}
 */
// @ts-ignore
export function createUpdateCartPoNumberRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCartPoNumberRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCartPricingSettingsRequest}
 */
// @ts-ignore
export function createUpdateCartPricingSettingsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCartPricingSettingsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCartReceiptToRequest}
 */
// @ts-ignore
export function createUpdateCartReceiptToRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCartReceiptToRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCartRequest}
 */
// @ts-ignore
export function createUpdateCartRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCartRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCartShippingRequest}
 */
// @ts-ignore
export function createUpdateCartShippingRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCartShippingRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCommissionPlanRequest}
 */
// @ts-ignore
export function createUpdateCommissionPlanRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCommissionPlanRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerNoteRequest}
 */
// @ts-ignore
export function createUpdateCustomerNoteRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerNoteRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerRequest}
 */
// @ts-ignore
export function createUpdateCustomerRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerResponse}
 */
// @ts-ignore
export function createUpdateCustomerResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateFlipbookRequest}
 */
// @ts-ignore
export function createUpdateFlipbookRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateFlipbookRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateIntegrationRequest_configuration}
 */
// @ts-ignore
export function createUpdateIntegrationRequest_configurationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateIntegrationRequest_configuration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateIntegrationRequest_secrets}
 */
// @ts-ignore
export function createUpdateIntegrationRequest_secretsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateIntegrationRequest_secrets;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateIntegrationRequest}
 */
// @ts-ignore
export function createUpdateIntegrationRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateIntegrationRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateIntegrationResponse_configuration}
 */
// @ts-ignore
export function createUpdateIntegrationResponse_configurationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateIntegrationResponse_configuration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateIntegrationResponse}
 */
// @ts-ignore
export function createUpdateIntegrationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateIntegrationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateInvoiceRequest}
 */
// @ts-ignore
export function createUpdateInvoiceRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateInvoiceRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateItemQuantityRequest}
 */
// @ts-ignore
export function createUpdateItemQuantityRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateItemQuantityRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateItemRequest}
 */
// @ts-ignore
export function createUpdateItemRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateItemRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateLineRequest}
 */
// @ts-ignore
export function createUpdateLineRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateLineRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateOrderExportSettingsRequest}
 */
// @ts-ignore
export function createUpdateOrderExportSettingsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateOrderExportSettingsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateOrderReceiptSettingsRequest}
 */
// @ts-ignore
export function createUpdateOrderReceiptSettingsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateOrderReceiptSettingsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateOrderStatusRequest}
 */
// @ts-ignore
export function createUpdateOrderStatusRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateOrderStatusRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateOrganizationFeaturesRequest}
 */
// @ts-ignore
export function createUpdateOrganizationFeaturesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateOrganizationFeaturesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdatePriceTierRequest}
 */
// @ts-ignore
export function createUpdatePriceTierRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdatePriceTierRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductCategoriesRequest_CategoryUpdate}
 */
// @ts-ignore
export function createUpdateProductCategoriesRequest_CategoryUpdateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductCategoriesRequest_CategoryUpdate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductCategoriesRequest}
 */
// @ts-ignore
export function createUpdateProductCategoriesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductCategoriesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductImagesRequest}
 */
// @ts-ignore
export function createUpdateProductImagesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductImagesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductPricesRequest_ProductPriceDto}
 */
// @ts-ignore
export function createUpdateProductPricesRequest_ProductPriceDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductPricesRequest_ProductPriceDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductPricesRequest_ProductPriceUpdate}
 */
// @ts-ignore
export function createUpdateProductPricesRequest_ProductPriceUpdateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductPricesRequest_ProductPriceUpdate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductPricesRequest}
 */
// @ts-ignore
export function createUpdateProductPricesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductPricesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductRequest_optionValues}
 */
// @ts-ignore
export function createUpdateProductRequest_optionValuesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductRequest_optionValues;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductRequest_productAttributes}
 */
// @ts-ignore
export function createUpdateProductRequest_productAttributesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductRequest_productAttributes;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductRequest_ProductPriceDto}
 */
// @ts-ignore
export function createUpdateProductRequest_ProductPriceDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductRequest_ProductPriceDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductRequest}
 */
// @ts-ignore
export function createUpdateProductRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductSortOrdersRequest_SortOrderUpdate}
 */
// @ts-ignore
export function createUpdateProductSortOrdersRequest_SortOrderUpdateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductSortOrdersRequest_SortOrderUpdate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductSortOrdersRequest}
 */
// @ts-ignore
export function createUpdateProductSortOrdersRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductSortOrdersRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductSortOrdersResponse_skipReasons}
 */
// @ts-ignore
export function createUpdateProductSortOrdersResponse_skipReasonsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductSortOrdersResponse_skipReasons;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductSortOrdersResponse}
 */
// @ts-ignore
export function createUpdateProductSortOrdersResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductSortOrdersResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductTagsRequest_TagUpdate}
 */
// @ts-ignore
export function createUpdateProductTagsRequest_TagUpdateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductTagsRequest_TagUpdate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductTagsRequest}
 */
// @ts-ignore
export function createUpdateProductTagsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductTagsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateProductTagsResponse}
 */
// @ts-ignore
export function createUpdateProductTagsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateProductTagsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateResearchSettingsRequest}
 */
// @ts-ignore
export function createUpdateResearchSettingsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateResearchSettingsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateSalesRepRequest}
 */
// @ts-ignore
export function createUpdateSalesRepRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateSalesRepRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateSalesRepResponse}
 */
// @ts-ignore
export function createUpdateSalesRepResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateSalesRepResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateSeatsRequest}
 */
// @ts-ignore
export function createUpdateSeatsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateSeatsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateSeatsResponse}
 */
// @ts-ignore
export function createUpdateSeatsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateSeatsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateTaskRequest}
 */
// @ts-ignore
export function createUpdateTaskRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateTaskRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateVendorLineHeaderRequest}
 */
// @ts-ignore
export function createUpdateVendorLineHeaderRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateVendorLineHeaderRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateVendorRequest}
 */
// @ts-ignore
export function createUpdateVendorRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateVendorRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UploadManyImagesRequest}
 */
// @ts-ignore
export function createUploadManyImagesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUploadManyImagesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {User2}
 */
// @ts-ignore
export function createUser2FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUser2;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {User3}
 */
// @ts-ignore
export function createUser3FromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUser3;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UserCustomer}
 */
// @ts-ignore
export function createUserCustomerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUserCustomer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UserDto}
 */
// @ts-ignore
export function createUserDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUserDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UserExistsResponse}
 */
// @ts-ignore
export function createUserExistsResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUserExistsResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {User}
 */
// @ts-ignore
export function createUserFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUser;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UserOrganizationDto}
 */
// @ts-ignore
export function createUserOrganizationDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUserOrganizationDto;
}
export interface CreateUserRequest extends Parsable {
    /**
     * Gets or sets the email of the sales representative.
     */
    email?: string | null;
    /**
     * Gets or sets the first name of the sales representative.
     */
    firstName?: string | null;
    /**
     * Gets or sets the Identity Organization Id.
     */
    identityOrganizationId?: string | null;
    /**
     * Gets or sets the last name of the sales representative.
     */
    lastName?: string | null;
    /**
     * Gets or sets the phone number of the sales representative.
     */
    phoneNumber?: string | null;
}
export interface CreateUserResponse extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ValidateConfig_ValidateConfigResponse}
 */
// @ts-ignore
export function createValidateConfig_ValidateConfigResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoValidateConfig_ValidateConfigResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ValidateIntegrationTemplateRequest_configuration}
 */
// @ts-ignore
export function createValidateIntegrationTemplateRequest_configurationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoValidateIntegrationTemplateRequest_configuration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ValidateIntegrationTemplateRequest_secrets}
 */
// @ts-ignore
export function createValidateIntegrationTemplateRequest_secretsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoValidateIntegrationTemplateRequest_secrets;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ValidateIntegrationTemplateRequest}
 */
// @ts-ignore
export function createValidateIntegrationTemplateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoValidateIntegrationTemplateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ValidateIntegrationTemplateResponse}
 */
// @ts-ignore
export function createValidateIntegrationTemplateResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoValidateIntegrationTemplateResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorCartRequest}
 */
// @ts-ignore
export function createVendorCartRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorCartRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorCustomerDto}
 */
// @ts-ignore
export function createVendorCustomerDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorCustomerDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorFieldsRequest}
 */
// @ts-ignore
export function createVendorFieldsRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorFieldsRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Vendor}
 */
// @ts-ignore
export function createVendorFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendor;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorLineDto}
 */
// @ts-ignore
export function createVendorLineDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorLineDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorLineOptionsDto}
 */
// @ts-ignore
export function createVendorLineOptionsDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorLineOptionsDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorLineRequest}
 */
// @ts-ignore
export function createVendorLineRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorLineRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorLinesResponse}
 */
// @ts-ignore
export function createVendorLinesResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorLinesResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorMinimum}
 */
// @ts-ignore
export function createVendorMinimumFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorMinimum;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorOrderDestination}
 */
// @ts-ignore
export function createVendorOrderDestinationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorOrderDestination;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorPrefillHints}
 */
// @ts-ignore
export function createVendorPrefillHintsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorPrefillHints;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorPrefillSuggestions_fields}
 */
// @ts-ignore
export function createVendorPrefillSuggestions_fieldsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorPrefillSuggestions_fields;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorPrefillSuggestions}
 */
// @ts-ignore
export function createVendorPrefillSuggestionsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorPrefillSuggestions;
}
export interface CreateVendorRequest extends AdditionalDataHolder, Parsable, VendorFieldsRequest {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The vendor's short code, e.g. "HAL": 1 to 16 characters with no spaces, '-', ':' or '/'. Storedupper-cased, unique within the organization, and fixed once set — every product of thisline carries it as the prefix of its SKU.
     */
    vendorCode?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VendorShipWindow}
 */
// @ts-ignore
export function createVendorShipWindowFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVendorShipWindow;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ViewCartShareMessageResponse}
 */
// @ts-ignore
export function createViewCartShareMessageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoViewCartShareMessageResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ViewCompanyDocsMessageResponse}
 */
// @ts-ignore
export function createViewCompanyDocsMessageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoViewCompanyDocsMessageResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ViewTearSheetsMessageResponse}
 */
// @ts-ignore
export function createViewTearSheetsMessageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoViewTearSheetsMessageResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VoidInvoiceRequest}
 */
// @ts-ignore
export function createVoidInvoiceRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVoidInvoiceRequest;
}
export interface CreateWebsiteApiKeyResponse extends Parsable {
    /**
     * The apiKey property
     */
    apiKey?: string | null;
}
export interface CreditCard extends Parsable {
    /**
     * The cardholderName property
     */
    cardholderName?: string | null;
    /**
     * The cardNumber property
     */
    cardNumber?: string | null;
    /**
     * The cvv property
     */
    cvv?: string | null;
    /**
     * The expiryMonth property
     */
    expiryMonth?: string | null;
    /**
     * The expiryYear property
     */
    expiryYear?: number | null;
}
export type CurrencyCode = (typeof CurrencyCodeObject)[keyof typeof CurrencyCodeObject];
export interface Customer extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The addresses property
     */
    addresses?: Address[] | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The contacts property
     */
    contacts?: Contact[] | null;
    /**
     * The customerAttributes property
     */
    customerAttributes?: Customer_customerAttributes | null;
    /**
     * The customerId property
     */
    customerId?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The defaultBillingAddress property
     */
    defaultBillingAddress?: Address | null;
    /**
     * The defaultShippingAddress property
     */
    defaultShippingAddress?: Address | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The pricing property
     */
    pricing?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The taxExempt property
     */
    taxExempt?: boolean | null;
    /**
     * The taxExemptionNumber property
     */
    taxExemptionNumber?: string | null;
    /**
     * The terms property
     */
    terms?: string | null;
}
export interface Customer_customerAttributes extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface Customer2 extends Parsable {
    /**
     * The billingAddress property
     */
    billingAddress?: Address | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The shippingAddress property
     */
    shippingAddress?: Address | null;
}
export interface Customer3 extends Parsable {
    /**
     * The billingAddress property
     */
    billingAddress?: Address | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The shippingAddress property
     */
    shippingAddress?: Address | null;
}
export interface CustomerAttribute extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * The slug property
     */
    slug?: string | null;
}
export interface CustomerDto extends Parsable {
    /**
     * The billingAddress property
     */
    billingAddress?: AddressDto | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The shippingAddress property
     */
    shippingAddress?: AddressDto | null;
}
export interface CustomerHealth extends Parsable {
    /**
     * The activeCount property
     */
    activeCount?: number | null;
    /**
     * The asOf property
     */
    asOf?: Date | null;
    /**
     * The atRiskCount property
     */
    atRiskCount?: number | null;
    /**
     * The coolingCount property
     */
    coolingCount?: number | null;
    /**
     * The lapsedCount property
     */
    lapsedCount?: number | null;
    /**
     * The totalCustomers property
     */
    totalCustomers?: number | null;
    /**
     * The worthACall property
     */
    worthACall?: QuietAccount[] | null;
}
export interface CustomerInput extends Parsable {
    /**
     * The billingAddress property
     */
    billingAddress?: AddressInput | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The shippingAddress property
     */
    shippingAddress?: AddressInput | null;
}
export interface CustomerNote extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The authorName property
     */
    authorName?: string | null;
    /**
     * The body property
     */
    body?: string | null;
    /**
     * The customerId property
     */
    customerId?: string | null;
    /**
     * The customerNoteId property
     */
    customerNoteId?: string | null;
    /**
     * The identityProviderUserId property
     */
    identityProviderUserId?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
/**
 * Different commission terms for one customer.
 */
export interface CustomerOverrideDto extends Parsable {
    /**
     * The customer this applies to, matched case-insensitively.
     */
    customerNumber?: string | null;
    /**
     * The rate for lines none of the override's rules match, as a fraction between 0 and 1. Null fallsback to the plan's default rate.
     */
    defaultRate?: number | null;
    /**
     * Latest invoice date the override covers, inclusive. Null leaves it open-ended into the future.
     */
    effectiveEndDate?: Date | null;
    /**
     * Earliest invoice date the override covers, inclusive. Null leaves it open-ended into the past.
     */
    effectiveStartDate?: Date | null;
    /**
     * The rules used instead of the plan's for this customer, resolved by priority in the same way. Anempty list means every line gets the override's default rate.
     */
    rules?: CommissionRuleDto[] | null;
}
export interface CustomerRevenueRanking extends Parsable {
    /**
     * The averageOrderValue property
     */
    averageOrderValue?: number | null;
    /**
     * The customerName property
     */
    customerName?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The totalRevenue property
     */
    totalRevenue?: number | null;
}
export interface CustomersPageSummary extends Parsable {
    /**
     * The asOf property
     */
    asOf?: Date | null;
    /**
     * The atRiskAccounts property
     */
    atRiskAccounts?: QuietAccount[] | null;
    /**
     * The atRiskCount property
     */
    atRiskCount?: number | null;
    /**
     * The atRiskLifetimeRevenue property
     */
    atRiskLifetimeRevenue?: number | null;
    /**
     * The newLast30Days property
     */
    newLast30Days?: number | null;
    /**
     * The orderedLast90Days property
     */
    orderedLast90Days?: number | null;
    /**
     * The orderedSame90DaysLastYear property
     */
    orderedSame90DaysLastYear?: number | null;
    /**
     * The reorderRate property
     */
    reorderRate?: number | null;
    /**
     * The reorderRatePriorYear property
     */
    reorderRatePriorYear?: number | null;
    /**
     * The totalCustomers property
     */
    totalCustomers?: number | null;
}
/**
 * One customer-user import job, as a summary: enough to show a list row and a live progressbar, never the per-row report — that is fetched by tracking id from the progress endpoint.
 */
export interface CustomerUserImportJobSummary extends Parsable {
    /**
     * Rows that matched an existing identity. Null until the import finishes.
     */
    alreadyExisted?: number | null;
    /**
     * Rows that created a new sign-in identity. Null until the import finishes.
     */
    created?: number | null;
    /**
     * When the job and its stored report are deleted (UTC). After this moment the tracking idanswers 404 and the job leaves this list.
     */
    expiresAt?: Date | null;
    /**
     * Rows that failed. Null until the import finishes.
     */
    failed?: number | null;
    /**
     * Whether the job has finished executing (successfully or not).
     */
    isComplete?: boolean | null;
    /**
     * Rows processed so far — equal to TotalRows once the import finishes.
     */
    processedRows?: number | null;
    /**
     * When the import was queued (UTC).
     */
    queuedAt?: Date | null;
    /**
     * True when the full per-row report can still be fetched from the progress endpoint. Acomplete job without an available report ended without producing one (for example, itwas cancelled).
     */
    reportAvailable?: boolean | null;
    /**
     * Human-readable description of where the import currently stands.
     */
    statusText?: string | null;
    /**
     * Rows in the whole import.
     */
    totalRows?: number | null;
    /**
     * The job's tracking id — the key for the progress endpoint.
     */
    trackingId?: string | null;
}
/**
 * A customer's standing with one of the agency's vendors: the price level they buy at, theirterms, their account number at the manufacturer, the saved payment method for this vendor andnotes. One per customer per vendor.
 */
export interface CustomerVendorAccountDto extends Parsable {
    /**
     * False once the account has been removed; removed accounts are left out of listings.
     */
    active?: boolean | null;
    /**
     * When the account was first set.
     */
    createdAt?: Date | null;
    /**
     * The customer's identifier.
     */
    customerId?: string | null;
    /**
     * The customer's number, when the account was read through the customer's own routes; null on a vendor's account list.
     */
    customerNumber?: string | null;
    /**
     * The account's identifier.
     */
    customerVendorAccountId?: string | null;
    /**
     * Free text, up to 4000 characters.
     */
    notes?: string | null;
    /**
     * The agency organization.
     */
    organizationId?: string | null;
    /**
     * The saved payment method for this vendor; null reads as "No payment method on file".
     */
    paymentMethodId?: string | null;
    /**
     * The price level the customer buys at, one of the vendor's price levels; null when none is set.
     */
    priceLevelId?: string | null;
    /**
     * The customer's terms with the vendor, one of the vendor's terms options; null reads as "Terms needed".
     */
    terms?: string | null;
    /**
     * When the account last changed.
     */
    updatedAt?: Date | null;
    /**
     * The customer's account number at the manufacturer.
     */
    vendorAccountNumber?: string | null;
    /**
     * The vendor's code, e.g. "HAL".
     */
    vendorCode?: string | null;
    /**
     * The vendor's identifier.
     */
    vendorId?: string | null;
}
/**
 * The route pair every customer–vendor account endpoint addresses: the customer by number, the vendor by code.
 */
export interface CustomerVendorAccountRequest extends AdditionalDataHolder, AgencyScopedRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface DanglingAssignmentsCleanUpJobRequest extends Parsable {
    /**
     * When true (the default) the job only reports findings; nothing is removed.
     */
    dryRun?: boolean | null;
    /**
     * Optional scope. When empty, every organization is scanned.
     */
    organizationIds?: string[] | null;
}
/**
 * Represents the response containing the status of the Dangling Image Assignments Clean-Up Job.
 */
export interface DanglingAssignmentsCleanUpJobStatusResponse extends Parsable {
    /**
     * Whether this run only reported findings without removing anything.
     */
    dryRun?: boolean | null;
    /**
     * The errorMessage property
     */
    errorMessage?: string | null;
    /**
     * The isSuccessfull property
     */
    isSuccessfull?: boolean | null;
    /**
     * Per-organization findings; only organizations with at least one dangling assignment appear.
     */
    organizations?: DanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments[] | null;
    /**
     * Gets or sets the total number of dangling image assignments found (dry run) or removed.
     */
    totalDanglingAssignments?: number | null;
    /**
     * Gets or sets the total number of organizations processed during the job.
     */
    totalOrganizations?: number | null;
    /**
     * Gets or sets the total number of products carrying at least one dangling assignment.
     */
    totalProductsAffected?: number | null;
}
/**
 * The dangling assignments found for one organization.
 */
export interface DanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments extends Parsable {
    /**
     * How many product-image assignments point at an image that no longer exists.
     */
    danglingAssignments?: number | null;
    /**
     * The distinct image ids that no longer resolve to an image document.
     */
    danglingImageIds?: string[] | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * How many products carry at least one dangling assignment.
     */
    productsAffected?: number | null;
}
export interface DataExport extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The exportEntityType property
     */
    exportEntityType?: ExportEntity | null;
    /**
     * The exportFileType property
     */
    exportFileType?: ExportTypes | null;
    /**
     * The formatKey property
     */
    formatKey?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The recordCount property
     */
    recordCount?: number | null;
    /**
     * The referenceIdentifiers property
     */
    referenceIdentifiers?: string[] | null;
    /**
     * The status property
     */
    status?: string | null;
}
export interface DataExportResult extends Parsable {
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The exportEntityType property
     */
    exportEntityType?: ExportEntity | null;
    /**
     * The exportType property
     */
    exportType?: ExportTypes | null;
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The formatKey property
     */
    formatKey?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The recordsInFile property
     */
    recordsInFile?: number | null;
}
export interface DataMapping extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The headerMappingFields property
     */
    headerMappingFields?: HeaderColumnMap[] | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The invertActiveProperty property
     */
    invertActiveProperty?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
}
export interface DeactivateCommissionPlanRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface DeactivateSalesRepRequest extends Parsable {
    /**
     * OrganizationSalesRepId 
     */
    organizationSalesRepId?: string | null;
}
export interface DeactivateVendorRequest extends AdditionalDataHolder, AgencyScopedRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface DeclineAccessRequestRequest extends Parsable {
    /**
     * The declineReason property
     */
    declineReason?: string | null;
}
export interface DeclineAccessRequestResponse extends Parsable {
    /**
     * The accessRequestId property
     */
    accessRequestId?: string | null;
    /**
     * The status property
     */
    status?: string | null;
}
export interface DeleteAdminUserRequest extends Parsable {
    /**
     * The identity provider user ID of the admin to remove
     */
    userId?: string | null;
}
export interface DeleteAdminUserResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface DeleteCommissionPlanRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface DeleteCommissionStatementRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface DeleteCustomerAttributeRequest extends Parsable {
    /**
     * The attribute property
     */
    attribute?: string | null;
}
export interface DeleteCustomerNoteRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface DeleteCustomerVendorAccountRequest extends AdditionalDataHolder, CustomerVendorAccountRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface DeleteEmptyCategoriesResponse extends Parsable {
    /**
     * The category paths that were removed, ordered by path. Empty when the organization had noempty categories — that is a successful no-op, not an error.
     */
    removed?: string[] | null;
}
export interface DeleteFulfillmentMethodRequest extends Parsable {
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
}
export interface DeleteIntegrationResponse extends Parsable {
    /**
     * When the integration was deleted
     */
    deletedAt?: Date | null;
    /**
     * The display name that was deleted (for confirmation)
     */
    displayName?: string | null;
    /**
     * The unique identifier of the deleted integration
     */
    integrationId?: string | null;
    /**
     * Descriptive message about the deletion result
     */
    message?: string | null;
    /**
     * The organization identifier
     */
    organizationId?: string | null;
    /**
     * The provider that was deleted (for confirmation)
     */
    provider?: string | null;
    /**
     * Whether the deletion was successful
     */
    success?: boolean | null;
}
export interface DeleteInvoiceRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface DeleteListRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface DeleteManyImagesRequest extends Parsable {
    /**
     * The ids property
     */
    ids?: string | null;
}
export interface DeleteMarketCodeRequest extends Parsable {
    /**
     * The marketCode property
     */
    marketCode?: string | null;
}
export interface DeleteOrderStatusRequest extends Parsable {
    /**
     * The orderStatus property
     */
    orderStatus?: string | null;
}
export interface DeleteOrderTypeRequest extends Parsable {
    /**
     * The orderType property
     */
    orderType?: string | null;
}
export interface DeletePriceTierRequest extends Parsable {
    /**
     * The name property
     */
    name?: string | null;
}
export interface DeleteProductAttributeRequest extends Parsable {
    /**
     * The attribute property
     */
    attribute?: string | null;
}
export interface DeleteSalesRepRequest extends Parsable {
    /**
     * OrganizationSalesRepId 
     */
    organizationSalesRepId?: string | null;
}
export interface DeleteSalesRepResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface DeleteTaskRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface DeleteTermRequest extends Parsable {
    /**
     * The payment term to remove, matched case-insensitively against the terms on file.
     */
    term?: string | null;
}
export interface DeliveryStatus extends Parsable {
    /**
     * Recipients whose email bounced.
     */
    emailsBounced?: number | null;
    /**
     * Recipients who clicked a link in the email at least once.
     */
    emailsClicked?: number | null;
    /**
     * Recipients who marked the email as spam.
     */
    emailsComplained?: number | null;
    /**
     * Recipients whose email the provider reported delivered. Updated by the delivery webhook, after the send.
     */
    emailsDelivered?: number | null;
    /**
     * The emailsFailed property
     */
    emailsFailed?: number | null;
    /**
     * Recipients who opened the email at least once.
     */
    emailsOpened?: number | null;
    /**
     * The emailsSent property
     */
    emailsSent?: number | null;
    /**
     * The errors property
     */
    errors?: string[] | null;
    /**
     * The smsFailed property
     */
    smsFailed?: number | null;
    /**
     * The smsSent property
     */
    smsSent?: number | null;
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAbandonedImageAssetsJobRequest(abandonedImageAssetsJobRequest: Partial<AbandonedImageAssetsJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { abandonedImageAssetsJobRequest.dryRun = n.getBooleanValue(); },
        "organizationIds": n => { abandonedImageAssetsJobRequest.organizationIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAbandonedImageAssetsJobStatusResponse(abandonedImageAssetsJobStatusResponse: Partial<AbandonedImageAssetsJobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { abandonedImageAssetsJobStatusResponse.dryRun = n.getBooleanValue(); },
        "errorMessage": n => { abandonedImageAssetsJobStatusResponse.errorMessage = n.getStringValue(); },
        "isSuccessfull": n => { abandonedImageAssetsJobStatusResponse.isSuccessfull = n.getBooleanValue(); },
        "organizations": n => { abandonedImageAssetsJobStatusResponse.organizations = n.getCollectionOfObjectValues<AbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages>(createAbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImagesFromDiscriminatorValue); },
        "totalAbandoned": n => { abandonedImageAssetsJobStatusResponse.totalAbandoned = n.getNumberValue(); },
        "totalDeleted": n => { abandonedImageAssetsJobStatusResponse.totalDeleted = n.getNumberValue(); },
        "totalOrganizations": n => { abandonedImageAssetsJobStatusResponse.totalOrganizations = n.getNumberValue(); },
        "totalStoredAssets": n => { abandonedImageAssetsJobStatusResponse.totalStoredAssets = n.getNumberValue(); },
        "totalTracked": n => { abandonedImageAssetsJobStatusResponse.totalTracked = n.getNumberValue(); },
        "unclassifiedAssets": n => { abandonedImageAssetsJobStatusResponse.unclassifiedAssets = n.getNumberValue(); },
        "unclassifiedSampleIds": n => { abandonedImageAssetsJobStatusResponse.unclassifiedSampleIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages(abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages: Partial<AbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "abandonedAssets": n => { abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.abandonedAssets = n.getNumberValue(); },
        "abandonedImageIds": n => { abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.abandonedImageIds = n.getCollectionOfPrimitiveValues<string>(); },
        "deletedAssets": n => { abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.deletedAssets = n.getNumberValue(); },
        "organizationId": n => { abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.organizationId = n.getStringValue(); },
        "trackedAssets": n => { abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.trackedAssets = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccessRequest(accessRequest: Partial<AccessRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(accessRequest),
        "accessRequestId": n => { accessRequest.accessRequestId = n.getStringValue(); },
        "address1": n => { accessRequest.address1 = n.getStringValue(); },
        "address2": n => { accessRequest.address2 = n.getStringValue(); },
        "city": n => { accessRequest.city = n.getStringValue(); },
        "companyEmail": n => { accessRequest.companyEmail = n.getStringValue(); },
        "companyName": n => { accessRequest.companyName = n.getStringValue(); },
        "country": n => { accessRequest.country = n.getStringValue(); },
        "customerNumber": n => { accessRequest.customerNumber = n.getStringValue(); },
        "emailAddress": n => { accessRequest.emailAddress = n.getStringValue(); },
        "firstName": n => { accessRequest.firstName = n.getStringValue(); },
        "lastName": n => { accessRequest.lastName = n.getStringValue(); },
        "organizationId": n => { accessRequest.organizationId = n.getStringValue(); },
        "phoneNumber": n => { accessRequest.phoneNumber = n.getStringValue(); },
        "postalCode": n => { accessRequest.postalCode = n.getStringValue(); },
        "research": n => { accessRequest.research = n.getObjectValue<AccessRequestResearch>(createAccessRequestResearchFromDiscriminatorValue); },
        "stateProvince": n => { accessRequest.stateProvince = n.getStringValue(); },
        "status": n => { accessRequest.status = n.getEnumValue<AccessRequestStatus>(AccessRequestStatusObject); },
        "statusChangedOn": n => { accessRequest.statusChangedOn = n.getDateValue(); },
        "taxIdEIN": n => { accessRequest.taxIdEIN = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccessRequestResearch(accessRequestResearch: Partial<AccessRequestResearch> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "content": n => { accessRequestResearch.content = n.getStringValue(); },
        "eligibilityScore": n => { accessRequestResearch.eligibilityScore = n.getNumberValue(); },
        "generatedAt": n => { accessRequestResearch.generatedAt = n.getDateValue(); },
        "generatedBy": n => { accessRequestResearch.generatedBy = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccessRequestResearchSettings(accessRequestResearchSettings: Partial<AccessRequestResearchSettings> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "approvalCriteria": n => { accessRequestResearchSettings.approvalCriteria = n.getStringValue(); },
        "industryDescription": n => { accessRequestResearchSettings.industryDescription = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccessRequestsPageSummary(accessRequestsPageSummary: Partial<AccessRequestsPageSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "approvedLast30Days": n => { accessRequestsPageSummary.approvedLast30Days = n.getNumberValue(); },
        "approvedPrior30Days": n => { accessRequestsPageSummary.approvedPrior30Days = n.getNumberValue(); },
        "asOf": n => { accessRequestsPageSummary.asOf = n.getDateValue(); },
        "averageResponseDays": n => { accessRequestsPageSummary.averageResponseDays = n.getNumberValue(); },
        "firstOrderRate": n => { accessRequestsPageSummary.firstOrderRate = n.getNumberValue(); },
        "firstOrderRatePrior": n => { accessRequestsPageSummary.firstOrderRatePrior = n.getNumberValue(); },
        "oldestPendingDays": n => { accessRequestsPageSummary.oldestPendingDays = n.getNumberValue(); },
        "pending": n => { accessRequestsPageSummary.pending = n.getNumberValue(); },
        "responseGoalDays": n => { accessRequestsPageSummary.responseGoalDays = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountSetup(accountSetup: Partial<AccountSetup> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isComplete": n => { accountSetup.isComplete = n.getBooleanValue(); },
        "nextStep": n => { accountSetup.nextStep = n.getObjectValue<Step>(createStepFromDiscriminatorValue); },
        "percentageComplete": n => { accountSetup.percentageComplete = n.getNumberValue(); },
        "steps": n => { accountSetup.steps = n.getCollectionOfObjectValues<Step>(createStepFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoActivateCommissionPlanRequest(activateCommissionPlanRequest: Partial<ActivateCommissionPlanRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { activateCommissionPlanRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { activateCommissionPlanRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoActivateSalesRepRequest(activateSalesRepRequest: Partial<ActivateSalesRepRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "organizationSalesRepId": n => { activateSalesRepRequest.organizationSalesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoActiveCustomersKpi(activeCustomersKpi: Partial<ActiveCustomersKpi> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "activeCustomerCount": n => { activeCustomersKpi.activeCustomerCount = n.getNumberValue(); },
        "endDate": n => { activeCustomersKpi.endDate = n.getDateValue(); },
        "organizationId": n => { activeCustomersKpi.organizationId = n.getStringValue(); },
        "startDate": n => { activeCustomersKpi.startDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddAdminUserRequest(addAdminUserRequest: Partial<AddAdminUserRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { addAdminUserRequest.email = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddAdminUserResponse(addAdminUserResponse: Partial<AddAdminUserResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { addAdminUserResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddCustomerAttributeRequest(addCustomerAttributeRequest: Partial<AddCustomerAttributeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "attribute": n => { addCustomerAttributeRequest.attribute = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddFulfillmentMethodRequest(addFulfillmentMethodRequest: Partial<AddFulfillmentMethodRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fulfillmentMethod": n => { addFulfillmentMethodRequest.fulfillmentMethod = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddItemRequest(addItemRequest: Partial<AddItemRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "newLine": n => { addItemRequest.newLine = n.getBooleanValue(); },
        "quantity": n => { addItemRequest.quantity = n.getNumberValue(); },
        "sku": n => { addItemRequest.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddItemToListRequest(addItemToListRequest: Partial<AddItemToListRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { addItemToListRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "productName": n => { addItemToListRequest.productName = n.getStringValue(); },
        "quantity": n => { addItemToListRequest.quantity = n.getNumberValue(); },
        "sku": n => { addItemToListRequest.sku = n.getStringValue(); },
        "source": n => { addItemToListRequest.source = n.getStringValue(); },
        "useOrganizationId": n => { addItemToListRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddMarketCodeRequest(addMarketCodeRequest: Partial<AddMarketCodeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "marketCode": n => { addMarketCodeRequest.marketCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddOrderStatusRequest(addOrderStatusRequest: Partial<AddOrderStatusRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderStatus": n => { addOrderStatusRequest.orderStatus = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddOrderTypeRequest(addOrderTypeRequest: Partial<AddOrderTypeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "kind": n => { addOrderTypeRequest.kind = n.getEnumValue<OrderKind>(OrderKindObject); },
        "orderType": n => { addOrderTypeRequest.orderType = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddPriceTierRequest(addPriceTierRequest: Partial<AddPriceTierRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyCode": n => { addPriceTierRequest.currencyCode = n.getStringValue(); },
        "name": n => { addPriceTierRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddProductAttributeRequest(addProductAttributeRequest: Partial<AddProductAttributeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "attribute": n => { addProductAttributeRequest.attribute = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddress(address: Partial<Address> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { address.address1 = n.getStringValue(); },
        "address2": n => { address.address2 = n.getStringValue(); },
        "addressType": n => { address.addressType = n.getEnumValue<AddressType>(AddressTypeObject); },
        "city": n => { address.city = n.getStringValue(); },
        "code": n => { address.code = n.getStringValue(); },
        "country": n => { address.country = n.getStringValue(); },
        "default": n => { address.defaultEscaped = n.getBooleanValue(); },
        "externalId": n => { address.externalId = n.getStringValue(); },
        "latitude": n => { address.latitude = n.getNumberValue(); },
        "longitude": n => { address.longitude = n.getNumberValue(); },
        "stateProvince": n => { address.stateProvince = n.getStringValue(); },
        "zipPostalCode": n => { address.zipPostalCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddressComponent(addressComponent: Partial<AddressComponent> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "long_name": n => { addressComponent.longName = n.getStringValue(); },
        "short_name": n => { addressComponent.shortName = n.getStringValue(); },
        "types": n => { addressComponent.types = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddressDto(addressDto: Partial<AddressDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { addressDto.address1 = n.getStringValue(); },
        "address2": n => { addressDto.address2 = n.getStringValue(); },
        "city": n => { addressDto.city = n.getStringValue(); },
        "country": n => { addressDto.country = n.getStringValue(); },
        "stateProvince": n => { addressDto.stateProvince = n.getStringValue(); },
        "zipPostalCode": n => { addressDto.zipPostalCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddressInput(addressInput: Partial<AddressInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { addressInput.address1 = n.getStringValue(); },
        "address2": n => { addressInput.address2 = n.getStringValue(); },
        "addressType": n => { addressInput.addressType = n.getStringValue(); },
        "city": n => { addressInput.city = n.getStringValue(); },
        "code": n => { addressInput.code = n.getStringValue(); },
        "country": n => { addressInput.country = n.getStringValue(); },
        "default": n => { addressInput.defaultEscaped = n.getBooleanValue(); },
        "externalId": n => { addressInput.externalId = n.getStringValue(); },
        "latitude": n => { addressInput.latitude = n.getNumberValue(); },
        "longitude": n => { addressInput.longitude = n.getNumberValue(); },
        "stateProvince": n => { addressInput.stateProvince = n.getStringValue(); },
        "zipPostalCode": n => { addressInput.zipPostalCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddSubscriptionItemRequest(addSubscriptionItemRequest: Partial<AddSubscriptionItemRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "lookupKey": n => { addSubscriptionItemRequest.lookupKey = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddSubscriptionItemResponse(addSubscriptionItemResponse: Partial<AddSubscriptionItemResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "entitlements": n => { addSubscriptionItemResponse.entitlements = n.getCollectionOfPrimitiveValues<string>(); },
        "subscriptionId": n => { addSubscriptionItemResponse.subscriptionId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddTermRequest(addTermRequest: Partial<AddTermRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "term": n => { addTermRequest.term = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAgencyScopedRequest(agencyScopedRequest: Partial<AgencyScopedRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { agencyScopedRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAiUsageBreakdownItem(aiUsageBreakdownItem: Partial<AiUsageBreakdownItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "callCount": n => { aiUsageBreakdownItem.callCount = n.getNumberValue(); },
        "costUsd": n => { aiUsageBreakdownItem.costUsd = n.getNumberValue(); },
        "model": n => { aiUsageBreakdownItem.model = n.getStringValue(); },
        "operation": n => { aiUsageBreakdownItem.operation = n.getStringValue(); },
        "tokens": n => { aiUsageBreakdownItem.tokens = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoApiAuthenticationRequest(apiAuthenticationRequest: Partial<ApiAuthenticationRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "clientId": n => { apiAuthenticationRequest.clientId = n.getStringValue() ?? "sdaf43tfsdg45dg"; },
        "clientSecret": n => { apiAuthenticationRequest.clientSecret = n.getStringValue() ?? "QsFdas%4F1asr23tgb675%3"; },
        "orgCode": n => { apiAuthenticationRequest.orgCode = n.getStringValue() ?? "org_12345"; },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoApiAuthenticationResponse(apiAuthenticationResponse: Partial<ApiAuthenticationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessToken": n => { apiAuthenticationResponse.accessToken = n.getStringValue(); },
        "expiresIn": n => { apiAuthenticationResponse.expiresIn = n.getNumberValue(); },
        "tokenType": n => { apiAuthenticationResponse.tokenType = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoApiKey(apiKey: Partial<ApiKey> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessScope": n => { apiKey.accessScope = n.getStringValue(); },
        "key": n => { apiKey.key = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAppliedPromotion(appliedPromotion: Partial<AppliedPromotion> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { appliedPromotion.amount = n.getNumberValue(); },
        "appliedVia": n => { appliedPromotion.appliedVia = n.getStringValue(); },
        "automatic": n => { appliedPromotion.automatic = n.getBooleanValue(); },
        "campaignId": n => { appliedPromotion.campaignId = n.getStringValue(); },
        "campaignName": n => { appliedPromotion.campaignName = n.getStringValue(); },
        "code": n => { appliedPromotion.code = n.getStringValue(); },
        "kind": n => { appliedPromotion.kind = n.getEnumValue<BenefitKind>(BenefitKindObject); },
        "promotionId": n => { appliedPromotion.promotionId = n.getStringValue(); },
        "promotionName": n => { appliedPromotion.promotionName = n.getStringValue(); },
        "tierThreshold": n => { appliedPromotion.tierThreshold = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoApplyCartCodeRequest(applyCartCodeRequest: Partial<ApplyCartCodeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { applyCartCodeRequest.code = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoApplyDiscountRequest(applyDiscountRequest: Partial<ApplyDiscountRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "discount": n => { applyDiscountRequest.discount = n.getObjectValue<DiscountInput>(createDiscountInputFromDiscriminatorValue); },
        "orgCodes": n => { applyDiscountRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { applyDiscountRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoApproveAccessRequestRequest(approveAccessRequestRequest: Partial<ApproveAccessRequestRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createCustomer": n => { approveAccessRequestRequest.createCustomer = n.getBooleanValue(); },
        "customerNumber": n => { approveAccessRequestRequest.customerNumber = n.getStringValue(); },
        "priceTier": n => { approveAccessRequestRequest.priceTier = n.getStringValue(); },
        "terms": n => { approveAccessRequestRequest.terms = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoApproveAccessRequestResponse(approveAccessRequestResponse: Partial<ApproveAccessRequestResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessRequestId": n => { approveAccessRequestResponse.accessRequestId = n.getStringValue(); },
        "alreadyHadAccess": n => { approveAccessRequestResponse.alreadyHadAccess = n.getBooleanValue(); },
        "customerNumber": n => { approveAccessRequestResponse.customerNumber = n.getStringValue(); },
        "emailSent": n => { approveAccessRequestResponse.emailSent = n.getBooleanValue(); },
        "identityProviderUserId": n => { approveAccessRequestResponse.identityProviderUserId = n.getStringValue(); },
        "userId": n => { approveAccessRequestResponse.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoApproveCommissionStatementRequest(approveCommissionStatementRequest: Partial<ApproveCommissionStatementRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { approveCommissionStatementRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { approveCommissionStatementRequest.useOrganizationId = n.getStringValue(); },
        "user": n => { approveCommissionStatementRequest.user = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAssignProductFamilyVariantsRequest(assignProductFamilyVariantsRequest: Partial<AssignProductFamilyVariantsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "variants": n => { assignProductFamilyVariantsRequest.variants = n.getCollectionOfObjectValues<AssignProductFamilyVariantsRequest_VariantAssignment>(createAssignProductFamilyVariantsRequest_VariantAssignmentFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAssignProductFamilyVariantsRequest_VariantAssignment(assignProductFamilyVariantsRequest_VariantAssignment: Partial<AssignProductFamilyVariantsRequest_VariantAssignment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "optionValues": n => { assignProductFamilyVariantsRequest_VariantAssignment.optionValues = n.getObjectValue<AssignProductFamilyVariantsRequest_VariantAssignment_optionValues>(createAssignProductFamilyVariantsRequest_VariantAssignment_optionValuesFromDiscriminatorValue); },
        "sku": n => { assignProductFamilyVariantsRequest_VariantAssignment.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAssignProductFamilyVariantsRequest_VariantAssignment_optionValues(assignProductFamilyVariantsRequest_VariantAssignment_optionValues: Partial<AssignProductFamilyVariantsRequest_VariantAssignment_optionValues> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAssignProductFamilyVariantsResponse(assignProductFamilyVariantsResponse: Partial<AssignProductFamilyVariantsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "family": n => { assignProductFamilyVariantsResponse.family = n.getObjectValue<ProductFamily>(createProductFamilyFromDiscriminatorValue); },
        "missingSkus": n => { assignProductFamilyVariantsResponse.missingSkus = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAssociateCustomerRequest(associateCustomerRequest: Partial<AssociateCustomerRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { associateCustomerRequest.customerNumber = n.getStringValue(); },
        "userId": n => { associateCustomerRequest.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAssociateCustomerResponse(associateCustomerResponse: Partial<AssociateCustomerResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "association": n => { associateCustomerResponse.association = n.getObjectValue<UserCustomer>(createUserCustomerFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAvailableExportFormatDto(availableExportFormatDto: Partial<AvailableExportFormatDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { availableExportFormatDto.displayName = n.getStringValue(); },
        "key": n => { availableExportFormatDto.key = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAverageOrderValueKpi(averageOrderValueKpi: Partial<AverageOrderValueKpi> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "averageOrderValue": n => { averageOrderValueKpi.averageOrderValue = n.getNumberValue(); },
        "endDate": n => { averageOrderValueKpi.endDate = n.getDateValue(); },
        "organizationId": n => { averageOrderValueKpi.organizationId = n.getStringValue(); },
        "startDate": n => { averageOrderValueKpi.startDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillCartShareEventsRequest(backfillCartShareEventsRequest: Partial<BackfillCartShareEventsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { backfillCartShareEventsRequest.dryRun = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillCartShareEventsResponse(backfillCartShareEventsResponse: Partial<BackfillCartShareEventsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alreadyRecorded": n => { backfillCartShareEventsResponse.alreadyRecorded = n.getNumberValue(); },
        "dryRun": n => { backfillCartShareEventsResponse.dryRun = n.getBooleanValue(); },
        "failed": n => { backfillCartShareEventsResponse.failed = n.getCollectionOfPrimitiveValues<string>(); },
        "noCart": n => { backfillCartShareEventsResponse.noCart = n.getNumberValue(); },
        "notSent": n => { backfillCartShareEventsResponse.notSent = n.getNumberValue(); },
        "organizationId": n => { backfillCartShareEventsResponse.organizationId = n.getStringValue(); },
        "recorded": n => { backfillCartShareEventsResponse.recorded = n.getNumberValue(); },
        "sharesExamined": n => { backfillCartShareEventsResponse.sharesExamined = n.getNumberValue(); },
        "success": n => { backfillCartShareEventsResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillOrderSalesRepsRequest(backfillOrderSalesRepsRequest: Partial<BackfillOrderSalesRepsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { backfillOrderSalesRepsRequest.dryRun = n.getBooleanValue(); },
        "normalizeMissingReps": n => { backfillOrderSalesRepsRequest.normalizeMissingReps = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillOrderSalesRepsResponse(backfillOrderSalesRepsResponse: Partial<BackfillOrderSalesRepsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { backfillOrderSalesRepsResponse.dryRun = n.getBooleanValue(); },
        "failed": n => { backfillOrderSalesRepsResponse.failed = n.getCollectionOfPrimitiveValues<string>(); },
        "ordersExamined": n => { backfillOrderSalesRepsResponse.ordersExamined = n.getNumberValue(); },
        "ordersHealed": n => { backfillOrderSalesRepsResponse.ordersHealed = n.getNumberValue(); },
        "ordersSetNotAssigned": n => { backfillOrderSalesRepsResponse.ordersSetNotAssigned = n.getNumberValue(); },
        "ordersUnchanged": n => { backfillOrderSalesRepsResponse.ordersUnchanged = n.getNumberValue(); },
        "organizationId": n => { backfillOrderSalesRepsResponse.organizationId = n.getStringValue(); },
        "success": n => { backfillOrderSalesRepsResponse.success = n.getBooleanValue(); },
        "unresolvableRepNumbers": n => { backfillOrderSalesRepsResponse.unresolvableRepNumbers = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillSubscriptionsResponse(backfillSubscriptionsResponse: Partial<BackfillSubscriptionsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "activeReps": n => { backfillSubscriptionsResponse.activeReps = n.getNumberValue(); },
        "seats": n => { backfillSubscriptionsResponse.seats = n.getNumberValue(); },
        "subscriptionsFound": n => { backfillSubscriptionsResponse.subscriptionsFound = n.getNumberValue(); },
        "subscriptionsRecorded": n => { backfillSubscriptionsResponse.subscriptionsRecorded = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillUserChannelsResponse(backfillUserChannelsResponse: Partial<BackfillUserChannelsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "channelsGranted": n => { backfillUserChannelsResponse.channelsGranted = n.getNumberValue(); },
        "failed": n => { backfillUserChannelsResponse.failed = n.getCollectionOfPrimitiveValues<string>(); },
        "organizationId": n => { backfillUserChannelsResponse.organizationId = n.getStringValue(); },
        "repsExamined": n => { backfillUserChannelsResponse.repsExamined = n.getNumberValue(); },
        "skippedBlankIdentity": n => { backfillUserChannelsResponse.skippedBlankIdentity = n.getNumberValue(); },
        "success": n => { backfillUserChannelsResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBaseEntity(baseEntity: Partial<BaseEntity> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { baseEntity.active = n.getBooleanValue(); },
        "createdAt": n => { baseEntity.createdAt = n.getDateValue(); },
        "updatedAt": n => { baseEntity.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBenefit(benefit: Partial<Benefit> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "discountType": n => { benefit.discountType = n.getEnumValue<DiscountType>(DiscountTypeObject); },
        "kind": n => { benefit.kind = n.getEnumValue<BenefitKind>(BenefitKindObject); },
        "quantity": n => { benefit.quantity = n.getNumberValue(); },
        "sku": n => { benefit.sku = n.getStringValue(); },
        "tiers": n => { benefit.tiers = n.getCollectionOfObjectValues<BenefitTier>(createBenefitTierFromDiscriminatorValue); },
        "value": n => { benefit.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBenefitInput(benefitInput: Partial<BenefitInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "discountType": n => { benefitInput.discountType = n.getEnumValue<DiscountType>(DiscountTypeObject); },
        "kind": n => { benefitInput.kind = n.getEnumValue<BenefitKind>(BenefitKindObject); },
        "quantity": n => { benefitInput.quantity = n.getNumberValue(); },
        "sku": n => { benefitInput.sku = n.getStringValue(); },
        "tiers": n => { benefitInput.tiers = n.getCollectionOfObjectValues<BenefitTierInput>(createBenefitTierInputFromDiscriminatorValue); },
        "value": n => { benefitInput.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBenefitTier(benefitTier: Partial<BenefitTier> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "threshold": n => { benefitTier.threshold = n.getNumberValue(); },
        "value": n => { benefitTier.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBenefitTierInput(benefitTierInput: Partial<BenefitTierInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "threshold": n => { benefitTierInput.threshold = n.getNumberValue(); },
        "value": n => { benefitTierInput.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBillingAddress(billingAddress: Partial<BillingAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { billingAddress.address1 = n.getStringValue(); },
        "address2": n => { billingAddress.address2 = n.getStringValue(); },
        "city": n => { billingAddress.city = n.getStringValue(); },
        "company": n => { billingAddress.company = n.getStringValue(); },
        "country": n => { billingAddress.country = n.getStringValue(); },
        "firstName": n => { billingAddress.firstName = n.getStringValue(); },
        "lastName": n => { billingAddress.lastName = n.getStringValue(); },
        "state": n => { billingAddress.state = n.getStringValue(); },
        "zipCode": n => { billingAddress.zipCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBillingInvoice(billingInvoice: Partial<BillingInvoice> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amountDue": n => { billingInvoice.amountDue = n.getNumberValue(); },
        "amountPaid": n => { billingInvoice.amountPaid = n.getNumberValue(); },
        "currencyCode": n => { billingInvoice.currencyCode = n.getStringValue(); },
        "date": n => { billingInvoice.date = n.getDateValue(); },
        "dueDate": n => { billingInvoice.dueDate = n.getDateValue(); },
        "id": n => { billingInvoice.id = n.getStringValue(); },
        "status": n => { billingInvoice.status = n.getStringValue(); },
        "total": n => { billingInvoice.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBillingInvoicePdfResponse(billingInvoicePdfResponse: Partial<BillingInvoicePdfResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "url": n => { billingInvoicePdfResponse.url = n.getStringValue(); },
        "validUntil": n => { billingInvoicePdfResponse.validUntil = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBillingInvoicesResponse(billingInvoicesResponse: Partial<BillingInvoicesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "invoices": n => { billingInvoicesResponse.invoices = n.getCollectionOfObjectValues<BillingInvoice>(createBillingInvoiceFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBulkDeleteDocumentsRequest(bulkDeleteDocumentsRequest: Partial<BulkDeleteDocumentsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "documentIds": n => { bulkDeleteDocumentsRequest.documentIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBulkImportCustomerUserResult(bulkImportCustomerUserResult: Partial<BulkImportCustomerUserResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { bulkImportCustomerUserResult.customerNumber = n.getStringValue(); },
        "email": n => { bulkImportCustomerUserResult.email = n.getStringValue(); },
        "error": n => { bulkImportCustomerUserResult.errorEscaped = n.getStringValue(); },
        "outcome": n => { bulkImportCustomerUserResult.outcome = n.getEnumValue<BulkImportCustomerUserOutcome>(BulkImportCustomerUserOutcomeObject); },
        "rowNumber": n => { bulkImportCustomerUserResult.rowNumber = n.getNumberValue(); },
        "temporaryPassword": n => { bulkImportCustomerUserResult.temporaryPassword = n.getStringValue(); },
        "userCustomerId": n => { bulkImportCustomerUserResult.userCustomerId = n.getStringValue(); },
        "userId": n => { bulkImportCustomerUserResult.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBulkImportCustomerUserRow(bulkImportCustomerUserRow: Partial<BulkImportCustomerUserRow> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { bulkImportCustomerUserRow.customerNumber = n.getStringValue(); },
        "email": n => { bulkImportCustomerUserRow.email = n.getStringValue(); },
        "firstName": n => { bulkImportCustomerUserRow.firstName = n.getStringValue(); },
        "lastName": n => { bulkImportCustomerUserRow.lastName = n.getStringValue(); },
        "phoneNumber": n => { bulkImportCustomerUserRow.phoneNumber = n.getStringValue(); },
        "temporaryPassword": n => { bulkImportCustomerUserRow.temporaryPassword = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBulkImportCustomerUsersRequest(bulkImportCustomerUsersRequest: Partial<BulkImportCustomerUsersRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "temporaryPasswordMode": n => { bulkImportCustomerUsersRequest.temporaryPasswordMode = n.getEnumValue<TemporaryPasswordMode>(TemporaryPasswordModeObject); },
        "users": n => { bulkImportCustomerUsersRequest.users = n.getCollectionOfObjectValues<BulkImportCustomerUserRow>(createBulkImportCustomerUserRowFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBulkImportCustomerUsersResponse(bulkImportCustomerUsersResponse: Partial<BulkImportCustomerUsersResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alreadyExisted": n => { bulkImportCustomerUsersResponse.alreadyExisted = n.getNumberValue(); },
        "created": n => { bulkImportCustomerUsersResponse.created = n.getNumberValue(); },
        "failed": n => { bulkImportCustomerUsersResponse.failed = n.getNumberValue(); },
        "results": n => { bulkImportCustomerUsersResponse.results = n.getCollectionOfObjectValues<BulkImportCustomerUserResult>(createBulkImportCustomerUserResultFromDiscriminatorValue); },
        "totalRows": n => { bulkImportCustomerUsersResponse.totalRows = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBulkMoveDocumentsRequest(bulkMoveDocumentsRequest: Partial<BulkMoveDocumentsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "documentIds": n => { bulkMoveDocumentsRequest.documentIds = n.getCollectionOfPrimitiveValues<string>(); },
        "targetFolderId": n => { bulkMoveDocumentsRequest.targetFolderId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBulkWriteDailyTotal(bulkWriteDailyTotal: Partial<BulkWriteDailyTotal> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "callCount": n => { bulkWriteDailyTotal.callCount = n.getNumberValue(); },
        "day": n => { bulkWriteDailyTotal.day = n.getStringValue(); },
        "documentCount": n => { bulkWriteDailyTotal.documentCount = n.getNumberValue(); },
        "endpoint": n => { bulkWriteDailyTotal.endpoint = n.getStringValue(); },
        "failedCallCount": n => { bulkWriteDailyTotal.failedCallCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBusinessCardAddress(businessCardAddress: Partial<BusinessCardAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { businessCardAddress.address1 = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "address2": n => { businessCardAddress.address2 = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "city": n => { businessCardAddress.city = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "country": n => { businessCardAddress.country = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "stateProvince": n => { businessCardAddress.stateProvince = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "zipPostalCode": n => { businessCardAddress.zipPostalCode = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBusinessCardField(businessCardField: Partial<BusinessCardField> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "confidence": n => { businessCardField.confidence = n.getNumberValue(); },
        "value": n => { businessCardField.value = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCampaign(campaign: Partial<Campaign> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(campaign),
        "activatedAt": n => { campaign.activatedAt = n.getDateValue(); },
        "campaignId": n => { campaign.campaignId = n.getStringValue(); },
        "channels": n => { campaign.channels = n.getCollectionOfPrimitiveValues<string>(); },
        "customerNumbers": n => { campaign.customerNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "description": n => { campaign.description = n.getStringValue(); },
        "marketCodes": n => { campaign.marketCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "maxRedemptions": n => { campaign.maxRedemptions = n.getNumberValue(); },
        "name": n => { campaign.name = n.getStringValue(); },
        "orderTypes": n => { campaign.orderTypes = n.getCollectionOfPrimitiveValues<string>(); },
        "organizationId": n => { campaign.organizationId = n.getStringValue(); },
        "promotions": n => { campaign.promotions = n.getCollectionOfObjectValues<Promotion>(createPromotionFromDiscriminatorValue); },
        "redemptionCount": n => { campaign.redemptionCount = n.getNumberValue(); },
        "trigger": n => { campaign.trigger = n.getEnumValue<CampaignTrigger>(CampaignTriggerObject); },
        "validFrom": n => { campaign.validFrom = n.getDateValue(); },
        "validTo": n => { campaign.validTo = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCampaignInput(campaignInput: Partial<CampaignInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "channels": n => { campaignInput.channels = n.getCollectionOfPrimitiveValues<string>(); },
        "customerNumbers": n => { campaignInput.customerNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "description": n => { campaignInput.description = n.getStringValue(); },
        "marketCodes": n => { campaignInput.marketCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "maxRedemptions": n => { campaignInput.maxRedemptions = n.getNumberValue(); },
        "name": n => { campaignInput.name = n.getStringValue(); },
        "orderTypes": n => { campaignInput.orderTypes = n.getCollectionOfPrimitiveValues<string>(); },
        "promotions": n => { campaignInput.promotions = n.getCollectionOfObjectValues<PromotionInput>(createPromotionInputFromDiscriminatorValue); },
        "trigger": n => { campaignInput.trigger = n.getEnumValue<CampaignTrigger>(CampaignTriggerObject); },
        "validFrom": n => { campaignInput.validFrom = n.getDateValue(); },
        "validTo": n => { campaignInput.validTo = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCancelInvoiceRequest(cancelInvoiceRequest: Partial<CancelInvoiceRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { cancelInvoiceRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { cancelInvoiceRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartActor(cartActor: Partial<CartActor> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { cartActor.displayName = n.getStringValue(); },
        "id": n => { cartActor.id = n.getStringValue(); },
        "syncUser": n => { cartActor.syncUser = n.getStringValue(); },
        "type": n => { cartActor.type = n.getEnumValue<CartActorType>(CartActorTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartEvent(cartEvent: Partial<CartEvent> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "action": n => { cartEvent.action = n.getEnumValue<CartEventAction>(CartEventActionObject); },
        "actor": n => { cartEvent.actor = n.getObjectValue<CartActor>(createCartActorFromDiscriminatorValue); },
        "after": n => { cartEvent.after = n.getStringValue(); },
        "before": n => { cartEvent.before = n.getStringValue(); },
        "cartEventId": n => { cartEvent.cartEventId = n.getStringValue(); },
        "cartId": n => { cartEvent.cartId = n.getStringValue(); },
        "note": n => { cartEvent.note = n.getStringValue(); },
        "occurredAt": n => { cartEvent.occurredAt = n.getDateValue(); },
        "organizationId": n => { cartEvent.organizationId = n.getStringValue(); },
        "recordedAt": n => { cartEvent.recordedAt = n.getDateValue(); },
        "sku": n => { cartEvent.sku = n.getStringValue(); },
        "surface": n => { cartEvent.surface = n.getStringValue(); },
        "vendorCode": n => { cartEvent.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartItem(cartItem: Partial<CartItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(cartItem),
        "categoryPaths": n => { cartItem.categoryPaths = n.getCollectionOfPrimitiveValues<string>(); },
        "discount": n => { cartItem.discount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "discountAmount": n => { cartItem.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { cartItem.discountAmountFormatted = n.getStringValue(); },
        "gift": n => { cartItem.gift = n.getObjectValue<GiftMarker>(createGiftMarkerFromDiscriminatorValue); },
        "imageName": n => { cartItem.imageName = n.getStringValue(); },
        "lineId": n => { cartItem.lineId = n.getStringValue(); },
        "minimumOrderQuantity": n => { cartItem.minimumOrderQuantity = n.getNumberValue(); },
        "note": n => { cartItem.note = n.getStringValue(); },
        "price": n => { cartItem.price = n.getNumberValue(); },
        "priceFormatted": n => { cartItem.priceFormatted = n.getStringValue(); },
        "priceOverride": n => { cartItem.priceOverride = n.getObjectValue<PriceOverride>(createPriceOverrideFromDiscriminatorValue); },
        "productName": n => { cartItem.productName = n.getStringValue(); },
        "quantity": n => { cartItem.quantity = n.getNumberValue(); },
        "quantityIncrement": n => { cartItem.quantityIncrement = n.getNumberValue(); },
        "sku": n => { cartItem.sku = n.getStringValue(); },
        "subTotal": n => { cartItem.subTotal = n.getNumberValue(); },
        "subTotalFormatted": n => { cartItem.subTotalFormatted = n.getStringValue(); },
        "taxCategory": n => { cartItem.taxCategory = n.getStringValue(); },
        "vendorCode": n => { cartItem.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartLine(cartLine: Partial<CartLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cancelDate": n => { cartLine.cancelDate = n.getDateOnlyValue(); },
        "discountAmount": n => { cartLine.discountAmount = n.getNumberValue(); },
        "discountPercent": n => { cartLine.discountPercent = n.getNumberValue(); },
        "fulfillmentMethod": n => { cartLine.fulfillmentMethod = n.getStringValue(); },
        "isOpeningOrder": n => { cartLine.isOpeningOrder = n.getBooleanValue(); },
        "minimumAmount": n => { cartLine.minimumAmount = n.getNumberValue(); },
        "noteToVendor": n => { cartLine.noteToVendor = n.getStringValue(); },
        "orderType": n => { cartLine.orderType = n.getStringValue(); },
        "poNumber": n => { cartLine.poNumber = n.getStringValue(); },
        "priceLevel": n => { cartLine.priceLevel = n.getStringValue(); },
        "savedForLater": n => { cartLine.savedForLater = n.getBooleanValue(); },
        "shipDate": n => { cartLine.shipDate = n.getDateOnlyValue(); },
        "shipWindowName": n => { cartLine.shipWindowName = n.getStringValue(); },
        "status": n => { cartLine.status = n.getEnumValue<CartLineStatus>(CartLineStatusObject); },
        "subtotal": n => { cartLine.subtotal = n.getNumberValue(); },
        "terms": n => { cartLine.terms = n.getStringValue(); },
        "total": n => { cartLine.total = n.getNumberValue(); },
        "vendorCode": n => { cartLine.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartPriceChange(cartPriceChange: Partial<CartPriceChange> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "lineId": n => { cartPriceChange.lineId = n.getStringValue(); },
        "newPrice": n => { cartPriceChange.newPrice = n.getNumberValue(); },
        "oldPrice": n => { cartPriceChange.oldPrice = n.getNumberValue(); },
        "sku": n => { cartPriceChange.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartPriceRefreshSummary(cartPriceRefreshSummary: Partial<CartPriceRefreshSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "changes": n => { cartPriceRefreshSummary.changes = n.getCollectionOfObjectValues<CartPriceChange>(createCartPriceChangeFromDiscriminatorValue); },
        "priceAgeDays": n => { cartPriceRefreshSummary.priceAgeDays = n.getNumberValue(); },
        "refreshedAtUtc": n => { cartPriceRefreshSummary.refreshedAtUtc = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartPricingSettings(cartPricingSettings: Partial<CartPricingSettings> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allowDecimalQuantities": n => { cartPricingSettings.allowDecimalQuantities = n.getBooleanValue(); },
        "allowLineItemDiscounts": n => { cartPricingSettings.allowLineItemDiscounts = n.getBooleanValue(); },
        "allowOrderDiscounts": n => { cartPricingSettings.allowOrderDiscounts = n.getBooleanValue(); },
        "allowPriceOverride": n => { cartPricingSettings.allowPriceOverride = n.getBooleanValue(); },
        "refreshStalePrices": n => { cartPricingSettings.refreshStalePrices = n.getBooleanValue(); },
        "stalePriceAgeDays": n => { cartPricingSettings.stalePriceAgeDays = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartPromotionSummary(cartPromotionSummary: Partial<CartPromotionSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applied": n => { cartPromotionSummary.applied = n.getCollectionOfObjectValues<AppliedPromotion>(createAppliedPromotionFromDiscriminatorValue); },
        "appliedAmount": n => { cartPromotionSummary.appliedAmount = n.getNumberValue(); },
        "appliedCode": n => { cartPromotionSummary.appliedCode = n.getStringValue(); },
        "appliedCodeSkip": n => { cartPromotionSummary.appliedCodeSkip = n.getObjectValue<PromotionSkip>(createPromotionSkipFromDiscriminatorValue); },
        "codeCampaigns": n => { cartPromotionSummary.codeCampaigns = n.getCollectionOfObjectValues<CodeCampaignSummary>(createCodeCampaignSummaryFromDiscriminatorValue); },
        "lineCount": n => { cartPromotionSummary.lineCount = n.getNumberValue(); },
        "pending": n => { cartPromotionSummary.pending = n.getCollectionOfObjectValues<PendingPromotion>(createPendingPromotionFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartReview(cartReview: Partial<CartReview> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNote": n => { cartReview.customerNote = n.getStringValue(); },
        "repNote": n => { cartReview.repNote = n.getStringValue(); },
        "requestedAtUtc": n => { cartReview.requestedAtUtc = n.getDateValue(); },
        "returnedAtUtc": n => { cartReview.returnedAtUtc = n.getDateValue(); },
        "status": n => { cartReview.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartShareLine(cartShareLine: Partial<CartShareLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "discountAmount": n => { cartShareLine.discountAmount = n.getNumberValue(); },
        "discountDetail": n => { cartShareLine.discountDetail = n.getObjectValue<DiscountDto>(createDiscountDtoFromDiscriminatorValue); },
        "gift": n => { cartShareLine.gift = n.getObjectValue<GiftMarkerDto>(createGiftMarkerDtoFromDiscriminatorValue); },
        "lineTotal": n => { cartShareLine.lineTotal = n.getNumberValue(); },
        "note": n => { cartShareLine.note = n.getStringValue(); },
        "productName": n => { cartShareLine.productName = n.getStringValue(); },
        "quantity": n => { cartShareLine.quantity = n.getNumberValue(); },
        "sku": n => { cartShareLine.sku = n.getStringValue(); },
        "unitPrice": n => { cartShareLine.unitPrice = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartShareLineRequest(cartShareLineRequest: Partial<CartShareLineRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "discountAmount": n => { cartShareLineRequest.discountAmount = n.getNumberValue(); },
        "discountDetail": n => { cartShareLineRequest.discountDetail = n.getObjectValue<DiscountDto>(createDiscountDtoFromDiscriminatorValue); },
        "gift": n => { cartShareLineRequest.gift = n.getObjectValue<GiftMarkerDto>(createGiftMarkerDtoFromDiscriminatorValue); },
        "lineTotal": n => { cartShareLineRequest.lineTotal = n.getNumberValue(); },
        "note": n => { cartShareLineRequest.note = n.getStringValue(); },
        "productName": n => { cartShareLineRequest.productName = n.getStringValue(); },
        "quantity": n => { cartShareLineRequest.quantity = n.getNumberValue(); },
        "sku": n => { cartShareLineRequest.sku = n.getStringValue(); },
        "unitPrice": n => { cartShareLineRequest.unitPrice = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartShareSnapshot(cartShareSnapshot: Partial<CartShareSnapshot> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "appliedCode": n => { cartShareSnapshot.appliedCode = n.getStringValue(); },
        "appliedPromotions": n => { cartShareSnapshot.appliedPromotions = n.getCollectionOfObjectValues<AppliedPromotion>(createAppliedPromotionFromDiscriminatorValue); },
        "companyName": n => { cartShareSnapshot.companyName = n.getStringValue(); },
        "currencyCode": n => { cartShareSnapshot.currencyCode = n.getStringValue(); },
        "customerNumber": n => { cartShareSnapshot.customerNumber = n.getStringValue(); },
        "discount": n => { cartShareSnapshot.discount = n.getNumberValue(); },
        "discountDetail": n => { cartShareSnapshot.discountDetail = n.getObjectValue<DiscountDto>(createDiscountDtoFromDiscriminatorValue); },
        "freeShipping": n => { cartShareSnapshot.freeShipping = n.getObjectValue<FreeShippingEntitlement>(createFreeShippingEntitlementFromDiscriminatorValue); },
        "itemCount": n => { cartShareSnapshot.itemCount = n.getNumberValue(); },
        "lines": n => { cartShareSnapshot.lines = n.getCollectionOfObjectValues<CartShareLine>(createCartShareLineFromDiscriminatorValue); },
        "notes": n => { cartShareSnapshot.notes = n.getStringValue(); },
        "poNumber": n => { cartShareSnapshot.poNumber = n.getStringValue(); },
        "shipping": n => { cartShareSnapshot.shipping = n.getNumberValue(); },
        "shoppingCartId": n => { cartShareSnapshot.shoppingCartId = n.getStringValue(); },
        "subtotal": n => { cartShareSnapshot.subtotal = n.getNumberValue(); },
        "tax": n => { cartShareSnapshot.tax = n.getNumberValue(); },
        "total": n => { cartShareSnapshot.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartShareSnapshotRequest(cartShareSnapshotRequest: Partial<CartShareSnapshotRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "appliedCode": n => { cartShareSnapshotRequest.appliedCode = n.getStringValue(); },
        "appliedPromotions": n => { cartShareSnapshotRequest.appliedPromotions = n.getCollectionOfObjectValues<AppliedPromotion>(createAppliedPromotionFromDiscriminatorValue); },
        "companyName": n => { cartShareSnapshotRequest.companyName = n.getStringValue(); },
        "currencyCode": n => { cartShareSnapshotRequest.currencyCode = n.getStringValue(); },
        "customerNumber": n => { cartShareSnapshotRequest.customerNumber = n.getStringValue(); },
        "discount": n => { cartShareSnapshotRequest.discount = n.getNumberValue(); },
        "discountDetail": n => { cartShareSnapshotRequest.discountDetail = n.getObjectValue<DiscountDto>(createDiscountDtoFromDiscriminatorValue); },
        "freeShipping": n => { cartShareSnapshotRequest.freeShipping = n.getObjectValue<FreeShippingEntitlement>(createFreeShippingEntitlementFromDiscriminatorValue); },
        "lines": n => { cartShareSnapshotRequest.lines = n.getCollectionOfObjectValues<CartShareLineRequest>(createCartShareLineRequestFromDiscriminatorValue); },
        "notes": n => { cartShareSnapshotRequest.notes = n.getStringValue(); },
        "poNumber": n => { cartShareSnapshotRequest.poNumber = n.getStringValue(); },
        "shipping": n => { cartShareSnapshotRequest.shipping = n.getNumberValue(); },
        "shoppingCartId": n => { cartShareSnapshotRequest.shoppingCartId = n.getStringValue(); },
        "subtotal": n => { cartShareSnapshotRequest.subtotal = n.getNumberValue(); },
        "tax": n => { cartShareSnapshotRequest.tax = n.getNumberValue(); },
        "total": n => { cartShareSnapshotRequest.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCartsPageSummary(cartsPageSummary: Partial<CartsPageSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "asOf": n => { cartsPageSummary.asOf = n.getDateValue(); },
        "checkedOutLast30Days": n => { cartsPageSummary.checkedOutLast30Days = n.getNumberValue(); },
        "conversionGoal": n => { cartsPageSummary.conversionGoal = n.getNumberValue(); },
        "conversionRate": n => { cartsPageSummary.conversionRate = n.getNumberValue(); },
        "openCarts": n => { cartsPageSummary.openCarts = n.getNumberValue(); },
        "openValue": n => { cartsPageSummary.openValue = n.getNumberValue(); },
        "overFourteenDays": n => { cartsPageSummary.overFourteenDays = n.getNumberValue(); },
        "overFourteenDaysValue": n => { cartsPageSummary.overFourteenDaysValue = n.getNumberValue(); },
        "sevenToFourteenDays": n => { cartsPageSummary.sevenToFourteenDays = n.getNumberValue(); },
        "stillOpenFromLast30Days": n => { cartsPageSummary.stillOpenFromLast30Days = n.getNumberValue(); },
        "underSevenDays": n => { cartsPageSummary.underSevenDays = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCatalogItem(catalogItem: Partial<CatalogItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applicableItemIds": n => { catalogItem.applicableItemIds = n.getCollectionOfPrimitiveValues<string>(); },
        "description": n => { catalogItem.description = n.getStringValue(); },
        "id": n => { catalogItem.id = n.getStringValue(); },
        "name": n => { catalogItem.name = n.getStringValue(); },
        "prices": n => { catalogItem.prices = n.getCollectionOfObjectValues<CatalogItemPrice>(createCatalogItemPriceFromDiscriminatorValue); },
        "type": n => { catalogItem.type = n.getStringValue(); },
        "unit": n => { catalogItem.unit = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCatalogItemPrice(catalogItemPrice: Partial<CatalogItemPrice> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyCode": n => { catalogItemPrice.currencyCode = n.getStringValue(); },
        "id": n => { catalogItemPrice.id = n.getStringValue(); },
        "name": n => { catalogItemPrice.name = n.getStringValue(); },
        "period": n => { catalogItemPrice.period = n.getNumberValue(); },
        "periodUnit": n => { catalogItemPrice.periodUnit = n.getStringValue(); },
        "price": n => { catalogItemPrice.price = n.getNumberValue(); },
        "pricingModel": n => { catalogItemPrice.pricingModel = n.getStringValue(); },
        "quantityLimits": n => { catalogItemPrice.quantityLimits = n.getObjectValue<QuantityLimits>(createQuantityLimitsFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCategory(category: Partial<Category> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(category),
        "breadcrumb": n => { category.breadcrumb = n.getStringValue(); },
        "categoryId": n => { category.categoryId = n.getStringValue(); },
        "imageUpdatedAt": n => { category.imageUpdatedAt = n.getDateValue(); },
        "name": n => { category.name = n.getStringValue(); },
        "organizationId": n => { category.organizationId = n.getStringValue(); },
        "sortOrder": n => { category.sortOrder = n.getNumberValue(); },
        "subCategories": n => { category.subCategories = n.getCollectionOfObjectValues<Category>(createCategoryFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCategoryDto(categoryDto: Partial<CategoryDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoCategory(categoryDto),
        "imageUrl": n => { categoryDto.imageUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCategoryRevenueRanking(categoryRevenueRanking: Partial<CategoryRevenueRanking> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "category": n => { categoryRevenueRanking.category = n.getStringValue(); },
        "orderCount": n => { categoryRevenueRanking.orderCount = n.getNumberValue(); },
        "productCount": n => { categoryRevenueRanking.productCount = n.getNumberValue(); },
        "totalRevenue": n => { categoryRevenueRanking.totalRevenue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChangeTaskStatusRequest(changeTaskStatusRequest: Partial<ChangeTaskStatusRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "completedByName": n => { changeTaskStatusRequest.completedByName = n.getStringValue(); },
        "orgCodes": n => { changeTaskStatusRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "status": n => { changeTaskStatusRequest.status = n.getEnumValue<TaskItemStatus>(TaskItemStatusObject); },
        "useOrganizationId": n => { changeTaskStatusRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChannelTrendPoint(channelTrendPoint: Partial<ChannelTrendPoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "otherOrders": n => { channelTrendPoint.otherOrders = n.getNumberValue(); },
        "periodStart": n => { channelTrendPoint.periodStart = n.getStringValue(); },
        "repAssistedOrders": n => { channelTrendPoint.repAssistedOrders = n.getNumberValue(); },
        "salesAppOrders": n => { channelTrendPoint.salesAppOrders = n.getNumberValue(); },
        "storefrontOrders": n => { channelTrendPoint.storefrontOrders = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCheckAccessRequestExistsResponse(checkAccessRequestExistsResponse: Partial<CheckAccessRequestExistsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "exists": n => { checkAccessRequestExistsResponse.exists = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCheckInSalesRepDeviceRequest(checkInSalesRepDeviceRequest: Partial<CheckInSalesRepDeviceRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "appVersion": n => { checkInSalesRepDeviceRequest.appVersion = n.getStringValue(); },
        "appVersionHeader": n => { checkInSalesRepDeviceRequest.appVersionHeader = n.getStringValue(); },
        "buildNumber": n => { checkInSalesRepDeviceRequest.buildNumber = n.getStringValue(); },
        "deviceId": n => { checkInSalesRepDeviceRequest.deviceId = n.getStringValue(); },
        "deviceModel": n => { checkInSalesRepDeviceRequest.deviceModel = n.getStringValue(); },
        "lastLoginAt": n => { checkInSalesRepDeviceRequest.lastLoginAt = n.getDateValue(); },
        "orgCodes": n => { checkInSalesRepDeviceRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "osVersion": n => { checkInSalesRepDeviceRequest.osVersion = n.getStringValue(); },
        "useOrganizationId": n => { checkInSalesRepDeviceRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCheckInSalesRepDeviceResponse(checkInSalesRepDeviceResponse: Partial<CheckInSalesRepDeviceResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { checkInSalesRepDeviceResponse.deviceId = n.getStringValue(); },
        "lastSeenAt": n => { checkInSalesRepDeviceResponse.lastSeenAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCheckoutBillingAddress(checkoutBillingAddress: Partial<CheckoutBillingAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { checkoutBillingAddress.address1 = n.getStringValue(); },
        "address2": n => { checkoutBillingAddress.address2 = n.getStringValue(); },
        "city": n => { checkoutBillingAddress.city = n.getStringValue(); },
        "country": n => { checkoutBillingAddress.country = n.getStringValue(); },
        "stateProvince": n => { checkoutBillingAddress.stateProvince = n.getStringValue(); },
        "zipPostalCode": n => { checkoutBillingAddress.zipPostalCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCheckoutItem(checkoutItem: Partial<CheckoutItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "lookupKey": n => { checkoutItem.lookupKey = n.getStringValue(); },
        "quantity": n => { checkoutItem.quantity = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCheckoutPageResponse(checkoutPageResponse: Partial<CheckoutPageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { checkoutPageResponse.createdAt = n.getNumberValue(); },
        "embed": n => { checkoutPageResponse.embed = n.getBooleanValue(); },
        "expiresAt": n => { checkoutPageResponse.expiresAt = n.getNumberValue(); },
        "id": n => { checkoutPageResponse.id = n.getStringValue(); },
        "state": n => { checkoutPageResponse.state = n.getStringValue(); },
        "type": n => { checkoutPageResponse.type = n.getStringValue(); },
        "url": n => { checkoutPageResponse.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCodeCampaignSummary(codeCampaignSummary: Partial<CodeCampaignSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { codeCampaignSummary.campaignId = n.getStringValue(); },
        "description": n => { codeCampaignSummary.description = n.getStringValue(); },
        "name": n => { codeCampaignSummary.name = n.getStringValue(); },
        "validTo": n => { codeCampaignSummary.validTo = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoColumnMappingSuggestion(columnMappingSuggestion: Partial<ColumnMappingSuggestion> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alternates": n => { columnMappingSuggestion.alternates = n.getCollectionOfObjectValues<MappingAlternate>(createMappingAlternateFromDiscriminatorValue); },
        "confidence": n => { columnMappingSuggestion.confidence = n.getNumberValue(); },
        "create": n => { columnMappingSuggestion.create = n.getObjectValue<MappingCreateProposal>(createMappingCreateProposalFromDiscriminatorValue); },
        "header": n => { columnMappingSuggestion.header = n.getStringValue(); },
        "suggested": n => { columnMappingSuggestion.suggested = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCommissionEntryDto(commissionEntryDto: Partial<CommissionEntryDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amountPaid": n => { commissionEntryDto.amountPaid = n.getNumberValue(); },
        "currencyCode": n => { commissionEntryDto.currencyCode = n.getStringValue(); },
        "customerNumber": n => { commissionEntryDto.customerNumber = n.getStringValue(); },
        "entryId": n => { commissionEntryDto.entryId = n.getStringValue(); },
        "invoiceDate": n => { commissionEntryDto.invoiceDate = n.getDateValue(); },
        "invoiceId": n => { commissionEntryDto.invoiceId = n.getStringValue(); },
        "invoiceNumber": n => { commissionEntryDto.invoiceNumber = n.getStringValue(); },
        "invoiceTotal": n => { commissionEntryDto.invoiceTotal = n.getNumberValue(); },
        "lines": n => { commissionEntryDto.lines = n.getCollectionOfObjectValues<CommissionLineEntryDto>(createCommissionLineEntryDtoFromDiscriminatorValue); },
        "percentagePaid": n => { commissionEntryDto.percentagePaid = n.getNumberValue(); },
        "subtotal": n => { commissionEntryDto.subtotal = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCommissionLineEntryDto(commissionLineEntryDto: Partial<CommissionLineEntryDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "adjustedCommission": n => { commissionLineEntryDto.adjustedCommission = n.getNumberValue(); },
        "appliedPercentagePaid": n => { commissionLineEntryDto.appliedPercentagePaid = n.getNumberValue(); },
        "commissionDue": n => { commissionLineEntryDto.commissionDue = n.getNumberValue(); },
        "lineSubtotal": n => { commissionLineEntryDto.lineSubtotal = n.getNumberValue(); },
        "productName": n => { commissionLineEntryDto.productName = n.getStringValue(); },
        "quantity": n => { commissionLineEntryDto.quantity = n.getNumberValue(); },
        "rate": n => { commissionLineEntryDto.rate = n.getNumberValue(); },
        "ruleAppliedId": n => { commissionLineEntryDto.ruleAppliedId = n.getStringValue(); },
        "sku": n => { commissionLineEntryDto.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCommissionPlanDto(commissionPlanDto: Partial<CommissionPlanDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { commissionPlanDto.active = n.getBooleanValue(); },
        "commissionPlanId": n => { commissionPlanDto.commissionPlanId = n.getStringValue(); },
        "createdAt": n => { commissionPlanDto.createdAt = n.getDateValue(); },
        "customerOverrides": n => { commissionPlanDto.customerOverrides = n.getCollectionOfObjectValues<CustomerOverrideDto>(createCustomerOverrideDtoFromDiscriminatorValue); },
        "defaultRate": n => { commissionPlanDto.defaultRate = n.getNumberValue(); },
        "description": n => { commissionPlanDto.description = n.getStringValue(); },
        "effectiveEndDate": n => { commissionPlanDto.effectiveEndDate = n.getDateValue(); },
        "effectiveStartDate": n => { commissionPlanDto.effectiveStartDate = n.getDateValue(); },
        "name": n => { commissionPlanDto.name = n.getStringValue(); },
        "organizationId": n => { commissionPlanDto.organizationId = n.getStringValue(); },
        "rules": n => { commissionPlanDto.rules = n.getCollectionOfObjectValues<CommissionRuleDto>(createCommissionRuleDtoFromDiscriminatorValue); },
        "salesRepId": n => { commissionPlanDto.salesRepId = n.getStringValue(); },
        "updatedAt": n => { commissionPlanDto.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCommissionRuleDto(commissionRuleDto: Partial<CommissionRuleDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "match": n => { commissionRuleDto.match = n.getObjectValue<CommissionRuleMatchDto>(createCommissionRuleMatchDtoFromDiscriminatorValue); },
        "name": n => { commissionRuleDto.name = n.getStringValue(); },
        "priority": n => { commissionRuleDto.priority = n.getNumberValue(); },
        "rate": n => { commissionRuleDto.rate = n.getNumberValue(); },
        "ruleId": n => { commissionRuleDto.ruleId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCommissionRuleMatchDto(commissionRuleMatchDto: Partial<CommissionRuleMatchDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumbers": n => { commissionRuleMatchDto.customerNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "maxLineAmount": n => { commissionRuleMatchDto.maxLineAmount = n.getNumberValue(); },
        "minLineAmount": n => { commissionRuleMatchDto.minLineAmount = n.getNumberValue(); },
        "productNamePatterns": n => { commissionRuleMatchDto.productNamePatterns = n.getCollectionOfPrimitiveValues<string>(); },
        "skuPatterns": n => { commissionRuleMatchDto.skuPatterns = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCommissionStatementDto(commissionStatementDto: Partial<CommissionStatementDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { commissionStatementDto.active = n.getBooleanValue(); },
        "commissionPlanId": n => { commissionStatementDto.commissionPlanId = n.getStringValue(); },
        "commissionStatementId": n => { commissionStatementDto.commissionStatementId = n.getStringValue(); },
        "createdAt": n => { commissionStatementDto.createdAt = n.getDateValue(); },
        "endDate": n => { commissionStatementDto.endDate = n.getDateValue(); },
        "entries": n => { commissionStatementDto.entries = n.getCollectionOfObjectValues<CommissionEntryDto>(createCommissionEntryDtoFromDiscriminatorValue); },
        "history": n => { commissionStatementDto.history = n.getCollectionOfObjectValues<StatementEventDto>(createStatementEventDtoFromDiscriminatorValue); },
        "organizationId": n => { commissionStatementDto.organizationId = n.getStringValue(); },
        "paymentReference": n => { commissionStatementDto.paymentReference = n.getStringValue(); },
        "salesRepId": n => { commissionStatementDto.salesRepId = n.getStringValue(); },
        "startDate": n => { commissionStatementDto.startDate = n.getDateValue(); },
        "status": n => { commissionStatementDto.status = n.getStringValue(); },
        "subtotal": n => { commissionStatementDto.subtotal = n.getNumberValue(); },
        "tax": n => { commissionStatementDto.tax = n.getNumberValue(); },
        "taxItems": n => { commissionStatementDto.taxItems = n.getCollectionOfObjectValues<CommissionTaxItemDto>(createCommissionTaxItemDtoFromDiscriminatorValue); },
        "total": n => { commissionStatementDto.total = n.getNumberValue(); },
        "updatedAt": n => { commissionStatementDto.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCommissionTaxItemDto(commissionTaxItemDto: Partial<CommissionTaxItemDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { commissionTaxItemDto.amount = n.getNumberValue(); },
        "ratePercent": n => { commissionTaxItemDto.ratePercent = n.getNumberValue(); },
        "taxName": n => { commissionTaxItemDto.taxName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCompanyDocumentDto(companyDocumentDto: Partial<CompanyDocumentDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cdnUrl": n => { companyDocumentDto.cdnUrl = n.getStringValue(); },
        "createdAt": n => { companyDocumentDto.createdAt = n.getDateValue(); },
        "documentId": n => { companyDocumentDto.documentId = n.getStringValue(); },
        "externalId": n => { companyDocumentDto.externalId = n.getStringValue(); },
        "fileExtension": n => { companyDocumentDto.fileExtension = n.getStringValue(); },
        "folderId": n => { companyDocumentDto.folderId = n.getStringValue(); },
        "mimeType": n => { companyDocumentDto.mimeType = n.getStringValue(); },
        "name": n => { companyDocumentDto.name = n.getStringValue(); },
        "organizationId": n => { companyDocumentDto.organizationId = n.getStringValue(); },
        "path": n => { companyDocumentDto.path = n.getStringValue(); },
        "size": n => { companyDocumentDto.size = n.getNumberValue(); },
        "updatedAt": n => { companyDocumentDto.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCompanyFolderDto(companyFolderDto: Partial<CompanyFolderDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { companyFolderDto.createdAt = n.getDateValue(); },
        "externalId": n => { companyFolderDto.externalId = n.getStringValue(); },
        "folderId": n => { companyFolderDto.folderId = n.getStringValue(); },
        "name": n => { companyFolderDto.name = n.getStringValue(); },
        "organizationId": n => { companyFolderDto.organizationId = n.getStringValue(); },
        "parentId": n => { companyFolderDto.parentId = n.getStringValue(); },
        "path": n => { companyFolderDto.path = n.getStringValue(); },
        "updatedAt": n => { companyFolderDto.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCompleteCheckoutRequest(completeCheckoutRequest: Partial<CompleteCheckoutRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "channel": n => { completeCheckoutRequest.channel = n.getStringValue(); },
        "orgCodes": n => { completeCheckoutRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "payment": n => { completeCheckoutRequest.payment = n.getObjectValue<Payment2>(createPayment2FromDiscriminatorValue); },
        "paymentProfileId": n => { completeCheckoutRequest.paymentProfileId = n.getStringValue(); },
        "useOrganizationId": n => { completeCheckoutRequest.useOrganizationId = n.getStringValue(); },
        "userType": n => { completeCheckoutRequest.userType = n.getEnumValue<UserTypes>(UserTypesObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCompleteCheckoutResponse(completeCheckoutResponse: Partial<CompleteCheckoutResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "confirmationId": n => { completeCheckoutResponse.confirmationId = n.getStringValue(); },
        "orderNumber": n => { completeCheckoutResponse.orderNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCompletePaymentRequest(completePaymentRequest: Partial<CompletePaymentRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { completePaymentRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { completePaymentRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConfigResponse(configResponse: Partial<ConfigResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "mapsApiKey": n => { configResponse.mapsApiKey = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConfigurationField(configurationField: Partial<ConfigurationField> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "defaultValue": n => { configurationField.defaultValue = n.getStringValue(); },
        "description": n => { configurationField.description = n.getStringValue(); },
        "displayName": n => { configurationField.displayName = n.getStringValue(); },
        "key": n => { configurationField.key = n.getStringValue(); },
        "placeholderText": n => { configurationField.placeholderText = n.getStringValue(); },
        "required": n => { configurationField.required = n.getBooleanValue(); },
        "type": n => { configurationField.type = n.getEnumValue<FieldType>(FieldTypeObject); },
        "validationPattern": n => { configurationField.validationPattern = n.getStringValue(); },
        "validValues": n => { configurationField.validValues = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConnectIntegrationRequest(connectIntegrationRequest: Partial<ConnectIntegrationRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "state": n => { connectIntegrationRequest.state = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConnectIntegrationResponse(connectIntegrationResponse: Partial<ConnectIntegrationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "authorizationUrl": n => { connectIntegrationResponse.authorizationUrl = n.getStringValue(); },
        "expiresAt": n => { connectIntegrationResponse.expiresAt = n.getDateValue(); },
        "integrationId": n => { connectIntegrationResponse.integrationId = n.getStringValue(); },
        "integrationType": n => { connectIntegrationResponse.integrationType = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
        "provider": n => { connectIntegrationResponse.provider = n.getStringValue(); },
        "state": n => { connectIntegrationResponse.state = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConnectorEndpointDto(connectorEndpointDto: Partial<ConnectorEndpointDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiPath": n => { connectorEndpointDto.apiPath = n.getStringValue(); },
        "dataMappingApiId": n => { connectorEndpointDto.dataMappingApiId = n.getStringValue(); },
        "endpointType": n => { connectorEndpointDto.endpointType = n.getStringValue(); },
        "fieldMappings": n => { connectorEndpointDto.fieldMappings = n.getCollectionOfObjectValues<ConnectorFieldMappingDto>(createConnectorFieldMappingDtoFromDiscriminatorValue); },
        "id": n => { connectorEndpointDto.id = n.getStringValue(); },
        "isEnabled": n => { connectorEndpointDto.isEnabled = n.getBooleanValue(); },
        "name": n => { connectorEndpointDto.name = n.getStringValue(); },
        "schedule": n => { connectorEndpointDto.schedule = n.getObjectValue<ConnectorScheduleDto>(createConnectorScheduleDtoFromDiscriminatorValue); },
        "sqlQuery": n => { connectorEndpointDto.sqlQuery = n.getStringValue(); },
        "syncMode": n => { connectorEndpointDto.syncMode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConnectorEndpointsDocument(connectorEndpointsDocument: Partial<ConnectorEndpointsDocument> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "connectorId": n => { connectorEndpointsDocument.connectorId = n.getStringValue(); },
        "endpoints": n => { connectorEndpointsDocument.endpoints = n.getCollectionOfObjectValues<ConnectorEndpointDto>(createConnectorEndpointDtoFromDiscriminatorValue); },
        "id": n => { connectorEndpointsDocument.id = n.getStringValue(); },
        "organizationId": n => { connectorEndpointsDocument.organizationId = n.getStringValue(); },
        "pushedAt": n => { connectorEndpointsDocument.pushedAt = n.getDateValue(); },
        "updatedAt": n => { connectorEndpointsDocument.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConnectorFieldMappingDto(connectorFieldMappingDto: Partial<ConnectorFieldMappingDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "defaultValue": n => { connectorFieldMappingDto.defaultValue = n.getStringValue(); },
        "isRequired": n => { connectorFieldMappingDto.isRequired = n.getBooleanValue(); },
        "sourceColumn": n => { connectorFieldMappingDto.sourceColumn = n.getStringValue(); },
        "targetField": n => { connectorFieldMappingDto.targetField = n.getStringValue(); },
        "transformation": n => { connectorFieldMappingDto.transformation = n.getStringValue(); },
        "transformationParameter": n => { connectorFieldMappingDto.transformationParameter = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConnectorScheduleDto(connectorScheduleDto: Partial<ConnectorScheduleDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cronExpression": n => { connectorScheduleDto.cronExpression = n.getStringValue(); },
        "intervalMinutes": n => { connectorScheduleDto.intervalMinutes = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContact(contact: Partial<Contact> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contactId": n => { contact.contactId = n.getStringValue(); },
        "contactType": n => { contact.contactType = n.getEnumValue<ContactType>(ContactTypeObject); },
        "default": n => { contact.defaultEscaped = n.getBooleanValue(); },
        "emailAddress": n => { contact.emailAddress = n.getStringValue(); },
        "externalId": n => { contact.externalId = n.getStringValue(); },
        "fax": n => { contact.fax = n.getStringValue(); },
        "firstName": n => { contact.firstName = n.getStringValue(); },
        "fullName": n => { contact.fullName = n.getStringValue(); },
        "lastName": n => { contact.lastName = n.getStringValue(); },
        "phone": n => { contact.phone = n.getStringValue(); },
        "title": n => { contact.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContactListItemDto(contactListItemDto: Partial<ContactListItemDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "companyName": n => { contactListItemDto.companyName = n.getStringValue(); },
        "contactId": n => { contactListItemDto.contactId = n.getStringValue(); },
        "contactType": n => { contactListItemDto.contactType = n.getEnumValue<ContactType>(ContactTypeObject); },
        "customerActive": n => { contactListItemDto.customerActive = n.getBooleanValue(); },
        "customerId": n => { contactListItemDto.customerId = n.getStringValue(); },
        "customerNumber": n => { contactListItemDto.customerNumber = n.getStringValue(); },
        "default": n => { contactListItemDto.defaultEscaped = n.getBooleanValue(); },
        "emailAddress": n => { contactListItemDto.emailAddress = n.getStringValue(); },
        "externalId": n => { contactListItemDto.externalId = n.getStringValue(); },
        "fax": n => { contactListItemDto.fax = n.getStringValue(); },
        "firstName": n => { contactListItemDto.firstName = n.getStringValue(); },
        "fullName": n => { contactListItemDto.fullName = n.getStringValue(); },
        "lastName": n => { contactListItemDto.lastName = n.getStringValue(); },
        "phone": n => { contactListItemDto.phone = n.getStringValue(); },
        "title": n => { contactListItemDto.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContent(content: Partial<Content> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customer": n => { content.customer = n.getObjectValue<SubscriptionCreatedCustomer>(createSubscriptionCreatedCustomerFromDiscriminatorValue); },
        "subscription": n => { content.subscription = n.getObjectValue<Subscription>(createSubscriptionFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateAccessRequestRequest(createAccessRequestRequest: Partial<CreateAccessRequestRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { createAccessRequestRequest.address1 = n.getStringValue(); },
        "address2": n => { createAccessRequestRequest.address2 = n.getStringValue(); },
        "city": n => { createAccessRequestRequest.city = n.getStringValue(); },
        "companyEmail": n => { createAccessRequestRequest.companyEmail = n.getStringValue(); },
        "companyName": n => { createAccessRequestRequest.companyName = n.getStringValue(); },
        "country": n => { createAccessRequestRequest.country = n.getStringValue(); },
        "emailAddress": n => { createAccessRequestRequest.emailAddress = n.getStringValue(); },
        "firstName": n => { createAccessRequestRequest.firstName = n.getStringValue(); },
        "lastName": n => { createAccessRequestRequest.lastName = n.getStringValue(); },
        "phoneNumber": n => { createAccessRequestRequest.phoneNumber = n.getStringValue(); },
        "postalCode": n => { createAccessRequestRequest.postalCode = n.getStringValue(); },
        "stateProvince": n => { createAccessRequestRequest.stateProvince = n.getStringValue(); },
        "taxIdEIN": n => { createAccessRequestRequest.taxIdEIN = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateAccessRequestResponse(createAccessRequestResponse: Partial<CreateAccessRequestResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessRequestId": n => { createAccessRequestResponse.accessRequestId = n.getStringValue(); },
        "address1": n => { createAccessRequestResponse.address1 = n.getStringValue(); },
        "address2": n => { createAccessRequestResponse.address2 = n.getStringValue(); },
        "city": n => { createAccessRequestResponse.city = n.getStringValue(); },
        "companyEmail": n => { createAccessRequestResponse.companyEmail = n.getStringValue(); },
        "companyName": n => { createAccessRequestResponse.companyName = n.getStringValue(); },
        "country": n => { createAccessRequestResponse.country = n.getStringValue(); },
        "createdAt": n => { createAccessRequestResponse.createdAt = n.getDateValue(); },
        "emailAddress": n => { createAccessRequestResponse.emailAddress = n.getStringValue(); },
        "firstName": n => { createAccessRequestResponse.firstName = n.getStringValue(); },
        "lastName": n => { createAccessRequestResponse.lastName = n.getStringValue(); },
        "organizationId": n => { createAccessRequestResponse.organizationId = n.getStringValue(); },
        "phoneNumber": n => { createAccessRequestResponse.phoneNumber = n.getStringValue(); },
        "postalCode": n => { createAccessRequestResponse.postalCode = n.getStringValue(); },
        "stateProvince": n => { createAccessRequestResponse.stateProvince = n.getStringValue(); },
        "taxIdEIN": n => { createAccessRequestResponse.taxIdEIN = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateApiAccessResponse(createApiAccessResponse: Partial<CreateApiAccessResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiKey": n => { createApiAccessResponse.apiKey = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCartRequest(createCartRequest: Partial<CreateCartRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderType": n => { createCartRequest.orderType = n.getStringValue(); },
        "quantity": n => { createCartRequest.quantity = n.getNumberValue(); },
        "sku": n => { createCartRequest.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCategoryRequest(createCategoryRequest: Partial<CreateCategoryRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { createCategoryRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCategoryResponse(createCategoryResponse: Partial<CreateCategoryResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { createCategoryResponse.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCheckoutRequest(createCheckoutRequest: Partial<CreateCheckoutRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "items": n => { createCheckoutRequest.items = n.getCollectionOfObjectValues<CheckoutItem>(createCheckoutItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCheckoutResponse(createCheckoutResponse: Partial<CreateCheckoutResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "clientSecret": n => { createCheckoutResponse.clientSecret = n.getStringValue(); },
        "sessionId": n => { createCheckoutResponse.sessionId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCodeRequest(createCodeRequest: Partial<CreateCodeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { createCodeRequest.code = n.getStringValue(); },
        "options": n => { createCodeRequest.options = n.getObjectValue<DiscountCodeOptionsInput>(createDiscountCodeOptionsInputFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCommissionPlanRequest(createCommissionPlanRequest: Partial<CreateCommissionPlanRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerOverrides": n => { createCommissionPlanRequest.customerOverrides = n.getCollectionOfObjectValues<CreateCommissionPlanRequest_CustomerOverrideInput>(createCreateCommissionPlanRequest_CustomerOverrideInputFromDiscriminatorValue); },
        "defaultRate": n => { createCommissionPlanRequest.defaultRate = n.getNumberValue(); },
        "description": n => { createCommissionPlanRequest.description = n.getStringValue(); },
        "effectiveEndDate": n => { createCommissionPlanRequest.effectiveEndDate = n.getDateValue(); },
        "effectiveStartDate": n => { createCommissionPlanRequest.effectiveStartDate = n.getDateValue(); },
        "name": n => { createCommissionPlanRequest.name = n.getStringValue(); },
        "orgCodes": n => { createCommissionPlanRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "rules": n => { createCommissionPlanRequest.rules = n.getCollectionOfObjectValues<CreateCommissionPlanRequest_RuleInput>(createCreateCommissionPlanRequest_RuleInputFromDiscriminatorValue); },
        "salesRepId": n => { createCommissionPlanRequest.salesRepId = n.getStringValue(); },
        "useOrganizationId": n => { createCommissionPlanRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCommissionPlanRequest_CustomerOverrideInput(createCommissionPlanRequest_CustomerOverrideInput: Partial<CreateCommissionPlanRequest_CustomerOverrideInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { createCommissionPlanRequest_CustomerOverrideInput.customerNumber = n.getStringValue(); },
        "defaultRate": n => { createCommissionPlanRequest_CustomerOverrideInput.defaultRate = n.getNumberValue(); },
        "effectiveEndDate": n => { createCommissionPlanRequest_CustomerOverrideInput.effectiveEndDate = n.getDateValue(); },
        "effectiveStartDate": n => { createCommissionPlanRequest_CustomerOverrideInput.effectiveStartDate = n.getDateValue(); },
        "rules": n => { createCommissionPlanRequest_CustomerOverrideInput.rules = n.getCollectionOfObjectValues<CreateCommissionPlanRequest_RuleInput>(createCreateCommissionPlanRequest_RuleInputFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCommissionPlanRequest_RuleInput(createCommissionPlanRequest_RuleInput: Partial<CreateCommissionPlanRequest_RuleInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "match": n => { createCommissionPlanRequest_RuleInput.match = n.getObjectValue<CreateCommissionPlanRequest_RuleMatchInput>(createCreateCommissionPlanRequest_RuleMatchInputFromDiscriminatorValue); },
        "name": n => { createCommissionPlanRequest_RuleInput.name = n.getStringValue(); },
        "priority": n => { createCommissionPlanRequest_RuleInput.priority = n.getNumberValue(); },
        "rate": n => { createCommissionPlanRequest_RuleInput.rate = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCommissionPlanRequest_RuleMatchInput(createCommissionPlanRequest_RuleMatchInput: Partial<CreateCommissionPlanRequest_RuleMatchInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumbers": n => { createCommissionPlanRequest_RuleMatchInput.customerNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "maxLineAmount": n => { createCommissionPlanRequest_RuleMatchInput.maxLineAmount = n.getNumberValue(); },
        "minLineAmount": n => { createCommissionPlanRequest_RuleMatchInput.minLineAmount = n.getNumberValue(); },
        "productNamePatterns": n => { createCommissionPlanRequest_RuleMatchInput.productNamePatterns = n.getCollectionOfPrimitiveValues<string>(); },
        "skuPatterns": n => { createCommissionPlanRequest_RuleMatchInput.skuPatterns = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCommissionStatementRequest(createCommissionStatementRequest: Partial<CreateCommissionStatementRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endDate": n => { createCommissionStatementRequest.endDate = n.getDateValue(); },
        "generatedByUser": n => { createCommissionStatementRequest.generatedByUser = n.getStringValue(); },
        "orgCodes": n => { createCommissionStatementRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { createCommissionStatementRequest.salesRepId = n.getStringValue(); },
        "startDate": n => { createCommissionStatementRequest.startDate = n.getDateValue(); },
        "taxItems": n => { createCommissionStatementRequest.taxItems = n.getCollectionOfObjectValues<CreateCommissionStatementRequest_TaxItemInput>(createCreateCommissionStatementRequest_TaxItemInputFromDiscriminatorValue); },
        "useOrganizationId": n => { createCommissionStatementRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCommissionStatementRequest_TaxItemInput(createCommissionStatementRequest_TaxItemInput: Partial<CreateCommissionStatementRequest_TaxItemInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { createCommissionStatementRequest_TaxItemInput.amount = n.getNumberValue(); },
        "ratePercent": n => { createCommissionStatementRequest_TaxItemInput.ratePercent = n.getNumberValue(); },
        "taxName": n => { createCommissionStatementRequest_TaxItemInput.taxName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCustomerNoteRequest(createCustomerNoteRequest: Partial<CreateCustomerNoteRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "authorName": n => { createCustomerNoteRequest.authorName = n.getStringValue(); },
        "body": n => { createCustomerNoteRequest.body = n.getStringValue(); },
        "orgCodes": n => { createCustomerNoteRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { createCustomerNoteRequest.salesRepId = n.getStringValue(); },
        "useOrganizationId": n => { createCustomerNoteRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCustomerRequest(createCustomerRequest: Partial<CreateCustomerRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { createCustomerRequest.active = n.getBooleanValue(); },
        "addresses": n => { createCustomerRequest.addresses = n.getCollectionOfObjectValues<Address>(createAddressFromDiscriminatorValue); },
        "companyEmail": n => { createCustomerRequest.companyEmail = n.getStringValue(); },
        "companyFax": n => { createCustomerRequest.companyFax = n.getStringValue(); },
        "companyName": n => { createCustomerRequest.companyName = n.getStringValue(); },
        "companyPhone": n => { createCustomerRequest.companyPhone = n.getStringValue(); },
        "contacts": n => { createCustomerRequest.contacts = n.getCollectionOfObjectValues<Contact>(createContactFromDiscriminatorValue); },
        "customerAttributes": n => { createCustomerRequest.customerAttributes = n.getObjectValue<CreateCustomerRequest_customerAttributes>(createCreateCustomerRequest_customerAttributesFromDiscriminatorValue); },
        "customerNumber": n => { createCustomerRequest.customerNumber = n.getStringValue(); },
        "externalId": n => { createCustomerRequest.externalId = n.getStringValue(); },
        "fulfillmentMethod": n => { createCustomerRequest.fulfillmentMethod = n.getStringValue(); },
        "pricing": n => { createCustomerRequest.pricing = n.getStringValue(); },
        "repNumber": n => { createCustomerRequest.repNumber = n.getStringValue(); },
        "terms": n => { createCustomerRequest.terms = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCustomerRequest_customerAttributes(createCustomerRequest_customerAttributes: Partial<CreateCustomerRequest_customerAttributes> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateFavoriteListRequest(createFavoriteListRequest: Partial<CreateFavoriteListRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isDefault": n => { createFavoriteListRequest.isDefault = n.getBooleanValue(); },
        "name": n => { createFavoriteListRequest.name = n.getStringValue(); },
        "orgCodes": n => { createFavoriteListRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { createFavoriteListRequest.salesRepId = n.getStringValue(); },
        "source": n => { createFavoriteListRequest.source = n.getStringValue(); },
        "useOrganizationId": n => { createFavoriteListRequest.useOrganizationId = n.getStringValue(); },
        "userId": n => { createFavoriteListRequest.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateFlipbookFromPdfResponse(createFlipbookFromPdfResponse: Partial<CreateFlipbookFromPdfResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "flipbookId": n => { createFlipbookFromPdfResponse.flipbookId = n.getStringValue(); },
        "pageCount": n => { createFlipbookFromPdfResponse.pageCount = n.getNumberValue(); },
        "pages": n => { createFlipbookFromPdfResponse.pages = n.getCollectionOfObjectValues<PageInfo>(createPageInfoFromDiscriminatorValue); },
        "title": n => { createFlipbookFromPdfResponse.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateFolderRequest(createFolderRequest: Partial<CreateFolderRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { createFolderRequest.name = n.getStringValue(); },
        "parentId": n => { createFolderRequest.parentId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateIntegrationRequest(createIntegrationRequest: Partial<CreateIntegrationRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "configuration": n => { createIntegrationRequest.configuration = n.getObjectValue<CreateIntegrationRequest_configuration>(createCreateIntegrationRequest_configurationFromDiscriminatorValue); },
        "displayName": n => { createIntegrationRequest.displayName = n.getStringValue(); },
        "integrationType": n => { createIntegrationRequest.integrationType = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
        "isEnabled": n => { createIntegrationRequest.isEnabled = n.getBooleanValue(); },
        "provider": n => { createIntegrationRequest.provider = n.getStringValue(); },
        "secrets": n => { createIntegrationRequest.secrets = n.getObjectValue<CreateIntegrationRequest_secrets>(createCreateIntegrationRequest_secretsFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateIntegrationRequest_configuration(createIntegrationRequest_configuration: Partial<CreateIntegrationRequest_configuration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateIntegrationRequest_secrets(createIntegrationRequest_secrets: Partial<CreateIntegrationRequest_secrets> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateIntegrationResponse(createIntegrationResponse: Partial<CreateIntegrationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { createIntegrationResponse.createdAt = n.getDateValue(); },
        "displayName": n => { createIntegrationResponse.displayName = n.getStringValue(); },
        "integrationId": n => { createIntegrationResponse.integrationId = n.getStringValue(); },
        "integrationType": n => { createIntegrationResponse.integrationType = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
        "isEnabled": n => { createIntegrationResponse.isEnabled = n.getBooleanValue(); },
        "organizationId": n => { createIntegrationResponse.organizationId = n.getStringValue(); },
        "provider": n => { createIntegrationResponse.provider = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateInvoiceRequest(createInvoiceRequest: Partial<CreateInvoiceRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { createInvoiceRequest.active = n.getBooleanValue(); },
        "currencyCode": n => { createInvoiceRequest.currencyCode = n.getStringValue(); },
        "customer": n => { createInvoiceRequest.customer = n.getObjectValue<CustomerInput>(createCustomerInputFromDiscriminatorValue); },
        "discount": n => { createInvoiceRequest.discount = n.getObjectValue<DiscountInput>(createDiscountInputFromDiscriminatorValue); },
        "dueDate": n => { createInvoiceRequest.dueDate = n.getDateValue(); },
        "fulfillmentCenter": n => { createInvoiceRequest.fulfillmentCenter = n.getStringValue(); },
        "fulfillmentMethod": n => { createInvoiceRequest.fulfillmentMethod = n.getStringValue(); },
        "importedBalance": n => { createInvoiceRequest.importedBalance = n.getNumberValue(); },
        "importedInvoiceTotal": n => { createInvoiceRequest.importedInvoiceTotal = n.getNumberValue(); },
        "invoiceDate": n => { createInvoiceRequest.invoiceDate = n.getDateValue(); },
        "invoiceNumber": n => { createInvoiceRequest.invoiceNumber = n.getStringValue(); },
        "items": n => { createInvoiceRequest.items = n.getCollectionOfObjectValues<InvoiceItemInput>(createInvoiceItemInputFromDiscriminatorValue); },
        "notes": n => { createInvoiceRequest.notes = n.getStringValue(); },
        "numberOfPackages": n => { createInvoiceRequest.numberOfPackages = n.getNumberValue(); },
        "orderId": n => { createInvoiceRequest.orderId = n.getStringValue(); },
        "orderNumber": n => { createInvoiceRequest.orderNumber = n.getStringValue(); },
        "orgCodes": n => { createInvoiceRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "poNumber": n => { createInvoiceRequest.poNumber = n.getStringValue(); },
        "primarySalesRep": n => { createInvoiceRequest.primarySalesRep = n.getObjectValue<SalesRepInput>(createSalesRepInputFromDiscriminatorValue); },
        "shippingDetails": n => { createInvoiceRequest.shippingDetails = n.getObjectValue<ShippingDetailsInput>(createShippingDetailsInputFromDiscriminatorValue); },
        "tax": n => { createInvoiceRequest.tax = n.getNumberValue(); },
        "terms": n => { createInvoiceRequest.terms = n.getStringValue(); },
        "trackingNumber": n => { createInvoiceRequest.trackingNumber = n.getStringValue(); },
        "useOrganizationId": n => { createInvoiceRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateManyCustomersRequest(createManyCustomersRequest: Partial<CreateManyCustomersRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customers": n => { createManyCustomersRequest.customers = n.getCollectionOfObjectValues<CreateCustomerRequest>(createCreateCustomerRequestFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateManyInvoicesRequest(createManyInvoicesRequest: Partial<CreateManyInvoicesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "invoices": n => { createManyInvoicesRequest.invoices = n.getCollectionOfObjectValues<CreateInvoiceRequest>(createCreateInvoiceRequestFromDiscriminatorValue); },
        "orgCodes": n => { createManyInvoicesRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { createManyInvoicesRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateManyOrdersRequest(createManyOrdersRequest: Partial<CreateManyOrdersRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orders": n => { createManyOrdersRequest.orders = n.getCollectionOfObjectValues<CreateOrderItemRequest>(createCreateOrderItemRequestFromDiscriminatorValue); },
        "orgCodes": n => { createManyOrdersRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { createManyOrdersRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateManyProductsRequest(createManyProductsRequest: Partial<CreateManyProductsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ignoreCategory": n => { createManyProductsRequest.ignoreCategory = n.getBooleanValue(); },
        "products": n => { createManyProductsRequest.products = n.getCollectionOfObjectValues<CreateProductRequest>(createCreateProductRequestFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateOrderItemRequest(createOrderItemRequest: Partial<CreateOrderItemRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { createOrderItemRequest.active = n.getBooleanValue(); },
        "channel": n => { createOrderItemRequest.channel = n.getStringValue(); },
        "currencyCode": n => { createOrderItemRequest.currencyCode = n.getStringValue(); },
        "customer": n => { createOrderItemRequest.customer = n.getObjectValue<Customer2>(createCustomer2FromDiscriminatorValue); },
        "externalId": n => { createOrderItemRequest.externalId = n.getStringValue(); },
        "fulfillmentCenter": n => { createOrderItemRequest.fulfillmentCenter = n.getStringValue(); },
        "fulfillmentMethod": n => { createOrderItemRequest.fulfillmentMethod = n.getStringValue(); },
        "items": n => { createOrderItemRequest.items = n.getCollectionOfObjectValues<OrderItemInput>(createOrderItemInputFromDiscriminatorValue); },
        "marketCode": n => { createOrderItemRequest.marketCode = n.getStringValue(); },
        "notes": n => { createOrderItemRequest.notes = n.getStringValue(); },
        "orderDate": n => { createOrderItemRequest.orderDate = n.getDateValue(); },
        "orderNumber": n => { createOrderItemRequest.orderNumber = n.getStringValue(); },
        "orderStatus": n => { createOrderItemRequest.orderStatus = n.getStringValue(); },
        "orderType": n => { createOrderItemRequest.orderType = n.getStringValue(); },
        "originationCartId": n => { createOrderItemRequest.originationCartId = n.getStringValue(); },
        "poNumber": n => { createOrderItemRequest.poNumber = n.getStringValue(); },
        "priceTier": n => { createOrderItemRequest.priceTier = n.getStringValue(); },
        "primarySalesRep": n => { createOrderItemRequest.primarySalesRep = n.getObjectValue<SalesRep>(createSalesRepFromDiscriminatorValue); },
        "shippingDetails": n => { createOrderItemRequest.shippingDetails = n.getObjectValue<ShippingDetails>(createShippingDetailsFromDiscriminatorValue); },
        "takenBySalesRep": n => { createOrderItemRequest.takenBySalesRep = n.getObjectValue<SalesRep>(createSalesRepFromDiscriminatorValue); },
        "tax": n => { createOrderItemRequest.tax = n.getNumberValue(); },
        "terms": n => { createOrderItemRequest.terms = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateOrganizationApiKeyRequest(createOrganizationApiKeyRequest: Partial<CreateOrganizationApiKeyRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { createOrganizationApiKeyRequest.name = n.getStringValue(); },
        "scope": n => { createOrganizationApiKeyRequest.scope = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateOrganizationApiKeyResponse(createOrganizationApiKeyResponse: Partial<CreateOrganizationApiKeyResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiKey": n => { createOrganizationApiKeyResponse.apiKey = n.getStringValue(); },
        "keyId": n => { createOrganizationApiKeyResponse.keyId = n.getStringValue(); },
        "scope": n => { createOrganizationApiKeyResponse.scope = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateOrganizationRequest(createOrganizationRequest: Partial<CreateOrganizationRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "organization": n => { createOrganizationRequest.organization = n.getObjectValue<Organization2>(createOrganization2FromDiscriminatorValue); },
        "user": n => { createOrganizationRequest.user = n.getObjectValue<User>(createUserFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateOrganizationResponse(createOrganizationResponse: Partial<CreateOrganizationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "identityOrganizationId": n => { createOrganizationResponse.identityOrganizationId = n.getStringValue(); },
        "name": n => { createOrganizationResponse.name = n.getStringValue(); },
        "organizationId": n => { createOrganizationResponse.organizationId = n.getStringValue(); },
        "slug": n => { createOrganizationResponse.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateOrUpdateDataMappingRequest(createOrUpdateDataMappingRequest: Partial<CreateOrUpdateDataMappingRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "headerMappingFields": n => { createOrUpdateDataMappingRequest.headerMappingFields = n.getCollectionOfObjectValues<CreateOrUpdateDataMappingRequest_HeaderMappingField>(createCreateOrUpdateDataMappingRequest_HeaderMappingFieldFromDiscriminatorValue); },
        "id": n => { createOrUpdateDataMappingRequest.id = n.getStringValue(); },
        "invertActiveProperty": n => { createOrUpdateDataMappingRequest.invertActiveProperty = n.getBooleanValue(); },
        "name": n => { createOrUpdateDataMappingRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateOrUpdateDataMappingRequest_HeaderMappingField(createOrUpdateDataMappingRequest_HeaderMappingField: Partial<CreateOrUpdateDataMappingRequest_HeaderMappingField> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "header": n => { createOrUpdateDataMappingRequest_HeaderMappingField.header = n.getStringValue(); },
        "mapping": n => { createOrUpdateDataMappingRequest_HeaderMappingField.mapping = n.getObjectValue<CreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping>(createCreateOrUpdateDataMappingRequest_HeaderMappingField_MappingFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping(createOrUpdateDataMappingRequest_HeaderMappingField_Mapping: Partial<CreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "mappedHeaderName": n => { createOrUpdateDataMappingRequest_HeaderMappingField_Mapping.mappedHeaderName = n.getStringValue(); },
        "uploadedHeaderName": n => { createOrUpdateDataMappingRequest_HeaderMappingField_Mapping.uploadedHeaderName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateProductRequest(createProductRequest: Partial<CreateProductRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { createProductRequest.active = n.getBooleanValue(); },
        "category": n => { createProductRequest.category = n.getStringValue(); },
        "description": n => { createProductRequest.description = n.getStringValue(); },
        "dimensions": n => { createProductRequest.dimensions = n.getStringValue(); },
        "dimensionsUnit": n => { createProductRequest.dimensionsUnit = n.getStringValue(); },
        "externalId": n => { createProductRequest.externalId = n.getStringValue(); },
        "familyDescription": n => { createProductRequest.familyDescription = n.getStringValue(); },
        "familyKey": n => { createProductRequest.familyKey = n.getStringValue(); },
        "familyName": n => { createProductRequest.familyName = n.getStringValue(); },
        "imageName": n => { createProductRequest.imageName = n.getStringValue(); },
        "images": n => { createProductRequest.images = n.getCollectionOfPrimitiveValues<string>(); },
        "minimumOrderQuantity": n => { createProductRequest.minimumOrderQuantity = n.getNumberValue(); },
        "name": n => { createProductRequest.name = n.getStringValue(); },
        "optionValues": n => { createProductRequest.optionValues = n.getObjectValue<CreateProductRequest_optionValues>(createCreateProductRequest_optionValuesFromDiscriminatorValue); },
        "price": n => { createProductRequest.price = n.getNumberValue(); },
        "prices": n => { createProductRequest.prices = n.getCollectionOfObjectValues<CreateProductRequest_ProductPriceDto>(createCreateProductRequest_ProductPriceDtoFromDiscriminatorValue); },
        "productAttributes": n => { createProductRequest.productAttributes = n.getObjectValue<CreateProductRequest_productAttributes>(createCreateProductRequest_productAttributesFromDiscriminatorValue); },
        "quantityIncrement": n => { createProductRequest.quantityIncrement = n.getNumberValue(); },
        "quantityOnHand": n => { createProductRequest.quantityOnHand = n.getNumberValue(); },
        "separateLines": n => { createProductRequest.separateLines = n.getBooleanValue(); },
        "sku": n => { createProductRequest.sku = n.getStringValue(); },
        "upc": n => { createProductRequest.upc = n.getStringValue(); },
        "vendorCode": n => { createProductRequest.vendorCode = n.getStringValue(); },
        "weight": n => { createProductRequest.weight = n.getNumberValue(); },
        "weightUnit": n => { createProductRequest.weightUnit = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateProductRequest_optionValues(createProductRequest_optionValues: Partial<CreateProductRequest_optionValues> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateProductRequest_productAttributes(createProductRequest_productAttributes: Partial<CreateProductRequest_productAttributes> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateProductRequest_ProductPriceDto(createProductRequest_ProductPriceDto: Partial<CreateProductRequest_ProductPriceDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "atQuantity": n => { createProductRequest_ProductPriceDto.atQuantity = n.getNumberValue(); },
        "price": n => { createProductRequest_ProductPriceDto.price = n.getNumberValue(); },
        "tier": n => { createProductRequest_ProductPriceDto.tier = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateSalesRepRequest(createSalesRepRequest: Partial<CreateSalesRepRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { createSalesRepRequest.email = n.getStringValue(); },
        "firstName": n => { createSalesRepRequest.firstName = n.getStringValue(); },
        "lastName": n => { createSalesRepRequest.lastName = n.getStringValue(); },
        "marketCode": n => { createSalesRepRequest.marketCode = n.getStringValue(); },
        "phoneNumber": n => { createSalesRepRequest.phoneNumber = n.getStringValue(); },
        "repNumber": n => { createSalesRepRequest.repNumber = n.getStringValue(); },
        "repNumbers": n => { createSalesRepRequest.repNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "roles": n => { createSalesRepRequest.roles = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateSalesRepResponse(createSalesRepResponse: Partial<CreateSalesRepResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { createSalesRepResponse.email = n.getStringValue(); },
        "firstName": n => { createSalesRepResponse.firstName = n.getStringValue(); },
        "identityOrganizationId": n => { createSalesRepResponse.identityOrganizationId = n.getStringValue(); },
        "identityProvider": n => { createSalesRepResponse.identityProvider = n.getStringValue(); },
        "identityProviderUserId": n => { createSalesRepResponse.identityProviderUserId = n.getStringValue(); },
        "lastName": n => { createSalesRepResponse.lastName = n.getStringValue(); },
        "marketCode": n => { createSalesRepResponse.marketCode = n.getStringValue(); },
        "organizationId": n => { createSalesRepResponse.organizationId = n.getStringValue(); },
        "organizationName": n => { createSalesRepResponse.organizationName = n.getStringValue(); },
        "organizationSalesRepId": n => { createSalesRepResponse.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { createSalesRepResponse.phoneNumber = n.getStringValue(); },
        "repNumber": n => { createSalesRepResponse.repNumber = n.getStringValue(); },
        "repNumbers": n => { createSalesRepResponse.repNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { createSalesRepResponse.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateTaskRequest(createTaskRequest: Partial<CreateTaskRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdByName": n => { createTaskRequest.createdByName = n.getStringValue(); },
        "customerNumber": n => { createTaskRequest.customerNumber = n.getStringValue(); },
        "description": n => { createTaskRequest.description = n.getStringValue(); },
        "dueAt": n => { createTaskRequest.dueAt = n.getDateValue(); },
        "dueTimeZoneId": n => { createTaskRequest.dueTimeZoneId = n.getStringValue(); },
        "organizationSalesRepId": n => { createTaskRequest.organizationSalesRepId = n.getStringValue(); },
        "orgCodes": n => { createTaskRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "priority": n => { createTaskRequest.priority = n.getEnumValue<TaskPriority>(TaskPriorityObject); },
        "title": n => { createTaskRequest.title = n.getStringValue(); },
        "useOrganizationId": n => { createTaskRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateTransactionSetupRequest(createTransactionSetupRequest: Partial<CreateTransactionSetupRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applicationReturnUrl": n => { createTransactionSetupRequest.applicationReturnUrl = n.getStringValue(); },
        "customerNumber": n => { createTransactionSetupRequest.customerNumber = n.getStringValue(); },
        "isDefault": n => { createTransactionSetupRequest.isDefault = n.getBooleanValue(); },
        "marketCode": n => { createTransactionSetupRequest.marketCode = n.getStringValue(); },
        "orgCodes": n => { createTransactionSetupRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "transactionAmount": n => { createTransactionSetupRequest.transactionAmount = n.getNumberValue(); },
        "useOrganizationId": n => { createTransactionSetupRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateTransactionSetupResponse(createTransactionSetupResponse: Partial<CreateTransactionSetupResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hostedPaymentUrl": n => { createTransactionSetupResponse.hostedPaymentUrl = n.getStringValue(); },
        "transactionSetupId": n => { createTransactionSetupResponse.transactionSetupId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateUserRequest(createUserRequest: Partial<CreateUserRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { createUserRequest.email = n.getStringValue(); },
        "firstName": n => { createUserRequest.firstName = n.getStringValue(); },
        "identityOrganizationId": n => { createUserRequest.identityOrganizationId = n.getStringValue(); },
        "lastName": n => { createUserRequest.lastName = n.getStringValue(); },
        "phoneNumber": n => { createUserRequest.phoneNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateUserResponse(createUserResponse: Partial<CreateUserResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { createUserResponse.email = n.getStringValue(); },
        "firstName": n => { createUserResponse.firstName = n.getStringValue(); },
        "lastName": n => { createUserResponse.lastName = n.getStringValue(); },
        "phoneNumber": n => { createUserResponse.phoneNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateVendorRequest(createVendorRequest: Partial<CreateVendorRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoVendorFieldsRequest(createVendorRequest),
        "vendorCode": n => { createVendorRequest.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateWebsiteApiKeyResponse(createWebsiteApiKeyResponse: Partial<CreateWebsiteApiKeyResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiKey": n => { createWebsiteApiKeyResponse.apiKey = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreditCard(creditCard: Partial<CreditCard> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cardholderName": n => { creditCard.cardholderName = n.getStringValue(); },
        "cardNumber": n => { creditCard.cardNumber = n.getStringValue(); },
        "cvv": n => { creditCard.cvv = n.getStringValue(); },
        "expiryMonth": n => { creditCard.expiryMonth = n.getStringValue(); },
        "expiryYear": n => { creditCard.expiryYear = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomer(customer: Partial<Customer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(customer),
        "addresses": n => { customer.addresses = n.getCollectionOfObjectValues<Address>(createAddressFromDiscriminatorValue); },
        "companyEmail": n => { customer.companyEmail = n.getStringValue(); },
        "companyFax": n => { customer.companyFax = n.getStringValue(); },
        "companyName": n => { customer.companyName = n.getStringValue(); },
        "companyPhone": n => { customer.companyPhone = n.getStringValue(); },
        "contacts": n => { customer.contacts = n.getCollectionOfObjectValues<Contact>(createContactFromDiscriminatorValue); },
        "customerAttributes": n => { customer.customerAttributes = n.getObjectValue<Customer_customerAttributes>(createCustomer_customerAttributesFromDiscriminatorValue); },
        "customerId": n => { customer.customerId = n.getStringValue(); },
        "customerNumber": n => { customer.customerNumber = n.getStringValue(); },
        "defaultBillingAddress": n => { customer.defaultBillingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
        "defaultShippingAddress": n => { customer.defaultShippingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
        "externalId": n => { customer.externalId = n.getStringValue(); },
        "fulfillmentMethod": n => { customer.fulfillmentMethod = n.getStringValue(); },
        "organizationId": n => { customer.organizationId = n.getStringValue(); },
        "pricing": n => { customer.pricing = n.getStringValue(); },
        "repNumber": n => { customer.repNumber = n.getStringValue(); },
        "taxExempt": n => { customer.taxExempt = n.getBooleanValue(); },
        "taxExemptionNumber": n => { customer.taxExemptionNumber = n.getStringValue(); },
        "terms": n => { customer.terms = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomer_customerAttributes(customer_customerAttributes: Partial<Customer_customerAttributes> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomer2(customer2: Partial<Customer2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress": n => { customer2.billingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
        "companyEmail": n => { customer2.companyEmail = n.getStringValue(); },
        "companyFax": n => { customer2.companyFax = n.getStringValue(); },
        "companyName": n => { customer2.companyName = n.getStringValue(); },
        "companyPhone": n => { customer2.companyPhone = n.getStringValue(); },
        "customerNumber": n => { customer2.customerNumber = n.getStringValue(); },
        "shippingAddress": n => { customer2.shippingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomer3(customer3: Partial<Customer3> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress": n => { customer3.billingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
        "companyEmail": n => { customer3.companyEmail = n.getStringValue(); },
        "companyFax": n => { customer3.companyFax = n.getStringValue(); },
        "companyName": n => { customer3.companyName = n.getStringValue(); },
        "companyPhone": n => { customer3.companyPhone = n.getStringValue(); },
        "customerNumber": n => { customer3.customerNumber = n.getStringValue(); },
        "shippingAddress": n => { customer3.shippingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerAttribute(customerAttribute: Partial<CustomerAttribute> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { customerAttribute.displayName = n.getStringValue(); },
        "slug": n => { customerAttribute.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerDto(customerDto: Partial<CustomerDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress": n => { customerDto.billingAddress = n.getObjectValue<AddressDto>(createAddressDtoFromDiscriminatorValue); },
        "companyEmail": n => { customerDto.companyEmail = n.getStringValue(); },
        "companyFax": n => { customerDto.companyFax = n.getStringValue(); },
        "companyName": n => { customerDto.companyName = n.getStringValue(); },
        "companyPhone": n => { customerDto.companyPhone = n.getStringValue(); },
        "customerNumber": n => { customerDto.customerNumber = n.getStringValue(); },
        "shippingAddress": n => { customerDto.shippingAddress = n.getObjectValue<AddressDto>(createAddressDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerHealth(customerHealth: Partial<CustomerHealth> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "activeCount": n => { customerHealth.activeCount = n.getNumberValue(); },
        "asOf": n => { customerHealth.asOf = n.getDateValue(); },
        "atRiskCount": n => { customerHealth.atRiskCount = n.getNumberValue(); },
        "coolingCount": n => { customerHealth.coolingCount = n.getNumberValue(); },
        "lapsedCount": n => { customerHealth.lapsedCount = n.getNumberValue(); },
        "totalCustomers": n => { customerHealth.totalCustomers = n.getNumberValue(); },
        "worthACall": n => { customerHealth.worthACall = n.getCollectionOfObjectValues<QuietAccount>(createQuietAccountFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerInput(customerInput: Partial<CustomerInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress": n => { customerInput.billingAddress = n.getObjectValue<AddressInput>(createAddressInputFromDiscriminatorValue); },
        "companyEmail": n => { customerInput.companyEmail = n.getStringValue(); },
        "companyFax": n => { customerInput.companyFax = n.getStringValue(); },
        "companyName": n => { customerInput.companyName = n.getStringValue(); },
        "companyPhone": n => { customerInput.companyPhone = n.getStringValue(); },
        "customerNumber": n => { customerInput.customerNumber = n.getStringValue(); },
        "shippingAddress": n => { customerInput.shippingAddress = n.getObjectValue<AddressInput>(createAddressInputFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerNote(customerNote: Partial<CustomerNote> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(customerNote),
        "authorName": n => { customerNote.authorName = n.getStringValue(); },
        "body": n => { customerNote.body = n.getStringValue(); },
        "customerId": n => { customerNote.customerId = n.getStringValue(); },
        "customerNoteId": n => { customerNote.customerNoteId = n.getStringValue(); },
        "identityProviderUserId": n => { customerNote.identityProviderUserId = n.getStringValue(); },
        "organizationId": n => { customerNote.organizationId = n.getStringValue(); },
        "repNumber": n => { customerNote.repNumber = n.getStringValue(); },
        "salesRepId": n => { customerNote.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerOverrideDto(customerOverrideDto: Partial<CustomerOverrideDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { customerOverrideDto.customerNumber = n.getStringValue(); },
        "defaultRate": n => { customerOverrideDto.defaultRate = n.getNumberValue(); },
        "effectiveEndDate": n => { customerOverrideDto.effectiveEndDate = n.getDateValue(); },
        "effectiveStartDate": n => { customerOverrideDto.effectiveStartDate = n.getDateValue(); },
        "rules": n => { customerOverrideDto.rules = n.getCollectionOfObjectValues<CommissionRuleDto>(createCommissionRuleDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerRevenueRanking(customerRevenueRanking: Partial<CustomerRevenueRanking> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "averageOrderValue": n => { customerRevenueRanking.averageOrderValue = n.getNumberValue(); },
        "customerName": n => { customerRevenueRanking.customerName = n.getStringValue(); },
        "customerNumber": n => { customerRevenueRanking.customerNumber = n.getStringValue(); },
        "orderCount": n => { customerRevenueRanking.orderCount = n.getNumberValue(); },
        "totalRevenue": n => { customerRevenueRanking.totalRevenue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomersPageSummary(customersPageSummary: Partial<CustomersPageSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "asOf": n => { customersPageSummary.asOf = n.getDateValue(); },
        "atRiskAccounts": n => { customersPageSummary.atRiskAccounts = n.getCollectionOfObjectValues<QuietAccount>(createQuietAccountFromDiscriminatorValue); },
        "atRiskCount": n => { customersPageSummary.atRiskCount = n.getNumberValue(); },
        "atRiskLifetimeRevenue": n => { customersPageSummary.atRiskLifetimeRevenue = n.getNumberValue(); },
        "newLast30Days": n => { customersPageSummary.newLast30Days = n.getNumberValue(); },
        "orderedLast90Days": n => { customersPageSummary.orderedLast90Days = n.getNumberValue(); },
        "orderedSame90DaysLastYear": n => { customersPageSummary.orderedSame90DaysLastYear = n.getNumberValue(); },
        "reorderRate": n => { customersPageSummary.reorderRate = n.getNumberValue(); },
        "reorderRatePriorYear": n => { customersPageSummary.reorderRatePriorYear = n.getNumberValue(); },
        "totalCustomers": n => { customersPageSummary.totalCustomers = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerUserImportJobSummary(customerUserImportJobSummary: Partial<CustomerUserImportJobSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alreadyExisted": n => { customerUserImportJobSummary.alreadyExisted = n.getNumberValue(); },
        "created": n => { customerUserImportJobSummary.created = n.getNumberValue(); },
        "expiresAt": n => { customerUserImportJobSummary.expiresAt = n.getDateValue(); },
        "failed": n => { customerUserImportJobSummary.failed = n.getNumberValue(); },
        "isComplete": n => { customerUserImportJobSummary.isComplete = n.getBooleanValue(); },
        "processedRows": n => { customerUserImportJobSummary.processedRows = n.getNumberValue(); },
        "queuedAt": n => { customerUserImportJobSummary.queuedAt = n.getDateValue(); },
        "reportAvailable": n => { customerUserImportJobSummary.reportAvailable = n.getBooleanValue(); },
        "statusText": n => { customerUserImportJobSummary.statusText = n.getStringValue(); },
        "totalRows": n => { customerUserImportJobSummary.totalRows = n.getNumberValue(); },
        "trackingId": n => { customerUserImportJobSummary.trackingId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerVendorAccountDto(customerVendorAccountDto: Partial<CustomerVendorAccountDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { customerVendorAccountDto.active = n.getBooleanValue(); },
        "createdAt": n => { customerVendorAccountDto.createdAt = n.getDateValue(); },
        "customerId": n => { customerVendorAccountDto.customerId = n.getStringValue(); },
        "customerNumber": n => { customerVendorAccountDto.customerNumber = n.getStringValue(); },
        "customerVendorAccountId": n => { customerVendorAccountDto.customerVendorAccountId = n.getStringValue(); },
        "notes": n => { customerVendorAccountDto.notes = n.getStringValue(); },
        "organizationId": n => { customerVendorAccountDto.organizationId = n.getStringValue(); },
        "paymentMethodId": n => { customerVendorAccountDto.paymentMethodId = n.getStringValue(); },
        "priceLevelId": n => { customerVendorAccountDto.priceLevelId = n.getStringValue(); },
        "terms": n => { customerVendorAccountDto.terms = n.getStringValue(); },
        "updatedAt": n => { customerVendorAccountDto.updatedAt = n.getDateValue(); },
        "vendorAccountNumber": n => { customerVendorAccountDto.vendorAccountNumber = n.getStringValue(); },
        "vendorCode": n => { customerVendorAccountDto.vendorCode = n.getStringValue(); },
        "vendorId": n => { customerVendorAccountDto.vendorId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerVendorAccountRequest(customerVendorAccountRequest: Partial<CustomerVendorAccountRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoAgencyScopedRequest(customerVendorAccountRequest),
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDanglingAssignmentsCleanUpJobRequest(danglingAssignmentsCleanUpJobRequest: Partial<DanglingAssignmentsCleanUpJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { danglingAssignmentsCleanUpJobRequest.dryRun = n.getBooleanValue(); },
        "organizationIds": n => { danglingAssignmentsCleanUpJobRequest.organizationIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDanglingAssignmentsCleanUpJobStatusResponse(danglingAssignmentsCleanUpJobStatusResponse: Partial<DanglingAssignmentsCleanUpJobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { danglingAssignmentsCleanUpJobStatusResponse.dryRun = n.getBooleanValue(); },
        "errorMessage": n => { danglingAssignmentsCleanUpJobStatusResponse.errorMessage = n.getStringValue(); },
        "isSuccessfull": n => { danglingAssignmentsCleanUpJobStatusResponse.isSuccessfull = n.getBooleanValue(); },
        "organizations": n => { danglingAssignmentsCleanUpJobStatusResponse.organizations = n.getCollectionOfObjectValues<DanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments>(createDanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignmentsFromDiscriminatorValue); },
        "totalDanglingAssignments": n => { danglingAssignmentsCleanUpJobStatusResponse.totalDanglingAssignments = n.getNumberValue(); },
        "totalOrganizations": n => { danglingAssignmentsCleanUpJobStatusResponse.totalOrganizations = n.getNumberValue(); },
        "totalProductsAffected": n => { danglingAssignmentsCleanUpJobStatusResponse.totalProductsAffected = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments(danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments: Partial<DanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "danglingAssignments": n => { danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments.danglingAssignments = n.getNumberValue(); },
        "danglingImageIds": n => { danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments.danglingImageIds = n.getCollectionOfPrimitiveValues<string>(); },
        "organizationId": n => { danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments.organizationId = n.getStringValue(); },
        "productsAffected": n => { danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments.productsAffected = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDataExport(dataExport: Partial<DataExport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(dataExport),
        "createdBy": n => { dataExport.createdBy = n.getStringValue(); },
        "exportEntityType": n => { dataExport.exportEntityType = n.getEnumValue<ExportEntity>(ExportEntityObject); },
        "exportFileType": n => { dataExport.exportFileType = n.getEnumValue<ExportTypes>(ExportTypesObject); },
        "formatKey": n => { dataExport.formatKey = n.getStringValue(); },
        "id": n => { dataExport.id = n.getStringValue(); },
        "name": n => { dataExport.name = n.getStringValue(); },
        "organizationId": n => { dataExport.organizationId = n.getStringValue(); },
        "recordCount": n => { dataExport.recordCount = n.getNumberValue(); },
        "referenceIdentifiers": n => { dataExport.referenceIdentifiers = n.getCollectionOfPrimitiveValues<string>(); },
        "status": n => { dataExport.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDataExportResult(dataExportResult: Partial<DataExportResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { dataExportResult.createdAt = n.getDateValue(); },
        "exportEntityType": n => { dataExportResult.exportEntityType = n.getEnumValue<ExportEntity>(ExportEntityObject); },
        "exportType": n => { dataExportResult.exportType = n.getEnumValue<ExportTypes>(ExportTypesObject); },
        "filename": n => { dataExportResult.filename = n.getStringValue(); },
        "formatKey": n => { dataExportResult.formatKey = n.getStringValue(); },
        "id": n => { dataExportResult.id = n.getStringValue(); },
        "organizationId": n => { dataExportResult.organizationId = n.getStringValue(); },
        "recordsInFile": n => { dataExportResult.recordsInFile = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDataMapping(dataMapping: Partial<DataMapping> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(dataMapping),
        "description": n => { dataMapping.description = n.getStringValue(); },
        "headerMappingFields": n => { dataMapping.headerMappingFields = n.getCollectionOfObjectValues<HeaderColumnMap>(createHeaderColumnMapFromDiscriminatorValue); },
        "id": n => { dataMapping.id = n.getStringValue(); },
        "invertActiveProperty": n => { dataMapping.invertActiveProperty = n.getBooleanValue(); },
        "name": n => { dataMapping.name = n.getStringValue(); },
        "organizationId": n => { dataMapping.organizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeactivateCommissionPlanRequest(deactivateCommissionPlanRequest: Partial<DeactivateCommissionPlanRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { deactivateCommissionPlanRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { deactivateCommissionPlanRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeactivateSalesRepRequest(deactivateSalesRepRequest: Partial<DeactivateSalesRepRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "organizationSalesRepId": n => { deactivateSalesRepRequest.organizationSalesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeactivateVendorRequest(deactivateVendorRequest: Partial<DeactivateVendorRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoAgencyScopedRequest(deactivateVendorRequest),
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeclineAccessRequestRequest(declineAccessRequestRequest: Partial<DeclineAccessRequestRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "declineReason": n => { declineAccessRequestRequest.declineReason = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeclineAccessRequestResponse(declineAccessRequestResponse: Partial<DeclineAccessRequestResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessRequestId": n => { declineAccessRequestResponse.accessRequestId = n.getStringValue(); },
        "status": n => { declineAccessRequestResponse.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteAdminUserRequest(deleteAdminUserRequest: Partial<DeleteAdminUserRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "userId": n => { deleteAdminUserRequest.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteAdminUserResponse(deleteAdminUserResponse: Partial<DeleteAdminUserResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { deleteAdminUserResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteCommissionPlanRequest(deleteCommissionPlanRequest: Partial<DeleteCommissionPlanRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { deleteCommissionPlanRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { deleteCommissionPlanRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteCommissionStatementRequest(deleteCommissionStatementRequest: Partial<DeleteCommissionStatementRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { deleteCommissionStatementRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { deleteCommissionStatementRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteCustomerAttributeRequest(deleteCustomerAttributeRequest: Partial<DeleteCustomerAttributeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "attribute": n => { deleteCustomerAttributeRequest.attribute = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteCustomerNoteRequest(deleteCustomerNoteRequest: Partial<DeleteCustomerNoteRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { deleteCustomerNoteRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { deleteCustomerNoteRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteCustomerVendorAccountRequest(deleteCustomerVendorAccountRequest: Partial<DeleteCustomerVendorAccountRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoCustomerVendorAccountRequest(deleteCustomerVendorAccountRequest),
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteEmptyCategoriesResponse(deleteEmptyCategoriesResponse: Partial<DeleteEmptyCategoriesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "removed": n => { deleteEmptyCategoriesResponse.removed = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteFulfillmentMethodRequest(deleteFulfillmentMethodRequest: Partial<DeleteFulfillmentMethodRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fulfillmentMethod": n => { deleteFulfillmentMethodRequest.fulfillmentMethod = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteIntegrationResponse(deleteIntegrationResponse: Partial<DeleteIntegrationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deletedAt": n => { deleteIntegrationResponse.deletedAt = n.getDateValue(); },
        "displayName": n => { deleteIntegrationResponse.displayName = n.getStringValue(); },
        "integrationId": n => { deleteIntegrationResponse.integrationId = n.getStringValue(); },
        "message": n => { deleteIntegrationResponse.message = n.getStringValue(); },
        "organizationId": n => { deleteIntegrationResponse.organizationId = n.getStringValue(); },
        "provider": n => { deleteIntegrationResponse.provider = n.getStringValue(); },
        "success": n => { deleteIntegrationResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteInvoiceRequest(deleteInvoiceRequest: Partial<DeleteInvoiceRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { deleteInvoiceRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { deleteInvoiceRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteListRequest(deleteListRequest: Partial<DeleteListRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { deleteListRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { deleteListRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteManyImagesRequest(deleteManyImagesRequest: Partial<DeleteManyImagesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ids": n => { deleteManyImagesRequest.ids = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteMarketCodeRequest(deleteMarketCodeRequest: Partial<DeleteMarketCodeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "marketCode": n => { deleteMarketCodeRequest.marketCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteOrderStatusRequest(deleteOrderStatusRequest: Partial<DeleteOrderStatusRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderStatus": n => { deleteOrderStatusRequest.orderStatus = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteOrderTypeRequest(deleteOrderTypeRequest: Partial<DeleteOrderTypeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderType": n => { deleteOrderTypeRequest.orderType = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeletePriceTierRequest(deletePriceTierRequest: Partial<DeletePriceTierRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { deletePriceTierRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteProductAttributeRequest(deleteProductAttributeRequest: Partial<DeleteProductAttributeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "attribute": n => { deleteProductAttributeRequest.attribute = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteSalesRepRequest(deleteSalesRepRequest: Partial<DeleteSalesRepRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "organizationSalesRepId": n => { deleteSalesRepRequest.organizationSalesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteSalesRepResponse(deleteSalesRepResponse: Partial<DeleteSalesRepResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { deleteSalesRepResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteTaskRequest(deleteTaskRequest: Partial<DeleteTaskRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { deleteTaskRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { deleteTaskRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeleteTermRequest(deleteTermRequest: Partial<DeleteTermRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "term": n => { deleteTermRequest.term = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDeliveryStatus(deliveryStatus: Partial<DeliveryStatus> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "emailsBounced": n => { deliveryStatus.emailsBounced = n.getNumberValue(); },
        "emailsClicked": n => { deliveryStatus.emailsClicked = n.getNumberValue(); },
        "emailsComplained": n => { deliveryStatus.emailsComplained = n.getNumberValue(); },
        "emailsDelivered": n => { deliveryStatus.emailsDelivered = n.getNumberValue(); },
        "emailsFailed": n => { deliveryStatus.emailsFailed = n.getNumberValue(); },
        "emailsOpened": n => { deliveryStatus.emailsOpened = n.getNumberValue(); },
        "emailsSent": n => { deliveryStatus.emailsSent = n.getNumberValue(); },
        "errors": n => { deliveryStatus.errors = n.getCollectionOfPrimitiveValues<string>(); },
        "smsFailed": n => { deliveryStatus.smsFailed = n.getNumberValue(); },
        "smsSent": n => { deliveryStatus.smsSent = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDisconnectIntegrationRequest(disconnectIntegrationRequest: Partial<DisconnectIntegrationRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "disableIntegration": n => { disconnectIntegrationRequest.disableIntegration = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDisconnectIntegrationResponse(disconnectIntegrationResponse: Partial<DisconnectIntegrationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "disconnectedAt": n => { disconnectIntegrationResponse.disconnectedAt = n.getDateValue(); },
        "integrationId": n => { disconnectIntegrationResponse.integrationId = n.getStringValue(); },
        "integrationType": n => { disconnectIntegrationResponse.integrationType = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
        "provider": n => { disconnectIntegrationResponse.provider = n.getStringValue(); },
        "wasDisabled": n => { disconnectIntegrationResponse.wasDisabled = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDiscount(discount: Partial<Discount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { discount.campaignId = n.getStringValue(); },
        "code": n => { discount.code = n.getStringValue(); },
        "description": n => { discount.description = n.getStringValue(); },
        "promotionId": n => { discount.promotionId = n.getStringValue(); },
        "type": n => { discount.type = n.getEnumValue<DiscountType>(DiscountTypeObject); },
        "value": n => { discount.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDiscountCode(discountCode: Partial<DiscountCode> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(discountCode),
        "campaignId": n => { discountCode.campaignId = n.getStringValue(); },
        "code": n => { discountCode.code = n.getStringValue(); },
        "customerNumbers": n => { discountCode.customerNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "discountCodeId": n => { discountCode.discountCodeId = n.getStringValue(); },
        "maxUses": n => { discountCode.maxUses = n.getNumberValue(); },
        "maxUsesPerCustomer": n => { discountCode.maxUsesPerCustomer = n.getNumberValue(); },
        "organizationId": n => { discountCode.organizationId = n.getStringValue(); },
        "usedCount": n => { discountCode.usedCount = n.getNumberValue(); },
        "validFrom": n => { discountCode.validFrom = n.getDateValue(); },
        "validTo": n => { discountCode.validTo = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDiscountCodeOptionsInput(discountCodeOptionsInput: Partial<DiscountCodeOptionsInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumbers": n => { discountCodeOptionsInput.customerNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "maxUses": n => { discountCodeOptionsInput.maxUses = n.getNumberValue(); },
        "maxUsesPerCustomer": n => { discountCodeOptionsInput.maxUsesPerCustomer = n.getNumberValue(); },
        "validFrom": n => { discountCodeOptionsInput.validFrom = n.getDateValue(); },
        "validTo": n => { discountCodeOptionsInput.validTo = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDiscountDto(discountDto: Partial<DiscountDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { discountDto.campaignId = n.getStringValue(); },
        "code": n => { discountDto.code = n.getStringValue(); },
        "description": n => { discountDto.description = n.getStringValue(); },
        "promotionId": n => { discountDto.promotionId = n.getStringValue(); },
        "type": n => { discountDto.type = n.getStringValue(); },
        "value": n => { discountDto.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDiscountInput(discountInput: Partial<DiscountInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { discountInput.code = n.getStringValue(); },
        "description": n => { discountInput.description = n.getStringValue(); },
        "type": n => { discountInput.type = n.getStringValue(); },
        "value": n => { discountInput.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDisputeCommissionStatementRequest(disputeCommissionStatementRequest: Partial<DisputeCommissionStatementRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { disputeCommissionStatementRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "reason": n => { disputeCommissionStatementRequest.reason = n.getStringValue(); },
        "useOrganizationId": n => { disputeCommissionStatementRequest.useOrganizationId = n.getStringValue(); },
        "user": n => { disputeCommissionStatementRequest.user = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDocumentListResponse(documentListResponse: Partial<DocumentListResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "documents": n => { documentListResponse.documents = n.getCollectionOfObjectValues<CompanyDocumentDto>(createCompanyDocumentDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDocumentResponse(documentResponse: Partial<DocumentResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "document": n => { documentResponse.document = n.getObjectValue<CompanyDocumentDto>(createCompanyDocumentDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDocumentResponse2(documentResponse2: Partial<DocumentResponse2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "document": n => { documentResponse2.document = n.getObjectValue<CompanyDocumentDto>(createCompanyDocumentDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDocumentStorageStatsDto(documentStorageStatsDto: Partial<DocumentStorageStatsDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "availableSize": n => { documentStorageStatsDto.availableSize = n.getNumberValue(); },
        "maxSize": n => { documentStorageStatsDto.maxSize = n.getNumberValue(); },
        "totalFiles": n => { documentStorageStatsDto.totalFiles = n.getNumberValue(); },
        "totalSize": n => { documentStorageStatsDto.totalSize = n.getNumberValue(); },
        "usedPercentage": n => { documentStorageStatsDto.usedPercentage = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEditCustomerAttributeRequest(editCustomerAttributeRequest: Partial<EditCustomerAttributeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { editCustomerAttributeRequest.displayName = n.getStringValue(); },
        "slug": n => { editCustomerAttributeRequest.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEditOrderTypeRequest(editOrderTypeRequest: Partial<EditOrderTypeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { editOrderTypeRequest.displayName = n.getStringValue(); },
        "kind": n => { editOrderTypeRequest.kind = n.getEnumValue<OrderKind>(OrderKindObject); },
        "slug": n => { editOrderTypeRequest.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEditProductAttributeRequest(editProductAttributeRequest: Partial<EditProductAttributeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { editProductAttributeRequest.displayName = n.getStringValue(); },
        "slug": n => { editProductAttributeRequest.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEmailInvoiceRequest(emailInvoiceRequest: Partial<EmailInvoiceRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "emailAddresses": n => { emailInvoiceRequest.emailAddresses = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEmailStatsCounts(emailStatsCounts: Partial<EmailStatsCounts> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bounced": n => { emailStatsCounts.bounced = n.getNumberValue(); },
        "clicked": n => { emailStatsCounts.clicked = n.getNumberValue(); },
        "complained": n => { emailStatsCounts.complained = n.getNumberValue(); },
        "delivered": n => { emailStatsCounts.delivered = n.getNumberValue(); },
        "opened": n => { emailStatsCounts.opened = n.getNumberValue(); },
        "requests": n => { emailStatsCounts.requests = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEmailStatsDay(emailStatsDay: Partial<EmailStatsDay> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoEmailStatsCounts(emailStatsDay),
        "date": n => { emailStatsDay.date = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEnrichCustomerRequest(enrichCustomerRequest: Partial<EnrichCustomerRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "domain": n => { enrichCustomerRequest.domain = n.getStringValue(); },
        "forceRefresh": n => { enrichCustomerRequest.forceRefresh = n.getBooleanValue(); },
        "orgCodes": n => { enrichCustomerRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEnrichCustomerResponse(enrichCustomerResponse: Partial<EnrichCustomerResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { enrichCustomerResponse.address = n.getObjectValue<ResearchedAddress>(createResearchedAddressFromDiscriminatorValue); },
        "companyName": n => { enrichCustomerResponse.companyName = n.getObjectValue<ResearchedValue>(createResearchedValueFromDiscriminatorValue); },
        "confidence": n => { enrichCustomerResponse.confidence = n.getNumberValue(); },
        "domain": n => { enrichCustomerResponse.domain = n.getStringValue(); },
        "fromCache": n => { enrichCustomerResponse.fromCache = n.getBooleanValue(); },
        "industry": n => { enrichCustomerResponse.industry = n.getObjectValue<ResearchedValue>(createResearchedValueFromDiscriminatorValue); },
        "phone": n => { enrichCustomerResponse.phone = n.getObjectValue<ResearchedValue>(createResearchedValueFromDiscriminatorValue); },
        "researchedAt": n => { enrichCustomerResponse.researchedAt = n.getDateValue(); },
        "sources": n => { enrichCustomerResponse.sources = n.getCollectionOfPrimitiveValues<string>(); },
        "status": n => { enrichCustomerResponse.status = n.getStringValue(); },
        "website": n => { enrichCustomerResponse.website = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEnrichM2MResponse(enrichM2MResponse: Partial<EnrichM2MResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessScope": n => { enrichM2MResponse.accessScope = n.getStringValue(); },
        "currencyCode": n => { enrichM2MResponse.currencyCode = n.getStringValue(); },
        "customerNumber": n => { enrichM2MResponse.customerNumber = n.getStringValue(); },
        "organizationId": n => { enrichM2MResponse.organizationId = n.getStringValue(); },
        "priceTier": n => { enrichM2MResponse.priceTier = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEnrichUserAccessTokenResponse(enrichUserAccessTokenResponse: Partial<EnrichUserAccessTokenResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyCode": n => { enrichUserAccessTokenResponse.currencyCode = n.getStringValue(); },
        "customerNumber": n => { enrichUserAccessTokenResponse.customerNumber = n.getStringValue(); },
        "priceTier": n => { enrichUserAccessTokenResponse.priceTier = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEntitlementOffer(entitlementOffer: Partial<EntitlementOffer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyCode": n => { entitlementOffer.currencyCode = n.getStringValue(); },
        "description": n => { entitlementOffer.description = n.getStringValue(); },
        "lookupKey": n => { entitlementOffer.lookupKey = n.getStringValue(); },
        "name": n => { entitlementOffer.name = n.getStringValue(); },
        "period": n => { entitlementOffer.period = n.getNumberValue(); },
        "periodUnit": n => { entitlementOffer.periodUnit = n.getStringValue(); },
        "price": n => { entitlementOffer.price = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEntitlementsResponse(entitlementsResponse: Partial<EntitlementsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "entitlements": n => { entitlementsResponse.entitlements = n.getCollectionOfPrimitiveValues<string>(); },
        "entitlementsKnown": n => { entitlementsResponse.entitlementsKnown = n.getBooleanValue(); },
        "hasSubscription": n => { entitlementsResponse.hasSubscription = n.getBooleanValue(); },
        "storefrontOffer": n => { entitlementsResponse.storefrontOffer = n.getObjectValue<EntitlementOffer>(createEntitlementOfferFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEntityDetailsResponseOfImageDetail(entityDetailsResponseOfImageDetail: Partial<EntityDetailsResponseOfImageDetail> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "entity": n => { entityDetailsResponseOfImageDetail.entity = n.getObjectValue<ImageDetail>(createImageDetailFromDiscriminatorValue); },
        "links": n => { entityDetailsResponseOfImageDetail.links = n.getCollectionOfObjectValues<Link>(createLinkFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEntityDetailsResponseOfOrder(entityDetailsResponseOfOrder: Partial<EntityDetailsResponseOfOrder> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "entity": n => { entityDetailsResponseOfOrder.entity = n.getObjectValue<Order>(createOrderFromDiscriminatorValue); },
        "links": n => { entityDetailsResponseOfOrder.links = n.getCollectionOfObjectValues<Link>(createLinkFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoErrorResponse(errorResponse: Partial<ErrorResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "errors": n => { errorResponse.errors = n.getObjectValue<ErrorResponse_errors>(createErrorResponse_errorsFromDiscriminatorValue); },
        "message": n => { errorResponse.messageEscaped = n.getStringValue() ?? "One or more errors occurred!"; },
        "statusCode": n => { errorResponse.statusCode = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoErrorResponse_errors(errorResponse_errors: Partial<ErrorResponse_errors> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExistingAccessCustomerResponse(existingAccessCustomerResponse: Partial<ExistingAccessCustomerResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "companyName": n => { existingAccessCustomerResponse.companyName = n.getStringValue(); },
        "customerActive": n => { existingAccessCustomerResponse.customerActive = n.getBooleanValue(); },
        "customerNumber": n => { existingAccessCustomerResponse.customerNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExistingAccessResponse(existingAccessResponse: Partial<ExistingAccessResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customers": n => { existingAccessResponse.customers = n.getCollectionOfObjectValues<ExistingAccessCustomerResponse>(createExistingAccessCustomerResponseFromDiscriminatorValue); },
        "hasAccess": n => { existingAccessResponse.hasAccess = n.getBooleanValue(); },
        "isOrganizationMember": n => { existingAccessResponse.isOrganizationMember = n.getBooleanValue(); },
        "userExists": n => { existingAccessResponse.userExists = n.getBooleanValue(); },
        "userId": n => { existingAccessResponse.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExistsResponse(existsResponse: Partial<ExistsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "exitsInOrganization": n => { existsResponse.exitsInOrganization = n.getBooleanValue(); },
        "identityExists": n => { existsResponse.identityExists = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExportCustomersRequest(exportCustomersRequest: Partial<ExportCustomersRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "exportFileType": n => { exportCustomersRequest.exportFileType = n.getEnumValue<ExportTypes>(ExportTypesObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExportedOrderDto(exportedOrderDto: Partial<ExportedOrderDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "exportedAt": n => { exportedOrderDto.exportedAt = n.getDateValue(); },
        "exportedBy": n => { exportedOrderDto.exportedBy = n.getStringValue(); },
        "id": n => { exportedOrderDto.id = n.getStringValue(); },
        "orderNumber": n => { exportedOrderDto.orderNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExportFormatDto(exportFormatDto: Partial<ExportFormatDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customFormatKey": n => { exportFormatDto.customFormatKey = n.getStringValue(); },
        "displayName": n => { exportFormatDto.displayName = n.getStringValue(); },
        "exportFileType": n => { exportFormatDto.exportFileType = n.getEnumValue<ExportTypes>(ExportTypesObject); },
        "isCustom": n => { exportFormatDto.isCustom = n.getBooleanValue(); },
        "key": n => { exportFormatDto.key = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExportOrdersByDateRequest(exportOrdersByDateRequest: Partial<ExportOrdersByDateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "exportFileType": n => { exportOrdersByDateRequest.exportFileType = n.getEnumValue<ExportTypes>(ExportTypesObject); },
        "filters": n => { exportOrdersByDateRequest.filters = n.getCollectionOfObjectValues<QueryFilter>(createQueryFilterFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExportOrdersByIdRequest(exportOrdersByIdRequest: Partial<ExportOrdersByIdRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customFormatKey": n => { exportOrdersByIdRequest.customFormatKey = n.getStringValue(); },
        "exportFileType": n => { exportOrdersByIdRequest.exportFileType = n.getEnumValue<ExportTypes>(ExportTypesObject); },
        "orderIds": n => { exportOrdersByIdRequest.orderIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExportProductsRequest(exportProductsRequest: Partial<ExportProductsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "exportFileType": n => { exportProductsRequest.exportFileType = n.getEnumValue<ExportTypes>(ExportTypesObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoExtractBusinessCardResponse(extractBusinessCardResponse: Partial<ExtractBusinessCardResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { extractBusinessCardResponse.address = n.getObjectValue<BusinessCardAddress>(createBusinessCardAddressFromDiscriminatorValue); },
        "companyName": n => { extractBusinessCardResponse.companyName = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "emailAddress": n => { extractBusinessCardResponse.emailAddress = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "fax": n => { extractBusinessCardResponse.fax = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "firstName": n => { extractBusinessCardResponse.firstName = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "lastName": n => { extractBusinessCardResponse.lastName = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "mobilePhone": n => { extractBusinessCardResponse.mobilePhone = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "phone": n => { extractBusinessCardResponse.phone = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "rawText": n => { extractBusinessCardResponse.rawText = n.getStringValue(); },
        "title": n => { extractBusinessCardResponse.title = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
        "website": n => { extractBusinessCardResponse.website = n.getObjectValue<BusinessCardField>(createBusinessCardFieldFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFailedLine(failedLine: Partial<FailedLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "reason": n => { failedLine.reason = n.getStringValue(); },
        "vendorCode": n => { failedLine.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFailPaymentRequest(failPaymentRequest: Partial<FailPaymentRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "notes": n => { failPaymentRequest.notes = n.getStringValue(); },
        "orgCodes": n => { failPaymentRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { failPaymentRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFavoriteList(favoriteList: Partial<FavoriteList> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(favoriteList),
        "customerNumber": n => { favoriteList.customerNumber = n.getStringValue(); },
        "favoriteListId": n => { favoriteList.favoriteListId = n.getStringValue(); },
        "isDefault": n => { favoriteList.isDefault = n.getBooleanValue(); },
        "items": n => { favoriteList.items = n.getCollectionOfObjectValues<FavoriteListItem>(createFavoriteListItemFromDiscriminatorValue); },
        "name": n => { favoriteList.name = n.getStringValue(); },
        "organizationId": n => { favoriteList.organizationId = n.getStringValue(); },
        "salesRepId": n => { favoriteList.salesRepId = n.getStringValue(); },
        "source": n => { favoriteList.source = n.getStringValue(); },
        "userId": n => { favoriteList.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFavoriteListItem(favoriteListItem: Partial<FavoriteListItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(favoriteListItem),
        "favoriteListId": n => { favoriteListItem.favoriteListId = n.getStringValue(); },
        "favoriteListItemId": n => { favoriteListItem.favoriteListItemId = n.getStringValue(); },
        "productName": n => { favoriteListItem.productName = n.getStringValue(); },
        "quantity": n => { favoriteListItem.quantity = n.getNumberValue(); },
        "sku": n => { favoriteListItem.sku = n.getStringValue(); },
        "source": n => { favoriteListItem.source = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFlipbook(flipbook: Partial<Flipbook> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(flipbook),
        "flipbookId": n => { flipbook.flipbookId = n.getStringValue(); },
        "organizationId": n => { flipbook.organizationId = n.getStringValue(); },
        "pages": n => { flipbook.pages = n.getCollectionOfObjectValues<Page>(createPageFromDiscriminatorValue); },
        "pdfSourceName": n => { flipbook.pdfSourceName = n.getStringValue(); },
        "sortOrder": n => { flipbook.sortOrder = n.getNumberValue(); },
        "title": n => { flipbook.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFlipbookPagesResponse(flipbookPagesResponse: Partial<FlipbookPagesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "flipbookId": n => { flipbookPagesResponse.flipbookId = n.getStringValue(); },
        "pageCount": n => { flipbookPagesResponse.pageCount = n.getNumberValue(); },
        "pages": n => { flipbookPagesResponse.pages = n.getCollectionOfObjectValues<PageInfo>(createPageInfoFromDiscriminatorValue); },
        "title": n => { flipbookPagesResponse.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFolderListResponse(folderListResponse: Partial<FolderListResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "folders": n => { folderListResponse.folders = n.getCollectionOfObjectValues<CompanyFolderDto>(createCompanyFolderDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFolderResponse(folderResponse: Partial<FolderResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "folder": n => { folderResponse.folder = n.getObjectValue<CompanyFolderDto>(createCompanyFolderDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFolderResponse2(folderResponse2: Partial<FolderResponse2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "folder": n => { folderResponse2.folder = n.getObjectValue<CompanyFolderDto>(createCompanyFolderDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoForecastModelDto(forecastModelDto: Partial<ForecastModelDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { forecastModelDto.createdAt = n.getDateValue(); },
        "entityId": n => { forecastModelDto.entityId = n.getStringValue(); },
        "granularity": n => { forecastModelDto.granularity = n.getStringValue(); },
        "isCurrent": n => { forecastModelDto.isCurrent = n.getBooleanValue(); },
        "metrics": n => { forecastModelDto.metrics = n.getObjectValue<ModelMetrics>(createModelMetricsFromDiscriminatorValue); },
        "modelId": n => { forecastModelDto.modelId = n.getStringValue(); },
        "modelType": n => { forecastModelDto.modelType = n.getStringValue(); },
        "name": n => { forecastModelDto.name = n.getStringValue(); },
        "organizationId": n => { forecastModelDto.organizationId = n.getStringValue(); },
        "settings": n => { forecastModelDto.settings = n.getObjectValue<ForecastModelSettings>(createForecastModelSettingsFromDiscriminatorValue); },
        "trainingDataEndDate": n => { forecastModelDto.trainingDataEndDate = n.getDateValue(); },
        "trainingDataPoints": n => { forecastModelDto.trainingDataPoints = n.getNumberValue(); },
        "trainingDataStartDate": n => { forecastModelDto.trainingDataStartDate = n.getDateValue(); },
        "trainingDurationMs": n => { forecastModelDto.trainingDurationMs = n.getNumberValue(); },
        "updatedAt": n => { forecastModelDto.updatedAt = n.getDateValue(); },
        "version": n => { forecastModelDto.version = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoForecastModelSettings(forecastModelSettings: Partial<ForecastModelSettings> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ciHalfWidth": n => { forecastModelSettings.ciHalfWidth = n.getNumberValue(); },
        "ciHalfWidths": n => { forecastModelSettings.ciHalfWidths = n.getCollectionOfPrimitiveValues<number>(); },
        "confidenceLevel": n => { forecastModelSettings.confidenceLevel = n.getNumberValue(); },
        "enableRecentLevelRescaling": n => { forecastModelSettings.enableRecentLevelRescaling = n.getBooleanValue(); },
        "horizon": n => { forecastModelSettings.horizon = n.getNumberValue(); },
        "inputColumnName": n => { forecastModelSettings.inputColumnName = n.getStringValue(); },
        "minimumDataPoints": n => { forecastModelSettings.minimumDataPoints = n.getNumberValue(); },
        "outputColumnName": n => { forecastModelSettings.outputColumnName = n.getStringValue(); },
        "seasonalityWindowSize": n => { forecastModelSettings.seasonalityWindowSize = n.getNumberValue(); },
        "seasonalNaiveBlendWeight": n => { forecastModelSettings.seasonalNaiveBlendWeight = n.getNumberValue(); },
        "seasonalNaiveUnitsByMonth": n => { forecastModelSettings.seasonalNaiveUnitsByMonth = n.getCollectionOfPrimitiveValues<number>(); },
        "trainingAverageUnits": n => { forecastModelSettings.trainingAverageUnits = n.getNumberValue(); },
        "trainingWindowSize": n => { forecastModelSettings.trainingWindowSize = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFreeShippingEntitlement(freeShippingEntitlement: Partial<FreeShippingEntitlement> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { freeShippingEntitlement.campaignId = n.getStringValue(); },
        "originalAmount": n => { freeShippingEntitlement.originalAmount = n.getNumberValue(); },
        "promotionId": n => { freeShippingEntitlement.promotionId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGenerateCodesRequest(generateCodesRequest: Partial<GenerateCodesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "count": n => { generateCodesRequest.count = n.getNumberValue(); },
        "customerNumbers": n => { generateCodesRequest.customerNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "options": n => { generateCodesRequest.options = n.getObjectValue<DiscountCodeOptionsInput>(createDiscountCodeOptionsInputFromDiscriminatorValue); },
        "prefix": n => { generateCodesRequest.prefix = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGenerateCommissionStatementRequest(generateCommissionStatementRequest: Partial<GenerateCommissionStatementRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endDate": n => { generateCommissionStatementRequest.endDate = n.getDateValue(); },
        "generatedByUser": n => { generateCommissionStatementRequest.generatedByUser = n.getStringValue(); },
        "orgCodes": n => { generateCommissionStatementRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { generateCommissionStatementRequest.salesRepId = n.getStringValue(); },
        "startDate": n => { generateCommissionStatementRequest.startDate = n.getDateValue(); },
        "taxItems": n => { generateCommissionStatementRequest.taxItems = n.getCollectionOfObjectValues<GenerateCommissionStatementRequest_TaxItemInput>(createGenerateCommissionStatementRequest_TaxItemInputFromDiscriminatorValue); },
        "useOrganizationId": n => { generateCommissionStatementRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGenerateCommissionStatementRequest_TaxItemInput(generateCommissionStatementRequest_TaxItemInput: Partial<GenerateCommissionStatementRequest_TaxItemInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { generateCommissionStatementRequest_TaxItemInput.amount = n.getNumberValue(); },
        "ratePercent": n => { generateCommissionStatementRequest_TaxItemInput.ratePercent = n.getNumberValue(); },
        "taxName": n => { generateCommissionStatementRequest_TaxItemInput.taxName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetAccessRequestNotificationSettingsResponse(getAccessRequestNotificationSettingsResponse: Partial<GetAccessRequestNotificationSettingsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "effectiveNotificationEmail": n => { getAccessRequestNotificationSettingsResponse.effectiveNotificationEmail = n.getStringValue(); },
        "notificationEmail": n => { getAccessRequestNotificationSettingsResponse.notificationEmail = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetAccessRequestResponse(getAccessRequestResponse: Partial<GetAccessRequestResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessRequest": n => { getAccessRequestResponse.accessRequest = n.getObjectValue<AccessRequest>(createAccessRequestFromDiscriminatorValue); },
        "customer": n => { getAccessRequestResponse.customer = n.getObjectValue<Customer>(createCustomerFromDiscriminatorValue); },
        "existingAccess": n => { getAccessRequestResponse.existingAccess = n.getObjectValue<ExistingAccessResponse>(createExistingAccessResponseFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetActivePaymentGatewayResponse(getActivePaymentGatewayResponse: Partial<GetActivePaymentGatewayResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "provider": n => { getActivePaymentGatewayResponse.provider = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetAddressDetailsRequest(getAddressDetailsRequest: Partial<GetAddressDetailsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "placeId": n => { getAddressDetailsRequest.placeId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetAddressDetailsResponse(getAddressDetailsResponse: Partial<GetAddressDetailsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "html_attributions": n => { getAddressDetailsResponse.htmlAttributions = n.getObjectValue<UntypedNode>(createUntypedNodeFromDiscriminatorValue); },
        "result": n => { getAddressDetailsResponse.result = n.getObjectValue<Result>(createResultFromDiscriminatorValue); },
        "status": n => { getAddressDetailsResponse.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetAiUsageResponse(getAiUsageResponse: Partial<GetAiUsageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "breakdown": n => { getAiUsageResponse.breakdown = n.getCollectionOfObjectValues<AiUsageBreakdownItem>(createAiUsageBreakdownItemFromDiscriminatorValue); },
        "callCount": n => { getAiUsageResponse.callCount = n.getNumberValue(); },
        "from": n => { getAiUsageResponse.from = n.getDateValue(); },
        "to": n => { getAiUsageResponse.to = n.getDateValue(); },
        "totalCostUsd": n => { getAiUsageResponse.totalCostUsd = n.getNumberValue(); },
        "totalTokens": n => { getAiUsageResponse.totalTokens = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetApiAccessResponse(getApiAccessResponse: Partial<GetApiAccessResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiKey": n => { getApiAccessResponse.apiKey = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetAvailableIntegrationsResponse(getAvailableIntegrationsResponse: Partial<GetAvailableIntegrationsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "configuredCount": n => { getAvailableIntegrationsResponse.configuredCount = n.getNumberValue(); },
        "enabledCount": n => { getAvailableIntegrationsResponse.enabledCount = n.getNumberValue(); },
        "integrationsByType": n => { getAvailableIntegrationsResponse.integrationsByType = n.getObjectValue<GetAvailableIntegrationsResponse_integrationsByType>(createGetAvailableIntegrationsResponse_integrationsByTypeFromDiscriminatorValue); },
        "organizationId": n => { getAvailableIntegrationsResponse.organizationId = n.getStringValue(); },
        "totalAvailable": n => { getAvailableIntegrationsResponse.totalAvailable = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetAvailableIntegrationsResponse_integrationsByType(getAvailableIntegrationsResponse_integrationsByType: Partial<GetAvailableIntegrationsResponse_integrationsByType> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetBulkWriteSummaryResponse(getBulkWriteSummaryResponse: Partial<GetBulkWriteSummaryResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "days": n => { getBulkWriteSummaryResponse.days = n.getCollectionOfObjectValues<BulkWriteDailyTotal>(createBulkWriteDailyTotalFromDiscriminatorValue); },
        "from": n => { getBulkWriteSummaryResponse.from = n.getDateValue(); },
        "to": n => { getBulkWriteSummaryResponse.to = n.getDateValue(); },
        "totalCalls": n => { getBulkWriteSummaryResponse.totalCalls = n.getNumberValue(); },
        "totalDocuments": n => { getBulkWriteSummaryResponse.totalDocuments = n.getNumberValue(); },
        "totalFailedCalls": n => { getBulkWriteSummaryResponse.totalFailedCalls = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetCartPricingSettingsResponse(getCartPricingSettingsResponse: Partial<GetCartPricingSettingsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allowDecimalQuantities": n => { getCartPricingSettingsResponse.allowDecimalQuantities = n.getBooleanValue(); },
        "allowLineItemDiscounts": n => { getCartPricingSettingsResponse.allowLineItemDiscounts = n.getBooleanValue(); },
        "allowOrderDiscounts": n => { getCartPricingSettingsResponse.allowOrderDiscounts = n.getBooleanValue(); },
        "allowPriceOverride": n => { getCartPricingSettingsResponse.allowPriceOverride = n.getBooleanValue(); },
        "refreshStalePrices": n => { getCartPricingSettingsResponse.refreshStalePrices = n.getBooleanValue(); },
        "stalePriceAgeDays": n => { getCartPricingSettingsResponse.stalePriceAgeDays = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetCustomerSalesRepResponse(getCustomerSalesRepResponse: Partial<GetCustomerSalesRepResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { getCustomerSalesRepResponse.active = n.getBooleanValue(); },
        "email": n => { getCustomerSalesRepResponse.email = n.getStringValue(); },
        "name": n => { getCustomerSalesRepResponse.name = n.getStringValue(); },
        "phone": n => { getCustomerSalesRepResponse.phone = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetEmailStatsResponse(getEmailStatsResponse: Partial<GetEmailStatsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "days": n => { getEmailStatsResponse.days = n.getCollectionOfObjectValues<EmailStatsDay>(createEmailStatsDayFromDiscriminatorValue); },
        "from": n => { getEmailStatsResponse.from = n.getDateValue(); },
        "timeZone": n => { getEmailStatsResponse.timeZone = n.getStringValue(); },
        "to": n => { getEmailStatsResponse.to = n.getDateValue(); },
        "totals": n => { getEmailStatsResponse.totals = n.getObjectValue<EmailStatsCounts>(createEmailStatsCountsFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetExportDownloadUrlResponse(getExportDownloadUrlResponse: Partial<GetExportDownloadUrlResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "downloadUrl": n => { getExportDownloadUrlResponse.downloadUrl = n.getStringValue(); },
        "expirationAtUtc": n => { getExportDownloadUrlResponse.expirationAtUtc = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetFeatureFlagsResponse(getFeatureFlagsResponse: Partial<GetFeatureFlagsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "flags": n => { getFeatureFlagsResponse.flags = n.getObjectValue<GetFeatureFlagsResponse_flags>(createGetFeatureFlagsResponse_flagsFromDiscriminatorValue); },
        "organizationId": n => { getFeatureFlagsResponse.organizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetFeatureFlagsResponse_flags(getFeatureFlagsResponse_flags: Partial<GetFeatureFlagsResponse_flags> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetForecastModelResponse(getForecastModelResponse: Partial<GetForecastModelResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "model": n => { getForecastModelResponse.model = n.getObjectValue<ForecastModelDto>(createForecastModelDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetIntegrationResponse(getIntegrationResponse: Partial<GetIntegrationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "availableFields": n => { getIntegrationResponse.availableFields = n.getObjectValue<GetIntegrationResponse_availableFields>(createGetIntegrationResponse_availableFieldsFromDiscriminatorValue); },
        "configuration": n => { getIntegrationResponse.configuration = n.getObjectValue<GetIntegrationResponse_configuration>(createGetIntegrationResponse_configurationFromDiscriminatorValue); },
        "createdAt": n => { getIntegrationResponse.createdAt = n.getDateValue(); },
        "createdBy": n => { getIntegrationResponse.createdBy = n.getStringValue(); },
        "displayName": n => { getIntegrationResponse.displayName = n.getStringValue(); },
        "integrationId": n => { getIntegrationResponse.integrationId = n.getStringValue(); },
        "integrationType": n => { getIntegrationResponse.integrationType = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
        "isEnabled": n => { getIntegrationResponse.isEnabled = n.getBooleanValue(); },
        "organizationId": n => { getIntegrationResponse.organizationId = n.getStringValue(); },
        "provider": n => { getIntegrationResponse.provider = n.getStringValue(); },
        "updatedAt": n => { getIntegrationResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetIntegrationResponse_availableFields(getIntegrationResponse_availableFields: Partial<GetIntegrationResponse_availableFields> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetIntegrationResponse_configuration(getIntegrationResponse_configuration: Partial<GetIntegrationResponse_configuration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetIntegrationTemplatesByTypeResponse(getIntegrationTemplatesByTypeResponse: Partial<GetIntegrationTemplatesByTypeResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "templates": n => { getIntegrationTemplatesByTypeResponse.templates = n.getCollectionOfObjectValues<IntegrationTemplate>(createIntegrationTemplateFromDiscriminatorValue); },
        "type": n => { getIntegrationTemplatesByTypeResponse.type = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetInvoicesByIdsRequest(getInvoicesByIdsRequest: Partial<GetInvoicesByIdsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "invoiceIds": n => { getInvoicesByIdsRequest.invoiceIds = n.getCollectionOfPrimitiveValues<string>(); },
        "orgCodes": n => { getInvoicesByIdsRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { getInvoicesByIdsRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetMapsTokenResponse(getMapsTokenResponse: Partial<GetMapsTokenResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "expiresOn": n => { getMapsTokenResponse.expiresOn = n.getDateValue(); },
        "token": n => { getMapsTokenResponse.token = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetOrderExportSettingsResponse(getOrderExportSettingsResponse: Partial<GetOrderExportSettingsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "availableFormats": n => { getOrderExportSettingsResponse.availableFormats = n.getCollectionOfObjectValues<AvailableExportFormatDto>(createAvailableExportFormatDtoFromDiscriminatorValue); },
        "enabledCustomFormats": n => { getOrderExportSettingsResponse.enabledCustomFormats = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetOrderInvoiceSummaryRequest(getOrderInvoiceSummaryRequest: Partial<GetOrderInvoiceSummaryRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderedQuantitiesBySku": n => { getOrderInvoiceSummaryRequest.orderedQuantitiesBySku = n.getObjectValue<GetOrderInvoiceSummaryRequest_orderedQuantitiesBySku>(createGetOrderInvoiceSummaryRequest_orderedQuantitiesBySkuFromDiscriminatorValue); },
        "orgCodes": n => { getOrderInvoiceSummaryRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { getOrderInvoiceSummaryRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetOrderInvoiceSummaryRequest_orderedQuantitiesBySku(getOrderInvoiceSummaryRequest_orderedQuantitiesBySku: Partial<GetOrderInvoiceSummaryRequest_orderedQuantitiesBySku> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetOrderKindsResponse(getOrderKindsResponse: Partial<GetOrderKindsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "kinds": n => { getOrderKindsResponse.kinds = n.getCollectionOfObjectValues<OrderKindDto>(createOrderKindDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetOrderVolumeForecastResponse(getOrderVolumeForecastResponse: Partial<GetOrderVolumeForecastResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "forecast": n => { getOrderVolumeForecastResponse.forecast = n.getCollectionOfObjectValues<MonthlyForecastPointDto>(createMonthlyForecastPointDtoFromDiscriminatorValue); },
        "generatedAt": n => { getOrderVolumeForecastResponse.generatedAt = n.getDateValue(); },
        "modelId": n => { getOrderVolumeForecastResponse.modelId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetOrderVolumeHistoryResponse(getOrderVolumeHistoryResponse: Partial<GetOrderVolumeHistoryResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "history": n => { getOrderVolumeHistoryResponse.history = n.getCollectionOfObjectValues<OrderVolumeHistoryPointDto>(createOrderVolumeHistoryPointDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetOrganizationProfileResponse(getOrganizationProfileResponse: Partial<GetOrganizationProfileResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "callerAccess": n => { getOrganizationProfileResponse.callerAccess = n.getStringValue(); },
        "organization": n => { getOrganizationProfileResponse.organization = n.getObjectValue<OrganizationProfileDto>(createOrganizationProfileDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetOrganizationResponse(getOrganizationResponse: Partial<GetOrganizationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "entitlements": n => { getOrganizationResponse.entitlements = n.getCollectionOfObjectValues<ListOfEntitlements>(createListOfEntitlementsFromDiscriminatorValue); },
        "organization": n => { getOrganizationResponse.organization = n.getObjectValue<Organization>(createOrganizationFromDiscriminatorValue); },
        "subscriptions": n => { getOrganizationResponse.subscriptions = n.getCollectionOfObjectValues<Subscription2>(createSubscription2FromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetProductsBySkusRequest(getProductsBySkusRequest: Partial<GetProductsBySkusRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "skus": n => { getProductsBySkusRequest.skus = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetResearchSettingsResponse(getResearchSettingsResponse: Partial<GetResearchSettingsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "approvalCriteria": n => { getResearchSettingsResponse.approvalCriteria = n.getStringValue(); },
        "industryDescription": n => { getResearchSettingsResponse.industryDescription = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetSeatsResponse(getSeatsResponse: Partial<GetSeatsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "activeReps": n => { getSeatsResponse.activeReps = n.getNumberValue(); },
        "billingPeriod": n => { getSeatsResponse.billingPeriod = n.getNumberValue(); },
        "billingPeriodUnit": n => { getSeatsResponse.billingPeriodUnit = n.getStringValue(); },
        "currencyCode": n => { getSeatsResponse.currencyCode = n.getStringValue(); },
        "discounts": n => { getSeatsResponse.discounts = n.getCollectionOfObjectValues<SubscriptionDiscountLine>(createSubscriptionDiscountLineFromDiscriminatorValue); },
        "hasSeatsAvailable": n => { getSeatsResponse.hasSeatsAvailable = n.getBooleanValue(); },
        "hasSubscription": n => { getSeatsResponse.hasSubscription = n.getBooleanValue(); },
        "inTrial": n => { getSeatsResponse.inTrial = n.getBooleanValue(); },
        "maxSeats": n => { getSeatsResponse.maxSeats = n.getNumberValue(); },
        "minSeats": n => { getSeatsResponse.minSeats = n.getNumberValue(); },
        "nextBillingAt": n => { getSeatsResponse.nextBillingAt = n.getDateValue(); },
        "nonBillableEmailDomains": n => { getSeatsResponse.nonBillableEmailDomains = n.getCollectionOfPrimitiveValues<string>(); },
        "planName": n => { getSeatsResponse.planName = n.getStringValue(); },
        "plans": n => { getSeatsResponse.plans = n.getCollectionOfObjectValues<SubscriptionPlanLine>(createSubscriptionPlanLineFromDiscriminatorValue); },
        "recurringSubtotal": n => { getSeatsResponse.recurringSubtotal = n.getNumberValue(); },
        "recurringTotal": n => { getSeatsResponse.recurringTotal = n.getNumberValue(); },
        "remaining": n => { getSeatsResponse.remaining = n.getNumberValue(); },
        "seats": n => { getSeatsResponse.seats = n.getNumberValue(); },
        "seatsKnown": n => { getSeatsResponse.seatsKnown = n.getBooleanValue(); },
        "seatStep": n => { getSeatsResponse.seatStep = n.getNumberValue(); },
        "seatUnitPrice": n => { getSeatsResponse.seatUnitPrice = n.getNumberValue(); },
        "subscriptionStatus": n => { getSeatsResponse.subscriptionStatus = n.getStringValue(); },
        "trialDaysRemaining": n => { getSeatsResponse.trialDaysRemaining = n.getNumberValue(); },
        "trialEndsAt": n => { getSeatsResponse.trialEndsAt = n.getDateValue(); },
        "unavailableReason": n => { getSeatsResponse.unavailableReason = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetSkuForecastResponse(getSkuForecastResponse: Partial<GetSkuForecastResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "forecast": n => { getSkuForecastResponse.forecast = n.getCollectionOfObjectValues<MonthlyForecastPointDto>(createMonthlyForecastPointDtoFromDiscriminatorValue); },
        "generatedAt": n => { getSkuForecastResponse.generatedAt = n.getDateValue(); },
        "modelId": n => { getSkuForecastResponse.modelId = n.getStringValue(); },
        "sku": n => { getSkuForecastResponse.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetSkuHistoryResponse(getSkuHistoryResponse: Partial<GetSkuHistoryResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "history": n => { getSkuHistoryResponse.history = n.getCollectionOfObjectValues<SkuHistoryPointDto>(createSkuHistoryPointDtoFromDiscriminatorValue); },
        "sku": n => { getSkuHistoryResponse.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetTemplatesResponse(getTemplatesResponse: Partial<GetTemplatesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "templates": n => { getTemplatesResponse.templates = n.getCollectionOfObjectValues<IntegrationTemplate>(createIntegrationTemplateFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGetUserProfileResponse(getUserProfileResponse: Partial<GetUserProfileResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { getUserProfileResponse.email = n.getStringValue(); },
        "firstName": n => { getUserProfileResponse.firstName = n.getStringValue(); },
        "lastName": n => { getUserProfileResponse.lastName = n.getStringValue(); },
        "phoneNumber": n => { getUserProfileResponse.phoneNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGiftInstruction(giftInstruction: Partial<GiftInstruction> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { giftInstruction.amount = n.getNumberValue(); },
        "campaignId": n => { giftInstruction.campaignId = n.getStringValue(); },
        "product": n => { giftInstruction.product = n.getObjectValue<GiftProductSnapshot>(createGiftProductSnapshotFromDiscriminatorValue); },
        "promotionId": n => { giftInstruction.promotionId = n.getStringValue(); },
        "quantity": n => { giftInstruction.quantity = n.getNumberValue(); },
        "sku": n => { giftInstruction.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGiftMarker(giftMarker: Partial<GiftMarker> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { giftMarker.campaignId = n.getStringValue(); },
        "freeQuantity": n => { giftMarker.freeQuantity = n.getNumberValue(); },
        "promotionId": n => { giftMarker.promotionId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGiftMarkerDto(giftMarkerDto: Partial<GiftMarkerDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { giftMarkerDto.campaignId = n.getStringValue(); },
        "freeQuantity": n => { giftMarkerDto.freeQuantity = n.getNumberValue(); },
        "promotionId": n => { giftMarkerDto.promotionId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoGiftProductSnapshot(giftProductSnapshot: Partial<GiftProductSnapshot> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { giftProductSnapshot.active = n.getBooleanValue(); },
        "imageName": n => { giftProductSnapshot.imageName = n.getStringValue(); },
        "minimumOrderQuantity": n => { giftProductSnapshot.minimumOrderQuantity = n.getNumberValue(); },
        "name": n => { giftProductSnapshot.name = n.getStringValue(); },
        "quantityIncrement": n => { giftProductSnapshot.quantityIncrement = n.getNumberValue(); },
        "sku": n => { giftProductSnapshot.sku = n.getStringValue(); },
        "taxCategory": n => { giftProductSnapshot.taxCategory = n.getStringValue(); },
        "unitPrice": n => { giftProductSnapshot.unitPrice = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoHeaderColumnMap(headerColumnMap: Partial<HeaderColumnMap> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "header": n => { headerColumnMap.header = n.getStringValue(); },
        "mapping": n => { headerColumnMap.mapping = n.getObjectValue<HeaderMapping>(createHeaderMappingFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoHeaderMapping(headerMapping: Partial<HeaderMapping> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "mappedHeaderName": n => { headerMapping.mappedHeaderName = n.getStringValue(); },
        "uploadedHeaderName": n => { headerMapping.uploadedHeaderName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoHeartbeatSqlConnectorRequest(heartbeatSqlConnectorRequest: Partial<HeartbeatSqlConnectorRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "metadata": n => { heartbeatSqlConnectorRequest.metadata = n.getObjectValue<HeartbeatSqlConnectorRequest_metadata>(createHeartbeatSqlConnectorRequest_metadataFromDiscriminatorValue); },
        "status": n => { heartbeatSqlConnectorRequest.status = n.getEnumValue<ConnectorStatusType>(ConnectorStatusTypeObject); },
        "version": n => { heartbeatSqlConnectorRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoHeartbeatSqlConnectorRequest_metadata(heartbeatSqlConnectorRequest_metadata: Partial<HeartbeatSqlConnectorRequest_metadata> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoHomeEndpoint_HomeResponse(homeEndpoint_HomeResponse: Partial<HomeEndpoint_HomeResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "buildDate": n => { homeEndpoint_HomeResponse.buildDate = n.getStringValue(); },
        "contact": n => { homeEndpoint_HomeResponse.contact = n.getStringValue(); },
        "documentation": n => { homeEndpoint_HomeResponse.documentation = n.getStringValue(); },
        "message": n => { homeEndpoint_HomeResponse.message = n.getStringValue(); },
        "version": n => { homeEndpoint_HomeResponse.version = n.getStringValue(); },
        "website": n => { homeEndpoint_HomeResponse.website = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImage(image: Partial<Image> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "baseUrl": n => { image.baseUrl = n.getStringValue(); },
        "imageId": n => { image.imageId = n.getStringValue(); },
        "imageName": n => { image.imageName = n.getStringValue(); },
        "largeUrl": n => { image.largeUrl = n.getStringValue(); },
        "mediumUrl": n => { image.mediumUrl = n.getStringValue(); },
        "position": n => { image.position = n.getNumberValue(); },
        "smallUrl": n => { image.smallUrl = n.getStringValue(); },
        "uploadedAt": n => { image.uploadedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageDetail(imageDetail: Partial<ImageDetail> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { imageDetail.active = n.getBooleanValue(); },
        "baseUrl": n => { imageDetail.baseUrl = n.getStringValue(); },
        "contentSize": n => { imageDetail.contentSize = n.getNumberValue(); },
        "createdAt": n => { imageDetail.createdAt = n.getDateValue(); },
        "format": n => { imageDetail.format = n.getEnumValue<ImageFormat>(ImageFormatObject); },
        "height": n => { imageDetail.height = n.getNumberValue(); },
        "id": n => { imageDetail.id = n.getStringValue(); },
        "largeUrl": n => { imageDetail.largeUrl = n.getStringValue(); },
        "mediumUrl": n => { imageDetail.mediumUrl = n.getStringValue(); },
        "name": n => { imageDetail.name = n.getStringValue(); },
        "organizationId": n => { imageDetail.organizationId = n.getStringValue(); },
        "smallUrl": n => { imageDetail.smallUrl = n.getStringValue(); },
        "source": n => { imageDetail.source = n.getStringValue(); },
        "updatedAt": n => { imageDetail.updatedAt = n.getDateValue(); },
        "width": n => { imageDetail.width = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageHousekeepingCleanUpRequest(imageHousekeepingCleanUpRequest: Partial<ImageHousekeepingCleanUpRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "imageIds": n => { imageHousekeepingCleanUpRequest.imageIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageHousekeepingCleanUpStatusResponse(imageHousekeepingCleanUpStatusResponse: Partial<ImageHousekeepingCleanUpStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "errorMessage": n => { imageHousekeepingCleanUpStatusResponse.errorMessage = n.getStringValue(); },
        "failed": n => { imageHousekeepingCleanUpStatusResponse.failed = n.getNumberValue(); },
        "isSuccessfull": n => { imageHousekeepingCleanUpStatusResponse.isSuccessfull = n.getBooleanValue(); },
        "requested": n => { imageHousekeepingCleanUpStatusResponse.requested = n.getNumberValue(); },
        "skippedFlipbookReferenced": n => { imageHousekeepingCleanUpStatusResponse.skippedFlipbookReferenced = n.getNumberValue(); },
        "skippedNotFound": n => { imageHousekeepingCleanUpStatusResponse.skippedNotFound = n.getNumberValue(); },
        "skippedTracked": n => { imageHousekeepingCleanUpStatusResponse.skippedTracked = n.getNumberValue(); },
        "trashed": n => { imageHousekeepingCleanUpStatusResponse.trashed = n.getNumberValue(); },
        "trashedImageIds": n => { imageHousekeepingCleanUpStatusResponse.trashedImageIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageHousekeepingScanStatusResponse(imageHousekeepingScanStatusResponse: Partial<ImageHousekeepingScanStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "abandonedAssets": n => { imageHousekeepingScanStatusResponse.abandonedAssets = n.getNumberValue(); },
        "abandonedImageIds": n => { imageHousekeepingScanStatusResponse.abandonedImageIds = n.getCollectionOfPrimitiveValues<string>(); },
        "errorMessage": n => { imageHousekeepingScanStatusResponse.errorMessage = n.getStringValue(); },
        "flipbookReferencedAssets": n => { imageHousekeepingScanStatusResponse.flipbookReferencedAssets = n.getNumberValue(); },
        "isSuccessfull": n => { imageHousekeepingScanStatusResponse.isSuccessfull = n.getBooleanValue(); },
        "totalAssets": n => { imageHousekeepingScanStatusResponse.totalAssets = n.getNumberValue(); },
        "trackedAssets": n => { imageHousekeepingScanStatusResponse.trackedAssets = n.getNumberValue(); },
        "trashedAssets": n => { imageHousekeepingScanStatusResponse.trashedAssets = n.getCollectionOfObjectValues<ImageHousekeepingScanStatusResponse_TrashedAsset>(createImageHousekeepingScanStatusResponse_TrashedAssetFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageHousekeepingScanStatusResponse_TrashedAsset(imageHousekeepingScanStatusResponse_TrashedAsset: Partial<ImageHousekeepingScanStatusResponse_TrashedAsset> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "imageId": n => { imageHousekeepingScanStatusResponse_TrashedAsset.imageId = n.getStringValue(); },
        "source": n => { imageHousekeepingScanStatusResponse_TrashedAsset.source = n.getStringValue(); },
        "trashedAt": n => { imageHousekeepingScanStatusResponse_TrashedAsset.trashedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImagesCleanUpJobStatusResponse(imagesCleanUpJobStatusResponse: Partial<ImagesCleanUpJobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "errorMessage": n => { imagesCleanUpJobStatusResponse.errorMessage = n.getStringValue(); },
        "isSuccessfull": n => { imagesCleanUpJobStatusResponse.isSuccessfull = n.getBooleanValue(); },
        "totalImagesCleaned": n => { imagesCleanUpJobStatusResponse.totalImagesCleaned = n.getNumberValue(); },
        "totalOrganizations": n => { imagesCleanUpJobStatusResponse.totalOrganizations = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageTrashPurgeJobRequest(imageTrashPurgeJobRequest: Partial<ImageTrashPurgeJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { imageTrashPurgeJobRequest.dryRun = n.getBooleanValue(); },
        "olderThanDays": n => { imageTrashPurgeJobRequest.olderThanDays = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageTrashPurgeJobStatusResponse(imageTrashPurgeJobStatusResponse: Partial<ImageTrashPurgeJobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { imageTrashPurgeJobStatusResponse.dryRun = n.getBooleanValue(); },
        "errorMessage": n => { imageTrashPurgeJobStatusResponse.errorMessage = n.getStringValue(); },
        "expiredImageIds": n => { imageTrashPurgeJobStatusResponse.expiredImageIds = n.getCollectionOfPrimitiveValues<string>(); },
        "isSuccessfull": n => { imageTrashPurgeJobStatusResponse.isSuccessfull = n.getBooleanValue(); },
        "retentionDays": n => { imageTrashPurgeJobStatusResponse.retentionDays = n.getNumberValue(); },
        "totalExpired": n => { imageTrashPurgeJobStatusResponse.totalExpired = n.getNumberValue(); },
        "totalPurged": n => { imageTrashPurgeJobStatusResponse.totalPurged = n.getNumberValue(); },
        "totalTrashed": n => { imageTrashPurgeJobStatusResponse.totalTrashed = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageUploadItem(imageUploadItem: Partial<ImageUploadItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "extractSkuFromImageName": n => { imageUploadItem.extractSkuFromImageName = n.getBooleanValue(); },
        "imageName": n => { imageUploadItem.imageName = n.getStringValue(); },
        "imageUrl": n => { imageUploadItem.imageUrl = n.getStringValue(); },
        "productSku": n => { imageUploadItem.productSku = n.getStringValue(); },
        "vendorCode": n => { imageUploadItem.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageUploadResponse(imageUploadResponse: Partial<ImageUploadResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "assignedTo": n => { imageUploadResponse.assignedTo = n.getStringValue(); },
        "assignedToKey": n => { imageUploadResponse.assignedToKey = n.getStringValue(); },
        "imageName": n => { imageUploadResponse.imageName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImportColumnSample(importColumnSample: Partial<ImportColumnSample> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "header": n => { importColumnSample.header = n.getStringValue(); },
        "samples": n => { importColumnSample.samples = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIntegrationOAuthCallbackResponse(integrationOAuthCallbackResponse: Partial<IntegrationOAuthCallbackResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "integrationId": n => { integrationOAuthCallbackResponse.integrationId = n.getStringValue(); },
        "message": n => { integrationOAuthCallbackResponse.message = n.getStringValue(); },
        "success": n => { integrationOAuthCallbackResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIntegrationSummary(integrationSummary: Partial<IntegrationSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "configuration": n => { integrationSummary.configuration = n.getObjectValue<IntegrationSummary_configuration>(createIntegrationSummary_configurationFromDiscriminatorValue); },
        "createdAt": n => { integrationSummary.createdAt = n.getDateValue(); },
        "displayName": n => { integrationSummary.displayName = n.getStringValue(); },
        "id": n => { integrationSummary.id = n.getStringValue(); },
        "integrationType": n => { integrationSummary.integrationType = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
        "isEnabled": n => { integrationSummary.isEnabled = n.getBooleanValue(); },
        "lastTestedAt": n => { integrationSummary.lastTestedAt = n.getDateValue(); },
        "organizationId": n => { integrationSummary.organizationId = n.getStringValue(); },
        "provider": n => { integrationSummary.provider = n.getStringValue(); },
        "testStatus": n => { integrationSummary.testStatus = n.getEnumValue<IntegrationTestStatus>(IntegrationTestStatusObject); },
        "updatedAt": n => { integrationSummary.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIntegrationSummary_configuration(integrationSummary_configuration: Partial<IntegrationSummary_configuration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIntegrationTemplate(integrationTemplate: Partial<IntegrationTemplate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "callbackUrl": n => { integrationTemplate.callbackUrl = n.getStringValue(); },
        "configurationFields": n => { integrationTemplate.configurationFields = n.getCollectionOfObjectValues<ConfigurationField>(createConfigurationFieldFromDiscriminatorValue); },
        "description": n => { integrationTemplate.description = n.getStringValue(); },
        "displayName": n => { integrationTemplate.displayName = n.getStringValue(); },
        "documentationUrl": n => { integrationTemplate.documentationUrl = n.getStringValue(); },
        "logoUrl": n => { integrationTemplate.logoUrl = n.getStringValue(); },
        "provider": n => { integrationTemplate.provider = n.getStringValue(); },
        "requiresOAuth": n => { integrationTemplate.requiresOAuth = n.getBooleanValue(); },
        "secretFields": n => { integrationTemplate.secretFields = n.getCollectionOfObjectValues<SecretField>(createSecretFieldFromDiscriminatorValue); },
        "supportedFeatures": n => { integrationTemplate.supportedFeatures = n.getCollectionOfPrimitiveValues<string>(); },
        "type": n => { integrationTemplate.type = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInternalErrorResponse(internalErrorResponse: Partial<InternalErrorResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { internalErrorResponse.code = n.getNumberValue(); },
        "note": n => { internalErrorResponse.note = n.getStringValue() ?? "See application log for stack trace."; },
        "reason": n => { internalErrorResponse.reason = n.getStringValue() ?? "Something unexpected has happened"; },
        "status": n => { internalErrorResponse.status = n.getStringValue() ?? "Internal Server Error!"; },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoice(invoice: Partial<Invoice> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(invoice),
        "amountPaid": n => { invoice.amountPaid = n.getNumberValue(); },
        "amountPaidFormatted": n => { invoice.amountPaidFormatted = n.getStringValue(); },
        "balance": n => { invoice.balance = n.getNumberValue(); },
        "balanceFormatted": n => { invoice.balanceFormatted = n.getStringValue(); },
        "currencyCode": n => { invoice.currencyCode = n.getStringValue(); },
        "customer": n => { invoice.customer = n.getObjectValue<Customer3>(createCustomer3FromDiscriminatorValue); },
        "discount": n => { invoice.discount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "discountAmount": n => { invoice.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { invoice.discountAmountFormatted = n.getStringValue(); },
        "dueDate": n => { invoice.dueDate = n.getDateValue(); },
        "externalId": n => { invoice.externalId = n.getStringValue(); },
        "fulfillmentCenter": n => { invoice.fulfillmentCenter = n.getStringValue(); },
        "fulfillmentMethod": n => { invoice.fulfillmentMethod = n.getStringValue(); },
        "id": n => { invoice.id = n.getStringValue(); },
        "importedBalance": n => { invoice.importedBalance = n.getNumberValue(); },
        "importedInvoiceTotal": n => { invoice.importedInvoiceTotal = n.getNumberValue(); },
        "invoiceDate": n => { invoice.invoiceDate = n.getDateValue(); },
        "invoiceNumber": n => { invoice.invoiceNumber = n.getStringValue(); },
        "invoiceTotal": n => { invoice.invoiceTotal = n.getNumberValue(); },
        "invoiceTotalFormatted": n => { invoice.invoiceTotalFormatted = n.getStringValue(); },
        "items": n => { invoice.items = n.getCollectionOfObjectValues<InvoiceItem>(createInvoiceItemFromDiscriminatorValue); },
        "notes": n => { invoice.notes = n.getStringValue(); },
        "numberOfPackages": n => { invoice.numberOfPackages = n.getNumberValue(); },
        "orderId": n => { invoice.orderId = n.getStringValue(); },
        "orderNumber": n => { invoice.orderNumber = n.getStringValue(); },
        "organizationId": n => { invoice.organizationId = n.getStringValue(); },
        "payments": n => { invoice.payments = n.getCollectionOfObjectValues<Payment>(createPaymentFromDiscriminatorValue); },
        "poNumber": n => { invoice.poNumber = n.getStringValue(); },
        "primaryRepNumber": n => { invoice.primaryRepNumber = n.getStringValue(); },
        "primarySalesRep": n => { invoice.primarySalesRep = n.getObjectValue<SalesRep2>(createSalesRep2FromDiscriminatorValue); },
        "shipping": n => { invoice.shipping = n.getNumberValue(); },
        "shippingDetails": n => { invoice.shippingDetails = n.getObjectValue<ShippingDetails>(createShippingDetailsFromDiscriminatorValue); },
        "shippingFormatted": n => { invoice.shippingFormatted = n.getStringValue(); },
        "status": n => { invoice.status = n.getEnumValue<InvoiceStatus>(InvoiceStatusObject); },
        "subtotal": n => { invoice.subtotal = n.getNumberValue(); },
        "subtotalFormatted": n => { invoice.subtotalFormatted = n.getStringValue(); },
        "tax": n => { invoice.tax = n.getNumberValue(); },
        "taxFormatted": n => { invoice.taxFormatted = n.getStringValue(); },
        "taxItems": n => { invoice.taxItems = n.getCollectionOfObjectValues<TaxLineItem>(createTaxLineItemFromDiscriminatorValue); },
        "terms": n => { invoice.terms = n.getStringValue(); },
        "trackingNumber": n => { invoice.trackingNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceAddressDto(invoiceAddressDto: Partial<InvoiceAddressDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { invoiceAddressDto.address1 = n.getStringValue(); },
        "address2": n => { invoiceAddressDto.address2 = n.getStringValue(); },
        "addressType": n => { invoiceAddressDto.addressType = n.getStringValue(); },
        "city": n => { invoiceAddressDto.city = n.getStringValue(); },
        "code": n => { invoiceAddressDto.code = n.getStringValue(); },
        "country": n => { invoiceAddressDto.country = n.getStringValue(); },
        "default": n => { invoiceAddressDto.defaultEscaped = n.getBooleanValue(); },
        "externalId": n => { invoiceAddressDto.externalId = n.getStringValue(); },
        "latitude": n => { invoiceAddressDto.latitude = n.getNumberValue(); },
        "longitude": n => { invoiceAddressDto.longitude = n.getNumberValue(); },
        "stateProvince": n => { invoiceAddressDto.stateProvince = n.getStringValue(); },
        "zipPostalCode": n => { invoiceAddressDto.zipPostalCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceCustomerDto(invoiceCustomerDto: Partial<InvoiceCustomerDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress": n => { invoiceCustomerDto.billingAddress = n.getObjectValue<InvoiceAddressDto>(createInvoiceAddressDtoFromDiscriminatorValue); },
        "companyEmail": n => { invoiceCustomerDto.companyEmail = n.getStringValue(); },
        "companyFax": n => { invoiceCustomerDto.companyFax = n.getStringValue(); },
        "companyName": n => { invoiceCustomerDto.companyName = n.getStringValue(); },
        "companyPhone": n => { invoiceCustomerDto.companyPhone = n.getStringValue(); },
        "customerNumber": n => { invoiceCustomerDto.customerNumber = n.getStringValue(); },
        "shippingAddress": n => { invoiceCustomerDto.shippingAddress = n.getObjectValue<InvoiceAddressDto>(createInvoiceAddressDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceDiscountDto(invoiceDiscountDto: Partial<InvoiceDiscountDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { invoiceDiscountDto.code = n.getStringValue(); },
        "description": n => { invoiceDiscountDto.description = n.getStringValue(); },
        "type": n => { invoiceDiscountDto.type = n.getStringValue(); },
        "value": n => { invoiceDiscountDto.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceDto(invoiceDto: Partial<InvoiceDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { invoiceDto.active = n.getBooleanValue(); },
        "amountPaid": n => { invoiceDto.amountPaid = n.getNumberValue(); },
        "amountPaidFormatted": n => { invoiceDto.amountPaidFormatted = n.getStringValue(); },
        "balance": n => { invoiceDto.balance = n.getNumberValue(); },
        "balanceFormatted": n => { invoiceDto.balanceFormatted = n.getStringValue(); },
        "createdAt": n => { invoiceDto.createdAt = n.getDateValue(); },
        "currencyCode": n => { invoiceDto.currencyCode = n.getStringValue(); },
        "customer": n => { invoiceDto.customer = n.getObjectValue<InvoiceCustomerDto>(createInvoiceCustomerDtoFromDiscriminatorValue); },
        "discount": n => { invoiceDto.discount = n.getObjectValue<InvoiceDiscountDto>(createInvoiceDiscountDtoFromDiscriminatorValue); },
        "discountAmount": n => { invoiceDto.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { invoiceDto.discountAmountFormatted = n.getStringValue(); },
        "dueDate": n => { invoiceDto.dueDate = n.getDateValue(); },
        "externalId": n => { invoiceDto.externalId = n.getStringValue(); },
        "fulfillmentCenter": n => { invoiceDto.fulfillmentCenter = n.getStringValue(); },
        "fulfillmentMethod": n => { invoiceDto.fulfillmentMethod = n.getStringValue(); },
        "id": n => { invoiceDto.id = n.getStringValue(); },
        "importedBalance": n => { invoiceDto.importedBalance = n.getNumberValue(); },
        "importedInvoiceTotal": n => { invoiceDto.importedInvoiceTotal = n.getNumberValue(); },
        "invoiceDate": n => { invoiceDto.invoiceDate = n.getDateValue(); },
        "invoiceNumber": n => { invoiceDto.invoiceNumber = n.getStringValue(); },
        "invoiceTotal": n => { invoiceDto.invoiceTotal = n.getNumberValue(); },
        "invoiceTotalFormatted": n => { invoiceDto.invoiceTotalFormatted = n.getStringValue(); },
        "items": n => { invoiceDto.items = n.getCollectionOfObjectValues<InvoiceItemDto>(createInvoiceItemDtoFromDiscriminatorValue); },
        "notes": n => { invoiceDto.notes = n.getStringValue(); },
        "numberOfPackages": n => { invoiceDto.numberOfPackages = n.getNumberValue(); },
        "orderId": n => { invoiceDto.orderId = n.getStringValue(); },
        "orderNumber": n => { invoiceDto.orderNumber = n.getStringValue(); },
        "organizationId": n => { invoiceDto.organizationId = n.getStringValue(); },
        "payments": n => { invoiceDto.payments = n.getCollectionOfObjectValues<PaymentDto>(createPaymentDtoFromDiscriminatorValue); },
        "poNumber": n => { invoiceDto.poNumber = n.getStringValue(); },
        "primarySalesRep": n => { invoiceDto.primarySalesRep = n.getObjectValue<InvoiceSalesRepDto>(createInvoiceSalesRepDtoFromDiscriminatorValue); },
        "shipping": n => { invoiceDto.shipping = n.getNumberValue(); },
        "shippingDetails": n => { invoiceDto.shippingDetails = n.getObjectValue<InvoiceShippingDetailsDto>(createInvoiceShippingDetailsDtoFromDiscriminatorValue); },
        "shippingFormatted": n => { invoiceDto.shippingFormatted = n.getStringValue(); },
        "status": n => { invoiceDto.status = n.getStringValue(); },
        "subtotal": n => { invoiceDto.subtotal = n.getNumberValue(); },
        "subtotalFormatted": n => { invoiceDto.subtotalFormatted = n.getStringValue(); },
        "tax": n => { invoiceDto.tax = n.getNumberValue(); },
        "taxFormatted": n => { invoiceDto.taxFormatted = n.getStringValue(); },
        "terms": n => { invoiceDto.terms = n.getStringValue(); },
        "trackingNumber": n => { invoiceDto.trackingNumber = n.getStringValue(); },
        "updatedAt": n => { invoiceDto.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceItem(invoiceItem: Partial<InvoiceItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "description": n => { invoiceItem.description = n.getStringValue(); },
        "discount": n => { invoiceItem.discount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "discountAmount": n => { invoiceItem.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { invoiceItem.discountAmountFormatted = n.getStringValue(); },
        "externalId": n => { invoiceItem.externalId = n.getStringValue(); },
        "imageName": n => { invoiceItem.imageName = n.getStringValue(); },
        "lineNumber": n => { invoiceItem.lineNumber = n.getNumberValue(); },
        "orderItemSku": n => { invoiceItem.orderItemSku = n.getStringValue(); },
        "price": n => { invoiceItem.price = n.getNumberValue(); },
        "priceFormatted": n => { invoiceItem.priceFormatted = n.getStringValue(); },
        "productName": n => { invoiceItem.productName = n.getStringValue(); },
        "qtyBackordered": n => { invoiceItem.qtyBackordered = n.getNumberValue(); },
        "quantity": n => { invoiceItem.quantity = n.getNumberValue(); },
        "sku": n => { invoiceItem.sku = n.getStringValue(); },
        "subTotal": n => { invoiceItem.subTotal = n.getNumberValue(); },
        "subTotalFormatted": n => { invoiceItem.subTotalFormatted = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceItemDto(invoiceItemDto: Partial<InvoiceItemDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "description": n => { invoiceItemDto.description = n.getStringValue(); },
        "discount": n => { invoiceItemDto.discount = n.getObjectValue<InvoiceDiscountDto>(createInvoiceDiscountDtoFromDiscriminatorValue); },
        "discountAmount": n => { invoiceItemDto.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { invoiceItemDto.discountAmountFormatted = n.getStringValue(); },
        "externalId": n => { invoiceItemDto.externalId = n.getStringValue(); },
        "imageName": n => { invoiceItemDto.imageName = n.getStringValue(); },
        "lineNumber": n => { invoiceItemDto.lineNumber = n.getNumberValue(); },
        "orderItemSku": n => { invoiceItemDto.orderItemSku = n.getStringValue(); },
        "price": n => { invoiceItemDto.price = n.getNumberValue(); },
        "priceFormatted": n => { invoiceItemDto.priceFormatted = n.getStringValue(); },
        "productName": n => { invoiceItemDto.productName = n.getStringValue(); },
        "qtyBackordered": n => { invoiceItemDto.qtyBackordered = n.getNumberValue(); },
        "quantity": n => { invoiceItemDto.quantity = n.getNumberValue(); },
        "sku": n => { invoiceItemDto.sku = n.getStringValue(); },
        "subTotal": n => { invoiceItemDto.subTotal = n.getNumberValue(); },
        "subTotalFormatted": n => { invoiceItemDto.subTotalFormatted = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceItemInput(invoiceItemInput: Partial<InvoiceItemInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "description": n => { invoiceItemInput.description = n.getStringValue(); },
        "discount": n => { invoiceItemInput.discount = n.getObjectValue<DiscountInput>(createDiscountInputFromDiscriminatorValue); },
        "imageName": n => { invoiceItemInput.imageName = n.getStringValue(); },
        "lineNumber": n => { invoiceItemInput.lineNumber = n.getNumberValue(); },
        "orderItemSku": n => { invoiceItemInput.orderItemSku = n.getStringValue(); },
        "price": n => { invoiceItemInput.price = n.getNumberValue(); },
        "priceFormatted": n => { invoiceItemInput.priceFormatted = n.getStringValue(); },
        "productName": n => { invoiceItemInput.productName = n.getStringValue(); },
        "qtyBackordered": n => { invoiceItemInput.qtyBackordered = n.getNumberValue(); },
        "quantity": n => { invoiceItemInput.quantity = n.getNumberValue(); },
        "sku": n => { invoiceItemInput.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceSalesRepDto(invoiceSalesRepDto: Partial<InvoiceSalesRepDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { invoiceSalesRepDto.email = n.getStringValue(); },
        "firstName": n => { invoiceSalesRepDto.firstName = n.getStringValue(); },
        "fullName": n => { invoiceSalesRepDto.fullName = n.getStringValue(); },
        "lastName": n => { invoiceSalesRepDto.lastName = n.getStringValue(); },
        "organizationSalesRepId": n => { invoiceSalesRepDto.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { invoiceSalesRepDto.phoneNumber = n.getStringValue(); },
        "repNumber": n => { invoiceSalesRepDto.repNumber = n.getStringValue(); },
        "salesRepId": n => { invoiceSalesRepDto.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceShippingDetailsDto(invoiceShippingDetailsDto: Partial<InvoiceShippingDetailsDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "method": n => { invoiceShippingDetailsDto.method = n.getStringValue(); },
        "total": n => { invoiceShippingDetailsDto.total = n.getNumberValue(); },
        "totalFormatted": n => { invoiceShippingDetailsDto.totalFormatted = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoicesPageSummary(invoicesPageSummary: Partial<InvoicesPageSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "asOf": n => { invoicesPageSummary.asOf = n.getDateValue(); },
        "averageDaysToPay": n => { invoicesPageSummary.averageDaysToPay = n.getNumberValue(); },
        "averageTermsDays": n => { invoicesPageSummary.averageTermsDays = n.getNumberValue(); },
        "collectedLast30Days": n => { invoicesPageSummary.collectedLast30Days = n.getNumberValue(); },
        "collectedPrior30Days": n => { invoicesPageSummary.collectedPrior30Days = n.getNumberValue(); },
        "currentBalance": n => { invoicesPageSummary.currentBalance = n.getNumberValue(); },
        "oldestOverdueDays": n => { invoicesPageSummary.oldestOverdueDays = n.getNumberValue(); },
        "outstandingBalance": n => { invoicesPageSummary.outstandingBalance = n.getNumberValue(); },
        "overdueBalance": n => { invoicesPageSummary.overdueBalance = n.getNumberValue(); },
        "overdueCount": n => { invoicesPageSummary.overdueCount = n.getNumberValue(); },
        "paidInvoicesMeasured": n => { invoicesPageSummary.paidInvoicesMeasured = n.getNumberValue(); },
        "pastDue1To30": n => { invoicesPageSummary.pastDue1To30 = n.getNumberValue(); },
        "pastDue31To60": n => { invoicesPageSummary.pastDue31To60 = n.getNumberValue(); },
        "pastDueOver60": n => { invoicesPageSummary.pastDueOver60 = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIssueInvoiceRequest(issueInvoiceRequest: Partial<IssueInvoiceRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { issueInvoiceRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { issueInvoiceRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobAcceptedResponse(jobAcceptedResponse: Partial<JobAcceptedResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "statusUri": n => { jobAcceptedResponse.statusUri = n.getStringValue(); },
        "trackingId": n => { jobAcceptedResponse.trackingId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobResultOfAbandonedImageAssetsJobStatusResponse(jobResultOfAbandonedImageAssetsJobStatusResponse: Partial<JobResultOfAbandonedImageAssetsJobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentStatus": n => { jobResultOfAbandonedImageAssetsJobStatusResponse.currentStatus = n.getStringValue(); },
        "currentStep": n => { jobResultOfAbandonedImageAssetsJobStatusResponse.currentStep = n.getNumberValue(); },
        "isComplete": n => { jobResultOfAbandonedImageAssetsJobStatusResponse.isComplete = n.getBooleanValue(); },
        "progressPercentage": n => { jobResultOfAbandonedImageAssetsJobStatusResponse.progressPercentage = n.getNumberValue(); },
        "result": n => { jobResultOfAbandonedImageAssetsJobStatusResponse.result = n.getObjectValue<AbandonedImageAssetsJobStatusResponse>(createAbandonedImageAssetsJobStatusResponseFromDiscriminatorValue); },
        "totalSteps": n => { jobResultOfAbandonedImageAssetsJobStatusResponse.totalSteps = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobResultOfBulkImportCustomerUsersResponse(jobResultOfBulkImportCustomerUsersResponse: Partial<JobResultOfBulkImportCustomerUsersResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentStatus": n => { jobResultOfBulkImportCustomerUsersResponse.currentStatus = n.getStringValue(); },
        "currentStep": n => { jobResultOfBulkImportCustomerUsersResponse.currentStep = n.getNumberValue(); },
        "isComplete": n => { jobResultOfBulkImportCustomerUsersResponse.isComplete = n.getBooleanValue(); },
        "progressPercentage": n => { jobResultOfBulkImportCustomerUsersResponse.progressPercentage = n.getNumberValue(); },
        "result": n => { jobResultOfBulkImportCustomerUsersResponse.result = n.getObjectValue<BulkImportCustomerUsersResponse>(createBulkImportCustomerUsersResponseFromDiscriminatorValue); },
        "totalSteps": n => { jobResultOfBulkImportCustomerUsersResponse.totalSteps = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobResultOfDanglingAssignmentsCleanUpJobStatusResponse(jobResultOfDanglingAssignmentsCleanUpJobStatusResponse: Partial<JobResultOfDanglingAssignmentsCleanUpJobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentStatus": n => { jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.currentStatus = n.getStringValue(); },
        "currentStep": n => { jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.currentStep = n.getNumberValue(); },
        "isComplete": n => { jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.isComplete = n.getBooleanValue(); },
        "progressPercentage": n => { jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.progressPercentage = n.getNumberValue(); },
        "result": n => { jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.result = n.getObjectValue<DanglingAssignmentsCleanUpJobStatusResponse>(createDanglingAssignmentsCleanUpJobStatusResponseFromDiscriminatorValue); },
        "totalSteps": n => { jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.totalSteps = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobResultOfImageHousekeepingCleanUpStatusResponse(jobResultOfImageHousekeepingCleanUpStatusResponse: Partial<JobResultOfImageHousekeepingCleanUpStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentStatus": n => { jobResultOfImageHousekeepingCleanUpStatusResponse.currentStatus = n.getStringValue(); },
        "currentStep": n => { jobResultOfImageHousekeepingCleanUpStatusResponse.currentStep = n.getNumberValue(); },
        "isComplete": n => { jobResultOfImageHousekeepingCleanUpStatusResponse.isComplete = n.getBooleanValue(); },
        "progressPercentage": n => { jobResultOfImageHousekeepingCleanUpStatusResponse.progressPercentage = n.getNumberValue(); },
        "result": n => { jobResultOfImageHousekeepingCleanUpStatusResponse.result = n.getObjectValue<ImageHousekeepingCleanUpStatusResponse>(createImageHousekeepingCleanUpStatusResponseFromDiscriminatorValue); },
        "totalSteps": n => { jobResultOfImageHousekeepingCleanUpStatusResponse.totalSteps = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobResultOfImageHousekeepingScanStatusResponse(jobResultOfImageHousekeepingScanStatusResponse: Partial<JobResultOfImageHousekeepingScanStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentStatus": n => { jobResultOfImageHousekeepingScanStatusResponse.currentStatus = n.getStringValue(); },
        "currentStep": n => { jobResultOfImageHousekeepingScanStatusResponse.currentStep = n.getNumberValue(); },
        "isComplete": n => { jobResultOfImageHousekeepingScanStatusResponse.isComplete = n.getBooleanValue(); },
        "progressPercentage": n => { jobResultOfImageHousekeepingScanStatusResponse.progressPercentage = n.getNumberValue(); },
        "result": n => { jobResultOfImageHousekeepingScanStatusResponse.result = n.getObjectValue<ImageHousekeepingScanStatusResponse>(createImageHousekeepingScanStatusResponseFromDiscriminatorValue); },
        "totalSteps": n => { jobResultOfImageHousekeepingScanStatusResponse.totalSteps = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobResultOfImagesCleanUpJobStatusResponse(jobResultOfImagesCleanUpJobStatusResponse: Partial<JobResultOfImagesCleanUpJobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentStatus": n => { jobResultOfImagesCleanUpJobStatusResponse.currentStatus = n.getStringValue(); },
        "currentStep": n => { jobResultOfImagesCleanUpJobStatusResponse.currentStep = n.getNumberValue(); },
        "isComplete": n => { jobResultOfImagesCleanUpJobStatusResponse.isComplete = n.getBooleanValue(); },
        "progressPercentage": n => { jobResultOfImagesCleanUpJobStatusResponse.progressPercentage = n.getNumberValue(); },
        "result": n => { jobResultOfImagesCleanUpJobStatusResponse.result = n.getObjectValue<ImagesCleanUpJobStatusResponse>(createImagesCleanUpJobStatusResponseFromDiscriminatorValue); },
        "totalSteps": n => { jobResultOfImagesCleanUpJobStatusResponse.totalSteps = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobResultOfImageTrashPurgeJobStatusResponse(jobResultOfImageTrashPurgeJobStatusResponse: Partial<JobResultOfImageTrashPurgeJobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentStatus": n => { jobResultOfImageTrashPurgeJobStatusResponse.currentStatus = n.getStringValue(); },
        "currentStep": n => { jobResultOfImageTrashPurgeJobStatusResponse.currentStep = n.getNumberValue(); },
        "isComplete": n => { jobResultOfImageTrashPurgeJobStatusResponse.isComplete = n.getBooleanValue(); },
        "progressPercentage": n => { jobResultOfImageTrashPurgeJobStatusResponse.progressPercentage = n.getNumberValue(); },
        "result": n => { jobResultOfImageTrashPurgeJobStatusResponse.result = n.getObjectValue<ImageTrashPurgeJobStatusResponse>(createImageTrashPurgeJobStatusResponseFromDiscriminatorValue); },
        "totalSteps": n => { jobResultOfImageTrashPurgeJobStatusResponse.totalSteps = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLineDiscountInstruction(lineDiscountInstruction: Partial<LineDiscountInstruction> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { lineDiscountInstruction.amount = n.getNumberValue(); },
        "discount": n => { lineDiscountInstruction.discount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "sku": n => { lineDiscountInstruction.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLink(link: Partial<Link> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "action": n => { link.action = n.getStringValue(); },
        "href": n => { link.href = n.getStringValue(); },
        "rel": n => { link.rel = n.getStringValue(); },
        "types": n => { link.types = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListApiAccessResponse(listApiAccessResponse: Partial<ListApiAccessResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiKeys": n => { listApiAccessResponse.apiKeys = n.getCollectionOfObjectValues<ApiKey>(createApiKeyFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListCategoriesResponse(listCategoriesResponse: Partial<ListCategoriesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categories": n => { listCategoriesResponse.categories = n.getCollectionOfObjectValues<CategoryDto>(createCategoryDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListCustomerUserImportJobsResponse(listCustomerUserImportJobsResponse: Partial<ListCustomerUserImportJobsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "jobs": n => { listCustomerUserImportJobsResponse.jobs = n.getCollectionOfObjectValues<CustomerUserImportJobSummary>(createCustomerUserImportJobSummaryFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListEmptyCategoriesResponse(listEmptyCategoriesResponse: Partial<ListEmptyCategoriesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categories": n => { listEmptyCategoriesResponse.categories = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListExportFormatsResponse(listExportFormatsResponse: Partial<ListExportFormatsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "formats": n => { listExportFormatsResponse.formats = n.getCollectionOfObjectValues<ExportFormatDto>(createExportFormatDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListForecastModelsResponse(listForecastModelsResponse: Partial<ListForecastModelsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "models": n => { listForecastModelsResponse.models = n.getCollectionOfObjectValues<ForecastModelDto>(createForecastModelDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListIntegrationsResponse(listIntegrationsResponse: Partial<ListIntegrationsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "integrations": n => { listIntegrationsResponse.integrations = n.getCollectionOfObjectValues<IntegrationSummary>(createIntegrationSummaryFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListOfEntitlements(listOfEntitlements: Partial<ListOfEntitlements> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "subscriptionEntitlement": n => { listOfEntitlements.subscriptionEntitlement = n.getObjectValue<SubscriptionEntitlement>(createSubscriptionEntitlementFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListOrderEmailsResponse(listOrderEmailsResponse: Partial<ListOrderEmailsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "emails": n => { listOrderEmailsResponse.emails = n.getCollectionOfObjectValues<SentEmailDto>(createSentEmailDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListOrganizationApiKeysResponse(listOrganizationApiKeysResponse: Partial<ListOrganizationApiKeysResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiKeys": n => { listOrganizationApiKeysResponse.apiKeys = n.getCollectionOfObjectValues<OrganizationApiKeySummary>(createOrganizationApiKeySummaryFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListOrganizationSalesRepsResponse(listOrganizationSalesRepsResponse: Partial<ListOrganizationSalesRepsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { listOrganizationSalesRepsResponse.active = n.getBooleanValue(); },
        "appVersion": n => { listOrganizationSalesRepsResponse.appVersion = n.getStringValue(); },
        "canViewAllCustomers": n => { listOrganizationSalesRepsResponse.canViewAllCustomers = n.getBooleanValue(); },
        "email": n => { listOrganizationSalesRepsResponse.email = n.getStringValue(); },
        "firstName": n => { listOrganizationSalesRepsResponse.firstName = n.getStringValue(); },
        "lastLoginAt": n => { listOrganizationSalesRepsResponse.lastLoginAt = n.getDateValue(); },
        "lastName": n => { listOrganizationSalesRepsResponse.lastName = n.getStringValue(); },
        "lastSeenAt": n => { listOrganizationSalesRepsResponse.lastSeenAt = n.getDateValue(); },
        "lineItemDiscounts": n => { listOrganizationSalesRepsResponse.lineItemDiscounts = n.getEnumValue<DiscountPermission>(DiscountPermissionObject); },
        "marketCode": n => { listOrganizationSalesRepsResponse.marketCode = n.getStringValue(); },
        "orderDiscounts": n => { listOrganizationSalesRepsResponse.orderDiscounts = n.getEnumValue<DiscountPermission>(DiscountPermissionObject); },
        "organizationId": n => { listOrganizationSalesRepsResponse.organizationId = n.getStringValue(); },
        "organizationSalesRepId": n => { listOrganizationSalesRepsResponse.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { listOrganizationSalesRepsResponse.phoneNumber = n.getStringValue(); },
        "repNumber": n => { listOrganizationSalesRepsResponse.repNumber = n.getStringValue(); },
        "repNumbers": n => { listOrganizationSalesRepsResponse.repNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { listOrganizationSalesRepsResponse.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListProductTagsResponse(listProductTagsResponse: Partial<ListProductTagsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "tags": n => { listProductTagsResponse.tags = n.getCollectionOfObjectValues<ListProductTagsResponse_ProductTagDto>(createListProductTagsResponse_ProductTagDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListProductTagsResponse_ProductTagDto(listProductTagsResponse_ProductTagDto: Partial<ListProductTagsResponse_ProductTagDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productCount": n => { listProductTagsResponse_ProductTagDto.productCount = n.getNumberValue(); },
        "tag": n => { listProductTagsResponse_ProductTagDto.tag = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListSalesRepDevicesResponse(listSalesRepDevicesResponse: Partial<ListSalesRepDevicesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "devices": n => { listSalesRepDevicesResponse.devices = n.getCollectionOfObjectValues<SalesRepDeviceDto>(createSalesRepDeviceDtoFromDiscriminatorValue); },
        "salesRepId": n => { listSalesRepDevicesResponse.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListSalesRepOrganizationsResponse(listSalesRepOrganizationsResponse: Partial<ListSalesRepOrganizationsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "salesRepOrganizations": n => { listSalesRepOrganizationsResponse.salesRepOrganizations = n.getCollectionOfObjectValues<OrganizationSalesRep>(createOrganizationSalesRepFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListSqlConnectorsResponse(listSqlConnectorsResponse: Partial<ListSqlConnectorsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "connectors": n => { listSqlConnectorsResponse.connectors = n.getCollectionOfObjectValues<SqlConnectorStatus>(createSqlConnectorStatusFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListSubCategoriesResponse(listSubCategoriesResponse: Partial<ListSubCategoriesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categories": n => { listSubCategoriesResponse.categories = n.getCollectionOfObjectValues<CategoryDto>(createCategoryDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoListUserOrganizationsResponse(listUserOrganizationsResponse: Partial<ListUserOrganizationsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "organizations": n => { listUserOrganizationsResponse.organizations = n.getCollectionOfObjectValues<UserOrganizationDto>(createUserOrganizationDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLookupAddressRequest(lookupAddressRequest: Partial<LookupAddressRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "country": n => { lookupAddressRequest.country = n.getStringValue(); },
        "query": n => { lookupAddressRequest.query = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLookupAddressResponse(lookupAddressResponse: Partial<LookupAddressResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "predictions": n => { lookupAddressResponse.predictions = n.getCollectionOfObjectValues<Prediction>(createPredictionFromDiscriminatorValue); },
        "status": n => { lookupAddressResponse.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMappingAlternate(mappingAlternate: Partial<MappingAlternate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "probability": n => { mappingAlternate.probability = n.getNumberValue(); },
        "target": n => { mappingAlternate.target = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMappingCreateProposal(mappingCreateProposal: Partial<MappingCreateProposal> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyCode": n => { mappingCreateProposal.currencyCode = n.getStringValue(); },
        "kind": n => { mappingCreateProposal.kind = n.getStringValue(); },
        "name": n => { mappingCreateProposal.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMappingOutcomeColumn(mappingOutcomeColumn: Partial<MappingOutcomeColumn> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "header": n => { mappingOutcomeColumn.header = n.getStringValue(); },
        "target": n => { mappingOutcomeColumn.target = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMarkOrdersExportedRequest(markOrdersExportedRequest: Partial<MarkOrdersExportedRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "exportedBy": n => { markOrdersExportedRequest.exportedBy = n.getStringValue(); },
        "orderIds": n => { markOrdersExportedRequest.orderIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMarkOrdersExportedResponse(markOrdersExportedResponse: Partial<MarkOrdersExportedResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "notFound": n => { markOrdersExportedResponse.notFound = n.getCollectionOfPrimitiveValues<string>(); },
        "orders": n => { markOrdersExportedResponse.orders = n.getCollectionOfObjectValues<ExportedOrderDto>(createExportedOrderDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMarkPaidRequest(markPaidRequest: Partial<MarkPaidRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { markPaidRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "paymentReference": n => { markPaidRequest.paymentReference = n.getStringValue(); },
        "useOrganizationId": n => { markPaidRequest.useOrganizationId = n.getStringValue(); },
        "user": n => { markPaidRequest.user = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMatchedSubstring(matchedSubstring: Partial<MatchedSubstring> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "length": n => { matchedSubstring.length = n.getNumberValue(); },
        "offset": n => { matchedSubstring.offset = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMessageAttachment(messageAttachment: Partial<MessageAttachment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "attachmentId": n => { messageAttachment.attachmentId = n.getStringValue(); },
        "mimeType": n => { messageAttachment.mimeType = n.getStringValue(); },
        "name": n => { messageAttachment.name = n.getStringValue(); },
        "size": n => { messageAttachment.size = n.getNumberValue(); },
        "url": n => { messageAttachment.url = n.getStringValue(); },
        "urlExpiresAt": n => { messageAttachment.urlExpiresAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMessageMetadata(messageMetadata: Partial<MessageMetadata> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ipAddress": n => { messageMetadata.ipAddress = n.getStringValue(); },
        "userAgent": n => { messageMetadata.userAgent = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoModelMetrics(modelMetrics: Partial<ModelMetrics> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "meanAbsoluteError": n => { modelMetrics.meanAbsoluteError = n.getNumberValue(); },
        "meanAbsolutePercentageError": n => { modelMetrics.meanAbsolutePercentageError = n.getNumberValue(); },
        "rootMeanSquaredError": n => { modelMetrics.rootMeanSquaredError = n.getNumberValue(); },
        "trainingDurationMs": n => { modelMetrics.trainingDurationMs = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMonthlyForecastPointDto(monthlyForecastPointDto: Partial<MonthlyForecastPointDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "confidenceLowerBound": n => { monthlyForecastPointDto.confidenceLowerBound = n.getNumberValue(); },
        "confidenceUpperBound": n => { monthlyForecastPointDto.confidenceUpperBound = n.getNumberValue(); },
        "month": n => { monthlyForecastPointDto.month = n.getNumberValue(); },
        "predictedUnits": n => { monthlyForecastPointDto.predictedUnits = n.getNumberValue(); },
        "year": n => { monthlyForecastPointDto.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMonthlyOrderTrend(monthlyOrderTrend: Partial<MonthlyOrderTrend> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "month": n => { monthlyOrderTrend.month = n.getNumberValue(); },
        "orderCount": n => { monthlyOrderTrend.orderCount = n.getNumberValue(); },
        "periodStart": n => { monthlyOrderTrend.periodStart = n.getDateValue(); },
        "year": n => { monthlyOrderTrend.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMonthlyRevenueTrend(monthlyRevenueTrend: Partial<MonthlyRevenueTrend> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "month": n => { monthlyRevenueTrend.month = n.getNumberValue(); },
        "periodStart": n => { monthlyRevenueTrend.periodStart = n.getDateValue(); },
        "totalRevenue": n => { monthlyRevenueTrend.totalRevenue = n.getNumberValue(); },
        "year": n => { monthlyRevenueTrend.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMoveDocumentRequest(moveDocumentRequest: Partial<MoveDocumentRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "targetFolderId": n => { moveDocumentRequest.targetFolderId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOk(ok: Partial<Ok> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "statusCode": n => { ok.statusCode = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOpenPipeline(openPipeline: Partial<OpenPipeline> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "asOf": n => { openPipeline.asOf = n.getDateValue(); },
        "initialOrderStatus": n => { openPipeline.initialOrderStatus = n.getStringValue(); },
        "oldestOverdueDays": n => { openPipeline.oldestOverdueDays = n.getNumberValue(); },
        "overdueBalance": n => { openPipeline.overdueBalance = n.getNumberValue(); },
        "overdueInvoiceCount": n => { openPipeline.overdueInvoiceCount = n.getNumberValue(); },
        "stages": n => { openPipeline.stages = n.getCollectionOfObjectValues<PipelineStage>(createPipelineStageFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrder(order: Partial<Order> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(order),
        "appliedCode": n => { order.appliedCode = n.getStringValue(); },
        "appliedPromotions": n => { order.appliedPromotions = n.getCollectionOfObjectValues<AppliedPromotion>(createAppliedPromotionFromDiscriminatorValue); },
        "cancelDate": n => { order.cancelDate = n.getDateOnlyValue(); },
        "cardType": n => { order.cardType = n.getStringValue(); },
        "channel": n => { order.channel = n.getStringValue(); },
        "currencyCode": n => { order.currencyCode = n.getStringValue(); },
        "customer": n => { order.customer = n.getObjectValue<Customer2>(createCustomer2FromDiscriminatorValue); },
        "discount": n => { order.discount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "discountAmount": n => { order.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { order.discountAmountFormatted = n.getStringValue(); },
        "exported": n => { order.exported = n.getBooleanValue(); },
        "exportedAt": n => { order.exportedAt = n.getDateValue(); },
        "exportedBy": n => { order.exportedBy = n.getStringValue(); },
        "externalId": n => { order.externalId = n.getStringValue(); },
        "freeShipping": n => { order.freeShipping = n.getObjectValue<FreeShippingEntitlement>(createFreeShippingEntitlementFromDiscriminatorValue); },
        "fulfillmentCenter": n => { order.fulfillmentCenter = n.getStringValue(); },
        "fulfillmentMethod": n => { order.fulfillmentMethod = n.getStringValue(); },
        "id": n => { order.id = n.getStringValue(); },
        "items": n => { order.items = n.getCollectionOfObjectValues<OrderItem>(createOrderItemFromDiscriminatorValue); },
        "last4Digits": n => { order.last4Digits = n.getStringValue(); },
        "marketCode": n => { order.marketCode = n.getStringValue(); },
        "notes": n => { order.notes = n.getStringValue(); },
        "noteToVendor": n => { order.noteToVendor = n.getStringValue(); },
        "orderBatchId": n => { order.orderBatchId = n.getStringValue(); },
        "orderDate": n => { order.orderDate = n.getDateValue(); },
        "orderKind": n => { order.orderKind = n.getEnumValue<OrderKind>(OrderKindObject); },
        "orderNumber": n => { order.orderNumber = n.getStringValue(); },
        "orderStatus": n => { order.orderStatus = n.getStringValue(); },
        "orderTotal": n => { order.orderTotal = n.getNumberValue(); },
        "orderTotalFormatted": n => { order.orderTotalFormatted = n.getStringValue(); },
        "orderType": n => { order.orderType = n.getStringValue(); },
        "organizationId": n => { order.organizationId = n.getStringValue(); },
        "originationCartId": n => { order.originationCartId = n.getStringValue(); },
        "paymentProfileId": n => { order.paymentProfileId = n.getStringValue(); },
        "poNumber": n => { order.poNumber = n.getStringValue(); },
        "priceTier": n => { order.priceTier = n.getStringValue(); },
        "primarySalesRep": n => { order.primarySalesRep = n.getObjectValue<SalesRep>(createSalesRepFromDiscriminatorValue); },
        "receiptTo": n => { order.receiptTo = n.getCollectionOfPrimitiveValues<string>(); },
        "shipDate": n => { order.shipDate = n.getDateOnlyValue(); },
        "shippingDetails": n => { order.shippingDetails = n.getObjectValue<ShippingDetails>(createShippingDetailsFromDiscriminatorValue); },
        "shippingFormatted": n => { order.shippingFormatted = n.getStringValue(); },
        "shipWindowName": n => { order.shipWindowName = n.getStringValue(); },
        "signatureUrl": n => { order.signatureUrl = n.getStringValue(); },
        "submittedVia": n => { order.submittedVia = n.getStringValue(); },
        "subtotal": n => { order.subtotal = n.getNumberValue(); },
        "subtotalFormatted": n => { order.subtotalFormatted = n.getStringValue(); },
        "takenBySalesRep": n => { order.takenBySalesRep = n.getObjectValue<SalesRep>(createSalesRepFromDiscriminatorValue); },
        "tax": n => { order.tax = n.getNumberValue(); },
        "taxFormatted": n => { order.taxFormatted = n.getStringValue(); },
        "taxItems": n => { order.taxItems = n.getCollectionOfObjectValues<TaxLineItem>(createTaxLineItemFromDiscriminatorValue); },
        "terms": n => { order.terms = n.getStringValue(); },
        "user": n => { order.user = n.getObjectValue<User2>(createUser2FromDiscriminatorValue); },
        "vendorCode": n => { order.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderBatchResponse(orderBatchResponse: Partial<OrderBatchResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { orderBatchResponse.customerNumber = n.getStringValue(); },
        "hasSignature": n => { orderBatchResponse.hasSignature = n.getBooleanValue(); },
        "orderBatchId": n => { orderBatchResponse.orderBatchId = n.getStringValue(); },
        "orders": n => { orderBatchResponse.orders = n.getCollectionOfObjectValues<OrderDto>(createOrderDtoFromDiscriminatorValue); },
        "originationCartId": n => { orderBatchResponse.originationCartId = n.getStringValue(); },
        "placedAt": n => { orderBatchResponse.placedAt = n.getDateValue(); },
        "placedBy": n => { orderBatchResponse.placedBy = n.getObjectValue<SalesRep>(createSalesRepFromDiscriminatorValue); },
        "receiptTo": n => { orderBatchResponse.receiptTo = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderDto(orderDto: Partial<OrderDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { orderDto.active = n.getBooleanValue(); },
        "appliedCode": n => { orderDto.appliedCode = n.getStringValue(); },
        "appliedPromotions": n => { orderDto.appliedPromotions = n.getCollectionOfObjectValues<AppliedPromotion>(createAppliedPromotionFromDiscriminatorValue); },
        "cancelDate": n => { orderDto.cancelDate = n.getDateOnlyValue(); },
        "channel": n => { orderDto.channel = n.getStringValue(); },
        "createdAt": n => { orderDto.createdAt = n.getDateValue(); },
        "currencyCode": n => { orderDto.currencyCode = n.getStringValue(); },
        "customer": n => { orderDto.customer = n.getObjectValue<CustomerDto>(createCustomerDtoFromDiscriminatorValue); },
        "discount": n => { orderDto.discount = n.getObjectValue<DiscountDto>(createDiscountDtoFromDiscriminatorValue); },
        "discountAmount": n => { orderDto.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { orderDto.discountAmountFormatted = n.getStringValue(); },
        "exported": n => { orderDto.exported = n.getBooleanValue(); },
        "exportedAt": n => { orderDto.exportedAt = n.getDateValue(); },
        "exportedBy": n => { orderDto.exportedBy = n.getStringValue(); },
        "externalId": n => { orderDto.externalId = n.getStringValue(); },
        "freeShipping": n => { orderDto.freeShipping = n.getObjectValue<FreeShippingEntitlement>(createFreeShippingEntitlementFromDiscriminatorValue); },
        "fulfillmentCenter": n => { orderDto.fulfillmentCenter = n.getStringValue(); },
        "fulfillmentMethod": n => { orderDto.fulfillmentMethod = n.getStringValue(); },
        "hasSignature": n => { orderDto.hasSignature = n.getBooleanValue(); },
        "id": n => { orderDto.id = n.getStringValue(); },
        "items": n => { orderDto.items = n.getCollectionOfObjectValues<OrderItemDto>(createOrderItemDtoFromDiscriminatorValue); },
        "marketCode": n => { orderDto.marketCode = n.getStringValue(); },
        "notes": n => { orderDto.notes = n.getStringValue(); },
        "noteToVendor": n => { orderDto.noteToVendor = n.getStringValue(); },
        "orderBatchId": n => { orderDto.orderBatchId = n.getStringValue(); },
        "orderDate": n => { orderDto.orderDate = n.getDateValue(); },
        "orderKind": n => { orderDto.orderKind = n.getEnumValue<OrderKind>(OrderKindObject); },
        "orderNumber": n => { orderDto.orderNumber = n.getStringValue(); },
        "orderStatus": n => { orderDto.orderStatus = n.getStringValue(); },
        "orderTotal": n => { orderDto.orderTotal = n.getNumberValue(); },
        "orderTotalFormatted": n => { orderDto.orderTotalFormatted = n.getStringValue(); },
        "orderType": n => { orderDto.orderType = n.getStringValue(); },
        "organization": n => { orderDto.organization = n.getObjectValue<OrganizationInfo>(createOrganizationInfoFromDiscriminatorValue); },
        "organizationId": n => { orderDto.organizationId = n.getStringValue(); },
        "originationCartId": n => { orderDto.originationCartId = n.getStringValue(); },
        "poNumber": n => { orderDto.poNumber = n.getStringValue(); },
        "priceTier": n => { orderDto.priceTier = n.getStringValue(); },
        "primarySalesRep": n => { orderDto.primarySalesRep = n.getObjectValue<SalesRepDto>(createSalesRepDtoFromDiscriminatorValue); },
        "receiptTo": n => { orderDto.receiptTo = n.getCollectionOfPrimitiveValues<string>(); },
        "shipDate": n => { orderDto.shipDate = n.getDateOnlyValue(); },
        "shippingDetails": n => { orderDto.shippingDetails = n.getObjectValue<ShippingDetailsDto>(createShippingDetailsDtoFromDiscriminatorValue); },
        "shippingFormatted": n => { orderDto.shippingFormatted = n.getStringValue(); },
        "shipWindowName": n => { orderDto.shipWindowName = n.getStringValue(); },
        "submittedVia": n => { orderDto.submittedVia = n.getStringValue(); },
        "subtotal": n => { orderDto.subtotal = n.getNumberValue(); },
        "subtotalFormatted": n => { orderDto.subtotalFormatted = n.getStringValue(); },
        "takenBySalesRep": n => { orderDto.takenBySalesRep = n.getObjectValue<SalesRepDto>(createSalesRepDtoFromDiscriminatorValue); },
        "tax": n => { orderDto.tax = n.getNumberValue(); },
        "taxFormatted": n => { orderDto.taxFormatted = n.getStringValue(); },
        "terms": n => { orderDto.terms = n.getStringValue(); },
        "updatedAt": n => { orderDto.updatedAt = n.getDateValue(); },
        "user": n => { orderDto.user = n.getObjectValue<UserDto>(createUserDtoFromDiscriminatorValue); },
        "vendorCode": n => { orderDto.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderExportSettings(orderExportSettings: Partial<OrderExportSettings> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "enabledCustomFormats": n => { orderExportSettings.enabledCustomFormats = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderInvoiceLineSummaryDto(orderInvoiceLineSummaryDto: Partial<OrderInvoiceLineSummaryDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "invoicedQuantity": n => { orderInvoiceLineSummaryDto.invoicedQuantity = n.getNumberValue(); },
        "orderedQuantity": n => { orderInvoiceLineSummaryDto.orderedQuantity = n.getNumberValue(); },
        "remainingQuantity": n => { orderInvoiceLineSummaryDto.remainingQuantity = n.getNumberValue(); },
        "sku": n => { orderInvoiceLineSummaryDto.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderInvoiceSummaryDto(orderInvoiceSummaryDto: Partial<OrderInvoiceSummaryDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyCode": n => { orderInvoiceSummaryDto.currencyCode = n.getStringValue(); },
        "fulfillmentStatus": n => { orderInvoiceSummaryDto.fulfillmentStatus = n.getStringValue(); },
        "invoiceCount": n => { orderInvoiceSummaryDto.invoiceCount = n.getNumberValue(); },
        "lines": n => { orderInvoiceSummaryDto.lines = n.getCollectionOfObjectValues<OrderInvoiceLineSummaryDto>(createOrderInvoiceLineSummaryDtoFromDiscriminatorValue); },
        "orderId": n => { orderInvoiceSummaryDto.orderId = n.getStringValue(); },
        "totalBalance": n => { orderInvoiceSummaryDto.totalBalance = n.getNumberValue(); },
        "totalBalanceFormatted": n => { orderInvoiceSummaryDto.totalBalanceFormatted = n.getStringValue(); },
        "totalInvoiced": n => { orderInvoiceSummaryDto.totalInvoiced = n.getNumberValue(); },
        "totalInvoicedFormatted": n => { orderInvoiceSummaryDto.totalInvoicedFormatted = n.getStringValue(); },
        "totalPaid": n => { orderInvoiceSummaryDto.totalPaid = n.getNumberValue(); },
        "totalPaidFormatted": n => { orderInvoiceSummaryDto.totalPaidFormatted = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderItem(orderItem: Partial<OrderItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categoryPaths": n => { orderItem.categoryPaths = n.getCollectionOfPrimitiveValues<string>(); },
        "discount": n => { orderItem.discount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "discountAmount": n => { orderItem.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { orderItem.discountAmountFormatted = n.getStringValue(); },
        "externalId": n => { orderItem.externalId = n.getStringValue(); },
        "gift": n => { orderItem.gift = n.getObjectValue<GiftMarker>(createGiftMarkerFromDiscriminatorValue); },
        "imageName": n => { orderItem.imageName = n.getStringValue(); },
        "lineId": n => { orderItem.lineId = n.getStringValue(); },
        "lineNumber": n => { orderItem.lineNumber = n.getNumberValue(); },
        "minimumOrderQuantity": n => { orderItem.minimumOrderQuantity = n.getNumberValue(); },
        "note": n => { orderItem.note = n.getStringValue(); },
        "openQuantity": n => { orderItem.openQuantity = n.getNumberValue(); },
        "price": n => { orderItem.price = n.getNumberValue(); },
        "priceFormatted": n => { orderItem.priceFormatted = n.getStringValue(); },
        "priceOverride": n => { orderItem.priceOverride = n.getObjectValue<PriceOverride>(createPriceOverrideFromDiscriminatorValue); },
        "productName": n => { orderItem.productName = n.getStringValue(); },
        "quantity": n => { orderItem.quantity = n.getNumberValue(); },
        "quantityIncrement": n => { orderItem.quantityIncrement = n.getNumberValue(); },
        "sku": n => { orderItem.sku = n.getStringValue(); },
        "subTotal": n => { orderItem.subTotal = n.getNumberValue(); },
        "subTotalFormatted": n => { orderItem.subTotalFormatted = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderItemDto(orderItemDto: Partial<OrderItemDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categoryPaths": n => { orderItemDto.categoryPaths = n.getCollectionOfPrimitiveValues<string>(); },
        "discount": n => { orderItemDto.discount = n.getObjectValue<DiscountDto>(createDiscountDtoFromDiscriminatorValue); },
        "discountAmount": n => { orderItemDto.discountAmount = n.getNumberValue(); },
        "discountAmountFormatted": n => { orderItemDto.discountAmountFormatted = n.getStringValue(); },
        "externalId": n => { orderItemDto.externalId = n.getStringValue(); },
        "gift": n => { orderItemDto.gift = n.getObjectValue<GiftMarkerDto>(createGiftMarkerDtoFromDiscriminatorValue); },
        "imageName": n => { orderItemDto.imageName = n.getStringValue(); },
        "lineId": n => { orderItemDto.lineId = n.getStringValue(); },
        "lineNumber": n => { orderItemDto.lineNumber = n.getNumberValue(); },
        "minimumOrderQuantity": n => { orderItemDto.minimumOrderQuantity = n.getNumberValue(); },
        "note": n => { orderItemDto.note = n.getStringValue(); },
        "openQuantity": n => { orderItemDto.openQuantity = n.getNumberValue(); },
        "paidQuantity": n => { orderItemDto.paidQuantity = n.getNumberValue(); },
        "price": n => { orderItemDto.price = n.getNumberValue(); },
        "priceFormatted": n => { orderItemDto.priceFormatted = n.getStringValue(); },
        "priceOverride": n => { orderItemDto.priceOverride = n.getObjectValue<PriceOverrideDto>(createPriceOverrideDtoFromDiscriminatorValue); },
        "productName": n => { orderItemDto.productName = n.getStringValue(); },
        "quantity": n => { orderItemDto.quantity = n.getNumberValue(); },
        "quantityIncrement": n => { orderItemDto.quantityIncrement = n.getNumberValue(); },
        "sku": n => { orderItemDto.sku = n.getStringValue(); },
        "subTotal": n => { orderItemDto.subTotal = n.getNumberValue(); },
        "subTotalFormatted": n => { orderItemDto.subTotalFormatted = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderItemInput(orderItemInput: Partial<OrderItemInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "discount": n => { orderItemInput.discount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "externalId": n => { orderItemInput.externalId = n.getStringValue(); },
        "imageName": n => { orderItemInput.imageName = n.getStringValue(); },
        "lineNumber": n => { orderItemInput.lineNumber = n.getNumberValue(); },
        "minimumOrderQuantity": n => { orderItemInput.minimumOrderQuantity = n.getNumberValue(); },
        "openQuantity": n => { orderItemInput.openQuantity = n.getNumberValue(); },
        "price": n => { orderItemInput.price = n.getNumberValue(); },
        "priceFormatted": n => { orderItemInput.priceFormatted = n.getStringValue(); },
        "productName": n => { orderItemInput.productName = n.getStringValue(); },
        "quantity": n => { orderItemInput.quantity = n.getNumberValue(); },
        "quantityIncrement": n => { orderItemInput.quantityIncrement = n.getNumberValue(); },
        "sku": n => { orderItemInput.sku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderKindDto(orderKindDto: Partial<OrderKindDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "description": n => { orderKindDto.description = n.getStringValue(); },
        "family": n => { orderKindDto.family = n.getStringValue(); },
        "kind": n => { orderKindDto.kind = n.getEnumValue<OrderKind>(OrderKindObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderReceiptSettings(orderReceiptSettings: Partial<OrderReceiptSettings> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerSubject": n => { orderReceiptSettings.customerSubject = n.getStringValue(); },
        "organizationSubject": n => { orderReceiptSettings.organizationSubject = n.getStringValue(); },
        "salesRepSubject": n => { orderReceiptSettings.salesRepSubject = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderReceiptSettingsResponse(orderReceiptSettingsResponse: Partial<OrderReceiptSettingsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "availableTokens": n => { orderReceiptSettingsResponse.availableTokens = n.getCollectionOfPrimitiveValues<string>(); },
        "customer": n => { orderReceiptSettingsResponse.customer = n.getObjectValue<OrderReceiptSubjectDto>(createOrderReceiptSubjectDtoFromDiscriminatorValue); },
        "organization": n => { orderReceiptSettingsResponse.organization = n.getObjectValue<OrderReceiptSubjectDto>(createOrderReceiptSubjectDtoFromDiscriminatorValue); },
        "salesRep": n => { orderReceiptSettingsResponse.salesRep = n.getObjectValue<OrderReceiptSubjectDto>(createOrderReceiptSubjectDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderReceiptSubjectDto(orderReceiptSubjectDto: Partial<OrderReceiptSubjectDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "defaultSubject": n => { orderReceiptSubjectDto.defaultSubject = n.getStringValue(); },
        "isDefault": n => { orderReceiptSubjectDto.isDefault = n.getBooleanValue(); },
        "subject": n => { orderReceiptSubjectDto.subject = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderRhythm(orderRhythm: Partial<OrderRhythm> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cells": n => { orderRhythm.cells = n.getCollectionOfObjectValues<OrderRhythmCell>(createOrderRhythmCellFromDiscriminatorValue); },
        "timeZone": n => { orderRhythm.timeZone = n.getStringValue(); },
        "totalOrders": n => { orderRhythm.totalOrders = n.getNumberValue(); },
        "totalStorefrontOrders": n => { orderRhythm.totalStorefrontOrders = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderRhythmCell(orderRhythmCell: Partial<OrderRhythmCell> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hour": n => { orderRhythmCell.hour = n.getNumberValue(); },
        "orderCount": n => { orderRhythmCell.orderCount = n.getNumberValue(); },
        "storefrontOrders": n => { orderRhythmCell.storefrontOrders = n.getNumberValue(); },
        "weekday": n => { orderRhythmCell.weekday = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrdersKpi(ordersKpi: Partial<OrdersKpi> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endDate": n => { ordersKpi.endDate = n.getDateValue(); },
        "orderCount": n => { ordersKpi.orderCount = n.getNumberValue(); },
        "organizationId": n => { ordersKpi.organizationId = n.getStringValue(); },
        "startDate": n => { ordersKpi.startDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrdersPageSummary(ordersPageSummary: Partial<OrdersPageSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "asOf": n => { ordersPageSummary.asOf = n.getDateValue(); },
        "initialOrderStatus": n => { ordersPageSummary.initialOrderStatus = n.getStringValue(); },
        "needsProcessing": n => { ordersPageSummary.needsProcessing = n.getNumberValue(); },
        "needsProcessingWaiting": n => { ordersPageSummary.needsProcessingWaiting = n.getNumberValue(); },
        "ordersLast30Days": n => { ordersPageSummary.ordersLast30Days = n.getNumberValue(); },
        "ordersPrior30Days": n => { ordersPageSummary.ordersPrior30Days = n.getNumberValue(); },
        "otherOrders": n => { ordersPageSummary.otherOrders = n.getNumberValue(); },
        "salesAppOrders": n => { ordersPageSummary.salesAppOrders = n.getNumberValue(); },
        "storefrontOrders": n => { ordersPageSummary.storefrontOrders = n.getNumberValue(); },
        "valueLast30Days": n => { ordersPageSummary.valueLast30Days = n.getNumberValue(); },
        "valuePrior30Days": n => { ordersPageSummary.valuePrior30Days = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderType(orderType: Partial<OrderType> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { orderType.displayName = n.getStringValue(); },
        "kind": n => { orderType.kind = n.getEnumValue<OrderKind>(OrderKindObject); },
        "slug": n => { orderType.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderTypeProfileDto(orderTypeProfileDto: Partial<OrderTypeProfileDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { orderTypeProfileDto.displayName = n.getStringValue(); },
        "kind": n => { orderTypeProfileDto.kind = n.getEnumValue<OrderKind>(OrderKindObject); },
        "slug": n => { orderTypeProfileDto.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderTypeResponse(orderTypeResponse: Partial<OrderTypeResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { orderTypeResponse.displayName = n.getStringValue(); },
        "kind": n => { orderTypeResponse.kind = n.getEnumValue<OrderKind>(OrderKindObject); },
        "slug": n => { orderTypeResponse.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderVolumeHistoryPointDto(orderVolumeHistoryPointDto: Partial<OrderVolumeHistoryPointDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "month": n => { orderVolumeHistoryPointDto.month = n.getNumberValue(); },
        "unitsSold": n => { orderVolumeHistoryPointDto.unitsSold = n.getNumberValue(); },
        "year": n => { orderVolumeHistoryPointDto.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrderWithInvoiceNumbersDto(orderWithInvoiceNumbersDto: Partial<OrderWithInvoiceNumbersDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "invoiceNumbers": n => { orderWithInvoiceNumbersDto.invoiceNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "order": n => { orderWithInvoiceNumbersDto.order = n.getObjectValue<Order>(createOrderFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrganization(organization: Partial<Organization> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(organization),
        "accessRequestNotificationEmail": n => { organization.accessRequestNotificationEmail = n.getStringValue(); },
        "accessRequestResearchSettings": n => { organization.accessRequestResearchSettings = n.getObjectValue<AccessRequestResearchSettings>(createAccessRequestResearchSettingsFromDiscriminatorValue); },
        "accountSetup": n => { organization.accountSetup = n.getObjectValue<AccountSetup>(createAccountSetupFromDiscriminatorValue); },
        "billingAddress1": n => { organization.billingAddress1 = n.getStringValue(); },
        "billingAddress2": n => { organization.billingAddress2 = n.getStringValue(); },
        "billingCity": n => { organization.billingCity = n.getStringValue(); },
        "billingCountry": n => { organization.billingCountry = n.getStringValue(); },
        "billingPostalCode": n => { organization.billingPostalCode = n.getStringValue(); },
        "billingStateProvince": n => { organization.billingStateProvince = n.getStringValue(); },
        "cartPricingSettings": n => { organization.cartPricingSettings = n.getObjectValue<CartPricingSettings>(createCartPricingSettingsFromDiscriminatorValue); },
        "customerAttributes": n => { organization.customerAttributes = n.getCollectionOfObjectValues<CustomerAttribute>(createCustomerAttributeFromDiscriminatorValue); },
        "defaultOrderStatus": n => { organization.defaultOrderStatus = n.getStringValue(); },
        "email": n => { organization.email = n.getStringValue(); },
        "features": n => { organization.features = n.getObjectValue<OrganizationFeatures>(createOrganizationFeaturesFromDiscriminatorValue); },
        "fulfillmentMethods": n => { organization.fulfillmentMethods = n.getCollectionOfPrimitiveValues<string>(); },
        "identityOrganizationId": n => { organization.identityOrganizationId = n.getStringValue(); },
        "latitude": n => { organization.latitude = n.getNumberValue(); },
        "logoUrl": n => { organization.logoUrl = n.getStringValue(); },
        "longitude": n => { organization.longitude = n.getNumberValue(); },
        "marketCodes": n => { organization.marketCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "name": n => { organization.name = n.getStringValue(); },
        "orderExportSettings": n => { organization.orderExportSettings = n.getObjectValue<OrderExportSettings>(createOrderExportSettingsFromDiscriminatorValue); },
        "orderReceiptSettings": n => { organization.orderReceiptSettings = n.getObjectValue<OrderReceiptSettings>(createOrderReceiptSettingsFromDiscriminatorValue); },
        "orderStatuses": n => { organization.orderStatuses = n.getCollectionOfPrimitiveValues<string>(); },
        "orderTypes": n => { organization.orderTypes = n.getCollectionOfObjectValues<OrderType>(createOrderTypeFromDiscriminatorValue); },
        "organizationId": n => { organization.organizationId = n.getStringValue(); },
        "phoneNumber": n => { organization.phoneNumber = n.getStringValue(); },
        "priceTiers": n => { organization.priceTiers = n.getCollectionOfObjectValues<PriceTier>(createPriceTierFromDiscriminatorValue); },
        "productAttributes": n => { organization.productAttributes = n.getCollectionOfObjectValues<ProductAttribute>(createProductAttributeFromDiscriminatorValue); },
        "productOptions": n => { organization.productOptions = n.getCollectionOfObjectValues<ProductOptionDefinition>(createProductOptionDefinitionFromDiscriminatorValue); },
        "seatAllowance": n => { organization.seatAllowance = n.getNumberValue(); },
        "subscriptions": n => { organization.subscriptions = n.getCollectionOfObjectValues<Subscription2>(createSubscription2FromDiscriminatorValue); },
        "taxSettings": n => { organization.taxSettings = n.getObjectValue<TaxSettings>(createTaxSettingsFromDiscriminatorValue); },
        "terms": n => { organization.terms = n.getCollectionOfPrimitiveValues<string>(); },
        "type": n => { organization.type = n.getEnumValue<OrganizationType>(OrganizationTypeObject); },
        "websiteUrl": n => { organization.websiteUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrganization2(organization2: Partial<Organization2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress1": n => { organization2.billingAddress1 = n.getStringValue(); },
        "billingAddress2": n => { organization2.billingAddress2 = n.getStringValue(); },
        "billingCity": n => { organization2.billingCity = n.getStringValue(); },
        "billingCountry": n => { organization2.billingCountry = n.getStringValue(); },
        "billingPostalCode": n => { organization2.billingPostalCode = n.getStringValue(); },
        "billingStateProvince": n => { organization2.billingStateProvince = n.getStringValue(); },
        "email": n => { organization2.email = n.getStringValue(); },
        "name": n => { organization2.name = n.getStringValue(); },
        "phoneNumber": n => { organization2.phoneNumber = n.getStringValue(); },
        "website": n => { organization2.website = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrganizationApiKeySummary(organizationApiKeySummary: Partial<OrganizationApiKeySummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdOn": n => { organizationApiKeySummary.createdOn = n.getStringValue(); },
        "keyId": n => { organizationApiKeySummary.keyId = n.getStringValue(); },
        "keyPrefix": n => { organizationApiKeySummary.keyPrefix = n.getStringValue(); },
        "keySuffix": n => { organizationApiKeySummary.keySuffix = n.getStringValue(); },
        "lastUsedOn": n => { organizationApiKeySummary.lastUsedOn = n.getStringValue(); },
        "name": n => { organizationApiKeySummary.name = n.getStringValue(); },
        "scope": n => { organizationApiKeySummary.scope = n.getStringValue(); },
        "status": n => { organizationApiKeySummary.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrganizationFeatures(organizationFeatures: Partial<OrganizationFeatures> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productVariants": n => { organizationFeatures.productVariants = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrganizationInfo(organizationInfo: Partial<OrganizationInfo> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress": n => { organizationInfo.billingAddress = n.getStringValue(); },
        "email": n => { organizationInfo.email = n.getStringValue(); },
        "logoUrl": n => { organizationInfo.logoUrl = n.getStringValue(); },
        "name": n => { organizationInfo.name = n.getStringValue(); },
        "phoneNumber": n => { organizationInfo.phoneNumber = n.getStringValue(); },
        "websiteUrl": n => { organizationInfo.websiteUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrganizationProfileDto(organizationProfileDto: Partial<OrganizationProfileDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress1": n => { organizationProfileDto.billingAddress1 = n.getStringValue(); },
        "billingAddress2": n => { organizationProfileDto.billingAddress2 = n.getStringValue(); },
        "billingCity": n => { organizationProfileDto.billingCity = n.getStringValue(); },
        "billingCountry": n => { organizationProfileDto.billingCountry = n.getStringValue(); },
        "billingPostalCode": n => { organizationProfileDto.billingPostalCode = n.getStringValue(); },
        "billingStateProvince": n => { organizationProfileDto.billingStateProvince = n.getStringValue(); },
        "email": n => { organizationProfileDto.email = n.getStringValue(); },
        "isAgency": n => { organizationProfileDto.isAgency = n.getBooleanValue(); },
        "name": n => { organizationProfileDto.name = n.getStringValue(); },
        "orderTypes": n => { organizationProfileDto.orderTypes = n.getCollectionOfObjectValues<OrderTypeProfileDto>(createOrderTypeProfileDtoFromDiscriminatorValue); },
        "organizationId": n => { organizationProfileDto.organizationId = n.getStringValue(); },
        "phoneNumber": n => { organizationProfileDto.phoneNumber = n.getStringValue(); },
        "productOptions": n => { organizationProfileDto.productOptions = n.getCollectionOfObjectValues<ProductOptionProfileDto>(createProductOptionProfileDtoFromDiscriminatorValue); },
        "productVariantsEnabled": n => { organizationProfileDto.productVariantsEnabled = n.getBooleanValue(); },
        "terms": n => { organizationProfileDto.terms = n.getCollectionOfPrimitiveValues<string>(); },
        "type": n => { organizationProfileDto.type = n.getEnumValue<OrganizationType>(OrganizationTypeObject); },
        "website": n => { organizationProfileDto.website = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrganizationSalesRep(organizationSalesRep: Partial<OrganizationSalesRep> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(organizationSalesRep),
        "canViewAllCustomers": n => { organizationSalesRep.canViewAllCustomers = n.getBooleanValue(); },
        "email": n => { organizationSalesRep.email = n.getStringValue(); },
        "firstName": n => { organizationSalesRep.firstName = n.getStringValue(); },
        "identityOrganizationId": n => { organizationSalesRep.identityOrganizationId = n.getStringValue(); },
        "identityProviderUserId": n => { organizationSalesRep.identityProviderUserId = n.getStringValue(); },
        "lastName": n => { organizationSalesRep.lastName = n.getStringValue(); },
        "lineItemDiscounts": n => { organizationSalesRep.lineItemDiscounts = n.getEnumValue<DiscountPermission>(DiscountPermissionObject); },
        "marketCode": n => { organizationSalesRep.marketCode = n.getStringValue(); },
        "orderDiscounts": n => { organizationSalesRep.orderDiscounts = n.getEnumValue<DiscountPermission>(DiscountPermissionObject); },
        "organizationId": n => { organizationSalesRep.organizationId = n.getStringValue(); },
        "organizationName": n => { organizationSalesRep.organizationName = n.getStringValue(); },
        "organizationSalesRepId": n => { organizationSalesRep.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { organizationSalesRep.phoneNumber = n.getStringValue(); },
        "repNumber": n => { organizationSalesRep.repNumber = n.getStringValue(); },
        "repNumbers": n => { organizationSalesRep.repNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { organizationSalesRep.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOrganizationUser(organizationUser: Partial<OrganizationUser> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { organizationUser.email = n.getStringValue(); },
        "first_name": n => { organizationUser.firstName = n.getStringValue(); },
        "full_name": n => { organizationUser.fullName = n.getStringValue(); },
        "id": n => { organizationUser.id = n.getStringValue(); },
        "joined_on": n => { organizationUser.joinedOn = n.getDateValue(); },
        "last_name": n => { organizationUser.lastName = n.getStringValue(); },
        "picture": n => { organizationUser.picture = n.getStringValue(); },
        "roles": n => { organizationUser.roles = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPage(page: Partial<Page> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "imageName": n => { page.imageName = n.getStringValue(); },
        "pageNumber": n => { page.pageNumber = n.getNumberValue(); },
        "tags": n => { page.tags = n.getCollectionOfObjectValues<Tag>(createTagFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfAccessRequest(pagedResultOfAccessRequest: Partial<PagedResultOfAccessRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfAccessRequest.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfAccessRequest.data = n.getCollectionOfObjectValues<AccessRequest>(createAccessRequestFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfAccessRequest.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfAccessRequest.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfAccessRequest.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfCampaign(pagedResultOfCampaign: Partial<PagedResultOfCampaign> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfCampaign.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfCampaign.data = n.getCollectionOfObjectValues<Campaign>(createCampaignFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfCampaign.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfCampaign.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfCampaign.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfCommissionPlanDto(pagedResultOfCommissionPlanDto: Partial<PagedResultOfCommissionPlanDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfCommissionPlanDto.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfCommissionPlanDto.data = n.getCollectionOfObjectValues<CommissionPlanDto>(createCommissionPlanDtoFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfCommissionPlanDto.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfCommissionPlanDto.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfCommissionPlanDto.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfCommissionStatementDto(pagedResultOfCommissionStatementDto: Partial<PagedResultOfCommissionStatementDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfCommissionStatementDto.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfCommissionStatementDto.data = n.getCollectionOfObjectValues<CommissionStatementDto>(createCommissionStatementDtoFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfCommissionStatementDto.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfCommissionStatementDto.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfCommissionStatementDto.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfContactListItemDto(pagedResultOfContactListItemDto: Partial<PagedResultOfContactListItemDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfContactListItemDto.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfContactListItemDto.data = n.getCollectionOfObjectValues<ContactListItemDto>(createContactListItemDtoFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfContactListItemDto.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfContactListItemDto.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfContactListItemDto.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfCustomer(pagedResultOfCustomer: Partial<PagedResultOfCustomer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfCustomer.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfCustomer.data = n.getCollectionOfObjectValues<Customer>(createCustomerFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfCustomer.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfCustomer.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfCustomer.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfCustomerNote(pagedResultOfCustomerNote: Partial<PagedResultOfCustomerNote> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfCustomerNote.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfCustomerNote.data = n.getCollectionOfObjectValues<CustomerNote>(createCustomerNoteFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfCustomerNote.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfCustomerNote.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfCustomerNote.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfDataExport(pagedResultOfDataExport: Partial<PagedResultOfDataExport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfDataExport.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfDataExport.data = n.getCollectionOfObjectValues<DataExport>(createDataExportFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfDataExport.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfDataExport.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfDataExport.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfDiscountCode(pagedResultOfDiscountCode: Partial<PagedResultOfDiscountCode> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfDiscountCode.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfDiscountCode.data = n.getCollectionOfObjectValues<DiscountCode>(createDiscountCodeFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfDiscountCode.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfDiscountCode.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfDiscountCode.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfEntityDetailsResponseOfImageDetail(pagedResultOfEntityDetailsResponseOfImageDetail: Partial<PagedResultOfEntityDetailsResponseOfImageDetail> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfEntityDetailsResponseOfImageDetail.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfEntityDetailsResponseOfImageDetail.data = n.getCollectionOfObjectValues<EntityDetailsResponseOfImageDetail>(createEntityDetailsResponseOfImageDetailFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfEntityDetailsResponseOfImageDetail.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfEntityDetailsResponseOfImageDetail.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfEntityDetailsResponseOfImageDetail.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfFlipbook(pagedResultOfFlipbook: Partial<PagedResultOfFlipbook> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfFlipbook.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfFlipbook.data = n.getCollectionOfObjectValues<Flipbook>(createFlipbookFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfFlipbook.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfFlipbook.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfFlipbook.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfInvoice(pagedResultOfInvoice: Partial<PagedResultOfInvoice> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfInvoice.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfInvoice.data = n.getCollectionOfObjectValues<Invoice>(createInvoiceFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfInvoice.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfInvoice.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfInvoice.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfInvoiceDto(pagedResultOfInvoiceDto: Partial<PagedResultOfInvoiceDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfInvoiceDto.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfInvoiceDto.data = n.getCollectionOfObjectValues<InvoiceDto>(createInvoiceDtoFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfInvoiceDto.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfInvoiceDto.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfInvoiceDto.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfOrder(pagedResultOfOrder: Partial<PagedResultOfOrder> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfOrder.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfOrder.data = n.getCollectionOfObjectValues<Order>(createOrderFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfOrder.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfOrder.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfOrder.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfOrderDto(pagedResultOfOrderDto: Partial<PagedResultOfOrderDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfOrderDto.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfOrderDto.data = n.getCollectionOfObjectValues<OrderDto>(createOrderDtoFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfOrderDto.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfOrderDto.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfOrderDto.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfOrderWithInvoiceNumbersDto(pagedResultOfOrderWithInvoiceNumbersDto: Partial<PagedResultOfOrderWithInvoiceNumbersDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfOrderWithInvoiceNumbersDto.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfOrderWithInvoiceNumbersDto.data = n.getCollectionOfObjectValues<OrderWithInvoiceNumbersDto>(createOrderWithInvoiceNumbersDtoFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfOrderWithInvoiceNumbersDto.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfOrderWithInvoiceNumbersDto.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfOrderWithInvoiceNumbersDto.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfProduct(pagedResultOfProduct: Partial<PagedResultOfProduct> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfProduct.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfProduct.data = n.getCollectionOfObjectValues<Product>(createProductFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfProduct.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfProduct.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfProduct.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfProductFamily(pagedResultOfProductFamily: Partial<PagedResultOfProductFamily> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfProductFamily.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfProductFamily.data = n.getCollectionOfObjectValues<ProductFamily>(createProductFamilyFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfProductFamily.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfProductFamily.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfProductFamily.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfSentEmailDto(pagedResultOfSentEmailDto: Partial<PagedResultOfSentEmailDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfSentEmailDto.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfSentEmailDto.data = n.getCollectionOfObjectValues<SentEmailDto>(createSentEmailDtoFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfSentEmailDto.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfSentEmailDto.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfSentEmailDto.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfShoppingCart(pagedResultOfShoppingCart: Partial<PagedResultOfShoppingCart> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfShoppingCart.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfShoppingCart.data = n.getCollectionOfObjectValues<ShoppingCart>(createShoppingCartFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfShoppingCart.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfShoppingCart.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfShoppingCart.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfStorefrontUserResponse(pagedResultOfStorefrontUserResponse: Partial<PagedResultOfStorefrontUserResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfStorefrontUserResponse.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfStorefrontUserResponse.data = n.getCollectionOfObjectValues<StorefrontUserResponse>(createStorefrontUserResponseFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfStorefrontUserResponse.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfStorefrontUserResponse.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfStorefrontUserResponse.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfTaskItem(pagedResultOfTaskItem: Partial<PagedResultOfTaskItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfTaskItem.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfTaskItem.data = n.getCollectionOfObjectValues<TaskItem>(createTaskItemFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfTaskItem.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfTaskItem.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfTaskItem.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfTearSheet(pagedResultOfTearSheet: Partial<PagedResultOfTearSheet> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfTearSheet.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfTearSheet.data = n.getCollectionOfObjectValues<TearSheet>(createTearSheetFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfTearSheet.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfTearSheet.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfTearSheet.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfUserCustomer(pagedResultOfUserCustomer: Partial<PagedResultOfUserCustomer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfUserCustomer.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfUserCustomer.data = n.getCollectionOfObjectValues<UserCustomer>(createUserCustomerFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfUserCustomer.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfUserCustomer.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfUserCustomer.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfVendor(pagedResultOfVendor: Partial<PagedResultOfVendor> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfVendor.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfVendor.data = n.getCollectionOfObjectValues<Vendor>(createVendorFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfVendor.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfVendor.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfVendor.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagedResultOfVendorCustomerDto(pagedResultOfVendorCustomerDto: Partial<PagedResultOfVendorCustomerDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currentPage": n => { pagedResultOfVendorCustomerDto.currentPage = n.getNumberValue(); },
        "data": n => { pagedResultOfVendorCustomerDto.data = n.getCollectionOfObjectValues<VendorCustomerDto>(createVendorCustomerDtoFromDiscriminatorValue); },
        "pageSize": n => { pagedResultOfVendorCustomerDto.pageSize = n.getNumberValue(); },
        "totalPages": n => { pagedResultOfVendorCustomerDto.totalPages = n.getNumberValue(); },
        "totalRecords": n => { pagedResultOfVendorCustomerDto.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPageInfo(pageInfo: Partial<PageInfo> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "imageName": n => { pageInfo.imageName = n.getStringValue(); },
        "pageNumber": n => { pageInfo.pageNumber = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPageUpdateInfo(pageUpdateInfo: Partial<PageUpdateInfo> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "imageName": n => { pageUpdateInfo.imageName = n.getStringValue(); },
        "pageNumber": n => { pageUpdateInfo.pageNumber = n.getNumberValue(); },
        "tags": n => { pageUpdateInfo.tags = n.getCollectionOfObjectValues<TagInfo>(createTagInfoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPayment(payment: Partial<Payment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { payment.amount = n.getNumberValue(); },
        "amountFormatted": n => { payment.amountFormatted = n.getStringValue(); },
        "cardType": n => { payment.cardType = n.getStringValue(); },
        "currencyCode": n => { payment.currencyCode = n.getStringValue(); },
        "id": n => { payment.id = n.getStringValue(); },
        "last4Digits": n => { payment.last4Digits = n.getStringValue(); },
        "method": n => { payment.method = n.getEnumValue<PaymentMethod2>(PaymentMethod2Object); },
        "netAmount": n => { payment.netAmount = n.getNumberValue(); },
        "netAmountFormatted": n => { payment.netAmountFormatted = n.getStringValue(); },
        "notes": n => { payment.notes = n.getStringValue(); },
        "paymentDate": n => { payment.paymentDate = n.getDateValue(); },
        "paymentProfileId": n => { payment.paymentProfileId = n.getStringValue(); },
        "reference": n => { payment.reference = n.getStringValue(); },
        "refundedAmount": n => { payment.refundedAmount = n.getNumberValue(); },
        "refundedAmountFormatted": n => { payment.refundedAmountFormatted = n.getStringValue(); },
        "refunds": n => { payment.refunds = n.getCollectionOfObjectValues<PaymentRefund>(createPaymentRefundFromDiscriminatorValue); },
        "status": n => { payment.status = n.getEnumValue<PaymentStatus>(PaymentStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPayment2(payment2: Partial<Payment2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress": n => { payment2.billingAddress = n.getObjectValue<CheckoutBillingAddress>(createCheckoutBillingAddressFromDiscriminatorValue); },
        "creditCard": n => { payment2.creditCard = n.getObjectValue<CreditCard>(createCreditCardFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaymentDto(paymentDto: Partial<PaymentDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { paymentDto.amount = n.getNumberValue(); },
        "amountFormatted": n => { paymentDto.amountFormatted = n.getStringValue(); },
        "cardType": n => { paymentDto.cardType = n.getStringValue(); },
        "currencyCode": n => { paymentDto.currencyCode = n.getStringValue(); },
        "id": n => { paymentDto.id = n.getStringValue(); },
        "last4Digits": n => { paymentDto.last4Digits = n.getStringValue(); },
        "method": n => { paymentDto.method = n.getStringValue(); },
        "netAmount": n => { paymentDto.netAmount = n.getNumberValue(); },
        "netAmountFormatted": n => { paymentDto.netAmountFormatted = n.getStringValue(); },
        "notes": n => { paymentDto.notes = n.getStringValue(); },
        "paymentDate": n => { paymentDto.paymentDate = n.getDateValue(); },
        "paymentProfileId": n => { paymentDto.paymentProfileId = n.getStringValue(); },
        "reference": n => { paymentDto.reference = n.getStringValue(); },
        "refundedAmount": n => { paymentDto.refundedAmount = n.getNumberValue(); },
        "refundedAmountFormatted": n => { paymentDto.refundedAmountFormatted = n.getStringValue(); },
        "refunds": n => { paymentDto.refunds = n.getCollectionOfObjectValues<PaymentRefundDto>(createPaymentRefundDtoFromDiscriminatorValue); },
        "status": n => { paymentDto.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaymentMethod(paymentMethod: Partial<PaymentMethod> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(paymentMethod),
        "billingAddress": n => { paymentMethod.billingAddress = n.getObjectValue<BillingAddress>(createBillingAddressFromDiscriminatorValue); },
        "cardType": n => { paymentMethod.cardType = n.getStringValue(); },
        "customerNumber": n => { paymentMethod.customerNumber = n.getStringValue(); },
        "customerProfileId": n => { paymentMethod.customerProfileId = n.getStringValue(); },
        "expirationDate": n => { paymentMethod.expirationDate = n.getStringValue(); },
        "expMonth": n => { paymentMethod.expMonth = n.getNumberValue(); },
        "expYear": n => { paymentMethod.expYear = n.getNumberValue(); },
        "isDefault": n => { paymentMethod.isDefault = n.getBooleanValue(); },
        "maskedCardNumber": n => { paymentMethod.maskedCardNumber = n.getStringValue(); },
        "networkTransactionId": n => { paymentMethod.networkTransactionId = n.getStringValue(); },
        "paymentProfileId": n => { paymentMethod.paymentProfileId = n.getStringValue(); },
        "paymentProvider": n => { paymentMethod.paymentProvider = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaymentProfile(paymentProfile: Partial<PaymentProfile> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(paymentProfile),
        "cardType": n => { paymentProfile.cardType = n.getStringValue(); },
        "customerNumber": n => { paymentProfile.customerNumber = n.getStringValue(); },
        "customerProfileId": n => { paymentProfile.customerProfileId = n.getStringValue(); },
        "expMonth": n => { paymentProfile.expMonth = n.getNumberValue(); },
        "expYear": n => { paymentProfile.expYear = n.getNumberValue(); },
        "id": n => { paymentProfile.id = n.getStringValue(); },
        "isDefault": n => { paymentProfile.isDefault = n.getBooleanValue(); },
        "last4Digits": n => { paymentProfile.last4Digits = n.getStringValue(); },
        "networkTransactionId": n => { paymentProfile.networkTransactionId = n.getStringValue(); },
        "organizationId": n => { paymentProfile.organizationId = n.getStringValue(); },
        "paymentProfileId": n => { paymentProfile.paymentProfileId = n.getStringValue(); },
        "provider": n => { paymentProfile.provider = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaymentRefund(paymentRefund: Partial<PaymentRefund> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { paymentRefund.amount = n.getNumberValue(); },
        "id": n => { paymentRefund.id = n.getStringValue(); },
        "notes": n => { paymentRefund.notes = n.getStringValue(); },
        "reference": n => { paymentRefund.reference = n.getStringValue(); },
        "refundDate": n => { paymentRefund.refundDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaymentRefundDto(paymentRefundDto: Partial<PaymentRefundDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { paymentRefundDto.amount = n.getNumberValue(); },
        "id": n => { paymentRefundDto.id = n.getStringValue(); },
        "notes": n => { paymentRefundDto.notes = n.getStringValue(); },
        "reference": n => { paymentRefundDto.reference = n.getStringValue(); },
        "refundDate": n => { paymentRefundDto.refundDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPendingPromotion(pendingPromotion: Partial<PendingPromotion> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { pendingPromotion.campaignId = n.getStringValue(); },
        "campaignName": n => { pendingPromotion.campaignName = n.getStringValue(); },
        "campaignValidTo": n => { pendingPromotion.campaignValidTo = n.getDateValue(); },
        "eligibleQuantity": n => { pendingPromotion.eligibleQuantity = n.getNumberValue(); },
        "eligibleSkus": n => { pendingPromotion.eligibleSkus = n.getCollectionOfPrimitiveValues<string>(); },
        "eligibleSubtotal": n => { pendingPromotion.eligibleSubtotal = n.getNumberValue(); },
        "hasScope": n => { pendingPromotion.hasScope = n.getBooleanValue(); },
        "message": n => { pendingPromotion.message = n.getStringValue(); },
        "progress": n => { pendingPromotion.progress = n.getObjectValue<PromotionProgress>(createPromotionProgressFromDiscriminatorValue); },
        "promotionId": n => { pendingPromotion.promotionId = n.getStringValue(); },
        "promotionName": n => { pendingPromotion.promotionName = n.getStringValue(); },
        "reason": n => { pendingPromotion.reason = n.getEnumValue<PromotionSkipReason>(PromotionSkipReasonObject); },
        "scopeCategories": n => { pendingPromotion.scopeCategories = n.getCollectionOfPrimitiveValues<string>(); },
        "scopeSkus": n => { pendingPromotion.scopeSkus = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPipelineStage(pipelineStage: Partial<PipelineStage> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "count": n => { pipelineStage.count = n.getNumberValue(); },
        "stage": n => { pipelineStage.stage = n.getStringValue(); },
        "statuses": n => { pipelineStage.statuses = n.getCollectionOfPrimitiveValues<string>(); },
        "value": n => { pipelineStage.value = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPlacedLine(placedLine: Partial<PlacedLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderBatchId": n => { placedLine.orderBatchId = n.getStringValue(); },
        "orderId": n => { placedLine.orderId = n.getStringValue(); },
        "orderNumber": n => { placedLine.orderNumber = n.getStringValue(); },
        "vendorCode": n => { placedLine.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPlaceLinesRequest(placeLinesRequest: Partial<PlaceLinesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoVendorCartRequest(placeLinesRequest),
        "paymentProfileId": n => { placeLinesRequest.paymentProfileId = n.getStringValue(); },
        "signaturePng": n => { placeLinesRequest.signaturePng = n.getStringValue(); },
        "submittedVia": n => { placeLinesRequest.submittedVia = n.getStringValue(); },
        "userType": n => { placeLinesRequest.userType = n.getEnumValue<UserTypes>(UserTypesObject); },
        "vendorCodes": n => { placeLinesRequest.vendorCodes = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPlaceLinesResponse(placeLinesResponse: Partial<PlaceLinesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "failed": n => { placeLinesResponse.failed = n.getCollectionOfObjectValues<FailedLine>(createFailedLineFromDiscriminatorValue); },
        "orderBatchId": n => { placeLinesResponse.orderBatchId = n.getStringValue(); },
        "placed": n => { placeLinesResponse.placed = n.getCollectionOfObjectValues<PlacedLine>(createPlacedLineFromDiscriminatorValue); },
        "remainingCartId": n => { placeLinesResponse.remainingCartId = n.getStringValue(); },
        "skipped": n => { placeLinesResponse.skipped = n.getCollectionOfObjectValues<SkippedLine>(createSkippedLineFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPlansResponse(plansResponse: Partial<PlansResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "items": n => { plansResponse.items = n.getCollectionOfObjectValues<CatalogItem>(createCatalogItemFromDiscriminatorValue); },
        "trialPeriodDays": n => { plansResponse.trialPeriodDays = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPortalSessionLinkResponse(portalSessionLinkResponse: Partial<PortalSessionLinkResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "sessionUrl": n => { portalSessionLinkResponse.sessionUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPrediction(prediction: Partial<Prediction> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "description": n => { prediction.description = n.getStringValue(); },
        "matchedSubstrings": n => { prediction.matchedSubstrings = n.getCollectionOfObjectValues<MatchedSubstring>(createMatchedSubstringFromDiscriminatorValue); },
        "placeId": n => { prediction.placeId = n.getStringValue(); },
        "reference": n => { prediction.reference = n.getStringValue(); },
        "structuredFormatting": n => { prediction.structuredFormatting = n.getObjectValue<StructuredFormatting>(createStructuredFormattingFromDiscriminatorValue); },
        "terms": n => { prediction.terms = n.getCollectionOfObjectValues<Term>(createTermFromDiscriminatorValue); },
        "types": n => { prediction.types = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPrefillVendorRequest(prefillVendorRequest: Partial<PrefillVendorRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoAgencyScopedRequest(prefillVendorRequest),
        "website": n => { prefillVendorRequest.website = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPriceOverride(priceOverride: Partial<PriceOverride> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "listPrice": n => { priceOverride.listPrice = n.getNumberValue(); },
        "overriddenAtUtc": n => { priceOverride.overriddenAtUtc = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPriceOverrideDto(priceOverrideDto: Partial<PriceOverrideDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "listPrice": n => { priceOverrideDto.listPrice = n.getNumberValue(); },
        "overriddenAtUtc": n => { priceOverrideDto.overriddenAtUtc = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPriceTier(priceTier: Partial<PriceTier> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyCode": n => { priceTier.currencyCode = n.getEnumValue<CurrencyCode>(CurrencyCodeObject); },
        "name": n => { priceTier.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProduct(product: Partial<Product> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { product.active = n.getBooleanValue(); },
        "category": n => { product.category = n.getStringValue(); },
        "categorySortOrders": n => { product.categorySortOrders = n.getObjectValue<Product_categorySortOrders>(createProduct_categorySortOrdersFromDiscriminatorValue); },
        "createdAt": n => { product.createdAt = n.getDateValue(); },
        "currencyCode": n => { product.currencyCode = n.getEnumValue<CurrencyCode>(CurrencyCodeObject); },
        "description": n => { product.description = n.getStringValue(); },
        "dimensions": n => { product.dimensions = n.getStringValue(); },
        "dimensionsUnit": n => { product.dimensionsUnit = n.getStringValue(); },
        "externalId": n => { product.externalId = n.getStringValue(); },
        "familyId": n => { product.familyId = n.getStringValue(); },
        "familyKey": n => { product.familyKey = n.getStringValue(); },
        "imageName": n => { product.imageName = n.getStringValue(); },
        "Images": n => { product.images = n.getCollectionOfObjectValues<Image>(createImageFromDiscriminatorValue); },
        "minimumOrderQuantity": n => { product.minimumOrderQuantity = n.getNumberValue(); },
        "name": n => { product.name = n.getStringValue(); },
        "optionValues": n => { product.optionValues = n.getObjectValue<Product_optionValues>(createProduct_optionValuesFromDiscriminatorValue); },
        "organizationId": n => { product.organizationId = n.getStringValue(); },
        "price": n => { product.price = n.getNumberValue(); },
        "priceFormatted": n => { product.priceFormatted = n.getStringValue(); },
        "prices": n => { product.prices = n.getCollectionOfObjectValues<ProductPrice>(createProductPriceFromDiscriminatorValue); },
        "productAttributeLabels": n => { product.productAttributeLabels = n.getObjectValue<Product_productAttributeLabels>(createProduct_productAttributeLabelsFromDiscriminatorValue); },
        "productAttributes": n => { product.productAttributes = n.getObjectValue<Product_productAttributes>(createProduct_productAttributesFromDiscriminatorValue); },
        "productId": n => { product.productId = n.getStringValue(); },
        "productType": n => { product.productType = n.getEnumValue<ProductType>(ProductTypeObject); },
        "quantityIncrement": n => { product.quantityIncrement = n.getNumberValue(); },
        "quantityOnHand": n => { product.quantityOnHand = n.getNumberValue(); },
        "separateLines": n => { product.separateLines = n.getBooleanValue(); },
        "sku": n => { product.sku = n.getStringValue(); },
        "tags": n => { product.tags = n.getCollectionOfPrimitiveValues<string>(); },
        "upc": n => { product.upc = n.getStringValue(); },
        "updatedAt": n => { product.updatedAt = n.getDateValue(); },
        "variantPosition": n => { product.variantPosition = n.getNumberValue(); },
        "vendorCode": n => { product.vendorCode = n.getStringValue(); },
        "vendorItemNumber": n => { product.vendorItemNumber = n.getStringValue(); },
        "weight": n => { product.weight = n.getNumberValue(); },
        "weightUnit": n => { product.weightUnit = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProduct_categorySortOrders(product_categorySortOrders: Partial<Product_categorySortOrders> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProduct_optionValues(product_optionValues: Partial<Product_optionValues> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProduct_productAttributeLabels(product_productAttributeLabels: Partial<Product_productAttributeLabels> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProduct_productAttributes(product_productAttributes: Partial<Product_productAttributes> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductAttribute(productAttribute: Partial<ProductAttribute> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { productAttribute.displayName = n.getStringValue(); },
        "slug": n => { productAttribute.slug = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductFamily(productFamily: Partial<ProductFamily> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { productFamily.active = n.getBooleanValue(); },
        "category": n => { productFamily.category = n.getStringValue(); },
        "createdAt": n => { productFamily.createdAt = n.getDateValue(); },
        "description": n => { productFamily.description = n.getStringValue(); },
        "externalId": n => { productFamily.externalId = n.getStringValue(); },
        "familyId": n => { productFamily.familyId = n.getStringValue(); },
        "familyKey": n => { productFamily.familyKey = n.getStringValue(); },
        "images": n => { productFamily.images = n.getCollectionOfObjectValues<Image>(createImageFromDiscriminatorValue); },
        "imagesByOption": n => { productFamily.imagesByOption = n.getObjectValue<ProductFamily_imagesByOption>(createProductFamily_imagesByOptionFromDiscriminatorValue); },
        "name": n => { productFamily.name = n.getStringValue(); },
        "options": n => { productFamily.options = n.getCollectionOfObjectValues<ProductFamilyOption>(createProductFamilyOptionFromDiscriminatorValue); },
        "summary": n => { productFamily.summary = n.getObjectValue<ProductFamilySummary>(createProductFamilySummaryFromDiscriminatorValue); },
        "tags": n => { productFamily.tags = n.getCollectionOfPrimitiveValues<string>(); },
        "updatedAt": n => { productFamily.updatedAt = n.getDateValue(); },
        "variants": n => { productFamily.variants = n.getCollectionOfObjectValues<Product>(createProductFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductFamily_imagesByOption(productFamily_imagesByOption: Partial<ProductFamily_imagesByOption> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductFamilyOption(productFamilyOption: Partial<ProductFamilyOption> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { productFamilyOption.displayName = n.getStringValue(); },
        "displayStyle": n => { productFamilyOption.displayStyle = n.getStringValue(); },
        "slug": n => { productFamilyOption.slug = n.getStringValue(); },
        "values": n => { productFamilyOption.values = n.getCollectionOfObjectValues<ProductFamilyOptionValue>(createProductFamilyOptionValueFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductFamilyOptionValue(productFamilyOptionValue: Partial<ProductFamilyOptionValue> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "available": n => { productFamilyOptionValue.available = n.getBooleanValue(); },
        "displayName": n => { productFamilyOptionValue.displayName = n.getStringValue(); },
        "slug": n => { productFamilyOptionValue.slug = n.getStringValue(); },
        "swatchHex": n => { productFamilyOptionValue.swatchHex = n.getStringValue(); },
        "swatchImageUrl": n => { productFamilyOptionValue.swatchImageUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductFamilySummary(productFamilySummary: Partial<ProductFamilySummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "activeVariantCount": n => { productFamilySummary.activeVariantCount = n.getNumberValue(); },
        "availableValues": n => { productFamilySummary.availableValues = n.getCollectionOfPrimitiveValues<string>(); },
        "defaultImage": n => { productFamilySummary.defaultImage = n.getObjectValue<Image>(createImageFromDiscriminatorValue); },
        "priceMax": n => { productFamilySummary.priceMax = n.getNumberValue(); },
        "priceMin": n => { productFamilySummary.priceMin = n.getNumberValue(); },
        "pricesByTier": n => { productFamilySummary.pricesByTier = n.getObjectValue<ProductFamilySummary_pricesByTier>(createProductFamilySummary_pricesByTierFromDiscriminatorValue); },
        "priceTier": n => { productFamilySummary.priceTier = n.getStringValue(); },
        "variantCount": n => { productFamilySummary.variantCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductFamilySummary_pricesByTier(productFamilySummary_pricesByTier: Partial<ProductFamilySummary_pricesByTier> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductOptionDefinition(productOptionDefinition: Partial<ProductOptionDefinition> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { productOptionDefinition.displayName = n.getStringValue(); },
        "displayStyle": n => { productOptionDefinition.displayStyle = n.getEnumValue<ProductOptionDisplayStyle>(ProductOptionDisplayStyleObject); },
        "slug": n => { productOptionDefinition.slug = n.getStringValue(); },
        "values": n => { productOptionDefinition.values = n.getCollectionOfObjectValues<ProductOptionValue>(createProductOptionValueFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductOptionProfileDto(productOptionProfileDto: Partial<ProductOptionProfileDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { productOptionProfileDto.displayName = n.getStringValue(); },
        "displayStyle": n => { productOptionProfileDto.displayStyle = n.getStringValue(); },
        "slug": n => { productOptionProfileDto.slug = n.getStringValue(); },
        "values": n => { productOptionProfileDto.values = n.getCollectionOfObjectValues<ProductOptionValueProfileDto>(createProductOptionValueProfileDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductOptionValue(productOptionValue: Partial<ProductOptionValue> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { productOptionValue.displayName = n.getStringValue(); },
        "slug": n => { productOptionValue.slug = n.getStringValue(); },
        "swatchHex": n => { productOptionValue.swatchHex = n.getStringValue(); },
        "swatchImageId": n => { productOptionValue.swatchImageId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductOptionValueProfileDto(productOptionValueProfileDto: Partial<ProductOptionValueProfileDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { productOptionValueProfileDto.displayName = n.getStringValue(); },
        "slug": n => { productOptionValueProfileDto.slug = n.getStringValue(); },
        "swatchHex": n => { productOptionValueProfileDto.swatchHex = n.getStringValue(); },
        "swatchImageUrl": n => { productOptionValueProfileDto.swatchImageUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductPrice(productPrice: Partial<ProductPrice> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "atQuantity": n => { productPrice.atQuantity = n.getNumberValue(); },
        "price": n => { productPrice.price = n.getNumberValue(); },
        "priceFormatted": n => { productPrice.priceFormatted = n.getStringValue(); },
        "tier": n => { productPrice.tier = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductRevenueRanking(productRevenueRanking: Partial<ProductRevenueRanking> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderCount": n => { productRevenueRanking.orderCount = n.getNumberValue(); },
        "productName": n => { productRevenueRanking.productName = n.getStringValue(); },
        "productsOrdered": n => { productRevenueRanking.productsOrdered = n.getNumberValue(); },
        "sku": n => { productRevenueRanking.sku = n.getStringValue(); },
        "totalRevenue": n => { productRevenueRanking.totalRevenue = n.getNumberValue(); },
        "uniqueOrders": n => { productRevenueRanking.uniqueOrders = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProductsPageSummary(productsPageSummary: Partial<ProductsPageSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "activeProducts": n => { productsPageSummary.activeProducts = n.getNumberValue(); },
        "asOf": n => { productsPageSummary.asOf = n.getDateValue(); },
        "bestSellerName": n => { productsPageSummary.bestSellerName = n.getStringValue(); },
        "bestSellerSku": n => { productsPageSummary.bestSellerSku = n.getStringValue(); },
        "bestSellerUnits": n => { productsPageSummary.bestSellerUnits = n.getNumberValue(); },
        "inactiveProducts": n => { productsPageSummary.inactiveProducts = n.getNumberValue(); },
        "missingImages": n => { productsPageSummary.missingImages = n.getNumberValue(); },
        "outOfStock": n => { productsPageSummary.outOfStock = n.getNumberValue(); },
        "outOfStockTopSellers": n => { productsPageSummary.outOfStockTopSellers = n.getNumberValue(); },
        "topSellerCount": n => { productsPageSummary.topSellerCount = n.getNumberValue(); },
        "totalProducts": n => { productsPageSummary.totalProducts = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotion(promotion: Partial<Promotion> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { promotion.active = n.getBooleanValue(); },
        "benefit": n => { promotion.benefit = n.getObjectValue<Benefit>(createBenefitFromDiscriminatorValue); },
        "categories": n => { promotion.categories = n.getCollectionOfPrimitiveValues<string>(); },
        "minQuantity": n => { promotion.minQuantity = n.getNumberValue(); },
        "minSubtotal": n => { promotion.minSubtotal = n.getNumberValue(); },
        "name": n => { promotion.name = n.getStringValue(); },
        "priority": n => { promotion.priority = n.getNumberValue(); },
        "promotionId": n => { promotion.promotionId = n.getStringValue(); },
        "skus": n => { promotion.skus = n.getCollectionOfPrimitiveValues<string>(); },
        "stackable": n => { promotion.stackable = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotionInput(promotionInput: Partial<PromotionInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { promotionInput.active = n.getBooleanValue(); },
        "benefit": n => { promotionInput.benefit = n.getObjectValue<BenefitInput>(createBenefitInputFromDiscriminatorValue); },
        "categories": n => { promotionInput.categories = n.getCollectionOfPrimitiveValues<string>(); },
        "minQuantity": n => { promotionInput.minQuantity = n.getNumberValue(); },
        "minSubtotal": n => { promotionInput.minSubtotal = n.getNumberValue(); },
        "name": n => { promotionInput.name = n.getStringValue(); },
        "priority": n => { promotionInput.priority = n.getNumberValue(); },
        "promotionId": n => { promotionInput.promotionId = n.getStringValue(); },
        "skus": n => { promotionInput.skus = n.getCollectionOfPrimitiveValues<string>(); },
        "stackable": n => { promotionInput.stackable = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotionPlan(promotionPlan: Partial<PromotionPlan> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applied": n => { promotionPlan.applied = n.getCollectionOfObjectValues<AppliedPromotion>(createAppliedPromotionFromDiscriminatorValue); },
        "appliedCode": n => { promotionPlan.appliedCode = n.getStringValue(); },
        "appliedCodeSkip": n => { promotionPlan.appliedCodeSkip = n.getObjectValue<PromotionSkip>(createPromotionSkipFromDiscriminatorValue); },
        "freeShipping": n => { promotionPlan.freeShipping = n.getObjectValue<FreeShippingEntitlement>(createFreeShippingEntitlementFromDiscriminatorValue); },
        "gifts": n => { promotionPlan.gifts = n.getCollectionOfObjectValues<GiftInstruction>(createGiftInstructionFromDiscriminatorValue); },
        "hasEffects": n => { promotionPlan.hasEffects = n.getBooleanValue(); },
        "lineDiscounts": n => { promotionPlan.lineDiscounts = n.getCollectionOfObjectValues<LineDiscountInstruction>(createLineDiscountInstructionFromDiscriminatorValue); },
        "orderDiscount": n => { promotionPlan.orderDiscount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "skips": n => { promotionPlan.skips = n.getCollectionOfObjectValues<PromotionSkip>(createPromotionSkipFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotionProgress(promotionProgress: Partial<PromotionProgress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "measure": n => { promotionProgress.measure = n.getEnumValue<PromotionMeasure>(PromotionMeasureObject); },
        "measured": n => { promotionProgress.measured = n.getNumberValue(); },
        "percent": n => { promotionProgress.percent = n.getNumberValue(); },
        "required": n => { promotionProgress.required = n.getNumberValue(); },
        "shortfall": n => { promotionProgress.shortfall = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotionSkip(promotionSkip: Partial<PromotionSkip> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { promotionSkip.campaignId = n.getStringValue(); },
        "code": n => { promotionSkip.code = n.getStringValue(); },
        "message": n => { promotionSkip.message = n.getStringValue(); },
        "promotionId": n => { promotionSkip.promotionId = n.getStringValue(); },
        "reason": n => { promotionSkip.reason = n.getEnumValue<PromotionSkipReason>(PromotionSkipReasonObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPushEndpointsRequest(pushEndpointsRequest: Partial<PushEndpointsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endpoints": n => { pushEndpointsRequest.endpoints = n.getCollectionOfObjectValues<ConnectorEndpointDto>(createConnectorEndpointDtoFromDiscriminatorValue); },
        "pushedAt": n => { pushEndpointsRequest.pushedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPushSyncRunRequest(pushSyncRunRequest: Partial<PushSyncRunRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "batchResults": n => { pushSyncRunRequest.batchResults = n.getCollectionOfObjectValues<SyncBatchResultDto>(createSyncBatchResultDtoFromDiscriminatorValue); },
        "completedAt": n => { pushSyncRunRequest.completedAt = n.getDateValue(); },
        "durationSeconds": n => { pushSyncRunRequest.durationSeconds = n.getNumberValue(); },
        "endpointId": n => { pushSyncRunRequest.endpointId = n.getStringValue(); },
        "endpointName": n => { pushSyncRunRequest.endpointName = n.getStringValue(); },
        "errorMessage": n => { pushSyncRunRequest.errorMessage = n.getStringValue(); },
        "failedBatches": n => { pushSyncRunRequest.failedBatches = n.getNumberValue(); },
        "failedRecords": n => { pushSyncRunRequest.failedRecords = n.getNumberValue(); },
        "isManualTrigger": n => { pushSyncRunRequest.isManualTrigger = n.getBooleanValue(); },
        "pushedAt": n => { pushSyncRunRequest.pushedAt = n.getDateValue(); },
        "startedAt": n => { pushSyncRunRequest.startedAt = n.getDateValue(); },
        "status": n => { pushSyncRunRequest.status = n.getStringValue(); },
        "successfulBatches": n => { pushSyncRunRequest.successfulBatches = n.getNumberValue(); },
        "successfulRecords": n => { pushSyncRunRequest.successfulRecords = n.getNumberValue(); },
        "syncMode": n => { pushSyncRunRequest.syncMode = n.getStringValue(); },
        "syncRunId": n => { pushSyncRunRequest.syncRunId = n.getStringValue(); },
        "totalBatches": n => { pushSyncRunRequest.totalBatches = n.getNumberValue(); },
        "totalRecords": n => { pushSyncRunRequest.totalRecords = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoQuantityLimits(quantityLimits: Partial<QuantityLimits> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "max": n => { quantityLimits.max = n.getNumberValue(); },
        "min": n => { quantityLimits.min = n.getNumberValue(); },
        "step": n => { quantityLimits.step = n.getNumberValue(); },
        "type": n => { quantityLimits.type = n.getStringValue(); },
        "values": n => { quantityLimits.values = n.getCollectionOfPrimitiveValues<number>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoQueryFilter(queryFilter: Partial<QueryFilter> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "field": n => { queryFilter.field = n.getStringValue(); },
        "operator": n => { queryFilter.operator = n.getEnumValue<QueryFilter_OperatorType>(QueryFilter_OperatorTypeObject); },
        "value": n => { queryFilter.value = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoQuickBooksAuthResponse(quickBooksAuthResponse: Partial<QuickBooksAuthResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "authUrl": n => { quickBooksAuthResponse.authUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoQuickBooksCompanyInfoResponse_CompanyInfo(quickBooksCompanyInfoResponse_CompanyInfo: Partial<QuickBooksCompanyInfoResponse_CompanyInfo> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "companyName": n => { quickBooksCompanyInfoResponse_CompanyInfo.companyName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoQuickbooksConnectedResponse(quickbooksConnectedResponse: Partial<QuickbooksConnectedResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isConnected": n => { quickbooksConnectedResponse.isConnected = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoQuickBooksTokenRequest(quickBooksTokenRequest: Partial<QuickBooksTokenRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { quickBooksTokenRequest.code = n.getStringValue(); },
        "realmId": n => { quickBooksTokenRequest.realmId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoQuickBooksTokenResponse(quickBooksTokenResponse: Partial<QuickBooksTokenResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessToken": n => { quickBooksTokenResponse.accessToken = n.getStringValue(); },
        "expiresIn": n => { quickBooksTokenResponse.expiresIn = n.getNumberValue(); },
        "refreshToken": n => { quickBooksTokenResponse.refreshToken = n.getStringValue(); },
        "tokenType": n => { quickBooksTokenResponse.tokenType = n.getStringValue(); },
        "xRefreshTokenExpiresIn": n => { quickBooksTokenResponse.xRefreshTokenExpiresIn = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoQuietAccount(quietAccount: Partial<QuietAccount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "companyName": n => { quietAccount.companyName = n.getStringValue(); },
        "customerNumber": n => { quietAccount.customerNumber = n.getStringValue(); },
        "daysQuiet": n => { quietAccount.daysQuiet = n.getNumberValue(); },
        "lastOrderDate": n => { quietAccount.lastOrderDate = n.getDateValue(); },
        "lifetimeRevenue": n => { quietAccount.lifetimeRevenue = n.getNumberValue(); },
        "repName": n => { quietAccount.repName = n.getStringValue(); },
        "terms": n => { quietAccount.terms = n.getStringValue(); },
        "trailingYearRevenue": n => { quietAccount.trailingYearRevenue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRawBodyRequest(rawBodyRequest: Partial<RawBodyRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "content": n => { rawBodyRequest.content = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReactivateVendorRequest(reactivateVendorRequest: Partial<ReactivateVendorRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoAgencyScopedRequest(reactivateVendorRequest),
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReadmeAuthResponse(readmeAuthResponse: Partial<ReadmeAuthResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "readmeAuthUrl": n => { readmeAuthResponse.readmeAuthUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReassignCustomerRequest(reassignCustomerRequest: Partial<ReassignCustomerRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fromCustomerNumber": n => { reassignCustomerRequest.fromCustomerNumber = n.getStringValue(); },
        "toCustomerNumber": n => { reassignCustomerRequest.toCustomerNumber = n.getStringValue(); },
        "userId": n => { reassignCustomerRequest.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReassignCustomerResponse(reassignCustomerResponse: Partial<ReassignCustomerResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { reassignCustomerResponse.customerNumber = n.getStringValue(); },
        "previousCustomerNumber": n => { reassignCustomerResponse.previousCustomerNumber = n.getStringValue(); },
        "reassigned": n => { reassignCustomerResponse.reassigned = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReconcileRepNumberChannelsRequest(reconcileRepNumberChannelsRequest: Partial<ReconcileRepNumberChannelsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "organizationSalesRepId": n => { reconcileRepNumberChannelsRequest.organizationSalesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReconcileRepNumberChannelsResponse(reconcileRepNumberChannelsResponse: Partial<ReconcileRepNumberChannelsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "channelsGranted": n => { reconcileRepNumberChannelsResponse.channelsGranted = n.getNumberValue(); },
        "channelsRevoked": n => { reconcileRepNumberChannelsResponse.channelsRevoked = n.getNumberValue(); },
        "collectionsGranted": n => { reconcileRepNumberChannelsResponse.collectionsGranted = n.getNumberValue(); },
        "failed": n => { reconcileRepNumberChannelsResponse.failed = n.getCollectionOfPrimitiveValues<string>(); },
        "organizationId": n => { reconcileRepNumberChannelsResponse.organizationId = n.getStringValue(); },
        "repsExamined": n => { reconcileRepNumberChannelsResponse.repsExamined = n.getNumberValue(); },
        "repsUnchanged": n => { reconcileRepNumberChannelsResponse.repsUnchanged = n.getNumberValue(); },
        "skippedInactive": n => { reconcileRepNumberChannelsResponse.skippedInactive = n.getNumberValue(); },
        "skippedNoSyncUser": n => { reconcileRepNumberChannelsResponse.skippedNoSyncUser = n.getNumberValue(); },
        "success": n => { reconcileRepNumberChannelsResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRecordPaymentRequest(recordPaymentRequest: Partial<RecordPaymentRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { recordPaymentRequest.amount = n.getNumberValue(); },
        "cardType": n => { recordPaymentRequest.cardType = n.getStringValue(); },
        "currencyCode": n => { recordPaymentRequest.currencyCode = n.getStringValue(); },
        "last4Digits": n => { recordPaymentRequest.last4Digits = n.getStringValue(); },
        "method": n => { recordPaymentRequest.method = n.getStringValue(); },
        "notes": n => { recordPaymentRequest.notes = n.getStringValue(); },
        "orgCodes": n => { recordPaymentRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "paymentDate": n => { recordPaymentRequest.paymentDate = n.getDateValue(); },
        "paymentProfileId": n => { recordPaymentRequest.paymentProfileId = n.getStringValue(); },
        "reference": n => { recordPaymentRequest.reference = n.getStringValue(); },
        "status": n => { recordPaymentRequest.status = n.getStringValue(); },
        "useOrganizationId": n => { recordPaymentRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRefreshProductFamilySummariesResponse(refreshProductFamilySummariesResponse: Partial<RefreshProductFamilySummariesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "refreshed": n => { refreshProductFamilySummariesResponse.refreshed = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRefreshUrlResponse(refreshUrlResponse: Partial<RefreshUrlResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cdnUrl": n => { refreshUrlResponse.cdnUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRefundPaymentRequest(refundPaymentRequest: Partial<RefundPaymentRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { refundPaymentRequest.amount = n.getNumberValue(); },
        "notes": n => { refundPaymentRequest.notes = n.getStringValue(); },
        "orgCodes": n => { refundPaymentRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "reference": n => { refundPaymentRequest.reference = n.getStringValue(); },
        "useOrganizationId": n => { refundPaymentRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRegisterSqlConnectorRequest(registerSqlConnectorRequest: Partial<RegisterSqlConnectorRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "connectorName": n => { registerSqlConnectorRequest.connectorName = n.getStringValue(); },
        "hostName": n => { registerSqlConnectorRequest.hostName = n.getStringValue(); },
        "metadata": n => { registerSqlConnectorRequest.metadata = n.getObjectValue<RegisterSqlConnectorRequest_metadata>(createRegisterSqlConnectorRequest_metadataFromDiscriminatorValue); },
        "version": n => { registerSqlConnectorRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRegisterSqlConnectorRequest_metadata(registerSqlConnectorRequest_metadata: Partial<RegisterSqlConnectorRequest_metadata> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRemoveDiscountRequest(removeDiscountRequest: Partial<RemoveDiscountRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { removeDiscountRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { removeDiscountRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRemoveItemFromListRequest(removeItemFromListRequest: Partial<RemoveItemFromListRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { removeItemFromListRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { removeItemFromListRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRemoveVendorImageRequest(removeVendorImageRequest: Partial<RemoveVendorImageRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoAgencyScopedRequest(removeVendorImageRequest),
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRenameListRequest(renameListRequest: Partial<RenameListRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "newName": n => { renameListRequest.newName = n.getStringValue(); },
        "orgCodes": n => { renameListRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { renameListRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderCategoriesRequest(reorderCategoriesRequest: Partial<ReorderCategoriesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categories": n => { reorderCategoriesRequest.categories = n.getCollectionOfPrimitiveValues<string>(); },
        "parentPath": n => { reorderCategoriesRequest.parentPath = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderCategoriesResponse(reorderCategoriesResponse: Partial<ReorderCategoriesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categories": n => { reorderCategoriesResponse.categories = n.getCollectionOfPrimitiveValues<string>(); },
        "parentPath": n => { reorderCategoriesResponse.parentPath = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderCustomerAttributesRequest(reorderCustomerAttributesRequest: Partial<ReorderCustomerAttributesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "slugs": n => { reorderCustomerAttributesRequest.slugs = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderCustomerAttributesResponse(reorderCustomerAttributesResponse: Partial<ReorderCustomerAttributesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerAttributes": n => { reorderCustomerAttributesResponse.customerAttributes = n.getCollectionOfObjectValues<CustomerAttribute>(createCustomerAttributeFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderFulfillmentMethodsRequest(reorderFulfillmentMethodsRequest: Partial<ReorderFulfillmentMethodsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fulfillmentMethods": n => { reorderFulfillmentMethodsRequest.fulfillmentMethods = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderFulfillmentMethodsResponse(reorderFulfillmentMethodsResponse: Partial<ReorderFulfillmentMethodsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fulfillmentMethods": n => { reorderFulfillmentMethodsResponse.fulfillmentMethods = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderOrderStatusesRequest(reorderOrderStatusesRequest: Partial<ReorderOrderStatusesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderStatuses": n => { reorderOrderStatusesRequest.orderStatuses = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderOrderStatusesResponse(reorderOrderStatusesResponse: Partial<ReorderOrderStatusesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderStatuses": n => { reorderOrderStatusesResponse.orderStatuses = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderOrderTypesRequest(reorderOrderTypesRequest: Partial<ReorderOrderTypesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderTypes": n => { reorderOrderTypesRequest.orderTypes = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderOrderTypesResponse(reorderOrderTypesResponse: Partial<ReorderOrderTypesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderTypes": n => { reorderOrderTypesResponse.orderTypes = n.getCollectionOfObjectValues<OrderTypeResponse>(createOrderTypeResponseFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderProductAttributesRequest(reorderProductAttributesRequest: Partial<ReorderProductAttributesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "slugs": n => { reorderProductAttributesRequest.slugs = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderProductAttributesResponse(reorderProductAttributesResponse: Partial<ReorderProductAttributesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productAttributes": n => { reorderProductAttributesResponse.productAttributes = n.getCollectionOfObjectValues<ProductAttribute>(createProductAttributeFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderProductsRequest(reorderProductsRequest: Partial<ReorderProductsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "category": n => { reorderProductsRequest.category = n.getStringValue(); },
        "skus": n => { reorderProductsRequest.skus = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderProductsResponse(reorderProductsResponse: Partial<ReorderProductsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "category": n => { reorderProductsResponse.category = n.getStringValue(); },
        "skus": n => { reorderProductsResponse.skus = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderTasksRequest(reorderTasksRequest: Partial<ReorderTasksRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { reorderTasksRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "taskItemIds": n => { reorderTasksRequest.taskItemIds = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { reorderTasksRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderTermsRequest(reorderTermsRequest: Partial<ReorderTermsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "terms": n => { reorderTermsRequest.terms = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReorderTermsResponse(reorderTermsResponse: Partial<ReorderTermsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "terms": n => { reorderTermsResponse.terms = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRep(rep: Partial<Rep> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { rep.email = n.getStringValue(); },
        "firstName": n => { rep.firstName = n.getStringValue(); },
        "fullName": n => { rep.fullName = n.getStringValue(); },
        "lastName": n => { rep.lastName = n.getStringValue(); },
        "marketCode": n => { rep.marketCode = n.getStringValue(); },
        "organizationSalesRepId": n => { rep.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { rep.phoneNumber = n.getStringValue(); },
        "repNumber": n => { rep.repNumber = n.getStringValue(); },
        "salesRepId": n => { rep.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReplaceProductOptionsRequest(replaceProductOptionsRequest: Partial<ReplaceProductOptionsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "options": n => { replaceProductOptionsRequest.options = n.getCollectionOfObjectValues<ReplaceProductOptionsRequest_ProductOptionInput>(createReplaceProductOptionsRequest_ProductOptionInputFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReplaceProductOptionsRequest_ProductOptionInput(replaceProductOptionsRequest_ProductOptionInput: Partial<ReplaceProductOptionsRequest_ProductOptionInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { replaceProductOptionsRequest_ProductOptionInput.displayName = n.getStringValue(); },
        "displayStyle": n => { replaceProductOptionsRequest_ProductOptionInput.displayStyle = n.getStringValue(); },
        "slug": n => { replaceProductOptionsRequest_ProductOptionInput.slug = n.getStringValue(); },
        "values": n => { replaceProductOptionsRequest_ProductOptionInput.values = n.getCollectionOfObjectValues<ReplaceProductOptionsRequest_ProductOptionValueInput>(createReplaceProductOptionsRequest_ProductOptionValueInputFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReplaceProductOptionsRequest_ProductOptionValueInput(replaceProductOptionsRequest_ProductOptionValueInput: Partial<ReplaceProductOptionsRequest_ProductOptionValueInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "displayName": n => { replaceProductOptionsRequest_ProductOptionValueInput.displayName = n.getStringValue(); },
        "slug": n => { replaceProductOptionsRequest_ProductOptionValueInput.slug = n.getStringValue(); },
        "swatchHex": n => { replaceProductOptionsRequest_ProductOptionValueInput.swatchHex = n.getStringValue(); },
        "swatchImageName": n => { replaceProductOptionsRequest_ProductOptionValueInput.swatchImageName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReportMappingOutcomeRequest(reportMappingOutcomeRequest: Partial<ReportMappingOutcomeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "columns": n => { reportMappingOutcomeRequest.columns = n.getCollectionOfObjectValues<MappingOutcomeColumn>(createMappingOutcomeColumnFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResearchAccessRequestResponse(researchAccessRequestResponse: Partial<ResearchAccessRequestResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessRequestId": n => { researchAccessRequestResponse.accessRequestId = n.getStringValue(); },
        "companyName": n => { researchAccessRequestResponse.companyName = n.getStringValue(); },
        "eligibilityScore": n => { researchAccessRequestResponse.eligibilityScore = n.getNumberValue(); },
        "estimatedCostUsd": n => { researchAccessRequestResponse.estimatedCostUsd = n.getNumberValue(); },
        "generatedAt": n => { researchAccessRequestResponse.generatedAt = n.getDateValue(); },
        "isCached": n => { researchAccessRequestResponse.isCached = n.getBooleanValue(); },
        "research": n => { researchAccessRequestResponse.research = n.getStringValue(); },
        "tokensUsed": n => { researchAccessRequestResponse.tokensUsed = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResearchedAddress(researchedAddress: Partial<ResearchedAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address1": n => { researchedAddress.address1 = n.getStringValue(); },
        "address2": n => { researchedAddress.address2 = n.getStringValue(); },
        "city": n => { researchedAddress.city = n.getStringValue(); },
        "country": n => { researchedAddress.country = n.getStringValue(); },
        "postalCode": n => { researchedAddress.postalCode = n.getStringValue(); },
        "source": n => { researchedAddress.source = n.getStringValue(); },
        "stateProvince": n => { researchedAddress.stateProvince = n.getStringValue(); },
        "verified": n => { researchedAddress.verified = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResearchedValue(researchedValue: Partial<ResearchedValue> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "source": n => { researchedValue.source = n.getStringValue(); },
        "value": n => { researchedValue.value = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResendSalesRepWelcomeRequest(resendSalesRepWelcomeRequest: Partial<ResendSalesRepWelcomeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { resendSalesRepWelcomeRequest.email = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResendSalesRepWelcomeResponse(resendSalesRepWelcomeResponse: Partial<ResendSalesRepWelcomeResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { resendSalesRepWelcomeResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResendWelcomeEmailRequest(resendWelcomeEmailRequest: Partial<ResendWelcomeEmailRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { resendWelcomeEmailRequest.email = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResendWelcomeEmailResponse(resendWelcomeEmailResponse: Partial<ResendWelcomeEmailResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { resendWelcomeEmailResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRestoreAccessRequestResponse(restoreAccessRequestResponse: Partial<RestoreAccessRequestResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessRequestId": n => { restoreAccessRequestResponse.accessRequestId = n.getStringValue(); },
        "status": n => { restoreAccessRequestResponse.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRestoreTrashedImagesRequest(restoreTrashedImagesRequest: Partial<RestoreTrashedImagesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "imageIds": n => { restoreTrashedImagesRequest.imageIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRestoreTrashedImagesResponse(restoreTrashedImagesResponse: Partial<RestoreTrashedImagesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "restoredCount": n => { restoreTrashedImagesResponse.restoredCount = n.getNumberValue(); },
        "restoredImageIds": n => { restoreTrashedImagesResponse.restoredImageIds = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResult(result: Partial<Result> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address_components": n => { result.addressComponents = n.getCollectionOfObjectValues<AddressComponent>(createAddressComponentFromDiscriminatorValue); },
        "formatted_address": n => { result.formattedAddress = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoReturnToReviewRequest(returnToReviewRequest: Partial<ReturnToReviewRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { returnToReviewRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { returnToReviewRequest.useOrganizationId = n.getStringValue(); },
        "user": n => { returnToReviewRequest.user = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevenueKpi(revenueKpi: Partial<RevenueKpi> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endDate": n => { revenueKpi.endDate = n.getDateValue(); },
        "organizationId": n => { revenueKpi.organizationId = n.getStringValue(); },
        "startDate": n => { revenueKpi.startDate = n.getDateValue(); },
        "totalRevenue": n => { revenueKpi.totalRevenue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevokeCustomerAccessResponse(revokeCustomerAccessResponse: Partial<RevokeCustomerAccessResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "removed": n => { revokeCustomerAccessResponse.removed = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevokeOrganizationApiKeyResponse(revokeOrganizationApiKeyResponse: Partial<RevokeOrganizationApiKeyResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "keyId": n => { revokeOrganizationApiKeyResponse.keyId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRotateIntegrationSecretsRequest(rotateIntegrationSecretsRequest: Partial<RotateIntegrationSecretsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "newSecrets": n => { rotateIntegrationSecretsRequest.newSecrets = n.getObjectValue<RotateIntegrationSecretsRequest_newSecrets>(createRotateIntegrationSecretsRequest_newSecretsFromDiscriminatorValue); },
        "testConnectionAfterRotation": n => { rotateIntegrationSecretsRequest.testConnectionAfterRotation = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRotateIntegrationSecretsRequest_newSecrets(rotateIntegrationSecretsRequest_newSecrets: Partial<RotateIntegrationSecretsRequest_newSecrets> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRotateIntegrationSecretsResponse(rotateIntegrationSecretsResponse: Partial<RotateIntegrationSecretsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "integrationId": n => { rotateIntegrationSecretsResponse.integrationId = n.getStringValue(); },
        "message": n => { rotateIntegrationSecretsResponse.message = n.getStringValue(); },
        "organizationId": n => { rotateIntegrationSecretsResponse.organizationId = n.getStringValue(); },
        "rotatedAt": n => { rotateIntegrationSecretsResponse.rotatedAt = n.getDateValue(); },
        "rotatedSecretKeys": n => { rotateIntegrationSecretsResponse.rotatedSecretKeys = n.getCollectionOfPrimitiveValues<string>(); },
        "rotationSuccessful": n => { rotateIntegrationSecretsResponse.rotationSuccessful = n.getBooleanValue(); },
        "testConnectionSuccessful": n => { rotateIntegrationSecretsResponse.testConnectionSuccessful = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRotateOrganizationApiKeyResponse(rotateOrganizationApiKeyResponse: Partial<RotateOrganizationApiKeyResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiKey": n => { rotateOrganizationApiKeyResponse.apiKey = n.getStringValue(); },
        "keyId": n => { rotateOrganizationApiKeyResponse.keyId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSalesRep(salesRep: Partial<SalesRep> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { salesRep.email = n.getStringValue(); },
        "firstName": n => { salesRep.firstName = n.getStringValue(); },
        "fullName": n => { salesRep.fullName = n.getStringValue(); },
        "lastName": n => { salesRep.lastName = n.getStringValue(); },
        "marketCode": n => { salesRep.marketCode = n.getStringValue(); },
        "organizationSalesRepId": n => { salesRep.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { salesRep.phoneNumber = n.getStringValue(); },
        "repNumber": n => { salesRep.repNumber = n.getStringValue(); },
        "salesRepId": n => { salesRep.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSalesRep2(salesRep2: Partial<SalesRep2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { salesRep2.email = n.getStringValue(); },
        "firstName": n => { salesRep2.firstName = n.getStringValue(); },
        "fullName": n => { salesRep2.fullName = n.getStringValue(); },
        "lastName": n => { salesRep2.lastName = n.getStringValue(); },
        "organizationSalesRepId": n => { salesRep2.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { salesRep2.phoneNumber = n.getStringValue(); },
        "repNumber": n => { salesRep2.repNumber = n.getStringValue(); },
        "salesRepId": n => { salesRep2.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSalesRepDeviceDto(salesRepDeviceDto: Partial<SalesRepDeviceDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "appVersion": n => { salesRepDeviceDto.appVersion = n.getStringValue(); },
        "buildNumber": n => { salesRepDeviceDto.buildNumber = n.getStringValue(); },
        "deviceId": n => { salesRepDeviceDto.deviceId = n.getStringValue(); },
        "deviceModel": n => { salesRepDeviceDto.deviceModel = n.getStringValue(); },
        "firstSeenAt": n => { salesRepDeviceDto.firstSeenAt = n.getDateValue(); },
        "lastLoginAt": n => { salesRepDeviceDto.lastLoginAt = n.getDateValue(); },
        "lastSeenAt": n => { salesRepDeviceDto.lastSeenAt = n.getDateValue(); },
        "osVersion": n => { salesRepDeviceDto.osVersion = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSalesRepDto(salesRepDto: Partial<SalesRepDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { salesRepDto.email = n.getStringValue(); },
        "firstName": n => { salesRepDto.firstName = n.getStringValue(); },
        "fullName": n => { salesRepDto.fullName = n.getStringValue(); },
        "lastName": n => { salesRepDto.lastName = n.getStringValue(); },
        "marketCode": n => { salesRepDto.marketCode = n.getStringValue(); },
        "organizationSalesRepId": n => { salesRepDto.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { salesRepDto.phoneNumber = n.getStringValue(); },
        "repNumber": n => { salesRepDto.repNumber = n.getStringValue(); },
        "salesRepId": n => { salesRepDto.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSalesRepInput(salesRepInput: Partial<SalesRepInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { salesRepInput.email = n.getStringValue(); },
        "firstName": n => { salesRepInput.firstName = n.getStringValue(); },
        "lastName": n => { salesRepInput.lastName = n.getStringValue(); },
        "organizationSalesRepId": n => { salesRepInput.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { salesRepInput.phoneNumber = n.getStringValue(); },
        "repNumber": n => { salesRepInput.repNumber = n.getStringValue(); },
        "salesRepId": n => { salesRepInput.salesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSalesRepRevenueRanking(salesRepRevenueRanking: Partial<SalesRepRevenueRanking> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "averageItemsPerOrder": n => { salesRepRevenueRanking.averageItemsPerOrder = n.getNumberValue(); },
        "averageOrderSize": n => { salesRepRevenueRanking.averageOrderSize = n.getNumberValue(); },
        "email": n => { salesRepRevenueRanking.email = n.getStringValue(); },
        "firstName": n => { salesRepRevenueRanking.firstName = n.getStringValue(); },
        "fullName": n => { salesRepRevenueRanking.fullName = n.getStringValue(); },
        "lastName": n => { salesRepRevenueRanking.lastName = n.getStringValue(); },
        "orderCount": n => { salesRepRevenueRanking.orderCount = n.getNumberValue(); },
        "organizationSalesRepId": n => { salesRepRevenueRanking.organizationSalesRepId = n.getStringValue(); },
        "phoneNumber": n => { salesRepRevenueRanking.phoneNumber = n.getStringValue(); },
        "repNumber": n => { salesRepRevenueRanking.repNumber = n.getStringValue(); },
        "salesRepId": n => { salesRepRevenueRanking.salesRepId = n.getStringValue(); },
        "totalRevenue": n => { salesRepRevenueRanking.totalRevenue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSalesRepTrend(salesRepTrend: Partial<SalesRepTrend> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fullName": n => { salesRepTrend.fullName = n.getStringValue(); },
        "orderCount": n => { salesRepTrend.orderCount = n.getNumberValue(); },
        "organizationSalesRepId": n => { salesRepTrend.organizationSalesRepId = n.getStringValue(); },
        "points": n => { salesRepTrend.points = n.getCollectionOfObjectValues<SalesTrendPoint>(createSalesTrendPointFromDiscriminatorValue); },
        "salesRepId": n => { salesRepTrend.salesRepId = n.getStringValue(); },
        "totalRevenue": n => { salesRepTrend.totalRevenue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSalesTrendPoint(salesTrendPoint: Partial<SalesTrendPoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderCount": n => { salesTrendPoint.orderCount = n.getNumberValue(); },
        "periodStart": n => { salesTrendPoint.periodStart = n.getStringValue(); },
        "revenue": n => { salesTrendPoint.revenue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSavePaymentMethodRequest(savePaymentMethodRequest: Partial<SavePaymentMethodRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "appUrl": n => { savePaymentMethodRequest.appUrl = n.getStringValue(); },
        "billingAddress": n => { savePaymentMethodRequest.billingAddress = n.getObjectValue<BillingAddress>(createBillingAddressFromDiscriminatorValue); },
        "cardCode": n => { savePaymentMethodRequest.cardCode = n.getStringValue(); },
        "cardNumber": n => { savePaymentMethodRequest.cardNumber = n.getStringValue(); },
        "customerNumber": n => { savePaymentMethodRequest.customerNumber = n.getStringValue(); },
        "emailAddress": n => { savePaymentMethodRequest.emailAddress = n.getStringValue(); },
        "expirationMonth": n => { savePaymentMethodRequest.expirationMonth = n.getStringValue(); },
        "expirationYear": n => { savePaymentMethodRequest.expirationYear = n.getStringValue(); },
        "isDefault": n => { savePaymentMethodRequest.isDefault = n.getBooleanValue(); },
        "orgCodes": n => { savePaymentMethodRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "paymentProvider": n => { savePaymentMethodRequest.paymentProvider = n.getStringValue(); },
        "useOrganizationId": n => { savePaymentMethodRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSavePaymentMethodResponse(savePaymentMethodResponse: Partial<SavePaymentMethodResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "paymentMethod": n => { savePaymentMethodResponse.paymentMethod = n.getObjectValue<PaymentMethod>(createPaymentMethodFromDiscriminatorValue); },
        "provider": n => { savePaymentMethodResponse.provider = n.getStringValue(); },
        "redirectUrl": n => { savePaymentMethodResponse.redirectUrl = n.getStringValue(); },
        "requiresRedirect": n => { savePaymentMethodResponse.requiresRedirect = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSaveProductFamilyRequest(saveProductFamilyRequest: Partial<SaveProductFamilyRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { saveProductFamilyRequest.active = n.getBooleanValue(); },
        "category": n => { saveProductFamilyRequest.category = n.getStringValue(); },
        "description": n => { saveProductFamilyRequest.description = n.getStringValue(); },
        "externalId": n => { saveProductFamilyRequest.externalId = n.getStringValue(); },
        "familyKey": n => { saveProductFamilyRequest.familyKey = n.getStringValue(); },
        "images": n => { saveProductFamilyRequest.images = n.getCollectionOfPrimitiveValues<string>(); },
        "imagesByOption": n => { saveProductFamilyRequest.imagesByOption = n.getObjectValue<SaveProductFamilyRequest_imagesByOption>(createSaveProductFamilyRequest_imagesByOptionFromDiscriminatorValue); },
        "name": n => { saveProductFamilyRequest.name = n.getStringValue(); },
        "options": n => { saveProductFamilyRequest.options = n.getCollectionOfObjectValues<SaveProductFamilyRequest_SaveProductFamilyOption>(createSaveProductFamilyRequest_SaveProductFamilyOptionFromDiscriminatorValue); },
        "tags": n => { saveProductFamilyRequest.tags = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSaveProductFamilyRequest_imagesByOption(saveProductFamilyRequest_imagesByOption: Partial<SaveProductFamilyRequest_imagesByOption> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSaveProductFamilyRequest_SaveProductFamilyOption(saveProductFamilyRequest_SaveProductFamilyOption: Partial<SaveProductFamilyRequest_SaveProductFamilyOption> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "option": n => { saveProductFamilyRequest_SaveProductFamilyOption.option = n.getStringValue(); },
        "values": n => { saveProductFamilyRequest_SaveProductFamilyOption.values = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSaveSignupProgressRequest(saveSignupProgressRequest: Partial<SaveSignupProgressRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "city": n => { saveSignupProgressRequest.city = n.getStringValue(); },
        "companyEmail": n => { saveSignupProgressRequest.companyEmail = n.getStringValue(); },
        "companyName": n => { saveSignupProgressRequest.companyName = n.getStringValue(); },
        "companyPhone": n => { saveSignupProgressRequest.companyPhone = n.getStringValue(); },
        "companyWebsite": n => { saveSignupProgressRequest.companyWebsite = n.getStringValue(); },
        "country": n => { saveSignupProgressRequest.country = n.getStringValue(); },
        "email": n => { saveSignupProgressRequest.email = n.getStringValue(); },
        "firstName": n => { saveSignupProgressRequest.firstName = n.getStringValue(); },
        "lastName": n => { saveSignupProgressRequest.lastName = n.getStringValue(); },
        "phoneNumber": n => { saveSignupProgressRequest.phoneNumber = n.getStringValue(); },
        "stateProvince": n => { saveSignupProgressRequest.stateProvince = n.getStringValue(); },
        "step": n => { saveSignupProgressRequest.step = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSecretField(secretField: Partial<SecretField> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "description": n => { secretField.description = n.getStringValue(); },
        "displayName": n => { secretField.displayName = n.getStringValue(); },
        "isSensitive": n => { secretField.isSensitive = n.getBooleanValue(); },
        "key": n => { secretField.key = n.getStringValue(); },
        "maxLength": n => { secretField.maxLength = n.getNumberValue(); },
        "placeholderText": n => { secretField.placeholderText = n.getStringValue(); },
        "required": n => { secretField.required = n.getBooleanValue(); },
        "validationPattern": n => { secretField.validationPattern = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSendCartShareMessageRequest(sendCartShareMessageRequest: Partial<SendCartShareMessageRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "body": n => { sendCartShareMessageRequest.body = n.getStringValue(); },
        "cart": n => { sendCartShareMessageRequest.cart = n.getObjectValue<CartShareSnapshotRequest>(createCartShareSnapshotRequestFromDiscriminatorValue); },
        "emails": n => { sendCartShareMessageRequest.emails = n.getCollectionOfPrimitiveValues<string>(); },
        "orgCodes": n => { sendCartShareMessageRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "phoneNumbers": n => { sendCartShareMessageRequest.phoneNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "sendViaEmail": n => { sendCartShareMessageRequest.sendViaEmail = n.getBooleanValue(); },
        "sendViaSms": n => { sendCartShareMessageRequest.sendViaSms = n.getBooleanValue(); },
        "subject": n => { sendCartShareMessageRequest.subject = n.getStringValue(); },
        "useOrganizationId": n => { sendCartShareMessageRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSendCartShareMessageResponse(sendCartShareMessageResponse: Partial<SendCartShareMessageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "emailsSent": n => { sendCartShareMessageResponse.emailsSent = n.getNumberValue(); },
        "errors": n => { sendCartShareMessageResponse.errors = n.getCollectionOfPrimitiveValues<string>(); },
        "messageId": n => { sendCartShareMessageResponse.messageId = n.getStringValue(); },
        "smsSent": n => { sendCartShareMessageResponse.smsSent = n.getNumberValue(); },
        "status": n => { sendCartShareMessageResponse.status = n.getStringValue(); },
        "totalRecipients": n => { sendCartShareMessageResponse.totalRecipients = n.getNumberValue(); },
        "viewOnlineUrl": n => { sendCartShareMessageResponse.viewOnlineUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSendCompanyDocsMessageRequest(sendCompanyDocsMessageRequest: Partial<SendCompanyDocsMessageRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "body": n => { sendCompanyDocsMessageRequest.body = n.getStringValue(); },
        "documentIds": n => { sendCompanyDocsMessageRequest.documentIds = n.getCollectionOfPrimitiveValues<string>(); },
        "emails": n => { sendCompanyDocsMessageRequest.emails = n.getCollectionOfPrimitiveValues<string>(); },
        "orgCodes": n => { sendCompanyDocsMessageRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "phoneNumbers": n => { sendCompanyDocsMessageRequest.phoneNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "sendViaEmail": n => { sendCompanyDocsMessageRequest.sendViaEmail = n.getBooleanValue(); },
        "sendViaSms": n => { sendCompanyDocsMessageRequest.sendViaSms = n.getBooleanValue(); },
        "subject": n => { sendCompanyDocsMessageRequest.subject = n.getStringValue(); },
        "useOrganizationId": n => { sendCompanyDocsMessageRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSendCompanyDocsMessageResponse(sendCompanyDocsMessageResponse: Partial<SendCompanyDocsMessageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "emailsSent": n => { sendCompanyDocsMessageResponse.emailsSent = n.getNumberValue(); },
        "errors": n => { sendCompanyDocsMessageResponse.errors = n.getCollectionOfPrimitiveValues<string>(); },
        "messageId": n => { sendCompanyDocsMessageResponse.messageId = n.getStringValue(); },
        "smsSent": n => { sendCompanyDocsMessageResponse.smsSent = n.getNumberValue(); },
        "status": n => { sendCompanyDocsMessageResponse.status = n.getStringValue(); },
        "totalRecipients": n => { sendCompanyDocsMessageResponse.totalRecipients = n.getNumberValue(); },
        "viewOnlineUrl": n => { sendCompanyDocsMessageResponse.viewOnlineUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSendTearSheetsMessageRequest(sendTearSheetsMessageRequest: Partial<SendTearSheetsMessageRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "body": n => { sendTearSheetsMessageRequest.body = n.getStringValue(); },
        "customerNumber": n => { sendTearSheetsMessageRequest.customerNumber = n.getStringValue(); },
        "emails": n => { sendTearSheetsMessageRequest.emails = n.getCollectionOfPrimitiveValues<string>(); },
        "orgCodes": n => { sendTearSheetsMessageRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "phoneNumbers": n => { sendTearSheetsMessageRequest.phoneNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "productIds": n => { sendTearSheetsMessageRequest.productIds = n.getCollectionOfPrimitiveValues<string>(); },
        "sendViaEmail": n => { sendTearSheetsMessageRequest.sendViaEmail = n.getBooleanValue(); },
        "sendViaSms": n => { sendTearSheetsMessageRequest.sendViaSms = n.getBooleanValue(); },
        "subject": n => { sendTearSheetsMessageRequest.subject = n.getStringValue(); },
        "useOrganizationId": n => { sendTearSheetsMessageRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSendTearSheetsMessageResponse(sendTearSheetsMessageResponse: Partial<SendTearSheetsMessageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "emailsSent": n => { sendTearSheetsMessageResponse.emailsSent = n.getNumberValue(); },
        "errors": n => { sendTearSheetsMessageResponse.errors = n.getCollectionOfPrimitiveValues<string>(); },
        "messageId": n => { sendTearSheetsMessageResponse.messageId = n.getStringValue(); },
        "smsSent": n => { sendTearSheetsMessageResponse.smsSent = n.getNumberValue(); },
        "status": n => { sendTearSheetsMessageResponse.status = n.getStringValue(); },
        "tearSheetId": n => { sendTearSheetsMessageResponse.tearSheetId = n.getStringValue(); },
        "totalRecipients": n => { sendTearSheetsMessageResponse.totalRecipients = n.getNumberValue(); },
        "viewOnlineUrl": n => { sendTearSheetsMessageResponse.viewOnlineUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSentEmailDetailDto(sentEmailDetailDto: Partial<SentEmailDetailDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoSentEmailDto(sentEmailDetailDto),
        "events": n => { sentEmailDetailDto.events = n.getCollectionOfObjectValues<SentEmailEventDto>(createSentEmailEventDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSentEmailDto(sentEmailDto: Partial<SentEmailDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "audience": n => { sentEmailDto.audience = n.getStringValue(); },
        "bounceReason": n => { sentEmailDto.bounceReason = n.getStringValue(); },
        "bounceType": n => { sentEmailDto.bounceType = n.getStringValue(); },
        "clickCount": n => { sentEmailDto.clickCount = n.getNumberValue(); },
        "entityId": n => { sentEmailDto.entityId = n.getStringValue(); },
        "entityReference": n => { sentEmailDto.entityReference = n.getStringValue(); },
        "firstClickedAt": n => { sentEmailDto.firstClickedAt = n.getDateValue(); },
        "firstOpenedAt": n => { sentEmailDto.firstOpenedAt = n.getDateValue(); },
        "id": n => { sentEmailDto.id = n.getStringValue(); },
        "kind": n => { sentEmailDto.kind = n.getStringValue(); },
        "lastClickedAt": n => { sentEmailDto.lastClickedAt = n.getDateValue(); },
        "lastOpenedAt": n => { sentEmailDto.lastOpenedAt = n.getDateValue(); },
        "latestStatus": n => { sentEmailDto.latestStatus = n.getStringValue(); },
        "latestStatusAt": n => { sentEmailDto.latestStatusAt = n.getDateValue(); },
        "messageId": n => { sentEmailDto.messageId = n.getStringValue(); },
        "openCount": n => { sentEmailDto.openCount = n.getNumberValue(); },
        "recipient": n => { sentEmailDto.recipient = n.getStringValue(); },
        "sentAt": n => { sentEmailDto.sentAt = n.getDateValue(); },
        "subject": n => { sentEmailDto.subject = n.getStringValue(); },
        "template": n => { sentEmailDto.template = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSentEmailEventDto(sentEmailEventDto: Partial<SentEmailEventDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "link": n => { sentEmailEventDto.link = n.getStringValue(); },
        "occurredAt": n => { sentEmailEventDto.occurredAt = n.getDateValue(); },
        "reason": n => { sentEmailEventDto.reason = n.getStringValue(); },
        "type": n => { sentEmailEventDto.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetAsDefaultRequest(setAsDefaultRequest: Partial<SetAsDefaultRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { setAsDefaultRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { setAsDefaultRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetCampaignActiveRequest(setCampaignActiveRequest: Partial<SetCampaignActiveRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { setCampaignActiveRequest.active = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetCodeActiveRequest(setCodeActiveRequest: Partial<SetCodeActiveRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { setCodeActiveRequest.active = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetCustomerVendorAccountRequest(setCustomerVendorAccountRequest: Partial<SetCustomerVendorAccountRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoCustomerVendorAccountRequest(setCustomerVendorAccountRequest),
        "notes": n => { setCustomerVendorAccountRequest.notes = n.getStringValue(); },
        "paymentMethodId": n => { setCustomerVendorAccountRequest.paymentMethodId = n.getStringValue(); },
        "priceLevelId": n => { setCustomerVendorAccountRequest.priceLevelId = n.getStringValue(); },
        "terms": n => { setCustomerVendorAccountRequest.terms = n.getStringValue(); },
        "vendorAccountNumber": n => { setCustomerVendorAccountRequest.vendorAccountNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetDiscountPermissionsRequest(setDiscountPermissionsRequest: Partial<SetDiscountPermissionsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "lineItemDiscounts": n => { setDiscountPermissionsRequest.lineItemDiscounts = n.getEnumValue<DiscountPermission>(DiscountPermissionObject); },
        "orderDiscounts": n => { setDiscountPermissionsRequest.orderDiscounts = n.getEnumValue<DiscountPermission>(DiscountPermissionObject); },
        "organizationSalesRepId": n => { setDiscountPermissionsRequest.organizationSalesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetDiscountPermissionsResponse(setDiscountPermissionsResponse: Partial<SetDiscountPermissionsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "lineItemDiscounts": n => { setDiscountPermissionsResponse.lineItemDiscounts = n.getEnumValue<DiscountPermission>(DiscountPermissionObject); },
        "orderDiscounts": n => { setDiscountPermissionsResponse.orderDiscounts = n.getEnumValue<DiscountPermission>(DiscountPermissionObject); },
        "organizationId": n => { setDiscountPermissionsResponse.organizationId = n.getStringValue(); },
        "organizationSalesRepId": n => { setDiscountPermissionsResponse.organizationSalesRepId = n.getStringValue(); },
        "success": n => { setDiscountPermissionsResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetVendorLineDiscountRequest(setVendorLineDiscountRequest: Partial<SetVendorLineDiscountRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoVendorLineRequest(setVendorLineDiscountRequest),
        "discountPercent": n => { setVendorLineDiscountRequest.discountPercent = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetVendorLineShipWindowRequest(setVendorLineShipWindowRequest: Partial<SetVendorLineShipWindowRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoVendorLineRequest(setVendorLineShipWindowRequest),
        "cancelDate": n => { setVendorLineShipWindowRequest.cancelDate = n.getDateOnlyValue(); },
        "shipDate": n => { setVendorLineShipWindowRequest.shipDate = n.getDateOnlyValue(); },
        "shipWindowName": n => { setVendorLineShipWindowRequest.shipWindowName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetViewAllCustomersRequest(setViewAllCustomersRequest: Partial<SetViewAllCustomersRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "canViewAllCustomers": n => { setViewAllCustomersRequest.canViewAllCustomers = n.getBooleanValue(); },
        "organizationSalesRepId": n => { setViewAllCustomersRequest.organizationSalesRepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetViewAllCustomersResponse(setViewAllCustomersResponse: Partial<SetViewAllCustomersResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "canViewAllCustomers": n => { setViewAllCustomersResponse.canViewAllCustomers = n.getBooleanValue(); },
        "organizationId": n => { setViewAllCustomersResponse.organizationId = n.getStringValue(); },
        "organizationSalesRepId": n => { setViewAllCustomersResponse.organizationSalesRepId = n.getStringValue(); },
        "success": n => { setViewAllCustomersResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoShippingDetails(shippingDetails: Partial<ShippingDetails> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "method": n => { shippingDetails.method = n.getStringValue(); },
        "total": n => { shippingDetails.total = n.getNumberValue(); },
        "totalFormatted": n => { shippingDetails.totalFormatted = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoShippingDetailsDto(shippingDetailsDto: Partial<ShippingDetailsDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "method": n => { shippingDetailsDto.method = n.getStringValue(); },
        "total": n => { shippingDetailsDto.total = n.getNumberValue(); },
        "totalFormatted": n => { shippingDetailsDto.totalFormatted = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoShippingDetailsInput(shippingDetailsInput: Partial<ShippingDetailsInput> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "method": n => { shippingDetailsInput.method = n.getStringValue(); },
        "total": n => { shippingDetailsInput.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoShoppingCart(shoppingCart: Partial<ShoppingCart> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(shoppingCart),
        "appliedCode": n => { shoppingCart.appliedCode = n.getStringValue(); },
        "appliedCodeSkip": n => { shoppingCart.appliedCodeSkip = n.getObjectValue<PromotionSkip>(createPromotionSkipFromDiscriminatorValue); },
        "appliedPromotions": n => { shoppingCart.appliedPromotions = n.getCollectionOfObjectValues<AppliedPromotion>(createAppliedPromotionFromDiscriminatorValue); },
        "billingAddress": n => { shoppingCart.billingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
        "cartItems": n => { shoppingCart.cartItems = n.getCollectionOfObjectValues<CartItem>(createCartItemFromDiscriminatorValue); },
        "channel": n => { shoppingCart.channel = n.getStringValue(); },
        "companyEmail": n => { shoppingCart.companyEmail = n.getStringValue(); },
        "companyFax": n => { shoppingCart.companyFax = n.getStringValue(); },
        "companyName": n => { shoppingCart.companyName = n.getStringValue(); },
        "companyPhone": n => { shoppingCart.companyPhone = n.getStringValue(); },
        "currencyCode": n => { shoppingCart.currencyCode = n.getStringValue(); },
        "customerNumber": n => { shoppingCart.customerNumber = n.getStringValue(); },
        "discount": n => { shoppingCart.discount = n.getObjectValue<Discount>(createDiscountFromDiscriminatorValue); },
        "discountAmount": n => { shoppingCart.discountAmount = n.getNumberValue(); },
        "freeShipping": n => { shoppingCart.freeShipping = n.getObjectValue<FreeShippingEntitlement>(createFreeShippingEntitlementFromDiscriminatorValue); },
        "fulfillmentMethod": n => { shoppingCart.fulfillmentMethod = n.getStringValue(); },
        "lastPriceRefresh": n => { shoppingCart.lastPriceRefresh = n.getObjectValue<CartPriceRefreshSummary>(createCartPriceRefreshSummaryFromDiscriminatorValue); },
        "lines": n => { shoppingCart.lines = n.getCollectionOfObjectValues<CartLine>(createCartLineFromDiscriminatorValue); },
        "marketCode": n => { shoppingCart.marketCode = n.getStringValue(); },
        "notes": n => { shoppingCart.notes = n.getStringValue(); },
        "orderStatus": n => { shoppingCart.orderStatus = n.getStringValue(); },
        "orderTotal": n => { shoppingCart.orderTotal = n.getNumberValue(); },
        "orderType": n => { shoppingCart.orderType = n.getStringValue(); },
        "organizationId": n => { shoppingCart.organizationId = n.getStringValue(); },
        "poNumber": n => { shoppingCart.poNumber = n.getStringValue(); },
        "pricesRefreshedUtc": n => { shoppingCart.pricesRefreshedUtc = n.getDateValue(); },
        "priceTier": n => { shoppingCart.priceTier = n.getStringValue(); },
        "primarySalesRep": n => { shoppingCart.primarySalesRep = n.getObjectValue<Rep>(createRepFromDiscriminatorValue); },
        "receiptTo": n => { shoppingCart.receiptTo = n.getCollectionOfPrimitiveValues<string>(); },
        "review": n => { shoppingCart.review = n.getObjectValue<CartReview>(createCartReviewFromDiscriminatorValue); },
        "shipping": n => { shoppingCart.shipping = n.getNumberValue(); },
        "shippingAddress": n => { shoppingCart.shippingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
        "shippingMethod": n => { shoppingCart.shippingMethod = n.getStringValue(); },
        "shoppingCartId": n => { shoppingCart.shoppingCartId = n.getStringValue(); },
        "subtotal": n => { shoppingCart.subtotal = n.getNumberValue(); },
        "takenBySalesRep": n => { shoppingCart.takenBySalesRep = n.getObjectValue<Rep>(createRepFromDiscriminatorValue); },
        "tax": n => { shoppingCart.tax = n.getNumberValue(); },
        "taxItems": n => { shoppingCart.taxItems = n.getCollectionOfObjectValues<TaxLineItem>(createTaxLineItemFromDiscriminatorValue); },
        "terms": n => { shoppingCart.terms = n.getStringValue(); },
        "user": n => { shoppingCart.user = n.getObjectValue<User3>(createUser3FromDiscriminatorValue); },
        "vendorLineDiscountAmount": n => { shoppingCart.vendorLineDiscountAmount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSimulateRequest(simulateRequest: Partial<SimulateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "campaignId": n => { simulateRequest.campaignId = n.getStringValue(); },
        "code": n => { simulateRequest.code = n.getStringValue(); },
        "shoppingCartId": n => { simulateRequest.shoppingCartId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSimulateResponse(simulateResponse: Partial<SimulateResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cart": n => { simulateResponse.cart = n.getObjectValue<ShoppingCart>(createShoppingCartFromDiscriminatorValue); },
        "plan": n => { simulateResponse.plan = n.getObjectValue<PromotionPlan>(createPromotionPlanFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSkippedLine(skippedLine: Partial<SkippedLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "reason": n => { skippedLine.reason = n.getStringValue(); },
        "vendorCode": n => { skippedLine.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSkuHistoryPointDto(skuHistoryPointDto: Partial<SkuHistoryPointDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "month": n => { skuHistoryPointDto.month = n.getNumberValue(); },
        "unitsSold": n => { skuHistoryPointDto.unitsSold = n.getNumberValue(); },
        "year": n => { skuHistoryPointDto.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSplitVendorLineResponse(splitVendorLineResponse: Partial<SplitVendorLineResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "newCart": n => { splitVendorLineResponse.newCart = n.getObjectValue<ShoppingCart>(createShoppingCartFromDiscriminatorValue); },
        "sourceCart": n => { splitVendorLineResponse.sourceCart = n.getObjectValue<ShoppingCart>(createShoppingCartFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSqlConnectorStatus(sqlConnectorStatus: Partial<SqlConnectorStatus> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "connectorName": n => { sqlConnectorStatus.connectorName = n.getStringValue(); },
        "hostName": n => { sqlConnectorStatus.hostName = n.getStringValue(); },
        "id": n => { sqlConnectorStatus.id = n.getStringValue(); },
        "lastHeartbeatAt": n => { sqlConnectorStatus.lastHeartbeatAt = n.getDateValue(); },
        "metadata": n => { sqlConnectorStatus.metadata = n.getObjectValue<SqlConnectorStatus_metadata>(createSqlConnectorStatus_metadataFromDiscriminatorValue); },
        "organizationId": n => { sqlConnectorStatus.organizationId = n.getStringValue(); },
        "registeredAt": n => { sqlConnectorStatus.registeredAt = n.getDateValue(); },
        "status": n => { sqlConnectorStatus.status = n.getEnumValue<ConnectorStatusType>(ConnectorStatusTypeObject); },
        "updatedAt": n => { sqlConnectorStatus.updatedAt = n.getDateValue(); },
        "version": n => { sqlConnectorStatus.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSqlConnectorStatus_metadata(sqlConnectorStatus_metadata: Partial<SqlConnectorStatus_metadata> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStatementEventDto(statementEventDto: Partial<StatementEventDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "eventId": n => { statementEventDto.eventId = n.getStringValue(); },
        "fromStatus": n => { statementEventDto.fromStatus = n.getStringValue(); },
        "message": n => { statementEventDto.message = n.getStringValue(); },
        "timestamp": n => { statementEventDto.timestamp = n.getDateValue(); },
        "toStatus": n => { statementEventDto.toStatus = n.getStringValue(); },
        "user": n => { statementEventDto.user = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStep(step: Partial<Step> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isComplete": n => { step.isComplete = n.getBooleanValue(); },
        "name": n => { step.name = n.getStringValue(); },
        "order": n => { step.order = n.getNumberValue(); },
        "stepId": n => { step.stepId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStorageStatsResponse(storageStatsResponse: Partial<StorageStatsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "stats": n => { storageStatsResponse.stats = n.getObjectValue<DocumentStorageStatsDto>(createDocumentStorageStatsDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStorefrontUserCustomerResponse(storefrontUserCustomerResponse: Partial<StorefrontUserCustomerResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "associatedAt": n => { storefrontUserCustomerResponse.associatedAt = n.getDateValue(); },
        "companyName": n => { storefrontUserCustomerResponse.companyName = n.getStringValue(); },
        "customerActive": n => { storefrontUserCustomerResponse.customerActive = n.getBooleanValue(); },
        "customerNumber": n => { storefrontUserCustomerResponse.customerNumber = n.getStringValue(); },
        "customerRecordFound": n => { storefrontUserCustomerResponse.customerRecordFound = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStorefrontUserResponse(storefrontUserResponse: Partial<StorefrontUserResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customers": n => { storefrontUserResponse.customers = n.getCollectionOfObjectValues<StorefrontUserCustomerResponse>(createStorefrontUserCustomerResponseFromDiscriminatorValue); },
        "email": n => { storefrontUserResponse.email = n.getStringValue(); },
        "firstName": n => { storefrontUserResponse.firstName = n.getStringValue(); },
        "fullName": n => { storefrontUserResponse.fullName = n.getStringValue(); },
        "joinedOn": n => { storefrontUserResponse.joinedOn = n.getDateValue(); },
        "lastName": n => { storefrontUserResponse.lastName = n.getStringValue(); },
        "pictureUrl": n => { storefrontUserResponse.pictureUrl = n.getStringValue(); },
        "userId": n => { storefrontUserResponse.userId = n.getStringValue(); },
        "userRecordFound": n => { storefrontUserResponse.userRecordFound = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStructuredFormatting(structuredFormatting: Partial<StructuredFormatting> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "mainText": n => { structuredFormatting.mainText = n.getStringValue(); },
        "mainTextMatchedSubstrings": n => { structuredFormatting.mainTextMatchedSubstrings = n.getCollectionOfObjectValues<MatchedSubstring>(createMatchedSubstringFromDiscriminatorValue); },
        "secondaryText": n => { structuredFormatting.secondaryText = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubmitForReviewRequest(submitForReviewRequest: Partial<SubmitForReviewRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { submitForReviewRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { submitForReviewRequest.useOrganizationId = n.getStringValue(); },
        "user": n => { submitForReviewRequest.user = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubmitForReviewRequest2(submitForReviewRequest2: Partial<SubmitForReviewRequest2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "note": n => { submitForReviewRequest2.note = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscription(subscription: Partial<Subscription> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { subscription.id = n.getStringValue(); },
        "status": n => { subscription.status = n.getStringValue(); },
        "subscription_items": n => { subscription.subscriptionItems = n.getCollectionOfObjectValues<SubscriptionItem>(createSubscriptionItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscription2(subscription2: Partial<Subscription2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { subscription2.id = n.getStringValue(); },
        "seatItemPriceId": n => { subscription2.seatItemPriceId = n.getStringValue(); },
        "seats": n => { subscription2.seats = n.getNumberValue(); },
        "status": n => { subscription2.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscriptionCreatedCustomer(subscriptionCreatedCustomer: Partial<SubscriptionCreatedCustomer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { subscriptionCreatedCustomer.id = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscriptionCreatedRequest(subscriptionCreatedRequest: Partial<SubscriptionCreatedRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "content": n => { subscriptionCreatedRequest.content = n.getObjectValue<Content>(createContentFromDiscriminatorValue); },
        "event_type": n => { subscriptionCreatedRequest.eventType = n.getStringValue(); },
        "id": n => { subscriptionCreatedRequest.id = n.getStringValue(); },
        "occurred_at": n => { subscriptionCreatedRequest.occurredAt = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscriptionDiscountLine(subscriptionDiscountLine: Partial<SubscriptionDiscountLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { subscriptionDiscountLine.amount = n.getNumberValue(); },
        "amountOff": n => { subscriptionDiscountLine.amountOff = n.getNumberValue(); },
        "appliesTo": n => { subscriptionDiscountLine.appliesTo = n.getCollectionOfPrimitiveValues<string>(); },
        "appliesToNextCharge": n => { subscriptionDiscountLine.appliesToNextCharge = n.getBooleanValue(); },
        "code": n => { subscriptionDiscountLine.code = n.getStringValue(); },
        "duration": n => { subscriptionDiscountLine.duration = n.getStringValue(); },
        "durationInMonths": n => { subscriptionDiscountLine.durationInMonths = n.getNumberValue(); },
        "endsAt": n => { subscriptionDiscountLine.endsAt = n.getDateValue(); },
        "name": n => { subscriptionDiscountLine.name = n.getStringValue(); },
        "percentOff": n => { subscriptionDiscountLine.percentOff = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscriptionEntitlement(subscriptionEntitlement: Partial<SubscriptionEntitlement> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "featureId": n => { subscriptionEntitlement.featureId = n.getStringValue(); },
        "featureName": n => { subscriptionEntitlement.featureName = n.getStringValue(); },
        "id": n => { subscriptionEntitlement.id = n.getStringValue(); },
        "isOverridden": n => { subscriptionEntitlement.isOverridden = n.getBooleanValue(); },
        "name": n => { subscriptionEntitlement.name = n.getStringValue(); },
        "subscriptionId": n => { subscriptionEntitlement.subscriptionId = n.getStringValue(); },
        "value": n => { subscriptionEntitlement.value = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscriptionItem(subscriptionItem: Partial<SubscriptionItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "item_price_id": n => { subscriptionItem.itemPriceId = n.getStringValue(); },
        "quantity": n => { subscriptionItem.quantity = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscriptionPlanLine(subscriptionPlanLine: Partial<SubscriptionPlanLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { subscriptionPlanLine.amount = n.getNumberValue(); },
        "isPerSeat": n => { subscriptionPlanLine.isPerSeat = n.getBooleanValue(); },
        "lookupKey": n => { subscriptionPlanLine.lookupKey = n.getStringValue(); },
        "name": n => { subscriptionPlanLine.name = n.getStringValue(); },
        "quantity": n => { subscriptionPlanLine.quantity = n.getNumberValue(); },
        "unitPrice": n => { subscriptionPlanLine.unitPrice = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSuggestMappingsRequest(suggestMappingsRequest: Partial<SuggestMappingsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "columns": n => { suggestMappingsRequest.columns = n.getCollectionOfObjectValues<ImportColumnSample>(createImportColumnSampleFromDiscriminatorValue); },
        "importType": n => { suggestMappingsRequest.importType = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSuggestMappingsResponse(suggestMappingsResponse: Partial<SuggestMappingsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "columns": n => { suggestMappingsResponse.columns = n.getCollectionOfObjectValues<ColumnMappingSuggestion>(createColumnMappingSuggestionFromDiscriminatorValue); },
        "degraded": n => { suggestMappingsResponse.degraded = n.getBooleanValue(); },
        "degradedReason": n => { suggestMappingsResponse.degradedReason = n.getStringValue(); },
        "importType": n => { suggestMappingsResponse.importType = n.getStringValue(); },
        "model": n => { suggestMappingsResponse.model = n.getStringValue(); },
        "runId": n => { suggestMappingsResponse.runId = n.getStringValue(); },
        "targets": n => { suggestMappingsResponse.targets = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSuggestResearchSettingsRequest(suggestResearchSettingsRequest: Partial<SuggestResearchSettingsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "forceRegenerate": n => { suggestResearchSettingsRequest.forceRegenerate = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSuggestResearchSettingsResponse(suggestResearchSettingsResponse: Partial<SuggestResearchSettingsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "approvalCriteria": n => { suggestResearchSettingsResponse.approvalCriteria = n.getStringValue(); },
        "estimatedCostUsd": n => { suggestResearchSettingsResponse.estimatedCostUsd = n.getNumberValue(); },
        "generatedAt": n => { suggestResearchSettingsResponse.generatedAt = n.getDateValue(); },
        "generatedBy": n => { suggestResearchSettingsResponse.generatedBy = n.getStringValue(); },
        "industryDescription": n => { suggestResearchSettingsResponse.industryDescription = n.getStringValue(); },
        "tokensUsed": n => { suggestResearchSettingsResponse.tokensUsed = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSyncBatchResultDto(syncBatchResultDto: Partial<SyncBatchResultDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "batchNumber": n => { syncBatchResultDto.batchNumber = n.getNumberValue(); },
        "durationSeconds": n => { syncBatchResultDto.durationSeconds = n.getNumberValue(); },
        "errorMessage": n => { syncBatchResultDto.errorMessage = n.getStringValue(); },
        "httpStatusCode": n => { syncBatchResultDto.httpStatusCode = n.getNumberValue(); },
        "isSuccess": n => { syncBatchResultDto.isSuccess = n.getBooleanValue(); },
        "recordCount": n => { syncBatchResultDto.recordCount = n.getNumberValue(); },
        "retryAttempts": n => { syncBatchResultDto.retryAttempts = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSyncRunDocument(syncRunDocument: Partial<SyncRunDocument> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "batchResults": n => { syncRunDocument.batchResults = n.getCollectionOfObjectValues<SyncBatchResultDto>(createSyncBatchResultDtoFromDiscriminatorValue); },
        "completedAt": n => { syncRunDocument.completedAt = n.getDateValue(); },
        "connectorId": n => { syncRunDocument.connectorId = n.getStringValue(); },
        "durationSeconds": n => { syncRunDocument.durationSeconds = n.getNumberValue(); },
        "endpointId": n => { syncRunDocument.endpointId = n.getStringValue(); },
        "endpointName": n => { syncRunDocument.endpointName = n.getStringValue(); },
        "errorMessage": n => { syncRunDocument.errorMessage = n.getStringValue(); },
        "failedBatches": n => { syncRunDocument.failedBatches = n.getNumberValue(); },
        "failedRecords": n => { syncRunDocument.failedRecords = n.getNumberValue(); },
        "id": n => { syncRunDocument.id = n.getStringValue(); },
        "isManualTrigger": n => { syncRunDocument.isManualTrigger = n.getBooleanValue(); },
        "organizationId": n => { syncRunDocument.organizationId = n.getStringValue(); },
        "pushedAt": n => { syncRunDocument.pushedAt = n.getDateValue(); },
        "startedAt": n => { syncRunDocument.startedAt = n.getDateValue(); },
        "status": n => { syncRunDocument.status = n.getStringValue(); },
        "successfulBatches": n => { syncRunDocument.successfulBatches = n.getNumberValue(); },
        "successfulRecords": n => { syncRunDocument.successfulRecords = n.getNumberValue(); },
        "syncMode": n => { syncRunDocument.syncMode = n.getStringValue(); },
        "syncRunId": n => { syncRunDocument.syncRunId = n.getStringValue(); },
        "totalBatches": n => { syncRunDocument.totalBatches = n.getNumberValue(); },
        "totalRecords": n => { syncRunDocument.totalRecords = n.getNumberValue(); },
        "updatedAt": n => { syncRunDocument.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTag(tag: Partial<Tag> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categoryPath": n => { tag.categoryPath = n.getStringValue(); },
        "height": n => { tag.height = n.getNumberValue(); },
        "kind": n => { tag.kind = n.getEnumValue<TagKind>(TagKindObject); },
        "sku": n => { tag.sku = n.getStringValue(); },
        "width": n => { tag.width = n.getNumberValue(); },
        "x": n => { tag.x = n.getNumberValue(); },
        "y": n => { tag.y = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTagInfo(tagInfo: Partial<TagInfo> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categoryPath": n => { tagInfo.categoryPath = n.getStringValue(); },
        "height": n => { tagInfo.height = n.getNumberValue(); },
        "kind": n => { tagInfo.kind = n.getEnumValue<TagKind>(TagKindObject); },
        "sku": n => { tagInfo.sku = n.getStringValue(); },
        "width": n => { tagInfo.width = n.getNumberValue(); },
        "x": n => { tagInfo.x = n.getNumberValue(); },
        "y": n => { tagInfo.y = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTaskItem(taskItem: Partial<TaskItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(taskItem),
        "completedAt": n => { taskItem.completedAt = n.getDateValue(); },
        "completedByIdentityProviderUserId": n => { taskItem.completedByIdentityProviderUserId = n.getStringValue(); },
        "completedByName": n => { taskItem.completedByName = n.getStringValue(); },
        "createdByIdentityProviderUserId": n => { taskItem.createdByIdentityProviderUserId = n.getStringValue(); },
        "createdByName": n => { taskItem.createdByName = n.getStringValue(); },
        "customerId": n => { taskItem.customerId = n.getStringValue(); },
        "customerName": n => { taskItem.customerName = n.getStringValue(); },
        "customerNumber": n => { taskItem.customerNumber = n.getStringValue(); },
        "customerRepNumber": n => { taskItem.customerRepNumber = n.getStringValue(); },
        "description": n => { taskItem.description = n.getStringValue(); },
        "dueAt": n => { taskItem.dueAt = n.getDateValue(); },
        "dueTimeZoneId": n => { taskItem.dueTimeZoneId = n.getStringValue(); },
        "organizationId": n => { taskItem.organizationId = n.getStringValue(); },
        "organizationSalesRepId": n => { taskItem.organizationSalesRepId = n.getStringValue(); },
        "priority": n => { taskItem.priority = n.getEnumValue<TaskPriority>(TaskPriorityObject); },
        "salesRepId": n => { taskItem.salesRepId = n.getStringValue(); },
        "salesRepName": n => { taskItem.salesRepName = n.getStringValue(); },
        "salesRepRepNumber": n => { taskItem.salesRepRepNumber = n.getStringValue(); },
        "sortOrder": n => { taskItem.sortOrder = n.getNumberValue(); },
        "status": n => { taskItem.status = n.getEnumValue<TaskItemStatus>(TaskItemStatusObject); },
        "taskItemId": n => { taskItem.taskItemId = n.getStringValue(); },
        "title": n => { taskItem.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTasksSummaryResponse(tasksSummaryResponse: Partial<TasksSummaryResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "asOf": n => { tasksSummaryResponse.asOf = n.getDateValue(); },
        "dueThisWeek": n => { tasksSummaryResponse.dueThisWeek = n.getNumberValue(); },
        "dueToday": n => { tasksSummaryResponse.dueToday = n.getNumberValue(); },
        "endOfToday": n => { tasksSummaryResponse.endOfToday = n.getDateValue(); },
        "endOfWeek": n => { tasksSummaryResponse.endOfWeek = n.getDateValue(); },
        "open": n => { tasksSummaryResponse.open = n.getNumberValue(); },
        "overdue": n => { tasksSummaryResponse.overdue = n.getNumberValue(); },
        "startOfToday": n => { tasksSummaryResponse.startOfToday = n.getDateValue(); },
        "timeZone": n => { tasksSummaryResponse.timeZone = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTaxLineItem(taxLineItem: Partial<TaxLineItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { taxLineItem.amount = n.getNumberValue(); },
        "jurisdiction": n => { taxLineItem.jurisdiction = n.getStringValue(); },
        "ratePercent": n => { taxLineItem.ratePercent = n.getNumberValue(); },
        "taxableAmount": n => { taxLineItem.taxableAmount = n.getNumberValue(); },
        "taxName": n => { taxLineItem.taxName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTaxRule(taxRule: Partial<TaxRule> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "country": n => { taxRule.country = n.getStringValue(); },
        "ratePercent": n => { taxRule.ratePercent = n.getNumberValue(); },
        "sourcingBasis": n => { taxRule.sourcingBasis = n.getEnumValue<SourcingBasis>(SourcingBasisObject); },
        "stateProvince": n => { taxRule.stateProvince = n.getStringValue(); },
        "taxName": n => { taxRule.taxName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTaxSettings(taxSettings: Partial<TaxSettings> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isEnabled": n => { taxSettings.isEnabled = n.getBooleanValue(); },
        "nexusStates": n => { taxSettings.nexusStates = n.getCollectionOfPrimitiveValues<string>(); },
        "provider": n => { taxSettings.provider = n.getStringValue(); },
        "ruleOverrides": n => { taxSettings.ruleOverrides = n.getCollectionOfObjectValues<TaxRule>(createTaxRuleFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTearSheet(tearSheet: Partial<TearSheet> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { tearSheet.active = n.getBooleanValue(); },
        "createdAt": n => { tearSheet.createdAt = n.getDateValue(); },
        "customerNumber": n => { tearSheet.customerNumber = n.getStringValue(); },
        "description": n => { tearSheet.description = n.getStringValue(); },
        "name": n => { tearSheet.name = n.getStringValue(); },
        "organizationId": n => { tearSheet.organizationId = n.getStringValue(); },
        "productIds": n => { tearSheet.productIds = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { tearSheet.salesRepId = n.getStringValue(); },
        "salesRepName": n => { tearSheet.salesRepName = n.getStringValue(); },
        "sentAt": n => { tearSheet.sentAt = n.getDateValue(); },
        "sentToEmail": n => { tearSheet.sentToEmail = n.getStringValue(); },
        "sentToPhoneNumber": n => { tearSheet.sentToPhoneNumber = n.getStringValue(); },
        "sentVia": n => { tearSheet.sentVia = n.getStringValue(); },
        "status": n => { tearSheet.status = n.getStringValue(); },
        "tearSheetId": n => { tearSheet.tearSheetId = n.getStringValue(); },
        "updatedAt": n => { tearSheet.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTerm(term: Partial<Term> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "offset": n => { term.offset = n.getNumberValue(); },
        "value": n => { term.value = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTestIntegrationResponse(testIntegrationResponse: Partial<TestIntegrationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "integrationId": n => { testIntegrationResponse.integrationId = n.getStringValue(); },
        "isSuccessful": n => { testIntegrationResponse.isSuccessful = n.getBooleanValue(); },
        "message": n => { testIntegrationResponse.message = n.getStringValue(); },
        "testedAt": n => { testIntegrationResponse.testedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTestJobRequest(testJobRequest: Partial<TestJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "organizationId": n => { testJobRequest.organizationId = n.getStringValue(); },
        "productId": n => { testJobRequest.productId = n.getStringValue(); },
        "productSku": n => { testJobRequest.productSku = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTrainOrderVolumeForecastModelRequest(trainOrderVolumeForecastModelRequest: Partial<TrainOrderVolumeForecastModelRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endDate": n => { trainOrderVolumeForecastModelRequest.endDate = n.getDateValue(); },
        "startDate": n => { trainOrderVolumeForecastModelRequest.startDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTrainOrderVolumeForecastModelResponse(trainOrderVolumeForecastModelResponse: Partial<TrainOrderVolumeForecastModelResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "model": n => { trainOrderVolumeForecastModelResponse.model = n.getObjectValue<ForecastModelDto>(createForecastModelDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTrainSkuForecastModelRequest(trainSkuForecastModelRequest: Partial<TrainSkuForecastModelRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endDate": n => { trainSkuForecastModelRequest.endDate = n.getDateValue(); },
        "startDate": n => { trainSkuForecastModelRequest.startDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTrainSkuForecastModelResponse(trainSkuForecastModelResponse: Partial<TrainSkuForecastModelResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "model": n => { trainSkuForecastModelResponse.model = n.getObjectValue<ForecastModelDto>(createForecastModelDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateAccessRequestNotificationSettingsRequest(updateAccessRequestNotificationSettingsRequest: Partial<UpdateAccessRequestNotificationSettingsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "notificationEmail": n => { updateAccessRequestNotificationSettingsRequest.notificationEmail = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCartPoNumberRequest(updateCartPoNumberRequest: Partial<UpdateCartPoNumberRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "poNumber": n => { updateCartPoNumberRequest.poNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCartPricingSettingsRequest(updateCartPricingSettingsRequest: Partial<UpdateCartPricingSettingsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allowDecimalQuantities": n => { updateCartPricingSettingsRequest.allowDecimalQuantities = n.getBooleanValue(); },
        "allowLineItemDiscounts": n => { updateCartPricingSettingsRequest.allowLineItemDiscounts = n.getBooleanValue(); },
        "allowOrderDiscounts": n => { updateCartPricingSettingsRequest.allowOrderDiscounts = n.getBooleanValue(); },
        "allowPriceOverride": n => { updateCartPricingSettingsRequest.allowPriceOverride = n.getBooleanValue(); },
        "refreshStalePrices": n => { updateCartPricingSettingsRequest.refreshStalePrices = n.getBooleanValue(); },
        "stalePriceAgeDays": n => { updateCartPricingSettingsRequest.stalePriceAgeDays = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCartReceiptToRequest(updateCartReceiptToRequest: Partial<UpdateCartReceiptToRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoVendorCartRequest(updateCartReceiptToRequest),
        "receiptTo": n => { updateCartReceiptToRequest.receiptTo = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCartRequest(updateCartRequest: Partial<UpdateCartRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cart": n => { updateCartRequest.cart = n.getObjectValue<ShoppingCart>(createShoppingCartFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCartShippingRequest(updateCartShippingRequest: Partial<UpdateCartShippingRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "shippingAddress": n => { updateCartShippingRequest.shippingAddress = n.getObjectValue<Address>(createAddressFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCommissionPlanRequest(updateCommissionPlanRequest: Partial<UpdateCommissionPlanRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "defaultRate": n => { updateCommissionPlanRequest.defaultRate = n.getNumberValue(); },
        "description": n => { updateCommissionPlanRequest.description = n.getStringValue(); },
        "effectiveEndDate": n => { updateCommissionPlanRequest.effectiveEndDate = n.getDateValue(); },
        "effectiveStartDate": n => { updateCommissionPlanRequest.effectiveStartDate = n.getDateValue(); },
        "name": n => { updateCommissionPlanRequest.name = n.getStringValue(); },
        "orgCodes": n => { updateCommissionPlanRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { updateCommissionPlanRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerNoteRequest(updateCustomerNoteRequest: Partial<UpdateCustomerNoteRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "body": n => { updateCustomerNoteRequest.body = n.getStringValue(); },
        "orgCodes": n => { updateCustomerNoteRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { updateCustomerNoteRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerRequest(updateCustomerRequest: Partial<UpdateCustomerRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { updateCustomerRequest.active = n.getBooleanValue(); },
        "addresses": n => { updateCustomerRequest.addresses = n.getCollectionOfObjectValues<Address>(createAddressFromDiscriminatorValue); },
        "companyEmail": n => { updateCustomerRequest.companyEmail = n.getStringValue(); },
        "companyFax": n => { updateCustomerRequest.companyFax = n.getStringValue(); },
        "companyName": n => { updateCustomerRequest.companyName = n.getStringValue(); },
        "companyPhone": n => { updateCustomerRequest.companyPhone = n.getStringValue(); },
        "contacts": n => { updateCustomerRequest.contacts = n.getCollectionOfObjectValues<Contact>(createContactFromDiscriminatorValue); },
        "customerId": n => { updateCustomerRequest.customerId = n.getStringValue(); },
        "fulfillmentMethod": n => { updateCustomerRequest.fulfillmentMethod = n.getStringValue(); },
        "pricing": n => { updateCustomerRequest.pricing = n.getStringValue(); },
        "repNumber": n => { updateCustomerRequest.repNumber = n.getStringValue(); },
        "terms": n => { updateCustomerRequest.terms = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerResponse(updateCustomerResponse: Partial<UpdateCustomerResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customer": n => { updateCustomerResponse.customer = n.getObjectValue<Customer>(createCustomerFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateFlipbookRequest(updateFlipbookRequest: Partial<UpdateFlipbookRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "pages": n => { updateFlipbookRequest.pages = n.getCollectionOfObjectValues<PageUpdateInfo>(createPageUpdateInfoFromDiscriminatorValue); },
        "title": n => { updateFlipbookRequest.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateIntegrationRequest(updateIntegrationRequest: Partial<UpdateIntegrationRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "configuration": n => { updateIntegrationRequest.configuration = n.getObjectValue<UpdateIntegrationRequest_configuration>(createUpdateIntegrationRequest_configurationFromDiscriminatorValue); },
        "displayName": n => { updateIntegrationRequest.displayName = n.getStringValue(); },
        "isEnabled": n => { updateIntegrationRequest.isEnabled = n.getBooleanValue(); },
        "secrets": n => { updateIntegrationRequest.secrets = n.getObjectValue<UpdateIntegrationRequest_secrets>(createUpdateIntegrationRequest_secretsFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateIntegrationRequest_configuration(updateIntegrationRequest_configuration: Partial<UpdateIntegrationRequest_configuration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateIntegrationRequest_secrets(updateIntegrationRequest_secrets: Partial<UpdateIntegrationRequest_secrets> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateIntegrationResponse(updateIntegrationResponse: Partial<UpdateIntegrationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "configuration": n => { updateIntegrationResponse.configuration = n.getObjectValue<UpdateIntegrationResponse_configuration>(createUpdateIntegrationResponse_configurationFromDiscriminatorValue); },
        "displayName": n => { updateIntegrationResponse.displayName = n.getStringValue(); },
        "integrationId": n => { updateIntegrationResponse.integrationId = n.getStringValue(); },
        "integrationType": n => { updateIntegrationResponse.integrationType = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
        "isEnabled": n => { updateIntegrationResponse.isEnabled = n.getBooleanValue(); },
        "organizationId": n => { updateIntegrationResponse.organizationId = n.getStringValue(); },
        "provider": n => { updateIntegrationResponse.provider = n.getStringValue(); },
        "testConnectionRequired": n => { updateIntegrationResponse.testConnectionRequired = n.getBooleanValue(); },
        "updatedAt": n => { updateIntegrationResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateIntegrationResponse_configuration(updateIntegrationResponse_configuration: Partial<UpdateIntegrationResponse_configuration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateInvoiceRequest(updateInvoiceRequest: Partial<UpdateInvoiceRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingAddress": n => { updateInvoiceRequest.billingAddress = n.getObjectValue<AddressInput>(createAddressInputFromDiscriminatorValue); },
        "customer": n => { updateInvoiceRequest.customer = n.getObjectValue<CustomerInput>(createCustomerInputFromDiscriminatorValue); },
        "dueDate": n => { updateInvoiceRequest.dueDate = n.getDateValue(); },
        "externalId": n => { updateInvoiceRequest.externalId = n.getStringValue(); },
        "invoiceNumber": n => { updateInvoiceRequest.invoiceNumber = n.getStringValue(); },
        "notes": n => { updateInvoiceRequest.notes = n.getStringValue(); },
        "orgCodes": n => { updateInvoiceRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { updateInvoiceRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateItemQuantityRequest(updateItemQuantityRequest: Partial<UpdateItemQuantityRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { updateItemQuantityRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "quantity": n => { updateItemQuantityRequest.quantity = n.getNumberValue(); },
        "useOrganizationId": n => { updateItemQuantityRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateItemRequest(updateItemRequest: Partial<UpdateItemRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "quantity": n => { updateItemRequest.quantity = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateLineRequest(updateLineRequest: Partial<UpdateLineRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "quantity": n => { updateLineRequest.quantity = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateOrderExportSettingsRequest(updateOrderExportSettingsRequest: Partial<UpdateOrderExportSettingsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "enabledCustomFormats": n => { updateOrderExportSettingsRequest.enabledCustomFormats = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateOrderReceiptSettingsRequest(updateOrderReceiptSettingsRequest: Partial<UpdateOrderReceiptSettingsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerSubject": n => { updateOrderReceiptSettingsRequest.customerSubject = n.getStringValue(); },
        "organizationSubject": n => { updateOrderReceiptSettingsRequest.organizationSubject = n.getStringValue(); },
        "salesRepSubject": n => { updateOrderReceiptSettingsRequest.salesRepSubject = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateOrderStatusRequest(updateOrderStatusRequest: Partial<UpdateOrderStatusRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderStatus": n => { updateOrderStatusRequest.orderStatus = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateOrganizationFeaturesRequest(updateOrganizationFeaturesRequest: Partial<UpdateOrganizationFeaturesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productVariants": n => { updateOrganizationFeaturesRequest.productVariants = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdatePriceTierRequest(updatePriceTierRequest: Partial<UpdatePriceTierRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currencyCode": n => { updatePriceTierRequest.currencyCode = n.getStringValue(); },
        "newName": n => { updatePriceTierRequest.newName = n.getStringValue(); },
        "oldName": n => { updatePriceTierRequest.oldName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductCategoriesRequest(updateProductCategoriesRequest: Partial<UpdateProductCategoriesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categoryUpdates": n => { updateProductCategoriesRequest.categoryUpdates = n.getCollectionOfObjectValues<UpdateProductCategoriesRequest_CategoryUpdate>(createUpdateProductCategoriesRequest_CategoryUpdateFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductCategoriesRequest_CategoryUpdate(updateProductCategoriesRequest_CategoryUpdate: Partial<UpdateProductCategoriesRequest_CategoryUpdate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { updateProductCategoriesRequest_CategoryUpdate.active = n.getBooleanValue(); },
        "category": n => { updateProductCategoriesRequest_CategoryUpdate.category = n.getStringValue(); },
        "sku": n => { updateProductCategoriesRequest_CategoryUpdate.sku = n.getStringValue(); },
        "vendorCode": n => { updateProductCategoriesRequest_CategoryUpdate.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductImagesRequest(updateProductImagesRequest: Partial<UpdateProductImagesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "imageIds": n => { updateProductImagesRequest.imageIds = n.getCollectionOfPrimitiveValues<string>(); },
        "sku": n => { updateProductImagesRequest.sku = n.getStringValue(); },
        "vendorCode": n => { updateProductImagesRequest.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductPricesRequest(updateProductPricesRequest: Partial<UpdateProductPricesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productUpdates": n => { updateProductPricesRequest.productUpdates = n.getCollectionOfObjectValues<UpdateProductPricesRequest_ProductPriceUpdate>(createUpdateProductPricesRequest_ProductPriceUpdateFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductPricesRequest_ProductPriceDto(updateProductPricesRequest_ProductPriceDto: Partial<UpdateProductPricesRequest_ProductPriceDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "atQuantity": n => { updateProductPricesRequest_ProductPriceDto.atQuantity = n.getNumberValue(); },
        "price": n => { updateProductPricesRequest_ProductPriceDto.price = n.getNumberValue(); },
        "tier": n => { updateProductPricesRequest_ProductPriceDto.tier = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductPricesRequest_ProductPriceUpdate(updateProductPricesRequest_ProductPriceUpdate: Partial<UpdateProductPricesRequest_ProductPriceUpdate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "prices": n => { updateProductPricesRequest_ProductPriceUpdate.prices = n.getCollectionOfObjectValues<UpdateProductPricesRequest_ProductPriceDto>(createUpdateProductPricesRequest_ProductPriceDtoFromDiscriminatorValue); },
        "sku": n => { updateProductPricesRequest_ProductPriceUpdate.sku = n.getStringValue(); },
        "vendorCode": n => { updateProductPricesRequest_ProductPriceUpdate.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductRequest(updateProductRequest: Partial<UpdateProductRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "active": n => { updateProductRequest.active = n.getBooleanValue(); },
        "category": n => { updateProductRequest.category = n.getStringValue(); },
        "description": n => { updateProductRequest.description = n.getStringValue(); },
        "detachFromFamily": n => { updateProductRequest.detachFromFamily = n.getBooleanValue(); },
        "dimensions": n => { updateProductRequest.dimensions = n.getStringValue(); },
        "dimensionsUnit": n => { updateProductRequest.dimensionsUnit = n.getStringValue(); },
        "externalId": n => { updateProductRequest.externalId = n.getStringValue(); },
        "familyDescription": n => { updateProductRequest.familyDescription = n.getStringValue(); },
        "familyKey": n => { updateProductRequest.familyKey = n.getStringValue(); },
        "familyName": n => { updateProductRequest.familyName = n.getStringValue(); },
        "imageName": n => { updateProductRequest.imageName = n.getStringValue(); },
        "images": n => { updateProductRequest.images = n.getCollectionOfPrimitiveValues<string>(); },
        "minimumOrderQuantity": n => { updateProductRequest.minimumOrderQuantity = n.getNumberValue(); },
        "name": n => { updateProductRequest.name = n.getStringValue(); },
        "optionValues": n => { updateProductRequest.optionValues = n.getObjectValue<UpdateProductRequest_optionValues>(createUpdateProductRequest_optionValuesFromDiscriminatorValue); },
        "price": n => { updateProductRequest.price = n.getNumberValue(); },
        "prices": n => { updateProductRequest.prices = n.getCollectionOfObjectValues<UpdateProductRequest_ProductPriceDto>(createUpdateProductRequest_ProductPriceDtoFromDiscriminatorValue); },
        "productAttributes": n => { updateProductRequest.productAttributes = n.getObjectValue<UpdateProductRequest_productAttributes>(createUpdateProductRequest_productAttributesFromDiscriminatorValue); },
        "quantityIncrement": n => { updateProductRequest.quantityIncrement = n.getNumberValue(); },
        "quantityOnHand": n => { updateProductRequest.quantityOnHand = n.getNumberValue(); },
        "separateLines": n => { updateProductRequest.separateLines = n.getBooleanValue(); },
        "sku": n => { updateProductRequest.sku = n.getStringValue(); },
        "tags": n => { updateProductRequest.tags = n.getCollectionOfPrimitiveValues<string>(); },
        "upc": n => { updateProductRequest.upc = n.getStringValue(); },
        "vendorCode": n => { updateProductRequest.vendorCode = n.getStringValue(); },
        "weight": n => { updateProductRequest.weight = n.getNumberValue(); },
        "weightUnit": n => { updateProductRequest.weightUnit = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductRequest_optionValues(updateProductRequest_optionValues: Partial<UpdateProductRequest_optionValues> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductRequest_productAttributes(updateProductRequest_productAttributes: Partial<UpdateProductRequest_productAttributes> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductRequest_ProductPriceDto(updateProductRequest_ProductPriceDto: Partial<UpdateProductRequest_ProductPriceDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "atQuantity": n => { updateProductRequest_ProductPriceDto.atQuantity = n.getNumberValue(); },
        "price": n => { updateProductRequest_ProductPriceDto.price = n.getNumberValue(); },
        "tier": n => { updateProductRequest_ProductPriceDto.tier = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductSortOrdersRequest(updateProductSortOrdersRequest: Partial<UpdateProductSortOrdersRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "sortOrderUpdates": n => { updateProductSortOrdersRequest.sortOrderUpdates = n.getCollectionOfObjectValues<UpdateProductSortOrdersRequest_SortOrderUpdate>(createUpdateProductSortOrdersRequest_SortOrderUpdateFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductSortOrdersRequest_SortOrderUpdate(updateProductSortOrdersRequest_SortOrderUpdate: Partial<UpdateProductSortOrdersRequest_SortOrderUpdate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "category": n => { updateProductSortOrdersRequest_SortOrderUpdate.category = n.getStringValue(); },
        "sku": n => { updateProductSortOrdersRequest_SortOrderUpdate.sku = n.getStringValue(); },
        "sortOrder": n => { updateProductSortOrdersRequest_SortOrderUpdate.sortOrder = n.getNumberValue(); },
        "vendorCode": n => { updateProductSortOrdersRequest_SortOrderUpdate.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductSortOrdersResponse(updateProductSortOrdersResponse: Partial<UpdateProductSortOrdersResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applied": n => { updateProductSortOrdersResponse.applied = n.getCollectionOfPrimitiveValues<string>(); },
        "appliedCount": n => { updateProductSortOrdersResponse.appliedCount = n.getNumberValue(); },
        "skipped": n => { updateProductSortOrdersResponse.skipped = n.getCollectionOfPrimitiveValues<string>(); },
        "skippedCount": n => { updateProductSortOrdersResponse.skippedCount = n.getNumberValue(); },
        "skipReasons": n => { updateProductSortOrdersResponse.skipReasons = n.getObjectValue<UpdateProductSortOrdersResponse_skipReasons>(createUpdateProductSortOrdersResponse_skipReasonsFromDiscriminatorValue); },
        "totalSkus": n => { updateProductSortOrdersResponse.totalSkus = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductSortOrdersResponse_skipReasons(updateProductSortOrdersResponse_skipReasons: Partial<UpdateProductSortOrdersResponse_skipReasons> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductTagsRequest(updateProductTagsRequest: Partial<UpdateProductTagsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "tagUpdates": n => { updateProductTagsRequest.tagUpdates = n.getCollectionOfObjectValues<UpdateProductTagsRequest_TagUpdate>(createUpdateProductTagsRequest_TagUpdateFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductTagsRequest_TagUpdate(updateProductTagsRequest_TagUpdate: Partial<UpdateProductTagsRequest_TagUpdate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "sku": n => { updateProductTagsRequest_TagUpdate.sku = n.getStringValue(); },
        "tags": n => { updateProductTagsRequest_TagUpdate.tags = n.getCollectionOfPrimitiveValues<string>(); },
        "vendorCode": n => { updateProductTagsRequest_TagUpdate.vendorCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateProductTagsResponse(updateProductTagsResponse: Partial<UpdateProductTagsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applied": n => { updateProductTagsResponse.applied = n.getCollectionOfPrimitiveValues<string>(); },
        "appliedCount": n => { updateProductTagsResponse.appliedCount = n.getNumberValue(); },
        "skipped": n => { updateProductTagsResponse.skipped = n.getCollectionOfPrimitiveValues<string>(); },
        "skippedCount": n => { updateProductTagsResponse.skippedCount = n.getNumberValue(); },
        "totalSkus": n => { updateProductTagsResponse.totalSkus = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateResearchSettingsRequest(updateResearchSettingsRequest: Partial<UpdateResearchSettingsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "approvalCriteria": n => { updateResearchSettingsRequest.approvalCriteria = n.getStringValue(); },
        "industryDescription": n => { updateResearchSettingsRequest.industryDescription = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateSalesRepRequest(updateSalesRepRequest: Partial<UpdateSalesRepRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "marketCode": n => { updateSalesRepRequest.marketCode = n.getStringValue(); },
        "organizationSalesRepId": n => { updateSalesRepRequest.organizationSalesRepId = n.getStringValue(); },
        "repNumber": n => { updateSalesRepRequest.repNumber = n.getStringValue(); },
        "repNumbers": n => { updateSalesRepRequest.repNumbers = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateSalesRepResponse(updateSalesRepResponse: Partial<UpdateSalesRepResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { updateSalesRepResponse.email = n.getStringValue(); },
        "firstName": n => { updateSalesRepResponse.firstName = n.getStringValue(); },
        "lastName": n => { updateSalesRepResponse.lastName = n.getStringValue(); },
        "marketCode": n => { updateSalesRepResponse.marketCode = n.getStringValue(); },
        "organizationId": n => { updateSalesRepResponse.organizationId = n.getStringValue(); },
        "organizationSalesRepId": n => { updateSalesRepResponse.organizationSalesRepId = n.getStringValue(); },
        "repNumber": n => { updateSalesRepResponse.repNumber = n.getStringValue(); },
        "repNumbers": n => { updateSalesRepResponse.repNumbers = n.getCollectionOfPrimitiveValues<string>(); },
        "salesRepId": n => { updateSalesRepResponse.salesRepId = n.getStringValue(); },
        "success": n => { updateSalesRepResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateSeatsRequest(updateSeatsRequest: Partial<UpdateSeatsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "seats": n => { updateSeatsRequest.seats = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateSeatsResponse(updateSeatsResponse: Partial<UpdateSeatsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "activeReps": n => { updateSeatsResponse.activeReps = n.getNumberValue(); },
        "seats": n => { updateSeatsResponse.seats = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateTaskRequest(updateTaskRequest: Partial<UpdateTaskRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { updateTaskRequest.customerNumber = n.getStringValue(); },
        "description": n => { updateTaskRequest.description = n.getStringValue(); },
        "dueAt": n => { updateTaskRequest.dueAt = n.getDateValue(); },
        "dueTimeZoneId": n => { updateTaskRequest.dueTimeZoneId = n.getStringValue(); },
        "organizationSalesRepId": n => { updateTaskRequest.organizationSalesRepId = n.getStringValue(); },
        "orgCodes": n => { updateTaskRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "priority": n => { updateTaskRequest.priority = n.getEnumValue<TaskPriority>(TaskPriorityObject); },
        "title": n => { updateTaskRequest.title = n.getStringValue(); },
        "useOrganizationId": n => { updateTaskRequest.useOrganizationId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateVendorLineHeaderRequest(updateVendorLineHeaderRequest: Partial<UpdateVendorLineHeaderRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoVendorLineRequest(updateVendorLineHeaderRequest),
        "fulfillmentMethod": n => { updateVendorLineHeaderRequest.fulfillmentMethod = n.getStringValue(); },
        "noteToVendor": n => { updateVendorLineHeaderRequest.noteToVendor = n.getStringValue(); },
        "orderType": n => { updateVendorLineHeaderRequest.orderType = n.getStringValue(); },
        "poNumber": n => { updateVendorLineHeaderRequest.poNumber = n.getStringValue(); },
        "priceLevel": n => { updateVendorLineHeaderRequest.priceLevel = n.getStringValue(); },
        "terms": n => { updateVendorLineHeaderRequest.terms = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateVendorRequest(updateVendorRequest: Partial<UpdateVendorRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoVendorFieldsRequest(updateVendorRequest),
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUploadManyImagesRequest(uploadManyImagesRequest: Partial<UploadManyImagesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "images": n => { uploadManyImagesRequest.images = n.getCollectionOfObjectValues<ImageUploadItem>(createImageUploadItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUser(user: Partial<User> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { user.email = n.getStringValue(); },
        "firstName": n => { user.firstName = n.getStringValue(); },
        "lastName": n => { user.lastName = n.getStringValue(); },
        "password": n => { user.password = n.getStringValue(); },
        "phoneNumber": n => { user.phoneNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUser2(user2: Partial<User2> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "identityProviderUserId": n => { user2.identityProviderUserId = n.getStringValue(); },
        "userId": n => { user2.userId = n.getStringValue(); },
        "userType": n => { user2.userType = n.getEnumValue<UserTypes>(UserTypesObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUser3(user3: Partial<User3> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "identityProviderUserId": n => { user3.identityProviderUserId = n.getStringValue(); },
        "userId": n => { user3.userId = n.getStringValue(); },
        "userType": n => { user3.userType = n.getEnumValue<UserTypes>(UserTypesObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUserCustomer(userCustomer: Partial<UserCustomer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(userCustomer),
        "customerNumber": n => { userCustomer.customerNumber = n.getStringValue(); },
        "organizationId": n => { userCustomer.organizationId = n.getStringValue(); },
        "userCustomerId": n => { userCustomer.userCustomerId = n.getStringValue(); },
        "userId": n => { userCustomer.userId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUserDto(userDto: Partial<UserDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "identityProviderUserId": n => { userDto.identityProviderUserId = n.getStringValue(); },
        "userId": n => { userDto.userId = n.getStringValue(); },
        "userType": n => { userDto.userType = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUserExistsResponse(userExistsResponse: Partial<UserExistsResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "userExists": n => { userExistsResponse.userExists = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUserOrganizationDto(userOrganizationDto: Partial<UserOrganizationDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { userOrganizationDto.name = n.getStringValue(); },
        "organizationId": n => { userOrganizationDto.organizationId = n.getStringValue(); },
        "orgCode": n => { userOrganizationDto.orgCode = n.getStringValue(); },
        "roles": n => { userOrganizationDto.roles = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoValidateConfig_ValidateConfigResponse(validateConfig_ValidateConfigResponse: Partial<ValidateConfig_ValidateConfigResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "env": n => { validateConfig_ValidateConfigResponse.env = n.getStringValue(); },
        "identityConfigured": n => { validateConfig_ValidateConfigResponse.identityConfigured = n.getBooleanValue(); },
        "identityMessage": n => { validateConfig_ValidateConfigResponse.identityMessage = n.getStringValue(); },
        "keyVaultConfigured": n => { validateConfig_ValidateConfigResponse.keyVaultConfigured = n.getBooleanValue(); },
        "keyVaultMessage": n => { validateConfig_ValidateConfigResponse.keyVaultMessage = n.getStringValue(); },
        "syncGatewayConfigured": n => { validateConfig_ValidateConfigResponse.syncGatewayConfigured = n.getBooleanValue(); },
        "syncGatewayMessage": n => { validateConfig_ValidateConfigResponse.syncGatewayMessage = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoValidateIntegrationTemplateRequest(validateIntegrationTemplateRequest: Partial<ValidateIntegrationTemplateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "configuration": n => { validateIntegrationTemplateRequest.configuration = n.getObjectValue<ValidateIntegrationTemplateRequest_configuration>(createValidateIntegrationTemplateRequest_configurationFromDiscriminatorValue); },
        "provider": n => { validateIntegrationTemplateRequest.provider = n.getStringValue(); },
        "secrets": n => { validateIntegrationTemplateRequest.secrets = n.getObjectValue<ValidateIntegrationTemplateRequest_secrets>(createValidateIntegrationTemplateRequest_secretsFromDiscriminatorValue); },
        "type": n => { validateIntegrationTemplateRequest.type = n.getEnumValue<IntegrationType>(IntegrationTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoValidateIntegrationTemplateRequest_configuration(validateIntegrationTemplateRequest_configuration: Partial<ValidateIntegrationTemplateRequest_configuration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoValidateIntegrationTemplateRequest_secrets(validateIntegrationTemplateRequest_secrets: Partial<ValidateIntegrationTemplateRequest_secrets> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoValidateIntegrationTemplateResponse(validateIntegrationTemplateResponse: Partial<ValidateIntegrationTemplateResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "errors": n => { validateIntegrationTemplateResponse.errors = n.getCollectionOfPrimitiveValues<string>(); },
        "isValid": n => { validateIntegrationTemplateResponse.isValid = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendor(vendor: Partial<Vendor> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoBaseEntity(vendor),
        "categoryIds": n => { vendor.categoryIds = n.getCollectionOfPrimitiveValues<string>(); },
        "defaultCommissionRate": n => { vendor.defaultCommissionRate = n.getNumberValue(); },
        "defaultMinimum": n => { vendor.defaultMinimum = n.getObjectValue<VendorMinimum>(createVendorMinimumFromDiscriminatorValue); },
        "description": n => { vendor.description = n.getStringValue(); },
        "fulfillmentMethodIds": n => { vendor.fulfillmentMethodIds = n.getCollectionOfPrimitiveValues<string>(); },
        "lifestyleImageUrl": n => { vendor.lifestyleImageUrl = n.getStringValue(); },
        "linkedOrganizationId": n => { vendor.linkedOrganizationId = n.getStringValue(); },
        "logoUrl": n => { vendor.logoUrl = n.getStringValue(); },
        "merchandisingTags": n => { vendor.merchandisingTags = n.getCollectionOfPrimitiveValues<string>(); },
        "minimumsByProductGroup": n => { vendor.minimumsByProductGroup = n.getCollectionOfObjectValues<VendorMinimum>(createVendorMinimumFromDiscriminatorValue); },
        "mustHaves": n => { vendor.mustHaves = n.getCollectionOfPrimitiveValues<string>(); },
        "name": n => { vendor.name = n.getStringValue(); },
        "orderDeskEmail": n => { vendor.orderDeskEmail = n.getStringValue(); },
        "orderDestination": n => { vendor.orderDestination = n.getObjectValue<VendorOrderDestination>(createVendorOrderDestinationFromDiscriminatorValue); },
        "orderTypes": n => { vendor.orderTypes = n.getCollectionOfPrimitiveValues<string>(); },
        "organizationId": n => { vendor.organizationId = n.getStringValue(); },
        "phone": n => { vendor.phone = n.getStringValue(); },
        "priceLevelIds": n => { vendor.priceLevelIds = n.getCollectionOfPrimitiveValues<string>(); },
        "shipWindows": n => { vendor.shipWindows = n.getCollectionOfObjectValues<VendorShipWindow>(createVendorShipWindowFromDiscriminatorValue); },
        "showOnLineCard": n => { vendor.showOnLineCard = n.getBooleanValue(); },
        "slug": n => { vendor.slug = n.getStringValue(); },
        "termsOptions": n => { vendor.termsOptions = n.getCollectionOfPrimitiveValues<string>(); },
        "vendorCode": n => { vendor.vendorCode = n.getStringValue(); },
        "vendorId": n => { vendor.vendorId = n.getStringValue(); },
        "website": n => { vendor.website = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorCartRequest(vendorCartRequest: Partial<VendorCartRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoAgencyScopedRequest(vendorCartRequest),
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorCustomerDto(vendorCustomerDto: Partial<VendorCustomerDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "account": n => { vendorCustomerDto.account = n.getObjectValue<CustomerVendorAccountDto>(createCustomerVendorAccountDtoFromDiscriminatorValue); },
        "customer": n => { vendorCustomerDto.customer = n.getObjectValue<Customer>(createCustomerFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorFieldsRequest(vendorFieldsRequest: Partial<VendorFieldsRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoAgencyScopedRequest(vendorFieldsRequest),
        "categoryIds": n => { vendorFieldsRequest.categoryIds = n.getCollectionOfPrimitiveValues<string>(); },
        "defaultCommissionRate": n => { vendorFieldsRequest.defaultCommissionRate = n.getNumberValue(); },
        "defaultMinimum": n => { vendorFieldsRequest.defaultMinimum = n.getObjectValue<VendorMinimum>(createVendorMinimumFromDiscriminatorValue); },
        "description": n => { vendorFieldsRequest.description = n.getStringValue(); },
        "fulfillmentMethodIds": n => { vendorFieldsRequest.fulfillmentMethodIds = n.getCollectionOfPrimitiveValues<string>(); },
        "lifestyleImageUrl": n => { vendorFieldsRequest.lifestyleImageUrl = n.getStringValue(); },
        "linkedOrganizationId": n => { vendorFieldsRequest.linkedOrganizationId = n.getStringValue(); },
        "logoUrl": n => { vendorFieldsRequest.logoUrl = n.getStringValue(); },
        "merchandisingTags": n => { vendorFieldsRequest.merchandisingTags = n.getCollectionOfPrimitiveValues<string>(); },
        "minimumsByProductGroup": n => { vendorFieldsRequest.minimumsByProductGroup = n.getCollectionOfObjectValues<VendorMinimum>(createVendorMinimumFromDiscriminatorValue); },
        "mustHaves": n => { vendorFieldsRequest.mustHaves = n.getCollectionOfPrimitiveValues<string>(); },
        "name": n => { vendorFieldsRequest.name = n.getStringValue(); },
        "orderDeskEmail": n => { vendorFieldsRequest.orderDeskEmail = n.getStringValue(); },
        "orderDestination": n => { vendorFieldsRequest.orderDestination = n.getObjectValue<VendorOrderDestination>(createVendorOrderDestinationFromDiscriminatorValue); },
        "orderTypes": n => { vendorFieldsRequest.orderTypes = n.getCollectionOfPrimitiveValues<string>(); },
        "phone": n => { vendorFieldsRequest.phone = n.getStringValue(); },
        "priceLevelIds": n => { vendorFieldsRequest.priceLevelIds = n.getCollectionOfPrimitiveValues<string>(); },
        "shipWindows": n => { vendorFieldsRequest.shipWindows = n.getCollectionOfObjectValues<VendorShipWindow>(createVendorShipWindowFromDiscriminatorValue); },
        "showOnLineCard": n => { vendorFieldsRequest.showOnLineCard = n.getBooleanValue(); },
        "slug": n => { vendorFieldsRequest.slug = n.getStringValue(); },
        "termsOptions": n => { vendorFieldsRequest.termsOptions = n.getCollectionOfPrimitiveValues<string>(); },
        "website": n => { vendorFieldsRequest.website = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorLineDto(vendorLineDto: Partial<VendorLineDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cancelDate": n => { vendorLineDto.cancelDate = n.getDateOnlyValue(); },
        "discountAmount": n => { vendorLineDto.discountAmount = n.getNumberValue(); },
        "discountPercent": n => { vendorLineDto.discountPercent = n.getNumberValue(); },
        "fulfillmentMethod": n => { vendorLineDto.fulfillmentMethod = n.getStringValue(); },
        "isOpeningOrder": n => { vendorLineDto.isOpeningOrder = n.getBooleanValue(); },
        "itemCount": n => { vendorLineDto.itemCount = n.getNumberValue(); },
        "itemLineIds": n => { vendorLineDto.itemLineIds = n.getCollectionOfPrimitiveValues<string>(); },
        "minimumAmount": n => { vendorLineDto.minimumAmount = n.getNumberValue(); },
        "noteToVendor": n => { vendorLineDto.noteToVendor = n.getStringValue(); },
        "options": n => { vendorLineDto.options = n.getObjectValue<VendorLineOptionsDto>(createVendorLineOptionsDtoFromDiscriminatorValue); },
        "orderType": n => { vendorLineDto.orderType = n.getStringValue(); },
        "poNumber": n => { vendorLineDto.poNumber = n.getStringValue(); },
        "priceLevel": n => { vendorLineDto.priceLevel = n.getStringValue(); },
        "savedForLater": n => { vendorLineDto.savedForLater = n.getBooleanValue(); },
        "shipDate": n => { vendorLineDto.shipDate = n.getDateOnlyValue(); },
        "shipWindowName": n => { vendorLineDto.shipWindowName = n.getStringValue(); },
        "status": n => { vendorLineDto.status = n.getEnumValue<CartLineStatus>(CartLineStatusObject); },
        "subtotal": n => { vendorLineDto.subtotal = n.getNumberValue(); },
        "terms": n => { vendorLineDto.terms = n.getStringValue(); },
        "total": n => { vendorLineDto.total = n.getNumberValue(); },
        "vendorCode": n => { vendorLineDto.vendorCode = n.getStringValue(); },
        "vendorLogoUrl": n => { vendorLineDto.vendorLogoUrl = n.getStringValue(); },
        "vendorName": n => { vendorLineDto.vendorName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorLineOptionsDto(vendorLineOptionsDto: Partial<VendorLineOptionsDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fulfillmentMethodIds": n => { vendorLineOptionsDto.fulfillmentMethodIds = n.getCollectionOfPrimitiveValues<string>(); },
        "openingOrderMinimum": n => { vendorLineOptionsDto.openingOrderMinimum = n.getNumberValue(); },
        "orderTypes": n => { vendorLineOptionsDto.orderTypes = n.getCollectionOfPrimitiveValues<string>(); },
        "priceLevelIds": n => { vendorLineOptionsDto.priceLevelIds = n.getCollectionOfPrimitiveValues<string>(); },
        "reorderMinimum": n => { vendorLineOptionsDto.reorderMinimum = n.getNumberValue(); },
        "shipWindows": n => { vendorLineOptionsDto.shipWindows = n.getCollectionOfObjectValues<VendorShipWindow>(createVendorShipWindowFromDiscriminatorValue); },
        "termsOptions": n => { vendorLineOptionsDto.termsOptions = n.getCollectionOfPrimitiveValues<string>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorLineRequest(vendorLineRequest: Partial<VendorLineRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoVendorCartRequest(vendorLineRequest),
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorLinesResponse(vendorLinesResponse: Partial<VendorLinesResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerNumber": n => { vendorLinesResponse.customerNumber = n.getStringValue(); },
        "lines": n => { vendorLinesResponse.lines = n.getCollectionOfObjectValues<VendorLineDto>(createVendorLineDtoFromDiscriminatorValue); },
        "receiptTo": n => { vendorLinesResponse.receiptTo = n.getCollectionOfPrimitiveValues<string>(); },
        "shoppingCartId": n => { vendorLinesResponse.shoppingCartId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorMinimum(vendorMinimum: Partial<VendorMinimum> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "openingOrder": n => { vendorMinimum.openingOrder = n.getNumberValue(); },
        "productGroup": n => { vendorMinimum.productGroup = n.getStringValue(); },
        "reorder": n => { vendorMinimum.reorder = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorOrderDestination(vendorOrderDestination: Partial<VendorOrderDestination> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ediDestination": n => { vendorOrderDestination.ediDestination = n.getStringValue(); },
        "ediFormat": n => { vendorOrderDestination.ediFormat = n.getStringValue(); },
        "emailTo": n => { vendorOrderDestination.emailTo = n.getCollectionOfPrimitiveValues<string>(); },
        "pushUrl": n => { vendorOrderDestination.pushUrl = n.getStringValue(); },
        "type": n => { vendorOrderDestination.type = n.getEnumValue<OrderDestinationType>(OrderDestinationTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorPrefillHints(vendorPrefillHints: Partial<VendorPrefillHints> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "openingOrderMinimum": n => { vendorPrefillHints.openingOrderMinimum = n.getNumberValue(); },
        "reorderMinimum": n => { vendorPrefillHints.reorderMinimum = n.getNumberValue(); },
        "termsText": n => { vendorPrefillHints.termsText = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorPrefillSuggestions(vendorPrefillSuggestions: Partial<VendorPrefillSuggestions> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "categoryIds": n => { vendorPrefillSuggestions.categoryIds = n.getCollectionOfPrimitiveValues<string>(); },
        "description": n => { vendorPrefillSuggestions.description = n.getStringValue(); },
        "email": n => { vendorPrefillSuggestions.email = n.getStringValue(); },
        "fields": n => { vendorPrefillSuggestions.fields = n.getObjectValue<VendorPrefillSuggestions_fields>(createVendorPrefillSuggestions_fieldsFromDiscriminatorValue); },
        "hints": n => { vendorPrefillSuggestions.hints = n.getObjectValue<VendorPrefillHints>(createVendorPrefillHintsFromDiscriminatorValue); },
        "logoUrl": n => { vendorPrefillSuggestions.logoUrl = n.getStringValue(); },
        "merchandisingTags": n => { vendorPrefillSuggestions.merchandisingTags = n.getCollectionOfPrimitiveValues<string>(); },
        "mustHaves": n => { vendorPrefillSuggestions.mustHaves = n.getCollectionOfPrimitiveValues<string>(); },
        "name": n => { vendorPrefillSuggestions.name = n.getStringValue(); },
        "pagesRead": n => { vendorPrefillSuggestions.pagesRead = n.getCollectionOfPrimitiveValues<string>(); },
        "phone": n => { vendorPrefillSuggestions.phone = n.getStringValue(); },
        "source": n => { vendorPrefillSuggestions.source = n.getStringValue(); },
        "vendorCode": n => { vendorPrefillSuggestions.vendorCode = n.getStringValue(); },
        "vendorCodeAlternatives": n => { vendorPrefillSuggestions.vendorCodeAlternatives = n.getCollectionOfPrimitiveValues<string>(); },
        "warnings": n => { vendorPrefillSuggestions.warnings = n.getCollectionOfPrimitiveValues<string>(); },
        "website": n => { vendorPrefillSuggestions.website = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorPrefillSuggestions_fields(vendorPrefillSuggestions_fields: Partial<VendorPrefillSuggestions_fields> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVendorShipWindow(vendorShipWindow: Partial<VendorShipWindow> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cancelDate": n => { vendorShipWindow.cancelDate = n.getDateOnlyValue(); },
        "isDefault": n => { vendorShipWindow.isDefault = n.getBooleanValue(); },
        "name": n => { vendorShipWindow.name = n.getStringValue(); },
        "shipDate": n => { vendorShipWindow.shipDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoViewCartShareMessageResponse(viewCartShareMessageResponse: Partial<ViewCartShareMessageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "body": n => { viewCartShareMessageResponse.body = n.getStringValue(); },
        "cart": n => { viewCartShareMessageResponse.cart = n.getObjectValue<CartShareSnapshot>(createCartShareSnapshotFromDiscriminatorValue); },
        "createdAt": n => { viewCartShareMessageResponse.createdAt = n.getDateValue(); },
        "messageId": n => { viewCartShareMessageResponse.messageId = n.getStringValue(); },
        "organization": n => { viewCartShareMessageResponse.organization = n.getObjectValue<OrganizationInfo>(createOrganizationInfoFromDiscriminatorValue); },
        "organizationId": n => { viewCartShareMessageResponse.organizationId = n.getStringValue(); },
        "senderEmail": n => { viewCartShareMessageResponse.senderEmail = n.getStringValue(); },
        "senderName": n => { viewCartShareMessageResponse.senderName = n.getStringValue(); },
        "sentAt": n => { viewCartShareMessageResponse.sentAt = n.getDateValue(); },
        "subject": n => { viewCartShareMessageResponse.subject = n.getStringValue(); },
        "viewOnlineUrl": n => { viewCartShareMessageResponse.viewOnlineUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoViewCompanyDocsMessageResponse(viewCompanyDocsMessageResponse: Partial<ViewCompanyDocsMessageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "attachments": n => { viewCompanyDocsMessageResponse.attachments = n.getCollectionOfObjectValues<MessageAttachment>(createMessageAttachmentFromDiscriminatorValue); },
        "body": n => { viewCompanyDocsMessageResponse.body = n.getStringValue(); },
        "createdAt": n => { viewCompanyDocsMessageResponse.createdAt = n.getDateValue(); },
        "deliveryStatus": n => { viewCompanyDocsMessageResponse.deliveryStatus = n.getObjectValue<DeliveryStatus>(createDeliveryStatusFromDiscriminatorValue); },
        "messageId": n => { viewCompanyDocsMessageResponse.messageId = n.getStringValue(); },
        "metadata": n => { viewCompanyDocsMessageResponse.metadata = n.getObjectValue<MessageMetadata>(createMessageMetadataFromDiscriminatorValue); },
        "organization": n => { viewCompanyDocsMessageResponse.organization = n.getObjectValue<OrganizationInfo>(createOrganizationInfoFromDiscriminatorValue); },
        "organizationId": n => { viewCompanyDocsMessageResponse.organizationId = n.getStringValue(); },
        "senderEmail": n => { viewCompanyDocsMessageResponse.senderEmail = n.getStringValue(); },
        "senderName": n => { viewCompanyDocsMessageResponse.senderName = n.getStringValue(); },
        "sentAt": n => { viewCompanyDocsMessageResponse.sentAt = n.getDateValue(); },
        "status": n => { viewCompanyDocsMessageResponse.status = n.getStringValue(); },
        "subject": n => { viewCompanyDocsMessageResponse.subject = n.getStringValue(); },
        "viewOnlineUrl": n => { viewCompanyDocsMessageResponse.viewOnlineUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoViewTearSheetsMessageResponse(viewTearSheetsMessageResponse: Partial<ViewTearSheetsMessageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "body": n => { viewTearSheetsMessageResponse.body = n.getStringValue(); },
        "createdAt": n => { viewTearSheetsMessageResponse.createdAt = n.getDateValue(); },
        "deliveryStatus": n => { viewTearSheetsMessageResponse.deliveryStatus = n.getObjectValue<DeliveryStatus>(createDeliveryStatusFromDiscriminatorValue); },
        "messageId": n => { viewTearSheetsMessageResponse.messageId = n.getStringValue(); },
        "metadata": n => { viewTearSheetsMessageResponse.metadata = n.getObjectValue<MessageMetadata>(createMessageMetadataFromDiscriminatorValue); },
        "organization": n => { viewTearSheetsMessageResponse.organization = n.getObjectValue<OrganizationInfo>(createOrganizationInfoFromDiscriminatorValue); },
        "organizationId": n => { viewTearSheetsMessageResponse.organizationId = n.getStringValue(); },
        "products": n => { viewTearSheetsMessageResponse.products = n.getCollectionOfObjectValues<Product>(createProductFromDiscriminatorValue); },
        "senderEmail": n => { viewTearSheetsMessageResponse.senderEmail = n.getStringValue(); },
        "senderName": n => { viewTearSheetsMessageResponse.senderName = n.getStringValue(); },
        "sentAt": n => { viewTearSheetsMessageResponse.sentAt = n.getDateValue(); },
        "status": n => { viewTearSheetsMessageResponse.status = n.getStringValue(); },
        "subject": n => { viewTearSheetsMessageResponse.subject = n.getStringValue(); },
        "tearSheet": n => { viewTearSheetsMessageResponse.tearSheet = n.getObjectValue<TearSheet>(createTearSheetFromDiscriminatorValue); },
        "viewOnlineUrl": n => { viewTearSheetsMessageResponse.viewOnlineUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVoidInvoiceRequest(voidInvoiceRequest: Partial<VoidInvoiceRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orgCodes": n => { voidInvoiceRequest.orgCodes = n.getCollectionOfPrimitiveValues<string>(); },
        "useOrganizationId": n => { voidInvoiceRequest.useOrganizationId = n.getStringValue(); },
    }
}
export interface DisconnectIntegrationRequest extends Parsable {
    /**
     * Whether to switch the integration off as well as disconnecting it. Defaults to true, whichleaves it disabled rather than enabled-but-disconnected. Send false to keep the enabled flagas it is. The outcome comes back as wasDisabled.
     */
    disableIntegration?: boolean | null;
}
export interface DisconnectIntegrationResponse extends Parsable {
    /**
     * When the connection was ended.
     */
    disconnectedAt?: Date | null;
    /**
     * The integration that was disconnected.
     */
    integrationId?: string | null;
    /**
     * What the integration is for, e.g. Accounting.
     */
    integrationType?: IntegrationType | null;
    /**
     * The provider whose tokens were revoked, e.g. QuickBooks.
     */
    provider?: string | null;
    /**
     * Whether the integration was actually disabled, which happens only when the request asked forit. False when it was not asked for, and also when disabling was asked for but did not take —the disconnect still succeeded in that case, so check this rather than assuming.
     */
    wasDisabled?: boolean | null;
}
export interface Discount extends Parsable {
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
    /**
     * The type property
     */
    type?: DiscountType | null;
    /**
     * The value property
     */
    value?: number | null;
}
export interface DiscountCode extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The customerNumbers property
     */
    customerNumbers?: string[] | null;
    /**
     * The discountCodeId property
     */
    discountCodeId?: string | null;
    /**
     * The maxUses property
     */
    maxUses?: number | null;
    /**
     * The maxUsesPerCustomer property
     */
    maxUsesPerCustomer?: number | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The usedCount property
     */
    usedCount?: number | null;
    /**
     * The validFrom property
     */
    validFrom?: Date | null;
    /**
     * The validTo property
     */
    validTo?: Date | null;
}
/**
 * The restrictions a discount code carries on top of its campaign's (D10). Null means none.
 */
export interface DiscountCodeOptionsInput extends Parsable {
    /**
     * The customerNumbers property
     */
    customerNumbers?: string[] | null;
    /**
     * The maxUses property
     */
    maxUses?: number | null;
    /**
     * The maxUsesPerCustomer property
     */
    maxUsesPerCustomer?: number | null;
    /**
     * The validFrom property
     */
    validFrom?: Date | null;
    /**
     * The validTo property
     */
    validTo?: Date | null;
}
/**
 * A discount on the order or a line. CampaignId and PromotionIdare set when a campaign promotion wrote it (CU-86bcj36vr); Description is thenthe promotion's name. Both null on a discount a rep entered by hand.
 */
export interface DiscountDto extends Parsable {
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
    /**
     * The type property
     */
    type?: string | null;
    /**
     * The value property
     */
    value?: number | null;
}
export interface DiscountInput extends Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The type property
     */
    type?: string | null;
    /**
     * The value property
     */
    value?: number | null;
}
export type DiscountPermission = (typeof DiscountPermissionObject)[keyof typeof DiscountPermissionObject];
export type DiscountType = (typeof DiscountTypeObject)[keyof typeof DiscountTypeObject];
export interface DisputeCommissionStatementRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The reason property
     */
    reason?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
    /**
     * The user property
     */
    user?: string | null;
}
export interface DocumentListResponse extends Parsable {
    /**
     * The documents property
     */
    documents?: CompanyDocumentDto[] | null;
}
export interface DocumentResponse extends Parsable {
    /**
     * A file in the organization's document library.
     */
    document?: CompanyDocumentDto | null;
}
export interface DocumentResponse2 extends Parsable {
    /**
     * A file in the organization's document library.
     */
    document?: CompanyDocumentDto | null;
}
/**
 * How much of an organization's document allowance is in use. All sizes are in bytes.
 */
export interface DocumentStorageStatsDto extends Parsable {
    /**
     * Bytes still free. An upload is refused when the file would take the total past the allowance,so a file must fit inside this figure whole.
     */
    availableSize?: number | null;
    /**
     * The organization's allowance in bytes. Fixed at 1 GB for every organization; it is a platformlimit and is not raised per customer.
     */
    maxSize?: number | null;
    /**
     * The number of documents in the library, wherever they are filed — documents inside foldersare included, so this describes the same set as the sizes below.
     */
    totalFiles?: number | null;
    /**
     * Bytes used by every document in the library, in folders included.
     */
    totalSize?: number | null;
    /**
     * Share of the allowance in use, as a percentage between 0 and 100.
     */
    usedPercentage?: number | null;
}
export interface EditCustomerAttributeRequest extends Parsable {
    /**
     * The new DisplayName for the CustomerAttribute
     */
    displayName?: string | null;
    /**
     * The slug of the CustomerAttribute to edit
     */
    slug?: string | null;
}
export interface EditOrderTypeRequest extends Parsable {
    /**
     * The new DisplayName for the OrderType
     */
    displayName?: string | null;
    /**
     * The platform kind to map this order type to. Omit to leave the kind exactly as it is —including leaving it unassigned on an order type that predates kinds.
     */
    kind?: OrderKind | null;
    /**
     * The slug of the OrderType to edit
     */
    slug?: string | null;
}
export interface EditProductAttributeRequest extends Parsable {
    /**
     * The new DisplayName for the ProductAttribute
     */
    displayName?: string | null;
    /**
     * The slug of the ProductAttribute to edit
     */
    slug?: string | null;
}
export interface EmailInvoiceRequest extends Parsable {
    /**
     * The emailAddresses property
     */
    emailAddresses?: string[] | null;
}
/**
 * How many emails reached each outcome. Each email counts once per outcome: an email opened fivetimes is one open.
 */
export interface EmailStatsCounts extends Parsable {
    /**
     * Emails that bounced.
     */
    bounced?: number | null;
    /**
     * Emails with at least one link clicked.
     */
    clicked?: number | null;
    /**
     * Emails the recipient marked as spam.
     */
    complained?: number | null;
    /**
     * Emails the recipient's mail server accepted.
     */
    delivered?: number | null;
    /**
     * Emails opened at least once.
     */
    opened?: number | null;
    /**
     * Emails sent.
     */
    requests?: number | null;
}
/**
 * One day's counts.
 */
export interface EmailStatsDay extends AdditionalDataHolder, EmailStatsCounts, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The day, as yyyy-MM-dd in the response's time zone.
     */
    date?: string | null;
}
/**
 * A business domain to look up, e.g. from a customer's email address or website.
 */
export interface EnrichCustomerRequest extends Parsable {
    /**
     * The business's domain. An email address, host or URL is accepted and reduced to its registrabledomain (sales@mail.acmesalon.com → acmesalon.com); consumer mail providers are refused.
     */
    domain?: string | null;
    /**
     * Research the domain again even when a recent answer exists. A live lookup is billed.
     */
    forceRefresh?: boolean | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
}
/**
 * What public web research found about the business behind a domain, for a person to review beforeusing any of it. Every value comes with the URL it was verified against; a value that could not beverified is null. Every field object is always present.
 */
export interface EnrichCustomerResponse extends Parsable {
    /**
     * The head office or main location.
     */
    address?: ResearchedAddress | null;
    /**
     * The business's trading name.
     */
    companyName?: ResearchedValue | null;
    /**
     * From 0 to 1: how sure the research is that these details belong to the business behind this domain.
     */
    confidence?: number | null;
    /**
     * The registrable domain that was looked up.
     */
    domain?: string | null;
    /**
     * True when the answer came from earlier research rather than a new lookup.
     */
    fromCache?: boolean | null;
    /**
     * A few words on what the business does.
     */
    industry?: ResearchedValue | null;
    /**
     * The business's main public phone number, as published.
     */
    phone?: ResearchedValue | null;
    /**
     * When the research ran.
     */
    researchedAt?: Date | null;
    /**
     * Every URL the research verified against, the business's own website first.
     */
    sources?: string[] | null;
    /**
     * Found, NotFound (no business could be verified behind the domain) or Refused.
     */
    status?: string | null;
    /**
     * The business's own website, when confirmed. A source to check, not a value to store.
     */
    website?: string | null;
}
export interface EnrichM2MResponse extends Parsable {
    /**
     * The accessScope property
     */
    accessScope?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The priceTier property
     */
    priceTier?: string | null;
}
export interface EnrichUserAccessTokenResponse extends Parsable {
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customer number associated with the user in the specified organization, if any
     */
    customerNumber?: string | null;
    /**
     * The priceTier property
     */
    priceTier?: string | null;
}
/**
 * An entitlement the organization does not hold yet, and what it would cost to add to the subscription italready pays for. Mirrors CatalogItemPrice, because it is the same thing seen from a customerwho is already subscribed.
 */
export interface EntitlementOffer extends Parsable {
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The price's lookup key — what the add endpoint is called with.
     */
    lookupKey?: string | null;
    /**
     * The product's name in the billing catalog, e.g. Nymble Storefront.
     */
    name?: string | null;
    /**
     * Billing period length, paired with PeriodUnit (e.g. 1 month).
     */
    period?: number | null;
    /**
     * The periodUnit property
     */
    periodUnit?: string | null;
    /**
     * Price in the currency's minor unit (e.g. 29900 = $299.00).
     */
    price?: number | null;
}
/**
 * What an organization's subscriptions entitle it to, for gating the parts of the app a customer has tobe paying for. Read live from the billing provider rather than mirrored onto the organization: asubscription can lapse or be changed in the provider's own portal, and a stored copy would keep afeature switched on afterthe customer stopped paying for it.
 */
export interface EntitlementsResponse extends Parsable {
    /**
     * Entitlement slugs currently held, e.g. storefront. Sourced from billing price metadata, sothe dashboard stays the source of truth for what a plan includes.
     */
    entitlements?: string[] | null;
    /**
     * False when the billing provider could not be read. Callers must treat this as "unknown", not"entitled to nothing" — showing an upsell to a paying customer because billing was brieflyunreachable is worsethan briefly leaving a feature open, so the app fails open on this flag.
     */
    entitlementsKnown?: boolean | null;
    /**
     * Whether the organization has any subscription at all, live or otherwise.
     */
    hasSubscription?: boolean | null;
    /**
     * What adding the storefront would cost, priced on the billing interval the organization already runson. Null when it is already held, when there is no subscription to add it to, or when the cataloghas no storefront price on that interval.
     */
    storefrontOffer?: EntitlementOffer | null;
}
export interface EntityDetailsResponseOfImageDetail extends Parsable {
    /**
     * The entity property
     */
    entity?: ImageDetail | null;
    /**
     * The links property
     */
    links?: Link[] | null;
}
export interface EntityDetailsResponseOfOrder extends Parsable {
    /**
     * The entity property
     */
    entity?: Order | null;
    /**
     * The links property
     */
    links?: Link[] | null;
}
/**
 * the dto used to send an error response to the client
 */
export interface ErrorResponse extends ApiError, Parsable {
    /**
     * the collection of errors for the current context
     */
    errors?: ErrorResponse_errors | null;
    /**
     * the message for the error response
     */
    messageEscaped?: string | null;
    /**
     * the http status code sent to the client. default is 400.
     */
    statusCode?: number | null;
}
/**
 * the collection of errors for the current context
 */
export interface ErrorResponse_errors extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * A customer the requester can already shop for.
 */
export interface ExistingAccessCustomerResponse extends Parsable {
    /**
     * The customer's company name; null when the association points at a customer record that nolonger exists.
     */
    companyName?: string | null;
    /**
     * Whether the customer record is active; null when the customer record was not found.
     */
    customerActive?: boolean | null;
    /**
     * The customer number the account is associated with.
     */
    customerNumber?: string | null;
}
/**
 * What the platform already knows about the person behind an access request: whether an accountexists for the email address and which customers, if any, it can already shop for in thisorganization.
 */
export interface ExistingAccessResponse extends Parsable {
    /**
     * The customers the account can already shop for in this organization. Empty when the person hasno storefront access here.
     */
    customers?: ExistingAccessCustomerResponse[] | null;
    /**
     * True when the account already has storefront access to at least one customer in thisorganization.
     */
    hasAccess?: boolean | null;
    /**
     * Whether the account is a member of this organization. Null when the account does not exist ormembership could not be determined.
     */
    isOrganizationMember?: boolean | null;
    /**
     * Whether an account already exists for the request's email address.
     */
    userExists?: boolean | null;
    /**
     * The account's user id when one exists; otherwise null.
     */
    userId?: string | null;
}
export interface ExistsResponse extends Parsable {
    /**
     * The exitsInOrganization property
     */
    exitsInOrganization?: boolean | null;
    /**
     * The identityExists property
     */
    identityExists?: boolean | null;
}
export interface ExportCustomersRequest extends Parsable {
    /**
     * The exportFileType property
     */
    exportFileType?: ExportTypes | null;
}
export interface ExportedOrderDto extends Parsable {
    /**
     * The exportedAt property
     */
    exportedAt?: Date | null;
    /**
     * The exportedBy property
     */
    exportedBy?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The orderNumber property
     */
    orderNumber?: string | null;
}
export type ExportEntity = (typeof ExportEntityObject)[keyof typeof ExportEntityObject];
/**
 * One selectable export format. Exactly one of ExportFileType andCustomFormatKey is populated, and that is what the caller sends back onPOST api/exports/orders/by-id.
 */
export interface ExportFormatDto extends Parsable {
    /**
     * The custom format key to send, or null when this option is a built-in type.
     */
    customFormatKey?: string | null;
    /**
     * What to show in the export menu (e.g. CSV, SAP B1 (DTW)).
     */
    displayName?: string | null;
    /**
     * The built-in export type to send, or null when this option is a custom format.
     */
    exportFileType?: ExportTypes | null;
    /**
     * True for a custom multi-file format. These download as a zip; built-ins download as asingle file.
     */
    isCustom?: boolean | null;
    /**
     * Stable identifier for the option — the enum name for a built-in (e.g. Csv), theformat key for a custom one (e.g. sap-b1-dtw). Safe to persist as a UI preference.
     */
    key?: string | null;
}
export interface ExportOrdersByDateRequest extends Parsable {
    /**
     * The exportFileType property
     */
    exportFileType?: ExportTypes | null;
    /**
     * Gets or sets the filters for the request, this is optionalAcceptable operators are: starts with, contains, notcontains, endswith, equals, notequals, gt, get, lt, lte
     */
    filters?: QueryFilter[] | null;
}
export interface ExportOrdersByIdRequest extends Parsable {
    /**
     * Optional key of a custom multi-file export format (e.g. sap-b1-dtw), fromGET api/exports/formats. When supplied it takes precedence overExportFileType, which may then be omitted, and the export is delivered as azip. The organization must have been enabled for the key or the request is rejected.
     */
    customFormatKey?: string | null;
    /**
     * The exportFileType property
     */
    exportFileType?: ExportTypes | null;
    /**
     * Gets or sets the list of Order IDs to export
     */
    orderIds?: string[] | null;
}
export interface ExportProductsRequest extends Parsable {
    /**
     * The exportFileType property
     */
    exportFileType?: ExportTypes | null;
}
export type ExportTypes = (typeof ExportTypesObject)[keyof typeof ExportTypesObject];
/**
 * The contact details read from a business card, for a person to review before anything is saved.Every field is always present: one the card does not carry has a null value and a confidence of 0.
 */
export interface ExtractBusinessCardResponse extends Parsable {
    /**
     * The postal address on the card.
     */
    address?: BusinessCardAddress | null;
    /**
     * The business the card belongs to.
     */
    companyName?: BusinessCardField | null;
    /**
     * The email address on the card.
     */
    emailAddress?: BusinessCardField | null;
    /**
     * The fax number, as printed.
     */
    fax?: BusinessCardField | null;
    /**
     * The given name of the person on the card.
     */
    firstName?: BusinessCardField | null;
    /**
     * The family name of the person on the card.
     */
    lastName?: BusinessCardField | null;
    /**
     * The mobile or cell number, as printed.
     */
    mobilePhone?: BusinessCardField | null;
    /**
     * The office or direct line, as printed.
     */
    phone?: BusinessCardField | null;
    /**
     * Every legible line on the card in reading order, one per line, so a reviewer can see what was read.
     */
    rawText?: string | null;
    /**
     * The person's job title.
     */
    title?: BusinessCardField | null;
    /**
     * The website, as printed.
     */
    website?: BusinessCardField | null;
}
/**
 * A line that could not be placed because of a failure part way; resending the same request finishes it.
 */
export interface FailedLine extends Parsable {
    /**
     * The reason property
     */
    reason?: string | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
}
export interface FailPaymentRequest extends Parsable {
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface FavoriteList extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The favoriteListId property
     */
    favoriteListId?: string | null;
    /**
     * The isDefault property
     */
    isDefault?: boolean | null;
    /**
     * The items property
     */
    items?: FavoriteListItem[] | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
    /**
     * The source property
     */
    source?: string | null;
    /**
     * The userId property
     */
    userId?: string | null;
}
export interface FavoriteListItem extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The favoriteListId property
     */
    favoriteListId?: string | null;
    /**
     * The favoriteListItemId property
     */
    favoriteListItemId?: string | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The source property
     */
    source?: string | null;
}
export type FieldType = (typeof FieldTypeObject)[keyof typeof FieldTypeObject];
export interface Flipbook extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The flipbookId property
     */
    flipbookId?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The pages property
     */
    pages?: Page[] | null;
    /**
     * The pdfSourceName property
     */
    pdfSourceName?: string | null;
    /**
     * The sortOrder property
     */
    sortOrder?: number | null;
    /**
     * The title property
     */
    title?: string | null;
}
/**
 * The page list of a flipbook after a page-level change.
 */
export interface FlipbookPagesResponse extends Parsable {
    /**
     * The flipbookId property
     */
    flipbookId?: string | null;
    /**
     * The pageCount property
     */
    pageCount?: number | null;
    /**
     * The pages property
     */
    pages?: PageInfo[] | null;
    /**
     * The title property
     */
    title?: string | null;
}
export interface FolderListResponse extends Parsable {
    /**
     * The folders property
     */
    folders?: CompanyFolderDto[] | null;
}
export interface FolderResponse extends Parsable {
    /**
     * A folder in the organization's document library.
     */
    folder?: CompanyFolderDto | null;
}
export interface FolderResponse2 extends Parsable {
    /**
     * A folder in the organization's document library.
     */
    folder?: CompanyFolderDto | null;
}
/**
 * A trained forecast model as it stands: what it was trained on, how well it scored, and whetherit is the version forecasts use by default.
 */
export interface ForecastModelDto extends Parsable {
    /**
     * When the model was trained.
     */
    createdAt?: Date | null;
    /**
     * What the model forecasts, where it is scoped to a single subject rather than the whole organisation.
     */
    entityId?: string | null;
    /**
     * The period each data point covers, e.g. monthly.
     */
    granularity?: string | null;
    /**
     * True for the version a forecast uses when the caller pins no modelId.
     */
    isCurrent?: boolean | null;
    /**
     * Accuracy scored against the training data. Null when training recorded none.
     */
    metrics?: ModelMetrics | null;
    /**
     * Identifies this model. Pass it as modelId on a forecast call to pin that version.
     */
    modelId?: string | null;
    /**
     * The family of model that was trained. Also the filter accepted by the list endpoint.
     */
    modelType?: string | null;
    /**
     * Human-readable name for the model.
     */
    name?: string | null;
    /**
     * The organisation the model was trained for. Models are never shared across organisations.
     */
    organizationId?: string | null;
    /**
     * The parameters training ran with, including the confidence-interval width forecasts reuse.
     */
    settings?: ForecastModelSettings | null;
    /**
     * End of the history the model was trained on. The model knows nothing after this date.
     */
    trainingDataEndDate?: Date | null;
    /**
     * How many observations training saw. A low count is the usual reason a forecast looks poor.
     */
    trainingDataPoints?: number | null;
    /**
     * Start of the history the model was trained on.
     */
    trainingDataStartDate?: Date | null;
    /**
     * How long training took, in milliseconds.
     */
    trainingDurationMs?: number | null;
    /**
     * When the model record last changed.
     */
    updatedAt?: Date | null;
    /**
     * Which training run produced this model, counting up from the first.
     */
    version?: number | null;
}
export interface ForecastModelSettings extends Parsable {
    /**
     * The ciHalfWidth property
     */
    ciHalfWidth?: number | null;
    /**
     * The ciHalfWidths property
     */
    ciHalfWidths?: number[] | null;
    /**
     * The confidenceLevel property
     */
    confidenceLevel?: number | null;
    /**
     * The enableRecentLevelRescaling property
     */
    enableRecentLevelRescaling?: boolean | null;
    /**
     * The horizon property
     */
    horizon?: number | null;
    /**
     * The inputColumnName property
     */
    inputColumnName?: string | null;
    /**
     * The minimumDataPoints property
     */
    minimumDataPoints?: number | null;
    /**
     * The outputColumnName property
     */
    outputColumnName?: string | null;
    /**
     * The seasonalityWindowSize property
     */
    seasonalityWindowSize?: number | null;
    /**
     * The seasonalNaiveBlendWeight property
     */
    seasonalNaiveBlendWeight?: number | null;
    /**
     * The seasonalNaiveUnitsByMonth property
     */
    seasonalNaiveUnitsByMonth?: number[] | null;
    /**
     * The trainingAverageUnits property
     */
    trainingAverageUnits?: number | null;
    /**
     * The trainingWindowSize property
     */
    trainingWindowSize?: number | null;
}
export interface FreeShippingEntitlement extends Parsable {
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The originalAmount property
     */
    originalAmount?: number | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
}
export interface GenerateCodesRequest extends Parsable {
    /**
     * How many codes to make, 1 to 1000. Ignored when customerNumbers is given.
     */
    count?: number | null;
    /**
     * One code per listed customer, each restricted to that customer.
     */
    customerNumbers?: string[] | null;
    /**
     * Restrictions applied to every generated code; omit for none.
     */
    options?: DiscountCodeOptionsInput | null;
    /**
     * Optional prefix every generated code starts with (up to 32 characters, same alphabet as a code).
     */
    prefix?: string | null;
}
export interface GenerateCommissionStatementRequest extends Parsable {
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The generatedByUser property
     */
    generatedByUser?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The taxItems property
     */
    taxItems?: GenerateCommissionStatementRequest_TaxItemInput[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface GenerateCommissionStatementRequest_TaxItemInput extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The ratePercent property
     */
    ratePercent?: number | null;
    /**
     * The taxName property
     */
    taxName?: string | null;
}
/**
 * Who is emailed when a new access request is submitted to the organization.
 */
export interface GetAccessRequestNotificationSettingsResponse extends Parsable {
    /**
     * The address notifications actually go to: the configured address when set, otherwise theorganization's contact email. Null only when neither is available, in which case nonotification is sent.
     */
    effectiveNotificationEmail?: string | null;
    /**
     * The configured notification address, or null when none has been set.
     */
    notificationEmail?: string | null;
}
export interface GetAccessRequestResponse extends Parsable {
    /**
     * The access request.
     */
    accessRequest?: AccessRequest | null;
    /**
     * The customer the request was approved into, when it has been approved and that customer still exists.
     */
    customer?: Customer | null;
    /**
     * What the platform already knows about the requester's email address: whether an account existsand which customers it can already shop for in this organization. Null when that could not bedetermined; the request itself is still returned.
     */
    existingAccess?: ExistingAccessResponse | null;
}
/**
 * The organization's active payment gateway. Provider is null when no payment integration is enabled.
 */
export interface GetActivePaymentGatewayResponse extends Parsable {
    /**
     * The provider property
     */
    provider?: string | null;
}
export interface GetAddressDetailsRequest extends Parsable {
    /**
     * The placeId property
     */
    placeId?: string | null;
}
export interface GetAddressDetailsResponse extends Parsable {
    /**
     * The html_attributions property
     */
    htmlAttributions?: UntypedNode | null;
    /**
     * The result property
     */
    result?: Result | null;
    /**
     * The status property
     */
    status?: string | null;
}
/**
 * Per-organization AI usage totals over a window, with a breakdown by operation and model.
 */
export interface GetAiUsageResponse extends Parsable {
    /**
     * Cost/tokens/calls grouped by operation + model, most expensive first.
     */
    breakdown?: AiUsageBreakdownItem[] | null;
    /**
     * Number of AI provider calls in the window.
     */
    callCount?: number | null;
    /**
     * The from property
     */
    from?: Date | null;
    /**
     * The to property
     */
    to?: Date | null;
    /**
     * Total estimated cost in USD across all AI calls in the window.
     */
    totalCostUsd?: number | null;
    /**
     * Total tokens (input + output) across all AI calls in the window.
     */
    totalTokens?: number | null;
}
export interface GetApiAccessResponse extends Parsable {
    /**
     * The apiKey property
     */
    apiKey?: string | null;
}
export interface GetAvailableIntegrationsResponse extends Parsable {
    /**
     * How many of them this organisation has set up.
     */
    configuredCount?: number | null;
    /**
     * How many of the configured ones are switched on.
     */
    enabledCount?: number | null;
    /**
     * Every supported provider, grouped by what it is for and sorted by display name.
     */
    integrationsByType?: GetAvailableIntegrationsResponse_integrationsByType | null;
    /**
     * The organisation this view was built for.
     */
    organizationId?: string | null;
    /**
     * How many providers the platform supports in total.
     */
    totalAvailable?: number | null;
}
/**
 * Every supported provider, grouped by what it is for and sorted by display name.
 */
export interface GetAvailableIntegrationsResponse_integrationsByType extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * Bulk write activity for one organization over a window, broken down by endpoint and UTC day.
 */
export interface GetBulkWriteSummaryResponse extends Parsable {
    /**
     * Per endpoint per UTC day, oldest day first.
     */
    days?: BulkWriteDailyTotal[] | null;
    /**
     * The from property
     */
    from?: Date | null;
    /**
     * The to property
     */
    to?: Date | null;
    /**
     * Bulk calls received in the window, successful or not.
     */
    totalCalls?: number | null;
    /**
     * Documents received across all bulk calls in the window.
     */
    totalDocuments?: number | null;
    /**
     * Calls that did not succeed.
     */
    totalFailedCalls?: number | null;
}
/**
 * The organization's cart pricing settings: stale cart price refresh and rep price overrides.
 */
export interface GetCartPricingSettingsResponse extends Parsable {
    /**
     * Whether sales reps may enter line quantities with up to two decimal places. False for everyorganization that has not opted in. Gates writing a fractional quantity only — lines andorders that already carry one keep it after it is turned off.
     */
    allowDecimalQuantities?: boolean | null;
    /**
     * The organization-wide default for whether sales reps may apply discounts to individual linesin the sales app. Same semantics as AllowOrderDiscounts.
     */
    allowLineItemDiscounts?: boolean | null;
    /**
     * The organization-wide default for whether sales reps may apply a discount to a whole order(the cart-level discount) in the sales app. True unless an admin has turned it off. A rep'sown setting (see the sales rep list) can override it either way. Gates applying a discountonly — carts and orders that already carry one keep it.
     */
    allowOrderDiscounts?: boolean | null;
    /**
     * Whether sales reps may override a cart line's catalog price by hand on Review Order. Falsefor every organization that has not opted in. Gates creating an override only — lines andorders that already carry one keep their price after it is turned off.
     */
    allowPriceOverride?: boolean | null;
    /**
     * Whether carts whose prices have aged past StalePriceAgeDays are repriced whenviewed and before checkout. False for every organization that has not opted in.
     */
    refreshStalePrices?: boolean | null;
    /**
     * How many days cart prices may age before they count as stale. Only meaningful whenRefreshStalePrices is true.
     */
    stalePriceAgeDays?: number | null;
}
export interface GetCustomerSalesRepResponse extends Parsable {
    /**
     * False when the customer's rep has been deactivated (or no rep is assigned). Storefrontskeep showing the contact details but must not offer flows that hand work to the rep, suchas sending a cart for review.
     */
    active?: boolean | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The phone property
     */
    phone?: string | null;
}
/**
 * Email delivery totals for a window, and the same counts day by day.
 */
export interface GetEmailStatsResponse extends Parsable {
    /**
     * One entry per day in the window, oldest first, including days with no email.
     */
    days?: EmailStatsDay[] | null;
    /**
     * The from property
     */
    from?: Date | null;
    /**
     * The time zone the days were counted in (UTC when the requested one was unknown).
     */
    timeZone?: string | null;
    /**
     * The to property
     */
    to?: Date | null;
    /**
     * How many emails reached each outcome. Each email counts once per outcome: an email opened fivetimes is one open.
     */
    totals?: EmailStatsCounts | null;
}
/**
 * Represents the response containing the download URL for an export and its expiration time.
 */
export interface GetExportDownloadUrlResponse extends Parsable {
    /**
     * Gets or sets the URL where the export can be downloaded.
     */
    downloadUrl?: string | null;
    /**
     * Gets or sets the UTC timestamp indicating when the download URL will expire.
     */
    expirationAtUtc?: Date | null;
}
export interface GetFeatureFlagsResponse extends Parsable {
    /**
     * Every boolean flag in force for the organization, keyed by flag code (e.g. business-card-scan).
     */
    flags?: GetFeatureFlagsResponse_flags | null;
    /**
     * The organization the flags are for.
     */
    organizationId?: string | null;
}
/**
 * Every boolean flag in force for the organization, keyed by flag code (e.g. business-card-scan).
 */
export interface GetFeatureFlagsResponse_flags extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface GetForecastModelResponse extends Parsable {
    /**
     * The requested model's metadata and accuracy metrics.
     */
    model?: ForecastModelDto | null;
}
export interface GetIntegrationResponse extends Parsable {
    /**
     * Available configuration fields from the template
     */
    availableFields?: GetIntegrationResponse_availableFields | null;
    /**
     * The configuration settings for the integration (secrets are excluded)
     */
    configuration?: GetIntegrationResponse_configuration | null;
    /**
     * When the integration was created
     */
    createdAt?: Date | null;
    /**
     * Who created the integration
     */
    createdBy?: string | null;
    /**
     * The display name for the integration
     */
    displayName?: string | null;
    /**
     * The unique identifier of the integration
     */
    integrationId?: string | null;
    /**
     * The type of integration (Payment, Accounting, etc.)
     */
    integrationType?: IntegrationType | null;
    /**
     * Whether the integration is enabled
     */
    isEnabled?: boolean | null;
    /**
     * The organization identifier
     */
    organizationId?: string | null;
    /**
     * The provider name (e.g., AuthorizeNet, QuickBooks)
     */
    provider?: string | null;
    /**
     * When the integration was last updated
     */
    updatedAt?: Date | null;
}
/**
 * Available configuration fields from the template
 */
export interface GetIntegrationResponse_availableFields extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * The configuration settings for the integration (secrets are excluded)
 */
export interface GetIntegrationResponse_configuration extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface GetIntegrationTemplatesByTypeResponse extends Parsable {
    /**
     * The providers in that category and what each requires. Empty if there are none.
     */
    templates?: IntegrationTemplate[] | null;
    /**
     * The category that was requested, echoed back.
     */
    type?: IntegrationType | null;
}
export interface GetInvoicesByIdsRequest extends Parsable {
    /**
     * The invoiceIds property
     */
    invoiceIds?: string[] | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
/**
 * A short-lived access token the admin app's map control uses to call the maps service directly(tiles, geocoding for pins). Issued from the API's own identity, so no map key ever ships to a browser.
 */
export interface GetMapsTokenResponse extends Parsable {
    /**
     * When the token expires; request a new one before then.
     */
    expiresOn?: Date | null;
    /**
     * Bearer token for the maps service.
     */
    token?: string | null;
}
/**
 * The organization's order export settings, together with every custom format that could beenabled for it. Both come back in one call so the settings screen can render a picker withouthaving to ask twice.
 */
export interface GetOrderExportSettingsResponse extends Parsable {
    /**
     * Every custom format the platform has implemented, whether or not this organization isenabled for it. This is the full set of valid keys the update endpoint will accept.
     */
    availableFormats?: AvailableExportFormatDto[] | null;
    /**
     * The custom format keys this organization may currently export with. A key here that nolonger appears in AvailableFormats is a format that has since been retired —it is inert, and saving the form drops it.
     */
    enabledCustomFormats?: string[] | null;
}
export interface GetOrderInvoiceSummaryRequest extends Parsable {
    /**
     * The orderedQuantitiesBySku property
     */
    orderedQuantitiesBySku?: GetOrderInvoiceSummaryRequest_orderedQuantitiesBySku | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface GetOrderInvoiceSummaryRequest_orderedQuantitiesBySku extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface GetOrderKindsResponse extends Parsable {
    /**
     * Every order kind the platform defines, grouped by family and ordered for display.
     */
    kinds?: OrderKindDto[] | null;
}
export interface GetOrderVolumeForecastResponse extends Parsable {
    /**
     * The forecast, one point per month, starting the month after the latest recorded history.
     */
    forecast?: MonthlyForecastPointDto[] | null;
    /**
     * When the forecast was computed. Forecasts are generated per request, never cached.
     */
    generatedAt?: Date | null;
    /**
     * The model that produced this forecast. Pass it back as modelId to reproduce the same run.
     */
    modelId?: string | null;
}
export interface GetOrderVolumeHistoryResponse extends Parsable {
    /**
     * Monthly order-volume data points ordered chronologically.
     */
    history?: OrderVolumeHistoryPointDto[] | null;
}
/**
 * Envelope for the organization profile response. Mirrors the existingGetOrganizationResponse shape (an Organization object) but carries thefixed-shape, customer-safe OrganizationProfileDto instead of the raw domain model.
 */
export interface GetOrganizationProfileResponse extends Parsable {
    /**
     * The kind of access the calling credential holds: admin, storefront,sales-rep or customer. Lets an integration confirm it was configured withthe key it expects — a storefront, for example, should refuse to run on an admin key.
     */
    callerAccess?: string | null;
    /**
     * The organization property
     */
    organization?: OrganizationProfileDto | null;
}
export interface GetOrganizationResponse extends Parsable {
    /**
     * The entitlements property
     */
    entitlements?: ListOfEntitlements[] | null;
    /**
     * The organization property
     */
    organization?: Organization | null;
    /**
     * The subscriptions property
     */
    subscriptions?: Subscription2[] | null;
}
export interface GetProductsBySkusRequest extends Parsable {
    /**
     * The skus property
     */
    skus?: string[] | null;
}
/**
 * The organization's AI access-request research settings. Both fields are optional free text; anull value means the setting is unset and the research tool falls back to graceful defaults(unknown industry, generic B2B criteria).
 */
export interface GetResearchSettingsResponse extends Parsable {
    /**
     * The tenant's description of what types of businesses they approve as B2B customers (andanything that should be declined). The eligibility assessment is judged against it. Null when unset.
     */
    approvalCriteria?: string | null;
    /**
     * The tenant's own description of their industry and what they sell. Drives the industry andlicensing checks in the research prompt. Null when unset.
     */
    industryDescription?: string | null;
}
/**
 * What an organization pays for against what it is using, for showing "3 of 5 seats used" and fordisabling the add-rep action before someone fills in a form that will be refused.
 */
export interface GetSeatsResponse extends Parsable {
    /**
     * Reps holding a seat. Excludes deactivated reps, and excludes our own staff — they are added tocustomer organizations for support and are not what the customer pays per rep for.
     */
    activeReps?: number | null;
    /**
     * Billing period length, paired with BillingPeriodUnit (e.g. 1 month).
     */
    billingPeriod?: number | null;
    /**
     * The billingPeriodUnit property
     */
    billingPeriodUnit?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * Coupons on the subscription, in the order Stripe applies them. Empty when there are none — andalso when the subscription could not be read, in which case RecurringTotal is theundiscounted figure.
     */
    discounts?: SubscriptionDiscountLine[] | null;
    /**
     * Whether another rep can be added right now.
     */
    hasSeatsAvailable?: boolean | null;
    /**
     * False when the organization has no subscription at all, rather than one without seats.
     */
    hasSubscription?: boolean | null;
    /**
     * Whether the subscription is still in its trial.
     */
    inTrial?: boolean | null;
    /**
     * Most seats the catalog allows, when it says. Null means no stated ceiling.
     */
    maxSeats?: number | null;
    /**
     * Fewest seats this subscription can be reduced to. From the billing catalog where it states aminimum, otherwise the platform floor. Callers should use this as the lower bound on any seatpicker rather than assuming one.
     */
    minSeats?: number | null;
    /**
     * When the next invoice falls due — for a trial, when the first real charge lands.
     */
    nextBillingAt?: Date | null;
    /**
     * Email domains whose reps don't consume a seat — our own staff, added to customer organizations forsupport. Exposed so a caller can present rep counts the same way we bill them, instead ofhardcoding the list and drifting from it.
     */
    nonBillableEmailDomains?: string[] | null;
    /**
     * The plan being paid for, e.g. "Sales Plan". Null when there is no subscription.
     */
    planName?: string | null;
    /**
     * Every line the subscription bills for, seat-bearing and flat-rate alike. RecurringSubtotalis their sum: a subscription can hold the sales app and the storefront together, and reporting onlythe seat line would quietly understate what the customer pays.
     */
    plans?: SubscriptionPlanLine[] | null;
    /**
     * What the whole subscription costs per period before any coupon — the sum of every line inPlans, not the seat line alone. A subscription may hold the storefront alongside theseats, and charging for both while reporting only one is how a billing page loses a customer'strust.
     */
    recurringSubtotal?: number | null;
    /**
     * What the next charge comes to: RecurringSubtotal less every coupon inDiscounts that is still running by then. Reporting the undiscounted figure here tolda customer with a coupon they paid more than they do.            This is the recurring charge, not what changing the seat count would bill today: amid-period change is prorated against the remaining period, and only the billing provider's own preview can saywhat that comes to. Tax is not included.
     */
    recurringTotal?: number | null;
    /**
     * The remaining property
     */
    remaining?: number | null;
    /**
     * Seats purchased. Zero means the plan includes no sales app.
     */
    seats?: number | null;
    /**
     * False when we hold a subscription recorded before seats were tracked and no billing event hasdescribed it since. Seats aren't enforced in that state, so a caller should present it as unknownrather than as a limit of zero.
     */
    seatsKnown?: boolean | null;
    /**
     * Increment seats are sold in, when the catalog says so. Defaults to 1.
     */
    seatStep?: number | null;
    /**
     * Price of one seat per billing period, in the currency's minor unit (4500 = $45.00). Zero when theplan sells no seats. Multiply by a seat count to get a recurring total.
     */
    seatUnitPrice?: number | null;
    /**
     * Subscription status in the billing provider, e.g. in_trial, active, cancelled.Distinct from InTrial, which only answers the trial question.
     */
    subscriptionStatus?: string | null;
    /**
     * Whole days of trial left, rounded up. Null when not in a trial.
     */
    trialDaysRemaining?: number | null;
    /**
     * The trialEndsAt property
     */
    trialEndsAt?: Date | null;
    /**
     * Why adding a rep would be refused, ready to show. Null when a seat is available.
     */
    unavailableReason?: string | null;
}
export interface GetSkuForecastResponse extends Parsable {
    /**
     * The forecast, one point per month, starting the month after the SKU's latest recorded sale.
     */
    forecast?: MonthlyForecastPointDto[] | null;
    /**
     * When the forecast was computed. Forecasts are generated per request, never cached.
     */
    generatedAt?: Date | null;
    /**
     * The model that produced this forecast. Pass it back as modelId to reproduce the same run.
     */
    modelId?: string | null;
    /**
     * The SKU this forecast is for.
     */
    sku?: string | null;
}
export interface GetSkuHistoryResponse extends Parsable {
    /**
     * Monthly sales data points ordered chronologically.
     */
    history?: SkuHistoryPointDto[] | null;
    /**
     * The SKU whose history is returned.
     */
    sku?: string | null;
}
export interface GetTemplatesResponse extends Parsable {
    /**
     * The providers the platform supports and the fields each one requires.
     */
    templates?: IntegrationTemplate[] | null;
}
export interface GetUserProfileResponse extends Parsable {
    /**
     * The user's email address
     */
    email?: string | null;
    /**
     * The user's first name
     */
    firstName?: string | null;
    /**
     * The user's last name
     */
    lastName?: string | null;
    /**
     * The user's phone number
     */
    phoneNumber?: string | null;
}
export interface GiftInstruction extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The product property
     */
    product?: GiftProductSnapshot | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
}
export interface GiftMarker extends Parsable {
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The freeQuantity property
     */
    freeQuantity?: number | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
}
/**
 * Free units a promotion put on a line (CU-86bcj36vr): which promotion, and how many of the line's units are free.
 */
export interface GiftMarkerDto extends Parsable {
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The freeQuantity property
     */
    freeQuantity?: number | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
}
export interface GiftProductSnapshot extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The minimumOrderQuantity property
     */
    minimumOrderQuantity?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The quantityIncrement property
     */
    quantityIncrement?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The taxCategory property
     */
    taxCategory?: string | null;
    /**
     * The unitPrice property
     */
    unitPrice?: number | null;
}
export interface HeaderColumnMap extends Parsable {
    /**
     * The header property
     */
    header?: string | null;
    /**
     * The mapping property
     */
    mapping?: HeaderMapping | null;
}
export interface HeaderMapping extends Parsable {
    /**
     * The mappedHeaderName property
     */
    mappedHeaderName?: string | null;
    /**
     * The uploadedHeaderName property
     */
    uploadedHeaderName?: string | null;
}
/**
 * A single liveness ping from a registered connector.
 */
export interface HeartbeatSqlConnectorRequest extends Parsable {
    /**
     * Free-form diagnostic values, merged into whatever the connector has already reported —keys absent from this request keep their previous value.
     */
    metadata?: HeartbeatSqlConnectorRequest_metadata | null;
    /**
     * How the connector is currently running. Defaults to Online.
     */
    status?: ConnectorStatusType | null;
    /**
     * The connector's build version. Omit it to leave the recorded version unchanged.
     */
    version?: string | null;
}
/**
 * Free-form diagnostic values, merged into whatever the connector has already reported —keys absent from this request keep their previous value.
 */
export interface HeartbeatSqlConnectorRequest_metadata extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface HomeEndpoint_HomeResponse extends Parsable {
    /**
     * The buildDate property
     */
    buildDate?: string | null;
    /**
     * The contact property
     */
    contact?: string | null;
    /**
     * The documentation property
     */
    documentation?: string | null;
    /**
     * The message property
     */
    message?: string | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The website property
     */
    website?: string | null;
}
export interface Image extends Parsable {
    /**
     * The baseUrl property
     */
    baseUrl?: string | null;
    /**
     * The imageId property
     */
    imageId?: string | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The largeUrl property
     */
    largeUrl?: string | null;
    /**
     * The mediumUrl property
     */
    mediumUrl?: string | null;
    /**
     * The position property
     */
    position?: number | null;
    /**
     * The smallUrl property
     */
    smallUrl?: string | null;
    /**
     * When the image behind this assignment was last uploaded; null for images stored beforeuploads were stamped. Image ids never change, so a replaced image keeps its URL: thetimestamp rides along as a cache-key version so browsers and apps fetch the new bytes.
     */
    uploadedAt?: Date | null;
}
export interface ImageDetail extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The baseUrl property
     */
    baseUrl?: string | null;
    /**
     * The contentSize property
     */
    contentSize?: number | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The format property
     */
    format?: ImageFormat | null;
    /**
     * The height property
     */
    height?: number | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The largeUrl property
     */
    largeUrl?: string | null;
    /**
     * The mediumUrl property
     */
    mediumUrl?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The smallUrl property
     */
    smallUrl?: string | null;
    /**
     * The source property
     */
    source?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
    /**
     * The width property
     */
    width?: number | null;
}
export type ImageFormat = (typeof ImageFormatObject)[keyof typeof ImageFormatObject];
export interface ImageHousekeepingCleanUpRequest extends Parsable {
    /**
     * The abandoned asset ids to move to the trash, as reported by the housekeeping scan.Every id is re-validated server-side; ids that are tracked, flipbook-referenced, alreadytrashed, or not the organization's are skipped and reported as such.
     */
    imageIds?: string[] | null;
}
/**
 * Outcome of an organization-scoped clean-up: what was moved to the trash and what wasskipped, per reason. Every submitted id is re-validated server-side.
 */
export interface ImageHousekeepingCleanUpStatusResponse extends Parsable {
    /**
     * The errorMessage property
     */
    errorMessage?: string | null;
    /**
     * Assets whose trash move failed; rerun the clean-up to pick them up.
     */
    failed?: number | null;
    /**
     * The isSuccessfull property
     */
    isSuccessfull?: boolean | null;
    /**
     * The requested property
     */
    requested?: number | null;
    /**
     * Skipped: a flipbook page references the asset.
     */
    skippedFlipbookReferenced?: number | null;
    /**
     * Skipped: not one of this organization's stored assets (unknown id, already trashed, oroutside the organization).
     */
    skippedNotFound?: number | null;
    /**
     * Skipped: an image document exists, the asset is live.
     */
    skippedTracked?: number | null;
    /**
     * Assets moved to the trash — recoverable until the retention purge.
     */
    trashed?: number | null;
    /**
     * The ids actually moved to the trash.
     */
    trashedImageIds?: string[] | null;
}
/**
 * Findings of an organization-scoped housekeeping scan: the org's abandoned assets and itscurrent trash, in one pass.
 */
export interface ImageHousekeepingScanStatusResponse extends Parsable {
    /**
     * Assets with no image document and no flipbook reference — the clean-up candidates.
     */
    abandonedAssets?: number | null;
    /**
     * The abandoned asset ids, exactly as stored.
     */
    abandonedImageIds?: string[] | null;
    /**
     * The errorMessage property
     */
    errorMessage?: string | null;
    /**
     * Assets kept live only by a flipbook page reference (no image document). Never offeredfor clean-up.
     */
    flipbookReferencedAssets?: number | null;
    /**
     * The isSuccessfull property
     */
    isSuccessfull?: boolean | null;
    /**
     * How many stored assets belong to the organization, trashed ones included.
     */
    totalAssets?: number | null;
    /**
     * Assets backed by an image document.
     */
    trackedAssets?: number | null;
    /**
     * The organization's assets currently sitting in the trash.
     */
    trashedAssets?: ImageHousekeepingScanStatusResponse_TrashedAsset[] | null;
}
/**
 * One asset in the trash: when it was trashed and by which flow.
 */
export interface ImageHousekeepingScanStatusResponse_TrashedAsset extends Parsable {
    /**
     * The imageId property
     */
    imageId?: string | null;
    /**
     * The source property
     */
    source?: string | null;
    /**
     * The trashedAt property
     */
    trashedAt?: Date | null;
}
/**
 * Represents the response containing the status of the Images Clean-Up Job.
 */
export interface ImagesCleanUpJobStatusResponse extends Parsable {
    /**
     * The errorMessage property
     */
    errorMessage?: string | null;
    /**
     * The isSuccessfull property
     */
    isSuccessfull?: boolean | null;
    /**
     * Gets or sets the total number of images cleaned during the job.
     */
    totalImagesCleaned?: number | null;
    /**
     * Gets or sets the total number of organizations processed during the job.
     */
    totalOrganizations?: number | null;
}
export interface ImageTrashPurgeJobRequest extends Parsable {
    /**
     * When true (the default) the job only reports what has expired; nothing is purged.
     */
    dryRun?: boolean | null;
    /**
     * Optional retention override in days. When omitted, the configured retention windowapplies. Assets trashed more recently than the window are never purged.
     */
    olderThanDays?: number | null;
}
/**
 * Represents the response containing the status of the Image Trash Purge Job.
 */
export interface ImageTrashPurgeJobStatusResponse extends Parsable {
    /**
     * Whether this run only reported findings without purging anything.
     */
    dryRun?: boolean | null;
    /**
     * The errorMessage property
     */
    errorMessage?: string | null;
    /**
     * The expired asset ids, exactly as stored.
     */
    expiredImageIds?: string[] | null;
    /**
     * The isSuccessfull property
     */
    isSuccessfull?: boolean | null;
    /**
     * The retention window applied, in days.
     */
    retentionDays?: number | null;
    /**
     * Trashed assets older than the retention window - the purge candidates.
     */
    totalExpired?: number | null;
    /**
     * Expired assets actually purged (always 0 on a dry run).
     */
    totalPurged?: number | null;
    /**
     * How many assets are currently in the trash, expired or not.
     */
    totalTrashed?: number | null;
}
/**
 * Represents an item to be uploaded, including its URL, name, and associated SKU.
 */
export interface ImageUploadItem extends Parsable {
    /**
     * Gets or sets a value indicating whether the SKU should be extracted from the image name.
     */
    extractSkuFromImageName?: boolean | null;
    /**
     * Gets or sets the name of the image. If not supplied, it will be extracted from the image URL.
     */
    imageName?: string | null;
    /**
     * Gets or sets the URL of the image to be uploaded. It is required
     */
    imageUrl?: string | null;
    /**
     * Gets or sets the product SKU associated with the image.
     */
    productSku?: string | null;
    /**
     * For agency organizations: the code of the vendor (line) the product belongs to, e.g. "HAL".The row's ProductSku is then matched as "{vendorCode}-{sku}", the way the product importstores it; a value already carrying the prefix is left alone, so re-sending an exported SKUdoes not double it. Must name one of the organization's vendors. Omit for the organization'sown catalog, and the SKU is used exactly as given. Refused for a Supplier organization. Notcombinable with ExtractSkuFromImageName, which derives the SKU from the file name as is.
     */
    vendorCode?: string | null;
}
/**
 * What an uploaded image was assigned to.
 */
export interface ImageUploadResponse extends Parsable {
    /**
     * product when a product's SKU or image name matched, productFamily when noproduct matched but a product family's key did (the image joins the family's sharedimages), or none when the image was stored but nothing matched.
     */
    assignedTo?: string | null;
    /**
     * The matched product's SKU or family's key; null when AssignedTo is none.
     */
    assignedToKey?: string | null;
    /**
     * The stored image name (the file name, lower-cased, without its extension).
     */
    imageName?: string | null;
}
export interface ImportColumnSample extends Parsable {
    /**
     * The column's header cell, as read from the sheet.
     */
    header?: string | null;
    /**
     * A handful of cell values from the column, to help tell apart columns whose headers alone areambiguous. Up to five distinct non-empty values are used; the rest are ignored. Customerssamples are masked before they are evaluated, so personal data never leaves the platform.
     */
    samples?: string[] | null;
}
/**
 * Returned only when the connection was started without a return URL. A flow that supplied one isanswered with a redirect instead of this body.
 */
export interface IntegrationOAuthCallbackResponse extends Parsable {
    /**
     * The integration that is now connected.
     */
    integrationId?: string | null;
    /**
     * A short description of the outcome, safe to show to a user.
     */
    message?: string | null;
    /**
     * Whether the connection completed.
     */
    success?: boolean | null;
}
/**
 * One configured integration, without its credentials.
 */
export interface IntegrationSummary extends Parsable {
    /**
     * The non-secret settings. Credentials are never included here or anywhere else.
     */
    configuration?: IntegrationSummary_configuration | null;
    /**
     * When the integration was created.
     */
    createdAt?: Date | null;
    /**
     * The name operators see.
     */
    displayName?: string | null;
    /**
     * The integration's identifier, as used on every other integration endpoint.
     */
    id?: string | null;
    /**
     * What the integration is for.
     */
    integrationType?: IntegrationType | null;
    /**
     * Whether the integration is switched on. Enabled is not the same as working.
     */
    isEnabled?: boolean | null;
    /**
     * When the connection was last tested. Null if it never has been.
     */
    lastTestedAt?: Date | null;
    /**
     * The organisation the integration belongs to.
     */
    organizationId?: string | null;
    /**
     * The provider it connects to, e.g. AuthorizeNet or QuickBooks.
     */
    provider?: string | null;
    /**
     * How the last connection test went. Unknown means it has never been tested.
     */
    testStatus?: IntegrationTestStatus | null;
    /**
     * When the integration was last changed.
     */
    updatedAt?: Date | null;
}
/**
 * The non-secret settings. Credentials are never included here or anywhere else.
 */
export interface IntegrationSummary_configuration extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * What one provider needs before an integration can be created against it. The keys named here arethe keys to use in a create or update request — they are not free-form.
 */
export interface IntegrationTemplate extends Parsable {
    /**
     * The address that must be registered with the provider as its OAuth return URL before aconnection attempt will succeed. Null for a provider that does not use OAuth.
     */
    callbackUrl?: string | null;
    /**
     * The non-secret settings this provider accepts, and which of them are required.
     */
    configurationFields?: ConfigurationField[] | null;
    /**
     * What connecting this provider gets the organisation.
     */
    description?: string | null;
    /**
     * The provider's name as it should be shown to an operator.
     */
    displayName?: string | null;
    /**
     * The provider's own documentation, for operators who need to find their credentials.
     */
    documentationUrl?: string | null;
    /**
     * The provider's logo, for rendering a catalogue.
     */
    logoUrl?: string | null;
    /**
     * The provider's key, passed verbatim when creating an integration.
     */
    provider?: string | null;
    /**
     * True when the provider is authorised through OAuth rather than by entering credentials, inwhich case the integration is created without secrets and then connected.
     */
    requiresOAuth?: boolean | null;
    /**
     * The credentials this provider asks for. Descriptions of what to supply — no value is everreturned here.
     */
    secretFields?: SecretField[] | null;
    /**
     * What this provider can do, as short feature keys.
     */
    supportedFeatures?: string[] | null;
    /**
     * The category this provider belongs to.
     */
    type?: IntegrationType | null;
}
export type IntegrationTestStatus = (typeof IntegrationTestStatusObject)[keyof typeof IntegrationTestStatusObject];
export type IntegrationType = (typeof IntegrationTypeObject)[keyof typeof IntegrationTypeObject];
/**
 * the dto used to send an error response to the client when an unhandled exception occurs on the server
 */
export interface InternalErrorResponse extends ApiError, Parsable {
    /**
     * http status code of the error response
     */
    code?: number | null;
    /**
     * additional information or instructions
     */
    note?: string | null;
    /**
     * the reason for the error
     */
    reason?: string | null;
    /**
     * error status
     */
    status?: string | null;
}
export interface Invoice extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The amountPaid property
     */
    amountPaid?: number | null;
    /**
     * The amountPaidFormatted property
     */
    amountPaidFormatted?: string | null;
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The balanceFormatted property
     */
    balanceFormatted?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customer property
     */
    customer?: Customer3 | null;
    /**
     * The discount property
     */
    discount?: Discount | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * The dueDate property
     */
    dueDate?: Date | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The fulfillmentCenter property
     */
    fulfillmentCenter?: string | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The importedBalance property
     */
    importedBalance?: number | null;
    /**
     * The importedInvoiceTotal property
     */
    importedInvoiceTotal?: number | null;
    /**
     * The invoiceDate property
     */
    invoiceDate?: Date | null;
    /**
     * The invoiceNumber property
     */
    invoiceNumber?: string | null;
    /**
     * The invoiceTotal property
     */
    invoiceTotal?: number | null;
    /**
     * The invoiceTotalFormatted property
     */
    invoiceTotalFormatted?: string | null;
    /**
     * The items property
     */
    items?: InvoiceItem[] | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The numberOfPackages property
     */
    numberOfPackages?: number | null;
    /**
     * The orderId property
     */
    orderId?: string | null;
    /**
     * The orderNumber property
     */
    orderNumber?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The payments property
     */
    payments?: Payment[] | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The primaryRepNumber property
     */
    primaryRepNumber?: string | null;
    /**
     * The primarySalesRep property
     */
    primarySalesRep?: SalesRep2 | null;
    /**
     * The shipping property
     */
    shipping?: number | null;
    /**
     * The shippingDetails property
     */
    shippingDetails?: ShippingDetails | null;
    /**
     * The shippingFormatted property
     */
    shippingFormatted?: string | null;
    /**
     * The status property
     */
    status?: InvoiceStatus | null;
    /**
     * The subtotal property
     */
    subtotal?: number | null;
    /**
     * The subtotalFormatted property
     */
    subtotalFormatted?: string | null;
    /**
     * The tax property
     */
    tax?: number | null;
    /**
     * The taxFormatted property
     */
    taxFormatted?: string | null;
    /**
     * The taxItems property
     */
    taxItems?: TaxLineItem[] | null;
    /**
     * The terms property
     */
    terms?: string | null;
    /**
     * The trackingNumber property
     */
    trackingNumber?: string | null;
}
/**
 * A postal address as it stood when the invoice was raised. It is a snapshot copied onto theinvoice, so later edits to the customer record do not change it.
 */
export interface InvoiceAddressDto extends Parsable {
    /**
     * The address1 property
     */
    address1?: string | null;
    /**
     * The address2 property
     */
    address2?: string | null;
    /**
     * What the address is for: Billing, Shipping or Company.
     */
    addressType?: string | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The short code the source system uses for this address, such as a ship-to code.
     */
    code?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * Whether this is the customer's default address of its type.
     */
    defaultEscaped?: boolean | null;
    /**
     * The address's identifier in the system the customer was imported from, when it has one.
     */
    externalId?: string | null;
    /**
     * Latitude in decimal degrees, or zero when the address has never been located.
     */
    latitude?: number | null;
    /**
     * Longitude in decimal degrees, or zero when the address has never been located.
     */
    longitude?: number | null;
    /**
     * The stateProvince property
     */
    stateProvince?: string | null;
    /**
     * The zipPostalCode property
     */
    zipPostalCode?: string | null;
}
/**
 * The customer the invoice was raised against, as they stood when it was raised. Like the addressesit carries, this is a snapshot rather than a live view of the customer record.
 */
export interface InvoiceCustomerDto extends Parsable {
    /**
     * Where the invoice is billed. This is the address that can be edited after the fact.
     */
    billingAddress?: InvoiceAddressDto | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The customer's number, which is how a customer is identified across the API.
     */
    customerNumber?: string | null;
    /**
     * Where the goods were sent.
     */
    shippingAddress?: InvoiceAddressDto | null;
}
/**
 * A discount, either on the invoice as a whole or on one of its lines.
 */
export interface InvoiceDiscountDto extends Parsable {
    /**
     * The promotion or agreement code the discount came from, when there is one.
     */
    code?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * How to read Value: Amount for a flat sum in the invoice's currency, Percentage for a share.
     */
    type?: string | null;
    /**
     * The raw figure. With type Amount a value of 10 means ten units of currency; with type Percentage it means ten percent.
     */
    value?: number | null;
}
/**
 * An invoice, with the customer and rep it was raised for, its lines, its payments and its money.An order may be invoiced in instalments, so several invoices can share one order.Every amount is in the invoice's own currency. Each property whose name ends in Formatted is thematching amount rendered for display in that currency, and carries no extra information.
 */
export interface InvoiceDto extends Parsable {
    /**
     * Whether the supplying system still considers the invoice current; an import clears it towithdraw an invoice without deleting it. This is a flag on the record, not a lifecycle statuslike Voided or Cancelled, and invoices are returned whatever its value — filter on it yourselfif it matters.
     */
    active?: boolean | null;
    /**
     * How much has actually been paid. Each payment counts for its net amount, so refunds bring thisdown and pending or failed payments add nothing. On an invoice that arrived with importedfigures it is the imported total less the imported balance instead.
     */
    amountPaid?: number | null;
    /**
     * The amountPaidFormatted property
     */
    amountPaidFormatted?: string | null;
    /**
     * The amount still outstanding — the total less what has been paid, or the imported balance when one was supplied.
     */
    balance?: number | null;
    /**
     * The balanceFormatted property
     */
    balanceFormatted?: string | null;
    /**
     * When the invoice record was created here, as distinct from InvoiceDate.
     */
    createdAt?: Date | null;
    /**
     * The currency every amount on this invoice is expressed in.
     */
    currencyCode?: string | null;
    /**
     * The customer property
     */
    customer?: InvoiceCustomerDto | null;
    /**
     * The single invoice-level discount, if one has been applied. Per-line discounts sit on the lines.
     */
    discount?: InvoiceDiscountDto | null;
    /**
     * What the invoice-level discount takes off, worked out against the subtotal. Zero when there is no discount.
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * When payment falls due under Terms. It can be moved after the fact.
     */
    dueDate?: Date | null;
    /**
     * The invoice's identifier in the accounting or ERP system it came from, when it came from one.
     */
    externalId?: string | null;
    /**
     * The warehouse that fulfilled the invoice, when the source system supplies one.
     */
    fulfillmentCenter?: string | null;
    /**
     * How the order is handed over — Ship, Pickup or Delivery. Carried through from the order or thesource system, so it is absent on invoices that never supplied one.
     */
    fulfillmentMethod?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The outstanding balance as reported by that other system, used as-is instead of being computed.Normally supplied alongside ImportedInvoiceTotal.
     */
    importedBalance?: number | null;
    /**
     * Present only on invoices whose payments are tracked in another system. When set it is theauthoritative total and overrides the figure computed from the lines, which is why editing thediscount on such an invoice does not move what is owed. Null on invoices totalled here.
     */
    importedInvoiceTotal?: number | null;
    /**
     * The date the invoice is dated, as supplied by whoever raised it. This drives the due date andany ageing; it is not when the record was written, which is CreatedAt.
     */
    invoiceDate?: Date | null;
    /**
     * The human-readable invoice number. Assigned once — either supplied by whoever created theinvoice or generated in sequence — and never reassigned afterwards.
     */
    invoiceNumber?: string | null;
    /**
     * The amount owed on the invoice: subtotal plus freight plus tax, less the invoice-leveldiscount. On an invoice that arrived with ImportedInvoiceTotal that figure isused instead, and the calculation above is ignored.
     */
    invoiceTotal?: number | null;
    /**
     * The invoiceTotalFormatted property
     */
    invoiceTotalFormatted?: string | null;
    /**
     * The invoice lines, ordered by their line number on the source document.
     */
    items?: InvoiceItemDto[] | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * How many packages the shipment held. Null means it was never supplied, which is different from a supplied zero.
     */
    numberOfPackages?: number | null;
    /**
     * The order this invoice was raised against. Absent on an invoice with no originating order.
     */
    orderId?: string | null;
    /**
     * The originating order's human-readable number, copied here when the invoice was raised.
     */
    orderNumber?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * Every payment recorded against the invoice, settled or not, in the order they were recorded.
     */
    payments?: PaymentDto[] | null;
    /**
     * The customer's purchase order number, when they gave one.
     */
    poNumber?: string | null;
    /**
     * The sales rep credited with the invoice. Absent when none was supplied.
     */
    primarySalesRep?: InvoiceSalesRepDto | null;
    /**
     * The freight charge, or zero when there are no shipping details. Added to the total on top of the subtotal.
     */
    shipping?: number | null;
    /**
     * Freight cost and carrier. Absent when the invoice carries no freight.
     */
    shippingDetails?: InvoiceShippingDetailsDto | null;
    /**
     * The shippingFormatted property
     */
    shippingFormatted?: string | null;
    /**
     * Where the invoice stands: Draft (created, not yet issued), Issued (sent and awaiting payment),PartiallyPaid (something settled, a balance remains), Paid (settled in full), Voided (writtenoff after issuance) or Cancelled (withdrawn before issuance). Voided and Cancelled are final.
     */
    status?: string | null;
    /**
     * The sum of the line subtotals, so it is already net of any per-line discounts but excludes theinvoice-level discount, freight and tax.
     */
    subtotal?: number | null;
    /**
     * The subtotalFormatted property
     */
    subtotalFormatted?: string | null;
    /**
     * The total tax on the invoice. Added on top of the subtotal.
     */
    tax?: number | null;
    /**
     * The taxFormatted property
     */
    taxFormatted?: string | null;
    /**
     * The payment terms as free text, such as "Net 30". Not interpreted by the API.
     */
    terms?: string | null;
    /**
     * The carrier's tracking number for the shipment this invoice covers, when there is one.
     */
    trackingNumber?: string | null;
    /**
     * When the invoice record last changed here, including payment and discount activity.
     */
    updatedAt?: Date | null;
}
export interface InvoiceItem extends Parsable {
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The discount property
     */
    discount?: Discount | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The lineNumber property
     */
    lineNumber?: number | null;
    /**
     * The orderItemSku property
     */
    orderItemSku?: string | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The qtyBackordered property
     */
    qtyBackordered?: number | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The subTotal property
     */
    subTotal?: number | null;
    /**
     * The subTotalFormatted property
     */
    subTotalFormatted?: string | null;
}
/**
 * One line on the invoice. When an order is invoiced in instalments a line covers part of an orderline rather than all of it.
 */
export interface InvoiceItemDto extends Parsable {
    /**
     * Free-form text for the line, such as a service description.
     */
    description?: string | null;
    /**
     * The discount applied to this line, if any. Separate from the invoice-level discount and set when the line is created.
     */
    discount?: InvoiceDiscountDto | null;
    /**
     * What the line discount takes off in total, already spread across the quantity — a flat Amount discount is applied per unit.
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * The product's identifier in the system the invoice came from.
     */
    externalId?: string | null;
    /**
     * The product image key, for rendering the line.
     */
    imageName?: string | null;
    /**
     * The line's position on the source document; lines are returned in this order. Zero on lines whose source supplied no numbering, in which case the stored order is kept.
     */
    lineNumber?: number | null;
    /**
     * The SKU of the order line this came from, which is what invoiced quantities are reconciled against. Usually the same as Sku, and absent on an invoice raised without an order.
     */
    orderItemSku?: string | null;
    /**
     * The unit price before any discount, in the invoice's currency.
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * How much of the ordered quantity is on back order and therefore not covered by this line. Zero when nothing is outstanding.
     */
    qtyBackordered?: number | null;
    /**
     * The quantity being invoiced on this line, which may be less than was ordered.
     */
    quantity?: number | null;
    /**
     * The SKU of the product being invoiced.
     */
    sku?: string | null;
    /**
     * Quantity times price, less DiscountAmount. Excludes tax, freight and any invoice-level discount.
     */
    subTotal?: number | null;
    /**
     * The subTotalFormatted property
     */
    subTotalFormatted?: string | null;
}
export interface InvoiceItemInput extends Parsable {
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The discount property
     */
    discount?: DiscountInput | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The lineNumber property
     */
    lineNumber?: number | null;
    /**
     * The orderItemSku property
     */
    orderItemSku?: string | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The qtyBackordered property
     */
    qtyBackordered?: number | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
}
/**
 * The sales rep credited with the invoice, snapshotted when it was raised.
 */
export interface InvoiceSalesRepDto extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * First and last name joined, for display.
     */
    fullName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The rep's identifier within the organization.
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The rep's number in the system the invoice came from. Often the only rep detail an import supplies.
     */
    repNumber?: string | null;
    /**
     * The rep's identifier. On an imported invoice whose rep number matched no rep, this and the organization rep id hold a placeholder meaning unassigned.
     */
    salesRepId?: string | null;
}
/**
 * Freight cost and carrier for the invoice.
 */
export interface InvoiceShippingDetailsDto extends Parsable {
    /**
     * The carrier and service, such as "UPS Ground". This is a different thing from the invoice's fulfillment method, which is how the order is handed over (Ship, Pickup, Delivery).
     */
    method?: string | null;
    /**
     * The freight charge, in the invoice's currency. It is added to the invoice total and is not part of the subtotal.
     */
    total?: number | null;
    /**
     * The freight charge rendered for display in the invoice's currency.
     */
    totalFormatted?: string | null;
}
export interface InvoicesPageSummary extends Parsable {
    /**
     * The asOf property
     */
    asOf?: Date | null;
    /**
     * The averageDaysToPay property
     */
    averageDaysToPay?: number | null;
    /**
     * The averageTermsDays property
     */
    averageTermsDays?: number | null;
    /**
     * The collectedLast30Days property
     */
    collectedLast30Days?: number | null;
    /**
     * The collectedPrior30Days property
     */
    collectedPrior30Days?: number | null;
    /**
     * The currentBalance property
     */
    currentBalance?: number | null;
    /**
     * The oldestOverdueDays property
     */
    oldestOverdueDays?: number | null;
    /**
     * The outstandingBalance property
     */
    outstandingBalance?: number | null;
    /**
     * The overdueBalance property
     */
    overdueBalance?: number | null;
    /**
     * The overdueCount property
     */
    overdueCount?: number | null;
    /**
     * The paidInvoicesMeasured property
     */
    paidInvoicesMeasured?: number | null;
    /**
     * The pastDue1To30 property
     */
    pastDue1To30?: number | null;
    /**
     * The pastDue31To60 property
     */
    pastDue31To60?: number | null;
    /**
     * The pastDueOver60 property
     */
    pastDueOver60?: number | null;
}
export type InvoiceStatus = (typeof InvoiceStatusObject)[keyof typeof InvoiceStatusObject];
export interface IssueInvoiceRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
/**
 * Represents the response returned when a job is accepted.
 */
export interface JobAcceptedResponse extends Parsable {
    /**
     * Gets or sets the URI to check the status of the accepted job.
     */
    statusUri?: string | null;
    /**
     * Gets or sets the unique tracking identifier for the accepted job.
     */
    trackingId?: string | null;
}
/**
 * a wrapper for holding a job execution result as well as any progress details.
 */
export interface JobResultOfAbandonedImageAssetsJobStatusResponse extends Parsable {
    /**
     * the current status
     */
    currentStatus?: string | null;
    /**
     * the number of steps currently completed
     */
    currentStep?: number | null;
    /**
     * returns true if either the result is ready or if all the steps are complete.
     */
    isComplete?: boolean | null;
    /**
     * the percentage of steps currently completed
     */
    progressPercentage?: number | null;
    /**
     * the end result
     */
    result?: AbandonedImageAssetsJobStatusResponse | null;
    /**
     * the number of total steps to be completed
     */
    totalSteps?: number | null;
}
/**
 * a wrapper for holding a job execution result as well as any progress details.
 */
export interface JobResultOfBulkImportCustomerUsersResponse extends Parsable {
    /**
     * the current status
     */
    currentStatus?: string | null;
    /**
     * the number of steps currently completed
     */
    currentStep?: number | null;
    /**
     * returns true if either the result is ready or if all the steps are complete.
     */
    isComplete?: boolean | null;
    /**
     * the percentage of steps currently completed
     */
    progressPercentage?: number | null;
    /**
     * the end result
     */
    result?: BulkImportCustomerUsersResponse | null;
    /**
     * the number of total steps to be completed
     */
    totalSteps?: number | null;
}
/**
 * a wrapper for holding a job execution result as well as any progress details.
 */
export interface JobResultOfDanglingAssignmentsCleanUpJobStatusResponse extends Parsable {
    /**
     * the current status
     */
    currentStatus?: string | null;
    /**
     * the number of steps currently completed
     */
    currentStep?: number | null;
    /**
     * returns true if either the result is ready or if all the steps are complete.
     */
    isComplete?: boolean | null;
    /**
     * the percentage of steps currently completed
     */
    progressPercentage?: number | null;
    /**
     * the end result
     */
    result?: DanglingAssignmentsCleanUpJobStatusResponse | null;
    /**
     * the number of total steps to be completed
     */
    totalSteps?: number | null;
}
/**
 * a wrapper for holding a job execution result as well as any progress details.
 */
export interface JobResultOfImageHousekeepingCleanUpStatusResponse extends Parsable {
    /**
     * the current status
     */
    currentStatus?: string | null;
    /**
     * the number of steps currently completed
     */
    currentStep?: number | null;
    /**
     * returns true if either the result is ready or if all the steps are complete.
     */
    isComplete?: boolean | null;
    /**
     * the percentage of steps currently completed
     */
    progressPercentage?: number | null;
    /**
     * the end result
     */
    result?: ImageHousekeepingCleanUpStatusResponse | null;
    /**
     * the number of total steps to be completed
     */
    totalSteps?: number | null;
}
/**
 * a wrapper for holding a job execution result as well as any progress details.
 */
export interface JobResultOfImageHousekeepingScanStatusResponse extends Parsable {
    /**
     * the current status
     */
    currentStatus?: string | null;
    /**
     * the number of steps currently completed
     */
    currentStep?: number | null;
    /**
     * returns true if either the result is ready or if all the steps are complete.
     */
    isComplete?: boolean | null;
    /**
     * the percentage of steps currently completed
     */
    progressPercentage?: number | null;
    /**
     * the end result
     */
    result?: ImageHousekeepingScanStatusResponse | null;
    /**
     * the number of total steps to be completed
     */
    totalSteps?: number | null;
}
/**
 * a wrapper for holding a job execution result as well as any progress details.
 */
export interface JobResultOfImagesCleanUpJobStatusResponse extends Parsable {
    /**
     * the current status
     */
    currentStatus?: string | null;
    /**
     * the number of steps currently completed
     */
    currentStep?: number | null;
    /**
     * returns true if either the result is ready or if all the steps are complete.
     */
    isComplete?: boolean | null;
    /**
     * the percentage of steps currently completed
     */
    progressPercentage?: number | null;
    /**
     * the end result
     */
    result?: ImagesCleanUpJobStatusResponse | null;
    /**
     * the number of total steps to be completed
     */
    totalSteps?: number | null;
}
/**
 * a wrapper for holding a job execution result as well as any progress details.
 */
export interface JobResultOfImageTrashPurgeJobStatusResponse extends Parsable {
    /**
     * the current status
     */
    currentStatus?: string | null;
    /**
     * the number of steps currently completed
     */
    currentStep?: number | null;
    /**
     * returns true if either the result is ready or if all the steps are complete.
     */
    isComplete?: boolean | null;
    /**
     * the percentage of steps currently completed
     */
    progressPercentage?: number | null;
    /**
     * the end result
     */
    result?: ImageTrashPurgeJobStatusResponse | null;
    /**
     * the number of total steps to be completed
     */
    totalSteps?: number | null;
}
export interface LineDiscountInstruction extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The discount property
     */
    discount?: Discount | null;
    /**
     * The sku property
     */
    sku?: string | null;
}
/**
 * Link class
 */
export interface Link extends Parsable {
    /**
     * Action Specifies the HTTP method used to access the resource
     */
    action?: string | null;
    /**
     * Href Specifies the linked resource’s address
     */
    href?: string | null;
    /**
     * Rel Specifies the relationship between the resource and the resource identified in the link
     */
    rel?: string | null;
    /**
     * The supported MIME types.
     */
    types?: string[] | null;
}
export interface ListApiAccessResponse extends Parsable {
    /**
     * The apiKeys property
     */
    apiKeys?: ApiKey[] | null;
}
export interface ListCategoriesResponse extends Parsable {
    /**
     * The categories property
     */
    categories?: CategoryDto[] | null;
}
/**
 * The organization's recent customer-user import jobs, newest first.
 */
export interface ListCustomerUserImportJobsResponse extends Parsable {
    /**
     * Recent import jobs, newest first. Jobs disappear once their retention lapses.
     */
    jobs?: CustomerUserImportJobSummary[] | null;
}
export interface ListEmptyCategoriesResponse extends Parsable {
    /**
     * The empty category paths, ordered by path. This is the exact setDELETE api/categories/empty would remove, so a client can show it for confirmationand take its length as the organization's empty-category count without a second call.
     */
    categories?: string[] | null;
}
/**
 * The export formats available to an organization — the platform's built-in file types plus anycustom (multi-file ERP) formats it has been enabled for. Drives the admin export menu.
 */
export interface ListExportFormatsResponse extends Parsable {
    /**
     * The formats property
     */
    formats?: ExportFormatDto[] | null;
}
export interface ListForecastModelsResponse extends Parsable {
    /**
     * The organisation's trained models. Empty when nothing has been trained yet.
     */
    models?: ForecastModelDto[] | null;
}
export interface ListIntegrationsResponse extends Parsable {
    /**
     * The matching integrations. Empty when the organisation has configured none.
     */
    integrations?: IntegrationSummary[] | null;
}
export interface ListOfEntitlements extends Parsable {
    /**
     * The subscriptionEntitlement property
     */
    subscriptionEntitlement?: SubscriptionEntitlement | null;
}
export interface ListOrderEmailsResponse extends Parsable {
    /**
     * The order's emails, one per recipient, newest first.
     */
    emails?: SentEmailDto[] | null;
}
export interface ListOrganizationApiKeysResponse extends Parsable {
    /**
     * The apiKeys property
     */
    apiKeys?: OrganizationApiKeySummary[] | null;
}
export interface ListOrganizationSalesRepsResponse extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * App version on the rep's most recently seen device; null until they check in.
     */
    appVersion?: string | null;
    /**
     * The canViewAllCustomers property
     */
    canViewAllCustomers?: boolean | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * Last login the app reported, across the rep's devices.
     */
    lastLoginAt?: Date | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * Last device check-in. This, not login, is the real activity signal — the app restores sessions offline for up to 30 days.
     */
    lastSeenAt?: Date | null;
    /**
     * This rep's own setting for discounting individual lines in the sales app; same semantics asOrderDiscounts.
     */
    lineItemDiscounts?: DiscountPermission | null;
    /**
     * The marketCode property
     */
    marketCode?: string | null;
    /**
     * This rep's own setting for discounting a whole order in the sales app: Inherit takes theorganization's default from cart pricing settings, Allow and Deny override it for this rep.
     */
    orderDiscounts?: DiscountPermission | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * Ordered rep numbers; the first entry is the default and equals RepNumber.
     */
    repNumbers?: string[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
/**
 * The organization's distinct product tags with a product count each, ordered by tag.
 */
export interface ListProductTagsResponse extends Parsable {
    /**
     * The tags property
     */
    tags?: ListProductTagsResponse_ProductTagDto[] | null;
}
export interface ListProductTagsResponse_ProductTagDto extends Parsable {
    /**
     * How many of the organization's products carry this tag.
     */
    productCount?: number | null;
    /**
     * The tag in its stored, normalized form (trimmed, UPPERCASE).
     */
    tag?: string | null;
}
export interface ListSalesRepDevicesResponse extends Parsable {
    /**
     * The devices property
     */
    devices?: SalesRepDeviceDto[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
export interface ListSalesRepOrganizationsResponse extends Parsable {
    /**
     * The salesRepOrganizations property
     */
    salesRepOrganizations?: OrganizationSalesRep[] | null;
}
export interface ListSqlConnectorsResponse extends Parsable {
    /**
     * The connectors property
     */
    connectors?: SqlConnectorStatus[] | null;
}
export interface ListSubCategoriesResponse extends Parsable {
    /**
     * The categories property
     */
    categories?: CategoryDto[] | null;
}
export interface ListUserOrganizationsResponse extends Parsable {
    /**
     * The organizations property
     */
    organizations?: UserOrganizationDto[] | null;
}
export interface LookupAddressRequest extends Parsable {
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The query property
     */
    query?: string | null;
}
export interface LookupAddressResponse extends Parsable {
    /**
     * The predictions property
     */
    predictions?: Prediction[] | null;
    /**
     * The status property
     */
    status?: string | null;
}
export interface MappingAlternate extends Parsable {
    /**
     * Probability of this target, 0 to 1; all of a column's probabilities sum to 1 with the suggestion's.
     */
    probability?: number | null;
    /**
     * The target property
     */
    target?: string | null;
}
export interface MappingCreateProposal extends Parsable {
    /**
     * For a price tier, the currency code the header names (CAD for Wholesale (CAD)); null when it names none.
     */
    currencyCode?: string | null;
    /**
     * attribute (a product attribute on Products, a customer attribute on Customers) or priceTier.
     */
    kind?: string | null;
    /**
     * The name to create it under: the column header.
     */
    name?: string | null;
}
export interface MappingOutcomeColumn extends Parsable {
    /**
     * The column's header, exactly as it was sent to SuggestImportMappings.
     */
    header?: string | null;
    /**
     * The target the column is mapped to, named as the Map Headers dropdown names it (e.g. sku,Price:Wholesale, Attribute:Material). Null or empty when the column is left unmapped.
     */
    target?: string | null;
}
/**
 * Stamps orders as exported to an external system. Sent by an integration (for example the SQLConnector after it has written the orders into QuickBooks Desktop) once the external recordexists, so the admin's order list stops showing them as "not exported".
 */
export interface MarkOrdersExportedRequest extends Parsable {
    /**
     * Who or what ran the export, shown on the order ("Exported by …"). Optional; when blank thecaller's user id is recorded, matching the file-export endpoints.
     */
    exportedBy?: string | null;
    /**
     * The Nymble order ids that were exported. Ids from other organizations are ignored.
     */
    orderIds?: string[] | null;
}
export interface MarkOrdersExportedResponse extends Parsable {
    /**
     * Ids from the request that were not stamped — unknown, deleted, or belonging to anotherorganization. Not an error: the caller records what it can and reports the rest.
     */
    notFound?: string[] | null;
    /**
     * The orders that were stamped, with the stamp as stored.
     */
    orders?: ExportedOrderDto[] | null;
}
export interface MarkPaidRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The paymentReference property
     */
    paymentReference?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
    /**
     * The user property
     */
    user?: string | null;
}
export interface MatchedSubstring extends Parsable {
    /**
     * The length property
     */
    length?: number | null;
    /**
     * The offset property
     */
    offset?: number | null;
}
export interface MessageAttachment extends Parsable {
    /**
     * The attachmentId property
     */
    attachmentId?: string | null;
    /**
     * The mimeType property
     */
    mimeType?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The url property
     */
    url?: string | null;
    /**
     * The urlExpiresAt property
     */
    urlExpiresAt?: Date | null;
}
export interface MessageMetadata extends Parsable {
    /**
     * The ipAddress property
     */
    ipAddress?: string | null;
    /**
     * The userAgent property
     */
    userAgent?: string | null;
}
export interface ModelMetrics extends Parsable {
    /**
     * The meanAbsoluteError property
     */
    meanAbsoluteError?: number | null;
    /**
     * The meanAbsolutePercentageError property
     */
    meanAbsolutePercentageError?: number | null;
    /**
     * The rootMeanSquaredError property
     */
    rootMeanSquaredError?: number | null;
    /**
     * The trainingDurationMs property
     */
    trainingDurationMs?: number | null;
}
/**
 * One forecasted month. Points further from the present are less reliable: each is predicted fromthe one before it, so error accumulates across the horizon.
 */
export interface MonthlyForecastPointDto extends Parsable {
    /**
     * Bottom of the 90% confidence interval, floored at zero. Null when the model recorded nointerval width during training.
     */
    confidenceLowerBound?: number | null;
    /**
     * Top of the 90% confidence interval. Null when the model recorded no interval width duringtraining.
     */
    confidenceUpperBound?: number | null;
    /**
     * Calendar month, 1–12.
     */
    month?: number | null;
    /**
     * Predicted units for this month. Never negative — a negative prediction is floored at zero.
     */
    predictedUnits?: number | null;
    /**
     * Calendar year of the forecast month.
     */
    year?: number | null;
}
export interface MonthlyOrderTrend extends Parsable {
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The periodStart property
     */
    periodStart?: Date | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface MonthlyRevenueTrend extends Parsable {
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The periodStart property
     */
    periodStart?: Date | null;
    /**
     * The totalRevenue property
     */
    totalRevenue?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface MoveDocumentRequest extends Parsable {
    /**
     * The folder to file the document under. Send null to move it back to the top level. The id isnot checked, so take it from the folders endpoints rather than composing one.
     */
    targetFolderId?: string | null;
}
export interface Ok extends Parsable {
    /**
     * The statusCode property
     */
    statusCode?: number | null;
}
export interface OpenPipeline extends Parsable {
    /**
     * The asOf property
     */
    asOf?: Date | null;
    /**
     * The initialOrderStatus property
     */
    initialOrderStatus?: string | null;
    /**
     * The oldestOverdueDays property
     */
    oldestOverdueDays?: number | null;
    /**
     * The overdueBalance property
     */
    overdueBalance?: number | null;
    /**
     * The overdueInvoiceCount property
     */
    overdueInvoiceCount?: number | null;
    /**
     * The stages property
     */
    stages?: PipelineStage[] | null;
}
export interface Order extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The appliedCode property
     */
    appliedCode?: string | null;
    /**
     * The appliedPromotions property
     */
    appliedPromotions?: AppliedPromotion[] | null;
    /**
     * The cancelDate property
     */
    cancelDate?: DateOnly | null;
    /**
     * The cardType property
     */
    cardType?: string | null;
    /**
     * The channel property
     */
    channel?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customer property
     */
    customer?: Customer2 | null;
    /**
     * The discount property
     */
    discount?: Discount | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * The exported property
     */
    exported?: boolean | null;
    /**
     * The exportedAt property
     */
    exportedAt?: Date | null;
    /**
     * The exportedBy property
     */
    exportedBy?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The freeShipping property
     */
    freeShipping?: FreeShippingEntitlement | null;
    /**
     * The fulfillmentCenter property
     */
    fulfillmentCenter?: string | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The items property
     */
    items?: OrderItem[] | null;
    /**
     * The last4Digits property
     */
    last4Digits?: string | null;
    /**
     * The marketCode property
     */
    marketCode?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The noteToVendor property
     */
    noteToVendor?: string | null;
    /**
     * The orderBatchId property
     */
    orderBatchId?: string | null;
    /**
     * The orderDate property
     */
    orderDate?: Date | null;
    /**
     * The orderKind property
     */
    orderKind?: OrderKind | null;
    /**
     * The orderNumber property
     */
    orderNumber?: string | null;
    /**
     * The orderStatus property
     */
    orderStatus?: string | null;
    /**
     * The orderTotal property
     */
    orderTotal?: number | null;
    /**
     * The orderTotalFormatted property
     */
    orderTotalFormatted?: string | null;
    /**
     * The orderType property
     */
    orderType?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The originationCartId property
     */
    originationCartId?: string | null;
    /**
     * The paymentProfileId property
     */
    paymentProfileId?: string | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The priceTier property
     */
    priceTier?: string | null;
    /**
     * The primarySalesRep property
     */
    primarySalesRep?: SalesRep | null;
    /**
     * The receiptTo property
     */
    receiptTo?: string[] | null;
    /**
     * The shipDate property
     */
    shipDate?: DateOnly | null;
    /**
     * The shippingDetails property
     */
    shippingDetails?: ShippingDetails | null;
    /**
     * The shippingFormatted property
     */
    shippingFormatted?: string | null;
    /**
     * The shipWindowName property
     */
    shipWindowName?: string | null;
    /**
     * The signatureUrl property
     */
    signatureUrl?: string | null;
    /**
     * The submittedVia property
     */
    submittedVia?: string | null;
    /**
     * The subtotal property
     */
    subtotal?: number | null;
    /**
     * The subtotalFormatted property
     */
    subtotalFormatted?: string | null;
    /**
     * The takenBySalesRep property
     */
    takenBySalesRep?: SalesRep | null;
    /**
     * The tax property
     */
    tax?: number | null;
    /**
     * The taxFormatted property
     */
    taxFormatted?: string | null;
    /**
     * The taxItems property
     */
    taxItems?: TaxLineItem[] | null;
    /**
     * The terms property
     */
    terms?: string | null;
    /**
     * The user property
     */
    user?: User2 | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
}
/**
 * One placement of an agency cart and its orders. SignatureUrl is aprivate storage reference: HasSignature says whether there is one, and each order'ssignature route serves the image.
 */
export interface OrderBatchResponse extends Parsable {
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The hasSignature property
     */
    hasSignature?: boolean | null;
    /**
     * The orderBatchId property
     */
    orderBatchId?: string | null;
    /**
     * The orders property
     */
    orders?: OrderDto[] | null;
    /**
     * The originationCartId property
     */
    originationCartId?: string | null;
    /**
     * The placedAt property
     */
    placedAt?: Date | null;
    /**
     * The placedBy property
     */
    placedBy?: SalesRep | null;
    /**
     * The receiptTo property
     */
    receiptTo?: string[] | null;
}
export type OrderDestinationType = (typeof OrderDestinationTypeObject)[keyof typeof OrderDestinationTypeObject];
export interface OrderDto extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The discount code the order carried at checkout, normalized; null when none (CU-86bcj36vr).
     */
    appliedCode?: string | null;
    /**
     * The promotions that applied, as checkout snapshotted them: the redemption record the Admin reads.
     */
    appliedPromotions?: AppliedPromotion[] | null;
    /**
     * The cancelDate property
     */
    cancelDate?: DateOnly | null;
    /**
     * The channel property
     */
    channel?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customer property
     */
    customer?: CustomerDto | null;
    /**
     * The discount property
     */
    discount?: DiscountDto | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * Whether the order has ever been exported. Derived from ExportedAt on thedomain model; carried here so the admin's detail view reads the same shape as the list.
     */
    exported?: boolean | null;
    /**
     * When the order was last included in an export handed to an external system. Null means ithas never been exported.
     */
    exportedAt?: Date | null;
    /**
     * Who ran the export that last included this order. Cleared on the anonymous public-link view,which must not surface internal user ids.
     */
    exportedBy?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * Set when a promotion waived shipping, with what it would have cost.
     */
    freeShipping?: FreeShippingEntitlement | null;
    /**
     * The warehouse fulfilling the order. ERP pass-through supplied by imports; null on legacyorders and at checkout, which never sets one.
     */
    fulfillmentCenter?: string | null;
    /**
     * How the order is fulfilled (e.g. Ship, Pickup, Delivery), copied from the originating cart atcheckout. Null when the cart carried none.
     */
    fulfillmentMethod?: string | null;
    /**
     * Whether the batch's signature is on the order. The image itself is private: read it fromGET api/orders/{id}/signature.
     */
    hasSignature?: boolean | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The items property
     */
    items?: OrderItemDto[] | null;
    /**
     * The order's market code for reporting and ERP, copied from the originating cart at checkout.Null when the cart carried no code — including when a rep deliberately cleared it.
     */
    marketCode?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The note to the vendor: only this vendor's order carries it.
     */
    noteToVendor?: string | null;
    /**
     * The placement this order was part of (GET api/orders/batches/{orderBatchId}).
     */
    orderBatchId?: string | null;
    /**
     * The orderDate property
     */
    orderDate?: Date | null;
    /**
     * The platform kind this order was created as, resolved from the organization's order type atcreation and stored on the order. A snapshot: re-mapping the order type later does not changewhat this order was. Orders written before kinds existed read as Order.
     */
    orderKind?: OrderKind | null;
    /**
     * The orderNumber property
     */
    orderNumber?: string | null;
    /**
     * The orderStatus property
     */
    orderStatus?: string | null;
    /**
     * The orderTotal property
     */
    orderTotal?: number | null;
    /**
     * The orderTotalFormatted property
     */
    orderTotalFormatted?: string | null;
    /**
     * The orderType property
     */
    orderType?: string | null;
    /**
     * Who the order is with — name, logo and contact details, for surfaces where the reader maynot already know. Populated only by the anonymous public order view: a customer opening ashare link from their receipt has no other way to tell which supplier the order belongs to,where every authenticated caller reached this order through that organization already.
     */
    organization?: OrganizationInfo | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The originationCartId property
     */
    originationCartId?: string | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The priceTier property
     */
    priceTier?: string | null;
    /**
     * The primarySalesRep property
     */
    primarySalesRep?: SalesRepDto | null;
    /**
     * Who received the order's receipt in place of the customer's company email.
     */
    receiptTo?: string[] | null;
    /**
     * The shipDate property
     */
    shipDate?: DateOnly | null;
    /**
     * The shippingDetails property
     */
    shippingDetails?: ShippingDetailsDto | null;
    /**
     * The shippingFormatted property
     */
    shippingFormatted?: string | null;
    /**
     * The vendor's named ship window the dates came from; null for a custom window.
     */
    shipWindowName?: string | null;
    /**
     * The surface that completed checkout, next to Channel (the origin): a storefrontcart a rep submitted reads Web / SalesApp. Null on orders that record none.
     */
    submittedVia?: string | null;
    /**
     * The subtotal property
     */
    subtotal?: number | null;
    /**
     * The subtotalFormatted property
     */
    subtotalFormatted?: string | null;
    /**
     * The takenBySalesRep property
     */
    takenBySalesRep?: SalesRepDto | null;
    /**
     * The tax property
     */
    tax?: number | null;
    /**
     * The taxFormatted property
     */
    taxFormatted?: string | null;
    /**
     * The terms property
     */
    terms?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
    /**
     * The user property
     */
    user?: UserDto | null;
    /**
     * The vendor this order goes to.
     */
    vendorCode?: string | null;
}
export interface OrderExportSettings extends Parsable {
    /**
     * The enabledCustomFormats property
     */
    enabledCustomFormats?: string[] | null;
}
/**
 * How much of one SKU on an order has been invoiced so far.
 */
export interface OrderInvoiceLineSummaryDto extends Parsable {
    /**
     * The quantity invoiced across the order's live invoices; voided and cancelled ones are left out.
     */
    invoicedQuantity?: number | null;
    /**
     * The quantity you told the summary was ordered. It is echoed back, not looked up.
     */
    orderedQuantity?: number | null;
    /**
     * What is still to invoice. Floored at zero, so over-invoicing shows as nothing remaining rather than a negative.
     */
    remainingQuantity?: number | null;
    /**
     * The SKU, as supplied in the request's ordered quantities.
     */
    sku?: string | null;
}
/**
 * How far an order has been invoiced, per SKU and in total.Voided and cancelled invoices are excluded from every figure here. Amounts are inCurrencyCode, and each property ending in Formatted is the matching amount renderedfor display in it.
 */
export interface OrderInvoiceSummaryDto extends Parsable {
    /**
     * The currency the totals are in, taken from the order's invoices. Empty when the order has none.
     */
    currencyCode?: string | null;
    /**
     * How completely the order has been invoiced: NotInvoiced, PartiallyInvoiced or FullyInvoiced.An order that has live invoices but for which no ordered quantities were supplied reportsPartiallyInvoiced, so an incomplete request is never mistaken for a finished order.
     */
    fulfillmentStatus?: string | null;
    /**
     * How many live invoices the order has.
     */
    invoiceCount?: number | null;
    /**
     * One entry per SKU whose ordered quantity was supplied in the request. A SKU that was invoicedbut not supplied is missing here even though its money still counts toward the totals below.
     */
    lines?: OrderInvoiceLineSummaryDto[] | null;
    /**
     * The orderId property
     */
    orderId?: string | null;
    /**
     * What is still outstanding across those invoices — invoiced less paid.
     */
    totalBalance?: number | null;
    /**
     * The totalBalanceFormatted property
     */
    totalBalanceFormatted?: string | null;
    /**
     * The sum of the invoice totals, across every SKU on those invoices rather than only the ones listed above.
     */
    totalInvoiced?: number | null;
    /**
     * The totalInvoicedFormatted property
     */
    totalInvoicedFormatted?: string | null;
    /**
     * The sum of what has actually been paid on those invoices, net of refunds.
     */
    totalPaid?: number | null;
    /**
     * The totalPaidFormatted property
     */
    totalPaidFormatted?: string | null;
}
export interface OrderItem extends Parsable {
    /**
     * The categoryPaths property
     */
    categoryPaths?: string[] | null;
    /**
     * The discount property
     */
    discount?: Discount | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The gift property
     */
    gift?: GiftMarker | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The lineId property
     */
    lineId?: string | null;
    /**
     * The lineNumber property
     */
    lineNumber?: number | null;
    /**
     * The minimumOrderQuantity property
     */
    minimumOrderQuantity?: number | null;
    /**
     * The note property
     */
    note?: string | null;
    /**
     * The openQuantity property
     */
    openQuantity?: number | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * The priceOverride property
     */
    priceOverride?: PriceOverride | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The quantityIncrement property
     */
    quantityIncrement?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The subTotal property
     */
    subTotal?: number | null;
    /**
     * The subTotalFormatted property
     */
    subTotalFormatted?: string | null;
}
export interface OrderItemDto extends Parsable {
    /**
     * The categoryPaths property
     */
    categoryPaths?: string[] | null;
    /**
     * The discount property
     */
    discount?: DiscountDto | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountAmountFormatted property
     */
    discountAmountFormatted?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The gift property
     */
    gift?: GiftMarkerDto | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The lineId property
     */
    lineId?: string | null;
    /**
     * The lineNumber property
     */
    lineNumber?: number | null;
    /**
     * The minimumOrderQuantity property
     */
    minimumOrderQuantity?: number | null;
    /**
     * The note property
     */
    note?: string | null;
    /**
     * The openQuantity property
     */
    openQuantity?: number | null;
    /**
     * The paidQuantity property
     */
    paidQuantity?: number | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * The priceOverride property
     */
    priceOverride?: PriceOverrideDto | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The quantityIncrement property
     */
    quantityIncrement?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The subTotal property
     */
    subTotal?: number | null;
    /**
     * The subTotalFormatted property
     */
    subTotalFormatted?: string | null;
}
/**
 * A single line item in a bulk-create order request, mirroring the Invoices bulk endpoint'sInvoiceItemInput. This is a wire-level input type rather than the domain OrderItem:the domain model has two public parameterized constructors and only a Newtonsoft[JsonConstructor], which System.Text.Json cannot deserialize — binding it directly made everybulk order request fail at $.orders[0].items[0] before the handler ran.
 */
export interface OrderItemInput extends Parsable {
    /**
     * The discount property
     */
    discount?: Discount | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The lineNumber property
     */
    lineNumber?: number | null;
    /**
     * The minimumOrderQuantity property
     */
    minimumOrderQuantity?: number | null;
    /**
     * The openQuantity property
     */
    openQuantity?: number | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The quantityIncrement property
     */
    quantityIncrement?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
}
export type OrderKind = (typeof OrderKindObject)[keyof typeof OrderKindObject];
/**
 * A platform order kind, as offered to a settings screen.
 */
export interface OrderKindDto extends Parsable {
    /**
     * One line explaining what the kind means, suitable as helper text.
     */
    description?: string | null;
    /**
     * Which group the kind belongs to, for grouping a picker: Sales, Returns or Field.
     */
    family?: string | null;
    /**
     * The kind itself — the value stored against an order type and stamped on orders.
     */
    kind?: OrderKind | null;
}
export interface OrderReceiptSettings extends Parsable {
    /**
     * The customerSubject property
     */
    customerSubject?: string | null;
    /**
     * The organizationSubject property
     */
    organizationSubject?: string | null;
    /**
     * The salesRepSubject property
     */
    salesRepSubject?: string | null;
}
/**
 * The organization's order receipt settings: the email subject line each audience of a receiptsees, resolved to what will actually be sent. Returned by the read and the update so asettings screen never has to ask twice.
 */
export interface OrderReceiptSettingsResponse extends Parsable {
    /**
     * Every placeholder a subject template may contain, as written (e.g. {OrderType}).Matched case-insensitively. A template using any other placeholder is rejected by the update.
     */
    availableTokens?: string[] | null;
    /**
     * The subject on the customer's copy of the receipt.
     */
    customer?: OrderReceiptSubjectDto | null;
    /**
     * The subject on the copy sent to the organization's own email address.
     */
    organization?: OrderReceiptSubjectDto | null;
    /**
     * The subject on the copy sent to the sales rep(s) on the order.
     */
    salesRep?: OrderReceiptSubjectDto | null;
}
/**
 * One audience's subject line, resolved.
 */
export interface OrderReceiptSubjectDto extends Parsable {
    /**
     * The platform default for this audience, so a screen can offer "reset to default".
     */
    defaultSubject?: string | null;
    /**
     * True while the organization has not stored its own template for this audience andSubject is the platform default.
     */
    isDefault?: boolean | null;
    /**
     * The subject template that will be used: the organization's own when it has set one,otherwise the platform default. Never empty.
     */
    subject?: string | null;
}
export interface OrderRhythm extends Parsable {
    /**
     * The cells property
     */
    cells?: OrderRhythmCell[] | null;
    /**
     * The timeZone property
     */
    timeZone?: string | null;
    /**
     * The totalOrders property
     */
    totalOrders?: number | null;
    /**
     * The totalStorefrontOrders property
     */
    totalStorefrontOrders?: number | null;
}
export interface OrderRhythmCell extends Parsable {
    /**
     * The hour property
     */
    hour?: number | null;
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The storefrontOrders property
     */
    storefrontOrders?: number | null;
    /**
     * The weekday property
     */
    weekday?: number | null;
}
export interface OrdersKpi extends Parsable {
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
}
export interface OrdersPageSummary extends Parsable {
    /**
     * The asOf property
     */
    asOf?: Date | null;
    /**
     * The initialOrderStatus property
     */
    initialOrderStatus?: string | null;
    /**
     * The needsProcessing property
     */
    needsProcessing?: number | null;
    /**
     * The needsProcessingWaiting property
     */
    needsProcessingWaiting?: number | null;
    /**
     * The ordersLast30Days property
     */
    ordersLast30Days?: number | null;
    /**
     * The ordersPrior30Days property
     */
    ordersPrior30Days?: number | null;
    /**
     * The otherOrders property
     */
    otherOrders?: number | null;
    /**
     * The salesAppOrders property
     */
    salesAppOrders?: number | null;
    /**
     * The storefrontOrders property
     */
    storefrontOrders?: number | null;
    /**
     * The valueLast30Days property
     */
    valueLast30Days?: number | null;
    /**
     * The valuePrior30Days property
     */
    valuePrior30Days?: number | null;
}
export interface OrderType extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * The kind property
     */
    kind?: OrderKind | null;
    /**
     * The slug property
     */
    slug?: string | null;
}
/**
 * An order type the organization offers, in the organization's display order. The firstentry is the default for new carts. Carries no pricing or terms.
 */
export interface OrderTypeProfileDto extends Parsable {
    /**
     * The organization's own name for this order type.
     */
    displayName?: string | null;
    /**
     * The platform kind this order type maps to, or null when no kind has been assigned yet —order types registered before kinds existed. The platform treats an unassigned kind asOrder; the null is preserved so a settings screen can flag what still needs a decisionrather than showing a kind nobody chose.
     */
    kind?: OrderKind | null;
    /**
     * Stable identifier; renaming the type does not change it.
     */
    slug?: string | null;
}
/**
 * One of an organization's order types: the name the organization calls it, the stable slug ordersreference it by, and the platform kind it maps to.
 */
export interface OrderTypeResponse extends Parsable {
    /**
     * The organization's own name for this order type — what reps and customers see.
     */
    displayName?: string | null;
    /**
     * The platform kind this order type maps to. null means no kind has been assigned yet —order types registered before kinds existed. The platform treats an unassigned kind asOrder, but the null is preserved so a settings screen can honestly flag what still needsa decision rather than showing a kind nobody chose.
     */
    kind?: OrderKind | null;
    /**
     * Stable identifier derived from the display name on creation. Renaming does not change it.
     */
    slug?: string | null;
}
/**
 * One month of actual org-wide order volume.
 */
export interface OrderVolumeHistoryPointDto extends Parsable {
    /**
     * The month property
     */
    month?: number | null;
    /**
     * Total units sold across all SKUs in this month. Null if no orders were placed.
     */
    unitsSold?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
/**
 * API list-view shape: an order plus the human-readable invoice numbers of invoices generatedagainst it. Mirrors OrderWithInvoiceNumbers so the APIcontrols its own contract independent of the domain library.
 */
export interface OrderWithInvoiceNumbersDto extends Parsable {
    /**
     * The invoiceNumbers property
     */
    invoiceNumbers?: string[] | null;
    /**
     * The order property
     */
    order?: Order | null;
}
export interface Organization extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * The accessRequestNotificationEmail property
     */
    accessRequestNotificationEmail?: string | null;
    /**
     * The accessRequestResearchSettings property
     */
    accessRequestResearchSettings?: AccessRequestResearchSettings | null;
    /**
     * The accountSetup property
     */
    accountSetup?: AccountSetup | null;
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The billingAddress1 property
     */
    billingAddress1?: string | null;
    /**
     * The billingAddress2 property
     */
    billingAddress2?: string | null;
    /**
     * The billingCity property
     */
    billingCity?: string | null;
    /**
     * The billingCountry property
     */
    billingCountry?: string | null;
    /**
     * The billingPostalCode property
     */
    billingPostalCode?: string | null;
    /**
     * The billingStateProvince property
     */
    billingStateProvince?: string | null;
    /**
     * The cartPricingSettings property
     */
    cartPricingSettings?: CartPricingSettings | null;
    /**
     * The customerAttributes property
     */
    customerAttributes?: CustomerAttribute[] | null;
    /**
     * The defaultOrderStatus property
     */
    defaultOrderStatus?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The features property
     */
    features?: OrganizationFeatures | null;
    /**
     * The fulfillmentMethods property
     */
    fulfillmentMethods?: string[] | null;
    /**
     * The identityOrganizationId property
     */
    identityOrganizationId?: string | null;
    /**
     * The latitude property
     */
    latitude?: number | null;
    /**
     * The logoUrl property
     */
    logoUrl?: string | null;
    /**
     * The longitude property
     */
    longitude?: number | null;
    /**
     * The marketCodes property
     */
    marketCodes?: string[] | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The orderExportSettings property
     */
    orderExportSettings?: OrderExportSettings | null;
    /**
     * The orderReceiptSettings property
     */
    orderReceiptSettings?: OrderReceiptSettings | null;
    /**
     * The orderStatuses property
     */
    orderStatuses?: string[] | null;
    /**
     * The orderTypes property
     */
    orderTypes?: OrderType[] | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The priceTiers property
     */
    priceTiers?: PriceTier[] | null;
    /**
     * The productAttributes property
     */
    productAttributes?: ProductAttribute[] | null;
    /**
     * The productOptions property
     */
    productOptions?: ProductOptionDefinition[] | null;
    /**
     * The seatAllowance property
     */
    seatAllowance?: number | null;
    /**
     * The subscriptions property
     */
    subscriptions?: Subscription2[] | null;
    /**
     * The taxSettings property
     */
    taxSettings?: TaxSettings | null;
    /**
     * The terms property
     */
    terms?: string[] | null;
    /**
     * The type property
     */
    type?: OrganizationType | null;
    /**
     * The websiteUrl property
     */
    websiteUrl?: string | null;
}
export interface Organization2 extends Parsable {
    /**
     * Gets or sets the billing address of the organization.
     */
    billingAddress1?: string | null;
    /**
     * Gets or sets the second line of the billing address of the organization.
     */
    billingAddress2?: string | null;
    /**
     * Gets or sets the billing city of the organization.
     */
    billingCity?: string | null;
    /**
     * Gets or sets the billing country of the organization.
     */
    billingCountry?: string | null;
    /**
     * Gets or sets the billing postal code of the organization.
     */
    billingPostalCode?: string | null;
    /**
     * Gets or sets the billing state/province of the organization.
     */
    billingStateProvince?: string | null;
    /**
     * Gets or sets the email of the organization.
     */
    email?: string | null;
    /**
     * Gets or sets the name of the organization.
     */
    name?: string | null;
    /**
     * Gets or sets the phone number of the organization. 
     */
    phoneNumber?: string | null;
    /**
     * Gets or sets the website of the organization.
     */
    website?: string | null;
}
/**
 * Identifying detail for one key. The key value itself is never included — it exists in readableform only in the response that created or rotated it.
 */
export interface OrganizationApiKeySummary extends Parsable {
    /**
     * The createdOn property
     */
    createdOn?: string | null;
    /**
     * The keyId property
     */
    keyId?: string | null;
    /**
     * The leading characters of the key, so a customer can match it to what they hold.
     */
    keyPrefix?: string | null;
    /**
     * The trailing characters of the key.
     */
    keySuffix?: string | null;
    /**
     * The lastUsedOn property
     */
    lastUsedOn?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The access this key grants: admin, storefront, or sql-connector.
     */
    scope?: string | null;
    /**
     * active, inactive, or revoked.
     */
    status?: string | null;
}
export interface OrganizationFeatures extends Parsable {
    /**
     * The productVariants property
     */
    productVariants?: boolean | null;
}
/**
 * The organization as an anonymous share view is allowed to see it: who they bought from and howto reach them, and nothing else.Deliberately a whitelist rather than a projection of the domain model. Everything a link-holderhas no business seeing — subscriptions, entitlements, price tiers, terms, account setup,coordinates — is absent because it was never added, not because something stripped it. Adding afield here puts it in front of anyone holding a share link, so add nothing that would not go onthe receipt.Shared by every anonymous share view (carts, tear sheets, company docs, orders) so each oneprints the organization the same way.
 */
export interface OrganizationInfo extends Parsable {
    /**
     * The billingAddress property
     */
    billingAddress?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The logoUrl property
     */
    logoUrl?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The websiteUrl property
     */
    websiteUrl?: string | null;
}
/**
 * Customer-safe projection of an organization. This type deliberately exposes ONLYnon-sensitive identity, contact, and billing-address fields plus the organization's ordertypes and payment term names. It has no member for subscriptions, entitlements,price tiers, account-setup state, or geo coordinates, so those can never be serialized for aCustomer/SalesRep caller — nor for a storefront key, which reads this in place of the fullorganization document to learn the order types it may open carts with and the terms astorefront may single out (e.g. which terms must pay by card, CU-86bbupuh9).Term names are what a customer already sees on their own carts and orders; the list carriesno amounts or per-customer assignment.Do not widen this type with sensitive fields — see OrganizationProfileMappersTests.
 */
export interface OrganizationProfileDto extends Parsable {
    /**
     * The billingAddress1 property
     */
    billingAddress1?: string | null;
    /**
     * The billingAddress2 property
     */
    billingAddress2?: string | null;
    /**
     * The billingCity property
     */
    billingCity?: string | null;
    /**
     * The billingCountry property
     */
    billingCountry?: string | null;
    /**
     * The billingPostalCode property
     */
    billingPostalCode?: string | null;
    /**
     * The billingStateProvince property
     */
    billingStateProvince?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The isAgency property
     */
    isAgency?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The orderTypes property
     */
    orderTypes?: OrderTypeProfileDto[] | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The productOptions property
     */
    productOptions?: ProductOptionProfileDto[] | null;
    /**
     * The productVariantsEnabled property
     */
    productVariantsEnabled?: boolean | null;
    /**
     * The terms property
     */
    terms?: string[] | null;
    /**
     * The type property
     */
    type?: OrganizationType | null;
    /**
     * The website property
     */
    website?: string | null;
}
export interface OrganizationSalesRep extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The canViewAllCustomers property
     */
    canViewAllCustomers?: boolean | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The identityOrganizationId property
     */
    identityOrganizationId?: string | null;
    /**
     * The identityProviderUserId property
     */
    identityProviderUserId?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The lineItemDiscounts property
     */
    lineItemDiscounts?: DiscountPermission | null;
    /**
     * The marketCode property
     */
    marketCode?: string | null;
    /**
     * The orderDiscounts property
     */
    orderDiscounts?: DiscountPermission | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The organizationName property
     */
    organizationName?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The repNumbers property
     */
    repNumbers?: string[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
export type OrganizationType = (typeof OrganizationTypeObject)[keyof typeof OrganizationTypeObject];
export interface OrganizationUser extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The first_name property
     */
    firstName?: string | null;
    /**
     * The full_name property
     */
    fullName?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The joined_on property
     */
    joinedOn?: Date | null;
    /**
     * The last_name property
     */
    lastName?: string | null;
    /**
     * The picture property
     */
    picture?: string | null;
    /**
     * The roles property
     */
    roles?: string[] | null;
}
export interface Page extends Parsable {
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The tags property
     */
    tags?: Tag[] | null;
}
export interface PagedResultOfAccessRequest extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: AccessRequest[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfCampaign extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: Campaign[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfCommissionPlanDto extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: CommissionPlanDto[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfCommissionStatementDto extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: CommissionStatementDto[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfContactListItemDto extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: ContactListItemDto[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfCustomer extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: Customer[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfCustomerNote extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: CustomerNote[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfDataExport extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: DataExport[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfDiscountCode extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: DiscountCode[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfEntityDetailsResponseOfImageDetail extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: EntityDetailsResponseOfImageDetail[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfFlipbook extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: Flipbook[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfInvoice extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: Invoice[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfInvoiceDto extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: InvoiceDto[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfOrder extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: Order[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfOrderDto extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: OrderDto[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfOrderWithInvoiceNumbersDto extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: OrderWithInvoiceNumbersDto[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfProduct extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: Product[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfProductFamily extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: ProductFamily[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfSentEmailDto extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: SentEmailDto[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfShoppingCart extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: ShoppingCart[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfStorefrontUserResponse extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: StorefrontUserResponse[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfTaskItem extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: TaskItem[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfTearSheet extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: TearSheet[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfUserCustomer extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: UserCustomer[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfVendor extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: Vendor[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PagedResultOfVendorCustomerDto extends Parsable {
    /**
     * The currentPage property
     */
    currentPage?: number | null;
    /**
     * The data property
     */
    data?: VendorCustomerDto[] | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
}
export interface PageInfo extends Parsable {
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
}
export interface PageUpdateInfo extends Parsable {
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The tags property
     */
    tags?: TagInfo[] | null;
}
export interface Payment extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The amountFormatted property
     */
    amountFormatted?: string | null;
    /**
     * The cardType property
     */
    cardType?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The last4Digits property
     */
    last4Digits?: string | null;
    /**
     * The method property
     */
    method?: PaymentMethod2 | null;
    /**
     * The netAmount property
     */
    netAmount?: number | null;
    /**
     * The netAmountFormatted property
     */
    netAmountFormatted?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The paymentDate property
     */
    paymentDate?: Date | null;
    /**
     * The paymentProfileId property
     */
    paymentProfileId?: string | null;
    /**
     * The reference property
     */
    reference?: string | null;
    /**
     * The refundedAmount property
     */
    refundedAmount?: number | null;
    /**
     * The refundedAmountFormatted property
     */
    refundedAmountFormatted?: string | null;
    /**
     * The refunds property
     */
    refunds?: PaymentRefund[] | null;
    /**
     * The status property
     */
    status?: PaymentStatus | null;
}
export interface Payment2 extends Parsable {
    /**
     * The billingAddress property
     */
    billingAddress?: CheckoutBillingAddress | null;
    /**
     * The creditCard property
     */
    creditCard?: CreditCard | null;
}
/**
 * A payment recorded against the invoice. An invoice may carry several, and only settled ones moveits balance.
 */
export interface PaymentDto extends Parsable {
    /**
     * The gross amount tendered, before any refunds.
     */
    amount?: number | null;
    /**
     * The amountFormatted property
     */
    amountFormatted?: string | null;
    /**
     * The card brand, for card payments.
     */
    cardType?: string | null;
    /**
     * The currency the payment was tendered in. It always matches the invoice's currency.
     */
    currencyCode?: string | null;
    /**
     * The payment's identifier within the invoice. This is what the complete, fail and refund endpoints take.
     */
    id?: string | null;
    /**
     * The last four digits of the card, for card payments.
     */
    last4Digits?: string | null;
    /**
     * How it was tendered: CreditCard, DebitCard, Ach, Wire, Check, Cash, StoreCredit or Other.
     */
    method?: string | null;
    /**
     * What this payment actually contributes to the invoice: the gross amount less refunds for a settled payment, and zero for a pending or failed one.
     */
    netAmount?: number | null;
    /**
     * The netAmountFormatted property
     */
    netAmountFormatted?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * When the payment was tendered, as supplied by whoever recorded it. Not the time the record was written.
     */
    paymentDate?: Date | null;
    /**
     * The stored payment method used, when the payment was taken against one.
     */
    paymentProfileId?: string | null;
    /**
     * An external reference such as a processor transaction id, check number or wire confirmation.
     */
    reference?: string | null;
    /**
     * The sum of every refund booked against this payment.
     */
    refundedAmount?: number | null;
    /**
     * The refundedAmountFormatted property
     */
    refundedAmountFormatted?: string | null;
    /**
     * The refunds property
     */
    refunds?: PaymentRefundDto[] | null;
    /**
     * Where the payment stands: Pending (recorded but not settled), Completed, Failed, PartiallyRefunded or Refunded.
     */
    status?: string | null;
}
export interface PaymentMethod extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The billingAddress property
     */
    billingAddress?: BillingAddress | null;
    /**
     * The cardType property
     */
    cardType?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The customerProfileId property
     */
    customerProfileId?: string | null;
    /**
     * The expirationDate property
     */
    expirationDate?: string | null;
    /**
     * The expMonth property
     */
    expMonth?: number | null;
    /**
     * The expYear property
     */
    expYear?: number | null;
    /**
     * The isDefault property
     */
    isDefault?: boolean | null;
    /**
     * The maskedCardNumber property
     */
    maskedCardNumber?: string | null;
    /**
     * The networkTransactionId property
     */
    networkTransactionId?: string | null;
    /**
     * The paymentProfileId property
     */
    paymentProfileId?: string | null;
    /**
     * The paymentProvider property
     */
    paymentProvider?: string | null;
}
export type PaymentMethod2 = (typeof PaymentMethod2Object)[keyof typeof PaymentMethod2Object];
export interface PaymentProfile extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The cardType property
     */
    cardType?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The customerProfileId property
     */
    customerProfileId?: string | null;
    /**
     * The expMonth property
     */
    expMonth?: number | null;
    /**
     * The expYear property
     */
    expYear?: number | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The isDefault property
     */
    isDefault?: boolean | null;
    /**
     * The last4Digits property
     */
    last4Digits?: string | null;
    /**
     * The networkTransactionId property
     */
    networkTransactionId?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The paymentProfileId property
     */
    paymentProfileId?: string | null;
    /**
     * The provider property
     */
    provider?: string | null;
}
export interface PaymentRefund extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The reference property
     */
    reference?: string | null;
    /**
     * The refundDate property
     */
    refundDate?: Date | null;
}
/**
 * One refund booked against a payment. A payment may carry several, so a refund can be issued ininstalments.
 */
export interface PaymentRefundDto extends Parsable {
    /**
     * The amount returned by this refund. Always positive.
     */
    amount?: number | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The reference from whoever issued the money back, such as a processor refund id or check number.
     */
    reference?: string | null;
    /**
     * When the refund was booked.
     */
    refundDate?: Date | null;
}
export type PaymentStatus = (typeof PaymentStatusObject)[keyof typeof PaymentStatusObject];
export interface PendingPromotion extends Parsable {
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The campaignName property
     */
    campaignName?: string | null;
    /**
     * The campaignValidTo property
     */
    campaignValidTo?: Date | null;
    /**
     * The eligibleQuantity property
     */
    eligibleQuantity?: number | null;
    /**
     * The eligibleSkus property
     */
    eligibleSkus?: string[] | null;
    /**
     * The eligibleSubtotal property
     */
    eligibleSubtotal?: number | null;
    /**
     * The hasScope property
     */
    hasScope?: boolean | null;
    /**
     * The message property
     */
    message?: string | null;
    /**
     * The progress property
     */
    progress?: PromotionProgress | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
    /**
     * The promotionName property
     */
    promotionName?: string | null;
    /**
     * The reason property
     */
    reason?: PromotionSkipReason | null;
    /**
     * The scopeCategories property
     */
    scopeCategories?: string[] | null;
    /**
     * The scopeSkus property
     */
    scopeSkus?: string[] | null;
}
export interface PipelineStage extends Parsable {
    /**
     * The count property
     */
    count?: number | null;
    /**
     * The stage property
     */
    stage?: string | null;
    /**
     * The statuses property
     */
    statuses?: string[] | null;
    /**
     * The value property
     */
    value?: number | null;
}
/**
 * A placed line and its vendor order. A resend answers lines placed earlier the same way.
 */
export interface PlacedLine extends Parsable {
    /**
     * The orderBatchId property
     */
    orderBatchId?: string | null;
    /**
     * The orderId property
     */
    orderId?: string | null;
    /**
     * The orderNumber property
     */
    orderNumber?: string | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
}
/**
 * Places the selected vendor lines of an agency cart as one batch under one signature.
 */
export interface PlaceLinesRequest extends AdditionalDataHolder, Parsable, VendorCartRequest {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The customer's saved card to record on each order, by its gateway payment profile id. Optional.
     */
    paymentProfileId?: string | null;
    /**
     * The one signature covering every order of the batch: a PNG, base64-encoded. Optional.
     */
    signaturePng?: string | null;
    /**
     * The surface placing the lines (SalesApp, Web, Admin). Recorded only when the caller may claim it; otherwise the caller's own surface is.
     */
    submittedVia?: string | null;
    /**
     * The kind of user the orders are filed under, as complete-checkout takes it. Optional.
     */
    userType?: UserTypes | null;
    /**
     * The lines to place, by vendor code. Placing one line alone is a batch of one.
     */
    vendorCodes?: string[] | null;
}
/**
 * The outcome of placing vendor lines: the batch, one order per placed line, the lines skipped(they stay in the cart) and any that failed part way (resend the request to finish them).
 */
export interface PlaceLinesResponse extends Parsable {
    /**
     * The failed property
     */
    failed?: FailedLine[] | null;
    /**
     * The batch the placed orders share; null when nothing was placed.
     */
    orderBatchId?: string | null;
    /**
     * The placed property
     */
    placed?: PlacedLine[] | null;
    /**
     * The cart, when lines remain on it; null when every line was placed and the cart deleted (or nothing was placed now).
     */
    remainingCartId?: string | null;
    /**
     * The skipped property
     */
    skipped?: SkippedLine[] | null;
}
export interface PlansResponse extends Parsable {
    /**
     * The items property
     */
    items?: CatalogItem[] | null;
    /**
     * Free days before the first charge on a new subscription, from StripeSettings:TrialPeriodDays.The admin computes the first-charge date, the reminder date and the legal line from this, so itmust stay the same number CreateCheckoutEndpoint passes to Stripe astrial_period_days — both read the one setting. Zero means there is no trial and thefirst charge lands at checkout.
     */
    trialPeriodDays?: number | null;
}
export interface PortalSessionLinkResponse extends Parsable {
    /**
     * The sessionUrl property
     */
    sessionUrl?: string | null;
}
export interface Prediction extends Parsable {
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The matchedSubstrings property
     */
    matchedSubstrings?: MatchedSubstring[] | null;
    /**
     * The placeId property
     */
    placeId?: string | null;
    /**
     * The reference property
     */
    reference?: string | null;
    /**
     * The structuredFormatting property
     */
    structuredFormatting?: StructuredFormatting | null;
    /**
     * The terms property
     */
    terms?: Term[] | null;
    /**
     * The types property
     */
    types?: string[] | null;
}
export interface PrefillVendorRequest extends AdditionalDataHolder, AgencyScopedRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The vendor's website, e.g. "https://halden.example.com" or just "halden.example.com".
     */
    website?: string | null;
}
export interface PriceOverride extends Parsable {
    /**
     * The listPrice property
     */
    listPrice?: number | null;
    /**
     * The overriddenAtUtc property
     */
    overriddenAtUtc?: Date | null;
}
/**
 * A rep's price override on an order line: the line's Price is the overridden amount andListPrice is the catalog price it replaced.
 */
export interface PriceOverrideDto extends Parsable {
    /**
     * The listPrice property
     */
    listPrice?: number | null;
    /**
     * The overriddenAtUtc property
     */
    overriddenAtUtc?: Date | null;
}
export interface PriceTier extends Parsable {
    /**
     * The currencyCode property
     */
    currencyCode?: CurrencyCode | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface Product extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The category property
     */
    category?: string | null;
    /**
     * Display position within each category listing, low to high, keyed by category path. Acategory absent from the map has never ranked this product; unranked products are listedafter ranked ones, by SKU. Managed via PUT /api/products/reorder orPUT /api/products/sortorders.
     */
    categorySortOrders?: Product_categorySortOrders | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The currencyCode property
     */
    currencyCode?: CurrencyCode | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The dimensions property
     */
    dimensions?: string | null;
    /**
     * The dimensionsUnit property
     */
    dimensionsUnit?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The product family this product is one variant of, or null for a standalone product.Only organizations with product variants enabled ever set it.
     */
    familyId?: string | null;
    /**
     * The family's external key, when the response was built with the family in hand (thesingle-product and family endpoints); null otherwise, even for a variant.
     */
    familyKey?: string | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The Images property
     */
    images?: Image[] | null;
    /**
     * The minimumOrderQuantity property
     */
    minimumOrderQuantity?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * This variant's option values as option slug to value slug, e.g.{ "color": "solid-black", "size": "2xl" }. Resolve labels and swatches through theorganization's product options. Null for a standalone product.
     */
    optionValues?: Product_optionValues | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * Base price. Absent from the response entirely (along with priceFormatted,currencyCode and prices) when the caller may not see pricing — astorefront key serving anonymous visitors.
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * Tier prices for the caller's price tier. Absent when the caller may not see pricing.
     */
    prices?: ProductPrice[] | null;
    /**
     * Human-readable label for each product attribute, keyed by the sameslug used in ProductAttributes. Sourced from theorganization's attribute registry; only slugs present on the productare included, and only when the organization defines a display name.Consumers should fall back to the slug when a label is absent.
     */
    productAttributeLabels?: Product_productAttributeLabels | null;
    /**
     * The productAttributes property
     */
    productAttributes?: Product_productAttributes | null;
    /**
     * The productId property
     */
    productId?: string | null;
    /**
     * The productType property
     */
    productType?: ProductType | null;
    /**
     * The quantityIncrement property
     */
    quantityIncrement?: number | null;
    /**
     * The quantityOnHand property
     */
    quantityOnHand?: number | null;
    /**
     * Every add of this product to a cart creates a new line instead of merging into the linethe cart already holds for the SKU (CU-86bcpta0t): jewelry sold by weight, where eachpiece is its own line with its own quantity and note. Off by default.
     */
    separateLines?: boolean | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * Normalized product tags (UPPERCASE, de-duped) — e.g. "ON SALE", "NEW INTRODUCTION".Managed via the bulk PUT /api/products/tags endpoint or the single-product update.
     */
    tags?: string[] | null;
    /**
     * The upc property
     */
    upc?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
    /**
     * Row-major position in the family grid, or null for a standalone product.
     */
    variantPosition?: number | null;
    /**
     * The code of the vendor (line) this product belongs to, for agency organizations. Absent for aproduct in the organization's own catalog, which is every product of a Supplier organization.When present the SKU is stored as "{vendorCode}-{vendor item number}".
     */
    vendorCode?: string | null;
    /**
     * The vendor's own item number: the SKU without its "{vendorCode}-" prefix, which is what thevendor-facing order document prints. Equal to the SKU when the product has no vendor.
     */
    vendorItemNumber?: string | null;
    /**
     * The weight property
     */
    weight?: number | null;
    /**
     * The weightUnit property
     */
    weightUnit?: string | null;
}
/**
 * Display position within each category listing, low to high, keyed by category path. Acategory absent from the map has never ranked this product; unranked products are listedafter ranked ones, by SKU. Managed via PUT /api/products/reorder orPUT /api/products/sortorders.
 */
export interface Product_categorySortOrders extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * This variant's option values as option slug to value slug, e.g.{ "color": "solid-black", "size": "2xl" }. Resolve labels and swatches through theorganization's product options. Null for a standalone product.
 */
export interface Product_optionValues extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * Human-readable label for each product attribute, keyed by the sameslug used in ProductAttributes. Sourced from theorganization's attribute registry; only slugs present on the productare included, and only when the organization defines a display name.Consumers should fall back to the slug when a label is absent.
 */
export interface Product_productAttributeLabels extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface Product_productAttributes extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface ProductAttribute extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * The slug property
     */
    slug?: string | null;
}
/**
 * A style sold in several variants. The family carries what the variants share; each variantis an ordinary product carrying the family id and its option values.
 */
export interface ProductFamily extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The category property
     */
    category?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The familyId property
     */
    familyId?: string | null;
    /**
     * The stable external key the family is addressed by.
     */
    familyKey?: string | null;
    /**
     * Images shared by every variant.
     */
    images?: Image[] | null;
    /**
     * Images shown when one option value is selected, keyed "optionSlug:valueSlug".A storefront falls back from the variant's own images, to these, to Images.
     */
    imagesByOption?: ProductFamily_imagesByOption | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The option axes in display order (the first is the grid's rows, the second itscolumns), each with only the values this family comes in, labelled from theorganization's product options.
     */
    options?: ProductFamilyOption[] | null;
    /**
     * The summary property
     */
    summary?: ProductFamilySummary | null;
    /**
     * The tags property
     */
    tags?: string[] | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
    /**
     * The variants in grid order, present on the single-family endpoint and absent from thelist. Each carries optionValues for its cell, and prices for the caller's tier.
     */
    variants?: Product[] | null;
}
/**
 * Images shown when one option value is selected, keyed "optionSlug:valueSlug".A storefront falls back from the variant's own images, to these, to Images.
 */
export interface ProductFamily_imagesByOption extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface ProductFamilyOption extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * Pill or Swatch.
     */
    displayStyle?: string | null;
    /**
     * The slug property
     */
    slug?: string | null;
    /**
     * The values property
     */
    values?: ProductFamilyOptionValue[] | null;
}
export interface ProductFamilyOptionValue extends Parsable {
    /**
     * Whether at least one active variant carries this value.
     */
    available?: boolean | null;
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * The slug property
     */
    slug?: string | null;
    /**
     * The swatchHex property
     */
    swatchHex?: string | null;
    /**
     * The swatchImageUrl property
     */
    swatchImageUrl?: string | null;
}
export interface ProductFamilySummary extends Parsable {
    /**
     * The activeVariantCount property
     */
    activeVariantCount?: number | null;
    /**
     * Option values with an active variant behind them, as "optionSlug:valueSlug".
     */
    availableValues?: string[] | null;
    /**
     * The defaultImage property
     */
    defaultImage?: Image | null;
    /**
     * The priceMax property
     */
    priceMax?: number | null;
    /**
     * Lowest entry price across active variants on the caller's price tier (falling back tothe organization's default tier). Absent when the caller may not see pricing, or whenno active variant carries a price on that tier.
     */
    priceMin?: number | null;
    /**
     * Entry-price spread for every tier the family is priced on, keyed by tier name. Adminsonly — a customer sees just their own tier through PriceMin/PriceMax.
     */
    pricesByTier?: ProductFamilySummary_pricesByTier | null;
    /**
     * The tier PriceMin/PriceMax were resolved from. Absent when there is no price.
     */
    priceTier?: string | null;
    /**
     * The variantCount property
     */
    variantCount?: number | null;
}
/**
 * Entry-price spread for every tier the family is priced on, keyed by tier name. Adminsonly — a customer sees just their own tier through PriceMin/PriceMax.
 */
export interface ProductFamilySummary_pricesByTier extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface ProductOptionDefinition extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * The displayStyle property
     */
    displayStyle?: ProductOptionDisplayStyle | null;
    /**
     * The slug property
     */
    slug?: string | null;
    /**
     * The values property
     */
    values?: ProductOptionValue[] | null;
}
export type ProductOptionDisplayStyle = (typeof ProductOptionDisplayStyleObject)[keyof typeof ProductOptionDisplayStyleObject];
/**
 * One option axis from the organization's product option registry, in display order, with itsvalues in display order. Present only when the organization has product variants enabled.
 */
export interface ProductOptionProfileDto extends Parsable {
    /**
     * The organization's own name for the option.
     */
    displayName?: string | null;
    /**
     * Pill (sizes, lengths) or Swatch (colours, prints).
     */
    displayStyle?: string | null;
    /**
     * Stable identifier; the key a variant's optionValues uses.
     */
    slug?: string | null;
    /**
     * The values in display order — sizes sort as listed here.
     */
    values?: ProductOptionValueProfileDto[] | null;
}
export interface ProductOptionValue extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * The slug property
     */
    slug?: string | null;
    /**
     * The swatchHex property
     */
    swatchHex?: string | null;
    /**
     * The swatchImageId property
     */
    swatchImageId?: string | null;
}
/**
 * One value of a product option.
 */
export interface ProductOptionValueProfileDto extends Parsable {
    /**
     * The label to show.
     */
    displayName?: string | null;
    /**
     * Stable identifier; the value a variant's optionValues carries.
     */
    slug?: string | null;
    /**
     * A CSS hex colour for swatch-style options, or null.
     */
    swatchHex?: string | null;
    /**
     * A small swatch image URL, used instead of the hex when present, or null.
     */
    swatchImageUrl?: string | null;
}
export interface ProductPrice extends Parsable {
    /**
     * The atQuantity property
     */
    atQuantity?: number | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The priceFormatted property
     */
    priceFormatted?: string | null;
    /**
     * The tier property
     */
    tier?: string | null;
}
export interface ProductRevenueRanking extends Parsable {
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The productsOrdered property
     */
    productsOrdered?: number | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The totalRevenue property
     */
    totalRevenue?: number | null;
    /**
     * The uniqueOrders property
     */
    uniqueOrders?: number | null;
}
export interface ProductsPageSummary extends Parsable {
    /**
     * The activeProducts property
     */
    activeProducts?: number | null;
    /**
     * The asOf property
     */
    asOf?: Date | null;
    /**
     * The bestSellerName property
     */
    bestSellerName?: string | null;
    /**
     * The bestSellerSku property
     */
    bestSellerSku?: string | null;
    /**
     * The bestSellerUnits property
     */
    bestSellerUnits?: number | null;
    /**
     * The inactiveProducts property
     */
    inactiveProducts?: number | null;
    /**
     * The missingImages property
     */
    missingImages?: number | null;
    /**
     * The outOfStock property
     */
    outOfStock?: number | null;
    /**
     * The outOfStockTopSellers property
     */
    outOfStockTopSellers?: number | null;
    /**
     * The topSellerCount property
     */
    topSellerCount?: number | null;
    /**
     * The totalProducts property
     */
    totalProducts?: number | null;
}
export type ProductType = (typeof ProductTypeObject)[keyof typeof ProductTypeObject];
export interface Promotion extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The benefit property
     */
    benefit?: Benefit | null;
    /**
     * The categories property
     */
    categories?: string[] | null;
    /**
     * The minQuantity property
     */
    minQuantity?: number | null;
    /**
     * The minSubtotal property
     */
    minSubtotal?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The priority property
     */
    priority?: number | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
    /**
     * The skus property
     */
    skus?: string[] | null;
    /**
     * The stackable property
     */
    stackable?: boolean | null;
}
export interface PromotionInput extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The benefit property
     */
    benefit?: BenefitInput | null;
    /**
     * Category paths ("/A/B"), each including its descendants.
     */
    categories?: string[] | null;
    /**
     * The minQuantity property
     */
    minQuantity?: number | null;
    /**
     * The minSubtotal property
     */
    minSubtotal?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * Tie-break order; lower runs first.
     */
    priority?: number | null;
    /**
     * Pass the existing id when editing so provenance on carts and orders stays meaningful; leave empty for a new promotion.
     */
    promotionId?: string | null;
    /**
     * SKUs, matched case-insensitively.
     */
    skus?: string[] | null;
    /**
     * Order discounts only: add on top of the best order discount instead of competing with it.
     */
    stackable?: boolean | null;
}
export type PromotionMeasure = (typeof PromotionMeasureObject)[keyof typeof PromotionMeasureObject];
export interface PromotionPlan extends Parsable {
    /**
     * The applied property
     */
    applied?: AppliedPromotion[] | null;
    /**
     * The appliedCode property
     */
    appliedCode?: string | null;
    /**
     * The appliedCodeSkip property
     */
    appliedCodeSkip?: PromotionSkip | null;
    /**
     * The freeShipping property
     */
    freeShipping?: FreeShippingEntitlement | null;
    /**
     * The gifts property
     */
    gifts?: GiftInstruction[] | null;
    /**
     * The hasEffects property
     */
    hasEffects?: boolean | null;
    /**
     * The lineDiscounts property
     */
    lineDiscounts?: LineDiscountInstruction[] | null;
    /**
     * The orderDiscount property
     */
    orderDiscount?: Discount | null;
    /**
     * The skips property
     */
    skips?: PromotionSkip[] | null;
}
export interface PromotionProgress extends Parsable {
    /**
     * The measure property
     */
    measure?: PromotionMeasure | null;
    /**
     * The measured property
     */
    measured?: number | null;
    /**
     * The percent property
     */
    percent?: number | null;
    /**
     * The required property
     */
    required?: number | null;
    /**
     * The shortfall property
     */
    shortfall?: number | null;
}
export interface PromotionSkip extends Parsable {
    /**
     * The campaignId property
     */
    campaignId?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The message property
     */
    message?: string | null;
    /**
     * The promotionId property
     */
    promotionId?: string | null;
    /**
     * The reason property
     */
    reason?: PromotionSkipReason | null;
}
export type PromotionSkipReason = (typeof PromotionSkipReasonObject)[keyof typeof PromotionSkipReasonObject];
/**
 * A complete snapshot of a connector's endpoint configuration. Replaces the stored set outright —anything omitted is dropped.
 */
export interface PushEndpointsRequest extends Parsable {
    /**
     * Every configured endpoint, enabled or not. Send the whole set, never a delta.
     */
    endpoints?: ConnectorEndpointDto[] | null;
    /**
     * When the connector assembled this snapshot.
     */
    pushedAt?: Date | null;
}
/**
 * The reported outcome of one completed sync. Identified by SyncRunId: pushing thesame id again replaces the stored record rather than adding another.
 */
export interface PushSyncRunRequest extends Parsable {
    /**
     * Per-batch outcomes, where a partial failure can be traced to the batch that caused it.
     */
    batchResults?: SyncBatchResultDto[] | null;
    /**
     * When the run finished. Null while a run is still in flight.
     */
    completedAt?: Date | null;
    /**
     * Wall-clock duration of the run in seconds.
     */
    durationSeconds?: number | null;
    /**
     * The configured endpoint this run synced.
     */
    endpointId?: string | null;
    /**
     * The endpoint's display name, so history stays readable after the endpoint is renamed or removed.
     */
    endpointName?: string | null;
    /**
     * Why the run failed outright, when it did. Null for a run that completed.
     */
    errorMessage?: string | null;
    /**
     * Batches rejected.
     */
    failedBatches?: number | null;
    /**
     * Rows rejected. Non-zero here is how a partial failure shows up.
     */
    failedRecords?: number | null;
    /**
     * True when an operator started the run by hand rather than the schedule starting it.
     */
    isManualTrigger?: boolean | null;
    /**
     * When the connector sent this report.
     */
    pushedAt?: Date | null;
    /**
     * When the run started.
     */
    startedAt?: Date | null;
    /**
     * The run's overall outcome as the connector judged it, e.g. "Completed" or "Failed".
     */
    status?: string | null;
    /**
     * Batches accepted.
     */
    successfulBatches?: number | null;
    /**
     * Rows accepted.
     */
    successfulRecords?: number | null;
    /**
     * How the run selected its rows, e.g. "Full" or "Incremental".
     */
    syncMode?: string | null;
    /**
     * The connector's own id for this run. Re-pushing the same id overwrites the stored run.
     */
    syncRunId?: string | null;
    /**
     * Batches the run sent.
     */
    totalBatches?: number | null;
    /**
     * Rows the run attempted.
     */
    totalRecords?: number | null;
}
/**
 * Quantity restrictions on a price, expressed as a range. Any of the minimum, maximum and step may beabsent, meaning no limit of that kind.
 */
export interface QuantityLimits extends Parsable {
    /**
     * The max property
     */
    max?: number | null;
    /**
     * The min property
     */
    min?: number | null;
    /**
     * Increment a range moves in, e.g. seats sold in blocks of 5.
     */
    step?: number | null;
    /**
     * Always range on the current catalog; fixed only on legacy records.
     */
    type?: string | null;
    /**
     * Always empty on the current catalog, which states limits as a range. Retained for backwardcompatibility.
     */
    values?: number[] | null;
}
export interface QueryFilter extends Parsable {
    /**
     * The field property
     */
    field?: string | null;
    /**
     * The operator property
     */
    operator?: QueryFilter_OperatorType | null;
    /**
     * The value property
     */
    value?: string | null;
}
export type QueryFilter_OperatorType = (typeof QueryFilter_OperatorTypeObject)[keyof typeof QueryFilter_OperatorTypeObject];
/**
 * The link that starts a QuickBooks authorization.
 */
export interface QuickBooksAuthResponse extends Parsable {
    /**
     * The QuickBooks consent page to open in a browser. Good for one authorization attempt, andalready carries the organization it was issued for — do not edit or rebuild it.
     */
    authUrl?: string | null;
}
/**
 * The QuickBooks company an organization is connected to.
 */
export interface QuickBooksCompanyInfoResponse_CompanyInfo extends Parsable {
    /**
     * The company's name as it stands in QuickBooks. It is read live, so it reflects a renamemade there without anything having to be re-synced here.
     */
    companyName?: string | null;
}
/**
 * Whether an organization's QuickBooks connection is currently working.
 */
export interface QuickbooksConnectedResponse extends Parsable {
    /**
     * True when QuickBooks answered for the connected company. False covers never connected,disconnected at the QuickBooks end, and expired alike — it carries no reason.
     */
    isConnected?: boolean | null;
}
export interface QuickBooksTokenRequest extends Parsable {
    /**
     * The authorization code QuickBooks returned after the administrator approved access. Singleuse, and it expires within minutes of being issued.
     */
    code?: string | null;
    /**
     * The id of the QuickBooks company that was authorized, as QuickBooks returned it alongsidethe code. It identifies which company this organization's data is read from.
     */
    realmId?: string | null;
}
/**
 * Confirmation that a QuickBooks connection was stored. The tokens are kept and refreshed by thisAPI, so a caller does not need to hold on to them.
 */
export interface QuickBooksTokenResponse extends Parsable {
    /**
     * The token this API will use to read the connected company, echoed back for confirmation.
     */
    accessToken?: string | null;
    /**
     * Reserved. This endpoint does not populate it, so it is always zero.
     */
    expiresIn?: number | null;
    /**
     * The token used to renew access when it expires, echoed back for confirmation.
     */
    refreshToken?: string | null;
    /**
     * Reserved. This endpoint does not populate it.
     */
    tokenType?: string | null;
    /**
     * Reserved. This endpoint does not populate it, so it is always zero.
     */
    xRefreshTokenExpiresIn?: number | null;
}
export interface QuietAccount extends Parsable {
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The daysQuiet property
     */
    daysQuiet?: number | null;
    /**
     * The lastOrderDate property
     */
    lastOrderDate?: Date | null;
    /**
     * The lifetimeRevenue property
     */
    lifetimeRevenue?: number | null;
    /**
     * The repName property
     */
    repName?: string | null;
    /**
     * The terms property
     */
    terms?: string | null;
    /**
     * The trailingYearRevenue property
     */
    trailingYearRevenue?: number | null;
}
/**
 * A webhook delivery taken as raw text, so the bytes that were signed are the bytes that getverified — parsing first and re-serializing would change them and break the signature.
 */
export interface RawBodyRequest extends Parsable {
    /**
     * The delivery's body, exactly as it was sent.
     */
    content?: string | null;
}
export interface ReactivateVendorRequest extends AdditionalDataHolder, AgencyScopedRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface ReadmeAuthResponse extends Parsable {
    /**
     * The readmeAuthUrl property
     */
    readmeAuthUrl?: string | null;
}
/**
 * Moves one storefront user from the customer they can shop for to a different one.
 */
export interface ReassignCustomerRequest extends Parsable {
    /**
     * The customer the user can shop for today, and will not be able to after this call. Matchedcase-insensitively; it must be an association this organization actually holds.
     */
    fromCustomerNumber?: string | null;
    /**
     * The customer the user should be able to shop for instead. Must resolve to a real customer inthis organization — this is the check that stops new associations being written againstcustomer numbers that do not exist.
     */
    toCustomerNumber?: string | null;
    /**
     * The identity provider user id being reassigned — the UserId the storefront-users listingreturns.
     */
    userId?: string | null;
}
export interface ReassignCustomerResponse extends Parsable {
    /**
     * The customer the user can shop for now.
     */
    customerNumber?: string | null;
    /**
     * The customer the user could shop for before this call, or null when nothing was removed.
     */
    previousCustomerNumber?: string | null;
    /**
     * True when the association was actually moved; false when the call asked for the state thatalready held (the target was the customer the user already shopped for). Both are success —the state the caller asked for holds either way — so the call is safe to repeat.
     */
    reassigned?: boolean | null;
}
/**
 * Represents a request to reconcile Sales Rep RepNumber customer sync channels.
 */
export interface ReconcileRepNumberChannelsRequest extends Parsable {
    /**
     * Gets or sets an optional single rep to reconcile. Omit to reconcile every active rep inthe organization.
     */
    organizationSalesRepId?: string | null;
}
/**
 * Counters describing what the reconcile run did.
 */
export interface ReconcileRepNumberChannelsResponse extends Parsable {
    /**
     * Missing repnum channels granted across all reps, counted once per channel name — eachgrant is applied to customers, customer notes, orders and invoices together.
     */
    channelsGranted?: number | null;
    /**
     * Stray repnum channels revoked across all reps, counted once per channel name — eachrevoke is applied to customers, customer notes, orders and invoices together.
     */
    channelsRevoked?: number | null;
    /**
     * Org-channel collections (products, campaigns, cart events, …) granted to reps that had noaccess to them, counted once per collection per rep.
     */
    collectionsGranted?: number | null;
    /**
     * Emails of reps whose reconcile failed; re-running heals them.
     */
    failed?: string[] | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * Reps considered, before any skipping.
     */
    repsExamined?: number | null;
    /**
     * Reps whose channels already matched their stored RepNumbers on every repnum-routedrecord type (customers, customer notes, orders, invoices).
     */
    repsUnchanged?: number | null;
    /**
     * Deactivated reps, left alone — reconciling one would resurrect its data access.
     */
    skippedInactive?: number | null;
    /**
     * Reps whose email has no sync user (never provisioned, or deleted).
     */
    skippedNoSyncUser?: number | null;
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface RecordPaymentRequest extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The cardType property
     */
    cardType?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The last4Digits property
     */
    last4Digits?: string | null;
    /**
     * The method property
     */
    method?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The paymentDate property
     */
    paymentDate?: Date | null;
    /**
     * The paymentProfileId property
     */
    paymentProfileId?: string | null;
    /**
     * The reference property
     */
    reference?: string | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface RefreshProductFamilySummariesResponse extends Parsable {
    /**
     * How many families had their summary recomputed and stored.
     */
    refreshed?: number | null;
}
/**
 * A newly issued link to a document.
 */
export interface RefreshUrlResponse extends Parsable {
    /**
     * A time-limited link to the file. It replaces the link the document was carrying, so a laterread of the document returns this one. It expires in turn — ask again when it stops working.
     */
    cdnUrl?: string | null;
}
export interface RefundPaymentRequest extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The reference property
     */
    reference?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
/**
 * Identifies a connector to the API on startup. Name plus host is the identity: registering thesame pair again updates the existing connector rather than creating a second one.
 */
export interface RegisterSqlConnectorRequest extends Parsable {
    /**
     * Operator-chosen label for this connector, e.g. "Acme Distributors Primary".
     */
    connectorName?: string | null;
    /**
     * The machine the connector runs on. Together with the name it identifies the connector.
     */
    hostName?: string | null;
    /**
     * Free-form values describing this installation, e.g. its source system or environment.
     */
    metadata?: RegisterSqlConnectorRequest_metadata | null;
    /**
     * The connector's build version.
     */
    version?: string | null;
}
/**
 * Free-form values describing this installation, e.g. its source system or environment.
 */
export interface RegisterSqlConnectorRequest_metadata extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface RemoveDiscountRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface RemoveItemFromListRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface RemoveVendorImageRequest extends AdditionalDataHolder, AgencyScopedRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface RenameListRequest extends Parsable {
    /**
     * The new display name, up to 100 characters. Unique per customer, so it must differ fromevery other name that customer holds — and from this list's current name.
     */
    newName?: string | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface ReorderCategoriesRequest extends Parsable {
    /**
     * Every category on that level, in the new order, as segment names or full paths. This onlyrearranges — adding, dropping, or repeating a category is rejected.
     */
    categories?: string[] | null;
    /**
     * The category whose children are being reordered, e.g. "/Apparel". Leave empty for the toplevel.
     */
    parentPath?: string | null;
}
export interface ReorderCategoriesResponse extends Parsable {
    /**
     * That level's categories in their new order, as segment names.
     */
    categories?: string[] | null;
    /**
     * The category whose children were reordered; empty for the top level.
     */
    parentPath?: string | null;
}
export interface ReorderCustomerAttributesRequest extends Parsable {
    /**
     * Every customer attribute the organization has, in the new order, identified by slug (displayname is also accepted). This only rearranges — adding, dropping, or repeating an attributeis rejected.
     */
    slugs?: string[] | null;
}
export interface ReorderCustomerAttributesResponse extends Parsable {
    /**
     * The organization's customer attributes in their new order. Position is the display order onthe grids and detail pages.
     */
    customerAttributes?: CustomerAttribute[] | null;
}
export interface ReorderFulfillmentMethodsRequest extends Parsable {
    /**
     * Every fulfillment method the organization has, in the new order, matched case-insensitively.This only rearranges — adding, dropping, or repeating a method is rejected.
     */
    fulfillmentMethods?: string[] | null;
}
export interface ReorderFulfillmentMethodsResponse extends Parsable {
    /**
     * The organization's fulfillment methods in their new order. The first item is the fallback newcarts are seeded with when the customer has no default of their own.
     */
    fulfillmentMethods?: string[] | null;
}
export interface ReorderOrderStatusesRequest extends Parsable {
    /**
     * Every order status the organization has, in the new order, matched case-insensitively.This only rearranges — adding, dropping, or repeating a status is rejected.
     */
    orderStatuses?: string[] | null;
}
export interface ReorderOrderStatusesResponse extends Parsable {
    /**
     * The organization's order statuses in their new order. The first item is the status new ordersare submitted with at checkout.
     */
    orderStatuses?: string[] | null;
}
export interface ReorderOrderTypesRequest extends Parsable {
    /**
     * Every order type the organization has, in the new order, identified by display name or slug.This only rearranges — adding, dropping, or repeating an order type is rejected.
     */
    orderTypes?: string[] | null;
}
export interface ReorderOrderTypesResponse extends Parsable {
    /**
     * The organization's order types in their new order, each with the platform kind it maps to.The first item is the default new carts are seeded with.
     */
    orderTypes?: OrderTypeResponse[] | null;
}
export interface ReorderProductAttributesRequest extends Parsable {
    /**
     * Every product attribute the organization has, in the new order, identified by slug (displayname is also accepted). This only rearranges — adding, dropping, or repeating an attributeis rejected.
     */
    slugs?: string[] | null;
}
export interface ReorderProductAttributesResponse extends Parsable {
    /**
     * The organization's product attributes in their new order. Position is the display order onthe grids and detail pages.
     */
    productAttributes?: ProductAttribute[] | null;
}
export interface ReorderProductsRequest extends Parsable {
    /**
     * The category whose products are being reordered, e.g. "/Apparel".
     */
    category?: string | null;
    /**
     * Every product in that category, in the new order, by SKU. This only rearranges — adding,dropping, or repeating a product is rejected.
     */
    skus?: string[] | null;
}
export interface ReorderProductsResponse extends Parsable {
    /**
     * The category whose products were reordered.
     */
    category?: string | null;
    /**
     * That category's products in their new order, by SKU.
     */
    skus?: string[] | null;
}
export interface ReorderTasksRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * The tasks of one board column, top to bottom, in their new order. They must all share onestatus; each takes its index in this list as its sortOrder.
     */
    taskItemIds?: string[] | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface ReorderTermsRequest extends Parsable {
    /**
     * Every payment term the organization has, in the new order, matched case-insensitively.This only rearranges — adding, dropping, or repeating a term is rejected.
     */
    terms?: string[] | null;
}
export interface ReorderTermsResponse extends Parsable {
    /**
     * The organization's payment terms in their new order — the display order everywhere termsare offered.
     */
    terms?: string[] | null;
}
export interface Rep extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The fullName property
     */
    fullName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The marketCode property
     */
    marketCode?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
/**
 * Replaces the organization's product option registry — the axes product families vary along(Color, Size, …), each with its values in display order and, for swatch-style options, aswatch per value.
 */
export interface ReplaceProductOptionsRequest extends Parsable {
    /**
     * The whole registry, in display order. Options and values absent from this list are removed.
     */
    options?: ReplaceProductOptionsRequest_ProductOptionInput[] | null;
}
export interface ReplaceProductOptionsRequest_ProductOptionInput extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * Pill (sizes, lengths) or Swatch (colours, prints).
     */
    displayStyle?: string | null;
    /**
     * The slug of an existing option, to keep its identity across a rename. Omit for a new option.
     */
    slug?: string | null;
    /**
     * The values in display order — sizes sort the way they are listed here, never alphabetically.
     */
    values?: ReplaceProductOptionsRequest_ProductOptionValueInput[] | null;
}
export interface ReplaceProductOptionsRequest_ProductOptionValueInput extends Parsable {
    /**
     * The displayName property
     */
    displayName?: string | null;
    /**
     * The slug of an existing value, to keep its identity across a rename. Omit for a new value.
     */
    slug?: string | null;
    /**
     * A CSS hex colour for swatch-style options, e.g. #1f3fbf.
     */
    swatchHex?: string | null;
    /**
     * The image name of a fabric or print swatch, used instead of the hex when set.
     */
    swatchImageName?: string | null;
}
export interface ReportMappingOutcomeRequest extends Parsable {
    /**
     * What each suggested column is mapped to as the import starts. Columns are matched to the run byheader; columns the run did not cover are ignored. At most 500.
     */
    columns?: MappingOutcomeColumn[] | null;
}
export interface ResearchAccessRequestResponse extends Parsable {
    /**
     * The ID of the access request that was researched
     */
    accessRequestId?: string | null;
    /**
     * The company name from the access request
     */
    companyName?: string | null;
    /**
     * B2B eligibility score from 1-10 (null if not parsed from AI response)
     */
    eligibilityScore?: number | null;
    /**
     * Estimated cost in USD for the AI request (0 if cached)
     */
    estimatedCostUsd?: number | null;
    /**
     * Timestamp when the research was generated
     */
    generatedAt?: Date | null;
    /**
     * Indicates whether the research was retrieved from cache (true)or freshly generated (false)
     */
    isCached?: boolean | null;
    /**
     * AI-generated research content about the organization
     */
    research?: string | null;
    /**
     * Total tokens used for the AI request (0 if cached)
     */
    tokensUsed?: number | null;
}
/**
 * A researched address. Every line is null when no address could be verified.
 */
export interface ResearchedAddress extends Parsable {
    /**
     * The street line: number and street.
     */
    address1?: string | null;
    /**
     * Suite, unit or floor.
     */
    address2?: string | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The country, as its English name.
     */
    country?: string | null;
    /**
     * The postalCode property
     */
    postalCode?: string | null;
    /**
     * The URL the address was verified against.
     */
    source?: string | null;
    /**
     * The state or province, as its postal abbreviation where the country has one.
     */
    stateProvince?: string | null;
    /**
     * True when the address service recognised the address; false when it is as the research found it.
     */
    verified?: boolean | null;
}
/**
 * One researched value and the URL it was verified against.
 */
export interface ResearchedValue extends Parsable {
    /**
     * The URL the value was verified against.
     */
    source?: string | null;
    /**
     * The value, or null when it could not be verified.
     */
    value?: string | null;
}
export interface ResendSalesRepWelcomeRequest extends Parsable {
    /**
     * The email address of the sales rep to resend the welcome email to
     */
    email?: string | null;
}
export interface ResendSalesRepWelcomeResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface ResendWelcomeEmailRequest extends Parsable {
    /**
     * The email address of the admin user to resend the welcome email to
     */
    email?: string | null;
}
export interface ResendWelcomeEmailResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface RestoreAccessRequestResponse extends Parsable {
    /**
     * The accessRequestId property
     */
    accessRequestId?: string | null;
    /**
     * The status property
     */
    status?: string | null;
}
export interface RestoreTrashedImagesRequest extends Parsable {
    /**
     * The stored asset ids to bring back from the trash, exactly as reported by the clean-upjobs (e.g. "orgid/imagename").
     */
    imageIds?: string[] | null;
}
export interface RestoreTrashedImagesResponse extends Parsable {
    /**
     * The restoredCount property
     */
    restoredCount?: number | null;
    /**
     * The ids actually restored. An id missing from this list was not found in storage.
     */
    restoredImageIds?: string[] | null;
}
export interface Result extends Parsable {
    /**
     * The address_components property
     */
    addressComponents?: AddressComponent[] | null;
    /**
     * The formatted_address property
     */
    formattedAddress?: string | null;
}
export interface ReturnToReviewRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
    /**
     * The user property
     */
    user?: string | null;
}
export interface RevenueKpi extends Parsable {
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The totalRevenue property
     */
    totalRevenue?: number | null;
}
export interface RevokeCustomerAccessResponse extends Parsable {
    /**
     * True when an association was removed by this call; false when there was nothing to remove(already gone, never existed, or not this organization's). Both are success — the state thecaller asked for holds either way — so the call is safe to repeat.
     */
    removed?: boolean | null;
}
export interface RevokeOrganizationApiKeyResponse extends Parsable {
    /**
     * The key that was revoked.
     */
    keyId?: string | null;
}
export interface RotateIntegrationSecretsRequest extends Parsable {
    /**
     * The newSecrets property
     */
    newSecrets?: RotateIntegrationSecretsRequest_newSecrets | null;
    /**
     * The testConnectionAfterRotation property
     */
    testConnectionAfterRotation?: boolean | null;
}
export interface RotateIntegrationSecretsRequest_newSecrets extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface RotateIntegrationSecretsResponse extends Parsable {
    /**
     * The unique identifier of the integration
     */
    integrationId?: string | null;
    /**
     * Descriptive message about the rotation result
     */
    message?: string | null;
    /**
     * The organization identifier
     */
    organizationId?: string | null;
    /**
     * When the secrets were rotated
     */
    rotatedAt?: Date | null;
    /**
     * List of secret keys that were rotated
     */
    rotatedSecretKeys?: string[] | null;
    /**
     * Whether the secret rotation was successful
     */
    rotationSuccessful?: boolean | null;
    /**
     * Whether the connection test passed after rotation (if requested)
     */
    testConnectionSuccessful?: boolean | null;
}
export interface RotateOrganizationApiKeyResponse extends Parsable {
    /**
     * The replacement key value. Returned only here — the previous value stops working immediately,so this must reach whoever holds it.
     */
    apiKey?: string | null;
    /**
     * The key identifier, unchanged by rotation.
     */
    keyId?: string | null;
}
export interface SalesRep extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The fullName property
     */
    fullName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The marketCode property
     */
    marketCode?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
export interface SalesRep2 extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The fullName property
     */
    fullName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
/**
 * A rep's device as shown in the admin rep dialog. Deliberately omits the organization the devicelast checked in under: a rep can belong to several organizations, and the admin reading thisalready only sees reps in their own organization.
 */
export interface SalesRepDeviceDto extends Parsable {
    /**
     * The appVersion property
     */
    appVersion?: string | null;
    /**
     * The buildNumber property
     */
    buildNumber?: string | null;
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The deviceModel property
     */
    deviceModel?: string | null;
    /**
     * The firstSeenAt property
     */
    firstSeenAt?: Date | null;
    /**
     * The lastLoginAt property
     */
    lastLoginAt?: Date | null;
    /**
     * The lastSeenAt property
     */
    lastSeenAt?: Date | null;
    /**
     * The osVersion property
     */
    osVersion?: string | null;
}
export interface SalesRepDto extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The fullName property
     */
    fullName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The marketCode property
     */
    marketCode?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
export interface SalesRepInput extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
}
export interface SalesRepRevenueRanking extends Parsable {
    /**
     * The averageItemsPerOrder property
     */
    averageItemsPerOrder?: number | null;
    /**
     * The averageOrderSize property
     */
    averageOrderSize?: number | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The fullName property
     */
    fullName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
    /**
     * The totalRevenue property
     */
    totalRevenue?: number | null;
}
export interface SalesRepTrend extends Parsable {
    /**
     * The fullName property
     */
    fullName?: string | null;
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The points property
     */
    points?: SalesTrendPoint[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
    /**
     * The totalRevenue property
     */
    totalRevenue?: number | null;
}
export interface SalesTrendPoint extends Parsable {
    /**
     * The orderCount property
     */
    orderCount?: number | null;
    /**
     * The periodStart property
     */
    periodStart?: string | null;
    /**
     * The revenue property
     */
    revenue?: number | null;
}
export interface SavePaymentMethodRequest extends Parsable {
    /**
     * Optional: Frontend URL to redirect to after hosted payment completion (for WorldPay). Defaults to http://localhost:3000/payment-success
     */
    appUrl?: string | null;
    /**
     * The billingAddress property
     */
    billingAddress?: BillingAddress | null;
    /**
     * The cardCode property
     */
    cardCode?: string | null;
    /**
     * The cardNumber property
     */
    cardNumber?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The emailAddress property
     */
    emailAddress?: string | null;
    /**
     * The expirationMonth property
     */
    expirationMonth?: string | null;
    /**
     * The expirationYear property
     */
    expirationYear?: string | null;
    /**
     * The isDefault property
     */
    isDefault?: boolean | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching
     */
    orgCodes?: string[] | null;
    /**
     * Optional: Specify which payment provider to use. If not provided, uses the default active payment provider for the organization.
     */
    paymentProvider?: string | null;
    /**
     * Optional: OrganizationId to switch to (must be in user's OrgCodes)
     */
    useOrganizationId?: string | null;
}
/**
 * Response for saving a payment method - supports both direct and hosted payment flows
 */
export interface SavePaymentMethodResponse extends Parsable {
    /**
     * The saved payment method details (for direct flows like AuthorizeNet)Only populated when RequiresRedirect is false
     */
    paymentMethod?: PaymentMethod | null;
    /**
     * The payment provider name
     */
    provider?: string | null;
    /**
     * The URL to redirect the user to (for hosted payment flows like WorldPay)
     */
    redirectUrl?: string | null;
    /**
     * Whether this response requires a redirect to complete (hosted payment flow)
     */
    requiresRedirect?: boolean | null;
}
/**
 * Creates or updates one product family by key. Only the fields sent are changed: a nullOptions, Images or ImagesByOption leaves what isstored, so a source that only knows the family's name and copy cannot erase its images.
 */
export interface SaveProductFamilyRequest extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * Category path(s), slash-delimited and pipe-joined like a product's.
     */
    category?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The stable external key — a style code, a source system's product id.
     */
    familyKey?: string | null;
    /**
     * Image names (already uploaded to the organization) shared by every variant, in order. Null leaves the stored images alone; an empty list clears them.
     */
    images?: string[] | null;
    /**
     * Image names per option value, keyed "Option:Value" by display name or slug, e.g.{ "Color:Solid Black": ["tee-black-front"] }. Null leaves the stored map alone.
     */
    imagesByOption?: SaveProductFamilyRequest_imagesByOption | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The option axes in display order with the values this family comes in. Options and valuesmay be given by display name or slug; unknown ones are registered in the organization'sproduct options. Null leaves the stored axes alone.
     */
    options?: SaveProductFamilyRequest_SaveProductFamilyOption[] | null;
    /**
     * The tags property
     */
    tags?: string[] | null;
}
/**
 * Image names per option value, keyed "Option:Value" by display name or slug, e.g.{ "Color:Solid Black": ["tee-black-front"] }. Null leaves the stored map alone.
 */
export interface SaveProductFamilyRequest_imagesByOption extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface SaveProductFamilyRequest_SaveProductFamilyOption extends Parsable {
    /**
     * The option, by display name or slug ("Color", "color").
     */
    option?: string | null;
    /**
     * The values this family comes in, by display name or slug, in display order.
     */
    values?: string[] | null;
}
/**
 * What the sign-up form holds when someone clicks Next or Create account. Only the email is required;every other field is whatever the steps so far have collected, and a blank one keeps what an earliersave captured.
 */
export interface SaveSignupProgressRequest extends Parsable {
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The companyWebsite property
     */
    companyWebsite?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The stateProvince property
     */
    stateProvince?: string | null;
    /**
     * The step just submitted: 1 is the email, 2 the person's details, 3 the organization (Create account clicked).
     */
    step?: number | null;
}
/**
 * One credential a provider asks for. This describes the field; the value itself is write-only andis never returned by any endpoint.
 */
export interface SecretField extends Parsable {
    /**
     * Help text explaining where to find this credential.
     */
    description?: string | null;
    /**
     * The field's label. Validation messages refer to the field by this name.
     */
    displayName?: string | null;
    /**
     * Whether the value should be masked in a form. True for credentials.
     */
    isSensitive?: boolean | null;
    /**
     * The key to use in a create or update request's secrets.
     */
    key?: string | null;
    /**
     * The longest accepted value, where the provider caps it.
     */
    maxLength?: number | null;
    /**
     * Placeholder text for the input.
     */
    placeholderText?: string | null;
    /**
     * Whether the integration cannot work without it.
     */
    required?: boolean | null;
    /**
     * A regular expression the value must match, where the credential has a known format.
     */
    validationPattern?: string | null;
}
/**
 * A sales rep shares a shopping cart with the customer by email and/or text. The cart travelsas a snapshot in the request: the recipient sees the cart as it was when shared, and a cartbuilt on the rep's device can be shared before it has synchronized to the server.
 */
export interface SendCartShareMessageRequest extends Parsable {
    /**
     * The rep's note to the customer. Optional; shown in the email, the text and the online view.
     */
    body?: string | null;
    /**
     * The cart as the rep sees it right now.
     */
    cart?: CartShareSnapshotRequest | null;
    /**
     * Email recipients. Required when SendViaEmail is true.
     */
    emails?: string[] | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * Text-message recipients in international format. Required when SendViaSms is true.
     */
    phoneNumbers?: string[] | null;
    /**
     * The sendViaEmail property
     */
    sendViaEmail?: boolean | null;
    /**
     * The sendViaSms property
     */
    sendViaSms?: boolean | null;
    /**
     * Email subject and the message headline; also the first line of the text message.
     */
    subject?: string | null;
    /**
     * Organization to send on behalf of, when the caller belongs to more than one.
     */
    useOrganizationId?: string | null;
}
export interface SendCartShareMessageResponse extends Parsable {
    /**
     * The emailsSent property
     */
    emailsSent?: number | null;
    /**
     * Per-channel delivery failures. A failure here does not fail the request.
     */
    errors?: string[] | null;
    /**
     * The messageId property
     */
    messageId?: string | null;
    /**
     * The smsSent property
     */
    smsSent?: number | null;
    /**
     * Sent, Failed, or PartiallyFailed when only one of two channels delivered.
     */
    status?: string | null;
    /**
     * The totalRecipients property
     */
    totalRecipients?: number | null;
    /**
     * The link recipients receive; opens the shared cart without signing in.
     */
    viewOnlineUrl?: string | null;
}
export interface SendCompanyDocsMessageRequest extends Parsable {
    /**
     * The body property
     */
    body?: string | null;
    /**
     * The documentIds property
     */
    documentIds?: string[] | null;
    /**
     * The emails property
     */
    emails?: string[] | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The phoneNumbers property
     */
    phoneNumbers?: string[] | null;
    /**
     * The sendViaEmail property
     */
    sendViaEmail?: boolean | null;
    /**
     * The sendViaSms property
     */
    sendViaSms?: boolean | null;
    /**
     * The subject property
     */
    subject?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface SendCompanyDocsMessageResponse extends Parsable {
    /**
     * The emailsSent property
     */
    emailsSent?: number | null;
    /**
     * The errors property
     */
    errors?: string[] | null;
    /**
     * The messageId property
     */
    messageId?: string | null;
    /**
     * The smsSent property
     */
    smsSent?: number | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The totalRecipients property
     */
    totalRecipients?: number | null;
    /**
     * The viewOnlineUrl property
     */
    viewOnlineUrl?: string | null;
}
export interface SendTearSheetsMessageRequest extends Parsable {
    /**
     * The body property
     */
    body?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The emails property
     */
    emails?: string[] | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The phoneNumbers property
     */
    phoneNumbers?: string[] | null;
    /**
     * The productIds property
     */
    productIds?: string[] | null;
    /**
     * The sendViaEmail property
     */
    sendViaEmail?: boolean | null;
    /**
     * The sendViaSms property
     */
    sendViaSms?: boolean | null;
    /**
     * The subject property
     */
    subject?: string | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface SendTearSheetsMessageResponse extends Parsable {
    /**
     * The emailsSent property
     */
    emailsSent?: number | null;
    /**
     * The errors property
     */
    errors?: string[] | null;
    /**
     * The messageId property
     */
    messageId?: string | null;
    /**
     * The smsSent property
     */
    smsSent?: number | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The tearSheetId property
     */
    tearSheetId?: string | null;
    /**
     * The totalRecipients property
     */
    totalRecipients?: number | null;
    /**
     * The viewOnlineUrl property
     */
    viewOnlineUrl?: string | null;
}
/**
 * One email with every delivery event recorded for it.
 */
export interface SentEmailDetailDto extends AdditionalDataHolder, Parsable, SentEmailDto {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The delivery events, oldest first.
     */
    events?: SentEmailEventDto[] | null;
}
/**
 * One email sent to one recipient, with its latest delivery status.
 */
export interface SentEmailDto extends Parsable {
    /**
     * Order receipts only: customer, sales-rep or organization.
     */
    audience?: string | null;
    /**
     * Why the email bounced, failed or was suppressed, when it did.
     */
    bounceReason?: string | null;
    /**
     * Permanent, Transient or Undetermined, for a bounce.
     */
    bounceType?: string | null;
    /**
     * How many times the recipient clicked a link in the email.
     */
    clickCount?: number | null;
    /**
     * The id of the order, invoice, tear sheet or other record the email is about.
     */
    entityId?: string | null;
    /**
     * What people call that record: the order number, invoice number or tear sheet name.
     */
    entityReference?: string | null;
    /**
     * The firstClickedAt property
     */
    firstClickedAt?: Date | null;
    /**
     * The firstOpenedAt property
     */
    firstOpenedAt?: Date | null;
    /**
     * The email's id, used to fetch its event timeline.
     */
    id?: string | null;
    /**
     * What the email is about: order, invoice, tearsheet, cart-share, cart-review, company-docs, access-request, api-access, user, sales-rep or organization-signup.
     */
    kind?: string | null;
    /**
     * The lastClickedAt property
     */
    lastClickedAt?: Date | null;
    /**
     * The lastOpenedAt property
     */
    lastOpenedAt?: Date | null;
    /**
     * scheduled, sent, delivery_delayed, delivered, opened, clicked, bounced, complained, failed orsuppressed. Moves forward as the email progresses (delivered, then opened, then clicked); abounce, spam complaint, failure or suppression takes precedence over any of those.
     */
    latestStatus?: string | null;
    /**
     * The latestStatusAt property
     */
    latestStatusAt?: Date | null;
    /**
     * The message-center message the email was sent from, when there is one.
     */
    messageId?: string | null;
    /**
     * How many times the recipient opened the email. Mail clients that prefetch images can count as opens.
     */
    openCount?: number | null;
    /**
     * The recipient property
     */
    recipient?: string | null;
    /**
     * The sentAt property
     */
    sentAt?: Date | null;
    /**
     * The subject property
     */
    subject?: string | null;
    /**
     * The email template used.
     */
    template?: string | null;
}
/**
 * One delivery event.
 */
export interface SentEmailEventDto extends Parsable {
    /**
     * The link the recipient followed, on a click.
     */
    link?: string | null;
    /**
     * The occurredAt property
     */
    occurredAt?: Date | null;
    /**
     * The bounce, failure or suppression reason the event carried.
     */
    reason?: string | null;
    /**
     * scheduled, sent, delivery_delayed, delivered, opened, clicked, bounced, complained, failed or suppressed.
     */
    type?: string | null;
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAbandonedImageAssetsJobRequest(writer: SerializationWriter, abandonedImageAssetsJobRequest: Partial<AbandonedImageAssetsJobRequest> | undefined | null = {}) : void {
    if (abandonedImageAssetsJobRequest) {
        writer.writeBooleanValue("dryRun", abandonedImageAssetsJobRequest.dryRun);
        writer.writeCollectionOfPrimitiveValues<string>("organizationIds", abandonedImageAssetsJobRequest.organizationIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAbandonedImageAssetsJobStatusResponse(writer: SerializationWriter, abandonedImageAssetsJobStatusResponse: Partial<AbandonedImageAssetsJobStatusResponse> | undefined | null = {}) : void {
    if (abandonedImageAssetsJobStatusResponse) {
        writer.writeBooleanValue("dryRun", abandonedImageAssetsJobStatusResponse.dryRun);
        writer.writeStringValue("errorMessage", abandonedImageAssetsJobStatusResponse.errorMessage);
        writer.writeBooleanValue("isSuccessfull", abandonedImageAssetsJobStatusResponse.isSuccessfull);
        writer.writeCollectionOfObjectValues<AbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages>("organizations", abandonedImageAssetsJobStatusResponse.organizations, serializeAbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages);
        writer.writeNumberValue("totalAbandoned", abandonedImageAssetsJobStatusResponse.totalAbandoned);
        writer.writeNumberValue("totalDeleted", abandonedImageAssetsJobStatusResponse.totalDeleted);
        writer.writeNumberValue("totalOrganizations", abandonedImageAssetsJobStatusResponse.totalOrganizations);
        writer.writeNumberValue("totalStoredAssets", abandonedImageAssetsJobStatusResponse.totalStoredAssets);
        writer.writeNumberValue("totalTracked", abandonedImageAssetsJobStatusResponse.totalTracked);
        writer.writeNumberValue("unclassifiedAssets", abandonedImageAssetsJobStatusResponse.unclassifiedAssets);
        writer.writeCollectionOfPrimitiveValues<string>("unclassifiedSampleIds", abandonedImageAssetsJobStatusResponse.unclassifiedSampleIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages(writer: SerializationWriter, abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages: Partial<AbandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages> | undefined | null = {}) : void {
    if (abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages) {
        writer.writeNumberValue("abandonedAssets", abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.abandonedAssets);
        writer.writeCollectionOfPrimitiveValues<string>("abandonedImageIds", abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.abandonedImageIds);
        writer.writeNumberValue("deletedAssets", abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.deletedAssets);
        writer.writeStringValue("organizationId", abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.organizationId);
        writer.writeNumberValue("trackedAssets", abandonedImageAssetsJobStatusResponse_OrganizationAbandonedImages.trackedAssets);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccessRequest(writer: SerializationWriter, accessRequest: Partial<AccessRequest> | undefined | null = {}) : void {
    if (accessRequest) {
        serializeBaseEntity(writer, accessRequest)
        writer.writeStringValue("accessRequestId", accessRequest.accessRequestId);
        writer.writeStringValue("address1", accessRequest.address1);
        writer.writeStringValue("address2", accessRequest.address2);
        writer.writeStringValue("city", accessRequest.city);
        writer.writeStringValue("companyEmail", accessRequest.companyEmail);
        writer.writeStringValue("companyName", accessRequest.companyName);
        writer.writeStringValue("country", accessRequest.country);
        writer.writeStringValue("customerNumber", accessRequest.customerNumber);
        writer.writeStringValue("emailAddress", accessRequest.emailAddress);
        writer.writeStringValue("firstName", accessRequest.firstName);
        writer.writeStringValue("lastName", accessRequest.lastName);
        writer.writeStringValue("organizationId", accessRequest.organizationId);
        writer.writeStringValue("phoneNumber", accessRequest.phoneNumber);
        writer.writeStringValue("postalCode", accessRequest.postalCode);
        writer.writeObjectValue<AccessRequestResearch>("research", accessRequest.research, serializeAccessRequestResearch);
        writer.writeStringValue("stateProvince", accessRequest.stateProvince);
        writer.writeEnumValue<AccessRequestStatus>("status", accessRequest.status);
        writer.writeDateValue("statusChangedOn", accessRequest.statusChangedOn);
        writer.writeStringValue("taxIdEIN", accessRequest.taxIdEIN);
        writer.writeAdditionalData(accessRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccessRequestResearch(writer: SerializationWriter, accessRequestResearch: Partial<AccessRequestResearch> | undefined | null = {}) : void {
    if (accessRequestResearch) {
        writer.writeStringValue("content", accessRequestResearch.content);
        writer.writeNumberValue("eligibilityScore", accessRequestResearch.eligibilityScore);
        writer.writeDateValue("generatedAt", accessRequestResearch.generatedAt);
        writer.writeStringValue("generatedBy", accessRequestResearch.generatedBy);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccessRequestResearchSettings(writer: SerializationWriter, accessRequestResearchSettings: Partial<AccessRequestResearchSettings> | undefined | null = {}) : void {
    if (accessRequestResearchSettings) {
        writer.writeStringValue("approvalCriteria", accessRequestResearchSettings.approvalCriteria);
        writer.writeStringValue("industryDescription", accessRequestResearchSettings.industryDescription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccessRequestsPageSummary(writer: SerializationWriter, accessRequestsPageSummary: Partial<AccessRequestsPageSummary> | undefined | null = {}) : void {
    if (accessRequestsPageSummary) {
        writer.writeNumberValue("approvedLast30Days", accessRequestsPageSummary.approvedLast30Days);
        writer.writeNumberValue("approvedPrior30Days", accessRequestsPageSummary.approvedPrior30Days);
        writer.writeDateValue("asOf", accessRequestsPageSummary.asOf);
        writer.writeNumberValue("averageResponseDays", accessRequestsPageSummary.averageResponseDays);
        writer.writeNumberValue("firstOrderRate", accessRequestsPageSummary.firstOrderRate);
        writer.writeNumberValue("firstOrderRatePrior", accessRequestsPageSummary.firstOrderRatePrior);
        writer.writeNumberValue("oldestPendingDays", accessRequestsPageSummary.oldestPendingDays);
        writer.writeNumberValue("pending", accessRequestsPageSummary.pending);
        writer.writeNumberValue("responseGoalDays", accessRequestsPageSummary.responseGoalDays);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountSetup(writer: SerializationWriter, accountSetup: Partial<AccountSetup> | undefined | null = {}) : void {
    if (accountSetup) {
        writer.writeBooleanValue("isComplete", accountSetup.isComplete);
        writer.writeObjectValue<Step>("nextStep", accountSetup.nextStep, serializeStep);
        writer.writeNumberValue("percentageComplete", accountSetup.percentageComplete);
        writer.writeCollectionOfObjectValues<Step>("steps", accountSetup.steps, serializeStep);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeActivateCommissionPlanRequest(writer: SerializationWriter, activateCommissionPlanRequest: Partial<ActivateCommissionPlanRequest> | undefined | null = {}) : void {
    if (activateCommissionPlanRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", activateCommissionPlanRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", activateCommissionPlanRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeActivateSalesRepRequest(writer: SerializationWriter, activateSalesRepRequest: Partial<ActivateSalesRepRequest> | undefined | null = {}) : void {
    if (activateSalesRepRequest) {
        writer.writeStringValue("organizationSalesRepId", activateSalesRepRequest.organizationSalesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeActiveCustomersKpi(writer: SerializationWriter, activeCustomersKpi: Partial<ActiveCustomersKpi> | undefined | null = {}) : void {
    if (activeCustomersKpi) {
        writer.writeNumberValue("activeCustomerCount", activeCustomersKpi.activeCustomerCount);
        writer.writeDateValue("endDate", activeCustomersKpi.endDate);
        writer.writeStringValue("organizationId", activeCustomersKpi.organizationId);
        writer.writeDateValue("startDate", activeCustomersKpi.startDate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddAdminUserRequest(writer: SerializationWriter, addAdminUserRequest: Partial<AddAdminUserRequest> | undefined | null = {}) : void {
    if (addAdminUserRequest) {
        writer.writeStringValue("email", addAdminUserRequest.email);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddAdminUserResponse(writer: SerializationWriter, addAdminUserResponse: Partial<AddAdminUserResponse> | undefined | null = {}) : void {
    if (addAdminUserResponse) {
        writer.writeBooleanValue("success", addAdminUserResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddCustomerAttributeRequest(writer: SerializationWriter, addCustomerAttributeRequest: Partial<AddCustomerAttributeRequest> | undefined | null = {}) : void {
    if (addCustomerAttributeRequest) {
        writer.writeStringValue("attribute", addCustomerAttributeRequest.attribute);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddFulfillmentMethodRequest(writer: SerializationWriter, addFulfillmentMethodRequest: Partial<AddFulfillmentMethodRequest> | undefined | null = {}) : void {
    if (addFulfillmentMethodRequest) {
        writer.writeStringValue("fulfillmentMethod", addFulfillmentMethodRequest.fulfillmentMethod);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddItemRequest(writer: SerializationWriter, addItemRequest: Partial<AddItemRequest> | undefined | null = {}) : void {
    if (addItemRequest) {
        writer.writeBooleanValue("newLine", addItemRequest.newLine);
        writer.writeNumberValue("quantity", addItemRequest.quantity);
        writer.writeStringValue("sku", addItemRequest.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddItemToListRequest(writer: SerializationWriter, addItemToListRequest: Partial<AddItemToListRequest> | undefined | null = {}) : void {
    if (addItemToListRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", addItemToListRequest.orgCodes);
        writer.writeStringValue("productName", addItemToListRequest.productName);
        writer.writeNumberValue("quantity", addItemToListRequest.quantity);
        writer.writeStringValue("sku", addItemToListRequest.sku);
        writer.writeStringValue("source", addItemToListRequest.source);
        writer.writeStringValue("useOrganizationId", addItemToListRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddMarketCodeRequest(writer: SerializationWriter, addMarketCodeRequest: Partial<AddMarketCodeRequest> | undefined | null = {}) : void {
    if (addMarketCodeRequest) {
        writer.writeStringValue("marketCode", addMarketCodeRequest.marketCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddOrderStatusRequest(writer: SerializationWriter, addOrderStatusRequest: Partial<AddOrderStatusRequest> | undefined | null = {}) : void {
    if (addOrderStatusRequest) {
        writer.writeStringValue("orderStatus", addOrderStatusRequest.orderStatus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddOrderTypeRequest(writer: SerializationWriter, addOrderTypeRequest: Partial<AddOrderTypeRequest> | undefined | null = {}) : void {
    if (addOrderTypeRequest) {
        writer.writeEnumValue<OrderKind>("kind", addOrderTypeRequest.kind);
        writer.writeStringValue("orderType", addOrderTypeRequest.orderType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddPriceTierRequest(writer: SerializationWriter, addPriceTierRequest: Partial<AddPriceTierRequest> | undefined | null = {}) : void {
    if (addPriceTierRequest) {
        writer.writeStringValue("currencyCode", addPriceTierRequest.currencyCode);
        writer.writeStringValue("name", addPriceTierRequest.name);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddProductAttributeRequest(writer: SerializationWriter, addProductAttributeRequest: Partial<AddProductAttributeRequest> | undefined | null = {}) : void {
    if (addProductAttributeRequest) {
        writer.writeStringValue("attribute", addProductAttributeRequest.attribute);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddress(writer: SerializationWriter, address: Partial<Address> | undefined | null = {}) : void {
    if (address) {
        writer.writeStringValue("address1", address.address1);
        writer.writeStringValue("address2", address.address2);
        writer.writeEnumValue<AddressType>("addressType", address.addressType);
        writer.writeStringValue("city", address.city);
        writer.writeStringValue("code", address.code);
        writer.writeStringValue("country", address.country);
        writer.writeBooleanValue("default", address.defaultEscaped);
        writer.writeStringValue("externalId", address.externalId);
        writer.writeNumberValue("latitude", address.latitude);
        writer.writeNumberValue("longitude", address.longitude);
        writer.writeStringValue("stateProvince", address.stateProvince);
        writer.writeStringValue("zipPostalCode", address.zipPostalCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddressComponent(writer: SerializationWriter, addressComponent: Partial<AddressComponent> | undefined | null = {}) : void {
    if (addressComponent) {
        writer.writeStringValue("long_name", addressComponent.longName);
        writer.writeStringValue("short_name", addressComponent.shortName);
        writer.writeCollectionOfPrimitiveValues<string>("types", addressComponent.types);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddressDto(writer: SerializationWriter, addressDto: Partial<AddressDto> | undefined | null = {}) : void {
    if (addressDto) {
        writer.writeStringValue("address1", addressDto.address1);
        writer.writeStringValue("address2", addressDto.address2);
        writer.writeStringValue("city", addressDto.city);
        writer.writeStringValue("country", addressDto.country);
        writer.writeStringValue("stateProvince", addressDto.stateProvince);
        writer.writeStringValue("zipPostalCode", addressDto.zipPostalCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddressInput(writer: SerializationWriter, addressInput: Partial<AddressInput> | undefined | null = {}) : void {
    if (addressInput) {
        writer.writeStringValue("address1", addressInput.address1);
        writer.writeStringValue("address2", addressInput.address2);
        writer.writeStringValue("addressType", addressInput.addressType);
        writer.writeStringValue("city", addressInput.city);
        writer.writeStringValue("code", addressInput.code);
        writer.writeStringValue("country", addressInput.country);
        writer.writeBooleanValue("default", addressInput.defaultEscaped);
        writer.writeStringValue("externalId", addressInput.externalId);
        writer.writeNumberValue("latitude", addressInput.latitude);
        writer.writeNumberValue("longitude", addressInput.longitude);
        writer.writeStringValue("stateProvince", addressInput.stateProvince);
        writer.writeStringValue("zipPostalCode", addressInput.zipPostalCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddSubscriptionItemRequest(writer: SerializationWriter, addSubscriptionItemRequest: Partial<AddSubscriptionItemRequest> | undefined | null = {}) : void {
    if (addSubscriptionItemRequest) {
        writer.writeStringValue("lookupKey", addSubscriptionItemRequest.lookupKey);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddSubscriptionItemResponse(writer: SerializationWriter, addSubscriptionItemResponse: Partial<AddSubscriptionItemResponse> | undefined | null = {}) : void {
    if (addSubscriptionItemResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("entitlements", addSubscriptionItemResponse.entitlements);
        writer.writeStringValue("subscriptionId", addSubscriptionItemResponse.subscriptionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddTermRequest(writer: SerializationWriter, addTermRequest: Partial<AddTermRequest> | undefined | null = {}) : void {
    if (addTermRequest) {
        writer.writeStringValue("term", addTermRequest.term);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAgencyScopedRequest(writer: SerializationWriter, agencyScopedRequest: Partial<AgencyScopedRequest> | undefined | null = {}) : void {
    if (agencyScopedRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", agencyScopedRequest.orgCodes);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAiUsageBreakdownItem(writer: SerializationWriter, aiUsageBreakdownItem: Partial<AiUsageBreakdownItem> | undefined | null = {}) : void {
    if (aiUsageBreakdownItem) {
        writer.writeNumberValue("callCount", aiUsageBreakdownItem.callCount);
        writer.writeNumberValue("costUsd", aiUsageBreakdownItem.costUsd);
        writer.writeStringValue("model", aiUsageBreakdownItem.model);
        writer.writeStringValue("operation", aiUsageBreakdownItem.operation);
        writer.writeNumberValue("tokens", aiUsageBreakdownItem.tokens);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeApiAuthenticationRequest(writer: SerializationWriter, apiAuthenticationRequest: Partial<ApiAuthenticationRequest> | undefined | null = {}) : void {
    if (apiAuthenticationRequest) {
        writer.writeStringValue("clientId", apiAuthenticationRequest.clientId ?? "sdaf43tfsdg45dg");
        writer.writeStringValue("clientSecret", apiAuthenticationRequest.clientSecret ?? "QsFdas%4F1asr23tgb675%3");
        writer.writeStringValue("orgCode", apiAuthenticationRequest.orgCode ?? "org_12345");
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeApiAuthenticationResponse(writer: SerializationWriter, apiAuthenticationResponse: Partial<ApiAuthenticationResponse> | undefined | null = {}) : void {
    if (apiAuthenticationResponse) {
        writer.writeStringValue("accessToken", apiAuthenticationResponse.accessToken);
        writer.writeNumberValue("expiresIn", apiAuthenticationResponse.expiresIn);
        writer.writeStringValue("tokenType", apiAuthenticationResponse.tokenType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeApiKey(writer: SerializationWriter, apiKey: Partial<ApiKey> | undefined | null = {}) : void {
    if (apiKey) {
        writer.writeStringValue("accessScope", apiKey.accessScope);
        writer.writeStringValue("key", apiKey.key);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAppliedPromotion(writer: SerializationWriter, appliedPromotion: Partial<AppliedPromotion> | undefined | null = {}) : void {
    if (appliedPromotion) {
        writer.writeNumberValue("amount", appliedPromotion.amount);
        writer.writeStringValue("appliedVia", appliedPromotion.appliedVia);
        writer.writeBooleanValue("automatic", appliedPromotion.automatic);
        writer.writeStringValue("campaignId", appliedPromotion.campaignId);
        writer.writeStringValue("campaignName", appliedPromotion.campaignName);
        writer.writeStringValue("code", appliedPromotion.code);
        writer.writeEnumValue<BenefitKind>("kind", appliedPromotion.kind);
        writer.writeStringValue("promotionId", appliedPromotion.promotionId);
        writer.writeStringValue("promotionName", appliedPromotion.promotionName);
        writer.writeNumberValue("tierThreshold", appliedPromotion.tierThreshold);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeApplyCartCodeRequest(writer: SerializationWriter, applyCartCodeRequest: Partial<ApplyCartCodeRequest> | undefined | null = {}) : void {
    if (applyCartCodeRequest) {
        writer.writeStringValue("code", applyCartCodeRequest.code);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeApplyDiscountRequest(writer: SerializationWriter, applyDiscountRequest: Partial<ApplyDiscountRequest> | undefined | null = {}) : void {
    if (applyDiscountRequest) {
        writer.writeObjectValue<DiscountInput>("discount", applyDiscountRequest.discount, serializeDiscountInput);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", applyDiscountRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", applyDiscountRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeApproveAccessRequestRequest(writer: SerializationWriter, approveAccessRequestRequest: Partial<ApproveAccessRequestRequest> | undefined | null = {}) : void {
    if (approveAccessRequestRequest) {
        writer.writeBooleanValue("createCustomer", approveAccessRequestRequest.createCustomer);
        writer.writeStringValue("customerNumber", approveAccessRequestRequest.customerNumber);
        writer.writeStringValue("priceTier", approveAccessRequestRequest.priceTier);
        writer.writeStringValue("terms", approveAccessRequestRequest.terms);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeApproveAccessRequestResponse(writer: SerializationWriter, approveAccessRequestResponse: Partial<ApproveAccessRequestResponse> | undefined | null = {}) : void {
    if (approveAccessRequestResponse) {
        writer.writeStringValue("accessRequestId", approveAccessRequestResponse.accessRequestId);
        writer.writeBooleanValue("alreadyHadAccess", approveAccessRequestResponse.alreadyHadAccess);
        writer.writeStringValue("customerNumber", approveAccessRequestResponse.customerNumber);
        writer.writeBooleanValue("emailSent", approveAccessRequestResponse.emailSent);
        writer.writeStringValue("identityProviderUserId", approveAccessRequestResponse.identityProviderUserId);
        writer.writeStringValue("userId", approveAccessRequestResponse.userId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeApproveCommissionStatementRequest(writer: SerializationWriter, approveCommissionStatementRequest: Partial<ApproveCommissionStatementRequest> | undefined | null = {}) : void {
    if (approveCommissionStatementRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", approveCommissionStatementRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", approveCommissionStatementRequest.useOrganizationId);
        writer.writeStringValue("user", approveCommissionStatementRequest.user);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAssignProductFamilyVariantsRequest(writer: SerializationWriter, assignProductFamilyVariantsRequest: Partial<AssignProductFamilyVariantsRequest> | undefined | null = {}) : void {
    if (assignProductFamilyVariantsRequest) {
        writer.writeCollectionOfObjectValues<AssignProductFamilyVariantsRequest_VariantAssignment>("variants", assignProductFamilyVariantsRequest.variants, serializeAssignProductFamilyVariantsRequest_VariantAssignment);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAssignProductFamilyVariantsRequest_VariantAssignment(writer: SerializationWriter, assignProductFamilyVariantsRequest_VariantAssignment: Partial<AssignProductFamilyVariantsRequest_VariantAssignment> | undefined | null = {}) : void {
    if (assignProductFamilyVariantsRequest_VariantAssignment) {
        writer.writeObjectValue<AssignProductFamilyVariantsRequest_VariantAssignment_optionValues>("optionValues", assignProductFamilyVariantsRequest_VariantAssignment.optionValues, serializeAssignProductFamilyVariantsRequest_VariantAssignment_optionValues);
        writer.writeStringValue("sku", assignProductFamilyVariantsRequest_VariantAssignment.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAssignProductFamilyVariantsRequest_VariantAssignment_optionValues(writer: SerializationWriter, assignProductFamilyVariantsRequest_VariantAssignment_optionValues: Partial<AssignProductFamilyVariantsRequest_VariantAssignment_optionValues> | undefined | null = {}) : void {
    if (assignProductFamilyVariantsRequest_VariantAssignment_optionValues) {
        writer.writeAdditionalData(assignProductFamilyVariantsRequest_VariantAssignment_optionValues.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAssignProductFamilyVariantsResponse(writer: SerializationWriter, assignProductFamilyVariantsResponse: Partial<AssignProductFamilyVariantsResponse> | undefined | null = {}) : void {
    if (assignProductFamilyVariantsResponse) {
        writer.writeObjectValue<ProductFamily>("family", assignProductFamilyVariantsResponse.family, serializeProductFamily);
        writer.writeCollectionOfPrimitiveValues<string>("missingSkus", assignProductFamilyVariantsResponse.missingSkus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAssociateCustomerRequest(writer: SerializationWriter, associateCustomerRequest: Partial<AssociateCustomerRequest> | undefined | null = {}) : void {
    if (associateCustomerRequest) {
        writer.writeStringValue("customerNumber", associateCustomerRequest.customerNumber);
        writer.writeStringValue("userId", associateCustomerRequest.userId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAssociateCustomerResponse(writer: SerializationWriter, associateCustomerResponse: Partial<AssociateCustomerResponse> | undefined | null = {}) : void {
    if (associateCustomerResponse) {
        writer.writeObjectValue<UserCustomer>("association", associateCustomerResponse.association, serializeUserCustomer);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAvailableExportFormatDto(writer: SerializationWriter, availableExportFormatDto: Partial<AvailableExportFormatDto> | undefined | null = {}) : void {
    if (availableExportFormatDto) {
        writer.writeStringValue("displayName", availableExportFormatDto.displayName);
        writer.writeStringValue("key", availableExportFormatDto.key);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAverageOrderValueKpi(writer: SerializationWriter, averageOrderValueKpi: Partial<AverageOrderValueKpi> | undefined | null = {}) : void {
    if (averageOrderValueKpi) {
        writer.writeNumberValue("averageOrderValue", averageOrderValueKpi.averageOrderValue);
        writer.writeDateValue("endDate", averageOrderValueKpi.endDate);
        writer.writeStringValue("organizationId", averageOrderValueKpi.organizationId);
        writer.writeDateValue("startDate", averageOrderValueKpi.startDate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillCartShareEventsRequest(writer: SerializationWriter, backfillCartShareEventsRequest: Partial<BackfillCartShareEventsRequest> | undefined | null = {}) : void {
    if (backfillCartShareEventsRequest) {
        writer.writeBooleanValue("dryRun", backfillCartShareEventsRequest.dryRun);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillCartShareEventsResponse(writer: SerializationWriter, backfillCartShareEventsResponse: Partial<BackfillCartShareEventsResponse> | undefined | null = {}) : void {
    if (backfillCartShareEventsResponse) {
        writer.writeNumberValue("alreadyRecorded", backfillCartShareEventsResponse.alreadyRecorded);
        writer.writeBooleanValue("dryRun", backfillCartShareEventsResponse.dryRun);
        writer.writeCollectionOfPrimitiveValues<string>("failed", backfillCartShareEventsResponse.failed);
        writer.writeNumberValue("noCart", backfillCartShareEventsResponse.noCart);
        writer.writeNumberValue("notSent", backfillCartShareEventsResponse.notSent);
        writer.writeStringValue("organizationId", backfillCartShareEventsResponse.organizationId);
        writer.writeNumberValue("recorded", backfillCartShareEventsResponse.recorded);
        writer.writeNumberValue("sharesExamined", backfillCartShareEventsResponse.sharesExamined);
        writer.writeBooleanValue("success", backfillCartShareEventsResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillOrderSalesRepsRequest(writer: SerializationWriter, backfillOrderSalesRepsRequest: Partial<BackfillOrderSalesRepsRequest> | undefined | null = {}) : void {
    if (backfillOrderSalesRepsRequest) {
        writer.writeBooleanValue("dryRun", backfillOrderSalesRepsRequest.dryRun);
        writer.writeBooleanValue("normalizeMissingReps", backfillOrderSalesRepsRequest.normalizeMissingReps);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillOrderSalesRepsResponse(writer: SerializationWriter, backfillOrderSalesRepsResponse: Partial<BackfillOrderSalesRepsResponse> | undefined | null = {}) : void {
    if (backfillOrderSalesRepsResponse) {
        writer.writeBooleanValue("dryRun", backfillOrderSalesRepsResponse.dryRun);
        writer.writeCollectionOfPrimitiveValues<string>("failed", backfillOrderSalesRepsResponse.failed);
        writer.writeNumberValue("ordersExamined", backfillOrderSalesRepsResponse.ordersExamined);
        writer.writeNumberValue("ordersHealed", backfillOrderSalesRepsResponse.ordersHealed);
        writer.writeNumberValue("ordersSetNotAssigned", backfillOrderSalesRepsResponse.ordersSetNotAssigned);
        writer.writeNumberValue("ordersUnchanged", backfillOrderSalesRepsResponse.ordersUnchanged);
        writer.writeStringValue("organizationId", backfillOrderSalesRepsResponse.organizationId);
        writer.writeBooleanValue("success", backfillOrderSalesRepsResponse.success);
        writer.writeCollectionOfPrimitiveValues<string>("unresolvableRepNumbers", backfillOrderSalesRepsResponse.unresolvableRepNumbers);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillSubscriptionsResponse(writer: SerializationWriter, backfillSubscriptionsResponse: Partial<BackfillSubscriptionsResponse> | undefined | null = {}) : void {
    if (backfillSubscriptionsResponse) {
        writer.writeNumberValue("activeReps", backfillSubscriptionsResponse.activeReps);
        writer.writeNumberValue("seats", backfillSubscriptionsResponse.seats);
        writer.writeNumberValue("subscriptionsFound", backfillSubscriptionsResponse.subscriptionsFound);
        writer.writeNumberValue("subscriptionsRecorded", backfillSubscriptionsResponse.subscriptionsRecorded);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillUserChannelsResponse(writer: SerializationWriter, backfillUserChannelsResponse: Partial<BackfillUserChannelsResponse> | undefined | null = {}) : void {
    if (backfillUserChannelsResponse) {
        writer.writeNumberValue("channelsGranted", backfillUserChannelsResponse.channelsGranted);
        writer.writeCollectionOfPrimitiveValues<string>("failed", backfillUserChannelsResponse.failed);
        writer.writeStringValue("organizationId", backfillUserChannelsResponse.organizationId);
        writer.writeNumberValue("repsExamined", backfillUserChannelsResponse.repsExamined);
        writer.writeNumberValue("skippedBlankIdentity", backfillUserChannelsResponse.skippedBlankIdentity);
        writer.writeBooleanValue("success", backfillUserChannelsResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBaseEntity(writer: SerializationWriter, baseEntity: Partial<BaseEntity> | undefined | null = {}) : void {
    if (baseEntity) {
        writer.writeBooleanValue("active", baseEntity.active);
        writer.writeDateValue("createdAt", baseEntity.createdAt);
        writer.writeDateValue("updatedAt", baseEntity.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBenefit(writer: SerializationWriter, benefit: Partial<Benefit> | undefined | null = {}) : void {
    if (benefit) {
        writer.writeEnumValue<DiscountType>("discountType", benefit.discountType);
        writer.writeEnumValue<BenefitKind>("kind", benefit.kind);
        writer.writeNumberValue("quantity", benefit.quantity);
        writer.writeStringValue("sku", benefit.sku);
        writer.writeCollectionOfObjectValues<BenefitTier>("tiers", benefit.tiers, serializeBenefitTier);
        writer.writeNumberValue("value", benefit.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBenefitInput(writer: SerializationWriter, benefitInput: Partial<BenefitInput> | undefined | null = {}) : void {
    if (benefitInput) {
        writer.writeEnumValue<DiscountType>("discountType", benefitInput.discountType);
        writer.writeEnumValue<BenefitKind>("kind", benefitInput.kind);
        writer.writeNumberValue("quantity", benefitInput.quantity);
        writer.writeStringValue("sku", benefitInput.sku);
        writer.writeCollectionOfObjectValues<BenefitTierInput>("tiers", benefitInput.tiers, serializeBenefitTierInput);
        writer.writeNumberValue("value", benefitInput.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBenefitTier(writer: SerializationWriter, benefitTier: Partial<BenefitTier> | undefined | null = {}) : void {
    if (benefitTier) {
        writer.writeNumberValue("threshold", benefitTier.threshold);
        writer.writeNumberValue("value", benefitTier.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBenefitTierInput(writer: SerializationWriter, benefitTierInput: Partial<BenefitTierInput> | undefined | null = {}) : void {
    if (benefitTierInput) {
        writer.writeNumberValue("threshold", benefitTierInput.threshold);
        writer.writeNumberValue("value", benefitTierInput.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBillingAddress(writer: SerializationWriter, billingAddress: Partial<BillingAddress> | undefined | null = {}) : void {
    if (billingAddress) {
        writer.writeStringValue("address1", billingAddress.address1);
        writer.writeStringValue("address2", billingAddress.address2);
        writer.writeStringValue("city", billingAddress.city);
        writer.writeStringValue("company", billingAddress.company);
        writer.writeStringValue("country", billingAddress.country);
        writer.writeStringValue("firstName", billingAddress.firstName);
        writer.writeStringValue("lastName", billingAddress.lastName);
        writer.writeStringValue("state", billingAddress.state);
        writer.writeStringValue("zipCode", billingAddress.zipCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBillingInvoice(writer: SerializationWriter, billingInvoice: Partial<BillingInvoice> | undefined | null = {}) : void {
    if (billingInvoice) {
        writer.writeNumberValue("amountDue", billingInvoice.amountDue);
        writer.writeNumberValue("amountPaid", billingInvoice.amountPaid);
        writer.writeStringValue("currencyCode", billingInvoice.currencyCode);
        writer.writeDateValue("date", billingInvoice.date);
        writer.writeDateValue("dueDate", billingInvoice.dueDate);
        writer.writeStringValue("id", billingInvoice.id);
        writer.writeStringValue("status", billingInvoice.status);
        writer.writeNumberValue("total", billingInvoice.total);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBillingInvoicePdfResponse(writer: SerializationWriter, billingInvoicePdfResponse: Partial<BillingInvoicePdfResponse> | undefined | null = {}) : void {
    if (billingInvoicePdfResponse) {
        writer.writeStringValue("url", billingInvoicePdfResponse.url);
        writer.writeDateValue("validUntil", billingInvoicePdfResponse.validUntil);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBillingInvoicesResponse(writer: SerializationWriter, billingInvoicesResponse: Partial<BillingInvoicesResponse> | undefined | null = {}) : void {
    if (billingInvoicesResponse) {
        writer.writeCollectionOfObjectValues<BillingInvoice>("invoices", billingInvoicesResponse.invoices, serializeBillingInvoice);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBulkDeleteDocumentsRequest(writer: SerializationWriter, bulkDeleteDocumentsRequest: Partial<BulkDeleteDocumentsRequest> | undefined | null = {}) : void {
    if (bulkDeleteDocumentsRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("documentIds", bulkDeleteDocumentsRequest.documentIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBulkImportCustomerUserResult(writer: SerializationWriter, bulkImportCustomerUserResult: Partial<BulkImportCustomerUserResult> | undefined | null = {}) : void {
    if (bulkImportCustomerUserResult) {
        writer.writeStringValue("customerNumber", bulkImportCustomerUserResult.customerNumber);
        writer.writeStringValue("email", bulkImportCustomerUserResult.email);
        writer.writeStringValue("error", bulkImportCustomerUserResult.errorEscaped);
        writer.writeEnumValue<BulkImportCustomerUserOutcome>("outcome", bulkImportCustomerUserResult.outcome);
        writer.writeNumberValue("rowNumber", bulkImportCustomerUserResult.rowNumber);
        writer.writeStringValue("temporaryPassword", bulkImportCustomerUserResult.temporaryPassword);
        writer.writeStringValue("userCustomerId", bulkImportCustomerUserResult.userCustomerId);
        writer.writeStringValue("userId", bulkImportCustomerUserResult.userId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBulkImportCustomerUserRow(writer: SerializationWriter, bulkImportCustomerUserRow: Partial<BulkImportCustomerUserRow> | undefined | null = {}) : void {
    if (bulkImportCustomerUserRow) {
        writer.writeStringValue("customerNumber", bulkImportCustomerUserRow.customerNumber);
        writer.writeStringValue("email", bulkImportCustomerUserRow.email);
        writer.writeStringValue("firstName", bulkImportCustomerUserRow.firstName);
        writer.writeStringValue("lastName", bulkImportCustomerUserRow.lastName);
        writer.writeStringValue("phoneNumber", bulkImportCustomerUserRow.phoneNumber);
        writer.writeStringValue("temporaryPassword", bulkImportCustomerUserRow.temporaryPassword);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBulkImportCustomerUsersRequest(writer: SerializationWriter, bulkImportCustomerUsersRequest: Partial<BulkImportCustomerUsersRequest> | undefined | null = {}) : void {
    if (bulkImportCustomerUsersRequest) {
        writer.writeEnumValue<TemporaryPasswordMode>("temporaryPasswordMode", bulkImportCustomerUsersRequest.temporaryPasswordMode);
        writer.writeCollectionOfObjectValues<BulkImportCustomerUserRow>("users", bulkImportCustomerUsersRequest.users, serializeBulkImportCustomerUserRow);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBulkImportCustomerUsersResponse(writer: SerializationWriter, bulkImportCustomerUsersResponse: Partial<BulkImportCustomerUsersResponse> | undefined | null = {}) : void {
    if (bulkImportCustomerUsersResponse) {
        writer.writeNumberValue("alreadyExisted", bulkImportCustomerUsersResponse.alreadyExisted);
        writer.writeNumberValue("created", bulkImportCustomerUsersResponse.created);
        writer.writeNumberValue("failed", bulkImportCustomerUsersResponse.failed);
        writer.writeCollectionOfObjectValues<BulkImportCustomerUserResult>("results", bulkImportCustomerUsersResponse.results, serializeBulkImportCustomerUserResult);
        writer.writeNumberValue("totalRows", bulkImportCustomerUsersResponse.totalRows);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBulkMoveDocumentsRequest(writer: SerializationWriter, bulkMoveDocumentsRequest: Partial<BulkMoveDocumentsRequest> | undefined | null = {}) : void {
    if (bulkMoveDocumentsRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("documentIds", bulkMoveDocumentsRequest.documentIds);
        writer.writeStringValue("targetFolderId", bulkMoveDocumentsRequest.targetFolderId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBulkWriteDailyTotal(writer: SerializationWriter, bulkWriteDailyTotal: Partial<BulkWriteDailyTotal> | undefined | null = {}) : void {
    if (bulkWriteDailyTotal) {
        writer.writeNumberValue("callCount", bulkWriteDailyTotal.callCount);
        writer.writeStringValue("day", bulkWriteDailyTotal.day);
        writer.writeNumberValue("documentCount", bulkWriteDailyTotal.documentCount);
        writer.writeStringValue("endpoint", bulkWriteDailyTotal.endpoint);
        writer.writeNumberValue("failedCallCount", bulkWriteDailyTotal.failedCallCount);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBusinessCardAddress(writer: SerializationWriter, businessCardAddress: Partial<BusinessCardAddress> | undefined | null = {}) : void {
    if (businessCardAddress) {
        writer.writeObjectValue<BusinessCardField>("address1", businessCardAddress.address1, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("address2", businessCardAddress.address2, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("city", businessCardAddress.city, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("country", businessCardAddress.country, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("stateProvince", businessCardAddress.stateProvince, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("zipPostalCode", businessCardAddress.zipPostalCode, serializeBusinessCardField);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBusinessCardField(writer: SerializationWriter, businessCardField: Partial<BusinessCardField> | undefined | null = {}) : void {
    if (businessCardField) {
        writer.writeNumberValue("confidence", businessCardField.confidence);
        writer.writeStringValue("value", businessCardField.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCampaign(writer: SerializationWriter, campaign: Partial<Campaign> | undefined | null = {}) : void {
    if (campaign) {
        serializeBaseEntity(writer, campaign)
        writer.writeDateValue("activatedAt", campaign.activatedAt);
        writer.writeStringValue("campaignId", campaign.campaignId);
        writer.writeCollectionOfPrimitiveValues<string>("channels", campaign.channels);
        writer.writeCollectionOfPrimitiveValues<string>("customerNumbers", campaign.customerNumbers);
        writer.writeStringValue("description", campaign.description);
        writer.writeCollectionOfPrimitiveValues<string>("marketCodes", campaign.marketCodes);
        writer.writeNumberValue("maxRedemptions", campaign.maxRedemptions);
        writer.writeStringValue("name", campaign.name);
        writer.writeCollectionOfPrimitiveValues<string>("orderTypes", campaign.orderTypes);
        writer.writeStringValue("organizationId", campaign.organizationId);
        writer.writeCollectionOfObjectValues<Promotion>("promotions", campaign.promotions, serializePromotion);
        writer.writeNumberValue("redemptionCount", campaign.redemptionCount);
        writer.writeEnumValue<CampaignTrigger>("trigger", campaign.trigger);
        writer.writeDateValue("validFrom", campaign.validFrom);
        writer.writeDateValue("validTo", campaign.validTo);
        writer.writeAdditionalData(campaign.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCampaignInput(writer: SerializationWriter, campaignInput: Partial<CampaignInput> | undefined | null = {}) : void {
    if (campaignInput) {
        writer.writeCollectionOfPrimitiveValues<string>("channels", campaignInput.channels);
        writer.writeCollectionOfPrimitiveValues<string>("customerNumbers", campaignInput.customerNumbers);
        writer.writeStringValue("description", campaignInput.description);
        writer.writeCollectionOfPrimitiveValues<string>("marketCodes", campaignInput.marketCodes);
        writer.writeNumberValue("maxRedemptions", campaignInput.maxRedemptions);
        writer.writeStringValue("name", campaignInput.name);
        writer.writeCollectionOfPrimitiveValues<string>("orderTypes", campaignInput.orderTypes);
        writer.writeCollectionOfObjectValues<PromotionInput>("promotions", campaignInput.promotions, serializePromotionInput);
        writer.writeEnumValue<CampaignTrigger>("trigger", campaignInput.trigger);
        writer.writeDateValue("validFrom", campaignInput.validFrom);
        writer.writeDateValue("validTo", campaignInput.validTo);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCancelInvoiceRequest(writer: SerializationWriter, cancelInvoiceRequest: Partial<CancelInvoiceRequest> | undefined | null = {}) : void {
    if (cancelInvoiceRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", cancelInvoiceRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", cancelInvoiceRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartActor(writer: SerializationWriter, cartActor: Partial<CartActor> | undefined | null = {}) : void {
    if (cartActor) {
        writer.writeStringValue("displayName", cartActor.displayName);
        writer.writeStringValue("id", cartActor.id);
        writer.writeStringValue("syncUser", cartActor.syncUser);
        writer.writeEnumValue<CartActorType>("type", cartActor.type);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartEvent(writer: SerializationWriter, cartEvent: Partial<CartEvent> | undefined | null = {}) : void {
    if (cartEvent) {
        writer.writeEnumValue<CartEventAction>("action", cartEvent.action);
        writer.writeObjectValue<CartActor>("actor", cartEvent.actor, serializeCartActor);
        writer.writeStringValue("after", cartEvent.after);
        writer.writeStringValue("before", cartEvent.before);
        writer.writeStringValue("cartEventId", cartEvent.cartEventId);
        writer.writeStringValue("cartId", cartEvent.cartId);
        writer.writeStringValue("note", cartEvent.note);
        writer.writeDateValue("occurredAt", cartEvent.occurredAt);
        writer.writeStringValue("organizationId", cartEvent.organizationId);
        writer.writeDateValue("recordedAt", cartEvent.recordedAt);
        writer.writeStringValue("sku", cartEvent.sku);
        writer.writeStringValue("surface", cartEvent.surface);
        writer.writeStringValue("vendorCode", cartEvent.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartItem(writer: SerializationWriter, cartItem: Partial<CartItem> | undefined | null = {}) : void {
    if (cartItem) {
        serializeBaseEntity(writer, cartItem)
        writer.writeCollectionOfPrimitiveValues<string>("categoryPaths", cartItem.categoryPaths);
        writer.writeObjectValue<Discount>("discount", cartItem.discount, serializeDiscount);
        writer.writeNumberValue("discountAmount", cartItem.discountAmount);
        writer.writeStringValue("discountAmountFormatted", cartItem.discountAmountFormatted);
        writer.writeObjectValue<GiftMarker>("gift", cartItem.gift, serializeGiftMarker);
        writer.writeStringValue("imageName", cartItem.imageName);
        writer.writeStringValue("lineId", cartItem.lineId);
        writer.writeNumberValue("minimumOrderQuantity", cartItem.minimumOrderQuantity);
        writer.writeStringValue("note", cartItem.note);
        writer.writeNumberValue("price", cartItem.price);
        writer.writeStringValue("priceFormatted", cartItem.priceFormatted);
        writer.writeObjectValue<PriceOverride>("priceOverride", cartItem.priceOverride, serializePriceOverride);
        writer.writeStringValue("productName", cartItem.productName);
        writer.writeNumberValue("quantity", cartItem.quantity);
        writer.writeNumberValue("quantityIncrement", cartItem.quantityIncrement);
        writer.writeStringValue("sku", cartItem.sku);
        writer.writeNumberValue("subTotal", cartItem.subTotal);
        writer.writeStringValue("subTotalFormatted", cartItem.subTotalFormatted);
        writer.writeStringValue("taxCategory", cartItem.taxCategory);
        writer.writeStringValue("vendorCode", cartItem.vendorCode);
        writer.writeAdditionalData(cartItem.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartLine(writer: SerializationWriter, cartLine: Partial<CartLine> | undefined | null = {}) : void {
    if (cartLine) {
        writer.writeDateOnlyValue("cancelDate", cartLine.cancelDate);
        writer.writeNumberValue("discountAmount", cartLine.discountAmount);
        writer.writeNumberValue("discountPercent", cartLine.discountPercent);
        writer.writeStringValue("fulfillmentMethod", cartLine.fulfillmentMethod);
        writer.writeBooleanValue("isOpeningOrder", cartLine.isOpeningOrder);
        writer.writeNumberValue("minimumAmount", cartLine.minimumAmount);
        writer.writeStringValue("noteToVendor", cartLine.noteToVendor);
        writer.writeStringValue("orderType", cartLine.orderType);
        writer.writeStringValue("poNumber", cartLine.poNumber);
        writer.writeStringValue("priceLevel", cartLine.priceLevel);
        writer.writeBooleanValue("savedForLater", cartLine.savedForLater);
        writer.writeDateOnlyValue("shipDate", cartLine.shipDate);
        writer.writeStringValue("shipWindowName", cartLine.shipWindowName);
        writer.writeEnumValue<CartLineStatus>("status", cartLine.status);
        writer.writeNumberValue("subtotal", cartLine.subtotal);
        writer.writeStringValue("terms", cartLine.terms);
        writer.writeNumberValue("total", cartLine.total);
        writer.writeStringValue("vendorCode", cartLine.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartPriceChange(writer: SerializationWriter, cartPriceChange: Partial<CartPriceChange> | undefined | null = {}) : void {
    if (cartPriceChange) {
        writer.writeStringValue("lineId", cartPriceChange.lineId);
        writer.writeNumberValue("newPrice", cartPriceChange.newPrice);
        writer.writeNumberValue("oldPrice", cartPriceChange.oldPrice);
        writer.writeStringValue("sku", cartPriceChange.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartPriceRefreshSummary(writer: SerializationWriter, cartPriceRefreshSummary: Partial<CartPriceRefreshSummary> | undefined | null = {}) : void {
    if (cartPriceRefreshSummary) {
        writer.writeCollectionOfObjectValues<CartPriceChange>("changes", cartPriceRefreshSummary.changes, serializeCartPriceChange);
        writer.writeNumberValue("priceAgeDays", cartPriceRefreshSummary.priceAgeDays);
        writer.writeDateValue("refreshedAtUtc", cartPriceRefreshSummary.refreshedAtUtc);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartPricingSettings(writer: SerializationWriter, cartPricingSettings: Partial<CartPricingSettings> | undefined | null = {}) : void {
    if (cartPricingSettings) {
        writer.writeBooleanValue("allowDecimalQuantities", cartPricingSettings.allowDecimalQuantities);
        writer.writeBooleanValue("allowLineItemDiscounts", cartPricingSettings.allowLineItemDiscounts);
        writer.writeBooleanValue("allowOrderDiscounts", cartPricingSettings.allowOrderDiscounts);
        writer.writeBooleanValue("allowPriceOverride", cartPricingSettings.allowPriceOverride);
        writer.writeBooleanValue("refreshStalePrices", cartPricingSettings.refreshStalePrices);
        writer.writeNumberValue("stalePriceAgeDays", cartPricingSettings.stalePriceAgeDays);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartPromotionSummary(writer: SerializationWriter, cartPromotionSummary: Partial<CartPromotionSummary> | undefined | null = {}) : void {
    if (cartPromotionSummary) {
        writer.writeCollectionOfObjectValues<AppliedPromotion>("applied", cartPromotionSummary.applied, serializeAppliedPromotion);
        writer.writeNumberValue("appliedAmount", cartPromotionSummary.appliedAmount);
        writer.writeStringValue("appliedCode", cartPromotionSummary.appliedCode);
        writer.writeObjectValue<PromotionSkip>("appliedCodeSkip", cartPromotionSummary.appliedCodeSkip, serializePromotionSkip);
        writer.writeCollectionOfObjectValues<CodeCampaignSummary>("codeCampaigns", cartPromotionSummary.codeCampaigns, serializeCodeCampaignSummary);
        writer.writeNumberValue("lineCount", cartPromotionSummary.lineCount);
        writer.writeCollectionOfObjectValues<PendingPromotion>("pending", cartPromotionSummary.pending, serializePendingPromotion);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartReview(writer: SerializationWriter, cartReview: Partial<CartReview> | undefined | null = {}) : void {
    if (cartReview) {
        writer.writeStringValue("customerNote", cartReview.customerNote);
        writer.writeStringValue("repNote", cartReview.repNote);
        writer.writeDateValue("requestedAtUtc", cartReview.requestedAtUtc);
        writer.writeDateValue("returnedAtUtc", cartReview.returnedAtUtc);
        writer.writeStringValue("status", cartReview.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartShareLine(writer: SerializationWriter, cartShareLine: Partial<CartShareLine> | undefined | null = {}) : void {
    if (cartShareLine) {
        writer.writeNumberValue("discountAmount", cartShareLine.discountAmount);
        writer.writeObjectValue<DiscountDto>("discountDetail", cartShareLine.discountDetail, serializeDiscountDto);
        writer.writeObjectValue<GiftMarkerDto>("gift", cartShareLine.gift, serializeGiftMarkerDto);
        writer.writeNumberValue("lineTotal", cartShareLine.lineTotal);
        writer.writeStringValue("note", cartShareLine.note);
        writer.writeStringValue("productName", cartShareLine.productName);
        writer.writeNumberValue("quantity", cartShareLine.quantity);
        writer.writeStringValue("sku", cartShareLine.sku);
        writer.writeNumberValue("unitPrice", cartShareLine.unitPrice);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartShareLineRequest(writer: SerializationWriter, cartShareLineRequest: Partial<CartShareLineRequest> | undefined | null = {}) : void {
    if (cartShareLineRequest) {
        writer.writeNumberValue("discountAmount", cartShareLineRequest.discountAmount);
        writer.writeObjectValue<DiscountDto>("discountDetail", cartShareLineRequest.discountDetail, serializeDiscountDto);
        writer.writeObjectValue<GiftMarkerDto>("gift", cartShareLineRequest.gift, serializeGiftMarkerDto);
        writer.writeNumberValue("lineTotal", cartShareLineRequest.lineTotal);
        writer.writeStringValue("note", cartShareLineRequest.note);
        writer.writeStringValue("productName", cartShareLineRequest.productName);
        writer.writeNumberValue("quantity", cartShareLineRequest.quantity);
        writer.writeStringValue("sku", cartShareLineRequest.sku);
        writer.writeNumberValue("unitPrice", cartShareLineRequest.unitPrice);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartShareSnapshot(writer: SerializationWriter, cartShareSnapshot: Partial<CartShareSnapshot> | undefined | null = {}) : void {
    if (cartShareSnapshot) {
        writer.writeStringValue("appliedCode", cartShareSnapshot.appliedCode);
        writer.writeCollectionOfObjectValues<AppliedPromotion>("appliedPromotions", cartShareSnapshot.appliedPromotions, serializeAppliedPromotion);
        writer.writeStringValue("companyName", cartShareSnapshot.companyName);
        writer.writeStringValue("currencyCode", cartShareSnapshot.currencyCode);
        writer.writeStringValue("customerNumber", cartShareSnapshot.customerNumber);
        writer.writeNumberValue("discount", cartShareSnapshot.discount);
        writer.writeObjectValue<DiscountDto>("discountDetail", cartShareSnapshot.discountDetail, serializeDiscountDto);
        writer.writeObjectValue<FreeShippingEntitlement>("freeShipping", cartShareSnapshot.freeShipping, serializeFreeShippingEntitlement);
        writer.writeNumberValue("itemCount", cartShareSnapshot.itemCount);
        writer.writeCollectionOfObjectValues<CartShareLine>("lines", cartShareSnapshot.lines, serializeCartShareLine);
        writer.writeStringValue("notes", cartShareSnapshot.notes);
        writer.writeStringValue("poNumber", cartShareSnapshot.poNumber);
        writer.writeNumberValue("shipping", cartShareSnapshot.shipping);
        writer.writeStringValue("shoppingCartId", cartShareSnapshot.shoppingCartId);
        writer.writeNumberValue("subtotal", cartShareSnapshot.subtotal);
        writer.writeNumberValue("tax", cartShareSnapshot.tax);
        writer.writeNumberValue("total", cartShareSnapshot.total);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartShareSnapshotRequest(writer: SerializationWriter, cartShareSnapshotRequest: Partial<CartShareSnapshotRequest> | undefined | null = {}) : void {
    if (cartShareSnapshotRequest) {
        writer.writeStringValue("appliedCode", cartShareSnapshotRequest.appliedCode);
        writer.writeCollectionOfObjectValues<AppliedPromotion>("appliedPromotions", cartShareSnapshotRequest.appliedPromotions, serializeAppliedPromotion);
        writer.writeStringValue("companyName", cartShareSnapshotRequest.companyName);
        writer.writeStringValue("currencyCode", cartShareSnapshotRequest.currencyCode);
        writer.writeStringValue("customerNumber", cartShareSnapshotRequest.customerNumber);
        writer.writeNumberValue("discount", cartShareSnapshotRequest.discount);
        writer.writeObjectValue<DiscountDto>("discountDetail", cartShareSnapshotRequest.discountDetail, serializeDiscountDto);
        writer.writeObjectValue<FreeShippingEntitlement>("freeShipping", cartShareSnapshotRequest.freeShipping, serializeFreeShippingEntitlement);
        writer.writeCollectionOfObjectValues<CartShareLineRequest>("lines", cartShareSnapshotRequest.lines, serializeCartShareLineRequest);
        writer.writeStringValue("notes", cartShareSnapshotRequest.notes);
        writer.writeStringValue("poNumber", cartShareSnapshotRequest.poNumber);
        writer.writeNumberValue("shipping", cartShareSnapshotRequest.shipping);
        writer.writeStringValue("shoppingCartId", cartShareSnapshotRequest.shoppingCartId);
        writer.writeNumberValue("subtotal", cartShareSnapshotRequest.subtotal);
        writer.writeNumberValue("tax", cartShareSnapshotRequest.tax);
        writer.writeNumberValue("total", cartShareSnapshotRequest.total);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCartsPageSummary(writer: SerializationWriter, cartsPageSummary: Partial<CartsPageSummary> | undefined | null = {}) : void {
    if (cartsPageSummary) {
        writer.writeDateValue("asOf", cartsPageSummary.asOf);
        writer.writeNumberValue("checkedOutLast30Days", cartsPageSummary.checkedOutLast30Days);
        writer.writeNumberValue("conversionGoal", cartsPageSummary.conversionGoal);
        writer.writeNumberValue("conversionRate", cartsPageSummary.conversionRate);
        writer.writeNumberValue("openCarts", cartsPageSummary.openCarts);
        writer.writeNumberValue("openValue", cartsPageSummary.openValue);
        writer.writeNumberValue("overFourteenDays", cartsPageSummary.overFourteenDays);
        writer.writeNumberValue("overFourteenDaysValue", cartsPageSummary.overFourteenDaysValue);
        writer.writeNumberValue("sevenToFourteenDays", cartsPageSummary.sevenToFourteenDays);
        writer.writeNumberValue("stillOpenFromLast30Days", cartsPageSummary.stillOpenFromLast30Days);
        writer.writeNumberValue("underSevenDays", cartsPageSummary.underSevenDays);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCatalogItem(writer: SerializationWriter, catalogItem: Partial<CatalogItem> | undefined | null = {}) : void {
    if (catalogItem) {
        writer.writeCollectionOfPrimitiveValues<string>("applicableItemIds", catalogItem.applicableItemIds);
        writer.writeStringValue("description", catalogItem.description);
        writer.writeStringValue("id", catalogItem.id);
        writer.writeStringValue("name", catalogItem.name);
        writer.writeCollectionOfObjectValues<CatalogItemPrice>("prices", catalogItem.prices, serializeCatalogItemPrice);
        writer.writeStringValue("type", catalogItem.type);
        writer.writeStringValue("unit", catalogItem.unit);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCatalogItemPrice(writer: SerializationWriter, catalogItemPrice: Partial<CatalogItemPrice> | undefined | null = {}) : void {
    if (catalogItemPrice) {
        writer.writeStringValue("currencyCode", catalogItemPrice.currencyCode);
        writer.writeStringValue("id", catalogItemPrice.id);
        writer.writeStringValue("name", catalogItemPrice.name);
        writer.writeNumberValue("period", catalogItemPrice.period);
        writer.writeStringValue("periodUnit", catalogItemPrice.periodUnit);
        writer.writeNumberValue("price", catalogItemPrice.price);
        writer.writeStringValue("pricingModel", catalogItemPrice.pricingModel);
        writer.writeObjectValue<QuantityLimits>("quantityLimits", catalogItemPrice.quantityLimits, serializeQuantityLimits);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCategory(writer: SerializationWriter, category: Partial<Category> | undefined | null = {}) : void {
    if (category) {
        serializeBaseEntity(writer, category)
        writer.writeStringValue("breadcrumb", category.breadcrumb);
        writer.writeStringValue("categoryId", category.categoryId);
        writer.writeDateValue("imageUpdatedAt", category.imageUpdatedAt);
        writer.writeStringValue("name", category.name);
        writer.writeStringValue("organizationId", category.organizationId);
        writer.writeNumberValue("sortOrder", category.sortOrder);
        writer.writeCollectionOfObjectValues<Category>("subCategories", category.subCategories, serializeCategory);
        writer.writeAdditionalData(category.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCategoryDto(writer: SerializationWriter, categoryDto: Partial<CategoryDto> | undefined | null = {}) : void {
    if (categoryDto) {
        serializeCategory(writer, categoryDto)
        writer.writeStringValue("imageUrl", categoryDto.imageUrl);
        writer.writeAdditionalData(categoryDto.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCategoryRevenueRanking(writer: SerializationWriter, categoryRevenueRanking: Partial<CategoryRevenueRanking> | undefined | null = {}) : void {
    if (categoryRevenueRanking) {
        writer.writeStringValue("category", categoryRevenueRanking.category);
        writer.writeNumberValue("orderCount", categoryRevenueRanking.orderCount);
        writer.writeNumberValue("productCount", categoryRevenueRanking.productCount);
        writer.writeNumberValue("totalRevenue", categoryRevenueRanking.totalRevenue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChangeTaskStatusRequest(writer: SerializationWriter, changeTaskStatusRequest: Partial<ChangeTaskStatusRequest> | undefined | null = {}) : void {
    if (changeTaskStatusRequest) {
        writer.writeStringValue("completedByName", changeTaskStatusRequest.completedByName);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", changeTaskStatusRequest.orgCodes);
        writer.writeEnumValue<TaskItemStatus>("status", changeTaskStatusRequest.status);
        writer.writeStringValue("useOrganizationId", changeTaskStatusRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChannelTrendPoint(writer: SerializationWriter, channelTrendPoint: Partial<ChannelTrendPoint> | undefined | null = {}) : void {
    if (channelTrendPoint) {
        writer.writeNumberValue("otherOrders", channelTrendPoint.otherOrders);
        writer.writeStringValue("periodStart", channelTrendPoint.periodStart);
        writer.writeNumberValue("repAssistedOrders", channelTrendPoint.repAssistedOrders);
        writer.writeNumberValue("salesAppOrders", channelTrendPoint.salesAppOrders);
        writer.writeNumberValue("storefrontOrders", channelTrendPoint.storefrontOrders);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCheckAccessRequestExistsResponse(writer: SerializationWriter, checkAccessRequestExistsResponse: Partial<CheckAccessRequestExistsResponse> | undefined | null = {}) : void {
    if (checkAccessRequestExistsResponse) {
        writer.writeBooleanValue("exists", checkAccessRequestExistsResponse.exists);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCheckInSalesRepDeviceRequest(writer: SerializationWriter, checkInSalesRepDeviceRequest: Partial<CheckInSalesRepDeviceRequest> | undefined | null = {}) : void {
    if (checkInSalesRepDeviceRequest) {
        writer.writeStringValue("appVersion", checkInSalesRepDeviceRequest.appVersion);
        writer.writeStringValue("appVersionHeader", checkInSalesRepDeviceRequest.appVersionHeader);
        writer.writeStringValue("buildNumber", checkInSalesRepDeviceRequest.buildNumber);
        writer.writeStringValue("deviceId", checkInSalesRepDeviceRequest.deviceId);
        writer.writeStringValue("deviceModel", checkInSalesRepDeviceRequest.deviceModel);
        writer.writeDateValue("lastLoginAt", checkInSalesRepDeviceRequest.lastLoginAt);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", checkInSalesRepDeviceRequest.orgCodes);
        writer.writeStringValue("osVersion", checkInSalesRepDeviceRequest.osVersion);
        writer.writeStringValue("useOrganizationId", checkInSalesRepDeviceRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCheckInSalesRepDeviceResponse(writer: SerializationWriter, checkInSalesRepDeviceResponse: Partial<CheckInSalesRepDeviceResponse> | undefined | null = {}) : void {
    if (checkInSalesRepDeviceResponse) {
        writer.writeStringValue("deviceId", checkInSalesRepDeviceResponse.deviceId);
        writer.writeDateValue("lastSeenAt", checkInSalesRepDeviceResponse.lastSeenAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCheckoutBillingAddress(writer: SerializationWriter, checkoutBillingAddress: Partial<CheckoutBillingAddress> | undefined | null = {}) : void {
    if (checkoutBillingAddress) {
        writer.writeStringValue("address1", checkoutBillingAddress.address1);
        writer.writeStringValue("address2", checkoutBillingAddress.address2);
        writer.writeStringValue("city", checkoutBillingAddress.city);
        writer.writeStringValue("country", checkoutBillingAddress.country);
        writer.writeStringValue("stateProvince", checkoutBillingAddress.stateProvince);
        writer.writeStringValue("zipPostalCode", checkoutBillingAddress.zipPostalCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCheckoutItem(writer: SerializationWriter, checkoutItem: Partial<CheckoutItem> | undefined | null = {}) : void {
    if (checkoutItem) {
        writer.writeStringValue("lookupKey", checkoutItem.lookupKey);
        writer.writeNumberValue("quantity", checkoutItem.quantity);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCheckoutPageResponse(writer: SerializationWriter, checkoutPageResponse: Partial<CheckoutPageResponse> | undefined | null = {}) : void {
    if (checkoutPageResponse) {
        writer.writeNumberValue("createdAt", checkoutPageResponse.createdAt);
        writer.writeBooleanValue("embed", checkoutPageResponse.embed);
        writer.writeNumberValue("expiresAt", checkoutPageResponse.expiresAt);
        writer.writeStringValue("id", checkoutPageResponse.id);
        writer.writeStringValue("state", checkoutPageResponse.state);
        writer.writeStringValue("type", checkoutPageResponse.type);
        writer.writeStringValue("url", checkoutPageResponse.url);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCodeCampaignSummary(writer: SerializationWriter, codeCampaignSummary: Partial<CodeCampaignSummary> | undefined | null = {}) : void {
    if (codeCampaignSummary) {
        writer.writeStringValue("campaignId", codeCampaignSummary.campaignId);
        writer.writeStringValue("description", codeCampaignSummary.description);
        writer.writeStringValue("name", codeCampaignSummary.name);
        writer.writeDateValue("validTo", codeCampaignSummary.validTo);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeColumnMappingSuggestion(writer: SerializationWriter, columnMappingSuggestion: Partial<ColumnMappingSuggestion> | undefined | null = {}) : void {
    if (columnMappingSuggestion) {
        writer.writeCollectionOfObjectValues<MappingAlternate>("alternates", columnMappingSuggestion.alternates, serializeMappingAlternate);
        writer.writeNumberValue("confidence", columnMappingSuggestion.confidence);
        writer.writeObjectValue<MappingCreateProposal>("create", columnMappingSuggestion.create, serializeMappingCreateProposal);
        writer.writeStringValue("header", columnMappingSuggestion.header);
        writer.writeStringValue("suggested", columnMappingSuggestion.suggested);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCommissionEntryDto(writer: SerializationWriter, commissionEntryDto: Partial<CommissionEntryDto> | undefined | null = {}) : void {
    if (commissionEntryDto) {
        writer.writeNumberValue("amountPaid", commissionEntryDto.amountPaid);
        writer.writeStringValue("currencyCode", commissionEntryDto.currencyCode);
        writer.writeStringValue("customerNumber", commissionEntryDto.customerNumber);
        writer.writeStringValue("entryId", commissionEntryDto.entryId);
        writer.writeDateValue("invoiceDate", commissionEntryDto.invoiceDate);
        writer.writeStringValue("invoiceId", commissionEntryDto.invoiceId);
        writer.writeStringValue("invoiceNumber", commissionEntryDto.invoiceNumber);
        writer.writeNumberValue("invoiceTotal", commissionEntryDto.invoiceTotal);
        writer.writeCollectionOfObjectValues<CommissionLineEntryDto>("lines", commissionEntryDto.lines, serializeCommissionLineEntryDto);
        writer.writeNumberValue("percentagePaid", commissionEntryDto.percentagePaid);
        writer.writeNumberValue("subtotal", commissionEntryDto.subtotal);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCommissionLineEntryDto(writer: SerializationWriter, commissionLineEntryDto: Partial<CommissionLineEntryDto> | undefined | null = {}) : void {
    if (commissionLineEntryDto) {
        writer.writeNumberValue("adjustedCommission", commissionLineEntryDto.adjustedCommission);
        writer.writeNumberValue("appliedPercentagePaid", commissionLineEntryDto.appliedPercentagePaid);
        writer.writeNumberValue("commissionDue", commissionLineEntryDto.commissionDue);
        writer.writeNumberValue("lineSubtotal", commissionLineEntryDto.lineSubtotal);
        writer.writeStringValue("productName", commissionLineEntryDto.productName);
        writer.writeNumberValue("quantity", commissionLineEntryDto.quantity);
        writer.writeNumberValue("rate", commissionLineEntryDto.rate);
        writer.writeStringValue("ruleAppliedId", commissionLineEntryDto.ruleAppliedId);
        writer.writeStringValue("sku", commissionLineEntryDto.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCommissionPlanDto(writer: SerializationWriter, commissionPlanDto: Partial<CommissionPlanDto> | undefined | null = {}) : void {
    if (commissionPlanDto) {
        writer.writeBooleanValue("active", commissionPlanDto.active);
        writer.writeStringValue("commissionPlanId", commissionPlanDto.commissionPlanId);
        writer.writeDateValue("createdAt", commissionPlanDto.createdAt);
        writer.writeCollectionOfObjectValues<CustomerOverrideDto>("customerOverrides", commissionPlanDto.customerOverrides, serializeCustomerOverrideDto);
        writer.writeNumberValue("defaultRate", commissionPlanDto.defaultRate);
        writer.writeStringValue("description", commissionPlanDto.description);
        writer.writeDateValue("effectiveEndDate", commissionPlanDto.effectiveEndDate);
        writer.writeDateValue("effectiveStartDate", commissionPlanDto.effectiveStartDate);
        writer.writeStringValue("name", commissionPlanDto.name);
        writer.writeStringValue("organizationId", commissionPlanDto.organizationId);
        writer.writeCollectionOfObjectValues<CommissionRuleDto>("rules", commissionPlanDto.rules, serializeCommissionRuleDto);
        writer.writeStringValue("salesRepId", commissionPlanDto.salesRepId);
        writer.writeDateValue("updatedAt", commissionPlanDto.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCommissionRuleDto(writer: SerializationWriter, commissionRuleDto: Partial<CommissionRuleDto> | undefined | null = {}) : void {
    if (commissionRuleDto) {
        writer.writeObjectValue<CommissionRuleMatchDto>("match", commissionRuleDto.match, serializeCommissionRuleMatchDto);
        writer.writeStringValue("name", commissionRuleDto.name);
        writer.writeNumberValue("priority", commissionRuleDto.priority);
        writer.writeNumberValue("rate", commissionRuleDto.rate);
        writer.writeStringValue("ruleId", commissionRuleDto.ruleId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCommissionRuleMatchDto(writer: SerializationWriter, commissionRuleMatchDto: Partial<CommissionRuleMatchDto> | undefined | null = {}) : void {
    if (commissionRuleMatchDto) {
        writer.writeCollectionOfPrimitiveValues<string>("customerNumbers", commissionRuleMatchDto.customerNumbers);
        writer.writeNumberValue("maxLineAmount", commissionRuleMatchDto.maxLineAmount);
        writer.writeNumberValue("minLineAmount", commissionRuleMatchDto.minLineAmount);
        writer.writeCollectionOfPrimitiveValues<string>("productNamePatterns", commissionRuleMatchDto.productNamePatterns);
        writer.writeCollectionOfPrimitiveValues<string>("skuPatterns", commissionRuleMatchDto.skuPatterns);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCommissionStatementDto(writer: SerializationWriter, commissionStatementDto: Partial<CommissionStatementDto> | undefined | null = {}) : void {
    if (commissionStatementDto) {
        writer.writeBooleanValue("active", commissionStatementDto.active);
        writer.writeStringValue("commissionPlanId", commissionStatementDto.commissionPlanId);
        writer.writeStringValue("commissionStatementId", commissionStatementDto.commissionStatementId);
        writer.writeDateValue("createdAt", commissionStatementDto.createdAt);
        writer.writeDateValue("endDate", commissionStatementDto.endDate);
        writer.writeCollectionOfObjectValues<CommissionEntryDto>("entries", commissionStatementDto.entries, serializeCommissionEntryDto);
        writer.writeCollectionOfObjectValues<StatementEventDto>("history", commissionStatementDto.history, serializeStatementEventDto);
        writer.writeStringValue("organizationId", commissionStatementDto.organizationId);
        writer.writeStringValue("paymentReference", commissionStatementDto.paymentReference);
        writer.writeStringValue("salesRepId", commissionStatementDto.salesRepId);
        writer.writeDateValue("startDate", commissionStatementDto.startDate);
        writer.writeStringValue("status", commissionStatementDto.status);
        writer.writeNumberValue("subtotal", commissionStatementDto.subtotal);
        writer.writeNumberValue("tax", commissionStatementDto.tax);
        writer.writeCollectionOfObjectValues<CommissionTaxItemDto>("taxItems", commissionStatementDto.taxItems, serializeCommissionTaxItemDto);
        writer.writeNumberValue("total", commissionStatementDto.total);
        writer.writeDateValue("updatedAt", commissionStatementDto.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCommissionTaxItemDto(writer: SerializationWriter, commissionTaxItemDto: Partial<CommissionTaxItemDto> | undefined | null = {}) : void {
    if (commissionTaxItemDto) {
        writer.writeNumberValue("amount", commissionTaxItemDto.amount);
        writer.writeNumberValue("ratePercent", commissionTaxItemDto.ratePercent);
        writer.writeStringValue("taxName", commissionTaxItemDto.taxName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCompanyDocumentDto(writer: SerializationWriter, companyDocumentDto: Partial<CompanyDocumentDto> | undefined | null = {}) : void {
    if (companyDocumentDto) {
        writer.writeStringValue("cdnUrl", companyDocumentDto.cdnUrl);
        writer.writeDateValue("createdAt", companyDocumentDto.createdAt);
        writer.writeStringValue("documentId", companyDocumentDto.documentId);
        writer.writeStringValue("externalId", companyDocumentDto.externalId);
        writer.writeStringValue("fileExtension", companyDocumentDto.fileExtension);
        writer.writeStringValue("folderId", companyDocumentDto.folderId);
        writer.writeStringValue("mimeType", companyDocumentDto.mimeType);
        writer.writeStringValue("name", companyDocumentDto.name);
        writer.writeStringValue("organizationId", companyDocumentDto.organizationId);
        writer.writeStringValue("path", companyDocumentDto.path);
        writer.writeNumberValue("size", companyDocumentDto.size);
        writer.writeDateValue("updatedAt", companyDocumentDto.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCompanyFolderDto(writer: SerializationWriter, companyFolderDto: Partial<CompanyFolderDto> | undefined | null = {}) : void {
    if (companyFolderDto) {
        writer.writeDateValue("createdAt", companyFolderDto.createdAt);
        writer.writeStringValue("externalId", companyFolderDto.externalId);
        writer.writeStringValue("folderId", companyFolderDto.folderId);
        writer.writeStringValue("name", companyFolderDto.name);
        writer.writeStringValue("organizationId", companyFolderDto.organizationId);
        writer.writeStringValue("parentId", companyFolderDto.parentId);
        writer.writeStringValue("path", companyFolderDto.path);
        writer.writeDateValue("updatedAt", companyFolderDto.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCompleteCheckoutRequest(writer: SerializationWriter, completeCheckoutRequest: Partial<CompleteCheckoutRequest> | undefined | null = {}) : void {
    if (completeCheckoutRequest) {
        writer.writeStringValue("channel", completeCheckoutRequest.channel);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", completeCheckoutRequest.orgCodes);
        writer.writeObjectValue<Payment2>("payment", completeCheckoutRequest.payment, serializePayment2);
        writer.writeStringValue("paymentProfileId", completeCheckoutRequest.paymentProfileId);
        writer.writeStringValue("useOrganizationId", completeCheckoutRequest.useOrganizationId);
        writer.writeEnumValue<UserTypes>("userType", completeCheckoutRequest.userType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCompleteCheckoutResponse(writer: SerializationWriter, completeCheckoutResponse: Partial<CompleteCheckoutResponse> | undefined | null = {}) : void {
    if (completeCheckoutResponse) {
        writer.writeStringValue("confirmationId", completeCheckoutResponse.confirmationId);
        writer.writeStringValue("orderNumber", completeCheckoutResponse.orderNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCompletePaymentRequest(writer: SerializationWriter, completePaymentRequest: Partial<CompletePaymentRequest> | undefined | null = {}) : void {
    if (completePaymentRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", completePaymentRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", completePaymentRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConfigResponse(writer: SerializationWriter, configResponse: Partial<ConfigResponse> | undefined | null = {}) : void {
    if (configResponse) {
        writer.writeStringValue("mapsApiKey", configResponse.mapsApiKey);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConfigurationField(writer: SerializationWriter, configurationField: Partial<ConfigurationField> | undefined | null = {}) : void {
    if (configurationField) {
        writer.writeStringValue("defaultValue", configurationField.defaultValue);
        writer.writeStringValue("description", configurationField.description);
        writer.writeStringValue("displayName", configurationField.displayName);
        writer.writeStringValue("key", configurationField.key);
        writer.writeStringValue("placeholderText", configurationField.placeholderText);
        writer.writeBooleanValue("required", configurationField.required);
        writer.writeEnumValue<FieldType>("type", configurationField.type);
        writer.writeStringValue("validationPattern", configurationField.validationPattern);
        writer.writeCollectionOfPrimitiveValues<string>("validValues", configurationField.validValues);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConnectIntegrationRequest(writer: SerializationWriter, connectIntegrationRequest: Partial<ConnectIntegrationRequest> | undefined | null = {}) : void {
    if (connectIntegrationRequest) {
        writer.writeStringValue("state", connectIntegrationRequest.state);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConnectIntegrationResponse(writer: SerializationWriter, connectIntegrationResponse: Partial<ConnectIntegrationResponse> | undefined | null = {}) : void {
    if (connectIntegrationResponse) {
        writer.writeStringValue("authorizationUrl", connectIntegrationResponse.authorizationUrl);
        writer.writeDateValue("expiresAt", connectIntegrationResponse.expiresAt);
        writer.writeStringValue("integrationId", connectIntegrationResponse.integrationId);
        writer.writeEnumValue<IntegrationType>("integrationType", connectIntegrationResponse.integrationType);
        writer.writeStringValue("provider", connectIntegrationResponse.provider);
        writer.writeStringValue("state", connectIntegrationResponse.state);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConnectorEndpointDto(writer: SerializationWriter, connectorEndpointDto: Partial<ConnectorEndpointDto> | undefined | null = {}) : void {
    if (connectorEndpointDto) {
        writer.writeStringValue("apiPath", connectorEndpointDto.apiPath);
        writer.writeStringValue("dataMappingApiId", connectorEndpointDto.dataMappingApiId);
        writer.writeStringValue("endpointType", connectorEndpointDto.endpointType);
        writer.writeCollectionOfObjectValues<ConnectorFieldMappingDto>("fieldMappings", connectorEndpointDto.fieldMappings, serializeConnectorFieldMappingDto);
        writer.writeStringValue("id", connectorEndpointDto.id);
        writer.writeBooleanValue("isEnabled", connectorEndpointDto.isEnabled);
        writer.writeStringValue("name", connectorEndpointDto.name);
        writer.writeObjectValue<ConnectorScheduleDto>("schedule", connectorEndpointDto.schedule, serializeConnectorScheduleDto);
        writer.writeStringValue("sqlQuery", connectorEndpointDto.sqlQuery);
        writer.writeStringValue("syncMode", connectorEndpointDto.syncMode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConnectorEndpointsDocument(writer: SerializationWriter, connectorEndpointsDocument: Partial<ConnectorEndpointsDocument> | undefined | null = {}) : void {
    if (connectorEndpointsDocument) {
        writer.writeStringValue("connectorId", connectorEndpointsDocument.connectorId);
        writer.writeCollectionOfObjectValues<ConnectorEndpointDto>("endpoints", connectorEndpointsDocument.endpoints, serializeConnectorEndpointDto);
        writer.writeStringValue("id", connectorEndpointsDocument.id);
        writer.writeStringValue("organizationId", connectorEndpointsDocument.organizationId);
        writer.writeDateValue("pushedAt", connectorEndpointsDocument.pushedAt);
        writer.writeDateValue("updatedAt", connectorEndpointsDocument.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConnectorFieldMappingDto(writer: SerializationWriter, connectorFieldMappingDto: Partial<ConnectorFieldMappingDto> | undefined | null = {}) : void {
    if (connectorFieldMappingDto) {
        writer.writeStringValue("defaultValue", connectorFieldMappingDto.defaultValue);
        writer.writeBooleanValue("isRequired", connectorFieldMappingDto.isRequired);
        writer.writeStringValue("sourceColumn", connectorFieldMappingDto.sourceColumn);
        writer.writeStringValue("targetField", connectorFieldMappingDto.targetField);
        writer.writeStringValue("transformation", connectorFieldMappingDto.transformation);
        writer.writeStringValue("transformationParameter", connectorFieldMappingDto.transformationParameter);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConnectorScheduleDto(writer: SerializationWriter, connectorScheduleDto: Partial<ConnectorScheduleDto> | undefined | null = {}) : void {
    if (connectorScheduleDto) {
        writer.writeStringValue("cronExpression", connectorScheduleDto.cronExpression);
        writer.writeNumberValue("intervalMinutes", connectorScheduleDto.intervalMinutes);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContact(writer: SerializationWriter, contact: Partial<Contact> | undefined | null = {}) : void {
    if (contact) {
        writer.writeStringValue("contactId", contact.contactId);
        writer.writeEnumValue<ContactType>("contactType", contact.contactType);
        writer.writeBooleanValue("default", contact.defaultEscaped);
        writer.writeStringValue("emailAddress", contact.emailAddress);
        writer.writeStringValue("externalId", contact.externalId);
        writer.writeStringValue("fax", contact.fax);
        writer.writeStringValue("firstName", contact.firstName);
        writer.writeStringValue("fullName", contact.fullName);
        writer.writeStringValue("lastName", contact.lastName);
        writer.writeStringValue("phone", contact.phone);
        writer.writeStringValue("title", contact.title);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContactListItemDto(writer: SerializationWriter, contactListItemDto: Partial<ContactListItemDto> | undefined | null = {}) : void {
    if (contactListItemDto) {
        writer.writeStringValue("companyName", contactListItemDto.companyName);
        writer.writeStringValue("contactId", contactListItemDto.contactId);
        writer.writeEnumValue<ContactType>("contactType", contactListItemDto.contactType);
        writer.writeBooleanValue("customerActive", contactListItemDto.customerActive);
        writer.writeStringValue("customerId", contactListItemDto.customerId);
        writer.writeStringValue("customerNumber", contactListItemDto.customerNumber);
        writer.writeBooleanValue("default", contactListItemDto.defaultEscaped);
        writer.writeStringValue("emailAddress", contactListItemDto.emailAddress);
        writer.writeStringValue("externalId", contactListItemDto.externalId);
        writer.writeStringValue("fax", contactListItemDto.fax);
        writer.writeStringValue("firstName", contactListItemDto.firstName);
        writer.writeStringValue("fullName", contactListItemDto.fullName);
        writer.writeStringValue("lastName", contactListItemDto.lastName);
        writer.writeStringValue("phone", contactListItemDto.phone);
        writer.writeStringValue("title", contactListItemDto.title);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContent(writer: SerializationWriter, content: Partial<Content> | undefined | null = {}) : void {
    if (content) {
        writer.writeObjectValue<SubscriptionCreatedCustomer>("customer", content.customer, serializeSubscriptionCreatedCustomer);
        writer.writeObjectValue<Subscription>("subscription", content.subscription, serializeSubscription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateAccessRequestRequest(writer: SerializationWriter, createAccessRequestRequest: Partial<CreateAccessRequestRequest> | undefined | null = {}) : void {
    if (createAccessRequestRequest) {
        writer.writeStringValue("address1", createAccessRequestRequest.address1);
        writer.writeStringValue("address2", createAccessRequestRequest.address2);
        writer.writeStringValue("city", createAccessRequestRequest.city);
        writer.writeStringValue("companyEmail", createAccessRequestRequest.companyEmail);
        writer.writeStringValue("companyName", createAccessRequestRequest.companyName);
        writer.writeStringValue("country", createAccessRequestRequest.country);
        writer.writeStringValue("emailAddress", createAccessRequestRequest.emailAddress);
        writer.writeStringValue("firstName", createAccessRequestRequest.firstName);
        writer.writeStringValue("lastName", createAccessRequestRequest.lastName);
        writer.writeStringValue("phoneNumber", createAccessRequestRequest.phoneNumber);
        writer.writeStringValue("postalCode", createAccessRequestRequest.postalCode);
        writer.writeStringValue("stateProvince", createAccessRequestRequest.stateProvince);
        writer.writeStringValue("taxIdEIN", createAccessRequestRequest.taxIdEIN);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateAccessRequestResponse(writer: SerializationWriter, createAccessRequestResponse: Partial<CreateAccessRequestResponse> | undefined | null = {}) : void {
    if (createAccessRequestResponse) {
        writer.writeStringValue("accessRequestId", createAccessRequestResponse.accessRequestId);
        writer.writeStringValue("address1", createAccessRequestResponse.address1);
        writer.writeStringValue("address2", createAccessRequestResponse.address2);
        writer.writeStringValue("city", createAccessRequestResponse.city);
        writer.writeStringValue("companyEmail", createAccessRequestResponse.companyEmail);
        writer.writeStringValue("companyName", createAccessRequestResponse.companyName);
        writer.writeStringValue("country", createAccessRequestResponse.country);
        writer.writeDateValue("createdAt", createAccessRequestResponse.createdAt);
        writer.writeStringValue("emailAddress", createAccessRequestResponse.emailAddress);
        writer.writeStringValue("firstName", createAccessRequestResponse.firstName);
        writer.writeStringValue("lastName", createAccessRequestResponse.lastName);
        writer.writeStringValue("organizationId", createAccessRequestResponse.organizationId);
        writer.writeStringValue("phoneNumber", createAccessRequestResponse.phoneNumber);
        writer.writeStringValue("postalCode", createAccessRequestResponse.postalCode);
        writer.writeStringValue("stateProvince", createAccessRequestResponse.stateProvince);
        writer.writeStringValue("taxIdEIN", createAccessRequestResponse.taxIdEIN);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateApiAccessResponse(writer: SerializationWriter, createApiAccessResponse: Partial<CreateApiAccessResponse> | undefined | null = {}) : void {
    if (createApiAccessResponse) {
        writer.writeStringValue("apiKey", createApiAccessResponse.apiKey);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCartRequest(writer: SerializationWriter, createCartRequest: Partial<CreateCartRequest> | undefined | null = {}) : void {
    if (createCartRequest) {
        writer.writeStringValue("orderType", createCartRequest.orderType);
        writer.writeNumberValue("quantity", createCartRequest.quantity);
        writer.writeStringValue("sku", createCartRequest.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCategoryRequest(writer: SerializationWriter, createCategoryRequest: Partial<CreateCategoryRequest> | undefined | null = {}) : void {
    if (createCategoryRequest) {
        writer.writeStringValue("name", createCategoryRequest.name);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCategoryResponse(writer: SerializationWriter, createCategoryResponse: Partial<CreateCategoryResponse> | undefined | null = {}) : void {
    if (createCategoryResponse) {
        writer.writeStringValue("name", createCategoryResponse.name);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCheckoutRequest(writer: SerializationWriter, createCheckoutRequest: Partial<CreateCheckoutRequest> | undefined | null = {}) : void {
    if (createCheckoutRequest) {
        writer.writeCollectionOfObjectValues<CheckoutItem>("items", createCheckoutRequest.items, serializeCheckoutItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCheckoutResponse(writer: SerializationWriter, createCheckoutResponse: Partial<CreateCheckoutResponse> | undefined | null = {}) : void {
    if (createCheckoutResponse) {
        writer.writeStringValue("clientSecret", createCheckoutResponse.clientSecret);
        writer.writeStringValue("sessionId", createCheckoutResponse.sessionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCodeRequest(writer: SerializationWriter, createCodeRequest: Partial<CreateCodeRequest> | undefined | null = {}) : void {
    if (createCodeRequest) {
        writer.writeStringValue("code", createCodeRequest.code);
        writer.writeObjectValue<DiscountCodeOptionsInput>("options", createCodeRequest.options, serializeDiscountCodeOptionsInput);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCommissionPlanRequest(writer: SerializationWriter, createCommissionPlanRequest: Partial<CreateCommissionPlanRequest> | undefined | null = {}) : void {
    if (createCommissionPlanRequest) {
        writer.writeCollectionOfObjectValues<CreateCommissionPlanRequest_CustomerOverrideInput>("customerOverrides", createCommissionPlanRequest.customerOverrides, serializeCreateCommissionPlanRequest_CustomerOverrideInput);
        writer.writeNumberValue("defaultRate", createCommissionPlanRequest.defaultRate);
        writer.writeStringValue("description", createCommissionPlanRequest.description);
        writer.writeDateValue("effectiveEndDate", createCommissionPlanRequest.effectiveEndDate);
        writer.writeDateValue("effectiveStartDate", createCommissionPlanRequest.effectiveStartDate);
        writer.writeStringValue("name", createCommissionPlanRequest.name);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createCommissionPlanRequest.orgCodes);
        writer.writeCollectionOfObjectValues<CreateCommissionPlanRequest_RuleInput>("rules", createCommissionPlanRequest.rules, serializeCreateCommissionPlanRequest_RuleInput);
        writer.writeStringValue("salesRepId", createCommissionPlanRequest.salesRepId);
        writer.writeStringValue("useOrganizationId", createCommissionPlanRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCommissionPlanRequest_CustomerOverrideInput(writer: SerializationWriter, createCommissionPlanRequest_CustomerOverrideInput: Partial<CreateCommissionPlanRequest_CustomerOverrideInput> | undefined | null = {}) : void {
    if (createCommissionPlanRequest_CustomerOverrideInput) {
        writer.writeStringValue("customerNumber", createCommissionPlanRequest_CustomerOverrideInput.customerNumber);
        writer.writeNumberValue("defaultRate", createCommissionPlanRequest_CustomerOverrideInput.defaultRate);
        writer.writeDateValue("effectiveEndDate", createCommissionPlanRequest_CustomerOverrideInput.effectiveEndDate);
        writer.writeDateValue("effectiveStartDate", createCommissionPlanRequest_CustomerOverrideInput.effectiveStartDate);
        writer.writeCollectionOfObjectValues<CreateCommissionPlanRequest_RuleInput>("rules", createCommissionPlanRequest_CustomerOverrideInput.rules, serializeCreateCommissionPlanRequest_RuleInput);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCommissionPlanRequest_RuleInput(writer: SerializationWriter, createCommissionPlanRequest_RuleInput: Partial<CreateCommissionPlanRequest_RuleInput> | undefined | null = {}) : void {
    if (createCommissionPlanRequest_RuleInput) {
        writer.writeObjectValue<CreateCommissionPlanRequest_RuleMatchInput>("match", createCommissionPlanRequest_RuleInput.match, serializeCreateCommissionPlanRequest_RuleMatchInput);
        writer.writeStringValue("name", createCommissionPlanRequest_RuleInput.name);
        writer.writeNumberValue("priority", createCommissionPlanRequest_RuleInput.priority);
        writer.writeNumberValue("rate", createCommissionPlanRequest_RuleInput.rate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCommissionPlanRequest_RuleMatchInput(writer: SerializationWriter, createCommissionPlanRequest_RuleMatchInput: Partial<CreateCommissionPlanRequest_RuleMatchInput> | undefined | null = {}) : void {
    if (createCommissionPlanRequest_RuleMatchInput) {
        writer.writeCollectionOfPrimitiveValues<string>("customerNumbers", createCommissionPlanRequest_RuleMatchInput.customerNumbers);
        writer.writeNumberValue("maxLineAmount", createCommissionPlanRequest_RuleMatchInput.maxLineAmount);
        writer.writeNumberValue("minLineAmount", createCommissionPlanRequest_RuleMatchInput.minLineAmount);
        writer.writeCollectionOfPrimitiveValues<string>("productNamePatterns", createCommissionPlanRequest_RuleMatchInput.productNamePatterns);
        writer.writeCollectionOfPrimitiveValues<string>("skuPatterns", createCommissionPlanRequest_RuleMatchInput.skuPatterns);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCommissionStatementRequest(writer: SerializationWriter, createCommissionStatementRequest: Partial<CreateCommissionStatementRequest> | undefined | null = {}) : void {
    if (createCommissionStatementRequest) {
        writer.writeDateValue("endDate", createCommissionStatementRequest.endDate);
        writer.writeStringValue("generatedByUser", createCommissionStatementRequest.generatedByUser);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createCommissionStatementRequest.orgCodes);
        writer.writeStringValue("salesRepId", createCommissionStatementRequest.salesRepId);
        writer.writeDateValue("startDate", createCommissionStatementRequest.startDate);
        writer.writeCollectionOfObjectValues<CreateCommissionStatementRequest_TaxItemInput>("taxItems", createCommissionStatementRequest.taxItems, serializeCreateCommissionStatementRequest_TaxItemInput);
        writer.writeStringValue("useOrganizationId", createCommissionStatementRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCommissionStatementRequest_TaxItemInput(writer: SerializationWriter, createCommissionStatementRequest_TaxItemInput: Partial<CreateCommissionStatementRequest_TaxItemInput> | undefined | null = {}) : void {
    if (createCommissionStatementRequest_TaxItemInput) {
        writer.writeNumberValue("amount", createCommissionStatementRequest_TaxItemInput.amount);
        writer.writeNumberValue("ratePercent", createCommissionStatementRequest_TaxItemInput.ratePercent);
        writer.writeStringValue("taxName", createCommissionStatementRequest_TaxItemInput.taxName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCustomerNoteRequest(writer: SerializationWriter, createCustomerNoteRequest: Partial<CreateCustomerNoteRequest> | undefined | null = {}) : void {
    if (createCustomerNoteRequest) {
        writer.writeStringValue("authorName", createCustomerNoteRequest.authorName);
        writer.writeStringValue("body", createCustomerNoteRequest.body);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createCustomerNoteRequest.orgCodes);
        writer.writeStringValue("salesRepId", createCustomerNoteRequest.salesRepId);
        writer.writeStringValue("useOrganizationId", createCustomerNoteRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCustomerRequest(writer: SerializationWriter, createCustomerRequest: Partial<CreateCustomerRequest> | undefined | null = {}) : void {
    if (createCustomerRequest) {
        writer.writeBooleanValue("active", createCustomerRequest.active);
        writer.writeCollectionOfObjectValues<Address>("addresses", createCustomerRequest.addresses, serializeAddress);
        writer.writeStringValue("companyEmail", createCustomerRequest.companyEmail);
        writer.writeStringValue("companyFax", createCustomerRequest.companyFax);
        writer.writeStringValue("companyName", createCustomerRequest.companyName);
        writer.writeStringValue("companyPhone", createCustomerRequest.companyPhone);
        writer.writeCollectionOfObjectValues<Contact>("contacts", createCustomerRequest.contacts, serializeContact);
        writer.writeObjectValue<CreateCustomerRequest_customerAttributes>("customerAttributes", createCustomerRequest.customerAttributes, serializeCreateCustomerRequest_customerAttributes);
        writer.writeStringValue("customerNumber", createCustomerRequest.customerNumber);
        writer.writeStringValue("externalId", createCustomerRequest.externalId);
        writer.writeStringValue("fulfillmentMethod", createCustomerRequest.fulfillmentMethod);
        writer.writeStringValue("pricing", createCustomerRequest.pricing);
        writer.writeStringValue("repNumber", createCustomerRequest.repNumber);
        writer.writeStringValue("terms", createCustomerRequest.terms);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCustomerRequest_customerAttributes(writer: SerializationWriter, createCustomerRequest_customerAttributes: Partial<CreateCustomerRequest_customerAttributes> | undefined | null = {}) : void {
    if (createCustomerRequest_customerAttributes) {
        writer.writeAdditionalData(createCustomerRequest_customerAttributes.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateFavoriteListRequest(writer: SerializationWriter, createFavoriteListRequest: Partial<CreateFavoriteListRequest> | undefined | null = {}) : void {
    if (createFavoriteListRequest) {
        writer.writeBooleanValue("isDefault", createFavoriteListRequest.isDefault);
        writer.writeStringValue("name", createFavoriteListRequest.name);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createFavoriteListRequest.orgCodes);
        writer.writeStringValue("salesRepId", createFavoriteListRequest.salesRepId);
        writer.writeStringValue("source", createFavoriteListRequest.source);
        writer.writeStringValue("useOrganizationId", createFavoriteListRequest.useOrganizationId);
        writer.writeStringValue("userId", createFavoriteListRequest.userId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateFlipbookFromPdfResponse(writer: SerializationWriter, createFlipbookFromPdfResponse: Partial<CreateFlipbookFromPdfResponse> | undefined | null = {}) : void {
    if (createFlipbookFromPdfResponse) {
        writer.writeStringValue("flipbookId", createFlipbookFromPdfResponse.flipbookId);
        writer.writeNumberValue("pageCount", createFlipbookFromPdfResponse.pageCount);
        writer.writeCollectionOfObjectValues<PageInfo>("pages", createFlipbookFromPdfResponse.pages, serializePageInfo);
        writer.writeStringValue("title", createFlipbookFromPdfResponse.title);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateFolderRequest(writer: SerializationWriter, createFolderRequest: Partial<CreateFolderRequest> | undefined | null = {}) : void {
    if (createFolderRequest) {
        writer.writeStringValue("name", createFolderRequest.name);
        writer.writeStringValue("parentId", createFolderRequest.parentId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateIntegrationRequest(writer: SerializationWriter, createIntegrationRequest: Partial<CreateIntegrationRequest> | undefined | null = {}) : void {
    if (createIntegrationRequest) {
        writer.writeObjectValue<CreateIntegrationRequest_configuration>("configuration", createIntegrationRequest.configuration, serializeCreateIntegrationRequest_configuration);
        writer.writeStringValue("displayName", createIntegrationRequest.displayName);
        writer.writeEnumValue<IntegrationType>("integrationType", createIntegrationRequest.integrationType);
        writer.writeBooleanValue("isEnabled", createIntegrationRequest.isEnabled);
        writer.writeStringValue("provider", createIntegrationRequest.provider);
        writer.writeObjectValue<CreateIntegrationRequest_secrets>("secrets", createIntegrationRequest.secrets, serializeCreateIntegrationRequest_secrets);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateIntegrationRequest_configuration(writer: SerializationWriter, createIntegrationRequest_configuration: Partial<CreateIntegrationRequest_configuration> | undefined | null = {}) : void {
    if (createIntegrationRequest_configuration) {
        writer.writeAdditionalData(createIntegrationRequest_configuration.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateIntegrationRequest_secrets(writer: SerializationWriter, createIntegrationRequest_secrets: Partial<CreateIntegrationRequest_secrets> | undefined | null = {}) : void {
    if (createIntegrationRequest_secrets) {
        writer.writeAdditionalData(createIntegrationRequest_secrets.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateIntegrationResponse(writer: SerializationWriter, createIntegrationResponse: Partial<CreateIntegrationResponse> | undefined | null = {}) : void {
    if (createIntegrationResponse) {
        writer.writeDateValue("createdAt", createIntegrationResponse.createdAt);
        writer.writeStringValue("displayName", createIntegrationResponse.displayName);
        writer.writeStringValue("integrationId", createIntegrationResponse.integrationId);
        writer.writeEnumValue<IntegrationType>("integrationType", createIntegrationResponse.integrationType);
        writer.writeBooleanValue("isEnabled", createIntegrationResponse.isEnabled);
        writer.writeStringValue("organizationId", createIntegrationResponse.organizationId);
        writer.writeStringValue("provider", createIntegrationResponse.provider);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateInvoiceRequest(writer: SerializationWriter, createInvoiceRequest: Partial<CreateInvoiceRequest> | undefined | null = {}) : void {
    if (createInvoiceRequest) {
        writer.writeBooleanValue("active", createInvoiceRequest.active);
        writer.writeStringValue("currencyCode", createInvoiceRequest.currencyCode);
        writer.writeObjectValue<CustomerInput>("customer", createInvoiceRequest.customer, serializeCustomerInput);
        writer.writeObjectValue<DiscountInput>("discount", createInvoiceRequest.discount, serializeDiscountInput);
        writer.writeDateValue("dueDate", createInvoiceRequest.dueDate);
        writer.writeStringValue("fulfillmentCenter", createInvoiceRequest.fulfillmentCenter);
        writer.writeStringValue("fulfillmentMethod", createInvoiceRequest.fulfillmentMethod);
        writer.writeNumberValue("importedBalance", createInvoiceRequest.importedBalance);
        writer.writeNumberValue("importedInvoiceTotal", createInvoiceRequest.importedInvoiceTotal);
        writer.writeDateValue("invoiceDate", createInvoiceRequest.invoiceDate);
        writer.writeStringValue("invoiceNumber", createInvoiceRequest.invoiceNumber);
        writer.writeCollectionOfObjectValues<InvoiceItemInput>("items", createInvoiceRequest.items, serializeInvoiceItemInput);
        writer.writeStringValue("notes", createInvoiceRequest.notes);
        writer.writeNumberValue("numberOfPackages", createInvoiceRequest.numberOfPackages);
        writer.writeStringValue("orderId", createInvoiceRequest.orderId);
        writer.writeStringValue("orderNumber", createInvoiceRequest.orderNumber);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createInvoiceRequest.orgCodes);
        writer.writeStringValue("poNumber", createInvoiceRequest.poNumber);
        writer.writeObjectValue<SalesRepInput>("primarySalesRep", createInvoiceRequest.primarySalesRep, serializeSalesRepInput);
        writer.writeObjectValue<ShippingDetailsInput>("shippingDetails", createInvoiceRequest.shippingDetails, serializeShippingDetailsInput);
        writer.writeNumberValue("tax", createInvoiceRequest.tax);
        writer.writeStringValue("terms", createInvoiceRequest.terms);
        writer.writeStringValue("trackingNumber", createInvoiceRequest.trackingNumber);
        writer.writeStringValue("useOrganizationId", createInvoiceRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateManyCustomersRequest(writer: SerializationWriter, createManyCustomersRequest: Partial<CreateManyCustomersRequest> | undefined | null = {}) : void {
    if (createManyCustomersRequest) {
        writer.writeCollectionOfObjectValues<CreateCustomerRequest>("customers", createManyCustomersRequest.customers, serializeCreateCustomerRequest);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateManyInvoicesRequest(writer: SerializationWriter, createManyInvoicesRequest: Partial<CreateManyInvoicesRequest> | undefined | null = {}) : void {
    if (createManyInvoicesRequest) {
        writer.writeCollectionOfObjectValues<CreateInvoiceRequest>("invoices", createManyInvoicesRequest.invoices, serializeCreateInvoiceRequest);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createManyInvoicesRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", createManyInvoicesRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateManyOrdersRequest(writer: SerializationWriter, createManyOrdersRequest: Partial<CreateManyOrdersRequest> | undefined | null = {}) : void {
    if (createManyOrdersRequest) {
        writer.writeCollectionOfObjectValues<CreateOrderItemRequest>("orders", createManyOrdersRequest.orders, serializeCreateOrderItemRequest);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createManyOrdersRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", createManyOrdersRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateManyProductsRequest(writer: SerializationWriter, createManyProductsRequest: Partial<CreateManyProductsRequest> | undefined | null = {}) : void {
    if (createManyProductsRequest) {
        writer.writeBooleanValue("ignoreCategory", createManyProductsRequest.ignoreCategory);
        writer.writeCollectionOfObjectValues<CreateProductRequest>("products", createManyProductsRequest.products, serializeCreateProductRequest);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateOrderItemRequest(writer: SerializationWriter, createOrderItemRequest: Partial<CreateOrderItemRequest> | undefined | null = {}) : void {
    if (createOrderItemRequest) {
        writer.writeBooleanValue("active", createOrderItemRequest.active);
        writer.writeStringValue("channel", createOrderItemRequest.channel);
        writer.writeStringValue("currencyCode", createOrderItemRequest.currencyCode);
        writer.writeObjectValue<Customer2>("customer", createOrderItemRequest.customer, serializeCustomer2);
        writer.writeStringValue("externalId", createOrderItemRequest.externalId);
        writer.writeStringValue("fulfillmentCenter", createOrderItemRequest.fulfillmentCenter);
        writer.writeStringValue("fulfillmentMethod", createOrderItemRequest.fulfillmentMethod);
        writer.writeCollectionOfObjectValues<OrderItemInput>("items", createOrderItemRequest.items, serializeOrderItemInput);
        writer.writeStringValue("marketCode", createOrderItemRequest.marketCode);
        writer.writeStringValue("notes", createOrderItemRequest.notes);
        writer.writeDateValue("orderDate", createOrderItemRequest.orderDate);
        writer.writeStringValue("orderNumber", createOrderItemRequest.orderNumber);
        writer.writeStringValue("orderStatus", createOrderItemRequest.orderStatus);
        writer.writeStringValue("orderType", createOrderItemRequest.orderType);
        writer.writeStringValue("originationCartId", createOrderItemRequest.originationCartId);
        writer.writeStringValue("poNumber", createOrderItemRequest.poNumber);
        writer.writeStringValue("priceTier", createOrderItemRequest.priceTier);
        writer.writeObjectValue<SalesRep>("primarySalesRep", createOrderItemRequest.primarySalesRep, serializeSalesRep);
        writer.writeObjectValue<ShippingDetails>("shippingDetails", createOrderItemRequest.shippingDetails, serializeShippingDetails);
        writer.writeObjectValue<SalesRep>("takenBySalesRep", createOrderItemRequest.takenBySalesRep, serializeSalesRep);
        writer.writeNumberValue("tax", createOrderItemRequest.tax);
        writer.writeStringValue("terms", createOrderItemRequest.terms);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateOrganizationApiKeyRequest(writer: SerializationWriter, createOrganizationApiKeyRequest: Partial<CreateOrganizationApiKeyRequest> | undefined | null = {}) : void {
    if (createOrganizationApiKeyRequest) {
        writer.writeStringValue("name", createOrganizationApiKeyRequest.name);
        writer.writeStringValue("scope", createOrganizationApiKeyRequest.scope);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateOrganizationApiKeyResponse(writer: SerializationWriter, createOrganizationApiKeyResponse: Partial<CreateOrganizationApiKeyResponse> | undefined | null = {}) : void {
    if (createOrganizationApiKeyResponse) {
        writer.writeStringValue("apiKey", createOrganizationApiKeyResponse.apiKey);
        writer.writeStringValue("keyId", createOrganizationApiKeyResponse.keyId);
        writer.writeStringValue("scope", createOrganizationApiKeyResponse.scope);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateOrganizationRequest(writer: SerializationWriter, createOrganizationRequest: Partial<CreateOrganizationRequest> | undefined | null = {}) : void {
    if (createOrganizationRequest) {
        writer.writeObjectValue<Organization2>("organization", createOrganizationRequest.organization, serializeOrganization2);
        writer.writeObjectValue<User>("user", createOrganizationRequest.user, serializeUser);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateOrganizationResponse(writer: SerializationWriter, createOrganizationResponse: Partial<CreateOrganizationResponse> | undefined | null = {}) : void {
    if (createOrganizationResponse) {
        writer.writeStringValue("identityOrganizationId", createOrganizationResponse.identityOrganizationId);
        writer.writeStringValue("name", createOrganizationResponse.name);
        writer.writeStringValue("organizationId", createOrganizationResponse.organizationId);
        writer.writeStringValue("slug", createOrganizationResponse.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateOrUpdateDataMappingRequest(writer: SerializationWriter, createOrUpdateDataMappingRequest: Partial<CreateOrUpdateDataMappingRequest> | undefined | null = {}) : void {
    if (createOrUpdateDataMappingRequest) {
        writer.writeCollectionOfObjectValues<CreateOrUpdateDataMappingRequest_HeaderMappingField>("headerMappingFields", createOrUpdateDataMappingRequest.headerMappingFields, serializeCreateOrUpdateDataMappingRequest_HeaderMappingField);
        writer.writeStringValue("id", createOrUpdateDataMappingRequest.id);
        writer.writeBooleanValue("invertActiveProperty", createOrUpdateDataMappingRequest.invertActiveProperty);
        writer.writeStringValue("name", createOrUpdateDataMappingRequest.name);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateOrUpdateDataMappingRequest_HeaderMappingField(writer: SerializationWriter, createOrUpdateDataMappingRequest_HeaderMappingField: Partial<CreateOrUpdateDataMappingRequest_HeaderMappingField> | undefined | null = {}) : void {
    if (createOrUpdateDataMappingRequest_HeaderMappingField) {
        writer.writeStringValue("header", createOrUpdateDataMappingRequest_HeaderMappingField.header);
        writer.writeObjectValue<CreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping>("mapping", createOrUpdateDataMappingRequest_HeaderMappingField.mapping, serializeCreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping(writer: SerializationWriter, createOrUpdateDataMappingRequest_HeaderMappingField_Mapping: Partial<CreateOrUpdateDataMappingRequest_HeaderMappingField_Mapping> | undefined | null = {}) : void {
    if (createOrUpdateDataMappingRequest_HeaderMappingField_Mapping) {
        writer.writeStringValue("mappedHeaderName", createOrUpdateDataMappingRequest_HeaderMappingField_Mapping.mappedHeaderName);
        writer.writeStringValue("uploadedHeaderName", createOrUpdateDataMappingRequest_HeaderMappingField_Mapping.uploadedHeaderName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateProductRequest(writer: SerializationWriter, createProductRequest: Partial<CreateProductRequest> | undefined | null = {}) : void {
    if (createProductRequest) {
        writer.writeBooleanValue("active", createProductRequest.active);
        writer.writeStringValue("category", createProductRequest.category);
        writer.writeStringValue("description", createProductRequest.description);
        writer.writeStringValue("dimensions", createProductRequest.dimensions);
        writer.writeStringValue("dimensionsUnit", createProductRequest.dimensionsUnit);
        writer.writeStringValue("externalId", createProductRequest.externalId);
        writer.writeStringValue("familyDescription", createProductRequest.familyDescription);
        writer.writeStringValue("familyKey", createProductRequest.familyKey);
        writer.writeStringValue("familyName", createProductRequest.familyName);
        writer.writeStringValue("imageName", createProductRequest.imageName);
        writer.writeCollectionOfPrimitiveValues<string>("images", createProductRequest.images);
        writer.writeNumberValue("minimumOrderQuantity", createProductRequest.minimumOrderQuantity);
        writer.writeStringValue("name", createProductRequest.name);
        writer.writeObjectValue<CreateProductRequest_optionValues>("optionValues", createProductRequest.optionValues, serializeCreateProductRequest_optionValues);
        writer.writeNumberValue("price", createProductRequest.price);
        writer.writeCollectionOfObjectValues<CreateProductRequest_ProductPriceDto>("prices", createProductRequest.prices, serializeCreateProductRequest_ProductPriceDto);
        writer.writeObjectValue<CreateProductRequest_productAttributes>("productAttributes", createProductRequest.productAttributes, serializeCreateProductRequest_productAttributes);
        writer.writeNumberValue("quantityIncrement", createProductRequest.quantityIncrement);
        writer.writeNumberValue("quantityOnHand", createProductRequest.quantityOnHand);
        writer.writeBooleanValue("separateLines", createProductRequest.separateLines);
        writer.writeStringValue("sku", createProductRequest.sku);
        writer.writeStringValue("upc", createProductRequest.upc);
        writer.writeStringValue("vendorCode", createProductRequest.vendorCode);
        writer.writeNumberValue("weight", createProductRequest.weight);
        writer.writeStringValue("weightUnit", createProductRequest.weightUnit);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateProductRequest_optionValues(writer: SerializationWriter, createProductRequest_optionValues: Partial<CreateProductRequest_optionValues> | undefined | null = {}) : void {
    if (createProductRequest_optionValues) {
        writer.writeAdditionalData(createProductRequest_optionValues.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateProductRequest_productAttributes(writer: SerializationWriter, createProductRequest_productAttributes: Partial<CreateProductRequest_productAttributes> | undefined | null = {}) : void {
    if (createProductRequest_productAttributes) {
        writer.writeAdditionalData(createProductRequest_productAttributes.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateProductRequest_ProductPriceDto(writer: SerializationWriter, createProductRequest_ProductPriceDto: Partial<CreateProductRequest_ProductPriceDto> | undefined | null = {}) : void {
    if (createProductRequest_ProductPriceDto) {
        writer.writeNumberValue("atQuantity", createProductRequest_ProductPriceDto.atQuantity);
        writer.writeNumberValue("price", createProductRequest_ProductPriceDto.price);
        writer.writeStringValue("tier", createProductRequest_ProductPriceDto.tier);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateSalesRepRequest(writer: SerializationWriter, createSalesRepRequest: Partial<CreateSalesRepRequest> | undefined | null = {}) : void {
    if (createSalesRepRequest) {
        writer.writeStringValue("email", createSalesRepRequest.email);
        writer.writeStringValue("firstName", createSalesRepRequest.firstName);
        writer.writeStringValue("lastName", createSalesRepRequest.lastName);
        writer.writeStringValue("marketCode", createSalesRepRequest.marketCode);
        writer.writeStringValue("phoneNumber", createSalesRepRequest.phoneNumber);
        writer.writeStringValue("repNumber", createSalesRepRequest.repNumber);
        writer.writeCollectionOfPrimitiveValues<string>("repNumbers", createSalesRepRequest.repNumbers);
        writer.writeCollectionOfPrimitiveValues<string>("roles", createSalesRepRequest.roles);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateSalesRepResponse(writer: SerializationWriter, createSalesRepResponse: Partial<CreateSalesRepResponse> | undefined | null = {}) : void {
    if (createSalesRepResponse) {
        writer.writeStringValue("email", createSalesRepResponse.email);
        writer.writeStringValue("firstName", createSalesRepResponse.firstName);
        writer.writeStringValue("identityOrganizationId", createSalesRepResponse.identityOrganizationId);
        writer.writeStringValue("identityProvider", createSalesRepResponse.identityProvider);
        writer.writeStringValue("identityProviderUserId", createSalesRepResponse.identityProviderUserId);
        writer.writeStringValue("lastName", createSalesRepResponse.lastName);
        writer.writeStringValue("marketCode", createSalesRepResponse.marketCode);
        writer.writeStringValue("organizationId", createSalesRepResponse.organizationId);
        writer.writeStringValue("organizationName", createSalesRepResponse.organizationName);
        writer.writeStringValue("organizationSalesRepId", createSalesRepResponse.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", createSalesRepResponse.phoneNumber);
        writer.writeStringValue("repNumber", createSalesRepResponse.repNumber);
        writer.writeCollectionOfPrimitiveValues<string>("repNumbers", createSalesRepResponse.repNumbers);
        writer.writeStringValue("salesRepId", createSalesRepResponse.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateTaskRequest(writer: SerializationWriter, createTaskRequest: Partial<CreateTaskRequest> | undefined | null = {}) : void {
    if (createTaskRequest) {
        writer.writeStringValue("createdByName", createTaskRequest.createdByName);
        writer.writeStringValue("customerNumber", createTaskRequest.customerNumber);
        writer.writeStringValue("description", createTaskRequest.description);
        writer.writeDateValue("dueAt", createTaskRequest.dueAt);
        writer.writeStringValue("dueTimeZoneId", createTaskRequest.dueTimeZoneId);
        writer.writeStringValue("organizationSalesRepId", createTaskRequest.organizationSalesRepId);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createTaskRequest.orgCodes);
        writer.writeEnumValue<TaskPriority>("priority", createTaskRequest.priority);
        writer.writeStringValue("title", createTaskRequest.title);
        writer.writeStringValue("useOrganizationId", createTaskRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateTransactionSetupRequest(writer: SerializationWriter, createTransactionSetupRequest: Partial<CreateTransactionSetupRequest> | undefined | null = {}) : void {
    if (createTransactionSetupRequest) {
        writer.writeStringValue("applicationReturnUrl", createTransactionSetupRequest.applicationReturnUrl);
        writer.writeStringValue("customerNumber", createTransactionSetupRequest.customerNumber);
        writer.writeBooleanValue("isDefault", createTransactionSetupRequest.isDefault);
        writer.writeStringValue("marketCode", createTransactionSetupRequest.marketCode);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", createTransactionSetupRequest.orgCodes);
        writer.writeNumberValue("transactionAmount", createTransactionSetupRequest.transactionAmount);
        writer.writeStringValue("useOrganizationId", createTransactionSetupRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateTransactionSetupResponse(writer: SerializationWriter, createTransactionSetupResponse: Partial<CreateTransactionSetupResponse> | undefined | null = {}) : void {
    if (createTransactionSetupResponse) {
        writer.writeStringValue("hostedPaymentUrl", createTransactionSetupResponse.hostedPaymentUrl);
        writer.writeStringValue("transactionSetupId", createTransactionSetupResponse.transactionSetupId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateUserRequest(writer: SerializationWriter, createUserRequest: Partial<CreateUserRequest> | undefined | null = {}) : void {
    if (createUserRequest) {
        writer.writeStringValue("email", createUserRequest.email);
        writer.writeStringValue("firstName", createUserRequest.firstName);
        writer.writeStringValue("identityOrganizationId", createUserRequest.identityOrganizationId);
        writer.writeStringValue("lastName", createUserRequest.lastName);
        writer.writeStringValue("phoneNumber", createUserRequest.phoneNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateUserResponse(writer: SerializationWriter, createUserResponse: Partial<CreateUserResponse> | undefined | null = {}) : void {
    if (createUserResponse) {
        writer.writeStringValue("email", createUserResponse.email);
        writer.writeStringValue("firstName", createUserResponse.firstName);
        writer.writeStringValue("lastName", createUserResponse.lastName);
        writer.writeStringValue("phoneNumber", createUserResponse.phoneNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateVendorRequest(writer: SerializationWriter, createVendorRequest: Partial<CreateVendorRequest> | undefined | null = {}) : void {
    if (createVendorRequest) {
        serializeVendorFieldsRequest(writer, createVendorRequest)
        writer.writeStringValue("vendorCode", createVendorRequest.vendorCode);
        writer.writeAdditionalData(createVendorRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateWebsiteApiKeyResponse(writer: SerializationWriter, createWebsiteApiKeyResponse: Partial<CreateWebsiteApiKeyResponse> | undefined | null = {}) : void {
    if (createWebsiteApiKeyResponse) {
        writer.writeStringValue("apiKey", createWebsiteApiKeyResponse.apiKey);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreditCard(writer: SerializationWriter, creditCard: Partial<CreditCard> | undefined | null = {}) : void {
    if (creditCard) {
        writer.writeStringValue("cardholderName", creditCard.cardholderName);
        writer.writeStringValue("cardNumber", creditCard.cardNumber);
        writer.writeStringValue("cvv", creditCard.cvv);
        writer.writeStringValue("expiryMonth", creditCard.expiryMonth);
        writer.writeNumberValue("expiryYear", creditCard.expiryYear);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomer(writer: SerializationWriter, customer: Partial<Customer> | undefined | null = {}) : void {
    if (customer) {
        serializeBaseEntity(writer, customer)
        writer.writeCollectionOfObjectValues<Address>("addresses", customer.addresses, serializeAddress);
        writer.writeStringValue("companyEmail", customer.companyEmail);
        writer.writeStringValue("companyFax", customer.companyFax);
        writer.writeStringValue("companyName", customer.companyName);
        writer.writeStringValue("companyPhone", customer.companyPhone);
        writer.writeCollectionOfObjectValues<Contact>("contacts", customer.contacts, serializeContact);
        writer.writeObjectValue<Customer_customerAttributes>("customerAttributes", customer.customerAttributes, serializeCustomer_customerAttributes);
        writer.writeStringValue("customerId", customer.customerId);
        writer.writeStringValue("customerNumber", customer.customerNumber);
        writer.writeObjectValue<Address>("defaultBillingAddress", customer.defaultBillingAddress, serializeAddress);
        writer.writeObjectValue<Address>("defaultShippingAddress", customer.defaultShippingAddress, serializeAddress);
        writer.writeStringValue("externalId", customer.externalId);
        writer.writeStringValue("fulfillmentMethod", customer.fulfillmentMethod);
        writer.writeStringValue("organizationId", customer.organizationId);
        writer.writeStringValue("pricing", customer.pricing);
        writer.writeStringValue("repNumber", customer.repNumber);
        writer.writeBooleanValue("taxExempt", customer.taxExempt);
        writer.writeStringValue("taxExemptionNumber", customer.taxExemptionNumber);
        writer.writeStringValue("terms", customer.terms);
        writer.writeAdditionalData(customer.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomer_customerAttributes(writer: SerializationWriter, customer_customerAttributes: Partial<Customer_customerAttributes> | undefined | null = {}) : void {
    if (customer_customerAttributes) {
        writer.writeAdditionalData(customer_customerAttributes.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomer2(writer: SerializationWriter, customer2: Partial<Customer2> | undefined | null = {}) : void {
    if (customer2) {
        writer.writeObjectValue<Address>("billingAddress", customer2.billingAddress, serializeAddress);
        writer.writeStringValue("companyEmail", customer2.companyEmail);
        writer.writeStringValue("companyFax", customer2.companyFax);
        writer.writeStringValue("companyName", customer2.companyName);
        writer.writeStringValue("companyPhone", customer2.companyPhone);
        writer.writeStringValue("customerNumber", customer2.customerNumber);
        writer.writeObjectValue<Address>("shippingAddress", customer2.shippingAddress, serializeAddress);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomer3(writer: SerializationWriter, customer3: Partial<Customer3> | undefined | null = {}) : void {
    if (customer3) {
        writer.writeObjectValue<Address>("billingAddress", customer3.billingAddress, serializeAddress);
        writer.writeStringValue("companyEmail", customer3.companyEmail);
        writer.writeStringValue("companyFax", customer3.companyFax);
        writer.writeStringValue("companyName", customer3.companyName);
        writer.writeStringValue("companyPhone", customer3.companyPhone);
        writer.writeStringValue("customerNumber", customer3.customerNumber);
        writer.writeObjectValue<Address>("shippingAddress", customer3.shippingAddress, serializeAddress);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerAttribute(writer: SerializationWriter, customerAttribute: Partial<CustomerAttribute> | undefined | null = {}) : void {
    if (customerAttribute) {
        writer.writeStringValue("displayName", customerAttribute.displayName);
        writer.writeStringValue("slug", customerAttribute.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerDto(writer: SerializationWriter, customerDto: Partial<CustomerDto> | undefined | null = {}) : void {
    if (customerDto) {
        writer.writeObjectValue<AddressDto>("billingAddress", customerDto.billingAddress, serializeAddressDto);
        writer.writeStringValue("companyEmail", customerDto.companyEmail);
        writer.writeStringValue("companyFax", customerDto.companyFax);
        writer.writeStringValue("companyName", customerDto.companyName);
        writer.writeStringValue("companyPhone", customerDto.companyPhone);
        writer.writeStringValue("customerNumber", customerDto.customerNumber);
        writer.writeObjectValue<AddressDto>("shippingAddress", customerDto.shippingAddress, serializeAddressDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerHealth(writer: SerializationWriter, customerHealth: Partial<CustomerHealth> | undefined | null = {}) : void {
    if (customerHealth) {
        writer.writeNumberValue("activeCount", customerHealth.activeCount);
        writer.writeDateValue("asOf", customerHealth.asOf);
        writer.writeNumberValue("atRiskCount", customerHealth.atRiskCount);
        writer.writeNumberValue("coolingCount", customerHealth.coolingCount);
        writer.writeNumberValue("lapsedCount", customerHealth.lapsedCount);
        writer.writeNumberValue("totalCustomers", customerHealth.totalCustomers);
        writer.writeCollectionOfObjectValues<QuietAccount>("worthACall", customerHealth.worthACall, serializeQuietAccount);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerInput(writer: SerializationWriter, customerInput: Partial<CustomerInput> | undefined | null = {}) : void {
    if (customerInput) {
        writer.writeObjectValue<AddressInput>("billingAddress", customerInput.billingAddress, serializeAddressInput);
        writer.writeStringValue("companyEmail", customerInput.companyEmail);
        writer.writeStringValue("companyFax", customerInput.companyFax);
        writer.writeStringValue("companyName", customerInput.companyName);
        writer.writeStringValue("companyPhone", customerInput.companyPhone);
        writer.writeStringValue("customerNumber", customerInput.customerNumber);
        writer.writeObjectValue<AddressInput>("shippingAddress", customerInput.shippingAddress, serializeAddressInput);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerNote(writer: SerializationWriter, customerNote: Partial<CustomerNote> | undefined | null = {}) : void {
    if (customerNote) {
        serializeBaseEntity(writer, customerNote)
        writer.writeStringValue("authorName", customerNote.authorName);
        writer.writeStringValue("body", customerNote.body);
        writer.writeStringValue("customerId", customerNote.customerId);
        writer.writeStringValue("customerNoteId", customerNote.customerNoteId);
        writer.writeStringValue("identityProviderUserId", customerNote.identityProviderUserId);
        writer.writeStringValue("organizationId", customerNote.organizationId);
        writer.writeStringValue("repNumber", customerNote.repNumber);
        writer.writeStringValue("salesRepId", customerNote.salesRepId);
        writer.writeAdditionalData(customerNote.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerOverrideDto(writer: SerializationWriter, customerOverrideDto: Partial<CustomerOverrideDto> | undefined | null = {}) : void {
    if (customerOverrideDto) {
        writer.writeStringValue("customerNumber", customerOverrideDto.customerNumber);
        writer.writeNumberValue("defaultRate", customerOverrideDto.defaultRate);
        writer.writeDateValue("effectiveEndDate", customerOverrideDto.effectiveEndDate);
        writer.writeDateValue("effectiveStartDate", customerOverrideDto.effectiveStartDate);
        writer.writeCollectionOfObjectValues<CommissionRuleDto>("rules", customerOverrideDto.rules, serializeCommissionRuleDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerRevenueRanking(writer: SerializationWriter, customerRevenueRanking: Partial<CustomerRevenueRanking> | undefined | null = {}) : void {
    if (customerRevenueRanking) {
        writer.writeNumberValue("averageOrderValue", customerRevenueRanking.averageOrderValue);
        writer.writeStringValue("customerName", customerRevenueRanking.customerName);
        writer.writeStringValue("customerNumber", customerRevenueRanking.customerNumber);
        writer.writeNumberValue("orderCount", customerRevenueRanking.orderCount);
        writer.writeNumberValue("totalRevenue", customerRevenueRanking.totalRevenue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomersPageSummary(writer: SerializationWriter, customersPageSummary: Partial<CustomersPageSummary> | undefined | null = {}) : void {
    if (customersPageSummary) {
        writer.writeDateValue("asOf", customersPageSummary.asOf);
        writer.writeCollectionOfObjectValues<QuietAccount>("atRiskAccounts", customersPageSummary.atRiskAccounts, serializeQuietAccount);
        writer.writeNumberValue("atRiskCount", customersPageSummary.atRiskCount);
        writer.writeNumberValue("atRiskLifetimeRevenue", customersPageSummary.atRiskLifetimeRevenue);
        writer.writeNumberValue("newLast30Days", customersPageSummary.newLast30Days);
        writer.writeNumberValue("orderedLast90Days", customersPageSummary.orderedLast90Days);
        writer.writeNumberValue("orderedSame90DaysLastYear", customersPageSummary.orderedSame90DaysLastYear);
        writer.writeNumberValue("reorderRate", customersPageSummary.reorderRate);
        writer.writeNumberValue("reorderRatePriorYear", customersPageSummary.reorderRatePriorYear);
        writer.writeNumberValue("totalCustomers", customersPageSummary.totalCustomers);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerUserImportJobSummary(writer: SerializationWriter, customerUserImportJobSummary: Partial<CustomerUserImportJobSummary> | undefined | null = {}) : void {
    if (customerUserImportJobSummary) {
        writer.writeNumberValue("alreadyExisted", customerUserImportJobSummary.alreadyExisted);
        writer.writeNumberValue("created", customerUserImportJobSummary.created);
        writer.writeDateValue("expiresAt", customerUserImportJobSummary.expiresAt);
        writer.writeNumberValue("failed", customerUserImportJobSummary.failed);
        writer.writeBooleanValue("isComplete", customerUserImportJobSummary.isComplete);
        writer.writeNumberValue("processedRows", customerUserImportJobSummary.processedRows);
        writer.writeDateValue("queuedAt", customerUserImportJobSummary.queuedAt);
        writer.writeBooleanValue("reportAvailable", customerUserImportJobSummary.reportAvailable);
        writer.writeStringValue("statusText", customerUserImportJobSummary.statusText);
        writer.writeNumberValue("totalRows", customerUserImportJobSummary.totalRows);
        writer.writeStringValue("trackingId", customerUserImportJobSummary.trackingId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerVendorAccountDto(writer: SerializationWriter, customerVendorAccountDto: Partial<CustomerVendorAccountDto> | undefined | null = {}) : void {
    if (customerVendorAccountDto) {
        writer.writeBooleanValue("active", customerVendorAccountDto.active);
        writer.writeDateValue("createdAt", customerVendorAccountDto.createdAt);
        writer.writeStringValue("customerId", customerVendorAccountDto.customerId);
        writer.writeStringValue("customerNumber", customerVendorAccountDto.customerNumber);
        writer.writeStringValue("customerVendorAccountId", customerVendorAccountDto.customerVendorAccountId);
        writer.writeStringValue("notes", customerVendorAccountDto.notes);
        writer.writeStringValue("organizationId", customerVendorAccountDto.organizationId);
        writer.writeStringValue("paymentMethodId", customerVendorAccountDto.paymentMethodId);
        writer.writeStringValue("priceLevelId", customerVendorAccountDto.priceLevelId);
        writer.writeStringValue("terms", customerVendorAccountDto.terms);
        writer.writeDateValue("updatedAt", customerVendorAccountDto.updatedAt);
        writer.writeStringValue("vendorAccountNumber", customerVendorAccountDto.vendorAccountNumber);
        writer.writeStringValue("vendorCode", customerVendorAccountDto.vendorCode);
        writer.writeStringValue("vendorId", customerVendorAccountDto.vendorId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerVendorAccountRequest(writer: SerializationWriter, customerVendorAccountRequest: Partial<CustomerVendorAccountRequest> | undefined | null = {}) : void {
    if (customerVendorAccountRequest) {
        serializeAgencyScopedRequest(writer, customerVendorAccountRequest)
        writer.writeAdditionalData(customerVendorAccountRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDanglingAssignmentsCleanUpJobRequest(writer: SerializationWriter, danglingAssignmentsCleanUpJobRequest: Partial<DanglingAssignmentsCleanUpJobRequest> | undefined | null = {}) : void {
    if (danglingAssignmentsCleanUpJobRequest) {
        writer.writeBooleanValue("dryRun", danglingAssignmentsCleanUpJobRequest.dryRun);
        writer.writeCollectionOfPrimitiveValues<string>("organizationIds", danglingAssignmentsCleanUpJobRequest.organizationIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDanglingAssignmentsCleanUpJobStatusResponse(writer: SerializationWriter, danglingAssignmentsCleanUpJobStatusResponse: Partial<DanglingAssignmentsCleanUpJobStatusResponse> | undefined | null = {}) : void {
    if (danglingAssignmentsCleanUpJobStatusResponse) {
        writer.writeBooleanValue("dryRun", danglingAssignmentsCleanUpJobStatusResponse.dryRun);
        writer.writeStringValue("errorMessage", danglingAssignmentsCleanUpJobStatusResponse.errorMessage);
        writer.writeBooleanValue("isSuccessfull", danglingAssignmentsCleanUpJobStatusResponse.isSuccessfull);
        writer.writeCollectionOfObjectValues<DanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments>("organizations", danglingAssignmentsCleanUpJobStatusResponse.organizations, serializeDanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments);
        writer.writeNumberValue("totalDanglingAssignments", danglingAssignmentsCleanUpJobStatusResponse.totalDanglingAssignments);
        writer.writeNumberValue("totalOrganizations", danglingAssignmentsCleanUpJobStatusResponse.totalOrganizations);
        writer.writeNumberValue("totalProductsAffected", danglingAssignmentsCleanUpJobStatusResponse.totalProductsAffected);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments(writer: SerializationWriter, danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments: Partial<DanglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments> | undefined | null = {}) : void {
    if (danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments) {
        writer.writeNumberValue("danglingAssignments", danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments.danglingAssignments);
        writer.writeCollectionOfPrimitiveValues<string>("danglingImageIds", danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments.danglingImageIds);
        writer.writeStringValue("organizationId", danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments.organizationId);
        writer.writeNumberValue("productsAffected", danglingAssignmentsCleanUpJobStatusResponse_OrganizationDanglingAssignments.productsAffected);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDataExport(writer: SerializationWriter, dataExport: Partial<DataExport> | undefined | null = {}) : void {
    if (dataExport) {
        serializeBaseEntity(writer, dataExport)
        writer.writeStringValue("createdBy", dataExport.createdBy);
        writer.writeEnumValue<ExportEntity>("exportEntityType", dataExport.exportEntityType);
        writer.writeEnumValue<ExportTypes>("exportFileType", dataExport.exportFileType);
        writer.writeStringValue("formatKey", dataExport.formatKey);
        writer.writeStringValue("id", dataExport.id);
        writer.writeStringValue("name", dataExport.name);
        writer.writeStringValue("organizationId", dataExport.organizationId);
        writer.writeNumberValue("recordCount", dataExport.recordCount);
        writer.writeCollectionOfPrimitiveValues<string>("referenceIdentifiers", dataExport.referenceIdentifiers);
        writer.writeStringValue("status", dataExport.status);
        writer.writeAdditionalData(dataExport.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDataExportResult(writer: SerializationWriter, dataExportResult: Partial<DataExportResult> | undefined | null = {}) : void {
    if (dataExportResult) {
        writer.writeDateValue("createdAt", dataExportResult.createdAt);
        writer.writeEnumValue<ExportEntity>("exportEntityType", dataExportResult.exportEntityType);
        writer.writeEnumValue<ExportTypes>("exportType", dataExportResult.exportType);
        writer.writeStringValue("filename", dataExportResult.filename);
        writer.writeStringValue("formatKey", dataExportResult.formatKey);
        writer.writeStringValue("id", dataExportResult.id);
        writer.writeStringValue("organizationId", dataExportResult.organizationId);
        writer.writeNumberValue("recordsInFile", dataExportResult.recordsInFile);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDataMapping(writer: SerializationWriter, dataMapping: Partial<DataMapping> | undefined | null = {}) : void {
    if (dataMapping) {
        serializeBaseEntity(writer, dataMapping)
        writer.writeStringValue("description", dataMapping.description);
        writer.writeCollectionOfObjectValues<HeaderColumnMap>("headerMappingFields", dataMapping.headerMappingFields, serializeHeaderColumnMap);
        writer.writeStringValue("id", dataMapping.id);
        writer.writeBooleanValue("invertActiveProperty", dataMapping.invertActiveProperty);
        writer.writeStringValue("name", dataMapping.name);
        writer.writeStringValue("organizationId", dataMapping.organizationId);
        writer.writeAdditionalData(dataMapping.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeactivateCommissionPlanRequest(writer: SerializationWriter, deactivateCommissionPlanRequest: Partial<DeactivateCommissionPlanRequest> | undefined | null = {}) : void {
    if (deactivateCommissionPlanRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", deactivateCommissionPlanRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", deactivateCommissionPlanRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeactivateSalesRepRequest(writer: SerializationWriter, deactivateSalesRepRequest: Partial<DeactivateSalesRepRequest> | undefined | null = {}) : void {
    if (deactivateSalesRepRequest) {
        writer.writeStringValue("organizationSalesRepId", deactivateSalesRepRequest.organizationSalesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeactivateVendorRequest(writer: SerializationWriter, deactivateVendorRequest: Partial<DeactivateVendorRequest> | undefined | null = {}) : void {
    if (deactivateVendorRequest) {
        serializeAgencyScopedRequest(writer, deactivateVendorRequest)
        writer.writeAdditionalData(deactivateVendorRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeclineAccessRequestRequest(writer: SerializationWriter, declineAccessRequestRequest: Partial<DeclineAccessRequestRequest> | undefined | null = {}) : void {
    if (declineAccessRequestRequest) {
        writer.writeStringValue("declineReason", declineAccessRequestRequest.declineReason);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeclineAccessRequestResponse(writer: SerializationWriter, declineAccessRequestResponse: Partial<DeclineAccessRequestResponse> | undefined | null = {}) : void {
    if (declineAccessRequestResponse) {
        writer.writeStringValue("accessRequestId", declineAccessRequestResponse.accessRequestId);
        writer.writeStringValue("status", declineAccessRequestResponse.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteAdminUserRequest(writer: SerializationWriter, deleteAdminUserRequest: Partial<DeleteAdminUserRequest> | undefined | null = {}) : void {
    if (deleteAdminUserRequest) {
        writer.writeStringValue("userId", deleteAdminUserRequest.userId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteAdminUserResponse(writer: SerializationWriter, deleteAdminUserResponse: Partial<DeleteAdminUserResponse> | undefined | null = {}) : void {
    if (deleteAdminUserResponse) {
        writer.writeBooleanValue("success", deleteAdminUserResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteCommissionPlanRequest(writer: SerializationWriter, deleteCommissionPlanRequest: Partial<DeleteCommissionPlanRequest> | undefined | null = {}) : void {
    if (deleteCommissionPlanRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", deleteCommissionPlanRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", deleteCommissionPlanRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteCommissionStatementRequest(writer: SerializationWriter, deleteCommissionStatementRequest: Partial<DeleteCommissionStatementRequest> | undefined | null = {}) : void {
    if (deleteCommissionStatementRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", deleteCommissionStatementRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", deleteCommissionStatementRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteCustomerAttributeRequest(writer: SerializationWriter, deleteCustomerAttributeRequest: Partial<DeleteCustomerAttributeRequest> | undefined | null = {}) : void {
    if (deleteCustomerAttributeRequest) {
        writer.writeStringValue("attribute", deleteCustomerAttributeRequest.attribute);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteCustomerNoteRequest(writer: SerializationWriter, deleteCustomerNoteRequest: Partial<DeleteCustomerNoteRequest> | undefined | null = {}) : void {
    if (deleteCustomerNoteRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", deleteCustomerNoteRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", deleteCustomerNoteRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteCustomerVendorAccountRequest(writer: SerializationWriter, deleteCustomerVendorAccountRequest: Partial<DeleteCustomerVendorAccountRequest> | undefined | null = {}) : void {
    if (deleteCustomerVendorAccountRequest) {
        serializeCustomerVendorAccountRequest(writer, deleteCustomerVendorAccountRequest)
        writer.writeAdditionalData(deleteCustomerVendorAccountRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteEmptyCategoriesResponse(writer: SerializationWriter, deleteEmptyCategoriesResponse: Partial<DeleteEmptyCategoriesResponse> | undefined | null = {}) : void {
    if (deleteEmptyCategoriesResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("removed", deleteEmptyCategoriesResponse.removed);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteFulfillmentMethodRequest(writer: SerializationWriter, deleteFulfillmentMethodRequest: Partial<DeleteFulfillmentMethodRequest> | undefined | null = {}) : void {
    if (deleteFulfillmentMethodRequest) {
        writer.writeStringValue("fulfillmentMethod", deleteFulfillmentMethodRequest.fulfillmentMethod);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteIntegrationResponse(writer: SerializationWriter, deleteIntegrationResponse: Partial<DeleteIntegrationResponse> | undefined | null = {}) : void {
    if (deleteIntegrationResponse) {
        writer.writeDateValue("deletedAt", deleteIntegrationResponse.deletedAt);
        writer.writeStringValue("displayName", deleteIntegrationResponse.displayName);
        writer.writeStringValue("integrationId", deleteIntegrationResponse.integrationId);
        writer.writeStringValue("message", deleteIntegrationResponse.message);
        writer.writeStringValue("organizationId", deleteIntegrationResponse.organizationId);
        writer.writeStringValue("provider", deleteIntegrationResponse.provider);
        writer.writeBooleanValue("success", deleteIntegrationResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteInvoiceRequest(writer: SerializationWriter, deleteInvoiceRequest: Partial<DeleteInvoiceRequest> | undefined | null = {}) : void {
    if (deleteInvoiceRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", deleteInvoiceRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", deleteInvoiceRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteListRequest(writer: SerializationWriter, deleteListRequest: Partial<DeleteListRequest> | undefined | null = {}) : void {
    if (deleteListRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", deleteListRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", deleteListRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteManyImagesRequest(writer: SerializationWriter, deleteManyImagesRequest: Partial<DeleteManyImagesRequest> | undefined | null = {}) : void {
    if (deleteManyImagesRequest) {
        writer.writeStringValue("ids", deleteManyImagesRequest.ids);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteMarketCodeRequest(writer: SerializationWriter, deleteMarketCodeRequest: Partial<DeleteMarketCodeRequest> | undefined | null = {}) : void {
    if (deleteMarketCodeRequest) {
        writer.writeStringValue("marketCode", deleteMarketCodeRequest.marketCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteOrderStatusRequest(writer: SerializationWriter, deleteOrderStatusRequest: Partial<DeleteOrderStatusRequest> | undefined | null = {}) : void {
    if (deleteOrderStatusRequest) {
        writer.writeStringValue("orderStatus", deleteOrderStatusRequest.orderStatus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteOrderTypeRequest(writer: SerializationWriter, deleteOrderTypeRequest: Partial<DeleteOrderTypeRequest> | undefined | null = {}) : void {
    if (deleteOrderTypeRequest) {
        writer.writeStringValue("orderType", deleteOrderTypeRequest.orderType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeletePriceTierRequest(writer: SerializationWriter, deletePriceTierRequest: Partial<DeletePriceTierRequest> | undefined | null = {}) : void {
    if (deletePriceTierRequest) {
        writer.writeStringValue("name", deletePriceTierRequest.name);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteProductAttributeRequest(writer: SerializationWriter, deleteProductAttributeRequest: Partial<DeleteProductAttributeRequest> | undefined | null = {}) : void {
    if (deleteProductAttributeRequest) {
        writer.writeStringValue("attribute", deleteProductAttributeRequest.attribute);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteSalesRepRequest(writer: SerializationWriter, deleteSalesRepRequest: Partial<DeleteSalesRepRequest> | undefined | null = {}) : void {
    if (deleteSalesRepRequest) {
        writer.writeStringValue("organizationSalesRepId", deleteSalesRepRequest.organizationSalesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteSalesRepResponse(writer: SerializationWriter, deleteSalesRepResponse: Partial<DeleteSalesRepResponse> | undefined | null = {}) : void {
    if (deleteSalesRepResponse) {
        writer.writeBooleanValue("success", deleteSalesRepResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteTaskRequest(writer: SerializationWriter, deleteTaskRequest: Partial<DeleteTaskRequest> | undefined | null = {}) : void {
    if (deleteTaskRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", deleteTaskRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", deleteTaskRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeleteTermRequest(writer: SerializationWriter, deleteTermRequest: Partial<DeleteTermRequest> | undefined | null = {}) : void {
    if (deleteTermRequest) {
        writer.writeStringValue("term", deleteTermRequest.term);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDeliveryStatus(writer: SerializationWriter, deliveryStatus: Partial<DeliveryStatus> | undefined | null = {}) : void {
    if (deliveryStatus) {
        writer.writeNumberValue("emailsBounced", deliveryStatus.emailsBounced);
        writer.writeNumberValue("emailsClicked", deliveryStatus.emailsClicked);
        writer.writeNumberValue("emailsComplained", deliveryStatus.emailsComplained);
        writer.writeNumberValue("emailsDelivered", deliveryStatus.emailsDelivered);
        writer.writeNumberValue("emailsFailed", deliveryStatus.emailsFailed);
        writer.writeNumberValue("emailsOpened", deliveryStatus.emailsOpened);
        writer.writeNumberValue("emailsSent", deliveryStatus.emailsSent);
        writer.writeCollectionOfPrimitiveValues<string>("errors", deliveryStatus.errors);
        writer.writeNumberValue("smsFailed", deliveryStatus.smsFailed);
        writer.writeNumberValue("smsSent", deliveryStatus.smsSent);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDisconnectIntegrationRequest(writer: SerializationWriter, disconnectIntegrationRequest: Partial<DisconnectIntegrationRequest> | undefined | null = {}) : void {
    if (disconnectIntegrationRequest) {
        writer.writeBooleanValue("disableIntegration", disconnectIntegrationRequest.disableIntegration);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDisconnectIntegrationResponse(writer: SerializationWriter, disconnectIntegrationResponse: Partial<DisconnectIntegrationResponse> | undefined | null = {}) : void {
    if (disconnectIntegrationResponse) {
        writer.writeDateValue("disconnectedAt", disconnectIntegrationResponse.disconnectedAt);
        writer.writeStringValue("integrationId", disconnectIntegrationResponse.integrationId);
        writer.writeEnumValue<IntegrationType>("integrationType", disconnectIntegrationResponse.integrationType);
        writer.writeStringValue("provider", disconnectIntegrationResponse.provider);
        writer.writeBooleanValue("wasDisabled", disconnectIntegrationResponse.wasDisabled);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDiscount(writer: SerializationWriter, discount: Partial<Discount> | undefined | null = {}) : void {
    if (discount) {
        writer.writeStringValue("campaignId", discount.campaignId);
        writer.writeStringValue("code", discount.code);
        writer.writeStringValue("description", discount.description);
        writer.writeStringValue("promotionId", discount.promotionId);
        writer.writeEnumValue<DiscountType>("type", discount.type);
        writer.writeNumberValue("value", discount.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDiscountCode(writer: SerializationWriter, discountCode: Partial<DiscountCode> | undefined | null = {}) : void {
    if (discountCode) {
        serializeBaseEntity(writer, discountCode)
        writer.writeStringValue("campaignId", discountCode.campaignId);
        writer.writeStringValue("code", discountCode.code);
        writer.writeCollectionOfPrimitiveValues<string>("customerNumbers", discountCode.customerNumbers);
        writer.writeStringValue("discountCodeId", discountCode.discountCodeId);
        writer.writeNumberValue("maxUses", discountCode.maxUses);
        writer.writeNumberValue("maxUsesPerCustomer", discountCode.maxUsesPerCustomer);
        writer.writeStringValue("organizationId", discountCode.organizationId);
        writer.writeNumberValue("usedCount", discountCode.usedCount);
        writer.writeDateValue("validFrom", discountCode.validFrom);
        writer.writeDateValue("validTo", discountCode.validTo);
        writer.writeAdditionalData(discountCode.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDiscountCodeOptionsInput(writer: SerializationWriter, discountCodeOptionsInput: Partial<DiscountCodeOptionsInput> | undefined | null = {}) : void {
    if (discountCodeOptionsInput) {
        writer.writeCollectionOfPrimitiveValues<string>("customerNumbers", discountCodeOptionsInput.customerNumbers);
        writer.writeNumberValue("maxUses", discountCodeOptionsInput.maxUses);
        writer.writeNumberValue("maxUsesPerCustomer", discountCodeOptionsInput.maxUsesPerCustomer);
        writer.writeDateValue("validFrom", discountCodeOptionsInput.validFrom);
        writer.writeDateValue("validTo", discountCodeOptionsInput.validTo);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDiscountDto(writer: SerializationWriter, discountDto: Partial<DiscountDto> | undefined | null = {}) : void {
    if (discountDto) {
        writer.writeStringValue("campaignId", discountDto.campaignId);
        writer.writeStringValue("code", discountDto.code);
        writer.writeStringValue("description", discountDto.description);
        writer.writeStringValue("promotionId", discountDto.promotionId);
        writer.writeStringValue("type", discountDto.type);
        writer.writeNumberValue("value", discountDto.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDiscountInput(writer: SerializationWriter, discountInput: Partial<DiscountInput> | undefined | null = {}) : void {
    if (discountInput) {
        writer.writeStringValue("code", discountInput.code);
        writer.writeStringValue("description", discountInput.description);
        writer.writeStringValue("type", discountInput.type);
        writer.writeNumberValue("value", discountInput.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDisputeCommissionStatementRequest(writer: SerializationWriter, disputeCommissionStatementRequest: Partial<DisputeCommissionStatementRequest> | undefined | null = {}) : void {
    if (disputeCommissionStatementRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", disputeCommissionStatementRequest.orgCodes);
        writer.writeStringValue("reason", disputeCommissionStatementRequest.reason);
        writer.writeStringValue("useOrganizationId", disputeCommissionStatementRequest.useOrganizationId);
        writer.writeStringValue("user", disputeCommissionStatementRequest.user);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDocumentListResponse(writer: SerializationWriter, documentListResponse: Partial<DocumentListResponse> | undefined | null = {}) : void {
    if (documentListResponse) {
        writer.writeCollectionOfObjectValues<CompanyDocumentDto>("documents", documentListResponse.documents, serializeCompanyDocumentDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDocumentResponse(writer: SerializationWriter, documentResponse: Partial<DocumentResponse> | undefined | null = {}) : void {
    if (documentResponse) {
        writer.writeObjectValue<CompanyDocumentDto>("document", documentResponse.document, serializeCompanyDocumentDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDocumentResponse2(writer: SerializationWriter, documentResponse2: Partial<DocumentResponse2> | undefined | null = {}) : void {
    if (documentResponse2) {
        writer.writeObjectValue<CompanyDocumentDto>("document", documentResponse2.document, serializeCompanyDocumentDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDocumentStorageStatsDto(writer: SerializationWriter, documentStorageStatsDto: Partial<DocumentStorageStatsDto> | undefined | null = {}) : void {
    if (documentStorageStatsDto) {
        writer.writeNumberValue("availableSize", documentStorageStatsDto.availableSize);
        writer.writeNumberValue("maxSize", documentStorageStatsDto.maxSize);
        writer.writeNumberValue("totalFiles", documentStorageStatsDto.totalFiles);
        writer.writeNumberValue("totalSize", documentStorageStatsDto.totalSize);
        writer.writeNumberValue("usedPercentage", documentStorageStatsDto.usedPercentage);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEditCustomerAttributeRequest(writer: SerializationWriter, editCustomerAttributeRequest: Partial<EditCustomerAttributeRequest> | undefined | null = {}) : void {
    if (editCustomerAttributeRequest) {
        writer.writeStringValue("displayName", editCustomerAttributeRequest.displayName);
        writer.writeStringValue("slug", editCustomerAttributeRequest.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEditOrderTypeRequest(writer: SerializationWriter, editOrderTypeRequest: Partial<EditOrderTypeRequest> | undefined | null = {}) : void {
    if (editOrderTypeRequest) {
        writer.writeStringValue("displayName", editOrderTypeRequest.displayName);
        writer.writeEnumValue<OrderKind>("kind", editOrderTypeRequest.kind);
        writer.writeStringValue("slug", editOrderTypeRequest.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEditProductAttributeRequest(writer: SerializationWriter, editProductAttributeRequest: Partial<EditProductAttributeRequest> | undefined | null = {}) : void {
    if (editProductAttributeRequest) {
        writer.writeStringValue("displayName", editProductAttributeRequest.displayName);
        writer.writeStringValue("slug", editProductAttributeRequest.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEmailInvoiceRequest(writer: SerializationWriter, emailInvoiceRequest: Partial<EmailInvoiceRequest> | undefined | null = {}) : void {
    if (emailInvoiceRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("emailAddresses", emailInvoiceRequest.emailAddresses);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEmailStatsCounts(writer: SerializationWriter, emailStatsCounts: Partial<EmailStatsCounts> | undefined | null = {}) : void {
    if (emailStatsCounts) {
        writer.writeNumberValue("bounced", emailStatsCounts.bounced);
        writer.writeNumberValue("clicked", emailStatsCounts.clicked);
        writer.writeNumberValue("complained", emailStatsCounts.complained);
        writer.writeNumberValue("delivered", emailStatsCounts.delivered);
        writer.writeNumberValue("opened", emailStatsCounts.opened);
        writer.writeNumberValue("requests", emailStatsCounts.requests);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEmailStatsDay(writer: SerializationWriter, emailStatsDay: Partial<EmailStatsDay> | undefined | null = {}) : void {
    if (emailStatsDay) {
        serializeEmailStatsCounts(writer, emailStatsDay)
        writer.writeStringValue("date", emailStatsDay.date);
        writer.writeAdditionalData(emailStatsDay.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEnrichCustomerRequest(writer: SerializationWriter, enrichCustomerRequest: Partial<EnrichCustomerRequest> | undefined | null = {}) : void {
    if (enrichCustomerRequest) {
        writer.writeStringValue("domain", enrichCustomerRequest.domain);
        writer.writeBooleanValue("forceRefresh", enrichCustomerRequest.forceRefresh);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", enrichCustomerRequest.orgCodes);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEnrichCustomerResponse(writer: SerializationWriter, enrichCustomerResponse: Partial<EnrichCustomerResponse> | undefined | null = {}) : void {
    if (enrichCustomerResponse) {
        writer.writeObjectValue<ResearchedAddress>("address", enrichCustomerResponse.address, serializeResearchedAddress);
        writer.writeObjectValue<ResearchedValue>("companyName", enrichCustomerResponse.companyName, serializeResearchedValue);
        writer.writeNumberValue("confidence", enrichCustomerResponse.confidence);
        writer.writeStringValue("domain", enrichCustomerResponse.domain);
        writer.writeBooleanValue("fromCache", enrichCustomerResponse.fromCache);
        writer.writeObjectValue<ResearchedValue>("industry", enrichCustomerResponse.industry, serializeResearchedValue);
        writer.writeObjectValue<ResearchedValue>("phone", enrichCustomerResponse.phone, serializeResearchedValue);
        writer.writeDateValue("researchedAt", enrichCustomerResponse.researchedAt);
        writer.writeCollectionOfPrimitiveValues<string>("sources", enrichCustomerResponse.sources);
        writer.writeStringValue("status", enrichCustomerResponse.status);
        writer.writeStringValue("website", enrichCustomerResponse.website);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEnrichM2MResponse(writer: SerializationWriter, enrichM2MResponse: Partial<EnrichM2MResponse> | undefined | null = {}) : void {
    if (enrichM2MResponse) {
        writer.writeStringValue("accessScope", enrichM2MResponse.accessScope);
        writer.writeStringValue("currencyCode", enrichM2MResponse.currencyCode);
        writer.writeStringValue("customerNumber", enrichM2MResponse.customerNumber);
        writer.writeStringValue("organizationId", enrichM2MResponse.organizationId);
        writer.writeStringValue("priceTier", enrichM2MResponse.priceTier);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEnrichUserAccessTokenResponse(writer: SerializationWriter, enrichUserAccessTokenResponse: Partial<EnrichUserAccessTokenResponse> | undefined | null = {}) : void {
    if (enrichUserAccessTokenResponse) {
        writer.writeStringValue("currencyCode", enrichUserAccessTokenResponse.currencyCode);
        writer.writeStringValue("customerNumber", enrichUserAccessTokenResponse.customerNumber);
        writer.writeStringValue("priceTier", enrichUserAccessTokenResponse.priceTier);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEntitlementOffer(writer: SerializationWriter, entitlementOffer: Partial<EntitlementOffer> | undefined | null = {}) : void {
    if (entitlementOffer) {
        writer.writeStringValue("currencyCode", entitlementOffer.currencyCode);
        writer.writeStringValue("description", entitlementOffer.description);
        writer.writeStringValue("lookupKey", entitlementOffer.lookupKey);
        writer.writeStringValue("name", entitlementOffer.name);
        writer.writeNumberValue("period", entitlementOffer.period);
        writer.writeStringValue("periodUnit", entitlementOffer.periodUnit);
        writer.writeNumberValue("price", entitlementOffer.price);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEntitlementsResponse(writer: SerializationWriter, entitlementsResponse: Partial<EntitlementsResponse> | undefined | null = {}) : void {
    if (entitlementsResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("entitlements", entitlementsResponse.entitlements);
        writer.writeBooleanValue("entitlementsKnown", entitlementsResponse.entitlementsKnown);
        writer.writeBooleanValue("hasSubscription", entitlementsResponse.hasSubscription);
        writer.writeObjectValue<EntitlementOffer>("storefrontOffer", entitlementsResponse.storefrontOffer, serializeEntitlementOffer);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEntityDetailsResponseOfImageDetail(writer: SerializationWriter, entityDetailsResponseOfImageDetail: Partial<EntityDetailsResponseOfImageDetail> | undefined | null = {}) : void {
    if (entityDetailsResponseOfImageDetail) {
        writer.writeObjectValue<ImageDetail>("entity", entityDetailsResponseOfImageDetail.entity, serializeImageDetail);
        writer.writeCollectionOfObjectValues<Link>("links", entityDetailsResponseOfImageDetail.links, serializeLink);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEntityDetailsResponseOfOrder(writer: SerializationWriter, entityDetailsResponseOfOrder: Partial<EntityDetailsResponseOfOrder> | undefined | null = {}) : void {
    if (entityDetailsResponseOfOrder) {
        writer.writeObjectValue<Order>("entity", entityDetailsResponseOfOrder.entity, serializeOrder);
        writer.writeCollectionOfObjectValues<Link>("links", entityDetailsResponseOfOrder.links, serializeLink);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeErrorResponse(writer: SerializationWriter, errorResponse: Partial<ErrorResponse> | undefined | null = {}) : void {
    if (errorResponse) {
        writer.writeObjectValue<ErrorResponse_errors>("errors", errorResponse.errors, serializeErrorResponse_errors);
        writer.writeStringValue("message", errorResponse.messageEscaped ?? "One or more errors occurred!");
        writer.writeNumberValue("statusCode", errorResponse.statusCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeErrorResponse_errors(writer: SerializationWriter, errorResponse_errors: Partial<ErrorResponse_errors> | undefined | null = {}) : void {
    if (errorResponse_errors) {
        writer.writeAdditionalData(errorResponse_errors.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExistingAccessCustomerResponse(writer: SerializationWriter, existingAccessCustomerResponse: Partial<ExistingAccessCustomerResponse> | undefined | null = {}) : void {
    if (existingAccessCustomerResponse) {
        writer.writeStringValue("companyName", existingAccessCustomerResponse.companyName);
        writer.writeBooleanValue("customerActive", existingAccessCustomerResponse.customerActive);
        writer.writeStringValue("customerNumber", existingAccessCustomerResponse.customerNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExistingAccessResponse(writer: SerializationWriter, existingAccessResponse: Partial<ExistingAccessResponse> | undefined | null = {}) : void {
    if (existingAccessResponse) {
        writer.writeCollectionOfObjectValues<ExistingAccessCustomerResponse>("customers", existingAccessResponse.customers, serializeExistingAccessCustomerResponse);
        writer.writeBooleanValue("hasAccess", existingAccessResponse.hasAccess);
        writer.writeBooleanValue("isOrganizationMember", existingAccessResponse.isOrganizationMember);
        writer.writeBooleanValue("userExists", existingAccessResponse.userExists);
        writer.writeStringValue("userId", existingAccessResponse.userId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExistsResponse(writer: SerializationWriter, existsResponse: Partial<ExistsResponse> | undefined | null = {}) : void {
    if (existsResponse) {
        writer.writeBooleanValue("exitsInOrganization", existsResponse.exitsInOrganization);
        writer.writeBooleanValue("identityExists", existsResponse.identityExists);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExportCustomersRequest(writer: SerializationWriter, exportCustomersRequest: Partial<ExportCustomersRequest> | undefined | null = {}) : void {
    if (exportCustomersRequest) {
        writer.writeEnumValue<ExportTypes>("exportFileType", exportCustomersRequest.exportFileType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExportedOrderDto(writer: SerializationWriter, exportedOrderDto: Partial<ExportedOrderDto> | undefined | null = {}) : void {
    if (exportedOrderDto) {
        writer.writeDateValue("exportedAt", exportedOrderDto.exportedAt);
        writer.writeStringValue("exportedBy", exportedOrderDto.exportedBy);
        writer.writeStringValue("id", exportedOrderDto.id);
        writer.writeStringValue("orderNumber", exportedOrderDto.orderNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExportFormatDto(writer: SerializationWriter, exportFormatDto: Partial<ExportFormatDto> | undefined | null = {}) : void {
    if (exportFormatDto) {
        writer.writeStringValue("customFormatKey", exportFormatDto.customFormatKey);
        writer.writeStringValue("displayName", exportFormatDto.displayName);
        writer.writeEnumValue<ExportTypes>("exportFileType", exportFormatDto.exportFileType);
        writer.writeBooleanValue("isCustom", exportFormatDto.isCustom);
        writer.writeStringValue("key", exportFormatDto.key);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExportOrdersByDateRequest(writer: SerializationWriter, exportOrdersByDateRequest: Partial<ExportOrdersByDateRequest> | undefined | null = {}) : void {
    if (exportOrdersByDateRequest) {
        writer.writeEnumValue<ExportTypes>("exportFileType", exportOrdersByDateRequest.exportFileType);
        writer.writeCollectionOfObjectValues<QueryFilter>("filters", exportOrdersByDateRequest.filters, serializeQueryFilter);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExportOrdersByIdRequest(writer: SerializationWriter, exportOrdersByIdRequest: Partial<ExportOrdersByIdRequest> | undefined | null = {}) : void {
    if (exportOrdersByIdRequest) {
        writer.writeStringValue("customFormatKey", exportOrdersByIdRequest.customFormatKey);
        writer.writeEnumValue<ExportTypes>("exportFileType", exportOrdersByIdRequest.exportFileType);
        writer.writeCollectionOfPrimitiveValues<string>("orderIds", exportOrdersByIdRequest.orderIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExportProductsRequest(writer: SerializationWriter, exportProductsRequest: Partial<ExportProductsRequest> | undefined | null = {}) : void {
    if (exportProductsRequest) {
        writer.writeEnumValue<ExportTypes>("exportFileType", exportProductsRequest.exportFileType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeExtractBusinessCardResponse(writer: SerializationWriter, extractBusinessCardResponse: Partial<ExtractBusinessCardResponse> | undefined | null = {}) : void {
    if (extractBusinessCardResponse) {
        writer.writeObjectValue<BusinessCardAddress>("address", extractBusinessCardResponse.address, serializeBusinessCardAddress);
        writer.writeObjectValue<BusinessCardField>("companyName", extractBusinessCardResponse.companyName, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("emailAddress", extractBusinessCardResponse.emailAddress, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("fax", extractBusinessCardResponse.fax, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("firstName", extractBusinessCardResponse.firstName, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("lastName", extractBusinessCardResponse.lastName, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("mobilePhone", extractBusinessCardResponse.mobilePhone, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("phone", extractBusinessCardResponse.phone, serializeBusinessCardField);
        writer.writeStringValue("rawText", extractBusinessCardResponse.rawText);
        writer.writeObjectValue<BusinessCardField>("title", extractBusinessCardResponse.title, serializeBusinessCardField);
        writer.writeObjectValue<BusinessCardField>("website", extractBusinessCardResponse.website, serializeBusinessCardField);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFailedLine(writer: SerializationWriter, failedLine: Partial<FailedLine> | undefined | null = {}) : void {
    if (failedLine) {
        writer.writeStringValue("reason", failedLine.reason);
        writer.writeStringValue("vendorCode", failedLine.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFailPaymentRequest(writer: SerializationWriter, failPaymentRequest: Partial<FailPaymentRequest> | undefined | null = {}) : void {
    if (failPaymentRequest) {
        writer.writeStringValue("notes", failPaymentRequest.notes);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", failPaymentRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", failPaymentRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFavoriteList(writer: SerializationWriter, favoriteList: Partial<FavoriteList> | undefined | null = {}) : void {
    if (favoriteList) {
        serializeBaseEntity(writer, favoriteList)
        writer.writeStringValue("customerNumber", favoriteList.customerNumber);
        writer.writeStringValue("favoriteListId", favoriteList.favoriteListId);
        writer.writeBooleanValue("isDefault", favoriteList.isDefault);
        writer.writeCollectionOfObjectValues<FavoriteListItem>("items", favoriteList.items, serializeFavoriteListItem);
        writer.writeStringValue("name", favoriteList.name);
        writer.writeStringValue("organizationId", favoriteList.organizationId);
        writer.writeStringValue("salesRepId", favoriteList.salesRepId);
        writer.writeStringValue("source", favoriteList.source);
        writer.writeStringValue("userId", favoriteList.userId);
        writer.writeAdditionalData(favoriteList.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFavoriteListItem(writer: SerializationWriter, favoriteListItem: Partial<FavoriteListItem> | undefined | null = {}) : void {
    if (favoriteListItem) {
        serializeBaseEntity(writer, favoriteListItem)
        writer.writeStringValue("favoriteListId", favoriteListItem.favoriteListId);
        writer.writeStringValue("favoriteListItemId", favoriteListItem.favoriteListItemId);
        writer.writeStringValue("productName", favoriteListItem.productName);
        writer.writeNumberValue("quantity", favoriteListItem.quantity);
        writer.writeStringValue("sku", favoriteListItem.sku);
        writer.writeStringValue("source", favoriteListItem.source);
        writer.writeAdditionalData(favoriteListItem.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFlipbook(writer: SerializationWriter, flipbook: Partial<Flipbook> | undefined | null = {}) : void {
    if (flipbook) {
        serializeBaseEntity(writer, flipbook)
        writer.writeStringValue("flipbookId", flipbook.flipbookId);
        writer.writeStringValue("organizationId", flipbook.organizationId);
        writer.writeCollectionOfObjectValues<Page>("pages", flipbook.pages, serializePage);
        writer.writeStringValue("pdfSourceName", flipbook.pdfSourceName);
        writer.writeNumberValue("sortOrder", flipbook.sortOrder);
        writer.writeStringValue("title", flipbook.title);
        writer.writeAdditionalData(flipbook.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFlipbookPagesResponse(writer: SerializationWriter, flipbookPagesResponse: Partial<FlipbookPagesResponse> | undefined | null = {}) : void {
    if (flipbookPagesResponse) {
        writer.writeStringValue("flipbookId", flipbookPagesResponse.flipbookId);
        writer.writeNumberValue("pageCount", flipbookPagesResponse.pageCount);
        writer.writeCollectionOfObjectValues<PageInfo>("pages", flipbookPagesResponse.pages, serializePageInfo);
        writer.writeStringValue("title", flipbookPagesResponse.title);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFolderListResponse(writer: SerializationWriter, folderListResponse: Partial<FolderListResponse> | undefined | null = {}) : void {
    if (folderListResponse) {
        writer.writeCollectionOfObjectValues<CompanyFolderDto>("folders", folderListResponse.folders, serializeCompanyFolderDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFolderResponse(writer: SerializationWriter, folderResponse: Partial<FolderResponse> | undefined | null = {}) : void {
    if (folderResponse) {
        writer.writeObjectValue<CompanyFolderDto>("folder", folderResponse.folder, serializeCompanyFolderDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFolderResponse2(writer: SerializationWriter, folderResponse2: Partial<FolderResponse2> | undefined | null = {}) : void {
    if (folderResponse2) {
        writer.writeObjectValue<CompanyFolderDto>("folder", folderResponse2.folder, serializeCompanyFolderDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeForecastModelDto(writer: SerializationWriter, forecastModelDto: Partial<ForecastModelDto> | undefined | null = {}) : void {
    if (forecastModelDto) {
        writer.writeDateValue("createdAt", forecastModelDto.createdAt);
        writer.writeStringValue("entityId", forecastModelDto.entityId);
        writer.writeStringValue("granularity", forecastModelDto.granularity);
        writer.writeBooleanValue("isCurrent", forecastModelDto.isCurrent);
        writer.writeObjectValue<ModelMetrics>("metrics", forecastModelDto.metrics, serializeModelMetrics);
        writer.writeStringValue("modelId", forecastModelDto.modelId);
        writer.writeStringValue("modelType", forecastModelDto.modelType);
        writer.writeStringValue("name", forecastModelDto.name);
        writer.writeStringValue("organizationId", forecastModelDto.organizationId);
        writer.writeObjectValue<ForecastModelSettings>("settings", forecastModelDto.settings, serializeForecastModelSettings);
        writer.writeDateValue("trainingDataEndDate", forecastModelDto.trainingDataEndDate);
        writer.writeNumberValue("trainingDataPoints", forecastModelDto.trainingDataPoints);
        writer.writeDateValue("trainingDataStartDate", forecastModelDto.trainingDataStartDate);
        writer.writeNumberValue("trainingDurationMs", forecastModelDto.trainingDurationMs);
        writer.writeDateValue("updatedAt", forecastModelDto.updatedAt);
        writer.writeNumberValue("version", forecastModelDto.version);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeForecastModelSettings(writer: SerializationWriter, forecastModelSettings: Partial<ForecastModelSettings> | undefined | null = {}) : void {
    if (forecastModelSettings) {
        writer.writeNumberValue("ciHalfWidth", forecastModelSettings.ciHalfWidth);
        writer.writeCollectionOfPrimitiveValues<number>("ciHalfWidths", forecastModelSettings.ciHalfWidths);
        writer.writeNumberValue("confidenceLevel", forecastModelSettings.confidenceLevel);
        writer.writeBooleanValue("enableRecentLevelRescaling", forecastModelSettings.enableRecentLevelRescaling);
        writer.writeNumberValue("horizon", forecastModelSettings.horizon);
        writer.writeStringValue("inputColumnName", forecastModelSettings.inputColumnName);
        writer.writeNumberValue("minimumDataPoints", forecastModelSettings.minimumDataPoints);
        writer.writeStringValue("outputColumnName", forecastModelSettings.outputColumnName);
        writer.writeNumberValue("seasonalityWindowSize", forecastModelSettings.seasonalityWindowSize);
        writer.writeNumberValue("seasonalNaiveBlendWeight", forecastModelSettings.seasonalNaiveBlendWeight);
        writer.writeCollectionOfPrimitiveValues<number>("seasonalNaiveUnitsByMonth", forecastModelSettings.seasonalNaiveUnitsByMonth);
        writer.writeNumberValue("trainingAverageUnits", forecastModelSettings.trainingAverageUnits);
        writer.writeNumberValue("trainingWindowSize", forecastModelSettings.trainingWindowSize);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFreeShippingEntitlement(writer: SerializationWriter, freeShippingEntitlement: Partial<FreeShippingEntitlement> | undefined | null = {}) : void {
    if (freeShippingEntitlement) {
        writer.writeStringValue("campaignId", freeShippingEntitlement.campaignId);
        writer.writeNumberValue("originalAmount", freeShippingEntitlement.originalAmount);
        writer.writeStringValue("promotionId", freeShippingEntitlement.promotionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGenerateCodesRequest(writer: SerializationWriter, generateCodesRequest: Partial<GenerateCodesRequest> | undefined | null = {}) : void {
    if (generateCodesRequest) {
        writer.writeNumberValue("count", generateCodesRequest.count);
        writer.writeCollectionOfPrimitiveValues<string>("customerNumbers", generateCodesRequest.customerNumbers);
        writer.writeObjectValue<DiscountCodeOptionsInput>("options", generateCodesRequest.options, serializeDiscountCodeOptionsInput);
        writer.writeStringValue("prefix", generateCodesRequest.prefix);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGenerateCommissionStatementRequest(writer: SerializationWriter, generateCommissionStatementRequest: Partial<GenerateCommissionStatementRequest> | undefined | null = {}) : void {
    if (generateCommissionStatementRequest) {
        writer.writeDateValue("endDate", generateCommissionStatementRequest.endDate);
        writer.writeStringValue("generatedByUser", generateCommissionStatementRequest.generatedByUser);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", generateCommissionStatementRequest.orgCodes);
        writer.writeStringValue("salesRepId", generateCommissionStatementRequest.salesRepId);
        writer.writeDateValue("startDate", generateCommissionStatementRequest.startDate);
        writer.writeCollectionOfObjectValues<GenerateCommissionStatementRequest_TaxItemInput>("taxItems", generateCommissionStatementRequest.taxItems, serializeGenerateCommissionStatementRequest_TaxItemInput);
        writer.writeStringValue("useOrganizationId", generateCommissionStatementRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGenerateCommissionStatementRequest_TaxItemInput(writer: SerializationWriter, generateCommissionStatementRequest_TaxItemInput: Partial<GenerateCommissionStatementRequest_TaxItemInput> | undefined | null = {}) : void {
    if (generateCommissionStatementRequest_TaxItemInput) {
        writer.writeNumberValue("amount", generateCommissionStatementRequest_TaxItemInput.amount);
        writer.writeNumberValue("ratePercent", generateCommissionStatementRequest_TaxItemInput.ratePercent);
        writer.writeStringValue("taxName", generateCommissionStatementRequest_TaxItemInput.taxName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetAccessRequestNotificationSettingsResponse(writer: SerializationWriter, getAccessRequestNotificationSettingsResponse: Partial<GetAccessRequestNotificationSettingsResponse> | undefined | null = {}) : void {
    if (getAccessRequestNotificationSettingsResponse) {
        writer.writeStringValue("effectiveNotificationEmail", getAccessRequestNotificationSettingsResponse.effectiveNotificationEmail);
        writer.writeStringValue("notificationEmail", getAccessRequestNotificationSettingsResponse.notificationEmail);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetAccessRequestResponse(writer: SerializationWriter, getAccessRequestResponse: Partial<GetAccessRequestResponse> | undefined | null = {}) : void {
    if (getAccessRequestResponse) {
        writer.writeObjectValue<AccessRequest>("accessRequest", getAccessRequestResponse.accessRequest, serializeAccessRequest);
        writer.writeObjectValue<Customer>("customer", getAccessRequestResponse.customer, serializeCustomer);
        writer.writeObjectValue<ExistingAccessResponse>("existingAccess", getAccessRequestResponse.existingAccess, serializeExistingAccessResponse);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetActivePaymentGatewayResponse(writer: SerializationWriter, getActivePaymentGatewayResponse: Partial<GetActivePaymentGatewayResponse> | undefined | null = {}) : void {
    if (getActivePaymentGatewayResponse) {
        writer.writeStringValue("provider", getActivePaymentGatewayResponse.provider);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetAddressDetailsRequest(writer: SerializationWriter, getAddressDetailsRequest: Partial<GetAddressDetailsRequest> | undefined | null = {}) : void {
    if (getAddressDetailsRequest) {
        writer.writeStringValue("placeId", getAddressDetailsRequest.placeId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetAddressDetailsResponse(writer: SerializationWriter, getAddressDetailsResponse: Partial<GetAddressDetailsResponse> | undefined | null = {}) : void {
    if (getAddressDetailsResponse) {
        writer.writeObjectValue("html_attributions", getAddressDetailsResponse.htmlAttributions);
        writer.writeObjectValue<Result>("result", getAddressDetailsResponse.result, serializeResult);
        writer.writeStringValue("status", getAddressDetailsResponse.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetAiUsageResponse(writer: SerializationWriter, getAiUsageResponse: Partial<GetAiUsageResponse> | undefined | null = {}) : void {
    if (getAiUsageResponse) {
        writer.writeCollectionOfObjectValues<AiUsageBreakdownItem>("breakdown", getAiUsageResponse.breakdown, serializeAiUsageBreakdownItem);
        writer.writeNumberValue("callCount", getAiUsageResponse.callCount);
        writer.writeDateValue("from", getAiUsageResponse.from);
        writer.writeDateValue("to", getAiUsageResponse.to);
        writer.writeNumberValue("totalCostUsd", getAiUsageResponse.totalCostUsd);
        writer.writeNumberValue("totalTokens", getAiUsageResponse.totalTokens);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetApiAccessResponse(writer: SerializationWriter, getApiAccessResponse: Partial<GetApiAccessResponse> | undefined | null = {}) : void {
    if (getApiAccessResponse) {
        writer.writeStringValue("apiKey", getApiAccessResponse.apiKey);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetAvailableIntegrationsResponse(writer: SerializationWriter, getAvailableIntegrationsResponse: Partial<GetAvailableIntegrationsResponse> | undefined | null = {}) : void {
    if (getAvailableIntegrationsResponse) {
        writer.writeNumberValue("configuredCount", getAvailableIntegrationsResponse.configuredCount);
        writer.writeNumberValue("enabledCount", getAvailableIntegrationsResponse.enabledCount);
        writer.writeObjectValue<GetAvailableIntegrationsResponse_integrationsByType>("integrationsByType", getAvailableIntegrationsResponse.integrationsByType, serializeGetAvailableIntegrationsResponse_integrationsByType);
        writer.writeStringValue("organizationId", getAvailableIntegrationsResponse.organizationId);
        writer.writeNumberValue("totalAvailable", getAvailableIntegrationsResponse.totalAvailable);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetAvailableIntegrationsResponse_integrationsByType(writer: SerializationWriter, getAvailableIntegrationsResponse_integrationsByType: Partial<GetAvailableIntegrationsResponse_integrationsByType> | undefined | null = {}) : void {
    if (getAvailableIntegrationsResponse_integrationsByType) {
        writer.writeAdditionalData(getAvailableIntegrationsResponse_integrationsByType.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetBulkWriteSummaryResponse(writer: SerializationWriter, getBulkWriteSummaryResponse: Partial<GetBulkWriteSummaryResponse> | undefined | null = {}) : void {
    if (getBulkWriteSummaryResponse) {
        writer.writeCollectionOfObjectValues<BulkWriteDailyTotal>("days", getBulkWriteSummaryResponse.days, serializeBulkWriteDailyTotal);
        writer.writeDateValue("from", getBulkWriteSummaryResponse.from);
        writer.writeDateValue("to", getBulkWriteSummaryResponse.to);
        writer.writeNumberValue("totalCalls", getBulkWriteSummaryResponse.totalCalls);
        writer.writeNumberValue("totalDocuments", getBulkWriteSummaryResponse.totalDocuments);
        writer.writeNumberValue("totalFailedCalls", getBulkWriteSummaryResponse.totalFailedCalls);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetCartPricingSettingsResponse(writer: SerializationWriter, getCartPricingSettingsResponse: Partial<GetCartPricingSettingsResponse> | undefined | null = {}) : void {
    if (getCartPricingSettingsResponse) {
        writer.writeBooleanValue("allowDecimalQuantities", getCartPricingSettingsResponse.allowDecimalQuantities);
        writer.writeBooleanValue("allowLineItemDiscounts", getCartPricingSettingsResponse.allowLineItemDiscounts);
        writer.writeBooleanValue("allowOrderDiscounts", getCartPricingSettingsResponse.allowOrderDiscounts);
        writer.writeBooleanValue("allowPriceOverride", getCartPricingSettingsResponse.allowPriceOverride);
        writer.writeBooleanValue("refreshStalePrices", getCartPricingSettingsResponse.refreshStalePrices);
        writer.writeNumberValue("stalePriceAgeDays", getCartPricingSettingsResponse.stalePriceAgeDays);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetCustomerSalesRepResponse(writer: SerializationWriter, getCustomerSalesRepResponse: Partial<GetCustomerSalesRepResponse> | undefined | null = {}) : void {
    if (getCustomerSalesRepResponse) {
        writer.writeBooleanValue("active", getCustomerSalesRepResponse.active);
        writer.writeStringValue("email", getCustomerSalesRepResponse.email);
        writer.writeStringValue("name", getCustomerSalesRepResponse.name);
        writer.writeStringValue("phone", getCustomerSalesRepResponse.phone);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetEmailStatsResponse(writer: SerializationWriter, getEmailStatsResponse: Partial<GetEmailStatsResponse> | undefined | null = {}) : void {
    if (getEmailStatsResponse) {
        writer.writeCollectionOfObjectValues<EmailStatsDay>("days", getEmailStatsResponse.days, serializeEmailStatsDay);
        writer.writeDateValue("from", getEmailStatsResponse.from);
        writer.writeStringValue("timeZone", getEmailStatsResponse.timeZone);
        writer.writeDateValue("to", getEmailStatsResponse.to);
        writer.writeObjectValue<EmailStatsCounts>("totals", getEmailStatsResponse.totals, serializeEmailStatsCounts);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetExportDownloadUrlResponse(writer: SerializationWriter, getExportDownloadUrlResponse: Partial<GetExportDownloadUrlResponse> | undefined | null = {}) : void {
    if (getExportDownloadUrlResponse) {
        writer.writeStringValue("downloadUrl", getExportDownloadUrlResponse.downloadUrl);
        writer.writeDateValue("expirationAtUtc", getExportDownloadUrlResponse.expirationAtUtc);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetFeatureFlagsResponse(writer: SerializationWriter, getFeatureFlagsResponse: Partial<GetFeatureFlagsResponse> | undefined | null = {}) : void {
    if (getFeatureFlagsResponse) {
        writer.writeObjectValue<GetFeatureFlagsResponse_flags>("flags", getFeatureFlagsResponse.flags, serializeGetFeatureFlagsResponse_flags);
        writer.writeStringValue("organizationId", getFeatureFlagsResponse.organizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetFeatureFlagsResponse_flags(writer: SerializationWriter, getFeatureFlagsResponse_flags: Partial<GetFeatureFlagsResponse_flags> | undefined | null = {}) : void {
    if (getFeatureFlagsResponse_flags) {
        writer.writeAdditionalData(getFeatureFlagsResponse_flags.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetForecastModelResponse(writer: SerializationWriter, getForecastModelResponse: Partial<GetForecastModelResponse> | undefined | null = {}) : void {
    if (getForecastModelResponse) {
        writer.writeObjectValue<ForecastModelDto>("model", getForecastModelResponse.model, serializeForecastModelDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetIntegrationResponse(writer: SerializationWriter, getIntegrationResponse: Partial<GetIntegrationResponse> | undefined | null = {}) : void {
    if (getIntegrationResponse) {
        writer.writeObjectValue<GetIntegrationResponse_availableFields>("availableFields", getIntegrationResponse.availableFields, serializeGetIntegrationResponse_availableFields);
        writer.writeObjectValue<GetIntegrationResponse_configuration>("configuration", getIntegrationResponse.configuration, serializeGetIntegrationResponse_configuration);
        writer.writeDateValue("createdAt", getIntegrationResponse.createdAt);
        writer.writeStringValue("createdBy", getIntegrationResponse.createdBy);
        writer.writeStringValue("displayName", getIntegrationResponse.displayName);
        writer.writeStringValue("integrationId", getIntegrationResponse.integrationId);
        writer.writeEnumValue<IntegrationType>("integrationType", getIntegrationResponse.integrationType);
        writer.writeBooleanValue("isEnabled", getIntegrationResponse.isEnabled);
        writer.writeStringValue("organizationId", getIntegrationResponse.organizationId);
        writer.writeStringValue("provider", getIntegrationResponse.provider);
        writer.writeDateValue("updatedAt", getIntegrationResponse.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetIntegrationResponse_availableFields(writer: SerializationWriter, getIntegrationResponse_availableFields: Partial<GetIntegrationResponse_availableFields> | undefined | null = {}) : void {
    if (getIntegrationResponse_availableFields) {
        writer.writeAdditionalData(getIntegrationResponse_availableFields.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetIntegrationResponse_configuration(writer: SerializationWriter, getIntegrationResponse_configuration: Partial<GetIntegrationResponse_configuration> | undefined | null = {}) : void {
    if (getIntegrationResponse_configuration) {
        writer.writeAdditionalData(getIntegrationResponse_configuration.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetIntegrationTemplatesByTypeResponse(writer: SerializationWriter, getIntegrationTemplatesByTypeResponse: Partial<GetIntegrationTemplatesByTypeResponse> | undefined | null = {}) : void {
    if (getIntegrationTemplatesByTypeResponse) {
        writer.writeCollectionOfObjectValues<IntegrationTemplate>("templates", getIntegrationTemplatesByTypeResponse.templates, serializeIntegrationTemplate);
        writer.writeEnumValue<IntegrationType>("type", getIntegrationTemplatesByTypeResponse.type);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetInvoicesByIdsRequest(writer: SerializationWriter, getInvoicesByIdsRequest: Partial<GetInvoicesByIdsRequest> | undefined | null = {}) : void {
    if (getInvoicesByIdsRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("invoiceIds", getInvoicesByIdsRequest.invoiceIds);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", getInvoicesByIdsRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", getInvoicesByIdsRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetMapsTokenResponse(writer: SerializationWriter, getMapsTokenResponse: Partial<GetMapsTokenResponse> | undefined | null = {}) : void {
    if (getMapsTokenResponse) {
        writer.writeDateValue("expiresOn", getMapsTokenResponse.expiresOn);
        writer.writeStringValue("token", getMapsTokenResponse.token);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetOrderExportSettingsResponse(writer: SerializationWriter, getOrderExportSettingsResponse: Partial<GetOrderExportSettingsResponse> | undefined | null = {}) : void {
    if (getOrderExportSettingsResponse) {
        writer.writeCollectionOfObjectValues<AvailableExportFormatDto>("availableFormats", getOrderExportSettingsResponse.availableFormats, serializeAvailableExportFormatDto);
        writer.writeCollectionOfPrimitiveValues<string>("enabledCustomFormats", getOrderExportSettingsResponse.enabledCustomFormats);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetOrderInvoiceSummaryRequest(writer: SerializationWriter, getOrderInvoiceSummaryRequest: Partial<GetOrderInvoiceSummaryRequest> | undefined | null = {}) : void {
    if (getOrderInvoiceSummaryRequest) {
        writer.writeObjectValue<GetOrderInvoiceSummaryRequest_orderedQuantitiesBySku>("orderedQuantitiesBySku", getOrderInvoiceSummaryRequest.orderedQuantitiesBySku, serializeGetOrderInvoiceSummaryRequest_orderedQuantitiesBySku);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", getOrderInvoiceSummaryRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", getOrderInvoiceSummaryRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetOrderInvoiceSummaryRequest_orderedQuantitiesBySku(writer: SerializationWriter, getOrderInvoiceSummaryRequest_orderedQuantitiesBySku: Partial<GetOrderInvoiceSummaryRequest_orderedQuantitiesBySku> | undefined | null = {}) : void {
    if (getOrderInvoiceSummaryRequest_orderedQuantitiesBySku) {
        writer.writeAdditionalData(getOrderInvoiceSummaryRequest_orderedQuantitiesBySku.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetOrderKindsResponse(writer: SerializationWriter, getOrderKindsResponse: Partial<GetOrderKindsResponse> | undefined | null = {}) : void {
    if (getOrderKindsResponse) {
        writer.writeCollectionOfObjectValues<OrderKindDto>("kinds", getOrderKindsResponse.kinds, serializeOrderKindDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetOrderVolumeForecastResponse(writer: SerializationWriter, getOrderVolumeForecastResponse: Partial<GetOrderVolumeForecastResponse> | undefined | null = {}) : void {
    if (getOrderVolumeForecastResponse) {
        writer.writeCollectionOfObjectValues<MonthlyForecastPointDto>("forecast", getOrderVolumeForecastResponse.forecast, serializeMonthlyForecastPointDto);
        writer.writeDateValue("generatedAt", getOrderVolumeForecastResponse.generatedAt);
        writer.writeStringValue("modelId", getOrderVolumeForecastResponse.modelId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetOrderVolumeHistoryResponse(writer: SerializationWriter, getOrderVolumeHistoryResponse: Partial<GetOrderVolumeHistoryResponse> | undefined | null = {}) : void {
    if (getOrderVolumeHistoryResponse) {
        writer.writeCollectionOfObjectValues<OrderVolumeHistoryPointDto>("history", getOrderVolumeHistoryResponse.history, serializeOrderVolumeHistoryPointDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetOrganizationProfileResponse(writer: SerializationWriter, getOrganizationProfileResponse: Partial<GetOrganizationProfileResponse> | undefined | null = {}) : void {
    if (getOrganizationProfileResponse) {
        writer.writeStringValue("callerAccess", getOrganizationProfileResponse.callerAccess);
        writer.writeObjectValue<OrganizationProfileDto>("organization", getOrganizationProfileResponse.organization, serializeOrganizationProfileDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetOrganizationResponse(writer: SerializationWriter, getOrganizationResponse: Partial<GetOrganizationResponse> | undefined | null = {}) : void {
    if (getOrganizationResponse) {
        writer.writeCollectionOfObjectValues<ListOfEntitlements>("entitlements", getOrganizationResponse.entitlements, serializeListOfEntitlements);
        writer.writeObjectValue<Organization>("organization", getOrganizationResponse.organization, serializeOrganization);
        writer.writeCollectionOfObjectValues<Subscription2>("subscriptions", getOrganizationResponse.subscriptions, serializeSubscription2);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetProductsBySkusRequest(writer: SerializationWriter, getProductsBySkusRequest: Partial<GetProductsBySkusRequest> | undefined | null = {}) : void {
    if (getProductsBySkusRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("skus", getProductsBySkusRequest.skus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetResearchSettingsResponse(writer: SerializationWriter, getResearchSettingsResponse: Partial<GetResearchSettingsResponse> | undefined | null = {}) : void {
    if (getResearchSettingsResponse) {
        writer.writeStringValue("approvalCriteria", getResearchSettingsResponse.approvalCriteria);
        writer.writeStringValue("industryDescription", getResearchSettingsResponse.industryDescription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetSeatsResponse(writer: SerializationWriter, getSeatsResponse: Partial<GetSeatsResponse> | undefined | null = {}) : void {
    if (getSeatsResponse) {
        writer.writeNumberValue("activeReps", getSeatsResponse.activeReps);
        writer.writeNumberValue("billingPeriod", getSeatsResponse.billingPeriod);
        writer.writeStringValue("billingPeriodUnit", getSeatsResponse.billingPeriodUnit);
        writer.writeStringValue("currencyCode", getSeatsResponse.currencyCode);
        writer.writeCollectionOfObjectValues<SubscriptionDiscountLine>("discounts", getSeatsResponse.discounts, serializeSubscriptionDiscountLine);
        writer.writeBooleanValue("hasSeatsAvailable", getSeatsResponse.hasSeatsAvailable);
        writer.writeBooleanValue("hasSubscription", getSeatsResponse.hasSubscription);
        writer.writeBooleanValue("inTrial", getSeatsResponse.inTrial);
        writer.writeNumberValue("maxSeats", getSeatsResponse.maxSeats);
        writer.writeNumberValue("minSeats", getSeatsResponse.minSeats);
        writer.writeDateValue("nextBillingAt", getSeatsResponse.nextBillingAt);
        writer.writeCollectionOfPrimitiveValues<string>("nonBillableEmailDomains", getSeatsResponse.nonBillableEmailDomains);
        writer.writeStringValue("planName", getSeatsResponse.planName);
        writer.writeCollectionOfObjectValues<SubscriptionPlanLine>("plans", getSeatsResponse.plans, serializeSubscriptionPlanLine);
        writer.writeNumberValue("recurringSubtotal", getSeatsResponse.recurringSubtotal);
        writer.writeNumberValue("recurringTotal", getSeatsResponse.recurringTotal);
        writer.writeNumberValue("remaining", getSeatsResponse.remaining);
        writer.writeNumberValue("seats", getSeatsResponse.seats);
        writer.writeBooleanValue("seatsKnown", getSeatsResponse.seatsKnown);
        writer.writeNumberValue("seatStep", getSeatsResponse.seatStep);
        writer.writeNumberValue("seatUnitPrice", getSeatsResponse.seatUnitPrice);
        writer.writeStringValue("subscriptionStatus", getSeatsResponse.subscriptionStatus);
        writer.writeNumberValue("trialDaysRemaining", getSeatsResponse.trialDaysRemaining);
        writer.writeDateValue("trialEndsAt", getSeatsResponse.trialEndsAt);
        writer.writeStringValue("unavailableReason", getSeatsResponse.unavailableReason);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetSkuForecastResponse(writer: SerializationWriter, getSkuForecastResponse: Partial<GetSkuForecastResponse> | undefined | null = {}) : void {
    if (getSkuForecastResponse) {
        writer.writeCollectionOfObjectValues<MonthlyForecastPointDto>("forecast", getSkuForecastResponse.forecast, serializeMonthlyForecastPointDto);
        writer.writeDateValue("generatedAt", getSkuForecastResponse.generatedAt);
        writer.writeStringValue("modelId", getSkuForecastResponse.modelId);
        writer.writeStringValue("sku", getSkuForecastResponse.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetSkuHistoryResponse(writer: SerializationWriter, getSkuHistoryResponse: Partial<GetSkuHistoryResponse> | undefined | null = {}) : void {
    if (getSkuHistoryResponse) {
        writer.writeCollectionOfObjectValues<SkuHistoryPointDto>("history", getSkuHistoryResponse.history, serializeSkuHistoryPointDto);
        writer.writeStringValue("sku", getSkuHistoryResponse.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetTemplatesResponse(writer: SerializationWriter, getTemplatesResponse: Partial<GetTemplatesResponse> | undefined | null = {}) : void {
    if (getTemplatesResponse) {
        writer.writeCollectionOfObjectValues<IntegrationTemplate>("templates", getTemplatesResponse.templates, serializeIntegrationTemplate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGetUserProfileResponse(writer: SerializationWriter, getUserProfileResponse: Partial<GetUserProfileResponse> | undefined | null = {}) : void {
    if (getUserProfileResponse) {
        writer.writeStringValue("email", getUserProfileResponse.email);
        writer.writeStringValue("firstName", getUserProfileResponse.firstName);
        writer.writeStringValue("lastName", getUserProfileResponse.lastName);
        writer.writeStringValue("phoneNumber", getUserProfileResponse.phoneNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGiftInstruction(writer: SerializationWriter, giftInstruction: Partial<GiftInstruction> | undefined | null = {}) : void {
    if (giftInstruction) {
        writer.writeNumberValue("amount", giftInstruction.amount);
        writer.writeStringValue("campaignId", giftInstruction.campaignId);
        writer.writeObjectValue<GiftProductSnapshot>("product", giftInstruction.product, serializeGiftProductSnapshot);
        writer.writeStringValue("promotionId", giftInstruction.promotionId);
        writer.writeNumberValue("quantity", giftInstruction.quantity);
        writer.writeStringValue("sku", giftInstruction.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGiftMarker(writer: SerializationWriter, giftMarker: Partial<GiftMarker> | undefined | null = {}) : void {
    if (giftMarker) {
        writer.writeStringValue("campaignId", giftMarker.campaignId);
        writer.writeNumberValue("freeQuantity", giftMarker.freeQuantity);
        writer.writeStringValue("promotionId", giftMarker.promotionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGiftMarkerDto(writer: SerializationWriter, giftMarkerDto: Partial<GiftMarkerDto> | undefined | null = {}) : void {
    if (giftMarkerDto) {
        writer.writeStringValue("campaignId", giftMarkerDto.campaignId);
        writer.writeNumberValue("freeQuantity", giftMarkerDto.freeQuantity);
        writer.writeStringValue("promotionId", giftMarkerDto.promotionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeGiftProductSnapshot(writer: SerializationWriter, giftProductSnapshot: Partial<GiftProductSnapshot> | undefined | null = {}) : void {
    if (giftProductSnapshot) {
        writer.writeBooleanValue("active", giftProductSnapshot.active);
        writer.writeStringValue("imageName", giftProductSnapshot.imageName);
        writer.writeNumberValue("minimumOrderQuantity", giftProductSnapshot.minimumOrderQuantity);
        writer.writeStringValue("name", giftProductSnapshot.name);
        writer.writeNumberValue("quantityIncrement", giftProductSnapshot.quantityIncrement);
        writer.writeStringValue("sku", giftProductSnapshot.sku);
        writer.writeStringValue("taxCategory", giftProductSnapshot.taxCategory);
        writer.writeNumberValue("unitPrice", giftProductSnapshot.unitPrice);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeHeaderColumnMap(writer: SerializationWriter, headerColumnMap: Partial<HeaderColumnMap> | undefined | null = {}) : void {
    if (headerColumnMap) {
        writer.writeStringValue("header", headerColumnMap.header);
        writer.writeObjectValue<HeaderMapping>("mapping", headerColumnMap.mapping, serializeHeaderMapping);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeHeaderMapping(writer: SerializationWriter, headerMapping: Partial<HeaderMapping> | undefined | null = {}) : void {
    if (headerMapping) {
        writer.writeStringValue("mappedHeaderName", headerMapping.mappedHeaderName);
        writer.writeStringValue("uploadedHeaderName", headerMapping.uploadedHeaderName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeHeartbeatSqlConnectorRequest(writer: SerializationWriter, heartbeatSqlConnectorRequest: Partial<HeartbeatSqlConnectorRequest> | undefined | null = {}) : void {
    if (heartbeatSqlConnectorRequest) {
        writer.writeObjectValue<HeartbeatSqlConnectorRequest_metadata>("metadata", heartbeatSqlConnectorRequest.metadata, serializeHeartbeatSqlConnectorRequest_metadata);
        writer.writeEnumValue<ConnectorStatusType>("status", heartbeatSqlConnectorRequest.status);
        writer.writeStringValue("version", heartbeatSqlConnectorRequest.version);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeHeartbeatSqlConnectorRequest_metadata(writer: SerializationWriter, heartbeatSqlConnectorRequest_metadata: Partial<HeartbeatSqlConnectorRequest_metadata> | undefined | null = {}) : void {
    if (heartbeatSqlConnectorRequest_metadata) {
        writer.writeAdditionalData(heartbeatSqlConnectorRequest_metadata.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeHomeEndpoint_HomeResponse(writer: SerializationWriter, homeEndpoint_HomeResponse: Partial<HomeEndpoint_HomeResponse> | undefined | null = {}) : void {
    if (homeEndpoint_HomeResponse) {
        writer.writeStringValue("buildDate", homeEndpoint_HomeResponse.buildDate);
        writer.writeStringValue("contact", homeEndpoint_HomeResponse.contact);
        writer.writeStringValue("documentation", homeEndpoint_HomeResponse.documentation);
        writer.writeStringValue("message", homeEndpoint_HomeResponse.message);
        writer.writeStringValue("version", homeEndpoint_HomeResponse.version);
        writer.writeStringValue("website", homeEndpoint_HomeResponse.website);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImage(writer: SerializationWriter, image: Partial<Image> | undefined | null = {}) : void {
    if (image) {
        writer.writeStringValue("baseUrl", image.baseUrl);
        writer.writeStringValue("imageId", image.imageId);
        writer.writeStringValue("imageName", image.imageName);
        writer.writeStringValue("largeUrl", image.largeUrl);
        writer.writeStringValue("mediumUrl", image.mediumUrl);
        writer.writeNumberValue("position", image.position);
        writer.writeStringValue("smallUrl", image.smallUrl);
        writer.writeDateValue("uploadedAt", image.uploadedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageDetail(writer: SerializationWriter, imageDetail: Partial<ImageDetail> | undefined | null = {}) : void {
    if (imageDetail) {
        writer.writeBooleanValue("active", imageDetail.active);
        writer.writeStringValue("baseUrl", imageDetail.baseUrl);
        writer.writeNumberValue("contentSize", imageDetail.contentSize);
        writer.writeDateValue("createdAt", imageDetail.createdAt);
        writer.writeEnumValue<ImageFormat>("format", imageDetail.format);
        writer.writeNumberValue("height", imageDetail.height);
        writer.writeStringValue("id", imageDetail.id);
        writer.writeStringValue("largeUrl", imageDetail.largeUrl);
        writer.writeStringValue("mediumUrl", imageDetail.mediumUrl);
        writer.writeStringValue("name", imageDetail.name);
        writer.writeStringValue("organizationId", imageDetail.organizationId);
        writer.writeStringValue("smallUrl", imageDetail.smallUrl);
        writer.writeStringValue("source", imageDetail.source);
        writer.writeDateValue("updatedAt", imageDetail.updatedAt);
        writer.writeNumberValue("width", imageDetail.width);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageHousekeepingCleanUpRequest(writer: SerializationWriter, imageHousekeepingCleanUpRequest: Partial<ImageHousekeepingCleanUpRequest> | undefined | null = {}) : void {
    if (imageHousekeepingCleanUpRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("imageIds", imageHousekeepingCleanUpRequest.imageIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageHousekeepingCleanUpStatusResponse(writer: SerializationWriter, imageHousekeepingCleanUpStatusResponse: Partial<ImageHousekeepingCleanUpStatusResponse> | undefined | null = {}) : void {
    if (imageHousekeepingCleanUpStatusResponse) {
        writer.writeStringValue("errorMessage", imageHousekeepingCleanUpStatusResponse.errorMessage);
        writer.writeNumberValue("failed", imageHousekeepingCleanUpStatusResponse.failed);
        writer.writeBooleanValue("isSuccessfull", imageHousekeepingCleanUpStatusResponse.isSuccessfull);
        writer.writeNumberValue("requested", imageHousekeepingCleanUpStatusResponse.requested);
        writer.writeNumberValue("skippedFlipbookReferenced", imageHousekeepingCleanUpStatusResponse.skippedFlipbookReferenced);
        writer.writeNumberValue("skippedNotFound", imageHousekeepingCleanUpStatusResponse.skippedNotFound);
        writer.writeNumberValue("skippedTracked", imageHousekeepingCleanUpStatusResponse.skippedTracked);
        writer.writeNumberValue("trashed", imageHousekeepingCleanUpStatusResponse.trashed);
        writer.writeCollectionOfPrimitiveValues<string>("trashedImageIds", imageHousekeepingCleanUpStatusResponse.trashedImageIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageHousekeepingScanStatusResponse(writer: SerializationWriter, imageHousekeepingScanStatusResponse: Partial<ImageHousekeepingScanStatusResponse> | undefined | null = {}) : void {
    if (imageHousekeepingScanStatusResponse) {
        writer.writeNumberValue("abandonedAssets", imageHousekeepingScanStatusResponse.abandonedAssets);
        writer.writeCollectionOfPrimitiveValues<string>("abandonedImageIds", imageHousekeepingScanStatusResponse.abandonedImageIds);
        writer.writeStringValue("errorMessage", imageHousekeepingScanStatusResponse.errorMessage);
        writer.writeNumberValue("flipbookReferencedAssets", imageHousekeepingScanStatusResponse.flipbookReferencedAssets);
        writer.writeBooleanValue("isSuccessfull", imageHousekeepingScanStatusResponse.isSuccessfull);
        writer.writeNumberValue("totalAssets", imageHousekeepingScanStatusResponse.totalAssets);
        writer.writeNumberValue("trackedAssets", imageHousekeepingScanStatusResponse.trackedAssets);
        writer.writeCollectionOfObjectValues<ImageHousekeepingScanStatusResponse_TrashedAsset>("trashedAssets", imageHousekeepingScanStatusResponse.trashedAssets, serializeImageHousekeepingScanStatusResponse_TrashedAsset);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageHousekeepingScanStatusResponse_TrashedAsset(writer: SerializationWriter, imageHousekeepingScanStatusResponse_TrashedAsset: Partial<ImageHousekeepingScanStatusResponse_TrashedAsset> | undefined | null = {}) : void {
    if (imageHousekeepingScanStatusResponse_TrashedAsset) {
        writer.writeStringValue("imageId", imageHousekeepingScanStatusResponse_TrashedAsset.imageId);
        writer.writeStringValue("source", imageHousekeepingScanStatusResponse_TrashedAsset.source);
        writer.writeDateValue("trashedAt", imageHousekeepingScanStatusResponse_TrashedAsset.trashedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImagesCleanUpJobStatusResponse(writer: SerializationWriter, imagesCleanUpJobStatusResponse: Partial<ImagesCleanUpJobStatusResponse> | undefined | null = {}) : void {
    if (imagesCleanUpJobStatusResponse) {
        writer.writeStringValue("errorMessage", imagesCleanUpJobStatusResponse.errorMessage);
        writer.writeBooleanValue("isSuccessfull", imagesCleanUpJobStatusResponse.isSuccessfull);
        writer.writeNumberValue("totalImagesCleaned", imagesCleanUpJobStatusResponse.totalImagesCleaned);
        writer.writeNumberValue("totalOrganizations", imagesCleanUpJobStatusResponse.totalOrganizations);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageTrashPurgeJobRequest(writer: SerializationWriter, imageTrashPurgeJobRequest: Partial<ImageTrashPurgeJobRequest> | undefined | null = {}) : void {
    if (imageTrashPurgeJobRequest) {
        writer.writeBooleanValue("dryRun", imageTrashPurgeJobRequest.dryRun);
        writer.writeNumberValue("olderThanDays", imageTrashPurgeJobRequest.olderThanDays);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageTrashPurgeJobStatusResponse(writer: SerializationWriter, imageTrashPurgeJobStatusResponse: Partial<ImageTrashPurgeJobStatusResponse> | undefined | null = {}) : void {
    if (imageTrashPurgeJobStatusResponse) {
        writer.writeBooleanValue("dryRun", imageTrashPurgeJobStatusResponse.dryRun);
        writer.writeStringValue("errorMessage", imageTrashPurgeJobStatusResponse.errorMessage);
        writer.writeCollectionOfPrimitiveValues<string>("expiredImageIds", imageTrashPurgeJobStatusResponse.expiredImageIds);
        writer.writeBooleanValue("isSuccessfull", imageTrashPurgeJobStatusResponse.isSuccessfull);
        writer.writeNumberValue("retentionDays", imageTrashPurgeJobStatusResponse.retentionDays);
        writer.writeNumberValue("totalExpired", imageTrashPurgeJobStatusResponse.totalExpired);
        writer.writeNumberValue("totalPurged", imageTrashPurgeJobStatusResponse.totalPurged);
        writer.writeNumberValue("totalTrashed", imageTrashPurgeJobStatusResponse.totalTrashed);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageUploadItem(writer: SerializationWriter, imageUploadItem: Partial<ImageUploadItem> | undefined | null = {}) : void {
    if (imageUploadItem) {
        writer.writeBooleanValue("extractSkuFromImageName", imageUploadItem.extractSkuFromImageName);
        writer.writeStringValue("imageName", imageUploadItem.imageName);
        writer.writeStringValue("imageUrl", imageUploadItem.imageUrl);
        writer.writeStringValue("productSku", imageUploadItem.productSku);
        writer.writeStringValue("vendorCode", imageUploadItem.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageUploadResponse(writer: SerializationWriter, imageUploadResponse: Partial<ImageUploadResponse> | undefined | null = {}) : void {
    if (imageUploadResponse) {
        writer.writeStringValue("assignedTo", imageUploadResponse.assignedTo);
        writer.writeStringValue("assignedToKey", imageUploadResponse.assignedToKey);
        writer.writeStringValue("imageName", imageUploadResponse.imageName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImportColumnSample(writer: SerializationWriter, importColumnSample: Partial<ImportColumnSample> | undefined | null = {}) : void {
    if (importColumnSample) {
        writer.writeStringValue("header", importColumnSample.header);
        writer.writeCollectionOfPrimitiveValues<string>("samples", importColumnSample.samples);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIntegrationOAuthCallbackResponse(writer: SerializationWriter, integrationOAuthCallbackResponse: Partial<IntegrationOAuthCallbackResponse> | undefined | null = {}) : void {
    if (integrationOAuthCallbackResponse) {
        writer.writeStringValue("integrationId", integrationOAuthCallbackResponse.integrationId);
        writer.writeStringValue("message", integrationOAuthCallbackResponse.message);
        writer.writeBooleanValue("success", integrationOAuthCallbackResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIntegrationSummary(writer: SerializationWriter, integrationSummary: Partial<IntegrationSummary> | undefined | null = {}) : void {
    if (integrationSummary) {
        writer.writeObjectValue<IntegrationSummary_configuration>("configuration", integrationSummary.configuration, serializeIntegrationSummary_configuration);
        writer.writeDateValue("createdAt", integrationSummary.createdAt);
        writer.writeStringValue("displayName", integrationSummary.displayName);
        writer.writeStringValue("id", integrationSummary.id);
        writer.writeEnumValue<IntegrationType>("integrationType", integrationSummary.integrationType);
        writer.writeBooleanValue("isEnabled", integrationSummary.isEnabled);
        writer.writeDateValue("lastTestedAt", integrationSummary.lastTestedAt);
        writer.writeStringValue("organizationId", integrationSummary.organizationId);
        writer.writeStringValue("provider", integrationSummary.provider);
        writer.writeEnumValue<IntegrationTestStatus>("testStatus", integrationSummary.testStatus);
        writer.writeDateValue("updatedAt", integrationSummary.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIntegrationSummary_configuration(writer: SerializationWriter, integrationSummary_configuration: Partial<IntegrationSummary_configuration> | undefined | null = {}) : void {
    if (integrationSummary_configuration) {
        writer.writeAdditionalData(integrationSummary_configuration.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIntegrationTemplate(writer: SerializationWriter, integrationTemplate: Partial<IntegrationTemplate> | undefined | null = {}) : void {
    if (integrationTemplate) {
        writer.writeStringValue("callbackUrl", integrationTemplate.callbackUrl);
        writer.writeCollectionOfObjectValues<ConfigurationField>("configurationFields", integrationTemplate.configurationFields, serializeConfigurationField);
        writer.writeStringValue("description", integrationTemplate.description);
        writer.writeStringValue("displayName", integrationTemplate.displayName);
        writer.writeStringValue("documentationUrl", integrationTemplate.documentationUrl);
        writer.writeStringValue("logoUrl", integrationTemplate.logoUrl);
        writer.writeStringValue("provider", integrationTemplate.provider);
        writer.writeBooleanValue("requiresOAuth", integrationTemplate.requiresOAuth);
        writer.writeCollectionOfObjectValues<SecretField>("secretFields", integrationTemplate.secretFields, serializeSecretField);
        writer.writeCollectionOfPrimitiveValues<string>("supportedFeatures", integrationTemplate.supportedFeatures);
        writer.writeEnumValue<IntegrationType>("type", integrationTemplate.type);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInternalErrorResponse(writer: SerializationWriter, internalErrorResponse: Partial<InternalErrorResponse> | undefined | null = {}) : void {
    if (internalErrorResponse) {
        writer.writeNumberValue("code", internalErrorResponse.code);
        writer.writeStringValue("note", internalErrorResponse.note ?? "See application log for stack trace.");
        writer.writeStringValue("reason", internalErrorResponse.reason ?? "Something unexpected has happened");
        writer.writeStringValue("status", internalErrorResponse.status ?? "Internal Server Error!");
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoice(writer: SerializationWriter, invoice: Partial<Invoice> | undefined | null = {}) : void {
    if (invoice) {
        serializeBaseEntity(writer, invoice)
        writer.writeNumberValue("amountPaid", invoice.amountPaid);
        writer.writeStringValue("amountPaidFormatted", invoice.amountPaidFormatted);
        writer.writeNumberValue("balance", invoice.balance);
        writer.writeStringValue("balanceFormatted", invoice.balanceFormatted);
        writer.writeStringValue("currencyCode", invoice.currencyCode);
        writer.writeObjectValue<Customer3>("customer", invoice.customer, serializeCustomer3);
        writer.writeObjectValue<Discount>("discount", invoice.discount, serializeDiscount);
        writer.writeNumberValue("discountAmount", invoice.discountAmount);
        writer.writeStringValue("discountAmountFormatted", invoice.discountAmountFormatted);
        writer.writeDateValue("dueDate", invoice.dueDate);
        writer.writeStringValue("externalId", invoice.externalId);
        writer.writeStringValue("fulfillmentCenter", invoice.fulfillmentCenter);
        writer.writeStringValue("fulfillmentMethod", invoice.fulfillmentMethod);
        writer.writeStringValue("id", invoice.id);
        writer.writeNumberValue("importedBalance", invoice.importedBalance);
        writer.writeNumberValue("importedInvoiceTotal", invoice.importedInvoiceTotal);
        writer.writeDateValue("invoiceDate", invoice.invoiceDate);
        writer.writeStringValue("invoiceNumber", invoice.invoiceNumber);
        writer.writeNumberValue("invoiceTotal", invoice.invoiceTotal);
        writer.writeStringValue("invoiceTotalFormatted", invoice.invoiceTotalFormatted);
        writer.writeCollectionOfObjectValues<InvoiceItem>("items", invoice.items, serializeInvoiceItem);
        writer.writeStringValue("notes", invoice.notes);
        writer.writeNumberValue("numberOfPackages", invoice.numberOfPackages);
        writer.writeStringValue("orderId", invoice.orderId);
        writer.writeStringValue("orderNumber", invoice.orderNumber);
        writer.writeStringValue("organizationId", invoice.organizationId);
        writer.writeCollectionOfObjectValues<Payment>("payments", invoice.payments, serializePayment);
        writer.writeStringValue("poNumber", invoice.poNumber);
        writer.writeStringValue("primaryRepNumber", invoice.primaryRepNumber);
        writer.writeObjectValue<SalesRep2>("primarySalesRep", invoice.primarySalesRep, serializeSalesRep2);
        writer.writeNumberValue("shipping", invoice.shipping);
        writer.writeObjectValue<ShippingDetails>("shippingDetails", invoice.shippingDetails, serializeShippingDetails);
        writer.writeStringValue("shippingFormatted", invoice.shippingFormatted);
        writer.writeEnumValue<InvoiceStatus>("status", invoice.status);
        writer.writeNumberValue("subtotal", invoice.subtotal);
        writer.writeStringValue("subtotalFormatted", invoice.subtotalFormatted);
        writer.writeNumberValue("tax", invoice.tax);
        writer.writeStringValue("taxFormatted", invoice.taxFormatted);
        writer.writeCollectionOfObjectValues<TaxLineItem>("taxItems", invoice.taxItems, serializeTaxLineItem);
        writer.writeStringValue("terms", invoice.terms);
        writer.writeStringValue("trackingNumber", invoice.trackingNumber);
        writer.writeAdditionalData(invoice.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceAddressDto(writer: SerializationWriter, invoiceAddressDto: Partial<InvoiceAddressDto> | undefined | null = {}) : void {
    if (invoiceAddressDto) {
        writer.writeStringValue("address1", invoiceAddressDto.address1);
        writer.writeStringValue("address2", invoiceAddressDto.address2);
        writer.writeStringValue("addressType", invoiceAddressDto.addressType);
        writer.writeStringValue("city", invoiceAddressDto.city);
        writer.writeStringValue("code", invoiceAddressDto.code);
        writer.writeStringValue("country", invoiceAddressDto.country);
        writer.writeBooleanValue("default", invoiceAddressDto.defaultEscaped);
        writer.writeStringValue("externalId", invoiceAddressDto.externalId);
        writer.writeNumberValue("latitude", invoiceAddressDto.latitude);
        writer.writeNumberValue("longitude", invoiceAddressDto.longitude);
        writer.writeStringValue("stateProvince", invoiceAddressDto.stateProvince);
        writer.writeStringValue("zipPostalCode", invoiceAddressDto.zipPostalCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceCustomerDto(writer: SerializationWriter, invoiceCustomerDto: Partial<InvoiceCustomerDto> | undefined | null = {}) : void {
    if (invoiceCustomerDto) {
        writer.writeObjectValue<InvoiceAddressDto>("billingAddress", invoiceCustomerDto.billingAddress, serializeInvoiceAddressDto);
        writer.writeStringValue("companyEmail", invoiceCustomerDto.companyEmail);
        writer.writeStringValue("companyFax", invoiceCustomerDto.companyFax);
        writer.writeStringValue("companyName", invoiceCustomerDto.companyName);
        writer.writeStringValue("companyPhone", invoiceCustomerDto.companyPhone);
        writer.writeStringValue("customerNumber", invoiceCustomerDto.customerNumber);
        writer.writeObjectValue<InvoiceAddressDto>("shippingAddress", invoiceCustomerDto.shippingAddress, serializeInvoiceAddressDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceDiscountDto(writer: SerializationWriter, invoiceDiscountDto: Partial<InvoiceDiscountDto> | undefined | null = {}) : void {
    if (invoiceDiscountDto) {
        writer.writeStringValue("code", invoiceDiscountDto.code);
        writer.writeStringValue("description", invoiceDiscountDto.description);
        writer.writeStringValue("type", invoiceDiscountDto.type);
        writer.writeNumberValue("value", invoiceDiscountDto.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceDto(writer: SerializationWriter, invoiceDto: Partial<InvoiceDto> | undefined | null = {}) : void {
    if (invoiceDto) {
        writer.writeBooleanValue("active", invoiceDto.active);
        writer.writeNumberValue("amountPaid", invoiceDto.amountPaid);
        writer.writeStringValue("amountPaidFormatted", invoiceDto.amountPaidFormatted);
        writer.writeNumberValue("balance", invoiceDto.balance);
        writer.writeStringValue("balanceFormatted", invoiceDto.balanceFormatted);
        writer.writeDateValue("createdAt", invoiceDto.createdAt);
        writer.writeStringValue("currencyCode", invoiceDto.currencyCode);
        writer.writeObjectValue<InvoiceCustomerDto>("customer", invoiceDto.customer, serializeInvoiceCustomerDto);
        writer.writeObjectValue<InvoiceDiscountDto>("discount", invoiceDto.discount, serializeInvoiceDiscountDto);
        writer.writeNumberValue("discountAmount", invoiceDto.discountAmount);
        writer.writeStringValue("discountAmountFormatted", invoiceDto.discountAmountFormatted);
        writer.writeDateValue("dueDate", invoiceDto.dueDate);
        writer.writeStringValue("externalId", invoiceDto.externalId);
        writer.writeStringValue("fulfillmentCenter", invoiceDto.fulfillmentCenter);
        writer.writeStringValue("fulfillmentMethod", invoiceDto.fulfillmentMethod);
        writer.writeStringValue("id", invoiceDto.id);
        writer.writeNumberValue("importedBalance", invoiceDto.importedBalance);
        writer.writeNumberValue("importedInvoiceTotal", invoiceDto.importedInvoiceTotal);
        writer.writeDateValue("invoiceDate", invoiceDto.invoiceDate);
        writer.writeStringValue("invoiceNumber", invoiceDto.invoiceNumber);
        writer.writeNumberValue("invoiceTotal", invoiceDto.invoiceTotal);
        writer.writeStringValue("invoiceTotalFormatted", invoiceDto.invoiceTotalFormatted);
        writer.writeCollectionOfObjectValues<InvoiceItemDto>("items", invoiceDto.items, serializeInvoiceItemDto);
        writer.writeStringValue("notes", invoiceDto.notes);
        writer.writeNumberValue("numberOfPackages", invoiceDto.numberOfPackages);
        writer.writeStringValue("orderId", invoiceDto.orderId);
        writer.writeStringValue("orderNumber", invoiceDto.orderNumber);
        writer.writeStringValue("organizationId", invoiceDto.organizationId);
        writer.writeCollectionOfObjectValues<PaymentDto>("payments", invoiceDto.payments, serializePaymentDto);
        writer.writeStringValue("poNumber", invoiceDto.poNumber);
        writer.writeObjectValue<InvoiceSalesRepDto>("primarySalesRep", invoiceDto.primarySalesRep, serializeInvoiceSalesRepDto);
        writer.writeNumberValue("shipping", invoiceDto.shipping);
        writer.writeObjectValue<InvoiceShippingDetailsDto>("shippingDetails", invoiceDto.shippingDetails, serializeInvoiceShippingDetailsDto);
        writer.writeStringValue("shippingFormatted", invoiceDto.shippingFormatted);
        writer.writeStringValue("status", invoiceDto.status);
        writer.writeNumberValue("subtotal", invoiceDto.subtotal);
        writer.writeStringValue("subtotalFormatted", invoiceDto.subtotalFormatted);
        writer.writeNumberValue("tax", invoiceDto.tax);
        writer.writeStringValue("taxFormatted", invoiceDto.taxFormatted);
        writer.writeStringValue("terms", invoiceDto.terms);
        writer.writeStringValue("trackingNumber", invoiceDto.trackingNumber);
        writer.writeDateValue("updatedAt", invoiceDto.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceItem(writer: SerializationWriter, invoiceItem: Partial<InvoiceItem> | undefined | null = {}) : void {
    if (invoiceItem) {
        writer.writeStringValue("description", invoiceItem.description);
        writer.writeObjectValue<Discount>("discount", invoiceItem.discount, serializeDiscount);
        writer.writeNumberValue("discountAmount", invoiceItem.discountAmount);
        writer.writeStringValue("discountAmountFormatted", invoiceItem.discountAmountFormatted);
        writer.writeStringValue("externalId", invoiceItem.externalId);
        writer.writeStringValue("imageName", invoiceItem.imageName);
        writer.writeNumberValue("lineNumber", invoiceItem.lineNumber);
        writer.writeStringValue("orderItemSku", invoiceItem.orderItemSku);
        writer.writeNumberValue("price", invoiceItem.price);
        writer.writeStringValue("priceFormatted", invoiceItem.priceFormatted);
        writer.writeStringValue("productName", invoiceItem.productName);
        writer.writeNumberValue("qtyBackordered", invoiceItem.qtyBackordered);
        writer.writeNumberValue("quantity", invoiceItem.quantity);
        writer.writeStringValue("sku", invoiceItem.sku);
        writer.writeNumberValue("subTotal", invoiceItem.subTotal);
        writer.writeStringValue("subTotalFormatted", invoiceItem.subTotalFormatted);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceItemDto(writer: SerializationWriter, invoiceItemDto: Partial<InvoiceItemDto> | undefined | null = {}) : void {
    if (invoiceItemDto) {
        writer.writeStringValue("description", invoiceItemDto.description);
        writer.writeObjectValue<InvoiceDiscountDto>("discount", invoiceItemDto.discount, serializeInvoiceDiscountDto);
        writer.writeNumberValue("discountAmount", invoiceItemDto.discountAmount);
        writer.writeStringValue("discountAmountFormatted", invoiceItemDto.discountAmountFormatted);
        writer.writeStringValue("externalId", invoiceItemDto.externalId);
        writer.writeStringValue("imageName", invoiceItemDto.imageName);
        writer.writeNumberValue("lineNumber", invoiceItemDto.lineNumber);
        writer.writeStringValue("orderItemSku", invoiceItemDto.orderItemSku);
        writer.writeNumberValue("price", invoiceItemDto.price);
        writer.writeStringValue("priceFormatted", invoiceItemDto.priceFormatted);
        writer.writeStringValue("productName", invoiceItemDto.productName);
        writer.writeNumberValue("qtyBackordered", invoiceItemDto.qtyBackordered);
        writer.writeNumberValue("quantity", invoiceItemDto.quantity);
        writer.writeStringValue("sku", invoiceItemDto.sku);
        writer.writeNumberValue("subTotal", invoiceItemDto.subTotal);
        writer.writeStringValue("subTotalFormatted", invoiceItemDto.subTotalFormatted);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceItemInput(writer: SerializationWriter, invoiceItemInput: Partial<InvoiceItemInput> | undefined | null = {}) : void {
    if (invoiceItemInput) {
        writer.writeStringValue("description", invoiceItemInput.description);
        writer.writeObjectValue<DiscountInput>("discount", invoiceItemInput.discount, serializeDiscountInput);
        writer.writeStringValue("imageName", invoiceItemInput.imageName);
        writer.writeNumberValue("lineNumber", invoiceItemInput.lineNumber);
        writer.writeStringValue("orderItemSku", invoiceItemInput.orderItemSku);
        writer.writeNumberValue("price", invoiceItemInput.price);
        writer.writeStringValue("priceFormatted", invoiceItemInput.priceFormatted);
        writer.writeStringValue("productName", invoiceItemInput.productName);
        writer.writeNumberValue("qtyBackordered", invoiceItemInput.qtyBackordered);
        writer.writeNumberValue("quantity", invoiceItemInput.quantity);
        writer.writeStringValue("sku", invoiceItemInput.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceSalesRepDto(writer: SerializationWriter, invoiceSalesRepDto: Partial<InvoiceSalesRepDto> | undefined | null = {}) : void {
    if (invoiceSalesRepDto) {
        writer.writeStringValue("email", invoiceSalesRepDto.email);
        writer.writeStringValue("firstName", invoiceSalesRepDto.firstName);
        writer.writeStringValue("fullName", invoiceSalesRepDto.fullName);
        writer.writeStringValue("lastName", invoiceSalesRepDto.lastName);
        writer.writeStringValue("organizationSalesRepId", invoiceSalesRepDto.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", invoiceSalesRepDto.phoneNumber);
        writer.writeStringValue("repNumber", invoiceSalesRepDto.repNumber);
        writer.writeStringValue("salesRepId", invoiceSalesRepDto.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceShippingDetailsDto(writer: SerializationWriter, invoiceShippingDetailsDto: Partial<InvoiceShippingDetailsDto> | undefined | null = {}) : void {
    if (invoiceShippingDetailsDto) {
        writer.writeStringValue("method", invoiceShippingDetailsDto.method);
        writer.writeNumberValue("total", invoiceShippingDetailsDto.total);
        writer.writeStringValue("totalFormatted", invoiceShippingDetailsDto.totalFormatted);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoicesPageSummary(writer: SerializationWriter, invoicesPageSummary: Partial<InvoicesPageSummary> | undefined | null = {}) : void {
    if (invoicesPageSummary) {
        writer.writeDateValue("asOf", invoicesPageSummary.asOf);
        writer.writeNumberValue("averageDaysToPay", invoicesPageSummary.averageDaysToPay);
        writer.writeNumberValue("averageTermsDays", invoicesPageSummary.averageTermsDays);
        writer.writeNumberValue("collectedLast30Days", invoicesPageSummary.collectedLast30Days);
        writer.writeNumberValue("collectedPrior30Days", invoicesPageSummary.collectedPrior30Days);
        writer.writeNumberValue("currentBalance", invoicesPageSummary.currentBalance);
        writer.writeNumberValue("oldestOverdueDays", invoicesPageSummary.oldestOverdueDays);
        writer.writeNumberValue("outstandingBalance", invoicesPageSummary.outstandingBalance);
        writer.writeNumberValue("overdueBalance", invoicesPageSummary.overdueBalance);
        writer.writeNumberValue("overdueCount", invoicesPageSummary.overdueCount);
        writer.writeNumberValue("paidInvoicesMeasured", invoicesPageSummary.paidInvoicesMeasured);
        writer.writeNumberValue("pastDue1To30", invoicesPageSummary.pastDue1To30);
        writer.writeNumberValue("pastDue31To60", invoicesPageSummary.pastDue31To60);
        writer.writeNumberValue("pastDueOver60", invoicesPageSummary.pastDueOver60);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIssueInvoiceRequest(writer: SerializationWriter, issueInvoiceRequest: Partial<IssueInvoiceRequest> | undefined | null = {}) : void {
    if (issueInvoiceRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", issueInvoiceRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", issueInvoiceRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobAcceptedResponse(writer: SerializationWriter, jobAcceptedResponse: Partial<JobAcceptedResponse> | undefined | null = {}) : void {
    if (jobAcceptedResponse) {
        writer.writeStringValue("statusUri", jobAcceptedResponse.statusUri);
        writer.writeStringValue("trackingId", jobAcceptedResponse.trackingId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobResultOfAbandonedImageAssetsJobStatusResponse(writer: SerializationWriter, jobResultOfAbandonedImageAssetsJobStatusResponse: Partial<JobResultOfAbandonedImageAssetsJobStatusResponse> | undefined | null = {}) : void {
    if (jobResultOfAbandonedImageAssetsJobStatusResponse) {
        writer.writeStringValue("currentStatus", jobResultOfAbandonedImageAssetsJobStatusResponse.currentStatus);
        writer.writeNumberValue("currentStep", jobResultOfAbandonedImageAssetsJobStatusResponse.currentStep);
        writer.writeBooleanValue("isComplete", jobResultOfAbandonedImageAssetsJobStatusResponse.isComplete);
        writer.writeNumberValue("progressPercentage", jobResultOfAbandonedImageAssetsJobStatusResponse.progressPercentage);
        writer.writeObjectValue<AbandonedImageAssetsJobStatusResponse>("result", jobResultOfAbandonedImageAssetsJobStatusResponse.result, serializeAbandonedImageAssetsJobStatusResponse);
        writer.writeNumberValue("totalSteps", jobResultOfAbandonedImageAssetsJobStatusResponse.totalSteps);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobResultOfBulkImportCustomerUsersResponse(writer: SerializationWriter, jobResultOfBulkImportCustomerUsersResponse: Partial<JobResultOfBulkImportCustomerUsersResponse> | undefined | null = {}) : void {
    if (jobResultOfBulkImportCustomerUsersResponse) {
        writer.writeStringValue("currentStatus", jobResultOfBulkImportCustomerUsersResponse.currentStatus);
        writer.writeNumberValue("currentStep", jobResultOfBulkImportCustomerUsersResponse.currentStep);
        writer.writeBooleanValue("isComplete", jobResultOfBulkImportCustomerUsersResponse.isComplete);
        writer.writeNumberValue("progressPercentage", jobResultOfBulkImportCustomerUsersResponse.progressPercentage);
        writer.writeObjectValue<BulkImportCustomerUsersResponse>("result", jobResultOfBulkImportCustomerUsersResponse.result, serializeBulkImportCustomerUsersResponse);
        writer.writeNumberValue("totalSteps", jobResultOfBulkImportCustomerUsersResponse.totalSteps);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobResultOfDanglingAssignmentsCleanUpJobStatusResponse(writer: SerializationWriter, jobResultOfDanglingAssignmentsCleanUpJobStatusResponse: Partial<JobResultOfDanglingAssignmentsCleanUpJobStatusResponse> | undefined | null = {}) : void {
    if (jobResultOfDanglingAssignmentsCleanUpJobStatusResponse) {
        writer.writeStringValue("currentStatus", jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.currentStatus);
        writer.writeNumberValue("currentStep", jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.currentStep);
        writer.writeBooleanValue("isComplete", jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.isComplete);
        writer.writeNumberValue("progressPercentage", jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.progressPercentage);
        writer.writeObjectValue<DanglingAssignmentsCleanUpJobStatusResponse>("result", jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.result, serializeDanglingAssignmentsCleanUpJobStatusResponse);
        writer.writeNumberValue("totalSteps", jobResultOfDanglingAssignmentsCleanUpJobStatusResponse.totalSteps);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobResultOfImageHousekeepingCleanUpStatusResponse(writer: SerializationWriter, jobResultOfImageHousekeepingCleanUpStatusResponse: Partial<JobResultOfImageHousekeepingCleanUpStatusResponse> | undefined | null = {}) : void {
    if (jobResultOfImageHousekeepingCleanUpStatusResponse) {
        writer.writeStringValue("currentStatus", jobResultOfImageHousekeepingCleanUpStatusResponse.currentStatus);
        writer.writeNumberValue("currentStep", jobResultOfImageHousekeepingCleanUpStatusResponse.currentStep);
        writer.writeBooleanValue("isComplete", jobResultOfImageHousekeepingCleanUpStatusResponse.isComplete);
        writer.writeNumberValue("progressPercentage", jobResultOfImageHousekeepingCleanUpStatusResponse.progressPercentage);
        writer.writeObjectValue<ImageHousekeepingCleanUpStatusResponse>("result", jobResultOfImageHousekeepingCleanUpStatusResponse.result, serializeImageHousekeepingCleanUpStatusResponse);
        writer.writeNumberValue("totalSteps", jobResultOfImageHousekeepingCleanUpStatusResponse.totalSteps);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobResultOfImageHousekeepingScanStatusResponse(writer: SerializationWriter, jobResultOfImageHousekeepingScanStatusResponse: Partial<JobResultOfImageHousekeepingScanStatusResponse> | undefined | null = {}) : void {
    if (jobResultOfImageHousekeepingScanStatusResponse) {
        writer.writeStringValue("currentStatus", jobResultOfImageHousekeepingScanStatusResponse.currentStatus);
        writer.writeNumberValue("currentStep", jobResultOfImageHousekeepingScanStatusResponse.currentStep);
        writer.writeBooleanValue("isComplete", jobResultOfImageHousekeepingScanStatusResponse.isComplete);
        writer.writeNumberValue("progressPercentage", jobResultOfImageHousekeepingScanStatusResponse.progressPercentage);
        writer.writeObjectValue<ImageHousekeepingScanStatusResponse>("result", jobResultOfImageHousekeepingScanStatusResponse.result, serializeImageHousekeepingScanStatusResponse);
        writer.writeNumberValue("totalSteps", jobResultOfImageHousekeepingScanStatusResponse.totalSteps);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobResultOfImagesCleanUpJobStatusResponse(writer: SerializationWriter, jobResultOfImagesCleanUpJobStatusResponse: Partial<JobResultOfImagesCleanUpJobStatusResponse> | undefined | null = {}) : void {
    if (jobResultOfImagesCleanUpJobStatusResponse) {
        writer.writeStringValue("currentStatus", jobResultOfImagesCleanUpJobStatusResponse.currentStatus);
        writer.writeNumberValue("currentStep", jobResultOfImagesCleanUpJobStatusResponse.currentStep);
        writer.writeBooleanValue("isComplete", jobResultOfImagesCleanUpJobStatusResponse.isComplete);
        writer.writeNumberValue("progressPercentage", jobResultOfImagesCleanUpJobStatusResponse.progressPercentage);
        writer.writeObjectValue<ImagesCleanUpJobStatusResponse>("result", jobResultOfImagesCleanUpJobStatusResponse.result, serializeImagesCleanUpJobStatusResponse);
        writer.writeNumberValue("totalSteps", jobResultOfImagesCleanUpJobStatusResponse.totalSteps);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobResultOfImageTrashPurgeJobStatusResponse(writer: SerializationWriter, jobResultOfImageTrashPurgeJobStatusResponse: Partial<JobResultOfImageTrashPurgeJobStatusResponse> | undefined | null = {}) : void {
    if (jobResultOfImageTrashPurgeJobStatusResponse) {
        writer.writeStringValue("currentStatus", jobResultOfImageTrashPurgeJobStatusResponse.currentStatus);
        writer.writeNumberValue("currentStep", jobResultOfImageTrashPurgeJobStatusResponse.currentStep);
        writer.writeBooleanValue("isComplete", jobResultOfImageTrashPurgeJobStatusResponse.isComplete);
        writer.writeNumberValue("progressPercentage", jobResultOfImageTrashPurgeJobStatusResponse.progressPercentage);
        writer.writeObjectValue<ImageTrashPurgeJobStatusResponse>("result", jobResultOfImageTrashPurgeJobStatusResponse.result, serializeImageTrashPurgeJobStatusResponse);
        writer.writeNumberValue("totalSteps", jobResultOfImageTrashPurgeJobStatusResponse.totalSteps);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLineDiscountInstruction(writer: SerializationWriter, lineDiscountInstruction: Partial<LineDiscountInstruction> | undefined | null = {}) : void {
    if (lineDiscountInstruction) {
        writer.writeNumberValue("amount", lineDiscountInstruction.amount);
        writer.writeObjectValue<Discount>("discount", lineDiscountInstruction.discount, serializeDiscount);
        writer.writeStringValue("sku", lineDiscountInstruction.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLink(writer: SerializationWriter, link: Partial<Link> | undefined | null = {}) : void {
    if (link) {
        writer.writeStringValue("action", link.action);
        writer.writeStringValue("href", link.href);
        writer.writeStringValue("rel", link.rel);
        writer.writeCollectionOfPrimitiveValues<string>("types", link.types);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListApiAccessResponse(writer: SerializationWriter, listApiAccessResponse: Partial<ListApiAccessResponse> | undefined | null = {}) : void {
    if (listApiAccessResponse) {
        writer.writeCollectionOfObjectValues<ApiKey>("apiKeys", listApiAccessResponse.apiKeys, serializeApiKey);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListCategoriesResponse(writer: SerializationWriter, listCategoriesResponse: Partial<ListCategoriesResponse> | undefined | null = {}) : void {
    if (listCategoriesResponse) {
        writer.writeCollectionOfObjectValues<CategoryDto>("categories", listCategoriesResponse.categories, serializeCategoryDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListCustomerUserImportJobsResponse(writer: SerializationWriter, listCustomerUserImportJobsResponse: Partial<ListCustomerUserImportJobsResponse> | undefined | null = {}) : void {
    if (listCustomerUserImportJobsResponse) {
        writer.writeCollectionOfObjectValues<CustomerUserImportJobSummary>("jobs", listCustomerUserImportJobsResponse.jobs, serializeCustomerUserImportJobSummary);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListEmptyCategoriesResponse(writer: SerializationWriter, listEmptyCategoriesResponse: Partial<ListEmptyCategoriesResponse> | undefined | null = {}) : void {
    if (listEmptyCategoriesResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("categories", listEmptyCategoriesResponse.categories);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListExportFormatsResponse(writer: SerializationWriter, listExportFormatsResponse: Partial<ListExportFormatsResponse> | undefined | null = {}) : void {
    if (listExportFormatsResponse) {
        writer.writeCollectionOfObjectValues<ExportFormatDto>("formats", listExportFormatsResponse.formats, serializeExportFormatDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListForecastModelsResponse(writer: SerializationWriter, listForecastModelsResponse: Partial<ListForecastModelsResponse> | undefined | null = {}) : void {
    if (listForecastModelsResponse) {
        writer.writeCollectionOfObjectValues<ForecastModelDto>("models", listForecastModelsResponse.models, serializeForecastModelDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListIntegrationsResponse(writer: SerializationWriter, listIntegrationsResponse: Partial<ListIntegrationsResponse> | undefined | null = {}) : void {
    if (listIntegrationsResponse) {
        writer.writeCollectionOfObjectValues<IntegrationSummary>("integrations", listIntegrationsResponse.integrations, serializeIntegrationSummary);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListOfEntitlements(writer: SerializationWriter, listOfEntitlements: Partial<ListOfEntitlements> | undefined | null = {}) : void {
    if (listOfEntitlements) {
        writer.writeObjectValue<SubscriptionEntitlement>("subscriptionEntitlement", listOfEntitlements.subscriptionEntitlement, serializeSubscriptionEntitlement);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListOrderEmailsResponse(writer: SerializationWriter, listOrderEmailsResponse: Partial<ListOrderEmailsResponse> | undefined | null = {}) : void {
    if (listOrderEmailsResponse) {
        writer.writeCollectionOfObjectValues<SentEmailDto>("emails", listOrderEmailsResponse.emails, serializeSentEmailDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListOrganizationApiKeysResponse(writer: SerializationWriter, listOrganizationApiKeysResponse: Partial<ListOrganizationApiKeysResponse> | undefined | null = {}) : void {
    if (listOrganizationApiKeysResponse) {
        writer.writeCollectionOfObjectValues<OrganizationApiKeySummary>("apiKeys", listOrganizationApiKeysResponse.apiKeys, serializeOrganizationApiKeySummary);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListOrganizationSalesRepsResponse(writer: SerializationWriter, listOrganizationSalesRepsResponse: Partial<ListOrganizationSalesRepsResponse> | undefined | null = {}) : void {
    if (listOrganizationSalesRepsResponse) {
        writer.writeBooleanValue("active", listOrganizationSalesRepsResponse.active);
        writer.writeStringValue("appVersion", listOrganizationSalesRepsResponse.appVersion);
        writer.writeBooleanValue("canViewAllCustomers", listOrganizationSalesRepsResponse.canViewAllCustomers);
        writer.writeStringValue("email", listOrganizationSalesRepsResponse.email);
        writer.writeStringValue("firstName", listOrganizationSalesRepsResponse.firstName);
        writer.writeDateValue("lastLoginAt", listOrganizationSalesRepsResponse.lastLoginAt);
        writer.writeStringValue("lastName", listOrganizationSalesRepsResponse.lastName);
        writer.writeDateValue("lastSeenAt", listOrganizationSalesRepsResponse.lastSeenAt);
        writer.writeEnumValue<DiscountPermission>("lineItemDiscounts", listOrganizationSalesRepsResponse.lineItemDiscounts);
        writer.writeStringValue("marketCode", listOrganizationSalesRepsResponse.marketCode);
        writer.writeEnumValue<DiscountPermission>("orderDiscounts", listOrganizationSalesRepsResponse.orderDiscounts);
        writer.writeStringValue("organizationId", listOrganizationSalesRepsResponse.organizationId);
        writer.writeStringValue("organizationSalesRepId", listOrganizationSalesRepsResponse.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", listOrganizationSalesRepsResponse.phoneNumber);
        writer.writeStringValue("repNumber", listOrganizationSalesRepsResponse.repNumber);
        writer.writeCollectionOfPrimitiveValues<string>("repNumbers", listOrganizationSalesRepsResponse.repNumbers);
        writer.writeStringValue("salesRepId", listOrganizationSalesRepsResponse.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListProductTagsResponse(writer: SerializationWriter, listProductTagsResponse: Partial<ListProductTagsResponse> | undefined | null = {}) : void {
    if (listProductTagsResponse) {
        writer.writeCollectionOfObjectValues<ListProductTagsResponse_ProductTagDto>("tags", listProductTagsResponse.tags, serializeListProductTagsResponse_ProductTagDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListProductTagsResponse_ProductTagDto(writer: SerializationWriter, listProductTagsResponse_ProductTagDto: Partial<ListProductTagsResponse_ProductTagDto> | undefined | null = {}) : void {
    if (listProductTagsResponse_ProductTagDto) {
        writer.writeNumberValue("productCount", listProductTagsResponse_ProductTagDto.productCount);
        writer.writeStringValue("tag", listProductTagsResponse_ProductTagDto.tag);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListSalesRepDevicesResponse(writer: SerializationWriter, listSalesRepDevicesResponse: Partial<ListSalesRepDevicesResponse> | undefined | null = {}) : void {
    if (listSalesRepDevicesResponse) {
        writer.writeCollectionOfObjectValues<SalesRepDeviceDto>("devices", listSalesRepDevicesResponse.devices, serializeSalesRepDeviceDto);
        writer.writeStringValue("salesRepId", listSalesRepDevicesResponse.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListSalesRepOrganizationsResponse(writer: SerializationWriter, listSalesRepOrganizationsResponse: Partial<ListSalesRepOrganizationsResponse> | undefined | null = {}) : void {
    if (listSalesRepOrganizationsResponse) {
        writer.writeCollectionOfObjectValues<OrganizationSalesRep>("salesRepOrganizations", listSalesRepOrganizationsResponse.salesRepOrganizations, serializeOrganizationSalesRep);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListSqlConnectorsResponse(writer: SerializationWriter, listSqlConnectorsResponse: Partial<ListSqlConnectorsResponse> | undefined | null = {}) : void {
    if (listSqlConnectorsResponse) {
        writer.writeCollectionOfObjectValues<SqlConnectorStatus>("connectors", listSqlConnectorsResponse.connectors, serializeSqlConnectorStatus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListSubCategoriesResponse(writer: SerializationWriter, listSubCategoriesResponse: Partial<ListSubCategoriesResponse> | undefined | null = {}) : void {
    if (listSubCategoriesResponse) {
        writer.writeCollectionOfObjectValues<CategoryDto>("categories", listSubCategoriesResponse.categories, serializeCategoryDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeListUserOrganizationsResponse(writer: SerializationWriter, listUserOrganizationsResponse: Partial<ListUserOrganizationsResponse> | undefined | null = {}) : void {
    if (listUserOrganizationsResponse) {
        writer.writeCollectionOfObjectValues<UserOrganizationDto>("organizations", listUserOrganizationsResponse.organizations, serializeUserOrganizationDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLookupAddressRequest(writer: SerializationWriter, lookupAddressRequest: Partial<LookupAddressRequest> | undefined | null = {}) : void {
    if (lookupAddressRequest) {
        writer.writeStringValue("country", lookupAddressRequest.country);
        writer.writeStringValue("query", lookupAddressRequest.query);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLookupAddressResponse(writer: SerializationWriter, lookupAddressResponse: Partial<LookupAddressResponse> | undefined | null = {}) : void {
    if (lookupAddressResponse) {
        writer.writeCollectionOfObjectValues<Prediction>("predictions", lookupAddressResponse.predictions, serializePrediction);
        writer.writeStringValue("status", lookupAddressResponse.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMappingAlternate(writer: SerializationWriter, mappingAlternate: Partial<MappingAlternate> | undefined | null = {}) : void {
    if (mappingAlternate) {
        writer.writeNumberValue("probability", mappingAlternate.probability);
        writer.writeStringValue("target", mappingAlternate.target);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMappingCreateProposal(writer: SerializationWriter, mappingCreateProposal: Partial<MappingCreateProposal> | undefined | null = {}) : void {
    if (mappingCreateProposal) {
        writer.writeStringValue("currencyCode", mappingCreateProposal.currencyCode);
        writer.writeStringValue("kind", mappingCreateProposal.kind);
        writer.writeStringValue("name", mappingCreateProposal.name);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMappingOutcomeColumn(writer: SerializationWriter, mappingOutcomeColumn: Partial<MappingOutcomeColumn> | undefined | null = {}) : void {
    if (mappingOutcomeColumn) {
        writer.writeStringValue("header", mappingOutcomeColumn.header);
        writer.writeStringValue("target", mappingOutcomeColumn.target);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMarkOrdersExportedRequest(writer: SerializationWriter, markOrdersExportedRequest: Partial<MarkOrdersExportedRequest> | undefined | null = {}) : void {
    if (markOrdersExportedRequest) {
        writer.writeStringValue("exportedBy", markOrdersExportedRequest.exportedBy);
        writer.writeCollectionOfPrimitiveValues<string>("orderIds", markOrdersExportedRequest.orderIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMarkOrdersExportedResponse(writer: SerializationWriter, markOrdersExportedResponse: Partial<MarkOrdersExportedResponse> | undefined | null = {}) : void {
    if (markOrdersExportedResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("notFound", markOrdersExportedResponse.notFound);
        writer.writeCollectionOfObjectValues<ExportedOrderDto>("orders", markOrdersExportedResponse.orders, serializeExportedOrderDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMarkPaidRequest(writer: SerializationWriter, markPaidRequest: Partial<MarkPaidRequest> | undefined | null = {}) : void {
    if (markPaidRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", markPaidRequest.orgCodes);
        writer.writeStringValue("paymentReference", markPaidRequest.paymentReference);
        writer.writeStringValue("useOrganizationId", markPaidRequest.useOrganizationId);
        writer.writeStringValue("user", markPaidRequest.user);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMatchedSubstring(writer: SerializationWriter, matchedSubstring: Partial<MatchedSubstring> | undefined | null = {}) : void {
    if (matchedSubstring) {
        writer.writeNumberValue("length", matchedSubstring.length);
        writer.writeNumberValue("offset", matchedSubstring.offset);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMessageAttachment(writer: SerializationWriter, messageAttachment: Partial<MessageAttachment> | undefined | null = {}) : void {
    if (messageAttachment) {
        writer.writeStringValue("attachmentId", messageAttachment.attachmentId);
        writer.writeStringValue("mimeType", messageAttachment.mimeType);
        writer.writeStringValue("name", messageAttachment.name);
        writer.writeNumberValue("size", messageAttachment.size);
        writer.writeStringValue("url", messageAttachment.url);
        writer.writeDateValue("urlExpiresAt", messageAttachment.urlExpiresAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMessageMetadata(writer: SerializationWriter, messageMetadata: Partial<MessageMetadata> | undefined | null = {}) : void {
    if (messageMetadata) {
        writer.writeStringValue("ipAddress", messageMetadata.ipAddress);
        writer.writeStringValue("userAgent", messageMetadata.userAgent);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeModelMetrics(writer: SerializationWriter, modelMetrics: Partial<ModelMetrics> | undefined | null = {}) : void {
    if (modelMetrics) {
        writer.writeNumberValue("meanAbsoluteError", modelMetrics.meanAbsoluteError);
        writer.writeNumberValue("meanAbsolutePercentageError", modelMetrics.meanAbsolutePercentageError);
        writer.writeNumberValue("rootMeanSquaredError", modelMetrics.rootMeanSquaredError);
        writer.writeNumberValue("trainingDurationMs", modelMetrics.trainingDurationMs);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMonthlyForecastPointDto(writer: SerializationWriter, monthlyForecastPointDto: Partial<MonthlyForecastPointDto> | undefined | null = {}) : void {
    if (monthlyForecastPointDto) {
        writer.writeNumberValue("confidenceLowerBound", monthlyForecastPointDto.confidenceLowerBound);
        writer.writeNumberValue("confidenceUpperBound", monthlyForecastPointDto.confidenceUpperBound);
        writer.writeNumberValue("month", monthlyForecastPointDto.month);
        writer.writeNumberValue("predictedUnits", monthlyForecastPointDto.predictedUnits);
        writer.writeNumberValue("year", monthlyForecastPointDto.year);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMonthlyOrderTrend(writer: SerializationWriter, monthlyOrderTrend: Partial<MonthlyOrderTrend> | undefined | null = {}) : void {
    if (monthlyOrderTrend) {
        writer.writeNumberValue("month", monthlyOrderTrend.month);
        writer.writeNumberValue("orderCount", monthlyOrderTrend.orderCount);
        writer.writeDateValue("periodStart", monthlyOrderTrend.periodStart);
        writer.writeNumberValue("year", monthlyOrderTrend.year);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMonthlyRevenueTrend(writer: SerializationWriter, monthlyRevenueTrend: Partial<MonthlyRevenueTrend> | undefined | null = {}) : void {
    if (monthlyRevenueTrend) {
        writer.writeNumberValue("month", monthlyRevenueTrend.month);
        writer.writeDateValue("periodStart", monthlyRevenueTrend.periodStart);
        writer.writeNumberValue("totalRevenue", monthlyRevenueTrend.totalRevenue);
        writer.writeNumberValue("year", monthlyRevenueTrend.year);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMoveDocumentRequest(writer: SerializationWriter, moveDocumentRequest: Partial<MoveDocumentRequest> | undefined | null = {}) : void {
    if (moveDocumentRequest) {
        writer.writeStringValue("targetFolderId", moveDocumentRequest.targetFolderId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOk(writer: SerializationWriter, ok: Partial<Ok> | undefined | null = {}) : void {
    if (ok) {
        writer.writeNumberValue("statusCode", ok.statusCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOpenPipeline(writer: SerializationWriter, openPipeline: Partial<OpenPipeline> | undefined | null = {}) : void {
    if (openPipeline) {
        writer.writeDateValue("asOf", openPipeline.asOf);
        writer.writeStringValue("initialOrderStatus", openPipeline.initialOrderStatus);
        writer.writeNumberValue("oldestOverdueDays", openPipeline.oldestOverdueDays);
        writer.writeNumberValue("overdueBalance", openPipeline.overdueBalance);
        writer.writeNumberValue("overdueInvoiceCount", openPipeline.overdueInvoiceCount);
        writer.writeCollectionOfObjectValues<PipelineStage>("stages", openPipeline.stages, serializePipelineStage);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrder(writer: SerializationWriter, order: Partial<Order> | undefined | null = {}) : void {
    if (order) {
        serializeBaseEntity(writer, order)
        writer.writeStringValue("appliedCode", order.appliedCode);
        writer.writeCollectionOfObjectValues<AppliedPromotion>("appliedPromotions", order.appliedPromotions, serializeAppliedPromotion);
        writer.writeDateOnlyValue("cancelDate", order.cancelDate);
        writer.writeStringValue("cardType", order.cardType);
        writer.writeStringValue("channel", order.channel);
        writer.writeStringValue("currencyCode", order.currencyCode);
        writer.writeObjectValue<Customer2>("customer", order.customer, serializeCustomer2);
        writer.writeObjectValue<Discount>("discount", order.discount, serializeDiscount);
        writer.writeNumberValue("discountAmount", order.discountAmount);
        writer.writeStringValue("discountAmountFormatted", order.discountAmountFormatted);
        writer.writeBooleanValue("exported", order.exported);
        writer.writeDateValue("exportedAt", order.exportedAt);
        writer.writeStringValue("exportedBy", order.exportedBy);
        writer.writeStringValue("externalId", order.externalId);
        writer.writeObjectValue<FreeShippingEntitlement>("freeShipping", order.freeShipping, serializeFreeShippingEntitlement);
        writer.writeStringValue("fulfillmentCenter", order.fulfillmentCenter);
        writer.writeStringValue("fulfillmentMethod", order.fulfillmentMethod);
        writer.writeStringValue("id", order.id);
        writer.writeCollectionOfObjectValues<OrderItem>("items", order.items, serializeOrderItem);
        writer.writeStringValue("last4Digits", order.last4Digits);
        writer.writeStringValue("marketCode", order.marketCode);
        writer.writeStringValue("notes", order.notes);
        writer.writeStringValue("noteToVendor", order.noteToVendor);
        writer.writeStringValue("orderBatchId", order.orderBatchId);
        writer.writeDateValue("orderDate", order.orderDate);
        writer.writeEnumValue<OrderKind>("orderKind", order.orderKind);
        writer.writeStringValue("orderNumber", order.orderNumber);
        writer.writeStringValue("orderStatus", order.orderStatus);
        writer.writeNumberValue("orderTotal", order.orderTotal);
        writer.writeStringValue("orderTotalFormatted", order.orderTotalFormatted);
        writer.writeStringValue("orderType", order.orderType);
        writer.writeStringValue("organizationId", order.organizationId);
        writer.writeStringValue("originationCartId", order.originationCartId);
        writer.writeStringValue("paymentProfileId", order.paymentProfileId);
        writer.writeStringValue("poNumber", order.poNumber);
        writer.writeStringValue("priceTier", order.priceTier);
        writer.writeObjectValue<SalesRep>("primarySalesRep", order.primarySalesRep, serializeSalesRep);
        writer.writeCollectionOfPrimitiveValues<string>("receiptTo", order.receiptTo);
        writer.writeDateOnlyValue("shipDate", order.shipDate);
        writer.writeObjectValue<ShippingDetails>("shippingDetails", order.shippingDetails, serializeShippingDetails);
        writer.writeStringValue("shippingFormatted", order.shippingFormatted);
        writer.writeStringValue("shipWindowName", order.shipWindowName);
        writer.writeStringValue("signatureUrl", order.signatureUrl);
        writer.writeStringValue("submittedVia", order.submittedVia);
        writer.writeNumberValue("subtotal", order.subtotal);
        writer.writeStringValue("subtotalFormatted", order.subtotalFormatted);
        writer.writeObjectValue<SalesRep>("takenBySalesRep", order.takenBySalesRep, serializeSalesRep);
        writer.writeNumberValue("tax", order.tax);
        writer.writeStringValue("taxFormatted", order.taxFormatted);
        writer.writeCollectionOfObjectValues<TaxLineItem>("taxItems", order.taxItems, serializeTaxLineItem);
        writer.writeStringValue("terms", order.terms);
        writer.writeObjectValue<User2>("user", order.user, serializeUser2);
        writer.writeStringValue("vendorCode", order.vendorCode);
        writer.writeAdditionalData(order.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderBatchResponse(writer: SerializationWriter, orderBatchResponse: Partial<OrderBatchResponse> | undefined | null = {}) : void {
    if (orderBatchResponse) {
        writer.writeStringValue("customerNumber", orderBatchResponse.customerNumber);
        writer.writeBooleanValue("hasSignature", orderBatchResponse.hasSignature);
        writer.writeStringValue("orderBatchId", orderBatchResponse.orderBatchId);
        writer.writeCollectionOfObjectValues<OrderDto>("orders", orderBatchResponse.orders, serializeOrderDto);
        writer.writeStringValue("originationCartId", orderBatchResponse.originationCartId);
        writer.writeDateValue("placedAt", orderBatchResponse.placedAt);
        writer.writeObjectValue<SalesRep>("placedBy", orderBatchResponse.placedBy, serializeSalesRep);
        writer.writeCollectionOfPrimitiveValues<string>("receiptTo", orderBatchResponse.receiptTo);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderDto(writer: SerializationWriter, orderDto: Partial<OrderDto> | undefined | null = {}) : void {
    if (orderDto) {
        writer.writeBooleanValue("active", orderDto.active);
        writer.writeStringValue("appliedCode", orderDto.appliedCode);
        writer.writeCollectionOfObjectValues<AppliedPromotion>("appliedPromotions", orderDto.appliedPromotions, serializeAppliedPromotion);
        writer.writeDateOnlyValue("cancelDate", orderDto.cancelDate);
        writer.writeStringValue("channel", orderDto.channel);
        writer.writeDateValue("createdAt", orderDto.createdAt);
        writer.writeStringValue("currencyCode", orderDto.currencyCode);
        writer.writeObjectValue<CustomerDto>("customer", orderDto.customer, serializeCustomerDto);
        writer.writeObjectValue<DiscountDto>("discount", orderDto.discount, serializeDiscountDto);
        writer.writeNumberValue("discountAmount", orderDto.discountAmount);
        writer.writeStringValue("discountAmountFormatted", orderDto.discountAmountFormatted);
        writer.writeBooleanValue("exported", orderDto.exported);
        writer.writeDateValue("exportedAt", orderDto.exportedAt);
        writer.writeStringValue("exportedBy", orderDto.exportedBy);
        writer.writeStringValue("externalId", orderDto.externalId);
        writer.writeObjectValue<FreeShippingEntitlement>("freeShipping", orderDto.freeShipping, serializeFreeShippingEntitlement);
        writer.writeStringValue("fulfillmentCenter", orderDto.fulfillmentCenter);
        writer.writeStringValue("fulfillmentMethod", orderDto.fulfillmentMethod);
        writer.writeBooleanValue("hasSignature", orderDto.hasSignature);
        writer.writeStringValue("id", orderDto.id);
        writer.writeCollectionOfObjectValues<OrderItemDto>("items", orderDto.items, serializeOrderItemDto);
        writer.writeStringValue("marketCode", orderDto.marketCode);
        writer.writeStringValue("notes", orderDto.notes);
        writer.writeStringValue("noteToVendor", orderDto.noteToVendor);
        writer.writeStringValue("orderBatchId", orderDto.orderBatchId);
        writer.writeDateValue("orderDate", orderDto.orderDate);
        writer.writeEnumValue<OrderKind>("orderKind", orderDto.orderKind);
        writer.writeStringValue("orderNumber", orderDto.orderNumber);
        writer.writeStringValue("orderStatus", orderDto.orderStatus);
        writer.writeNumberValue("orderTotal", orderDto.orderTotal);
        writer.writeStringValue("orderTotalFormatted", orderDto.orderTotalFormatted);
        writer.writeStringValue("orderType", orderDto.orderType);
        writer.writeObjectValue<OrganizationInfo>("organization", orderDto.organization, serializeOrganizationInfo);
        writer.writeStringValue("organizationId", orderDto.organizationId);
        writer.writeStringValue("originationCartId", orderDto.originationCartId);
        writer.writeStringValue("poNumber", orderDto.poNumber);
        writer.writeStringValue("priceTier", orderDto.priceTier);
        writer.writeObjectValue<SalesRepDto>("primarySalesRep", orderDto.primarySalesRep, serializeSalesRepDto);
        writer.writeCollectionOfPrimitiveValues<string>("receiptTo", orderDto.receiptTo);
        writer.writeDateOnlyValue("shipDate", orderDto.shipDate);
        writer.writeObjectValue<ShippingDetailsDto>("shippingDetails", orderDto.shippingDetails, serializeShippingDetailsDto);
        writer.writeStringValue("shippingFormatted", orderDto.shippingFormatted);
        writer.writeStringValue("shipWindowName", orderDto.shipWindowName);
        writer.writeStringValue("submittedVia", orderDto.submittedVia);
        writer.writeNumberValue("subtotal", orderDto.subtotal);
        writer.writeStringValue("subtotalFormatted", orderDto.subtotalFormatted);
        writer.writeObjectValue<SalesRepDto>("takenBySalesRep", orderDto.takenBySalesRep, serializeSalesRepDto);
        writer.writeNumberValue("tax", orderDto.tax);
        writer.writeStringValue("taxFormatted", orderDto.taxFormatted);
        writer.writeStringValue("terms", orderDto.terms);
        writer.writeDateValue("updatedAt", orderDto.updatedAt);
        writer.writeObjectValue<UserDto>("user", orderDto.user, serializeUserDto);
        writer.writeStringValue("vendorCode", orderDto.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderExportSettings(writer: SerializationWriter, orderExportSettings: Partial<OrderExportSettings> | undefined | null = {}) : void {
    if (orderExportSettings) {
        writer.writeCollectionOfPrimitiveValues<string>("enabledCustomFormats", orderExportSettings.enabledCustomFormats);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderInvoiceLineSummaryDto(writer: SerializationWriter, orderInvoiceLineSummaryDto: Partial<OrderInvoiceLineSummaryDto> | undefined | null = {}) : void {
    if (orderInvoiceLineSummaryDto) {
        writer.writeNumberValue("invoicedQuantity", orderInvoiceLineSummaryDto.invoicedQuantity);
        writer.writeNumberValue("orderedQuantity", orderInvoiceLineSummaryDto.orderedQuantity);
        writer.writeNumberValue("remainingQuantity", orderInvoiceLineSummaryDto.remainingQuantity);
        writer.writeStringValue("sku", orderInvoiceLineSummaryDto.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderInvoiceSummaryDto(writer: SerializationWriter, orderInvoiceSummaryDto: Partial<OrderInvoiceSummaryDto> | undefined | null = {}) : void {
    if (orderInvoiceSummaryDto) {
        writer.writeStringValue("currencyCode", orderInvoiceSummaryDto.currencyCode);
        writer.writeStringValue("fulfillmentStatus", orderInvoiceSummaryDto.fulfillmentStatus);
        writer.writeNumberValue("invoiceCount", orderInvoiceSummaryDto.invoiceCount);
        writer.writeCollectionOfObjectValues<OrderInvoiceLineSummaryDto>("lines", orderInvoiceSummaryDto.lines, serializeOrderInvoiceLineSummaryDto);
        writer.writeStringValue("orderId", orderInvoiceSummaryDto.orderId);
        writer.writeNumberValue("totalBalance", orderInvoiceSummaryDto.totalBalance);
        writer.writeStringValue("totalBalanceFormatted", orderInvoiceSummaryDto.totalBalanceFormatted);
        writer.writeNumberValue("totalInvoiced", orderInvoiceSummaryDto.totalInvoiced);
        writer.writeStringValue("totalInvoicedFormatted", orderInvoiceSummaryDto.totalInvoicedFormatted);
        writer.writeNumberValue("totalPaid", orderInvoiceSummaryDto.totalPaid);
        writer.writeStringValue("totalPaidFormatted", orderInvoiceSummaryDto.totalPaidFormatted);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderItem(writer: SerializationWriter, orderItem: Partial<OrderItem> | undefined | null = {}) : void {
    if (orderItem) {
        writer.writeCollectionOfPrimitiveValues<string>("categoryPaths", orderItem.categoryPaths);
        writer.writeObjectValue<Discount>("discount", orderItem.discount, serializeDiscount);
        writer.writeNumberValue("discountAmount", orderItem.discountAmount);
        writer.writeStringValue("discountAmountFormatted", orderItem.discountAmountFormatted);
        writer.writeStringValue("externalId", orderItem.externalId);
        writer.writeObjectValue<GiftMarker>("gift", orderItem.gift, serializeGiftMarker);
        writer.writeStringValue("imageName", orderItem.imageName);
        writer.writeStringValue("lineId", orderItem.lineId);
        writer.writeNumberValue("lineNumber", orderItem.lineNumber);
        writer.writeNumberValue("minimumOrderQuantity", orderItem.minimumOrderQuantity);
        writer.writeStringValue("note", orderItem.note);
        writer.writeNumberValue("openQuantity", orderItem.openQuantity);
        writer.writeNumberValue("price", orderItem.price);
        writer.writeStringValue("priceFormatted", orderItem.priceFormatted);
        writer.writeObjectValue<PriceOverride>("priceOverride", orderItem.priceOverride, serializePriceOverride);
        writer.writeStringValue("productName", orderItem.productName);
        writer.writeNumberValue("quantity", orderItem.quantity);
        writer.writeNumberValue("quantityIncrement", orderItem.quantityIncrement);
        writer.writeStringValue("sku", orderItem.sku);
        writer.writeNumberValue("subTotal", orderItem.subTotal);
        writer.writeStringValue("subTotalFormatted", orderItem.subTotalFormatted);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderItemDto(writer: SerializationWriter, orderItemDto: Partial<OrderItemDto> | undefined | null = {}) : void {
    if (orderItemDto) {
        writer.writeCollectionOfPrimitiveValues<string>("categoryPaths", orderItemDto.categoryPaths);
        writer.writeObjectValue<DiscountDto>("discount", orderItemDto.discount, serializeDiscountDto);
        writer.writeNumberValue("discountAmount", orderItemDto.discountAmount);
        writer.writeStringValue("discountAmountFormatted", orderItemDto.discountAmountFormatted);
        writer.writeStringValue("externalId", orderItemDto.externalId);
        writer.writeObjectValue<GiftMarkerDto>("gift", orderItemDto.gift, serializeGiftMarkerDto);
        writer.writeStringValue("imageName", orderItemDto.imageName);
        writer.writeStringValue("lineId", orderItemDto.lineId);
        writer.writeNumberValue("lineNumber", orderItemDto.lineNumber);
        writer.writeNumberValue("minimumOrderQuantity", orderItemDto.minimumOrderQuantity);
        writer.writeStringValue("note", orderItemDto.note);
        writer.writeNumberValue("openQuantity", orderItemDto.openQuantity);
        writer.writeNumberValue("paidQuantity", orderItemDto.paidQuantity);
        writer.writeNumberValue("price", orderItemDto.price);
        writer.writeStringValue("priceFormatted", orderItemDto.priceFormatted);
        writer.writeObjectValue<PriceOverrideDto>("priceOverride", orderItemDto.priceOverride, serializePriceOverrideDto);
        writer.writeStringValue("productName", orderItemDto.productName);
        writer.writeNumberValue("quantity", orderItemDto.quantity);
        writer.writeNumberValue("quantityIncrement", orderItemDto.quantityIncrement);
        writer.writeStringValue("sku", orderItemDto.sku);
        writer.writeNumberValue("subTotal", orderItemDto.subTotal);
        writer.writeStringValue("subTotalFormatted", orderItemDto.subTotalFormatted);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderItemInput(writer: SerializationWriter, orderItemInput: Partial<OrderItemInput> | undefined | null = {}) : void {
    if (orderItemInput) {
        writer.writeObjectValue<Discount>("discount", orderItemInput.discount, serializeDiscount);
        writer.writeStringValue("externalId", orderItemInput.externalId);
        writer.writeStringValue("imageName", orderItemInput.imageName);
        writer.writeNumberValue("lineNumber", orderItemInput.lineNumber);
        writer.writeNumberValue("minimumOrderQuantity", orderItemInput.minimumOrderQuantity);
        writer.writeNumberValue("openQuantity", orderItemInput.openQuantity);
        writer.writeNumberValue("price", orderItemInput.price);
        writer.writeStringValue("priceFormatted", orderItemInput.priceFormatted);
        writer.writeStringValue("productName", orderItemInput.productName);
        writer.writeNumberValue("quantity", orderItemInput.quantity);
        writer.writeNumberValue("quantityIncrement", orderItemInput.quantityIncrement);
        writer.writeStringValue("sku", orderItemInput.sku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderKindDto(writer: SerializationWriter, orderKindDto: Partial<OrderKindDto> | undefined | null = {}) : void {
    if (orderKindDto) {
        writer.writeStringValue("description", orderKindDto.description);
        writer.writeStringValue("family", orderKindDto.family);
        writer.writeEnumValue<OrderKind>("kind", orderKindDto.kind);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderReceiptSettings(writer: SerializationWriter, orderReceiptSettings: Partial<OrderReceiptSettings> | undefined | null = {}) : void {
    if (orderReceiptSettings) {
        writer.writeStringValue("customerSubject", orderReceiptSettings.customerSubject);
        writer.writeStringValue("organizationSubject", orderReceiptSettings.organizationSubject);
        writer.writeStringValue("salesRepSubject", orderReceiptSettings.salesRepSubject);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderReceiptSettingsResponse(writer: SerializationWriter, orderReceiptSettingsResponse: Partial<OrderReceiptSettingsResponse> | undefined | null = {}) : void {
    if (orderReceiptSettingsResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("availableTokens", orderReceiptSettingsResponse.availableTokens);
        writer.writeObjectValue<OrderReceiptSubjectDto>("customer", orderReceiptSettingsResponse.customer, serializeOrderReceiptSubjectDto);
        writer.writeObjectValue<OrderReceiptSubjectDto>("organization", orderReceiptSettingsResponse.organization, serializeOrderReceiptSubjectDto);
        writer.writeObjectValue<OrderReceiptSubjectDto>("salesRep", orderReceiptSettingsResponse.salesRep, serializeOrderReceiptSubjectDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderReceiptSubjectDto(writer: SerializationWriter, orderReceiptSubjectDto: Partial<OrderReceiptSubjectDto> | undefined | null = {}) : void {
    if (orderReceiptSubjectDto) {
        writer.writeStringValue("defaultSubject", orderReceiptSubjectDto.defaultSubject);
        writer.writeBooleanValue("isDefault", orderReceiptSubjectDto.isDefault);
        writer.writeStringValue("subject", orderReceiptSubjectDto.subject);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderRhythm(writer: SerializationWriter, orderRhythm: Partial<OrderRhythm> | undefined | null = {}) : void {
    if (orderRhythm) {
        writer.writeCollectionOfObjectValues<OrderRhythmCell>("cells", orderRhythm.cells, serializeOrderRhythmCell);
        writer.writeStringValue("timeZone", orderRhythm.timeZone);
        writer.writeNumberValue("totalOrders", orderRhythm.totalOrders);
        writer.writeNumberValue("totalStorefrontOrders", orderRhythm.totalStorefrontOrders);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderRhythmCell(writer: SerializationWriter, orderRhythmCell: Partial<OrderRhythmCell> | undefined | null = {}) : void {
    if (orderRhythmCell) {
        writer.writeNumberValue("hour", orderRhythmCell.hour);
        writer.writeNumberValue("orderCount", orderRhythmCell.orderCount);
        writer.writeNumberValue("storefrontOrders", orderRhythmCell.storefrontOrders);
        writer.writeNumberValue("weekday", orderRhythmCell.weekday);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrdersKpi(writer: SerializationWriter, ordersKpi: Partial<OrdersKpi> | undefined | null = {}) : void {
    if (ordersKpi) {
        writer.writeDateValue("endDate", ordersKpi.endDate);
        writer.writeNumberValue("orderCount", ordersKpi.orderCount);
        writer.writeStringValue("organizationId", ordersKpi.organizationId);
        writer.writeDateValue("startDate", ordersKpi.startDate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrdersPageSummary(writer: SerializationWriter, ordersPageSummary: Partial<OrdersPageSummary> | undefined | null = {}) : void {
    if (ordersPageSummary) {
        writer.writeDateValue("asOf", ordersPageSummary.asOf);
        writer.writeStringValue("initialOrderStatus", ordersPageSummary.initialOrderStatus);
        writer.writeNumberValue("needsProcessing", ordersPageSummary.needsProcessing);
        writer.writeNumberValue("needsProcessingWaiting", ordersPageSummary.needsProcessingWaiting);
        writer.writeNumberValue("ordersLast30Days", ordersPageSummary.ordersLast30Days);
        writer.writeNumberValue("ordersPrior30Days", ordersPageSummary.ordersPrior30Days);
        writer.writeNumberValue("otherOrders", ordersPageSummary.otherOrders);
        writer.writeNumberValue("salesAppOrders", ordersPageSummary.salesAppOrders);
        writer.writeNumberValue("storefrontOrders", ordersPageSummary.storefrontOrders);
        writer.writeNumberValue("valueLast30Days", ordersPageSummary.valueLast30Days);
        writer.writeNumberValue("valuePrior30Days", ordersPageSummary.valuePrior30Days);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderType(writer: SerializationWriter, orderType: Partial<OrderType> | undefined | null = {}) : void {
    if (orderType) {
        writer.writeStringValue("displayName", orderType.displayName);
        writer.writeEnumValue<OrderKind>("kind", orderType.kind);
        writer.writeStringValue("slug", orderType.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderTypeProfileDto(writer: SerializationWriter, orderTypeProfileDto: Partial<OrderTypeProfileDto> | undefined | null = {}) : void {
    if (orderTypeProfileDto) {
        writer.writeStringValue("displayName", orderTypeProfileDto.displayName);
        writer.writeEnumValue<OrderKind>("kind", orderTypeProfileDto.kind);
        writer.writeStringValue("slug", orderTypeProfileDto.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderTypeResponse(writer: SerializationWriter, orderTypeResponse: Partial<OrderTypeResponse> | undefined | null = {}) : void {
    if (orderTypeResponse) {
        writer.writeStringValue("displayName", orderTypeResponse.displayName);
        writer.writeEnumValue<OrderKind>("kind", orderTypeResponse.kind);
        writer.writeStringValue("slug", orderTypeResponse.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderVolumeHistoryPointDto(writer: SerializationWriter, orderVolumeHistoryPointDto: Partial<OrderVolumeHistoryPointDto> | undefined | null = {}) : void {
    if (orderVolumeHistoryPointDto) {
        writer.writeNumberValue("month", orderVolumeHistoryPointDto.month);
        writer.writeNumberValue("unitsSold", orderVolumeHistoryPointDto.unitsSold);
        writer.writeNumberValue("year", orderVolumeHistoryPointDto.year);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrderWithInvoiceNumbersDto(writer: SerializationWriter, orderWithInvoiceNumbersDto: Partial<OrderWithInvoiceNumbersDto> | undefined | null = {}) : void {
    if (orderWithInvoiceNumbersDto) {
        writer.writeCollectionOfPrimitiveValues<string>("invoiceNumbers", orderWithInvoiceNumbersDto.invoiceNumbers);
        writer.writeObjectValue<Order>("order", orderWithInvoiceNumbersDto.order, serializeOrder);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrganization(writer: SerializationWriter, organization: Partial<Organization> | undefined | null = {}) : void {
    if (organization) {
        serializeBaseEntity(writer, organization)
        writer.writeStringValue("accessRequestNotificationEmail", organization.accessRequestNotificationEmail);
        writer.writeObjectValue<AccessRequestResearchSettings>("accessRequestResearchSettings", organization.accessRequestResearchSettings, serializeAccessRequestResearchSettings);
        writer.writeObjectValue<AccountSetup>("accountSetup", organization.accountSetup, serializeAccountSetup);
        writer.writeStringValue("billingAddress1", organization.billingAddress1);
        writer.writeStringValue("billingAddress2", organization.billingAddress2);
        writer.writeStringValue("billingCity", organization.billingCity);
        writer.writeStringValue("billingCountry", organization.billingCountry);
        writer.writeStringValue("billingPostalCode", organization.billingPostalCode);
        writer.writeStringValue("billingStateProvince", organization.billingStateProvince);
        writer.writeObjectValue<CartPricingSettings>("cartPricingSettings", organization.cartPricingSettings, serializeCartPricingSettings);
        writer.writeCollectionOfObjectValues<CustomerAttribute>("customerAttributes", organization.customerAttributes, serializeCustomerAttribute);
        writer.writeStringValue("defaultOrderStatus", organization.defaultOrderStatus);
        writer.writeStringValue("email", organization.email);
        writer.writeObjectValue<OrganizationFeatures>("features", organization.features, serializeOrganizationFeatures);
        writer.writeCollectionOfPrimitiveValues<string>("fulfillmentMethods", organization.fulfillmentMethods);
        writer.writeStringValue("identityOrganizationId", organization.identityOrganizationId);
        writer.writeNumberValue("latitude", organization.latitude);
        writer.writeStringValue("logoUrl", organization.logoUrl);
        writer.writeNumberValue("longitude", organization.longitude);
        writer.writeCollectionOfPrimitiveValues<string>("marketCodes", organization.marketCodes);
        writer.writeStringValue("name", organization.name);
        writer.writeObjectValue<OrderExportSettings>("orderExportSettings", organization.orderExportSettings, serializeOrderExportSettings);
        writer.writeObjectValue<OrderReceiptSettings>("orderReceiptSettings", organization.orderReceiptSettings, serializeOrderReceiptSettings);
        writer.writeCollectionOfPrimitiveValues<string>("orderStatuses", organization.orderStatuses);
        writer.writeCollectionOfObjectValues<OrderType>("orderTypes", organization.orderTypes, serializeOrderType);
        writer.writeStringValue("organizationId", organization.organizationId);
        writer.writeStringValue("phoneNumber", organization.phoneNumber);
        writer.writeCollectionOfObjectValues<PriceTier>("priceTiers", organization.priceTiers, serializePriceTier);
        writer.writeCollectionOfObjectValues<ProductAttribute>("productAttributes", organization.productAttributes, serializeProductAttribute);
        writer.writeCollectionOfObjectValues<ProductOptionDefinition>("productOptions", organization.productOptions, serializeProductOptionDefinition);
        writer.writeNumberValue("seatAllowance", organization.seatAllowance);
        writer.writeCollectionOfObjectValues<Subscription2>("subscriptions", organization.subscriptions, serializeSubscription2);
        writer.writeObjectValue<TaxSettings>("taxSettings", organization.taxSettings, serializeTaxSettings);
        writer.writeCollectionOfPrimitiveValues<string>("terms", organization.terms);
        writer.writeEnumValue<OrganizationType>("type", organization.type);
        writer.writeStringValue("websiteUrl", organization.websiteUrl);
        writer.writeAdditionalData(organization.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrganization2(writer: SerializationWriter, organization2: Partial<Organization2> | undefined | null = {}) : void {
    if (organization2) {
        writer.writeStringValue("billingAddress1", organization2.billingAddress1);
        writer.writeStringValue("billingAddress2", organization2.billingAddress2);
        writer.writeStringValue("billingCity", organization2.billingCity);
        writer.writeStringValue("billingCountry", organization2.billingCountry);
        writer.writeStringValue("billingPostalCode", organization2.billingPostalCode);
        writer.writeStringValue("billingStateProvince", organization2.billingStateProvince);
        writer.writeStringValue("email", organization2.email);
        writer.writeStringValue("name", organization2.name);
        writer.writeStringValue("phoneNumber", organization2.phoneNumber);
        writer.writeStringValue("website", organization2.website);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrganizationApiKeySummary(writer: SerializationWriter, organizationApiKeySummary: Partial<OrganizationApiKeySummary> | undefined | null = {}) : void {
    if (organizationApiKeySummary) {
        writer.writeStringValue("createdOn", organizationApiKeySummary.createdOn);
        writer.writeStringValue("keyId", organizationApiKeySummary.keyId);
        writer.writeStringValue("keyPrefix", organizationApiKeySummary.keyPrefix);
        writer.writeStringValue("keySuffix", organizationApiKeySummary.keySuffix);
        writer.writeStringValue("lastUsedOn", organizationApiKeySummary.lastUsedOn);
        writer.writeStringValue("name", organizationApiKeySummary.name);
        writer.writeStringValue("scope", organizationApiKeySummary.scope);
        writer.writeStringValue("status", organizationApiKeySummary.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrganizationFeatures(writer: SerializationWriter, organizationFeatures: Partial<OrganizationFeatures> | undefined | null = {}) : void {
    if (organizationFeatures) {
        writer.writeBooleanValue("productVariants", organizationFeatures.productVariants);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrganizationInfo(writer: SerializationWriter, organizationInfo: Partial<OrganizationInfo> | undefined | null = {}) : void {
    if (organizationInfo) {
        writer.writeStringValue("billingAddress", organizationInfo.billingAddress);
        writer.writeStringValue("email", organizationInfo.email);
        writer.writeStringValue("logoUrl", organizationInfo.logoUrl);
        writer.writeStringValue("name", organizationInfo.name);
        writer.writeStringValue("phoneNumber", organizationInfo.phoneNumber);
        writer.writeStringValue("websiteUrl", organizationInfo.websiteUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrganizationProfileDto(writer: SerializationWriter, organizationProfileDto: Partial<OrganizationProfileDto> | undefined | null = {}) : void {
    if (organizationProfileDto) {
        writer.writeStringValue("billingAddress1", organizationProfileDto.billingAddress1);
        writer.writeStringValue("billingAddress2", organizationProfileDto.billingAddress2);
        writer.writeStringValue("billingCity", organizationProfileDto.billingCity);
        writer.writeStringValue("billingCountry", organizationProfileDto.billingCountry);
        writer.writeStringValue("billingPostalCode", organizationProfileDto.billingPostalCode);
        writer.writeStringValue("billingStateProvince", organizationProfileDto.billingStateProvince);
        writer.writeStringValue("email", organizationProfileDto.email);
        writer.writeBooleanValue("isAgency", organizationProfileDto.isAgency);
        writer.writeStringValue("name", organizationProfileDto.name);
        writer.writeCollectionOfObjectValues<OrderTypeProfileDto>("orderTypes", organizationProfileDto.orderTypes, serializeOrderTypeProfileDto);
        writer.writeStringValue("organizationId", organizationProfileDto.organizationId);
        writer.writeStringValue("phoneNumber", organizationProfileDto.phoneNumber);
        writer.writeCollectionOfObjectValues<ProductOptionProfileDto>("productOptions", organizationProfileDto.productOptions, serializeProductOptionProfileDto);
        writer.writeBooleanValue("productVariantsEnabled", organizationProfileDto.productVariantsEnabled);
        writer.writeCollectionOfPrimitiveValues<string>("terms", organizationProfileDto.terms);
        writer.writeEnumValue<OrganizationType>("type", organizationProfileDto.type);
        writer.writeStringValue("website", organizationProfileDto.website);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrganizationSalesRep(writer: SerializationWriter, organizationSalesRep: Partial<OrganizationSalesRep> | undefined | null = {}) : void {
    if (organizationSalesRep) {
        serializeBaseEntity(writer, organizationSalesRep)
        writer.writeBooleanValue("canViewAllCustomers", organizationSalesRep.canViewAllCustomers);
        writer.writeStringValue("email", organizationSalesRep.email);
        writer.writeStringValue("firstName", organizationSalesRep.firstName);
        writer.writeStringValue("identityOrganizationId", organizationSalesRep.identityOrganizationId);
        writer.writeStringValue("identityProviderUserId", organizationSalesRep.identityProviderUserId);
        writer.writeStringValue("lastName", organizationSalesRep.lastName);
        writer.writeEnumValue<DiscountPermission>("lineItemDiscounts", organizationSalesRep.lineItemDiscounts);
        writer.writeStringValue("marketCode", organizationSalesRep.marketCode);
        writer.writeEnumValue<DiscountPermission>("orderDiscounts", organizationSalesRep.orderDiscounts);
        writer.writeStringValue("organizationId", organizationSalesRep.organizationId);
        writer.writeStringValue("organizationName", organizationSalesRep.organizationName);
        writer.writeStringValue("organizationSalesRepId", organizationSalesRep.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", organizationSalesRep.phoneNumber);
        writer.writeStringValue("repNumber", organizationSalesRep.repNumber);
        writer.writeCollectionOfPrimitiveValues<string>("repNumbers", organizationSalesRep.repNumbers);
        writer.writeStringValue("salesRepId", organizationSalesRep.salesRepId);
        writer.writeAdditionalData(organizationSalesRep.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOrganizationUser(writer: SerializationWriter, organizationUser: Partial<OrganizationUser> | undefined | null = {}) : void {
    if (organizationUser) {
        writer.writeStringValue("email", organizationUser.email);
        writer.writeStringValue("first_name", organizationUser.firstName);
        writer.writeStringValue("full_name", organizationUser.fullName);
        writer.writeStringValue("id", organizationUser.id);
        writer.writeDateValue("joined_on", organizationUser.joinedOn);
        writer.writeStringValue("last_name", organizationUser.lastName);
        writer.writeStringValue("picture", organizationUser.picture);
        writer.writeCollectionOfPrimitiveValues<string>("roles", organizationUser.roles);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePage(writer: SerializationWriter, page: Partial<Page> | undefined | null = {}) : void {
    if (page) {
        writer.writeStringValue("imageName", page.imageName);
        writer.writeNumberValue("pageNumber", page.pageNumber);
        writer.writeCollectionOfObjectValues<Tag>("tags", page.tags, serializeTag);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfAccessRequest(writer: SerializationWriter, pagedResultOfAccessRequest: Partial<PagedResultOfAccessRequest> | undefined | null = {}) : void {
    if (pagedResultOfAccessRequest) {
        writer.writeNumberValue("currentPage", pagedResultOfAccessRequest.currentPage);
        writer.writeCollectionOfObjectValues<AccessRequest>("data", pagedResultOfAccessRequest.data, serializeAccessRequest);
        writer.writeNumberValue("pageSize", pagedResultOfAccessRequest.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfAccessRequest.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfAccessRequest.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfCampaign(writer: SerializationWriter, pagedResultOfCampaign: Partial<PagedResultOfCampaign> | undefined | null = {}) : void {
    if (pagedResultOfCampaign) {
        writer.writeNumberValue("currentPage", pagedResultOfCampaign.currentPage);
        writer.writeCollectionOfObjectValues<Campaign>("data", pagedResultOfCampaign.data, serializeCampaign);
        writer.writeNumberValue("pageSize", pagedResultOfCampaign.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfCampaign.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfCampaign.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfCommissionPlanDto(writer: SerializationWriter, pagedResultOfCommissionPlanDto: Partial<PagedResultOfCommissionPlanDto> | undefined | null = {}) : void {
    if (pagedResultOfCommissionPlanDto) {
        writer.writeNumberValue("currentPage", pagedResultOfCommissionPlanDto.currentPage);
        writer.writeCollectionOfObjectValues<CommissionPlanDto>("data", pagedResultOfCommissionPlanDto.data, serializeCommissionPlanDto);
        writer.writeNumberValue("pageSize", pagedResultOfCommissionPlanDto.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfCommissionPlanDto.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfCommissionPlanDto.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfCommissionStatementDto(writer: SerializationWriter, pagedResultOfCommissionStatementDto: Partial<PagedResultOfCommissionStatementDto> | undefined | null = {}) : void {
    if (pagedResultOfCommissionStatementDto) {
        writer.writeNumberValue("currentPage", pagedResultOfCommissionStatementDto.currentPage);
        writer.writeCollectionOfObjectValues<CommissionStatementDto>("data", pagedResultOfCommissionStatementDto.data, serializeCommissionStatementDto);
        writer.writeNumberValue("pageSize", pagedResultOfCommissionStatementDto.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfCommissionStatementDto.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfCommissionStatementDto.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfContactListItemDto(writer: SerializationWriter, pagedResultOfContactListItemDto: Partial<PagedResultOfContactListItemDto> | undefined | null = {}) : void {
    if (pagedResultOfContactListItemDto) {
        writer.writeNumberValue("currentPage", pagedResultOfContactListItemDto.currentPage);
        writer.writeCollectionOfObjectValues<ContactListItemDto>("data", pagedResultOfContactListItemDto.data, serializeContactListItemDto);
        writer.writeNumberValue("pageSize", pagedResultOfContactListItemDto.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfContactListItemDto.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfContactListItemDto.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfCustomer(writer: SerializationWriter, pagedResultOfCustomer: Partial<PagedResultOfCustomer> | undefined | null = {}) : void {
    if (pagedResultOfCustomer) {
        writer.writeNumberValue("currentPage", pagedResultOfCustomer.currentPage);
        writer.writeCollectionOfObjectValues<Customer>("data", pagedResultOfCustomer.data, serializeCustomer);
        writer.writeNumberValue("pageSize", pagedResultOfCustomer.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfCustomer.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfCustomer.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfCustomerNote(writer: SerializationWriter, pagedResultOfCustomerNote: Partial<PagedResultOfCustomerNote> | undefined | null = {}) : void {
    if (pagedResultOfCustomerNote) {
        writer.writeNumberValue("currentPage", pagedResultOfCustomerNote.currentPage);
        writer.writeCollectionOfObjectValues<CustomerNote>("data", pagedResultOfCustomerNote.data, serializeCustomerNote);
        writer.writeNumberValue("pageSize", pagedResultOfCustomerNote.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfCustomerNote.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfCustomerNote.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfDataExport(writer: SerializationWriter, pagedResultOfDataExport: Partial<PagedResultOfDataExport> | undefined | null = {}) : void {
    if (pagedResultOfDataExport) {
        writer.writeNumberValue("currentPage", pagedResultOfDataExport.currentPage);
        writer.writeCollectionOfObjectValues<DataExport>("data", pagedResultOfDataExport.data, serializeDataExport);
        writer.writeNumberValue("pageSize", pagedResultOfDataExport.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfDataExport.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfDataExport.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfDiscountCode(writer: SerializationWriter, pagedResultOfDiscountCode: Partial<PagedResultOfDiscountCode> | undefined | null = {}) : void {
    if (pagedResultOfDiscountCode) {
        writer.writeNumberValue("currentPage", pagedResultOfDiscountCode.currentPage);
        writer.writeCollectionOfObjectValues<DiscountCode>("data", pagedResultOfDiscountCode.data, serializeDiscountCode);
        writer.writeNumberValue("pageSize", pagedResultOfDiscountCode.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfDiscountCode.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfDiscountCode.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfEntityDetailsResponseOfImageDetail(writer: SerializationWriter, pagedResultOfEntityDetailsResponseOfImageDetail: Partial<PagedResultOfEntityDetailsResponseOfImageDetail> | undefined | null = {}) : void {
    if (pagedResultOfEntityDetailsResponseOfImageDetail) {
        writer.writeNumberValue("currentPage", pagedResultOfEntityDetailsResponseOfImageDetail.currentPage);
        writer.writeCollectionOfObjectValues<EntityDetailsResponseOfImageDetail>("data", pagedResultOfEntityDetailsResponseOfImageDetail.data, serializeEntityDetailsResponseOfImageDetail);
        writer.writeNumberValue("pageSize", pagedResultOfEntityDetailsResponseOfImageDetail.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfEntityDetailsResponseOfImageDetail.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfEntityDetailsResponseOfImageDetail.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfFlipbook(writer: SerializationWriter, pagedResultOfFlipbook: Partial<PagedResultOfFlipbook> | undefined | null = {}) : void {
    if (pagedResultOfFlipbook) {
        writer.writeNumberValue("currentPage", pagedResultOfFlipbook.currentPage);
        writer.writeCollectionOfObjectValues<Flipbook>("data", pagedResultOfFlipbook.data, serializeFlipbook);
        writer.writeNumberValue("pageSize", pagedResultOfFlipbook.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfFlipbook.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfFlipbook.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfInvoice(writer: SerializationWriter, pagedResultOfInvoice: Partial<PagedResultOfInvoice> | undefined | null = {}) : void {
    if (pagedResultOfInvoice) {
        writer.writeNumberValue("currentPage", pagedResultOfInvoice.currentPage);
        writer.writeCollectionOfObjectValues<Invoice>("data", pagedResultOfInvoice.data, serializeInvoice);
        writer.writeNumberValue("pageSize", pagedResultOfInvoice.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfInvoice.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfInvoice.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfInvoiceDto(writer: SerializationWriter, pagedResultOfInvoiceDto: Partial<PagedResultOfInvoiceDto> | undefined | null = {}) : void {
    if (pagedResultOfInvoiceDto) {
        writer.writeNumberValue("currentPage", pagedResultOfInvoiceDto.currentPage);
        writer.writeCollectionOfObjectValues<InvoiceDto>("data", pagedResultOfInvoiceDto.data, serializeInvoiceDto);
        writer.writeNumberValue("pageSize", pagedResultOfInvoiceDto.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfInvoiceDto.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfInvoiceDto.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfOrder(writer: SerializationWriter, pagedResultOfOrder: Partial<PagedResultOfOrder> | undefined | null = {}) : void {
    if (pagedResultOfOrder) {
        writer.writeNumberValue("currentPage", pagedResultOfOrder.currentPage);
        writer.writeCollectionOfObjectValues<Order>("data", pagedResultOfOrder.data, serializeOrder);
        writer.writeNumberValue("pageSize", pagedResultOfOrder.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfOrder.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfOrder.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfOrderDto(writer: SerializationWriter, pagedResultOfOrderDto: Partial<PagedResultOfOrderDto> | undefined | null = {}) : void {
    if (pagedResultOfOrderDto) {
        writer.writeNumberValue("currentPage", pagedResultOfOrderDto.currentPage);
        writer.writeCollectionOfObjectValues<OrderDto>("data", pagedResultOfOrderDto.data, serializeOrderDto);
        writer.writeNumberValue("pageSize", pagedResultOfOrderDto.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfOrderDto.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfOrderDto.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfOrderWithInvoiceNumbersDto(writer: SerializationWriter, pagedResultOfOrderWithInvoiceNumbersDto: Partial<PagedResultOfOrderWithInvoiceNumbersDto> | undefined | null = {}) : void {
    if (pagedResultOfOrderWithInvoiceNumbersDto) {
        writer.writeNumberValue("currentPage", pagedResultOfOrderWithInvoiceNumbersDto.currentPage);
        writer.writeCollectionOfObjectValues<OrderWithInvoiceNumbersDto>("data", pagedResultOfOrderWithInvoiceNumbersDto.data, serializeOrderWithInvoiceNumbersDto);
        writer.writeNumberValue("pageSize", pagedResultOfOrderWithInvoiceNumbersDto.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfOrderWithInvoiceNumbersDto.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfOrderWithInvoiceNumbersDto.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfProduct(writer: SerializationWriter, pagedResultOfProduct: Partial<PagedResultOfProduct> | undefined | null = {}) : void {
    if (pagedResultOfProduct) {
        writer.writeNumberValue("currentPage", pagedResultOfProduct.currentPage);
        writer.writeCollectionOfObjectValues<Product>("data", pagedResultOfProduct.data, serializeProduct);
        writer.writeNumberValue("pageSize", pagedResultOfProduct.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfProduct.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfProduct.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfProductFamily(writer: SerializationWriter, pagedResultOfProductFamily: Partial<PagedResultOfProductFamily> | undefined | null = {}) : void {
    if (pagedResultOfProductFamily) {
        writer.writeNumberValue("currentPage", pagedResultOfProductFamily.currentPage);
        writer.writeCollectionOfObjectValues<ProductFamily>("data", pagedResultOfProductFamily.data, serializeProductFamily);
        writer.writeNumberValue("pageSize", pagedResultOfProductFamily.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfProductFamily.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfProductFamily.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfSentEmailDto(writer: SerializationWriter, pagedResultOfSentEmailDto: Partial<PagedResultOfSentEmailDto> | undefined | null = {}) : void {
    if (pagedResultOfSentEmailDto) {
        writer.writeNumberValue("currentPage", pagedResultOfSentEmailDto.currentPage);
        writer.writeCollectionOfObjectValues<SentEmailDto>("data", pagedResultOfSentEmailDto.data, serializeSentEmailDto);
        writer.writeNumberValue("pageSize", pagedResultOfSentEmailDto.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfSentEmailDto.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfSentEmailDto.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfShoppingCart(writer: SerializationWriter, pagedResultOfShoppingCart: Partial<PagedResultOfShoppingCart> | undefined | null = {}) : void {
    if (pagedResultOfShoppingCart) {
        writer.writeNumberValue("currentPage", pagedResultOfShoppingCart.currentPage);
        writer.writeCollectionOfObjectValues<ShoppingCart>("data", pagedResultOfShoppingCart.data, serializeShoppingCart);
        writer.writeNumberValue("pageSize", pagedResultOfShoppingCart.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfShoppingCart.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfShoppingCart.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfStorefrontUserResponse(writer: SerializationWriter, pagedResultOfStorefrontUserResponse: Partial<PagedResultOfStorefrontUserResponse> | undefined | null = {}) : void {
    if (pagedResultOfStorefrontUserResponse) {
        writer.writeNumberValue("currentPage", pagedResultOfStorefrontUserResponse.currentPage);
        writer.writeCollectionOfObjectValues<StorefrontUserResponse>("data", pagedResultOfStorefrontUserResponse.data, serializeStorefrontUserResponse);
        writer.writeNumberValue("pageSize", pagedResultOfStorefrontUserResponse.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfStorefrontUserResponse.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfStorefrontUserResponse.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfTaskItem(writer: SerializationWriter, pagedResultOfTaskItem: Partial<PagedResultOfTaskItem> | undefined | null = {}) : void {
    if (pagedResultOfTaskItem) {
        writer.writeNumberValue("currentPage", pagedResultOfTaskItem.currentPage);
        writer.writeCollectionOfObjectValues<TaskItem>("data", pagedResultOfTaskItem.data, serializeTaskItem);
        writer.writeNumberValue("pageSize", pagedResultOfTaskItem.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfTaskItem.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfTaskItem.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfTearSheet(writer: SerializationWriter, pagedResultOfTearSheet: Partial<PagedResultOfTearSheet> | undefined | null = {}) : void {
    if (pagedResultOfTearSheet) {
        writer.writeNumberValue("currentPage", pagedResultOfTearSheet.currentPage);
        writer.writeCollectionOfObjectValues<TearSheet>("data", pagedResultOfTearSheet.data, serializeTearSheet);
        writer.writeNumberValue("pageSize", pagedResultOfTearSheet.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfTearSheet.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfTearSheet.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfUserCustomer(writer: SerializationWriter, pagedResultOfUserCustomer: Partial<PagedResultOfUserCustomer> | undefined | null = {}) : void {
    if (pagedResultOfUserCustomer) {
        writer.writeNumberValue("currentPage", pagedResultOfUserCustomer.currentPage);
        writer.writeCollectionOfObjectValues<UserCustomer>("data", pagedResultOfUserCustomer.data, serializeUserCustomer);
        writer.writeNumberValue("pageSize", pagedResultOfUserCustomer.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfUserCustomer.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfUserCustomer.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfVendor(writer: SerializationWriter, pagedResultOfVendor: Partial<PagedResultOfVendor> | undefined | null = {}) : void {
    if (pagedResultOfVendor) {
        writer.writeNumberValue("currentPage", pagedResultOfVendor.currentPage);
        writer.writeCollectionOfObjectValues<Vendor>("data", pagedResultOfVendor.data, serializeVendor);
        writer.writeNumberValue("pageSize", pagedResultOfVendor.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfVendor.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfVendor.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagedResultOfVendorCustomerDto(writer: SerializationWriter, pagedResultOfVendorCustomerDto: Partial<PagedResultOfVendorCustomerDto> | undefined | null = {}) : void {
    if (pagedResultOfVendorCustomerDto) {
        writer.writeNumberValue("currentPage", pagedResultOfVendorCustomerDto.currentPage);
        writer.writeCollectionOfObjectValues<VendorCustomerDto>("data", pagedResultOfVendorCustomerDto.data, serializeVendorCustomerDto);
        writer.writeNumberValue("pageSize", pagedResultOfVendorCustomerDto.pageSize);
        writer.writeNumberValue("totalPages", pagedResultOfVendorCustomerDto.totalPages);
        writer.writeNumberValue("totalRecords", pagedResultOfVendorCustomerDto.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePageInfo(writer: SerializationWriter, pageInfo: Partial<PageInfo> | undefined | null = {}) : void {
    if (pageInfo) {
        writer.writeStringValue("imageName", pageInfo.imageName);
        writer.writeNumberValue("pageNumber", pageInfo.pageNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePageUpdateInfo(writer: SerializationWriter, pageUpdateInfo: Partial<PageUpdateInfo> | undefined | null = {}) : void {
    if (pageUpdateInfo) {
        writer.writeStringValue("imageName", pageUpdateInfo.imageName);
        writer.writeNumberValue("pageNumber", pageUpdateInfo.pageNumber);
        writer.writeCollectionOfObjectValues<TagInfo>("tags", pageUpdateInfo.tags, serializeTagInfo);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePayment(writer: SerializationWriter, payment: Partial<Payment> | undefined | null = {}) : void {
    if (payment) {
        writer.writeNumberValue("amount", payment.amount);
        writer.writeStringValue("amountFormatted", payment.amountFormatted);
        writer.writeStringValue("cardType", payment.cardType);
        writer.writeStringValue("currencyCode", payment.currencyCode);
        writer.writeStringValue("id", payment.id);
        writer.writeStringValue("last4Digits", payment.last4Digits);
        writer.writeEnumValue<PaymentMethod2>("method", payment.method);
        writer.writeNumberValue("netAmount", payment.netAmount);
        writer.writeStringValue("netAmountFormatted", payment.netAmountFormatted);
        writer.writeStringValue("notes", payment.notes);
        writer.writeDateValue("paymentDate", payment.paymentDate);
        writer.writeStringValue("paymentProfileId", payment.paymentProfileId);
        writer.writeStringValue("reference", payment.reference);
        writer.writeNumberValue("refundedAmount", payment.refundedAmount);
        writer.writeStringValue("refundedAmountFormatted", payment.refundedAmountFormatted);
        writer.writeCollectionOfObjectValues<PaymentRefund>("refunds", payment.refunds, serializePaymentRefund);
        writer.writeEnumValue<PaymentStatus>("status", payment.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePayment2(writer: SerializationWriter, payment2: Partial<Payment2> | undefined | null = {}) : void {
    if (payment2) {
        writer.writeObjectValue<CheckoutBillingAddress>("billingAddress", payment2.billingAddress, serializeCheckoutBillingAddress);
        writer.writeObjectValue<CreditCard>("creditCard", payment2.creditCard, serializeCreditCard);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaymentDto(writer: SerializationWriter, paymentDto: Partial<PaymentDto> | undefined | null = {}) : void {
    if (paymentDto) {
        writer.writeNumberValue("amount", paymentDto.amount);
        writer.writeStringValue("amountFormatted", paymentDto.amountFormatted);
        writer.writeStringValue("cardType", paymentDto.cardType);
        writer.writeStringValue("currencyCode", paymentDto.currencyCode);
        writer.writeStringValue("id", paymentDto.id);
        writer.writeStringValue("last4Digits", paymentDto.last4Digits);
        writer.writeStringValue("method", paymentDto.method);
        writer.writeNumberValue("netAmount", paymentDto.netAmount);
        writer.writeStringValue("netAmountFormatted", paymentDto.netAmountFormatted);
        writer.writeStringValue("notes", paymentDto.notes);
        writer.writeDateValue("paymentDate", paymentDto.paymentDate);
        writer.writeStringValue("paymentProfileId", paymentDto.paymentProfileId);
        writer.writeStringValue("reference", paymentDto.reference);
        writer.writeNumberValue("refundedAmount", paymentDto.refundedAmount);
        writer.writeStringValue("refundedAmountFormatted", paymentDto.refundedAmountFormatted);
        writer.writeCollectionOfObjectValues<PaymentRefundDto>("refunds", paymentDto.refunds, serializePaymentRefundDto);
        writer.writeStringValue("status", paymentDto.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaymentMethod(writer: SerializationWriter, paymentMethod: Partial<PaymentMethod> | undefined | null = {}) : void {
    if (paymentMethod) {
        serializeBaseEntity(writer, paymentMethod)
        writer.writeObjectValue<BillingAddress>("billingAddress", paymentMethod.billingAddress, serializeBillingAddress);
        writer.writeStringValue("cardType", paymentMethod.cardType);
        writer.writeStringValue("customerNumber", paymentMethod.customerNumber);
        writer.writeStringValue("customerProfileId", paymentMethod.customerProfileId);
        writer.writeStringValue("expirationDate", paymentMethod.expirationDate);
        writer.writeNumberValue("expMonth", paymentMethod.expMonth);
        writer.writeNumberValue("expYear", paymentMethod.expYear);
        writer.writeBooleanValue("isDefault", paymentMethod.isDefault);
        writer.writeStringValue("maskedCardNumber", paymentMethod.maskedCardNumber);
        writer.writeStringValue("networkTransactionId", paymentMethod.networkTransactionId);
        writer.writeStringValue("paymentProfileId", paymentMethod.paymentProfileId);
        writer.writeStringValue("paymentProvider", paymentMethod.paymentProvider);
        writer.writeAdditionalData(paymentMethod.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaymentProfile(writer: SerializationWriter, paymentProfile: Partial<PaymentProfile> | undefined | null = {}) : void {
    if (paymentProfile) {
        serializeBaseEntity(writer, paymentProfile)
        writer.writeStringValue("cardType", paymentProfile.cardType);
        writer.writeStringValue("customerNumber", paymentProfile.customerNumber);
        writer.writeStringValue("customerProfileId", paymentProfile.customerProfileId);
        writer.writeNumberValue("expMonth", paymentProfile.expMonth);
        writer.writeNumberValue("expYear", paymentProfile.expYear);
        writer.writeStringValue("id", paymentProfile.id);
        writer.writeBooleanValue("isDefault", paymentProfile.isDefault);
        writer.writeStringValue("last4Digits", paymentProfile.last4Digits);
        writer.writeStringValue("networkTransactionId", paymentProfile.networkTransactionId);
        writer.writeStringValue("organizationId", paymentProfile.organizationId);
        writer.writeStringValue("paymentProfileId", paymentProfile.paymentProfileId);
        writer.writeStringValue("provider", paymentProfile.provider);
        writer.writeAdditionalData(paymentProfile.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaymentRefund(writer: SerializationWriter, paymentRefund: Partial<PaymentRefund> | undefined | null = {}) : void {
    if (paymentRefund) {
        writer.writeNumberValue("amount", paymentRefund.amount);
        writer.writeStringValue("id", paymentRefund.id);
        writer.writeStringValue("notes", paymentRefund.notes);
        writer.writeStringValue("reference", paymentRefund.reference);
        writer.writeDateValue("refundDate", paymentRefund.refundDate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaymentRefundDto(writer: SerializationWriter, paymentRefundDto: Partial<PaymentRefundDto> | undefined | null = {}) : void {
    if (paymentRefundDto) {
        writer.writeNumberValue("amount", paymentRefundDto.amount);
        writer.writeStringValue("id", paymentRefundDto.id);
        writer.writeStringValue("notes", paymentRefundDto.notes);
        writer.writeStringValue("reference", paymentRefundDto.reference);
        writer.writeDateValue("refundDate", paymentRefundDto.refundDate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePendingPromotion(writer: SerializationWriter, pendingPromotion: Partial<PendingPromotion> | undefined | null = {}) : void {
    if (pendingPromotion) {
        writer.writeStringValue("campaignId", pendingPromotion.campaignId);
        writer.writeStringValue("campaignName", pendingPromotion.campaignName);
        writer.writeDateValue("campaignValidTo", pendingPromotion.campaignValidTo);
        writer.writeNumberValue("eligibleQuantity", pendingPromotion.eligibleQuantity);
        writer.writeCollectionOfPrimitiveValues<string>("eligibleSkus", pendingPromotion.eligibleSkus);
        writer.writeNumberValue("eligibleSubtotal", pendingPromotion.eligibleSubtotal);
        writer.writeBooleanValue("hasScope", pendingPromotion.hasScope);
        writer.writeStringValue("message", pendingPromotion.message);
        writer.writeObjectValue<PromotionProgress>("progress", pendingPromotion.progress, serializePromotionProgress);
        writer.writeStringValue("promotionId", pendingPromotion.promotionId);
        writer.writeStringValue("promotionName", pendingPromotion.promotionName);
        writer.writeEnumValue<PromotionSkipReason>("reason", pendingPromotion.reason);
        writer.writeCollectionOfPrimitiveValues<string>("scopeCategories", pendingPromotion.scopeCategories);
        writer.writeCollectionOfPrimitiveValues<string>("scopeSkus", pendingPromotion.scopeSkus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePipelineStage(writer: SerializationWriter, pipelineStage: Partial<PipelineStage> | undefined | null = {}) : void {
    if (pipelineStage) {
        writer.writeNumberValue("count", pipelineStage.count);
        writer.writeStringValue("stage", pipelineStage.stage);
        writer.writeCollectionOfPrimitiveValues<string>("statuses", pipelineStage.statuses);
        writer.writeNumberValue("value", pipelineStage.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePlacedLine(writer: SerializationWriter, placedLine: Partial<PlacedLine> | undefined | null = {}) : void {
    if (placedLine) {
        writer.writeStringValue("orderBatchId", placedLine.orderBatchId);
        writer.writeStringValue("orderId", placedLine.orderId);
        writer.writeStringValue("orderNumber", placedLine.orderNumber);
        writer.writeStringValue("vendorCode", placedLine.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePlaceLinesRequest(writer: SerializationWriter, placeLinesRequest: Partial<PlaceLinesRequest> | undefined | null = {}) : void {
    if (placeLinesRequest) {
        serializeVendorCartRequest(writer, placeLinesRequest)
        writer.writeStringValue("paymentProfileId", placeLinesRequest.paymentProfileId);
        writer.writeStringValue("signaturePng", placeLinesRequest.signaturePng);
        writer.writeStringValue("submittedVia", placeLinesRequest.submittedVia);
        writer.writeEnumValue<UserTypes>("userType", placeLinesRequest.userType);
        writer.writeCollectionOfPrimitiveValues<string>("vendorCodes", placeLinesRequest.vendorCodes);
        writer.writeAdditionalData(placeLinesRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePlaceLinesResponse(writer: SerializationWriter, placeLinesResponse: Partial<PlaceLinesResponse> | undefined | null = {}) : void {
    if (placeLinesResponse) {
        writer.writeCollectionOfObjectValues<FailedLine>("failed", placeLinesResponse.failed, serializeFailedLine);
        writer.writeStringValue("orderBatchId", placeLinesResponse.orderBatchId);
        writer.writeCollectionOfObjectValues<PlacedLine>("placed", placeLinesResponse.placed, serializePlacedLine);
        writer.writeStringValue("remainingCartId", placeLinesResponse.remainingCartId);
        writer.writeCollectionOfObjectValues<SkippedLine>("skipped", placeLinesResponse.skipped, serializeSkippedLine);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePlansResponse(writer: SerializationWriter, plansResponse: Partial<PlansResponse> | undefined | null = {}) : void {
    if (plansResponse) {
        writer.writeCollectionOfObjectValues<CatalogItem>("items", plansResponse.items, serializeCatalogItem);
        writer.writeNumberValue("trialPeriodDays", plansResponse.trialPeriodDays);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePortalSessionLinkResponse(writer: SerializationWriter, portalSessionLinkResponse: Partial<PortalSessionLinkResponse> | undefined | null = {}) : void {
    if (portalSessionLinkResponse) {
        writer.writeStringValue("sessionUrl", portalSessionLinkResponse.sessionUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePrediction(writer: SerializationWriter, prediction: Partial<Prediction> | undefined | null = {}) : void {
    if (prediction) {
        writer.writeStringValue("description", prediction.description);
        writer.writeCollectionOfObjectValues<MatchedSubstring>("matchedSubstrings", prediction.matchedSubstrings, serializeMatchedSubstring);
        writer.writeStringValue("placeId", prediction.placeId);
        writer.writeStringValue("reference", prediction.reference);
        writer.writeObjectValue<StructuredFormatting>("structuredFormatting", prediction.structuredFormatting, serializeStructuredFormatting);
        writer.writeCollectionOfObjectValues<Term>("terms", prediction.terms, serializeTerm);
        writer.writeCollectionOfPrimitiveValues<string>("types", prediction.types);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePrefillVendorRequest(writer: SerializationWriter, prefillVendorRequest: Partial<PrefillVendorRequest> | undefined | null = {}) : void {
    if (prefillVendorRequest) {
        serializeAgencyScopedRequest(writer, prefillVendorRequest)
        writer.writeStringValue("website", prefillVendorRequest.website);
        writer.writeAdditionalData(prefillVendorRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePriceOverride(writer: SerializationWriter, priceOverride: Partial<PriceOverride> | undefined | null = {}) : void {
    if (priceOverride) {
        writer.writeNumberValue("listPrice", priceOverride.listPrice);
        writer.writeDateValue("overriddenAtUtc", priceOverride.overriddenAtUtc);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePriceOverrideDto(writer: SerializationWriter, priceOverrideDto: Partial<PriceOverrideDto> | undefined | null = {}) : void {
    if (priceOverrideDto) {
        writer.writeNumberValue("listPrice", priceOverrideDto.listPrice);
        writer.writeDateValue("overriddenAtUtc", priceOverrideDto.overriddenAtUtc);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePriceTier(writer: SerializationWriter, priceTier: Partial<PriceTier> | undefined | null = {}) : void {
    if (priceTier) {
        writer.writeEnumValue<CurrencyCode>("currencyCode", priceTier.currencyCode);
        writer.writeStringValue("name", priceTier.name);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProduct(writer: SerializationWriter, product: Partial<Product> | undefined | null = {}) : void {
    if (product) {
        writer.writeBooleanValue("active", product.active);
        writer.writeStringValue("category", product.category);
        writer.writeObjectValue<Product_categorySortOrders>("categorySortOrders", product.categorySortOrders, serializeProduct_categorySortOrders);
        writer.writeDateValue("createdAt", product.createdAt);
        writer.writeEnumValue<CurrencyCode>("currencyCode", product.currencyCode);
        writer.writeStringValue("description", product.description);
        writer.writeStringValue("dimensions", product.dimensions);
        writer.writeStringValue("dimensionsUnit", product.dimensionsUnit);
        writer.writeStringValue("externalId", product.externalId);
        writer.writeStringValue("familyId", product.familyId);
        writer.writeStringValue("familyKey", product.familyKey);
        writer.writeStringValue("imageName", product.imageName);
        writer.writeCollectionOfObjectValues<Image>("Images", product.images, serializeImage);
        writer.writeNumberValue("minimumOrderQuantity", product.minimumOrderQuantity);
        writer.writeStringValue("name", product.name);
        writer.writeObjectValue<Product_optionValues>("optionValues", product.optionValues, serializeProduct_optionValues);
        writer.writeStringValue("organizationId", product.organizationId);
        writer.writeNumberValue("price", product.price);
        writer.writeStringValue("priceFormatted", product.priceFormatted);
        writer.writeCollectionOfObjectValues<ProductPrice>("prices", product.prices, serializeProductPrice);
        writer.writeObjectValue<Product_productAttributeLabels>("productAttributeLabels", product.productAttributeLabels, serializeProduct_productAttributeLabels);
        writer.writeObjectValue<Product_productAttributes>("productAttributes", product.productAttributes, serializeProduct_productAttributes);
        writer.writeStringValue("productId", product.productId);
        writer.writeEnumValue<ProductType>("productType", product.productType);
        writer.writeNumberValue("quantityIncrement", product.quantityIncrement);
        writer.writeNumberValue("quantityOnHand", product.quantityOnHand);
        writer.writeBooleanValue("separateLines", product.separateLines);
        writer.writeStringValue("sku", product.sku);
        writer.writeCollectionOfPrimitiveValues<string>("tags", product.tags);
        writer.writeStringValue("upc", product.upc);
        writer.writeDateValue("updatedAt", product.updatedAt);
        writer.writeNumberValue("variantPosition", product.variantPosition);
        writer.writeStringValue("vendorCode", product.vendorCode);
        writer.writeStringValue("vendorItemNumber", product.vendorItemNumber);
        writer.writeNumberValue("weight", product.weight);
        writer.writeStringValue("weightUnit", product.weightUnit);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProduct_categorySortOrders(writer: SerializationWriter, product_categorySortOrders: Partial<Product_categorySortOrders> | undefined | null = {}) : void {
    if (product_categorySortOrders) {
        writer.writeAdditionalData(product_categorySortOrders.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProduct_optionValues(writer: SerializationWriter, product_optionValues: Partial<Product_optionValues> | undefined | null = {}) : void {
    if (product_optionValues) {
        writer.writeAdditionalData(product_optionValues.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProduct_productAttributeLabels(writer: SerializationWriter, product_productAttributeLabels: Partial<Product_productAttributeLabels> | undefined | null = {}) : void {
    if (product_productAttributeLabels) {
        writer.writeAdditionalData(product_productAttributeLabels.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProduct_productAttributes(writer: SerializationWriter, product_productAttributes: Partial<Product_productAttributes> | undefined | null = {}) : void {
    if (product_productAttributes) {
        writer.writeAdditionalData(product_productAttributes.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductAttribute(writer: SerializationWriter, productAttribute: Partial<ProductAttribute> | undefined | null = {}) : void {
    if (productAttribute) {
        writer.writeStringValue("displayName", productAttribute.displayName);
        writer.writeStringValue("slug", productAttribute.slug);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductFamily(writer: SerializationWriter, productFamily: Partial<ProductFamily> | undefined | null = {}) : void {
    if (productFamily) {
        writer.writeBooleanValue("active", productFamily.active);
        writer.writeStringValue("category", productFamily.category);
        writer.writeDateValue("createdAt", productFamily.createdAt);
        writer.writeStringValue("description", productFamily.description);
        writer.writeStringValue("externalId", productFamily.externalId);
        writer.writeStringValue("familyId", productFamily.familyId);
        writer.writeStringValue("familyKey", productFamily.familyKey);
        writer.writeCollectionOfObjectValues<Image>("images", productFamily.images, serializeImage);
        writer.writeObjectValue<ProductFamily_imagesByOption>("imagesByOption", productFamily.imagesByOption, serializeProductFamily_imagesByOption);
        writer.writeStringValue("name", productFamily.name);
        writer.writeCollectionOfObjectValues<ProductFamilyOption>("options", productFamily.options, serializeProductFamilyOption);
        writer.writeObjectValue<ProductFamilySummary>("summary", productFamily.summary, serializeProductFamilySummary);
        writer.writeCollectionOfPrimitiveValues<string>("tags", productFamily.tags);
        writer.writeDateValue("updatedAt", productFamily.updatedAt);
        writer.writeCollectionOfObjectValues<Product>("variants", productFamily.variants, serializeProduct);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductFamily_imagesByOption(writer: SerializationWriter, productFamily_imagesByOption: Partial<ProductFamily_imagesByOption> | undefined | null = {}) : void {
    if (productFamily_imagesByOption) {
        writer.writeAdditionalData(productFamily_imagesByOption.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductFamilyOption(writer: SerializationWriter, productFamilyOption: Partial<ProductFamilyOption> | undefined | null = {}) : void {
    if (productFamilyOption) {
        writer.writeStringValue("displayName", productFamilyOption.displayName);
        writer.writeStringValue("displayStyle", productFamilyOption.displayStyle);
        writer.writeStringValue("slug", productFamilyOption.slug);
        writer.writeCollectionOfObjectValues<ProductFamilyOptionValue>("values", productFamilyOption.values, serializeProductFamilyOptionValue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductFamilyOptionValue(writer: SerializationWriter, productFamilyOptionValue: Partial<ProductFamilyOptionValue> | undefined | null = {}) : void {
    if (productFamilyOptionValue) {
        writer.writeBooleanValue("available", productFamilyOptionValue.available);
        writer.writeStringValue("displayName", productFamilyOptionValue.displayName);
        writer.writeStringValue("slug", productFamilyOptionValue.slug);
        writer.writeStringValue("swatchHex", productFamilyOptionValue.swatchHex);
        writer.writeStringValue("swatchImageUrl", productFamilyOptionValue.swatchImageUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductFamilySummary(writer: SerializationWriter, productFamilySummary: Partial<ProductFamilySummary> | undefined | null = {}) : void {
    if (productFamilySummary) {
        writer.writeNumberValue("activeVariantCount", productFamilySummary.activeVariantCount);
        writer.writeCollectionOfPrimitiveValues<string>("availableValues", productFamilySummary.availableValues);
        writer.writeObjectValue<Image>("defaultImage", productFamilySummary.defaultImage, serializeImage);
        writer.writeNumberValue("priceMax", productFamilySummary.priceMax);
        writer.writeNumberValue("priceMin", productFamilySummary.priceMin);
        writer.writeObjectValue<ProductFamilySummary_pricesByTier>("pricesByTier", productFamilySummary.pricesByTier, serializeProductFamilySummary_pricesByTier);
        writer.writeStringValue("priceTier", productFamilySummary.priceTier);
        writer.writeNumberValue("variantCount", productFamilySummary.variantCount);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductFamilySummary_pricesByTier(writer: SerializationWriter, productFamilySummary_pricesByTier: Partial<ProductFamilySummary_pricesByTier> | undefined | null = {}) : void {
    if (productFamilySummary_pricesByTier) {
        writer.writeAdditionalData(productFamilySummary_pricesByTier.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductOptionDefinition(writer: SerializationWriter, productOptionDefinition: Partial<ProductOptionDefinition> | undefined | null = {}) : void {
    if (productOptionDefinition) {
        writer.writeStringValue("displayName", productOptionDefinition.displayName);
        writer.writeEnumValue<ProductOptionDisplayStyle>("displayStyle", productOptionDefinition.displayStyle);
        writer.writeStringValue("slug", productOptionDefinition.slug);
        writer.writeCollectionOfObjectValues<ProductOptionValue>("values", productOptionDefinition.values, serializeProductOptionValue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductOptionProfileDto(writer: SerializationWriter, productOptionProfileDto: Partial<ProductOptionProfileDto> | undefined | null = {}) : void {
    if (productOptionProfileDto) {
        writer.writeStringValue("displayName", productOptionProfileDto.displayName);
        writer.writeStringValue("displayStyle", productOptionProfileDto.displayStyle);
        writer.writeStringValue("slug", productOptionProfileDto.slug);
        writer.writeCollectionOfObjectValues<ProductOptionValueProfileDto>("values", productOptionProfileDto.values, serializeProductOptionValueProfileDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductOptionValue(writer: SerializationWriter, productOptionValue: Partial<ProductOptionValue> | undefined | null = {}) : void {
    if (productOptionValue) {
        writer.writeStringValue("displayName", productOptionValue.displayName);
        writer.writeStringValue("slug", productOptionValue.slug);
        writer.writeStringValue("swatchHex", productOptionValue.swatchHex);
        writer.writeStringValue("swatchImageId", productOptionValue.swatchImageId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductOptionValueProfileDto(writer: SerializationWriter, productOptionValueProfileDto: Partial<ProductOptionValueProfileDto> | undefined | null = {}) : void {
    if (productOptionValueProfileDto) {
        writer.writeStringValue("displayName", productOptionValueProfileDto.displayName);
        writer.writeStringValue("slug", productOptionValueProfileDto.slug);
        writer.writeStringValue("swatchHex", productOptionValueProfileDto.swatchHex);
        writer.writeStringValue("swatchImageUrl", productOptionValueProfileDto.swatchImageUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductPrice(writer: SerializationWriter, productPrice: Partial<ProductPrice> | undefined | null = {}) : void {
    if (productPrice) {
        writer.writeNumberValue("atQuantity", productPrice.atQuantity);
        writer.writeNumberValue("price", productPrice.price);
        writer.writeStringValue("priceFormatted", productPrice.priceFormatted);
        writer.writeStringValue("tier", productPrice.tier);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductRevenueRanking(writer: SerializationWriter, productRevenueRanking: Partial<ProductRevenueRanking> | undefined | null = {}) : void {
    if (productRevenueRanking) {
        writer.writeNumberValue("orderCount", productRevenueRanking.orderCount);
        writer.writeStringValue("productName", productRevenueRanking.productName);
        writer.writeNumberValue("productsOrdered", productRevenueRanking.productsOrdered);
        writer.writeStringValue("sku", productRevenueRanking.sku);
        writer.writeNumberValue("totalRevenue", productRevenueRanking.totalRevenue);
        writer.writeNumberValue("uniqueOrders", productRevenueRanking.uniqueOrders);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProductsPageSummary(writer: SerializationWriter, productsPageSummary: Partial<ProductsPageSummary> | undefined | null = {}) : void {
    if (productsPageSummary) {
        writer.writeNumberValue("activeProducts", productsPageSummary.activeProducts);
        writer.writeDateValue("asOf", productsPageSummary.asOf);
        writer.writeStringValue("bestSellerName", productsPageSummary.bestSellerName);
        writer.writeStringValue("bestSellerSku", productsPageSummary.bestSellerSku);
        writer.writeNumberValue("bestSellerUnits", productsPageSummary.bestSellerUnits);
        writer.writeNumberValue("inactiveProducts", productsPageSummary.inactiveProducts);
        writer.writeNumberValue("missingImages", productsPageSummary.missingImages);
        writer.writeNumberValue("outOfStock", productsPageSummary.outOfStock);
        writer.writeNumberValue("outOfStockTopSellers", productsPageSummary.outOfStockTopSellers);
        writer.writeNumberValue("topSellerCount", productsPageSummary.topSellerCount);
        writer.writeNumberValue("totalProducts", productsPageSummary.totalProducts);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotion(writer: SerializationWriter, promotion: Partial<Promotion> | undefined | null = {}) : void {
    if (promotion) {
        writer.writeBooleanValue("active", promotion.active);
        writer.writeObjectValue<Benefit>("benefit", promotion.benefit, serializeBenefit);
        writer.writeCollectionOfPrimitiveValues<string>("categories", promotion.categories);
        writer.writeNumberValue("minQuantity", promotion.minQuantity);
        writer.writeNumberValue("minSubtotal", promotion.minSubtotal);
        writer.writeStringValue("name", promotion.name);
        writer.writeNumberValue("priority", promotion.priority);
        writer.writeStringValue("promotionId", promotion.promotionId);
        writer.writeCollectionOfPrimitiveValues<string>("skus", promotion.skus);
        writer.writeBooleanValue("stackable", promotion.stackable);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotionInput(writer: SerializationWriter, promotionInput: Partial<PromotionInput> | undefined | null = {}) : void {
    if (promotionInput) {
        writer.writeBooleanValue("active", promotionInput.active);
        writer.writeObjectValue<BenefitInput>("benefit", promotionInput.benefit, serializeBenefitInput);
        writer.writeCollectionOfPrimitiveValues<string>("categories", promotionInput.categories);
        writer.writeNumberValue("minQuantity", promotionInput.minQuantity);
        writer.writeNumberValue("minSubtotal", promotionInput.minSubtotal);
        writer.writeStringValue("name", promotionInput.name);
        writer.writeNumberValue("priority", promotionInput.priority);
        writer.writeStringValue("promotionId", promotionInput.promotionId);
        writer.writeCollectionOfPrimitiveValues<string>("skus", promotionInput.skus);
        writer.writeBooleanValue("stackable", promotionInput.stackable);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotionPlan(writer: SerializationWriter, promotionPlan: Partial<PromotionPlan> | undefined | null = {}) : void {
    if (promotionPlan) {
        writer.writeCollectionOfObjectValues<AppliedPromotion>("applied", promotionPlan.applied, serializeAppliedPromotion);
        writer.writeStringValue("appliedCode", promotionPlan.appliedCode);
        writer.writeObjectValue<PromotionSkip>("appliedCodeSkip", promotionPlan.appliedCodeSkip, serializePromotionSkip);
        writer.writeObjectValue<FreeShippingEntitlement>("freeShipping", promotionPlan.freeShipping, serializeFreeShippingEntitlement);
        writer.writeCollectionOfObjectValues<GiftInstruction>("gifts", promotionPlan.gifts, serializeGiftInstruction);
        writer.writeBooleanValue("hasEffects", promotionPlan.hasEffects);
        writer.writeCollectionOfObjectValues<LineDiscountInstruction>("lineDiscounts", promotionPlan.lineDiscounts, serializeLineDiscountInstruction);
        writer.writeObjectValue<Discount>("orderDiscount", promotionPlan.orderDiscount, serializeDiscount);
        writer.writeCollectionOfObjectValues<PromotionSkip>("skips", promotionPlan.skips, serializePromotionSkip);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotionProgress(writer: SerializationWriter, promotionProgress: Partial<PromotionProgress> | undefined | null = {}) : void {
    if (promotionProgress) {
        writer.writeEnumValue<PromotionMeasure>("measure", promotionProgress.measure);
        writer.writeNumberValue("measured", promotionProgress.measured);
        writer.writeNumberValue("percent", promotionProgress.percent);
        writer.writeNumberValue("required", promotionProgress.required);
        writer.writeNumberValue("shortfall", promotionProgress.shortfall);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotionSkip(writer: SerializationWriter, promotionSkip: Partial<PromotionSkip> | undefined | null = {}) : void {
    if (promotionSkip) {
        writer.writeStringValue("campaignId", promotionSkip.campaignId);
        writer.writeStringValue("code", promotionSkip.code);
        writer.writeStringValue("message", promotionSkip.message);
        writer.writeStringValue("promotionId", promotionSkip.promotionId);
        writer.writeEnumValue<PromotionSkipReason>("reason", promotionSkip.reason);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePushEndpointsRequest(writer: SerializationWriter, pushEndpointsRequest: Partial<PushEndpointsRequest> | undefined | null = {}) : void {
    if (pushEndpointsRequest) {
        writer.writeCollectionOfObjectValues<ConnectorEndpointDto>("endpoints", pushEndpointsRequest.endpoints, serializeConnectorEndpointDto);
        writer.writeDateValue("pushedAt", pushEndpointsRequest.pushedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePushSyncRunRequest(writer: SerializationWriter, pushSyncRunRequest: Partial<PushSyncRunRequest> | undefined | null = {}) : void {
    if (pushSyncRunRequest) {
        writer.writeCollectionOfObjectValues<SyncBatchResultDto>("batchResults", pushSyncRunRequest.batchResults, serializeSyncBatchResultDto);
        writer.writeDateValue("completedAt", pushSyncRunRequest.completedAt);
        writer.writeNumberValue("durationSeconds", pushSyncRunRequest.durationSeconds);
        writer.writeStringValue("endpointId", pushSyncRunRequest.endpointId);
        writer.writeStringValue("endpointName", pushSyncRunRequest.endpointName);
        writer.writeStringValue("errorMessage", pushSyncRunRequest.errorMessage);
        writer.writeNumberValue("failedBatches", pushSyncRunRequest.failedBatches);
        writer.writeNumberValue("failedRecords", pushSyncRunRequest.failedRecords);
        writer.writeBooleanValue("isManualTrigger", pushSyncRunRequest.isManualTrigger);
        writer.writeDateValue("pushedAt", pushSyncRunRequest.pushedAt);
        writer.writeDateValue("startedAt", pushSyncRunRequest.startedAt);
        writer.writeStringValue("status", pushSyncRunRequest.status);
        writer.writeNumberValue("successfulBatches", pushSyncRunRequest.successfulBatches);
        writer.writeNumberValue("successfulRecords", pushSyncRunRequest.successfulRecords);
        writer.writeStringValue("syncMode", pushSyncRunRequest.syncMode);
        writer.writeStringValue("syncRunId", pushSyncRunRequest.syncRunId);
        writer.writeNumberValue("totalBatches", pushSyncRunRequest.totalBatches);
        writer.writeNumberValue("totalRecords", pushSyncRunRequest.totalRecords);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeQuantityLimits(writer: SerializationWriter, quantityLimits: Partial<QuantityLimits> | undefined | null = {}) : void {
    if (quantityLimits) {
        writer.writeNumberValue("max", quantityLimits.max);
        writer.writeNumberValue("min", quantityLimits.min);
        writer.writeNumberValue("step", quantityLimits.step);
        writer.writeStringValue("type", quantityLimits.type);
        writer.writeCollectionOfPrimitiveValues<number>("values", quantityLimits.values);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeQueryFilter(writer: SerializationWriter, queryFilter: Partial<QueryFilter> | undefined | null = {}) : void {
    if (queryFilter) {
        writer.writeStringValue("field", queryFilter.field);
        writer.writeEnumValue<QueryFilter_OperatorType>("operator", queryFilter.operator);
        writer.writeStringValue("value", queryFilter.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeQuickBooksAuthResponse(writer: SerializationWriter, quickBooksAuthResponse: Partial<QuickBooksAuthResponse> | undefined | null = {}) : void {
    if (quickBooksAuthResponse) {
        writer.writeStringValue("authUrl", quickBooksAuthResponse.authUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeQuickBooksCompanyInfoResponse_CompanyInfo(writer: SerializationWriter, quickBooksCompanyInfoResponse_CompanyInfo: Partial<QuickBooksCompanyInfoResponse_CompanyInfo> | undefined | null = {}) : void {
    if (quickBooksCompanyInfoResponse_CompanyInfo) {
        writer.writeStringValue("companyName", quickBooksCompanyInfoResponse_CompanyInfo.companyName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeQuickbooksConnectedResponse(writer: SerializationWriter, quickbooksConnectedResponse: Partial<QuickbooksConnectedResponse> | undefined | null = {}) : void {
    if (quickbooksConnectedResponse) {
        writer.writeBooleanValue("isConnected", quickbooksConnectedResponse.isConnected);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeQuickBooksTokenRequest(writer: SerializationWriter, quickBooksTokenRequest: Partial<QuickBooksTokenRequest> | undefined | null = {}) : void {
    if (quickBooksTokenRequest) {
        writer.writeStringValue("code", quickBooksTokenRequest.code);
        writer.writeStringValue("realmId", quickBooksTokenRequest.realmId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeQuickBooksTokenResponse(writer: SerializationWriter, quickBooksTokenResponse: Partial<QuickBooksTokenResponse> | undefined | null = {}) : void {
    if (quickBooksTokenResponse) {
        writer.writeStringValue("accessToken", quickBooksTokenResponse.accessToken);
        writer.writeNumberValue("expiresIn", quickBooksTokenResponse.expiresIn);
        writer.writeStringValue("refreshToken", quickBooksTokenResponse.refreshToken);
        writer.writeStringValue("tokenType", quickBooksTokenResponse.tokenType);
        writer.writeNumberValue("xRefreshTokenExpiresIn", quickBooksTokenResponse.xRefreshTokenExpiresIn);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeQuietAccount(writer: SerializationWriter, quietAccount: Partial<QuietAccount> | undefined | null = {}) : void {
    if (quietAccount) {
        writer.writeStringValue("companyName", quietAccount.companyName);
        writer.writeStringValue("customerNumber", quietAccount.customerNumber);
        writer.writeNumberValue("daysQuiet", quietAccount.daysQuiet);
        writer.writeDateValue("lastOrderDate", quietAccount.lastOrderDate);
        writer.writeNumberValue("lifetimeRevenue", quietAccount.lifetimeRevenue);
        writer.writeStringValue("repName", quietAccount.repName);
        writer.writeStringValue("terms", quietAccount.terms);
        writer.writeNumberValue("trailingYearRevenue", quietAccount.trailingYearRevenue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRawBodyRequest(writer: SerializationWriter, rawBodyRequest: Partial<RawBodyRequest> | undefined | null = {}) : void {
    if (rawBodyRequest) {
        writer.writeStringValue("content", rawBodyRequest.content);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReactivateVendorRequest(writer: SerializationWriter, reactivateVendorRequest: Partial<ReactivateVendorRequest> | undefined | null = {}) : void {
    if (reactivateVendorRequest) {
        serializeAgencyScopedRequest(writer, reactivateVendorRequest)
        writer.writeAdditionalData(reactivateVendorRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReadmeAuthResponse(writer: SerializationWriter, readmeAuthResponse: Partial<ReadmeAuthResponse> | undefined | null = {}) : void {
    if (readmeAuthResponse) {
        writer.writeStringValue("readmeAuthUrl", readmeAuthResponse.readmeAuthUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReassignCustomerRequest(writer: SerializationWriter, reassignCustomerRequest: Partial<ReassignCustomerRequest> | undefined | null = {}) : void {
    if (reassignCustomerRequest) {
        writer.writeStringValue("fromCustomerNumber", reassignCustomerRequest.fromCustomerNumber);
        writer.writeStringValue("toCustomerNumber", reassignCustomerRequest.toCustomerNumber);
        writer.writeStringValue("userId", reassignCustomerRequest.userId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReassignCustomerResponse(writer: SerializationWriter, reassignCustomerResponse: Partial<ReassignCustomerResponse> | undefined | null = {}) : void {
    if (reassignCustomerResponse) {
        writer.writeStringValue("customerNumber", reassignCustomerResponse.customerNumber);
        writer.writeStringValue("previousCustomerNumber", reassignCustomerResponse.previousCustomerNumber);
        writer.writeBooleanValue("reassigned", reassignCustomerResponse.reassigned);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReconcileRepNumberChannelsRequest(writer: SerializationWriter, reconcileRepNumberChannelsRequest: Partial<ReconcileRepNumberChannelsRequest> | undefined | null = {}) : void {
    if (reconcileRepNumberChannelsRequest) {
        writer.writeStringValue("organizationSalesRepId", reconcileRepNumberChannelsRequest.organizationSalesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReconcileRepNumberChannelsResponse(writer: SerializationWriter, reconcileRepNumberChannelsResponse: Partial<ReconcileRepNumberChannelsResponse> | undefined | null = {}) : void {
    if (reconcileRepNumberChannelsResponse) {
        writer.writeNumberValue("channelsGranted", reconcileRepNumberChannelsResponse.channelsGranted);
        writer.writeNumberValue("channelsRevoked", reconcileRepNumberChannelsResponse.channelsRevoked);
        writer.writeNumberValue("collectionsGranted", reconcileRepNumberChannelsResponse.collectionsGranted);
        writer.writeCollectionOfPrimitiveValues<string>("failed", reconcileRepNumberChannelsResponse.failed);
        writer.writeStringValue("organizationId", reconcileRepNumberChannelsResponse.organizationId);
        writer.writeNumberValue("repsExamined", reconcileRepNumberChannelsResponse.repsExamined);
        writer.writeNumberValue("repsUnchanged", reconcileRepNumberChannelsResponse.repsUnchanged);
        writer.writeNumberValue("skippedInactive", reconcileRepNumberChannelsResponse.skippedInactive);
        writer.writeNumberValue("skippedNoSyncUser", reconcileRepNumberChannelsResponse.skippedNoSyncUser);
        writer.writeBooleanValue("success", reconcileRepNumberChannelsResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRecordPaymentRequest(writer: SerializationWriter, recordPaymentRequest: Partial<RecordPaymentRequest> | undefined | null = {}) : void {
    if (recordPaymentRequest) {
        writer.writeNumberValue("amount", recordPaymentRequest.amount);
        writer.writeStringValue("cardType", recordPaymentRequest.cardType);
        writer.writeStringValue("currencyCode", recordPaymentRequest.currencyCode);
        writer.writeStringValue("last4Digits", recordPaymentRequest.last4Digits);
        writer.writeStringValue("method", recordPaymentRequest.method);
        writer.writeStringValue("notes", recordPaymentRequest.notes);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", recordPaymentRequest.orgCodes);
        writer.writeDateValue("paymentDate", recordPaymentRequest.paymentDate);
        writer.writeStringValue("paymentProfileId", recordPaymentRequest.paymentProfileId);
        writer.writeStringValue("reference", recordPaymentRequest.reference);
        writer.writeStringValue("status", recordPaymentRequest.status);
        writer.writeStringValue("useOrganizationId", recordPaymentRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRefreshProductFamilySummariesResponse(writer: SerializationWriter, refreshProductFamilySummariesResponse: Partial<RefreshProductFamilySummariesResponse> | undefined | null = {}) : void {
    if (refreshProductFamilySummariesResponse) {
        writer.writeNumberValue("refreshed", refreshProductFamilySummariesResponse.refreshed);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRefreshUrlResponse(writer: SerializationWriter, refreshUrlResponse: Partial<RefreshUrlResponse> | undefined | null = {}) : void {
    if (refreshUrlResponse) {
        writer.writeStringValue("cdnUrl", refreshUrlResponse.cdnUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRefundPaymentRequest(writer: SerializationWriter, refundPaymentRequest: Partial<RefundPaymentRequest> | undefined | null = {}) : void {
    if (refundPaymentRequest) {
        writer.writeNumberValue("amount", refundPaymentRequest.amount);
        writer.writeStringValue("notes", refundPaymentRequest.notes);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", refundPaymentRequest.orgCodes);
        writer.writeStringValue("reference", refundPaymentRequest.reference);
        writer.writeStringValue("useOrganizationId", refundPaymentRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRegisterSqlConnectorRequest(writer: SerializationWriter, registerSqlConnectorRequest: Partial<RegisterSqlConnectorRequest> | undefined | null = {}) : void {
    if (registerSqlConnectorRequest) {
        writer.writeStringValue("connectorName", registerSqlConnectorRequest.connectorName);
        writer.writeStringValue("hostName", registerSqlConnectorRequest.hostName);
        writer.writeObjectValue<RegisterSqlConnectorRequest_metadata>("metadata", registerSqlConnectorRequest.metadata, serializeRegisterSqlConnectorRequest_metadata);
        writer.writeStringValue("version", registerSqlConnectorRequest.version);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRegisterSqlConnectorRequest_metadata(writer: SerializationWriter, registerSqlConnectorRequest_metadata: Partial<RegisterSqlConnectorRequest_metadata> | undefined | null = {}) : void {
    if (registerSqlConnectorRequest_metadata) {
        writer.writeAdditionalData(registerSqlConnectorRequest_metadata.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRemoveDiscountRequest(writer: SerializationWriter, removeDiscountRequest: Partial<RemoveDiscountRequest> | undefined | null = {}) : void {
    if (removeDiscountRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", removeDiscountRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", removeDiscountRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRemoveItemFromListRequest(writer: SerializationWriter, removeItemFromListRequest: Partial<RemoveItemFromListRequest> | undefined | null = {}) : void {
    if (removeItemFromListRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", removeItemFromListRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", removeItemFromListRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRemoveVendorImageRequest(writer: SerializationWriter, removeVendorImageRequest: Partial<RemoveVendorImageRequest> | undefined | null = {}) : void {
    if (removeVendorImageRequest) {
        serializeAgencyScopedRequest(writer, removeVendorImageRequest)
        writer.writeAdditionalData(removeVendorImageRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRenameListRequest(writer: SerializationWriter, renameListRequest: Partial<RenameListRequest> | undefined | null = {}) : void {
    if (renameListRequest) {
        writer.writeStringValue("newName", renameListRequest.newName);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", renameListRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", renameListRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderCategoriesRequest(writer: SerializationWriter, reorderCategoriesRequest: Partial<ReorderCategoriesRequest> | undefined | null = {}) : void {
    if (reorderCategoriesRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("categories", reorderCategoriesRequest.categories);
        writer.writeStringValue("parentPath", reorderCategoriesRequest.parentPath);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderCategoriesResponse(writer: SerializationWriter, reorderCategoriesResponse: Partial<ReorderCategoriesResponse> | undefined | null = {}) : void {
    if (reorderCategoriesResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("categories", reorderCategoriesResponse.categories);
        writer.writeStringValue("parentPath", reorderCategoriesResponse.parentPath);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderCustomerAttributesRequest(writer: SerializationWriter, reorderCustomerAttributesRequest: Partial<ReorderCustomerAttributesRequest> | undefined | null = {}) : void {
    if (reorderCustomerAttributesRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("slugs", reorderCustomerAttributesRequest.slugs);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderCustomerAttributesResponse(writer: SerializationWriter, reorderCustomerAttributesResponse: Partial<ReorderCustomerAttributesResponse> | undefined | null = {}) : void {
    if (reorderCustomerAttributesResponse) {
        writer.writeCollectionOfObjectValues<CustomerAttribute>("customerAttributes", reorderCustomerAttributesResponse.customerAttributes, serializeCustomerAttribute);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderFulfillmentMethodsRequest(writer: SerializationWriter, reorderFulfillmentMethodsRequest: Partial<ReorderFulfillmentMethodsRequest> | undefined | null = {}) : void {
    if (reorderFulfillmentMethodsRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("fulfillmentMethods", reorderFulfillmentMethodsRequest.fulfillmentMethods);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderFulfillmentMethodsResponse(writer: SerializationWriter, reorderFulfillmentMethodsResponse: Partial<ReorderFulfillmentMethodsResponse> | undefined | null = {}) : void {
    if (reorderFulfillmentMethodsResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("fulfillmentMethods", reorderFulfillmentMethodsResponse.fulfillmentMethods);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderOrderStatusesRequest(writer: SerializationWriter, reorderOrderStatusesRequest: Partial<ReorderOrderStatusesRequest> | undefined | null = {}) : void {
    if (reorderOrderStatusesRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orderStatuses", reorderOrderStatusesRequest.orderStatuses);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderOrderStatusesResponse(writer: SerializationWriter, reorderOrderStatusesResponse: Partial<ReorderOrderStatusesResponse> | undefined | null = {}) : void {
    if (reorderOrderStatusesResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("orderStatuses", reorderOrderStatusesResponse.orderStatuses);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderOrderTypesRequest(writer: SerializationWriter, reorderOrderTypesRequest: Partial<ReorderOrderTypesRequest> | undefined | null = {}) : void {
    if (reorderOrderTypesRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orderTypes", reorderOrderTypesRequest.orderTypes);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderOrderTypesResponse(writer: SerializationWriter, reorderOrderTypesResponse: Partial<ReorderOrderTypesResponse> | undefined | null = {}) : void {
    if (reorderOrderTypesResponse) {
        writer.writeCollectionOfObjectValues<OrderTypeResponse>("orderTypes", reorderOrderTypesResponse.orderTypes, serializeOrderTypeResponse);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderProductAttributesRequest(writer: SerializationWriter, reorderProductAttributesRequest: Partial<ReorderProductAttributesRequest> | undefined | null = {}) : void {
    if (reorderProductAttributesRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("slugs", reorderProductAttributesRequest.slugs);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderProductAttributesResponse(writer: SerializationWriter, reorderProductAttributesResponse: Partial<ReorderProductAttributesResponse> | undefined | null = {}) : void {
    if (reorderProductAttributesResponse) {
        writer.writeCollectionOfObjectValues<ProductAttribute>("productAttributes", reorderProductAttributesResponse.productAttributes, serializeProductAttribute);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderProductsRequest(writer: SerializationWriter, reorderProductsRequest: Partial<ReorderProductsRequest> | undefined | null = {}) : void {
    if (reorderProductsRequest) {
        writer.writeStringValue("category", reorderProductsRequest.category);
        writer.writeCollectionOfPrimitiveValues<string>("skus", reorderProductsRequest.skus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderProductsResponse(writer: SerializationWriter, reorderProductsResponse: Partial<ReorderProductsResponse> | undefined | null = {}) : void {
    if (reorderProductsResponse) {
        writer.writeStringValue("category", reorderProductsResponse.category);
        writer.writeCollectionOfPrimitiveValues<string>("skus", reorderProductsResponse.skus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderTasksRequest(writer: SerializationWriter, reorderTasksRequest: Partial<ReorderTasksRequest> | undefined | null = {}) : void {
    if (reorderTasksRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", reorderTasksRequest.orgCodes);
        writer.writeCollectionOfPrimitiveValues<string>("taskItemIds", reorderTasksRequest.taskItemIds);
        writer.writeStringValue("useOrganizationId", reorderTasksRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderTermsRequest(writer: SerializationWriter, reorderTermsRequest: Partial<ReorderTermsRequest> | undefined | null = {}) : void {
    if (reorderTermsRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("terms", reorderTermsRequest.terms);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReorderTermsResponse(writer: SerializationWriter, reorderTermsResponse: Partial<ReorderTermsResponse> | undefined | null = {}) : void {
    if (reorderTermsResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("terms", reorderTermsResponse.terms);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRep(writer: SerializationWriter, rep: Partial<Rep> | undefined | null = {}) : void {
    if (rep) {
        writer.writeStringValue("email", rep.email);
        writer.writeStringValue("firstName", rep.firstName);
        writer.writeStringValue("fullName", rep.fullName);
        writer.writeStringValue("lastName", rep.lastName);
        writer.writeStringValue("marketCode", rep.marketCode);
        writer.writeStringValue("organizationSalesRepId", rep.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", rep.phoneNumber);
        writer.writeStringValue("repNumber", rep.repNumber);
        writer.writeStringValue("salesRepId", rep.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReplaceProductOptionsRequest(writer: SerializationWriter, replaceProductOptionsRequest: Partial<ReplaceProductOptionsRequest> | undefined | null = {}) : void {
    if (replaceProductOptionsRequest) {
        writer.writeCollectionOfObjectValues<ReplaceProductOptionsRequest_ProductOptionInput>("options", replaceProductOptionsRequest.options, serializeReplaceProductOptionsRequest_ProductOptionInput);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReplaceProductOptionsRequest_ProductOptionInput(writer: SerializationWriter, replaceProductOptionsRequest_ProductOptionInput: Partial<ReplaceProductOptionsRequest_ProductOptionInput> | undefined | null = {}) : void {
    if (replaceProductOptionsRequest_ProductOptionInput) {
        writer.writeStringValue("displayName", replaceProductOptionsRequest_ProductOptionInput.displayName);
        writer.writeStringValue("displayStyle", replaceProductOptionsRequest_ProductOptionInput.displayStyle);
        writer.writeStringValue("slug", replaceProductOptionsRequest_ProductOptionInput.slug);
        writer.writeCollectionOfObjectValues<ReplaceProductOptionsRequest_ProductOptionValueInput>("values", replaceProductOptionsRequest_ProductOptionInput.values, serializeReplaceProductOptionsRequest_ProductOptionValueInput);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReplaceProductOptionsRequest_ProductOptionValueInput(writer: SerializationWriter, replaceProductOptionsRequest_ProductOptionValueInput: Partial<ReplaceProductOptionsRequest_ProductOptionValueInput> | undefined | null = {}) : void {
    if (replaceProductOptionsRequest_ProductOptionValueInput) {
        writer.writeStringValue("displayName", replaceProductOptionsRequest_ProductOptionValueInput.displayName);
        writer.writeStringValue("slug", replaceProductOptionsRequest_ProductOptionValueInput.slug);
        writer.writeStringValue("swatchHex", replaceProductOptionsRequest_ProductOptionValueInput.swatchHex);
        writer.writeStringValue("swatchImageName", replaceProductOptionsRequest_ProductOptionValueInput.swatchImageName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReportMappingOutcomeRequest(writer: SerializationWriter, reportMappingOutcomeRequest: Partial<ReportMappingOutcomeRequest> | undefined | null = {}) : void {
    if (reportMappingOutcomeRequest) {
        writer.writeCollectionOfObjectValues<MappingOutcomeColumn>("columns", reportMappingOutcomeRequest.columns, serializeMappingOutcomeColumn);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResearchAccessRequestResponse(writer: SerializationWriter, researchAccessRequestResponse: Partial<ResearchAccessRequestResponse> | undefined | null = {}) : void {
    if (researchAccessRequestResponse) {
        writer.writeStringValue("accessRequestId", researchAccessRequestResponse.accessRequestId);
        writer.writeStringValue("companyName", researchAccessRequestResponse.companyName);
        writer.writeNumberValue("eligibilityScore", researchAccessRequestResponse.eligibilityScore);
        writer.writeNumberValue("estimatedCostUsd", researchAccessRequestResponse.estimatedCostUsd);
        writer.writeDateValue("generatedAt", researchAccessRequestResponse.generatedAt);
        writer.writeBooleanValue("isCached", researchAccessRequestResponse.isCached);
        writer.writeStringValue("research", researchAccessRequestResponse.research);
        writer.writeNumberValue("tokensUsed", researchAccessRequestResponse.tokensUsed);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResearchedAddress(writer: SerializationWriter, researchedAddress: Partial<ResearchedAddress> | undefined | null = {}) : void {
    if (researchedAddress) {
        writer.writeStringValue("address1", researchedAddress.address1);
        writer.writeStringValue("address2", researchedAddress.address2);
        writer.writeStringValue("city", researchedAddress.city);
        writer.writeStringValue("country", researchedAddress.country);
        writer.writeStringValue("postalCode", researchedAddress.postalCode);
        writer.writeStringValue("source", researchedAddress.source);
        writer.writeStringValue("stateProvince", researchedAddress.stateProvince);
        writer.writeBooleanValue("verified", researchedAddress.verified);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResearchedValue(writer: SerializationWriter, researchedValue: Partial<ResearchedValue> | undefined | null = {}) : void {
    if (researchedValue) {
        writer.writeStringValue("source", researchedValue.source);
        writer.writeStringValue("value", researchedValue.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResendSalesRepWelcomeRequest(writer: SerializationWriter, resendSalesRepWelcomeRequest: Partial<ResendSalesRepWelcomeRequest> | undefined | null = {}) : void {
    if (resendSalesRepWelcomeRequest) {
        writer.writeStringValue("email", resendSalesRepWelcomeRequest.email);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResendSalesRepWelcomeResponse(writer: SerializationWriter, resendSalesRepWelcomeResponse: Partial<ResendSalesRepWelcomeResponse> | undefined | null = {}) : void {
    if (resendSalesRepWelcomeResponse) {
        writer.writeBooleanValue("success", resendSalesRepWelcomeResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResendWelcomeEmailRequest(writer: SerializationWriter, resendWelcomeEmailRequest: Partial<ResendWelcomeEmailRequest> | undefined | null = {}) : void {
    if (resendWelcomeEmailRequest) {
        writer.writeStringValue("email", resendWelcomeEmailRequest.email);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResendWelcomeEmailResponse(writer: SerializationWriter, resendWelcomeEmailResponse: Partial<ResendWelcomeEmailResponse> | undefined | null = {}) : void {
    if (resendWelcomeEmailResponse) {
        writer.writeBooleanValue("success", resendWelcomeEmailResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRestoreAccessRequestResponse(writer: SerializationWriter, restoreAccessRequestResponse: Partial<RestoreAccessRequestResponse> | undefined | null = {}) : void {
    if (restoreAccessRequestResponse) {
        writer.writeStringValue("accessRequestId", restoreAccessRequestResponse.accessRequestId);
        writer.writeStringValue("status", restoreAccessRequestResponse.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRestoreTrashedImagesRequest(writer: SerializationWriter, restoreTrashedImagesRequest: Partial<RestoreTrashedImagesRequest> | undefined | null = {}) : void {
    if (restoreTrashedImagesRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("imageIds", restoreTrashedImagesRequest.imageIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRestoreTrashedImagesResponse(writer: SerializationWriter, restoreTrashedImagesResponse: Partial<RestoreTrashedImagesResponse> | undefined | null = {}) : void {
    if (restoreTrashedImagesResponse) {
        writer.writeNumberValue("restoredCount", restoreTrashedImagesResponse.restoredCount);
        writer.writeCollectionOfPrimitiveValues<string>("restoredImageIds", restoreTrashedImagesResponse.restoredImageIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResult(writer: SerializationWriter, result: Partial<Result> | undefined | null = {}) : void {
    if (result) {
        writer.writeCollectionOfObjectValues<AddressComponent>("address_components", result.addressComponents, serializeAddressComponent);
        writer.writeStringValue("formatted_address", result.formattedAddress);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeReturnToReviewRequest(writer: SerializationWriter, returnToReviewRequest: Partial<ReturnToReviewRequest> | undefined | null = {}) : void {
    if (returnToReviewRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", returnToReviewRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", returnToReviewRequest.useOrganizationId);
        writer.writeStringValue("user", returnToReviewRequest.user);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevenueKpi(writer: SerializationWriter, revenueKpi: Partial<RevenueKpi> | undefined | null = {}) : void {
    if (revenueKpi) {
        writer.writeDateValue("endDate", revenueKpi.endDate);
        writer.writeStringValue("organizationId", revenueKpi.organizationId);
        writer.writeDateValue("startDate", revenueKpi.startDate);
        writer.writeNumberValue("totalRevenue", revenueKpi.totalRevenue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevokeCustomerAccessResponse(writer: SerializationWriter, revokeCustomerAccessResponse: Partial<RevokeCustomerAccessResponse> | undefined | null = {}) : void {
    if (revokeCustomerAccessResponse) {
        writer.writeBooleanValue("removed", revokeCustomerAccessResponse.removed);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevokeOrganizationApiKeyResponse(writer: SerializationWriter, revokeOrganizationApiKeyResponse: Partial<RevokeOrganizationApiKeyResponse> | undefined | null = {}) : void {
    if (revokeOrganizationApiKeyResponse) {
        writer.writeStringValue("keyId", revokeOrganizationApiKeyResponse.keyId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRotateIntegrationSecretsRequest(writer: SerializationWriter, rotateIntegrationSecretsRequest: Partial<RotateIntegrationSecretsRequest> | undefined | null = {}) : void {
    if (rotateIntegrationSecretsRequest) {
        writer.writeObjectValue<RotateIntegrationSecretsRequest_newSecrets>("newSecrets", rotateIntegrationSecretsRequest.newSecrets, serializeRotateIntegrationSecretsRequest_newSecrets);
        writer.writeBooleanValue("testConnectionAfterRotation", rotateIntegrationSecretsRequest.testConnectionAfterRotation);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRotateIntegrationSecretsRequest_newSecrets(writer: SerializationWriter, rotateIntegrationSecretsRequest_newSecrets: Partial<RotateIntegrationSecretsRequest_newSecrets> | undefined | null = {}) : void {
    if (rotateIntegrationSecretsRequest_newSecrets) {
        writer.writeAdditionalData(rotateIntegrationSecretsRequest_newSecrets.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRotateIntegrationSecretsResponse(writer: SerializationWriter, rotateIntegrationSecretsResponse: Partial<RotateIntegrationSecretsResponse> | undefined | null = {}) : void {
    if (rotateIntegrationSecretsResponse) {
        writer.writeStringValue("integrationId", rotateIntegrationSecretsResponse.integrationId);
        writer.writeStringValue("message", rotateIntegrationSecretsResponse.message);
        writer.writeStringValue("organizationId", rotateIntegrationSecretsResponse.organizationId);
        writer.writeDateValue("rotatedAt", rotateIntegrationSecretsResponse.rotatedAt);
        writer.writeCollectionOfPrimitiveValues<string>("rotatedSecretKeys", rotateIntegrationSecretsResponse.rotatedSecretKeys);
        writer.writeBooleanValue("rotationSuccessful", rotateIntegrationSecretsResponse.rotationSuccessful);
        writer.writeBooleanValue("testConnectionSuccessful", rotateIntegrationSecretsResponse.testConnectionSuccessful);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRotateOrganizationApiKeyResponse(writer: SerializationWriter, rotateOrganizationApiKeyResponse: Partial<RotateOrganizationApiKeyResponse> | undefined | null = {}) : void {
    if (rotateOrganizationApiKeyResponse) {
        writer.writeStringValue("apiKey", rotateOrganizationApiKeyResponse.apiKey);
        writer.writeStringValue("keyId", rotateOrganizationApiKeyResponse.keyId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSalesRep(writer: SerializationWriter, salesRep: Partial<SalesRep> | undefined | null = {}) : void {
    if (salesRep) {
        writer.writeStringValue("email", salesRep.email);
        writer.writeStringValue("firstName", salesRep.firstName);
        writer.writeStringValue("fullName", salesRep.fullName);
        writer.writeStringValue("lastName", salesRep.lastName);
        writer.writeStringValue("marketCode", salesRep.marketCode);
        writer.writeStringValue("organizationSalesRepId", salesRep.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", salesRep.phoneNumber);
        writer.writeStringValue("repNumber", salesRep.repNumber);
        writer.writeStringValue("salesRepId", salesRep.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSalesRep2(writer: SerializationWriter, salesRep2: Partial<SalesRep2> | undefined | null = {}) : void {
    if (salesRep2) {
        writer.writeStringValue("email", salesRep2.email);
        writer.writeStringValue("firstName", salesRep2.firstName);
        writer.writeStringValue("fullName", salesRep2.fullName);
        writer.writeStringValue("lastName", salesRep2.lastName);
        writer.writeStringValue("organizationSalesRepId", salesRep2.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", salesRep2.phoneNumber);
        writer.writeStringValue("repNumber", salesRep2.repNumber);
        writer.writeStringValue("salesRepId", salesRep2.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSalesRepDeviceDto(writer: SerializationWriter, salesRepDeviceDto: Partial<SalesRepDeviceDto> | undefined | null = {}) : void {
    if (salesRepDeviceDto) {
        writer.writeStringValue("appVersion", salesRepDeviceDto.appVersion);
        writer.writeStringValue("buildNumber", salesRepDeviceDto.buildNumber);
        writer.writeStringValue("deviceId", salesRepDeviceDto.deviceId);
        writer.writeStringValue("deviceModel", salesRepDeviceDto.deviceModel);
        writer.writeDateValue("firstSeenAt", salesRepDeviceDto.firstSeenAt);
        writer.writeDateValue("lastLoginAt", salesRepDeviceDto.lastLoginAt);
        writer.writeDateValue("lastSeenAt", salesRepDeviceDto.lastSeenAt);
        writer.writeStringValue("osVersion", salesRepDeviceDto.osVersion);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSalesRepDto(writer: SerializationWriter, salesRepDto: Partial<SalesRepDto> | undefined | null = {}) : void {
    if (salesRepDto) {
        writer.writeStringValue("email", salesRepDto.email);
        writer.writeStringValue("firstName", salesRepDto.firstName);
        writer.writeStringValue("fullName", salesRepDto.fullName);
        writer.writeStringValue("lastName", salesRepDto.lastName);
        writer.writeStringValue("marketCode", salesRepDto.marketCode);
        writer.writeStringValue("organizationSalesRepId", salesRepDto.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", salesRepDto.phoneNumber);
        writer.writeStringValue("repNumber", salesRepDto.repNumber);
        writer.writeStringValue("salesRepId", salesRepDto.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSalesRepInput(writer: SerializationWriter, salesRepInput: Partial<SalesRepInput> | undefined | null = {}) : void {
    if (salesRepInput) {
        writer.writeStringValue("email", salesRepInput.email);
        writer.writeStringValue("firstName", salesRepInput.firstName);
        writer.writeStringValue("lastName", salesRepInput.lastName);
        writer.writeStringValue("organizationSalesRepId", salesRepInput.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", salesRepInput.phoneNumber);
        writer.writeStringValue("repNumber", salesRepInput.repNumber);
        writer.writeStringValue("salesRepId", salesRepInput.salesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSalesRepRevenueRanking(writer: SerializationWriter, salesRepRevenueRanking: Partial<SalesRepRevenueRanking> | undefined | null = {}) : void {
    if (salesRepRevenueRanking) {
        writer.writeNumberValue("averageItemsPerOrder", salesRepRevenueRanking.averageItemsPerOrder);
        writer.writeNumberValue("averageOrderSize", salesRepRevenueRanking.averageOrderSize);
        writer.writeStringValue("email", salesRepRevenueRanking.email);
        writer.writeStringValue("firstName", salesRepRevenueRanking.firstName);
        writer.writeStringValue("fullName", salesRepRevenueRanking.fullName);
        writer.writeStringValue("lastName", salesRepRevenueRanking.lastName);
        writer.writeNumberValue("orderCount", salesRepRevenueRanking.orderCount);
        writer.writeStringValue("organizationSalesRepId", salesRepRevenueRanking.organizationSalesRepId);
        writer.writeStringValue("phoneNumber", salesRepRevenueRanking.phoneNumber);
        writer.writeStringValue("repNumber", salesRepRevenueRanking.repNumber);
        writer.writeStringValue("salesRepId", salesRepRevenueRanking.salesRepId);
        writer.writeNumberValue("totalRevenue", salesRepRevenueRanking.totalRevenue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSalesRepTrend(writer: SerializationWriter, salesRepTrend: Partial<SalesRepTrend> | undefined | null = {}) : void {
    if (salesRepTrend) {
        writer.writeStringValue("fullName", salesRepTrend.fullName);
        writer.writeNumberValue("orderCount", salesRepTrend.orderCount);
        writer.writeStringValue("organizationSalesRepId", salesRepTrend.organizationSalesRepId);
        writer.writeCollectionOfObjectValues<SalesTrendPoint>("points", salesRepTrend.points, serializeSalesTrendPoint);
        writer.writeStringValue("salesRepId", salesRepTrend.salesRepId);
        writer.writeNumberValue("totalRevenue", salesRepTrend.totalRevenue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSalesTrendPoint(writer: SerializationWriter, salesTrendPoint: Partial<SalesTrendPoint> | undefined | null = {}) : void {
    if (salesTrendPoint) {
        writer.writeNumberValue("orderCount", salesTrendPoint.orderCount);
        writer.writeStringValue("periodStart", salesTrendPoint.periodStart);
        writer.writeNumberValue("revenue", salesTrendPoint.revenue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSavePaymentMethodRequest(writer: SerializationWriter, savePaymentMethodRequest: Partial<SavePaymentMethodRequest> | undefined | null = {}) : void {
    if (savePaymentMethodRequest) {
        writer.writeStringValue("appUrl", savePaymentMethodRequest.appUrl);
        writer.writeObjectValue<BillingAddress>("billingAddress", savePaymentMethodRequest.billingAddress, serializeBillingAddress);
        writer.writeStringValue("cardCode", savePaymentMethodRequest.cardCode);
        writer.writeStringValue("cardNumber", savePaymentMethodRequest.cardNumber);
        writer.writeStringValue("customerNumber", savePaymentMethodRequest.customerNumber);
        writer.writeStringValue("emailAddress", savePaymentMethodRequest.emailAddress);
        writer.writeStringValue("expirationMonth", savePaymentMethodRequest.expirationMonth);
        writer.writeStringValue("expirationYear", savePaymentMethodRequest.expirationYear);
        writer.writeBooleanValue("isDefault", savePaymentMethodRequest.isDefault);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", savePaymentMethodRequest.orgCodes);
        writer.writeStringValue("paymentProvider", savePaymentMethodRequest.paymentProvider);
        writer.writeStringValue("useOrganizationId", savePaymentMethodRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSavePaymentMethodResponse(writer: SerializationWriter, savePaymentMethodResponse: Partial<SavePaymentMethodResponse> | undefined | null = {}) : void {
    if (savePaymentMethodResponse) {
        writer.writeObjectValue<PaymentMethod>("paymentMethod", savePaymentMethodResponse.paymentMethod, serializePaymentMethod);
        writer.writeStringValue("provider", savePaymentMethodResponse.provider);
        writer.writeStringValue("redirectUrl", savePaymentMethodResponse.redirectUrl);
        writer.writeBooleanValue("requiresRedirect", savePaymentMethodResponse.requiresRedirect);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSaveProductFamilyRequest(writer: SerializationWriter, saveProductFamilyRequest: Partial<SaveProductFamilyRequest> | undefined | null = {}) : void {
    if (saveProductFamilyRequest) {
        writer.writeBooleanValue("active", saveProductFamilyRequest.active);
        writer.writeStringValue("category", saveProductFamilyRequest.category);
        writer.writeStringValue("description", saveProductFamilyRequest.description);
        writer.writeStringValue("externalId", saveProductFamilyRequest.externalId);
        writer.writeStringValue("familyKey", saveProductFamilyRequest.familyKey);
        writer.writeCollectionOfPrimitiveValues<string>("images", saveProductFamilyRequest.images);
        writer.writeObjectValue<SaveProductFamilyRequest_imagesByOption>("imagesByOption", saveProductFamilyRequest.imagesByOption, serializeSaveProductFamilyRequest_imagesByOption);
        writer.writeStringValue("name", saveProductFamilyRequest.name);
        writer.writeCollectionOfObjectValues<SaveProductFamilyRequest_SaveProductFamilyOption>("options", saveProductFamilyRequest.options, serializeSaveProductFamilyRequest_SaveProductFamilyOption);
        writer.writeCollectionOfPrimitiveValues<string>("tags", saveProductFamilyRequest.tags);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSaveProductFamilyRequest_imagesByOption(writer: SerializationWriter, saveProductFamilyRequest_imagesByOption: Partial<SaveProductFamilyRequest_imagesByOption> | undefined | null = {}) : void {
    if (saveProductFamilyRequest_imagesByOption) {
        writer.writeAdditionalData(saveProductFamilyRequest_imagesByOption.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSaveProductFamilyRequest_SaveProductFamilyOption(writer: SerializationWriter, saveProductFamilyRequest_SaveProductFamilyOption: Partial<SaveProductFamilyRequest_SaveProductFamilyOption> | undefined | null = {}) : void {
    if (saveProductFamilyRequest_SaveProductFamilyOption) {
        writer.writeStringValue("option", saveProductFamilyRequest_SaveProductFamilyOption.option);
        writer.writeCollectionOfPrimitiveValues<string>("values", saveProductFamilyRequest_SaveProductFamilyOption.values);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSaveSignupProgressRequest(writer: SerializationWriter, saveSignupProgressRequest: Partial<SaveSignupProgressRequest> | undefined | null = {}) : void {
    if (saveSignupProgressRequest) {
        writer.writeStringValue("city", saveSignupProgressRequest.city);
        writer.writeStringValue("companyEmail", saveSignupProgressRequest.companyEmail);
        writer.writeStringValue("companyName", saveSignupProgressRequest.companyName);
        writer.writeStringValue("companyPhone", saveSignupProgressRequest.companyPhone);
        writer.writeStringValue("companyWebsite", saveSignupProgressRequest.companyWebsite);
        writer.writeStringValue("country", saveSignupProgressRequest.country);
        writer.writeStringValue("email", saveSignupProgressRequest.email);
        writer.writeStringValue("firstName", saveSignupProgressRequest.firstName);
        writer.writeStringValue("lastName", saveSignupProgressRequest.lastName);
        writer.writeStringValue("phoneNumber", saveSignupProgressRequest.phoneNumber);
        writer.writeStringValue("stateProvince", saveSignupProgressRequest.stateProvince);
        writer.writeNumberValue("step", saveSignupProgressRequest.step);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSecretField(writer: SerializationWriter, secretField: Partial<SecretField> | undefined | null = {}) : void {
    if (secretField) {
        writer.writeStringValue("description", secretField.description);
        writer.writeStringValue("displayName", secretField.displayName);
        writer.writeBooleanValue("isSensitive", secretField.isSensitive);
        writer.writeStringValue("key", secretField.key);
        writer.writeNumberValue("maxLength", secretField.maxLength);
        writer.writeStringValue("placeholderText", secretField.placeholderText);
        writer.writeBooleanValue("required", secretField.required);
        writer.writeStringValue("validationPattern", secretField.validationPattern);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSendCartShareMessageRequest(writer: SerializationWriter, sendCartShareMessageRequest: Partial<SendCartShareMessageRequest> | undefined | null = {}) : void {
    if (sendCartShareMessageRequest) {
        writer.writeStringValue("body", sendCartShareMessageRequest.body);
        writer.writeObjectValue<CartShareSnapshotRequest>("cart", sendCartShareMessageRequest.cart, serializeCartShareSnapshotRequest);
        writer.writeCollectionOfPrimitiveValues<string>("emails", sendCartShareMessageRequest.emails);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", sendCartShareMessageRequest.orgCodes);
        writer.writeCollectionOfPrimitiveValues<string>("phoneNumbers", sendCartShareMessageRequest.phoneNumbers);
        writer.writeBooleanValue("sendViaEmail", sendCartShareMessageRequest.sendViaEmail);
        writer.writeBooleanValue("sendViaSms", sendCartShareMessageRequest.sendViaSms);
        writer.writeStringValue("subject", sendCartShareMessageRequest.subject);
        writer.writeStringValue("useOrganizationId", sendCartShareMessageRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSendCartShareMessageResponse(writer: SerializationWriter, sendCartShareMessageResponse: Partial<SendCartShareMessageResponse> | undefined | null = {}) : void {
    if (sendCartShareMessageResponse) {
        writer.writeNumberValue("emailsSent", sendCartShareMessageResponse.emailsSent);
        writer.writeCollectionOfPrimitiveValues<string>("errors", sendCartShareMessageResponse.errors);
        writer.writeStringValue("messageId", sendCartShareMessageResponse.messageId);
        writer.writeNumberValue("smsSent", sendCartShareMessageResponse.smsSent);
        writer.writeStringValue("status", sendCartShareMessageResponse.status);
        writer.writeNumberValue("totalRecipients", sendCartShareMessageResponse.totalRecipients);
        writer.writeStringValue("viewOnlineUrl", sendCartShareMessageResponse.viewOnlineUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSendCompanyDocsMessageRequest(writer: SerializationWriter, sendCompanyDocsMessageRequest: Partial<SendCompanyDocsMessageRequest> | undefined | null = {}) : void {
    if (sendCompanyDocsMessageRequest) {
        writer.writeStringValue("body", sendCompanyDocsMessageRequest.body);
        writer.writeCollectionOfPrimitiveValues<string>("documentIds", sendCompanyDocsMessageRequest.documentIds);
        writer.writeCollectionOfPrimitiveValues<string>("emails", sendCompanyDocsMessageRequest.emails);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", sendCompanyDocsMessageRequest.orgCodes);
        writer.writeCollectionOfPrimitiveValues<string>("phoneNumbers", sendCompanyDocsMessageRequest.phoneNumbers);
        writer.writeBooleanValue("sendViaEmail", sendCompanyDocsMessageRequest.sendViaEmail);
        writer.writeBooleanValue("sendViaSms", sendCompanyDocsMessageRequest.sendViaSms);
        writer.writeStringValue("subject", sendCompanyDocsMessageRequest.subject);
        writer.writeStringValue("useOrganizationId", sendCompanyDocsMessageRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSendCompanyDocsMessageResponse(writer: SerializationWriter, sendCompanyDocsMessageResponse: Partial<SendCompanyDocsMessageResponse> | undefined | null = {}) : void {
    if (sendCompanyDocsMessageResponse) {
        writer.writeNumberValue("emailsSent", sendCompanyDocsMessageResponse.emailsSent);
        writer.writeCollectionOfPrimitiveValues<string>("errors", sendCompanyDocsMessageResponse.errors);
        writer.writeStringValue("messageId", sendCompanyDocsMessageResponse.messageId);
        writer.writeNumberValue("smsSent", sendCompanyDocsMessageResponse.smsSent);
        writer.writeStringValue("status", sendCompanyDocsMessageResponse.status);
        writer.writeNumberValue("totalRecipients", sendCompanyDocsMessageResponse.totalRecipients);
        writer.writeStringValue("viewOnlineUrl", sendCompanyDocsMessageResponse.viewOnlineUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSendTearSheetsMessageRequest(writer: SerializationWriter, sendTearSheetsMessageRequest: Partial<SendTearSheetsMessageRequest> | undefined | null = {}) : void {
    if (sendTearSheetsMessageRequest) {
        writer.writeStringValue("body", sendTearSheetsMessageRequest.body);
        writer.writeStringValue("customerNumber", sendTearSheetsMessageRequest.customerNumber);
        writer.writeCollectionOfPrimitiveValues<string>("emails", sendTearSheetsMessageRequest.emails);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", sendTearSheetsMessageRequest.orgCodes);
        writer.writeCollectionOfPrimitiveValues<string>("phoneNumbers", sendTearSheetsMessageRequest.phoneNumbers);
        writer.writeCollectionOfPrimitiveValues<string>("productIds", sendTearSheetsMessageRequest.productIds);
        writer.writeBooleanValue("sendViaEmail", sendTearSheetsMessageRequest.sendViaEmail);
        writer.writeBooleanValue("sendViaSms", sendTearSheetsMessageRequest.sendViaSms);
        writer.writeStringValue("subject", sendTearSheetsMessageRequest.subject);
        writer.writeStringValue("useOrganizationId", sendTearSheetsMessageRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSendTearSheetsMessageResponse(writer: SerializationWriter, sendTearSheetsMessageResponse: Partial<SendTearSheetsMessageResponse> | undefined | null = {}) : void {
    if (sendTearSheetsMessageResponse) {
        writer.writeNumberValue("emailsSent", sendTearSheetsMessageResponse.emailsSent);
        writer.writeCollectionOfPrimitiveValues<string>("errors", sendTearSheetsMessageResponse.errors);
        writer.writeStringValue("messageId", sendTearSheetsMessageResponse.messageId);
        writer.writeNumberValue("smsSent", sendTearSheetsMessageResponse.smsSent);
        writer.writeStringValue("status", sendTearSheetsMessageResponse.status);
        writer.writeStringValue("tearSheetId", sendTearSheetsMessageResponse.tearSheetId);
        writer.writeNumberValue("totalRecipients", sendTearSheetsMessageResponse.totalRecipients);
        writer.writeStringValue("viewOnlineUrl", sendTearSheetsMessageResponse.viewOnlineUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSentEmailDetailDto(writer: SerializationWriter, sentEmailDetailDto: Partial<SentEmailDetailDto> | undefined | null = {}) : void {
    if (sentEmailDetailDto) {
        serializeSentEmailDto(writer, sentEmailDetailDto)
        writer.writeCollectionOfObjectValues<SentEmailEventDto>("events", sentEmailDetailDto.events, serializeSentEmailEventDto);
        writer.writeAdditionalData(sentEmailDetailDto.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSentEmailDto(writer: SerializationWriter, sentEmailDto: Partial<SentEmailDto> | undefined | null = {}) : void {
    if (sentEmailDto) {
        writer.writeStringValue("audience", sentEmailDto.audience);
        writer.writeStringValue("bounceReason", sentEmailDto.bounceReason);
        writer.writeStringValue("bounceType", sentEmailDto.bounceType);
        writer.writeNumberValue("clickCount", sentEmailDto.clickCount);
        writer.writeStringValue("entityId", sentEmailDto.entityId);
        writer.writeStringValue("entityReference", sentEmailDto.entityReference);
        writer.writeDateValue("firstClickedAt", sentEmailDto.firstClickedAt);
        writer.writeDateValue("firstOpenedAt", sentEmailDto.firstOpenedAt);
        writer.writeStringValue("id", sentEmailDto.id);
        writer.writeStringValue("kind", sentEmailDto.kind);
        writer.writeDateValue("lastClickedAt", sentEmailDto.lastClickedAt);
        writer.writeDateValue("lastOpenedAt", sentEmailDto.lastOpenedAt);
        writer.writeStringValue("latestStatus", sentEmailDto.latestStatus);
        writer.writeDateValue("latestStatusAt", sentEmailDto.latestStatusAt);
        writer.writeStringValue("messageId", sentEmailDto.messageId);
        writer.writeNumberValue("openCount", sentEmailDto.openCount);
        writer.writeStringValue("recipient", sentEmailDto.recipient);
        writer.writeDateValue("sentAt", sentEmailDto.sentAt);
        writer.writeStringValue("subject", sentEmailDto.subject);
        writer.writeStringValue("template", sentEmailDto.template);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSentEmailEventDto(writer: SerializationWriter, sentEmailEventDto: Partial<SentEmailEventDto> | undefined | null = {}) : void {
    if (sentEmailEventDto) {
        writer.writeStringValue("link", sentEmailEventDto.link);
        writer.writeDateValue("occurredAt", sentEmailEventDto.occurredAt);
        writer.writeStringValue("reason", sentEmailEventDto.reason);
        writer.writeStringValue("type", sentEmailEventDto.type);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetAsDefaultRequest(writer: SerializationWriter, setAsDefaultRequest: Partial<SetAsDefaultRequest> | undefined | null = {}) : void {
    if (setAsDefaultRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", setAsDefaultRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", setAsDefaultRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetCampaignActiveRequest(writer: SerializationWriter, setCampaignActiveRequest: Partial<SetCampaignActiveRequest> | undefined | null = {}) : void {
    if (setCampaignActiveRequest) {
        writer.writeBooleanValue("active", setCampaignActiveRequest.active);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetCodeActiveRequest(writer: SerializationWriter, setCodeActiveRequest: Partial<SetCodeActiveRequest> | undefined | null = {}) : void {
    if (setCodeActiveRequest) {
        writer.writeBooleanValue("active", setCodeActiveRequest.active);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetCustomerVendorAccountRequest(writer: SerializationWriter, setCustomerVendorAccountRequest: Partial<SetCustomerVendorAccountRequest> | undefined | null = {}) : void {
    if (setCustomerVendorAccountRequest) {
        serializeCustomerVendorAccountRequest(writer, setCustomerVendorAccountRequest)
        writer.writeStringValue("notes", setCustomerVendorAccountRequest.notes);
        writer.writeStringValue("paymentMethodId", setCustomerVendorAccountRequest.paymentMethodId);
        writer.writeStringValue("priceLevelId", setCustomerVendorAccountRequest.priceLevelId);
        writer.writeStringValue("terms", setCustomerVendorAccountRequest.terms);
        writer.writeStringValue("vendorAccountNumber", setCustomerVendorAccountRequest.vendorAccountNumber);
        writer.writeAdditionalData(setCustomerVendorAccountRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetDiscountPermissionsRequest(writer: SerializationWriter, setDiscountPermissionsRequest: Partial<SetDiscountPermissionsRequest> | undefined | null = {}) : void {
    if (setDiscountPermissionsRequest) {
        writer.writeEnumValue<DiscountPermission>("lineItemDiscounts", setDiscountPermissionsRequest.lineItemDiscounts);
        writer.writeEnumValue<DiscountPermission>("orderDiscounts", setDiscountPermissionsRequest.orderDiscounts);
        writer.writeStringValue("organizationSalesRepId", setDiscountPermissionsRequest.organizationSalesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetDiscountPermissionsResponse(writer: SerializationWriter, setDiscountPermissionsResponse: Partial<SetDiscountPermissionsResponse> | undefined | null = {}) : void {
    if (setDiscountPermissionsResponse) {
        writer.writeEnumValue<DiscountPermission>("lineItemDiscounts", setDiscountPermissionsResponse.lineItemDiscounts);
        writer.writeEnumValue<DiscountPermission>("orderDiscounts", setDiscountPermissionsResponse.orderDiscounts);
        writer.writeStringValue("organizationId", setDiscountPermissionsResponse.organizationId);
        writer.writeStringValue("organizationSalesRepId", setDiscountPermissionsResponse.organizationSalesRepId);
        writer.writeBooleanValue("success", setDiscountPermissionsResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetVendorLineDiscountRequest(writer: SerializationWriter, setVendorLineDiscountRequest: Partial<SetVendorLineDiscountRequest> | undefined | null = {}) : void {
    if (setVendorLineDiscountRequest) {
        serializeVendorLineRequest(writer, setVendorLineDiscountRequest)
        writer.writeNumberValue("discountPercent", setVendorLineDiscountRequest.discountPercent);
        writer.writeAdditionalData(setVendorLineDiscountRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetVendorLineShipWindowRequest(writer: SerializationWriter, setVendorLineShipWindowRequest: Partial<SetVendorLineShipWindowRequest> | undefined | null = {}) : void {
    if (setVendorLineShipWindowRequest) {
        serializeVendorLineRequest(writer, setVendorLineShipWindowRequest)
        writer.writeDateOnlyValue("cancelDate", setVendorLineShipWindowRequest.cancelDate);
        writer.writeDateOnlyValue("shipDate", setVendorLineShipWindowRequest.shipDate);
        writer.writeStringValue("shipWindowName", setVendorLineShipWindowRequest.shipWindowName);
        writer.writeAdditionalData(setVendorLineShipWindowRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetViewAllCustomersRequest(writer: SerializationWriter, setViewAllCustomersRequest: Partial<SetViewAllCustomersRequest> | undefined | null = {}) : void {
    if (setViewAllCustomersRequest) {
        writer.writeBooleanValue("canViewAllCustomers", setViewAllCustomersRequest.canViewAllCustomers);
        writer.writeStringValue("organizationSalesRepId", setViewAllCustomersRequest.organizationSalesRepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetViewAllCustomersResponse(writer: SerializationWriter, setViewAllCustomersResponse: Partial<SetViewAllCustomersResponse> | undefined | null = {}) : void {
    if (setViewAllCustomersResponse) {
        writer.writeBooleanValue("canViewAllCustomers", setViewAllCustomersResponse.canViewAllCustomers);
        writer.writeStringValue("organizationId", setViewAllCustomersResponse.organizationId);
        writer.writeStringValue("organizationSalesRepId", setViewAllCustomersResponse.organizationSalesRepId);
        writer.writeBooleanValue("success", setViewAllCustomersResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeShippingDetails(writer: SerializationWriter, shippingDetails: Partial<ShippingDetails> | undefined | null = {}) : void {
    if (shippingDetails) {
        writer.writeStringValue("method", shippingDetails.method);
        writer.writeNumberValue("total", shippingDetails.total);
        writer.writeStringValue("totalFormatted", shippingDetails.totalFormatted);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeShippingDetailsDto(writer: SerializationWriter, shippingDetailsDto: Partial<ShippingDetailsDto> | undefined | null = {}) : void {
    if (shippingDetailsDto) {
        writer.writeStringValue("method", shippingDetailsDto.method);
        writer.writeNumberValue("total", shippingDetailsDto.total);
        writer.writeStringValue("totalFormatted", shippingDetailsDto.totalFormatted);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeShippingDetailsInput(writer: SerializationWriter, shippingDetailsInput: Partial<ShippingDetailsInput> | undefined | null = {}) : void {
    if (shippingDetailsInput) {
        writer.writeStringValue("method", shippingDetailsInput.method);
        writer.writeNumberValue("total", shippingDetailsInput.total);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeShoppingCart(writer: SerializationWriter, shoppingCart: Partial<ShoppingCart> | undefined | null = {}) : void {
    if (shoppingCart) {
        serializeBaseEntity(writer, shoppingCart)
        writer.writeStringValue("appliedCode", shoppingCart.appliedCode);
        writer.writeObjectValue<PromotionSkip>("appliedCodeSkip", shoppingCart.appliedCodeSkip, serializePromotionSkip);
        writer.writeCollectionOfObjectValues<AppliedPromotion>("appliedPromotions", shoppingCart.appliedPromotions, serializeAppliedPromotion);
        writer.writeObjectValue<Address>("billingAddress", shoppingCart.billingAddress, serializeAddress);
        writer.writeCollectionOfObjectValues<CartItem>("cartItems", shoppingCart.cartItems, serializeCartItem);
        writer.writeStringValue("channel", shoppingCart.channel);
        writer.writeStringValue("companyEmail", shoppingCart.companyEmail);
        writer.writeStringValue("companyFax", shoppingCart.companyFax);
        writer.writeStringValue("companyName", shoppingCart.companyName);
        writer.writeStringValue("companyPhone", shoppingCart.companyPhone);
        writer.writeStringValue("currencyCode", shoppingCart.currencyCode);
        writer.writeStringValue("customerNumber", shoppingCart.customerNumber);
        writer.writeObjectValue<Discount>("discount", shoppingCart.discount, serializeDiscount);
        writer.writeNumberValue("discountAmount", shoppingCart.discountAmount);
        writer.writeObjectValue<FreeShippingEntitlement>("freeShipping", shoppingCart.freeShipping, serializeFreeShippingEntitlement);
        writer.writeStringValue("fulfillmentMethod", shoppingCart.fulfillmentMethod);
        writer.writeObjectValue<CartPriceRefreshSummary>("lastPriceRefresh", shoppingCart.lastPriceRefresh, serializeCartPriceRefreshSummary);
        writer.writeCollectionOfObjectValues<CartLine>("lines", shoppingCart.lines, serializeCartLine);
        writer.writeStringValue("marketCode", shoppingCart.marketCode);
        writer.writeStringValue("notes", shoppingCart.notes);
        writer.writeStringValue("orderStatus", shoppingCart.orderStatus);
        writer.writeNumberValue("orderTotal", shoppingCart.orderTotal);
        writer.writeStringValue("orderType", shoppingCart.orderType);
        writer.writeStringValue("organizationId", shoppingCart.organizationId);
        writer.writeStringValue("poNumber", shoppingCart.poNumber);
        writer.writeDateValue("pricesRefreshedUtc", shoppingCart.pricesRefreshedUtc);
        writer.writeStringValue("priceTier", shoppingCart.priceTier);
        writer.writeObjectValue<Rep>("primarySalesRep", shoppingCart.primarySalesRep, serializeRep);
        writer.writeCollectionOfPrimitiveValues<string>("receiptTo", shoppingCart.receiptTo);
        writer.writeObjectValue<CartReview>("review", shoppingCart.review, serializeCartReview);
        writer.writeNumberValue("shipping", shoppingCart.shipping);
        writer.writeObjectValue<Address>("shippingAddress", shoppingCart.shippingAddress, serializeAddress);
        writer.writeStringValue("shippingMethod", shoppingCart.shippingMethod);
        writer.writeStringValue("shoppingCartId", shoppingCart.shoppingCartId);
        writer.writeNumberValue("subtotal", shoppingCart.subtotal);
        writer.writeObjectValue<Rep>("takenBySalesRep", shoppingCart.takenBySalesRep, serializeRep);
        writer.writeNumberValue("tax", shoppingCart.tax);
        writer.writeCollectionOfObjectValues<TaxLineItem>("taxItems", shoppingCart.taxItems, serializeTaxLineItem);
        writer.writeStringValue("terms", shoppingCart.terms);
        writer.writeObjectValue<User3>("user", shoppingCart.user, serializeUser3);
        writer.writeNumberValue("vendorLineDiscountAmount", shoppingCart.vendorLineDiscountAmount);
        writer.writeAdditionalData(shoppingCart.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSimulateRequest(writer: SerializationWriter, simulateRequest: Partial<SimulateRequest> | undefined | null = {}) : void {
    if (simulateRequest) {
        writer.writeStringValue("campaignId", simulateRequest.campaignId);
        writer.writeStringValue("code", simulateRequest.code);
        writer.writeStringValue("shoppingCartId", simulateRequest.shoppingCartId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSimulateResponse(writer: SerializationWriter, simulateResponse: Partial<SimulateResponse> | undefined | null = {}) : void {
    if (simulateResponse) {
        writer.writeObjectValue<ShoppingCart>("cart", simulateResponse.cart, serializeShoppingCart);
        writer.writeObjectValue<PromotionPlan>("plan", simulateResponse.plan, serializePromotionPlan);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSkippedLine(writer: SerializationWriter, skippedLine: Partial<SkippedLine> | undefined | null = {}) : void {
    if (skippedLine) {
        writer.writeStringValue("reason", skippedLine.reason);
        writer.writeStringValue("vendorCode", skippedLine.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSkuHistoryPointDto(writer: SerializationWriter, skuHistoryPointDto: Partial<SkuHistoryPointDto> | undefined | null = {}) : void {
    if (skuHistoryPointDto) {
        writer.writeNumberValue("month", skuHistoryPointDto.month);
        writer.writeNumberValue("unitsSold", skuHistoryPointDto.unitsSold);
        writer.writeNumberValue("year", skuHistoryPointDto.year);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSplitVendorLineResponse(writer: SerializationWriter, splitVendorLineResponse: Partial<SplitVendorLineResponse> | undefined | null = {}) : void {
    if (splitVendorLineResponse) {
        writer.writeObjectValue<ShoppingCart>("newCart", splitVendorLineResponse.newCart, serializeShoppingCart);
        writer.writeObjectValue<ShoppingCart>("sourceCart", splitVendorLineResponse.sourceCart, serializeShoppingCart);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSqlConnectorStatus(writer: SerializationWriter, sqlConnectorStatus: Partial<SqlConnectorStatus> | undefined | null = {}) : void {
    if (sqlConnectorStatus) {
        writer.writeStringValue("connectorName", sqlConnectorStatus.connectorName);
        writer.writeStringValue("hostName", sqlConnectorStatus.hostName);
        writer.writeStringValue("id", sqlConnectorStatus.id);
        writer.writeDateValue("lastHeartbeatAt", sqlConnectorStatus.lastHeartbeatAt);
        writer.writeObjectValue<SqlConnectorStatus_metadata>("metadata", sqlConnectorStatus.metadata, serializeSqlConnectorStatus_metadata);
        writer.writeStringValue("organizationId", sqlConnectorStatus.organizationId);
        writer.writeDateValue("registeredAt", sqlConnectorStatus.registeredAt);
        writer.writeEnumValue<ConnectorStatusType>("status", sqlConnectorStatus.status);
        writer.writeDateValue("updatedAt", sqlConnectorStatus.updatedAt);
        writer.writeStringValue("version", sqlConnectorStatus.version);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSqlConnectorStatus_metadata(writer: SerializationWriter, sqlConnectorStatus_metadata: Partial<SqlConnectorStatus_metadata> | undefined | null = {}) : void {
    if (sqlConnectorStatus_metadata) {
        writer.writeAdditionalData(sqlConnectorStatus_metadata.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStatementEventDto(writer: SerializationWriter, statementEventDto: Partial<StatementEventDto> | undefined | null = {}) : void {
    if (statementEventDto) {
        writer.writeStringValue("eventId", statementEventDto.eventId);
        writer.writeStringValue("fromStatus", statementEventDto.fromStatus);
        writer.writeStringValue("message", statementEventDto.message);
        writer.writeDateValue("timestamp", statementEventDto.timestamp);
        writer.writeStringValue("toStatus", statementEventDto.toStatus);
        writer.writeStringValue("user", statementEventDto.user);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStep(writer: SerializationWriter, step: Partial<Step> | undefined | null = {}) : void {
    if (step) {
        writer.writeBooleanValue("isComplete", step.isComplete);
        writer.writeStringValue("name", step.name);
        writer.writeNumberValue("order", step.order);
        writer.writeStringValue("stepId", step.stepId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStorageStatsResponse(writer: SerializationWriter, storageStatsResponse: Partial<StorageStatsResponse> | undefined | null = {}) : void {
    if (storageStatsResponse) {
        writer.writeObjectValue<DocumentStorageStatsDto>("stats", storageStatsResponse.stats, serializeDocumentStorageStatsDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStorefrontUserCustomerResponse(writer: SerializationWriter, storefrontUserCustomerResponse: Partial<StorefrontUserCustomerResponse> | undefined | null = {}) : void {
    if (storefrontUserCustomerResponse) {
        writer.writeDateValue("associatedAt", storefrontUserCustomerResponse.associatedAt);
        writer.writeStringValue("companyName", storefrontUserCustomerResponse.companyName);
        writer.writeBooleanValue("customerActive", storefrontUserCustomerResponse.customerActive);
        writer.writeStringValue("customerNumber", storefrontUserCustomerResponse.customerNumber);
        writer.writeBooleanValue("customerRecordFound", storefrontUserCustomerResponse.customerRecordFound);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStorefrontUserResponse(writer: SerializationWriter, storefrontUserResponse: Partial<StorefrontUserResponse> | undefined | null = {}) : void {
    if (storefrontUserResponse) {
        writer.writeCollectionOfObjectValues<StorefrontUserCustomerResponse>("customers", storefrontUserResponse.customers, serializeStorefrontUserCustomerResponse);
        writer.writeStringValue("email", storefrontUserResponse.email);
        writer.writeStringValue("firstName", storefrontUserResponse.firstName);
        writer.writeStringValue("fullName", storefrontUserResponse.fullName);
        writer.writeDateValue("joinedOn", storefrontUserResponse.joinedOn);
        writer.writeStringValue("lastName", storefrontUserResponse.lastName);
        writer.writeStringValue("pictureUrl", storefrontUserResponse.pictureUrl);
        writer.writeStringValue("userId", storefrontUserResponse.userId);
        writer.writeBooleanValue("userRecordFound", storefrontUserResponse.userRecordFound);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStructuredFormatting(writer: SerializationWriter, structuredFormatting: Partial<StructuredFormatting> | undefined | null = {}) : void {
    if (structuredFormatting) {
        writer.writeStringValue("mainText", structuredFormatting.mainText);
        writer.writeCollectionOfObjectValues<MatchedSubstring>("mainTextMatchedSubstrings", structuredFormatting.mainTextMatchedSubstrings, serializeMatchedSubstring);
        writer.writeStringValue("secondaryText", structuredFormatting.secondaryText);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubmitForReviewRequest(writer: SerializationWriter, submitForReviewRequest: Partial<SubmitForReviewRequest> | undefined | null = {}) : void {
    if (submitForReviewRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", submitForReviewRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", submitForReviewRequest.useOrganizationId);
        writer.writeStringValue("user", submitForReviewRequest.user);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubmitForReviewRequest2(writer: SerializationWriter, submitForReviewRequest2: Partial<SubmitForReviewRequest2> | undefined | null = {}) : void {
    if (submitForReviewRequest2) {
        writer.writeStringValue("note", submitForReviewRequest2.note);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscription(writer: SerializationWriter, subscription: Partial<Subscription> | undefined | null = {}) : void {
    if (subscription) {
        writer.writeStringValue("id", subscription.id);
        writer.writeStringValue("status", subscription.status);
        writer.writeCollectionOfObjectValues<SubscriptionItem>("subscription_items", subscription.subscriptionItems, serializeSubscriptionItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscription2(writer: SerializationWriter, subscription2: Partial<Subscription2> | undefined | null = {}) : void {
    if (subscription2) {
        writer.writeStringValue("id", subscription2.id);
        writer.writeStringValue("seatItemPriceId", subscription2.seatItemPriceId);
        writer.writeNumberValue("seats", subscription2.seats);
        writer.writeStringValue("status", subscription2.status);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscriptionCreatedCustomer(writer: SerializationWriter, subscriptionCreatedCustomer: Partial<SubscriptionCreatedCustomer> | undefined | null = {}) : void {
    if (subscriptionCreatedCustomer) {
        writer.writeStringValue("id", subscriptionCreatedCustomer.id);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscriptionCreatedRequest(writer: SerializationWriter, subscriptionCreatedRequest: Partial<SubscriptionCreatedRequest> | undefined | null = {}) : void {
    if (subscriptionCreatedRequest) {
        writer.writeObjectValue<Content>("content", subscriptionCreatedRequest.content, serializeContent);
        writer.writeStringValue("event_type", subscriptionCreatedRequest.eventType);
        writer.writeStringValue("id", subscriptionCreatedRequest.id);
        writer.writeNumberValue("occurred_at", subscriptionCreatedRequest.occurredAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscriptionDiscountLine(writer: SerializationWriter, subscriptionDiscountLine: Partial<SubscriptionDiscountLine> | undefined | null = {}) : void {
    if (subscriptionDiscountLine) {
        writer.writeNumberValue("amount", subscriptionDiscountLine.amount);
        writer.writeNumberValue("amountOff", subscriptionDiscountLine.amountOff);
        writer.writeCollectionOfPrimitiveValues<string>("appliesTo", subscriptionDiscountLine.appliesTo);
        writer.writeBooleanValue("appliesToNextCharge", subscriptionDiscountLine.appliesToNextCharge);
        writer.writeStringValue("code", subscriptionDiscountLine.code);
        writer.writeStringValue("duration", subscriptionDiscountLine.duration);
        writer.writeNumberValue("durationInMonths", subscriptionDiscountLine.durationInMonths);
        writer.writeDateValue("endsAt", subscriptionDiscountLine.endsAt);
        writer.writeStringValue("name", subscriptionDiscountLine.name);
        writer.writeNumberValue("percentOff", subscriptionDiscountLine.percentOff);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscriptionEntitlement(writer: SerializationWriter, subscriptionEntitlement: Partial<SubscriptionEntitlement> | undefined | null = {}) : void {
    if (subscriptionEntitlement) {
        writer.writeStringValue("featureId", subscriptionEntitlement.featureId);
        writer.writeStringValue("featureName", subscriptionEntitlement.featureName);
        writer.writeStringValue("id", subscriptionEntitlement.id);
        writer.writeBooleanValue("isOverridden", subscriptionEntitlement.isOverridden);
        writer.writeStringValue("name", subscriptionEntitlement.name);
        writer.writeStringValue("subscriptionId", subscriptionEntitlement.subscriptionId);
        writer.writeStringValue("value", subscriptionEntitlement.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscriptionItem(writer: SerializationWriter, subscriptionItem: Partial<SubscriptionItem> | undefined | null = {}) : void {
    if (subscriptionItem) {
        writer.writeStringValue("item_price_id", subscriptionItem.itemPriceId);
        writer.writeNumberValue("quantity", subscriptionItem.quantity);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscriptionPlanLine(writer: SerializationWriter, subscriptionPlanLine: Partial<SubscriptionPlanLine> | undefined | null = {}) : void {
    if (subscriptionPlanLine) {
        writer.writeNumberValue("amount", subscriptionPlanLine.amount);
        writer.writeBooleanValue("isPerSeat", subscriptionPlanLine.isPerSeat);
        writer.writeStringValue("lookupKey", subscriptionPlanLine.lookupKey);
        writer.writeStringValue("name", subscriptionPlanLine.name);
        writer.writeNumberValue("quantity", subscriptionPlanLine.quantity);
        writer.writeNumberValue("unitPrice", subscriptionPlanLine.unitPrice);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSuggestMappingsRequest(writer: SerializationWriter, suggestMappingsRequest: Partial<SuggestMappingsRequest> | undefined | null = {}) : void {
    if (suggestMappingsRequest) {
        writer.writeCollectionOfObjectValues<ImportColumnSample>("columns", suggestMappingsRequest.columns, serializeImportColumnSample);
        writer.writeStringValue("importType", suggestMappingsRequest.importType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSuggestMappingsResponse(writer: SerializationWriter, suggestMappingsResponse: Partial<SuggestMappingsResponse> | undefined | null = {}) : void {
    if (suggestMappingsResponse) {
        writer.writeCollectionOfObjectValues<ColumnMappingSuggestion>("columns", suggestMappingsResponse.columns, serializeColumnMappingSuggestion);
        writer.writeBooleanValue("degraded", suggestMappingsResponse.degraded);
        writer.writeStringValue("degradedReason", suggestMappingsResponse.degradedReason);
        writer.writeStringValue("importType", suggestMappingsResponse.importType);
        writer.writeStringValue("model", suggestMappingsResponse.model);
        writer.writeStringValue("runId", suggestMappingsResponse.runId);
        writer.writeCollectionOfPrimitiveValues<string>("targets", suggestMappingsResponse.targets);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSuggestResearchSettingsRequest(writer: SerializationWriter, suggestResearchSettingsRequest: Partial<SuggestResearchSettingsRequest> | undefined | null = {}) : void {
    if (suggestResearchSettingsRequest) {
        writer.writeBooleanValue("forceRegenerate", suggestResearchSettingsRequest.forceRegenerate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSuggestResearchSettingsResponse(writer: SerializationWriter, suggestResearchSettingsResponse: Partial<SuggestResearchSettingsResponse> | undefined | null = {}) : void {
    if (suggestResearchSettingsResponse) {
        writer.writeStringValue("approvalCriteria", suggestResearchSettingsResponse.approvalCriteria);
        writer.writeNumberValue("estimatedCostUsd", suggestResearchSettingsResponse.estimatedCostUsd);
        writer.writeDateValue("generatedAt", suggestResearchSettingsResponse.generatedAt);
        writer.writeStringValue("generatedBy", suggestResearchSettingsResponse.generatedBy);
        writer.writeStringValue("industryDescription", suggestResearchSettingsResponse.industryDescription);
        writer.writeNumberValue("tokensUsed", suggestResearchSettingsResponse.tokensUsed);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSyncBatchResultDto(writer: SerializationWriter, syncBatchResultDto: Partial<SyncBatchResultDto> | undefined | null = {}) : void {
    if (syncBatchResultDto) {
        writer.writeNumberValue("batchNumber", syncBatchResultDto.batchNumber);
        writer.writeNumberValue("durationSeconds", syncBatchResultDto.durationSeconds);
        writer.writeStringValue("errorMessage", syncBatchResultDto.errorMessage);
        writer.writeNumberValue("httpStatusCode", syncBatchResultDto.httpStatusCode);
        writer.writeBooleanValue("isSuccess", syncBatchResultDto.isSuccess);
        writer.writeNumberValue("recordCount", syncBatchResultDto.recordCount);
        writer.writeNumberValue("retryAttempts", syncBatchResultDto.retryAttempts);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSyncRunDocument(writer: SerializationWriter, syncRunDocument: Partial<SyncRunDocument> | undefined | null = {}) : void {
    if (syncRunDocument) {
        writer.writeCollectionOfObjectValues<SyncBatchResultDto>("batchResults", syncRunDocument.batchResults, serializeSyncBatchResultDto);
        writer.writeDateValue("completedAt", syncRunDocument.completedAt);
        writer.writeStringValue("connectorId", syncRunDocument.connectorId);
        writer.writeNumberValue("durationSeconds", syncRunDocument.durationSeconds);
        writer.writeStringValue("endpointId", syncRunDocument.endpointId);
        writer.writeStringValue("endpointName", syncRunDocument.endpointName);
        writer.writeStringValue("errorMessage", syncRunDocument.errorMessage);
        writer.writeNumberValue("failedBatches", syncRunDocument.failedBatches);
        writer.writeNumberValue("failedRecords", syncRunDocument.failedRecords);
        writer.writeStringValue("id", syncRunDocument.id);
        writer.writeBooleanValue("isManualTrigger", syncRunDocument.isManualTrigger);
        writer.writeStringValue("organizationId", syncRunDocument.organizationId);
        writer.writeDateValue("pushedAt", syncRunDocument.pushedAt);
        writer.writeDateValue("startedAt", syncRunDocument.startedAt);
        writer.writeStringValue("status", syncRunDocument.status);
        writer.writeNumberValue("successfulBatches", syncRunDocument.successfulBatches);
        writer.writeNumberValue("successfulRecords", syncRunDocument.successfulRecords);
        writer.writeStringValue("syncMode", syncRunDocument.syncMode);
        writer.writeStringValue("syncRunId", syncRunDocument.syncRunId);
        writer.writeNumberValue("totalBatches", syncRunDocument.totalBatches);
        writer.writeNumberValue("totalRecords", syncRunDocument.totalRecords);
        writer.writeDateValue("updatedAt", syncRunDocument.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTag(writer: SerializationWriter, tag: Partial<Tag> | undefined | null = {}) : void {
    if (tag) {
        writer.writeStringValue("categoryPath", tag.categoryPath);
        writer.writeNumberValue("height", tag.height);
        writer.writeEnumValue<TagKind>("kind", tag.kind);
        writer.writeStringValue("sku", tag.sku);
        writer.writeNumberValue("width", tag.width);
        writer.writeNumberValue("x", tag.x);
        writer.writeNumberValue("y", tag.y);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTagInfo(writer: SerializationWriter, tagInfo: Partial<TagInfo> | undefined | null = {}) : void {
    if (tagInfo) {
        writer.writeStringValue("categoryPath", tagInfo.categoryPath);
        writer.writeNumberValue("height", tagInfo.height);
        writer.writeEnumValue<TagKind>("kind", tagInfo.kind);
        writer.writeStringValue("sku", tagInfo.sku);
        writer.writeNumberValue("width", tagInfo.width);
        writer.writeNumberValue("x", tagInfo.x);
        writer.writeNumberValue("y", tagInfo.y);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTaskItem(writer: SerializationWriter, taskItem: Partial<TaskItem> | undefined | null = {}) : void {
    if (taskItem) {
        serializeBaseEntity(writer, taskItem)
        writer.writeDateValue("completedAt", taskItem.completedAt);
        writer.writeStringValue("completedByIdentityProviderUserId", taskItem.completedByIdentityProviderUserId);
        writer.writeStringValue("completedByName", taskItem.completedByName);
        writer.writeStringValue("createdByIdentityProviderUserId", taskItem.createdByIdentityProviderUserId);
        writer.writeStringValue("createdByName", taskItem.createdByName);
        writer.writeStringValue("customerId", taskItem.customerId);
        writer.writeStringValue("customerName", taskItem.customerName);
        writer.writeStringValue("customerNumber", taskItem.customerNumber);
        writer.writeStringValue("customerRepNumber", taskItem.customerRepNumber);
        writer.writeStringValue("description", taskItem.description);
        writer.writeDateValue("dueAt", taskItem.dueAt);
        writer.writeStringValue("dueTimeZoneId", taskItem.dueTimeZoneId);
        writer.writeStringValue("organizationId", taskItem.organizationId);
        writer.writeStringValue("organizationSalesRepId", taskItem.organizationSalesRepId);
        writer.writeEnumValue<TaskPriority>("priority", taskItem.priority);
        writer.writeStringValue("salesRepId", taskItem.salesRepId);
        writer.writeStringValue("salesRepName", taskItem.salesRepName);
        writer.writeStringValue("salesRepRepNumber", taskItem.salesRepRepNumber);
        writer.writeNumberValue("sortOrder", taskItem.sortOrder);
        writer.writeEnumValue<TaskItemStatus>("status", taskItem.status);
        writer.writeStringValue("taskItemId", taskItem.taskItemId);
        writer.writeStringValue("title", taskItem.title);
        writer.writeAdditionalData(taskItem.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTasksSummaryResponse(writer: SerializationWriter, tasksSummaryResponse: Partial<TasksSummaryResponse> | undefined | null = {}) : void {
    if (tasksSummaryResponse) {
        writer.writeDateValue("asOf", tasksSummaryResponse.asOf);
        writer.writeNumberValue("dueThisWeek", tasksSummaryResponse.dueThisWeek);
        writer.writeNumberValue("dueToday", tasksSummaryResponse.dueToday);
        writer.writeDateValue("endOfToday", tasksSummaryResponse.endOfToday);
        writer.writeDateValue("endOfWeek", tasksSummaryResponse.endOfWeek);
        writer.writeNumberValue("open", tasksSummaryResponse.open);
        writer.writeNumberValue("overdue", tasksSummaryResponse.overdue);
        writer.writeDateValue("startOfToday", tasksSummaryResponse.startOfToday);
        writer.writeStringValue("timeZone", tasksSummaryResponse.timeZone);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTaxLineItem(writer: SerializationWriter, taxLineItem: Partial<TaxLineItem> | undefined | null = {}) : void {
    if (taxLineItem) {
        writer.writeNumberValue("amount", taxLineItem.amount);
        writer.writeStringValue("jurisdiction", taxLineItem.jurisdiction);
        writer.writeNumberValue("ratePercent", taxLineItem.ratePercent);
        writer.writeNumberValue("taxableAmount", taxLineItem.taxableAmount);
        writer.writeStringValue("taxName", taxLineItem.taxName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTaxRule(writer: SerializationWriter, taxRule: Partial<TaxRule> | undefined | null = {}) : void {
    if (taxRule) {
        writer.writeStringValue("country", taxRule.country);
        writer.writeNumberValue("ratePercent", taxRule.ratePercent);
        writer.writeEnumValue<SourcingBasis>("sourcingBasis", taxRule.sourcingBasis);
        writer.writeStringValue("stateProvince", taxRule.stateProvince);
        writer.writeStringValue("taxName", taxRule.taxName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTaxSettings(writer: SerializationWriter, taxSettings: Partial<TaxSettings> | undefined | null = {}) : void {
    if (taxSettings) {
        writer.writeBooleanValue("isEnabled", taxSettings.isEnabled);
        writer.writeCollectionOfPrimitiveValues<string>("nexusStates", taxSettings.nexusStates);
        writer.writeStringValue("provider", taxSettings.provider);
        writer.writeCollectionOfObjectValues<TaxRule>("ruleOverrides", taxSettings.ruleOverrides, serializeTaxRule);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTearSheet(writer: SerializationWriter, tearSheet: Partial<TearSheet> | undefined | null = {}) : void {
    if (tearSheet) {
        writer.writeBooleanValue("active", tearSheet.active);
        writer.writeDateValue("createdAt", tearSheet.createdAt);
        writer.writeStringValue("customerNumber", tearSheet.customerNumber);
        writer.writeStringValue("description", tearSheet.description);
        writer.writeStringValue("name", tearSheet.name);
        writer.writeStringValue("organizationId", tearSheet.organizationId);
        writer.writeCollectionOfPrimitiveValues<string>("productIds", tearSheet.productIds);
        writer.writeStringValue("salesRepId", tearSheet.salesRepId);
        writer.writeStringValue("salesRepName", tearSheet.salesRepName);
        writer.writeDateValue("sentAt", tearSheet.sentAt);
        writer.writeStringValue("sentToEmail", tearSheet.sentToEmail);
        writer.writeStringValue("sentToPhoneNumber", tearSheet.sentToPhoneNumber);
        writer.writeStringValue("sentVia", tearSheet.sentVia);
        writer.writeStringValue("status", tearSheet.status);
        writer.writeStringValue("tearSheetId", tearSheet.tearSheetId);
        writer.writeDateValue("updatedAt", tearSheet.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTerm(writer: SerializationWriter, term: Partial<Term> | undefined | null = {}) : void {
    if (term) {
        writer.writeNumberValue("offset", term.offset);
        writer.writeStringValue("value", term.value);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTestIntegrationResponse(writer: SerializationWriter, testIntegrationResponse: Partial<TestIntegrationResponse> | undefined | null = {}) : void {
    if (testIntegrationResponse) {
        writer.writeStringValue("integrationId", testIntegrationResponse.integrationId);
        writer.writeBooleanValue("isSuccessful", testIntegrationResponse.isSuccessful);
        writer.writeStringValue("message", testIntegrationResponse.message);
        writer.writeDateValue("testedAt", testIntegrationResponse.testedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTestJobRequest(writer: SerializationWriter, testJobRequest: Partial<TestJobRequest> | undefined | null = {}) : void {
    if (testJobRequest) {
        writer.writeStringValue("organizationId", testJobRequest.organizationId);
        writer.writeStringValue("productId", testJobRequest.productId);
        writer.writeStringValue("productSku", testJobRequest.productSku);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTrainOrderVolumeForecastModelRequest(writer: SerializationWriter, trainOrderVolumeForecastModelRequest: Partial<TrainOrderVolumeForecastModelRequest> | undefined | null = {}) : void {
    if (trainOrderVolumeForecastModelRequest) {
        writer.writeDateValue("endDate", trainOrderVolumeForecastModelRequest.endDate);
        writer.writeDateValue("startDate", trainOrderVolumeForecastModelRequest.startDate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTrainOrderVolumeForecastModelResponse(writer: SerializationWriter, trainOrderVolumeForecastModelResponse: Partial<TrainOrderVolumeForecastModelResponse> | undefined | null = {}) : void {
    if (trainOrderVolumeForecastModelResponse) {
        writer.writeObjectValue<ForecastModelDto>("model", trainOrderVolumeForecastModelResponse.model, serializeForecastModelDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTrainSkuForecastModelRequest(writer: SerializationWriter, trainSkuForecastModelRequest: Partial<TrainSkuForecastModelRequest> | undefined | null = {}) : void {
    if (trainSkuForecastModelRequest) {
        writer.writeDateValue("endDate", trainSkuForecastModelRequest.endDate);
        writer.writeDateValue("startDate", trainSkuForecastModelRequest.startDate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTrainSkuForecastModelResponse(writer: SerializationWriter, trainSkuForecastModelResponse: Partial<TrainSkuForecastModelResponse> | undefined | null = {}) : void {
    if (trainSkuForecastModelResponse) {
        writer.writeObjectValue<ForecastModelDto>("model", trainSkuForecastModelResponse.model, serializeForecastModelDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateAccessRequestNotificationSettingsRequest(writer: SerializationWriter, updateAccessRequestNotificationSettingsRequest: Partial<UpdateAccessRequestNotificationSettingsRequest> | undefined | null = {}) : void {
    if (updateAccessRequestNotificationSettingsRequest) {
        writer.writeStringValue("notificationEmail", updateAccessRequestNotificationSettingsRequest.notificationEmail);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCartPoNumberRequest(writer: SerializationWriter, updateCartPoNumberRequest: Partial<UpdateCartPoNumberRequest> | undefined | null = {}) : void {
    if (updateCartPoNumberRequest) {
        writer.writeStringValue("poNumber", updateCartPoNumberRequest.poNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCartPricingSettingsRequest(writer: SerializationWriter, updateCartPricingSettingsRequest: Partial<UpdateCartPricingSettingsRequest> | undefined | null = {}) : void {
    if (updateCartPricingSettingsRequest) {
        writer.writeBooleanValue("allowDecimalQuantities", updateCartPricingSettingsRequest.allowDecimalQuantities);
        writer.writeBooleanValue("allowLineItemDiscounts", updateCartPricingSettingsRequest.allowLineItemDiscounts);
        writer.writeBooleanValue("allowOrderDiscounts", updateCartPricingSettingsRequest.allowOrderDiscounts);
        writer.writeBooleanValue("allowPriceOverride", updateCartPricingSettingsRequest.allowPriceOverride);
        writer.writeBooleanValue("refreshStalePrices", updateCartPricingSettingsRequest.refreshStalePrices);
        writer.writeNumberValue("stalePriceAgeDays", updateCartPricingSettingsRequest.stalePriceAgeDays);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCartReceiptToRequest(writer: SerializationWriter, updateCartReceiptToRequest: Partial<UpdateCartReceiptToRequest> | undefined | null = {}) : void {
    if (updateCartReceiptToRequest) {
        serializeVendorCartRequest(writer, updateCartReceiptToRequest)
        writer.writeCollectionOfPrimitiveValues<string>("receiptTo", updateCartReceiptToRequest.receiptTo);
        writer.writeAdditionalData(updateCartReceiptToRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCartRequest(writer: SerializationWriter, updateCartRequest: Partial<UpdateCartRequest> | undefined | null = {}) : void {
    if (updateCartRequest) {
        writer.writeObjectValue<ShoppingCart>("cart", updateCartRequest.cart, serializeShoppingCart);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCartShippingRequest(writer: SerializationWriter, updateCartShippingRequest: Partial<UpdateCartShippingRequest> | undefined | null = {}) : void {
    if (updateCartShippingRequest) {
        writer.writeObjectValue<Address>("shippingAddress", updateCartShippingRequest.shippingAddress, serializeAddress);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCommissionPlanRequest(writer: SerializationWriter, updateCommissionPlanRequest: Partial<UpdateCommissionPlanRequest> | undefined | null = {}) : void {
    if (updateCommissionPlanRequest) {
        writer.writeNumberValue("defaultRate", updateCommissionPlanRequest.defaultRate);
        writer.writeStringValue("description", updateCommissionPlanRequest.description);
        writer.writeDateValue("effectiveEndDate", updateCommissionPlanRequest.effectiveEndDate);
        writer.writeDateValue("effectiveStartDate", updateCommissionPlanRequest.effectiveStartDate);
        writer.writeStringValue("name", updateCommissionPlanRequest.name);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", updateCommissionPlanRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", updateCommissionPlanRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerNoteRequest(writer: SerializationWriter, updateCustomerNoteRequest: Partial<UpdateCustomerNoteRequest> | undefined | null = {}) : void {
    if (updateCustomerNoteRequest) {
        writer.writeStringValue("body", updateCustomerNoteRequest.body);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", updateCustomerNoteRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", updateCustomerNoteRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerRequest(writer: SerializationWriter, updateCustomerRequest: Partial<UpdateCustomerRequest> | undefined | null = {}) : void {
    if (updateCustomerRequest) {
        writer.writeBooleanValue("active", updateCustomerRequest.active);
        writer.writeCollectionOfObjectValues<Address>("addresses", updateCustomerRequest.addresses, serializeAddress);
        writer.writeStringValue("companyEmail", updateCustomerRequest.companyEmail);
        writer.writeStringValue("companyFax", updateCustomerRequest.companyFax);
        writer.writeStringValue("companyName", updateCustomerRequest.companyName);
        writer.writeStringValue("companyPhone", updateCustomerRequest.companyPhone);
        writer.writeCollectionOfObjectValues<Contact>("contacts", updateCustomerRequest.contacts, serializeContact);
        writer.writeStringValue("customerId", updateCustomerRequest.customerId);
        writer.writeStringValue("fulfillmentMethod", updateCustomerRequest.fulfillmentMethod);
        writer.writeStringValue("pricing", updateCustomerRequest.pricing);
        writer.writeStringValue("repNumber", updateCustomerRequest.repNumber);
        writer.writeStringValue("terms", updateCustomerRequest.terms);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerResponse(writer: SerializationWriter, updateCustomerResponse: Partial<UpdateCustomerResponse> | undefined | null = {}) : void {
    if (updateCustomerResponse) {
        writer.writeObjectValue<Customer>("customer", updateCustomerResponse.customer, serializeCustomer);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateFlipbookRequest(writer: SerializationWriter, updateFlipbookRequest: Partial<UpdateFlipbookRequest> | undefined | null = {}) : void {
    if (updateFlipbookRequest) {
        writer.writeCollectionOfObjectValues<PageUpdateInfo>("pages", updateFlipbookRequest.pages, serializePageUpdateInfo);
        writer.writeStringValue("title", updateFlipbookRequest.title);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateIntegrationRequest(writer: SerializationWriter, updateIntegrationRequest: Partial<UpdateIntegrationRequest> | undefined | null = {}) : void {
    if (updateIntegrationRequest) {
        writer.writeObjectValue<UpdateIntegrationRequest_configuration>("configuration", updateIntegrationRequest.configuration, serializeUpdateIntegrationRequest_configuration);
        writer.writeStringValue("displayName", updateIntegrationRequest.displayName);
        writer.writeBooleanValue("isEnabled", updateIntegrationRequest.isEnabled);
        writer.writeObjectValue<UpdateIntegrationRequest_secrets>("secrets", updateIntegrationRequest.secrets, serializeUpdateIntegrationRequest_secrets);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateIntegrationRequest_configuration(writer: SerializationWriter, updateIntegrationRequest_configuration: Partial<UpdateIntegrationRequest_configuration> | undefined | null = {}) : void {
    if (updateIntegrationRequest_configuration) {
        writer.writeAdditionalData(updateIntegrationRequest_configuration.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateIntegrationRequest_secrets(writer: SerializationWriter, updateIntegrationRequest_secrets: Partial<UpdateIntegrationRequest_secrets> | undefined | null = {}) : void {
    if (updateIntegrationRequest_secrets) {
        writer.writeAdditionalData(updateIntegrationRequest_secrets.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateIntegrationResponse(writer: SerializationWriter, updateIntegrationResponse: Partial<UpdateIntegrationResponse> | undefined | null = {}) : void {
    if (updateIntegrationResponse) {
        writer.writeObjectValue<UpdateIntegrationResponse_configuration>("configuration", updateIntegrationResponse.configuration, serializeUpdateIntegrationResponse_configuration);
        writer.writeStringValue("displayName", updateIntegrationResponse.displayName);
        writer.writeStringValue("integrationId", updateIntegrationResponse.integrationId);
        writer.writeEnumValue<IntegrationType>("integrationType", updateIntegrationResponse.integrationType);
        writer.writeBooleanValue("isEnabled", updateIntegrationResponse.isEnabled);
        writer.writeStringValue("organizationId", updateIntegrationResponse.organizationId);
        writer.writeStringValue("provider", updateIntegrationResponse.provider);
        writer.writeBooleanValue("testConnectionRequired", updateIntegrationResponse.testConnectionRequired);
        writer.writeDateValue("updatedAt", updateIntegrationResponse.updatedAt);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateIntegrationResponse_configuration(writer: SerializationWriter, updateIntegrationResponse_configuration: Partial<UpdateIntegrationResponse_configuration> | undefined | null = {}) : void {
    if (updateIntegrationResponse_configuration) {
        writer.writeAdditionalData(updateIntegrationResponse_configuration.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateInvoiceRequest(writer: SerializationWriter, updateInvoiceRequest: Partial<UpdateInvoiceRequest> | undefined | null = {}) : void {
    if (updateInvoiceRequest) {
        writer.writeObjectValue<AddressInput>("billingAddress", updateInvoiceRequest.billingAddress, serializeAddressInput);
        writer.writeObjectValue<CustomerInput>("customer", updateInvoiceRequest.customer, serializeCustomerInput);
        writer.writeDateValue("dueDate", updateInvoiceRequest.dueDate);
        writer.writeStringValue("externalId", updateInvoiceRequest.externalId);
        writer.writeStringValue("invoiceNumber", updateInvoiceRequest.invoiceNumber);
        writer.writeStringValue("notes", updateInvoiceRequest.notes);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", updateInvoiceRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", updateInvoiceRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateItemQuantityRequest(writer: SerializationWriter, updateItemQuantityRequest: Partial<UpdateItemQuantityRequest> | undefined | null = {}) : void {
    if (updateItemQuantityRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", updateItemQuantityRequest.orgCodes);
        writer.writeNumberValue("quantity", updateItemQuantityRequest.quantity);
        writer.writeStringValue("useOrganizationId", updateItemQuantityRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateItemRequest(writer: SerializationWriter, updateItemRequest: Partial<UpdateItemRequest> | undefined | null = {}) : void {
    if (updateItemRequest) {
        writer.writeNumberValue("quantity", updateItemRequest.quantity);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateLineRequest(writer: SerializationWriter, updateLineRequest: Partial<UpdateLineRequest> | undefined | null = {}) : void {
    if (updateLineRequest) {
        writer.writeNumberValue("quantity", updateLineRequest.quantity);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateOrderExportSettingsRequest(writer: SerializationWriter, updateOrderExportSettingsRequest: Partial<UpdateOrderExportSettingsRequest> | undefined | null = {}) : void {
    if (updateOrderExportSettingsRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("enabledCustomFormats", updateOrderExportSettingsRequest.enabledCustomFormats);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateOrderReceiptSettingsRequest(writer: SerializationWriter, updateOrderReceiptSettingsRequest: Partial<UpdateOrderReceiptSettingsRequest> | undefined | null = {}) : void {
    if (updateOrderReceiptSettingsRequest) {
        writer.writeStringValue("customerSubject", updateOrderReceiptSettingsRequest.customerSubject);
        writer.writeStringValue("organizationSubject", updateOrderReceiptSettingsRequest.organizationSubject);
        writer.writeStringValue("salesRepSubject", updateOrderReceiptSettingsRequest.salesRepSubject);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateOrderStatusRequest(writer: SerializationWriter, updateOrderStatusRequest: Partial<UpdateOrderStatusRequest> | undefined | null = {}) : void {
    if (updateOrderStatusRequest) {
        writer.writeStringValue("orderStatus", updateOrderStatusRequest.orderStatus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateOrganizationFeaturesRequest(writer: SerializationWriter, updateOrganizationFeaturesRequest: Partial<UpdateOrganizationFeaturesRequest> | undefined | null = {}) : void {
    if (updateOrganizationFeaturesRequest) {
        writer.writeBooleanValue("productVariants", updateOrganizationFeaturesRequest.productVariants);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdatePriceTierRequest(writer: SerializationWriter, updatePriceTierRequest: Partial<UpdatePriceTierRequest> | undefined | null = {}) : void {
    if (updatePriceTierRequest) {
        writer.writeStringValue("currencyCode", updatePriceTierRequest.currencyCode);
        writer.writeStringValue("newName", updatePriceTierRequest.newName);
        writer.writeStringValue("oldName", updatePriceTierRequest.oldName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductCategoriesRequest(writer: SerializationWriter, updateProductCategoriesRequest: Partial<UpdateProductCategoriesRequest> | undefined | null = {}) : void {
    if (updateProductCategoriesRequest) {
        writer.writeCollectionOfObjectValues<UpdateProductCategoriesRequest_CategoryUpdate>("categoryUpdates", updateProductCategoriesRequest.categoryUpdates, serializeUpdateProductCategoriesRequest_CategoryUpdate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductCategoriesRequest_CategoryUpdate(writer: SerializationWriter, updateProductCategoriesRequest_CategoryUpdate: Partial<UpdateProductCategoriesRequest_CategoryUpdate> | undefined | null = {}) : void {
    if (updateProductCategoriesRequest_CategoryUpdate) {
        writer.writeBooleanValue("active", updateProductCategoriesRequest_CategoryUpdate.active);
        writer.writeStringValue("category", updateProductCategoriesRequest_CategoryUpdate.category);
        writer.writeStringValue("sku", updateProductCategoriesRequest_CategoryUpdate.sku);
        writer.writeStringValue("vendorCode", updateProductCategoriesRequest_CategoryUpdate.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductImagesRequest(writer: SerializationWriter, updateProductImagesRequest: Partial<UpdateProductImagesRequest> | undefined | null = {}) : void {
    if (updateProductImagesRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("imageIds", updateProductImagesRequest.imageIds);
        writer.writeStringValue("sku", updateProductImagesRequest.sku);
        writer.writeStringValue("vendorCode", updateProductImagesRequest.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductPricesRequest(writer: SerializationWriter, updateProductPricesRequest: Partial<UpdateProductPricesRequest> | undefined | null = {}) : void {
    if (updateProductPricesRequest) {
        writer.writeCollectionOfObjectValues<UpdateProductPricesRequest_ProductPriceUpdate>("productUpdates", updateProductPricesRequest.productUpdates, serializeUpdateProductPricesRequest_ProductPriceUpdate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductPricesRequest_ProductPriceDto(writer: SerializationWriter, updateProductPricesRequest_ProductPriceDto: Partial<UpdateProductPricesRequest_ProductPriceDto> | undefined | null = {}) : void {
    if (updateProductPricesRequest_ProductPriceDto) {
        writer.writeNumberValue("atQuantity", updateProductPricesRequest_ProductPriceDto.atQuantity);
        writer.writeNumberValue("price", updateProductPricesRequest_ProductPriceDto.price);
        writer.writeStringValue("tier", updateProductPricesRequest_ProductPriceDto.tier);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductPricesRequest_ProductPriceUpdate(writer: SerializationWriter, updateProductPricesRequest_ProductPriceUpdate: Partial<UpdateProductPricesRequest_ProductPriceUpdate> | undefined | null = {}) : void {
    if (updateProductPricesRequest_ProductPriceUpdate) {
        writer.writeCollectionOfObjectValues<UpdateProductPricesRequest_ProductPriceDto>("prices", updateProductPricesRequest_ProductPriceUpdate.prices, serializeUpdateProductPricesRequest_ProductPriceDto);
        writer.writeStringValue("sku", updateProductPricesRequest_ProductPriceUpdate.sku);
        writer.writeStringValue("vendorCode", updateProductPricesRequest_ProductPriceUpdate.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductRequest(writer: SerializationWriter, updateProductRequest: Partial<UpdateProductRequest> | undefined | null = {}) : void {
    if (updateProductRequest) {
        writer.writeBooleanValue("active", updateProductRequest.active);
        writer.writeStringValue("category", updateProductRequest.category);
        writer.writeStringValue("description", updateProductRequest.description);
        writer.writeBooleanValue("detachFromFamily", updateProductRequest.detachFromFamily);
        writer.writeStringValue("dimensions", updateProductRequest.dimensions);
        writer.writeStringValue("dimensionsUnit", updateProductRequest.dimensionsUnit);
        writer.writeStringValue("externalId", updateProductRequest.externalId);
        writer.writeStringValue("familyDescription", updateProductRequest.familyDescription);
        writer.writeStringValue("familyKey", updateProductRequest.familyKey);
        writer.writeStringValue("familyName", updateProductRequest.familyName);
        writer.writeStringValue("imageName", updateProductRequest.imageName);
        writer.writeCollectionOfPrimitiveValues<string>("images", updateProductRequest.images);
        writer.writeNumberValue("minimumOrderQuantity", updateProductRequest.minimumOrderQuantity);
        writer.writeStringValue("name", updateProductRequest.name);
        writer.writeObjectValue<UpdateProductRequest_optionValues>("optionValues", updateProductRequest.optionValues, serializeUpdateProductRequest_optionValues);
        writer.writeNumberValue("price", updateProductRequest.price);
        writer.writeCollectionOfObjectValues<UpdateProductRequest_ProductPriceDto>("prices", updateProductRequest.prices, serializeUpdateProductRequest_ProductPriceDto);
        writer.writeObjectValue<UpdateProductRequest_productAttributes>("productAttributes", updateProductRequest.productAttributes, serializeUpdateProductRequest_productAttributes);
        writer.writeNumberValue("quantityIncrement", updateProductRequest.quantityIncrement);
        writer.writeNumberValue("quantityOnHand", updateProductRequest.quantityOnHand);
        writer.writeBooleanValue("separateLines", updateProductRequest.separateLines);
        writer.writeStringValue("sku", updateProductRequest.sku);
        writer.writeCollectionOfPrimitiveValues<string>("tags", updateProductRequest.tags);
        writer.writeStringValue("upc", updateProductRequest.upc);
        writer.writeStringValue("vendorCode", updateProductRequest.vendorCode);
        writer.writeNumberValue("weight", updateProductRequest.weight);
        writer.writeStringValue("weightUnit", updateProductRequest.weightUnit);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductRequest_optionValues(writer: SerializationWriter, updateProductRequest_optionValues: Partial<UpdateProductRequest_optionValues> | undefined | null = {}) : void {
    if (updateProductRequest_optionValues) {
        writer.writeAdditionalData(updateProductRequest_optionValues.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductRequest_productAttributes(writer: SerializationWriter, updateProductRequest_productAttributes: Partial<UpdateProductRequest_productAttributes> | undefined | null = {}) : void {
    if (updateProductRequest_productAttributes) {
        writer.writeAdditionalData(updateProductRequest_productAttributes.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductRequest_ProductPriceDto(writer: SerializationWriter, updateProductRequest_ProductPriceDto: Partial<UpdateProductRequest_ProductPriceDto> | undefined | null = {}) : void {
    if (updateProductRequest_ProductPriceDto) {
        writer.writeNumberValue("atQuantity", updateProductRequest_ProductPriceDto.atQuantity);
        writer.writeNumberValue("price", updateProductRequest_ProductPriceDto.price);
        writer.writeStringValue("tier", updateProductRequest_ProductPriceDto.tier);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductSortOrdersRequest(writer: SerializationWriter, updateProductSortOrdersRequest: Partial<UpdateProductSortOrdersRequest> | undefined | null = {}) : void {
    if (updateProductSortOrdersRequest) {
        writer.writeCollectionOfObjectValues<UpdateProductSortOrdersRequest_SortOrderUpdate>("sortOrderUpdates", updateProductSortOrdersRequest.sortOrderUpdates, serializeUpdateProductSortOrdersRequest_SortOrderUpdate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductSortOrdersRequest_SortOrderUpdate(writer: SerializationWriter, updateProductSortOrdersRequest_SortOrderUpdate: Partial<UpdateProductSortOrdersRequest_SortOrderUpdate> | undefined | null = {}) : void {
    if (updateProductSortOrdersRequest_SortOrderUpdate) {
        writer.writeStringValue("category", updateProductSortOrdersRequest_SortOrderUpdate.category);
        writer.writeStringValue("sku", updateProductSortOrdersRequest_SortOrderUpdate.sku);
        writer.writeNumberValue("sortOrder", updateProductSortOrdersRequest_SortOrderUpdate.sortOrder);
        writer.writeStringValue("vendorCode", updateProductSortOrdersRequest_SortOrderUpdate.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductSortOrdersResponse(writer: SerializationWriter, updateProductSortOrdersResponse: Partial<UpdateProductSortOrdersResponse> | undefined | null = {}) : void {
    if (updateProductSortOrdersResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("applied", updateProductSortOrdersResponse.applied);
        writer.writeNumberValue("appliedCount", updateProductSortOrdersResponse.appliedCount);
        writer.writeCollectionOfPrimitiveValues<string>("skipped", updateProductSortOrdersResponse.skipped);
        writer.writeNumberValue("skippedCount", updateProductSortOrdersResponse.skippedCount);
        writer.writeObjectValue<UpdateProductSortOrdersResponse_skipReasons>("skipReasons", updateProductSortOrdersResponse.skipReasons, serializeUpdateProductSortOrdersResponse_skipReasons);
        writer.writeNumberValue("totalSkus", updateProductSortOrdersResponse.totalSkus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductSortOrdersResponse_skipReasons(writer: SerializationWriter, updateProductSortOrdersResponse_skipReasons: Partial<UpdateProductSortOrdersResponse_skipReasons> | undefined | null = {}) : void {
    if (updateProductSortOrdersResponse_skipReasons) {
        writer.writeAdditionalData(updateProductSortOrdersResponse_skipReasons.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductTagsRequest(writer: SerializationWriter, updateProductTagsRequest: Partial<UpdateProductTagsRequest> | undefined | null = {}) : void {
    if (updateProductTagsRequest) {
        writer.writeCollectionOfObjectValues<UpdateProductTagsRequest_TagUpdate>("tagUpdates", updateProductTagsRequest.tagUpdates, serializeUpdateProductTagsRequest_TagUpdate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductTagsRequest_TagUpdate(writer: SerializationWriter, updateProductTagsRequest_TagUpdate: Partial<UpdateProductTagsRequest_TagUpdate> | undefined | null = {}) : void {
    if (updateProductTagsRequest_TagUpdate) {
        writer.writeStringValue("sku", updateProductTagsRequest_TagUpdate.sku);
        writer.writeCollectionOfPrimitiveValues<string>("tags", updateProductTagsRequest_TagUpdate.tags);
        writer.writeStringValue("vendorCode", updateProductTagsRequest_TagUpdate.vendorCode);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateProductTagsResponse(writer: SerializationWriter, updateProductTagsResponse: Partial<UpdateProductTagsResponse> | undefined | null = {}) : void {
    if (updateProductTagsResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("applied", updateProductTagsResponse.applied);
        writer.writeNumberValue("appliedCount", updateProductTagsResponse.appliedCount);
        writer.writeCollectionOfPrimitiveValues<string>("skipped", updateProductTagsResponse.skipped);
        writer.writeNumberValue("skippedCount", updateProductTagsResponse.skippedCount);
        writer.writeNumberValue("totalSkus", updateProductTagsResponse.totalSkus);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateResearchSettingsRequest(writer: SerializationWriter, updateResearchSettingsRequest: Partial<UpdateResearchSettingsRequest> | undefined | null = {}) : void {
    if (updateResearchSettingsRequest) {
        writer.writeStringValue("approvalCriteria", updateResearchSettingsRequest.approvalCriteria);
        writer.writeStringValue("industryDescription", updateResearchSettingsRequest.industryDescription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateSalesRepRequest(writer: SerializationWriter, updateSalesRepRequest: Partial<UpdateSalesRepRequest> | undefined | null = {}) : void {
    if (updateSalesRepRequest) {
        writer.writeStringValue("marketCode", updateSalesRepRequest.marketCode);
        writer.writeStringValue("organizationSalesRepId", updateSalesRepRequest.organizationSalesRepId);
        writer.writeStringValue("repNumber", updateSalesRepRequest.repNumber);
        writer.writeCollectionOfPrimitiveValues<string>("repNumbers", updateSalesRepRequest.repNumbers);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateSalesRepResponse(writer: SerializationWriter, updateSalesRepResponse: Partial<UpdateSalesRepResponse> | undefined | null = {}) : void {
    if (updateSalesRepResponse) {
        writer.writeStringValue("email", updateSalesRepResponse.email);
        writer.writeStringValue("firstName", updateSalesRepResponse.firstName);
        writer.writeStringValue("lastName", updateSalesRepResponse.lastName);
        writer.writeStringValue("marketCode", updateSalesRepResponse.marketCode);
        writer.writeStringValue("organizationId", updateSalesRepResponse.organizationId);
        writer.writeStringValue("organizationSalesRepId", updateSalesRepResponse.organizationSalesRepId);
        writer.writeStringValue("repNumber", updateSalesRepResponse.repNumber);
        writer.writeCollectionOfPrimitiveValues<string>("repNumbers", updateSalesRepResponse.repNumbers);
        writer.writeStringValue("salesRepId", updateSalesRepResponse.salesRepId);
        writer.writeBooleanValue("success", updateSalesRepResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateSeatsRequest(writer: SerializationWriter, updateSeatsRequest: Partial<UpdateSeatsRequest> | undefined | null = {}) : void {
    if (updateSeatsRequest) {
        writer.writeNumberValue("seats", updateSeatsRequest.seats);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateSeatsResponse(writer: SerializationWriter, updateSeatsResponse: Partial<UpdateSeatsResponse> | undefined | null = {}) : void {
    if (updateSeatsResponse) {
        writer.writeNumberValue("activeReps", updateSeatsResponse.activeReps);
        writer.writeNumberValue("seats", updateSeatsResponse.seats);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateTaskRequest(writer: SerializationWriter, updateTaskRequest: Partial<UpdateTaskRequest> | undefined | null = {}) : void {
    if (updateTaskRequest) {
        writer.writeStringValue("customerNumber", updateTaskRequest.customerNumber);
        writer.writeStringValue("description", updateTaskRequest.description);
        writer.writeDateValue("dueAt", updateTaskRequest.dueAt);
        writer.writeStringValue("dueTimeZoneId", updateTaskRequest.dueTimeZoneId);
        writer.writeStringValue("organizationSalesRepId", updateTaskRequest.organizationSalesRepId);
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", updateTaskRequest.orgCodes);
        writer.writeEnumValue<TaskPriority>("priority", updateTaskRequest.priority);
        writer.writeStringValue("title", updateTaskRequest.title);
        writer.writeStringValue("useOrganizationId", updateTaskRequest.useOrganizationId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateVendorLineHeaderRequest(writer: SerializationWriter, updateVendorLineHeaderRequest: Partial<UpdateVendorLineHeaderRequest> | undefined | null = {}) : void {
    if (updateVendorLineHeaderRequest) {
        serializeVendorLineRequest(writer, updateVendorLineHeaderRequest)
        writer.writeStringValue("fulfillmentMethod", updateVendorLineHeaderRequest.fulfillmentMethod);
        writer.writeStringValue("noteToVendor", updateVendorLineHeaderRequest.noteToVendor);
        writer.writeStringValue("orderType", updateVendorLineHeaderRequest.orderType);
        writer.writeStringValue("poNumber", updateVendorLineHeaderRequest.poNumber);
        writer.writeStringValue("priceLevel", updateVendorLineHeaderRequest.priceLevel);
        writer.writeStringValue("terms", updateVendorLineHeaderRequest.terms);
        writer.writeAdditionalData(updateVendorLineHeaderRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateVendorRequest(writer: SerializationWriter, updateVendorRequest: Partial<UpdateVendorRequest> | undefined | null = {}) : void {
    if (updateVendorRequest) {
        serializeVendorFieldsRequest(writer, updateVendorRequest)
        writer.writeAdditionalData(updateVendorRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUploadManyImagesRequest(writer: SerializationWriter, uploadManyImagesRequest: Partial<UploadManyImagesRequest> | undefined | null = {}) : void {
    if (uploadManyImagesRequest) {
        writer.writeCollectionOfObjectValues<ImageUploadItem>("images", uploadManyImagesRequest.images, serializeImageUploadItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUser(writer: SerializationWriter, user: Partial<User> | undefined | null = {}) : void {
    if (user) {
        writer.writeStringValue("email", user.email);
        writer.writeStringValue("firstName", user.firstName);
        writer.writeStringValue("lastName", user.lastName);
        writer.writeStringValue("password", user.password);
        writer.writeStringValue("phoneNumber", user.phoneNumber);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUser2(writer: SerializationWriter, user2: Partial<User2> | undefined | null = {}) : void {
    if (user2) {
        writer.writeStringValue("identityProviderUserId", user2.identityProviderUserId);
        writer.writeStringValue("userId", user2.userId);
        writer.writeEnumValue<UserTypes>("userType", user2.userType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUser3(writer: SerializationWriter, user3: Partial<User3> | undefined | null = {}) : void {
    if (user3) {
        writer.writeStringValue("identityProviderUserId", user3.identityProviderUserId);
        writer.writeStringValue("userId", user3.userId);
        writer.writeEnumValue<UserTypes>("userType", user3.userType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUserCustomer(writer: SerializationWriter, userCustomer: Partial<UserCustomer> | undefined | null = {}) : void {
    if (userCustomer) {
        serializeBaseEntity(writer, userCustomer)
        writer.writeStringValue("customerNumber", userCustomer.customerNumber);
        writer.writeStringValue("organizationId", userCustomer.organizationId);
        writer.writeStringValue("userCustomerId", userCustomer.userCustomerId);
        writer.writeStringValue("userId", userCustomer.userId);
        writer.writeAdditionalData(userCustomer.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUserDto(writer: SerializationWriter, userDto: Partial<UserDto> | undefined | null = {}) : void {
    if (userDto) {
        writer.writeStringValue("identityProviderUserId", userDto.identityProviderUserId);
        writer.writeStringValue("userId", userDto.userId);
        writer.writeStringValue("userType", userDto.userType);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUserExistsResponse(writer: SerializationWriter, userExistsResponse: Partial<UserExistsResponse> | undefined | null = {}) : void {
    if (userExistsResponse) {
        writer.writeBooleanValue("userExists", userExistsResponse.userExists);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUserOrganizationDto(writer: SerializationWriter, userOrganizationDto: Partial<UserOrganizationDto> | undefined | null = {}) : void {
    if (userOrganizationDto) {
        writer.writeStringValue("name", userOrganizationDto.name);
        writer.writeStringValue("organizationId", userOrganizationDto.organizationId);
        writer.writeStringValue("orgCode", userOrganizationDto.orgCode);
        writer.writeCollectionOfPrimitiveValues<string>("roles", userOrganizationDto.roles);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeValidateConfig_ValidateConfigResponse(writer: SerializationWriter, validateConfig_ValidateConfigResponse: Partial<ValidateConfig_ValidateConfigResponse> | undefined | null = {}) : void {
    if (validateConfig_ValidateConfigResponse) {
        writer.writeStringValue("env", validateConfig_ValidateConfigResponse.env);
        writer.writeBooleanValue("identityConfigured", validateConfig_ValidateConfigResponse.identityConfigured);
        writer.writeStringValue("identityMessage", validateConfig_ValidateConfigResponse.identityMessage);
        writer.writeBooleanValue("keyVaultConfigured", validateConfig_ValidateConfigResponse.keyVaultConfigured);
        writer.writeStringValue("keyVaultMessage", validateConfig_ValidateConfigResponse.keyVaultMessage);
        writer.writeBooleanValue("syncGatewayConfigured", validateConfig_ValidateConfigResponse.syncGatewayConfigured);
        writer.writeStringValue("syncGatewayMessage", validateConfig_ValidateConfigResponse.syncGatewayMessage);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeValidateIntegrationTemplateRequest(writer: SerializationWriter, validateIntegrationTemplateRequest: Partial<ValidateIntegrationTemplateRequest> | undefined | null = {}) : void {
    if (validateIntegrationTemplateRequest) {
        writer.writeObjectValue<ValidateIntegrationTemplateRequest_configuration>("configuration", validateIntegrationTemplateRequest.configuration, serializeValidateIntegrationTemplateRequest_configuration);
        writer.writeStringValue("provider", validateIntegrationTemplateRequest.provider);
        writer.writeObjectValue<ValidateIntegrationTemplateRequest_secrets>("secrets", validateIntegrationTemplateRequest.secrets, serializeValidateIntegrationTemplateRequest_secrets);
        writer.writeEnumValue<IntegrationType>("type", validateIntegrationTemplateRequest.type);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeValidateIntegrationTemplateRequest_configuration(writer: SerializationWriter, validateIntegrationTemplateRequest_configuration: Partial<ValidateIntegrationTemplateRequest_configuration> | undefined | null = {}) : void {
    if (validateIntegrationTemplateRequest_configuration) {
        writer.writeAdditionalData(validateIntegrationTemplateRequest_configuration.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeValidateIntegrationTemplateRequest_secrets(writer: SerializationWriter, validateIntegrationTemplateRequest_secrets: Partial<ValidateIntegrationTemplateRequest_secrets> | undefined | null = {}) : void {
    if (validateIntegrationTemplateRequest_secrets) {
        writer.writeAdditionalData(validateIntegrationTemplateRequest_secrets.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeValidateIntegrationTemplateResponse(writer: SerializationWriter, validateIntegrationTemplateResponse: Partial<ValidateIntegrationTemplateResponse> | undefined | null = {}) : void {
    if (validateIntegrationTemplateResponse) {
        writer.writeCollectionOfPrimitiveValues<string>("errors", validateIntegrationTemplateResponse.errors);
        writer.writeBooleanValue("isValid", validateIntegrationTemplateResponse.isValid);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendor(writer: SerializationWriter, vendor: Partial<Vendor> | undefined | null = {}) : void {
    if (vendor) {
        serializeBaseEntity(writer, vendor)
        writer.writeCollectionOfPrimitiveValues<string>("categoryIds", vendor.categoryIds);
        writer.writeNumberValue("defaultCommissionRate", vendor.defaultCommissionRate);
        writer.writeObjectValue<VendorMinimum>("defaultMinimum", vendor.defaultMinimum, serializeVendorMinimum);
        writer.writeStringValue("description", vendor.description);
        writer.writeCollectionOfPrimitiveValues<string>("fulfillmentMethodIds", vendor.fulfillmentMethodIds);
        writer.writeStringValue("lifestyleImageUrl", vendor.lifestyleImageUrl);
        writer.writeStringValue("linkedOrganizationId", vendor.linkedOrganizationId);
        writer.writeStringValue("logoUrl", vendor.logoUrl);
        writer.writeCollectionOfPrimitiveValues<string>("merchandisingTags", vendor.merchandisingTags);
        writer.writeCollectionOfObjectValues<VendorMinimum>("minimumsByProductGroup", vendor.minimumsByProductGroup, serializeVendorMinimum);
        writer.writeCollectionOfPrimitiveValues<string>("mustHaves", vendor.mustHaves);
        writer.writeStringValue("name", vendor.name);
        writer.writeStringValue("orderDeskEmail", vendor.orderDeskEmail);
        writer.writeObjectValue<VendorOrderDestination>("orderDestination", vendor.orderDestination, serializeVendorOrderDestination);
        writer.writeCollectionOfPrimitiveValues<string>("orderTypes", vendor.orderTypes);
        writer.writeStringValue("organizationId", vendor.organizationId);
        writer.writeStringValue("phone", vendor.phone);
        writer.writeCollectionOfPrimitiveValues<string>("priceLevelIds", vendor.priceLevelIds);
        writer.writeCollectionOfObjectValues<VendorShipWindow>("shipWindows", vendor.shipWindows, serializeVendorShipWindow);
        writer.writeBooleanValue("showOnLineCard", vendor.showOnLineCard);
        writer.writeStringValue("slug", vendor.slug);
        writer.writeCollectionOfPrimitiveValues<string>("termsOptions", vendor.termsOptions);
        writer.writeStringValue("vendorCode", vendor.vendorCode);
        writer.writeStringValue("vendorId", vendor.vendorId);
        writer.writeStringValue("website", vendor.website);
        writer.writeAdditionalData(vendor.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorCartRequest(writer: SerializationWriter, vendorCartRequest: Partial<VendorCartRequest> | undefined | null = {}) : void {
    if (vendorCartRequest) {
        serializeAgencyScopedRequest(writer, vendorCartRequest)
        writer.writeAdditionalData(vendorCartRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorCustomerDto(writer: SerializationWriter, vendorCustomerDto: Partial<VendorCustomerDto> | undefined | null = {}) : void {
    if (vendorCustomerDto) {
        writer.writeObjectValue<CustomerVendorAccountDto>("account", vendorCustomerDto.account, serializeCustomerVendorAccountDto);
        writer.writeObjectValue<Customer>("customer", vendorCustomerDto.customer, serializeCustomer);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorFieldsRequest(writer: SerializationWriter, vendorFieldsRequest: Partial<VendorFieldsRequest> | undefined | null = {}) : void {
    if (vendorFieldsRequest) {
        serializeAgencyScopedRequest(writer, vendorFieldsRequest)
        writer.writeCollectionOfPrimitiveValues<string>("categoryIds", vendorFieldsRequest.categoryIds);
        writer.writeNumberValue("defaultCommissionRate", vendorFieldsRequest.defaultCommissionRate);
        writer.writeObjectValue<VendorMinimum>("defaultMinimum", vendorFieldsRequest.defaultMinimum, serializeVendorMinimum);
        writer.writeStringValue("description", vendorFieldsRequest.description);
        writer.writeCollectionOfPrimitiveValues<string>("fulfillmentMethodIds", vendorFieldsRequest.fulfillmentMethodIds);
        writer.writeStringValue("lifestyleImageUrl", vendorFieldsRequest.lifestyleImageUrl);
        writer.writeStringValue("linkedOrganizationId", vendorFieldsRequest.linkedOrganizationId);
        writer.writeStringValue("logoUrl", vendorFieldsRequest.logoUrl);
        writer.writeCollectionOfPrimitiveValues<string>("merchandisingTags", vendorFieldsRequest.merchandisingTags);
        writer.writeCollectionOfObjectValues<VendorMinimum>("minimumsByProductGroup", vendorFieldsRequest.minimumsByProductGroup, serializeVendorMinimum);
        writer.writeCollectionOfPrimitiveValues<string>("mustHaves", vendorFieldsRequest.mustHaves);
        writer.writeStringValue("name", vendorFieldsRequest.name);
        writer.writeStringValue("orderDeskEmail", vendorFieldsRequest.orderDeskEmail);
        writer.writeObjectValue<VendorOrderDestination>("orderDestination", vendorFieldsRequest.orderDestination, serializeVendorOrderDestination);
        writer.writeCollectionOfPrimitiveValues<string>("orderTypes", vendorFieldsRequest.orderTypes);
        writer.writeStringValue("phone", vendorFieldsRequest.phone);
        writer.writeCollectionOfPrimitiveValues<string>("priceLevelIds", vendorFieldsRequest.priceLevelIds);
        writer.writeCollectionOfObjectValues<VendorShipWindow>("shipWindows", vendorFieldsRequest.shipWindows, serializeVendorShipWindow);
        writer.writeBooleanValue("showOnLineCard", vendorFieldsRequest.showOnLineCard);
        writer.writeStringValue("slug", vendorFieldsRequest.slug);
        writer.writeCollectionOfPrimitiveValues<string>("termsOptions", vendorFieldsRequest.termsOptions);
        writer.writeStringValue("website", vendorFieldsRequest.website);
        writer.writeAdditionalData(vendorFieldsRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorLineDto(writer: SerializationWriter, vendorLineDto: Partial<VendorLineDto> | undefined | null = {}) : void {
    if (vendorLineDto) {
        writer.writeDateOnlyValue("cancelDate", vendorLineDto.cancelDate);
        writer.writeNumberValue("discountAmount", vendorLineDto.discountAmount);
        writer.writeNumberValue("discountPercent", vendorLineDto.discountPercent);
        writer.writeStringValue("fulfillmentMethod", vendorLineDto.fulfillmentMethod);
        writer.writeBooleanValue("isOpeningOrder", vendorLineDto.isOpeningOrder);
        writer.writeNumberValue("itemCount", vendorLineDto.itemCount);
        writer.writeCollectionOfPrimitiveValues<string>("itemLineIds", vendorLineDto.itemLineIds);
        writer.writeNumberValue("minimumAmount", vendorLineDto.minimumAmount);
        writer.writeStringValue("noteToVendor", vendorLineDto.noteToVendor);
        writer.writeObjectValue<VendorLineOptionsDto>("options", vendorLineDto.options, serializeVendorLineOptionsDto);
        writer.writeStringValue("orderType", vendorLineDto.orderType);
        writer.writeStringValue("poNumber", vendorLineDto.poNumber);
        writer.writeStringValue("priceLevel", vendorLineDto.priceLevel);
        writer.writeBooleanValue("savedForLater", vendorLineDto.savedForLater);
        writer.writeDateOnlyValue("shipDate", vendorLineDto.shipDate);
        writer.writeStringValue("shipWindowName", vendorLineDto.shipWindowName);
        writer.writeEnumValue<CartLineStatus>("status", vendorLineDto.status);
        writer.writeNumberValue("subtotal", vendorLineDto.subtotal);
        writer.writeStringValue("terms", vendorLineDto.terms);
        writer.writeNumberValue("total", vendorLineDto.total);
        writer.writeStringValue("vendorCode", vendorLineDto.vendorCode);
        writer.writeStringValue("vendorLogoUrl", vendorLineDto.vendorLogoUrl);
        writer.writeStringValue("vendorName", vendorLineDto.vendorName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorLineOptionsDto(writer: SerializationWriter, vendorLineOptionsDto: Partial<VendorLineOptionsDto> | undefined | null = {}) : void {
    if (vendorLineOptionsDto) {
        writer.writeCollectionOfPrimitiveValues<string>("fulfillmentMethodIds", vendorLineOptionsDto.fulfillmentMethodIds);
        writer.writeNumberValue("openingOrderMinimum", vendorLineOptionsDto.openingOrderMinimum);
        writer.writeCollectionOfPrimitiveValues<string>("orderTypes", vendorLineOptionsDto.orderTypes);
        writer.writeCollectionOfPrimitiveValues<string>("priceLevelIds", vendorLineOptionsDto.priceLevelIds);
        writer.writeNumberValue("reorderMinimum", vendorLineOptionsDto.reorderMinimum);
        writer.writeCollectionOfObjectValues<VendorShipWindow>("shipWindows", vendorLineOptionsDto.shipWindows, serializeVendorShipWindow);
        writer.writeCollectionOfPrimitiveValues<string>("termsOptions", vendorLineOptionsDto.termsOptions);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorLineRequest(writer: SerializationWriter, vendorLineRequest: Partial<VendorLineRequest> | undefined | null = {}) : void {
    if (vendorLineRequest) {
        serializeVendorCartRequest(writer, vendorLineRequest)
        writer.writeAdditionalData(vendorLineRequest.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorLinesResponse(writer: SerializationWriter, vendorLinesResponse: Partial<VendorLinesResponse> | undefined | null = {}) : void {
    if (vendorLinesResponse) {
        writer.writeStringValue("customerNumber", vendorLinesResponse.customerNumber);
        writer.writeCollectionOfObjectValues<VendorLineDto>("lines", vendorLinesResponse.lines, serializeVendorLineDto);
        writer.writeCollectionOfPrimitiveValues<string>("receiptTo", vendorLinesResponse.receiptTo);
        writer.writeStringValue("shoppingCartId", vendorLinesResponse.shoppingCartId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorMinimum(writer: SerializationWriter, vendorMinimum: Partial<VendorMinimum> | undefined | null = {}) : void {
    if (vendorMinimum) {
        writer.writeNumberValue("openingOrder", vendorMinimum.openingOrder);
        writer.writeStringValue("productGroup", vendorMinimum.productGroup);
        writer.writeNumberValue("reorder", vendorMinimum.reorder);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorOrderDestination(writer: SerializationWriter, vendorOrderDestination: Partial<VendorOrderDestination> | undefined | null = {}) : void {
    if (vendorOrderDestination) {
        writer.writeStringValue("ediDestination", vendorOrderDestination.ediDestination);
        writer.writeStringValue("ediFormat", vendorOrderDestination.ediFormat);
        writer.writeCollectionOfPrimitiveValues<string>("emailTo", vendorOrderDestination.emailTo);
        writer.writeStringValue("pushUrl", vendorOrderDestination.pushUrl);
        writer.writeEnumValue<OrderDestinationType>("type", vendorOrderDestination.type);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorPrefillHints(writer: SerializationWriter, vendorPrefillHints: Partial<VendorPrefillHints> | undefined | null = {}) : void {
    if (vendorPrefillHints) {
        writer.writeNumberValue("openingOrderMinimum", vendorPrefillHints.openingOrderMinimum);
        writer.writeNumberValue("reorderMinimum", vendorPrefillHints.reorderMinimum);
        writer.writeStringValue("termsText", vendorPrefillHints.termsText);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorPrefillSuggestions(writer: SerializationWriter, vendorPrefillSuggestions: Partial<VendorPrefillSuggestions> | undefined | null = {}) : void {
    if (vendorPrefillSuggestions) {
        writer.writeCollectionOfPrimitiveValues<string>("categoryIds", vendorPrefillSuggestions.categoryIds);
        writer.writeStringValue("description", vendorPrefillSuggestions.description);
        writer.writeStringValue("email", vendorPrefillSuggestions.email);
        writer.writeObjectValue<VendorPrefillSuggestions_fields>("fields", vendorPrefillSuggestions.fields, serializeVendorPrefillSuggestions_fields);
        writer.writeObjectValue<VendorPrefillHints>("hints", vendorPrefillSuggestions.hints, serializeVendorPrefillHints);
        writer.writeStringValue("logoUrl", vendorPrefillSuggestions.logoUrl);
        writer.writeCollectionOfPrimitiveValues<string>("merchandisingTags", vendorPrefillSuggestions.merchandisingTags);
        writer.writeCollectionOfPrimitiveValues<string>("mustHaves", vendorPrefillSuggestions.mustHaves);
        writer.writeStringValue("name", vendorPrefillSuggestions.name);
        writer.writeCollectionOfPrimitiveValues<string>("pagesRead", vendorPrefillSuggestions.pagesRead);
        writer.writeStringValue("phone", vendorPrefillSuggestions.phone);
        writer.writeStringValue("source", vendorPrefillSuggestions.source);
        writer.writeStringValue("vendorCode", vendorPrefillSuggestions.vendorCode);
        writer.writeCollectionOfPrimitiveValues<string>("vendorCodeAlternatives", vendorPrefillSuggestions.vendorCodeAlternatives);
        writer.writeCollectionOfPrimitiveValues<string>("warnings", vendorPrefillSuggestions.warnings);
        writer.writeStringValue("website", vendorPrefillSuggestions.website);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorPrefillSuggestions_fields(writer: SerializationWriter, vendorPrefillSuggestions_fields: Partial<VendorPrefillSuggestions_fields> | undefined | null = {}) : void {
    if (vendorPrefillSuggestions_fields) {
        writer.writeAdditionalData(vendorPrefillSuggestions_fields.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVendorShipWindow(writer: SerializationWriter, vendorShipWindow: Partial<VendorShipWindow> | undefined | null = {}) : void {
    if (vendorShipWindow) {
        writer.writeDateOnlyValue("cancelDate", vendorShipWindow.cancelDate);
        writer.writeBooleanValue("isDefault", vendorShipWindow.isDefault);
        writer.writeStringValue("name", vendorShipWindow.name);
        writer.writeDateOnlyValue("shipDate", vendorShipWindow.shipDate);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeViewCartShareMessageResponse(writer: SerializationWriter, viewCartShareMessageResponse: Partial<ViewCartShareMessageResponse> | undefined | null = {}) : void {
    if (viewCartShareMessageResponse) {
        writer.writeStringValue("body", viewCartShareMessageResponse.body);
        writer.writeObjectValue<CartShareSnapshot>("cart", viewCartShareMessageResponse.cart, serializeCartShareSnapshot);
        writer.writeDateValue("createdAt", viewCartShareMessageResponse.createdAt);
        writer.writeStringValue("messageId", viewCartShareMessageResponse.messageId);
        writer.writeObjectValue<OrganizationInfo>("organization", viewCartShareMessageResponse.organization, serializeOrganizationInfo);
        writer.writeStringValue("organizationId", viewCartShareMessageResponse.organizationId);
        writer.writeStringValue("senderEmail", viewCartShareMessageResponse.senderEmail);
        writer.writeStringValue("senderName", viewCartShareMessageResponse.senderName);
        writer.writeDateValue("sentAt", viewCartShareMessageResponse.sentAt);
        writer.writeStringValue("subject", viewCartShareMessageResponse.subject);
        writer.writeStringValue("viewOnlineUrl", viewCartShareMessageResponse.viewOnlineUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeViewCompanyDocsMessageResponse(writer: SerializationWriter, viewCompanyDocsMessageResponse: Partial<ViewCompanyDocsMessageResponse> | undefined | null = {}) : void {
    if (viewCompanyDocsMessageResponse) {
        writer.writeCollectionOfObjectValues<MessageAttachment>("attachments", viewCompanyDocsMessageResponse.attachments, serializeMessageAttachment);
        writer.writeStringValue("body", viewCompanyDocsMessageResponse.body);
        writer.writeDateValue("createdAt", viewCompanyDocsMessageResponse.createdAt);
        writer.writeObjectValue<DeliveryStatus>("deliveryStatus", viewCompanyDocsMessageResponse.deliveryStatus, serializeDeliveryStatus);
        writer.writeStringValue("messageId", viewCompanyDocsMessageResponse.messageId);
        writer.writeObjectValue<MessageMetadata>("metadata", viewCompanyDocsMessageResponse.metadata, serializeMessageMetadata);
        writer.writeObjectValue<OrganizationInfo>("organization", viewCompanyDocsMessageResponse.organization, serializeOrganizationInfo);
        writer.writeStringValue("organizationId", viewCompanyDocsMessageResponse.organizationId);
        writer.writeStringValue("senderEmail", viewCompanyDocsMessageResponse.senderEmail);
        writer.writeStringValue("senderName", viewCompanyDocsMessageResponse.senderName);
        writer.writeDateValue("sentAt", viewCompanyDocsMessageResponse.sentAt);
        writer.writeStringValue("status", viewCompanyDocsMessageResponse.status);
        writer.writeStringValue("subject", viewCompanyDocsMessageResponse.subject);
        writer.writeStringValue("viewOnlineUrl", viewCompanyDocsMessageResponse.viewOnlineUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeViewTearSheetsMessageResponse(writer: SerializationWriter, viewTearSheetsMessageResponse: Partial<ViewTearSheetsMessageResponse> | undefined | null = {}) : void {
    if (viewTearSheetsMessageResponse) {
        writer.writeStringValue("body", viewTearSheetsMessageResponse.body);
        writer.writeDateValue("createdAt", viewTearSheetsMessageResponse.createdAt);
        writer.writeObjectValue<DeliveryStatus>("deliveryStatus", viewTearSheetsMessageResponse.deliveryStatus, serializeDeliveryStatus);
        writer.writeStringValue("messageId", viewTearSheetsMessageResponse.messageId);
        writer.writeObjectValue<MessageMetadata>("metadata", viewTearSheetsMessageResponse.metadata, serializeMessageMetadata);
        writer.writeObjectValue<OrganizationInfo>("organization", viewTearSheetsMessageResponse.organization, serializeOrganizationInfo);
        writer.writeStringValue("organizationId", viewTearSheetsMessageResponse.organizationId);
        writer.writeCollectionOfObjectValues<Product>("products", viewTearSheetsMessageResponse.products, serializeProduct);
        writer.writeStringValue("senderEmail", viewTearSheetsMessageResponse.senderEmail);
        writer.writeStringValue("senderName", viewTearSheetsMessageResponse.senderName);
        writer.writeDateValue("sentAt", viewTearSheetsMessageResponse.sentAt);
        writer.writeStringValue("status", viewTearSheetsMessageResponse.status);
        writer.writeStringValue("subject", viewTearSheetsMessageResponse.subject);
        writer.writeObjectValue<TearSheet>("tearSheet", viewTearSheetsMessageResponse.tearSheet, serializeTearSheet);
        writer.writeStringValue("viewOnlineUrl", viewTearSheetsMessageResponse.viewOnlineUrl);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVoidInvoiceRequest(writer: SerializationWriter, voidInvoiceRequest: Partial<VoidInvoiceRequest> | undefined | null = {}) : void {
    if (voidInvoiceRequest) {
        writer.writeCollectionOfPrimitiveValues<string>("orgCodes", voidInvoiceRequest.orgCodes);
        writer.writeStringValue("useOrganizationId", voidInvoiceRequest.useOrganizationId);
    }
}
export interface SetAsDefaultRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface SetCampaignActiveRequest extends Parsable {
    /**
     * True to (re)activate, false to deactivate.
     */
    active?: boolean | null;
}
export interface SetCodeActiveRequest extends Parsable {
    /**
     * True to (re)activate, false to deactivate.
     */
    active?: boolean | null;
}
export interface SetCustomerVendorAccountRequest extends AdditionalDataHolder, CustomerVendorAccountRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * Free text, up to 4000 characters.
     */
    notes?: string | null;
    /**
     * The saved payment method to use for this vendor. Omit or blank for "No payment method on file".
     */
    paymentMethodId?: string | null;
    /**
     * The price level the customer buys at, one of the vendor's price levels. Omit or blank to leave it unset.
     */
    priceLevelId?: string | null;
    /**
     * The customer's terms with the vendor, one of the vendor's terms options in any casing. Omit or blank for "Terms needed".
     */
    terms?: string | null;
    /**
     * The customer's account number at the manufacturer.
     */
    vendorAccountNumber?: string | null;
}
/**
 * Sets one Sales Representative's own discount permissions for the sales app, laid over theorganization's defaults from cart pricing settings. A full replace: both kinds are required.
 */
export interface SetDiscountPermissionsRequest extends Parsable {
    /**
     * Whether this rep may put discounts on individual lines; same semantics asOrderDiscounts against allowLineItemDiscounts. Required.
     */
    lineItemDiscounts?: DiscountPermission | null;
    /**
     * Whether this rep may put a discount on a whole order: Inherit takes the organization'sdefault (allowOrderDiscounts in cart pricing settings), Allow and Deny override it for thisrep either way. Required.
     */
    orderDiscounts?: DiscountPermission | null;
    /**
     * Gets or sets the organization sales representative ID.
     */
    organizationSalesRepId?: string | null;
}
/**
 * The stored discount permissions after the change.
 */
export interface SetDiscountPermissionsResponse extends Parsable {
    /**
     * Gets or sets the rep's line-item-discount setting after the change.
     */
    lineItemDiscounts?: DiscountPermission | null;
    /**
     * Gets or sets the rep's order-discount setting after the change.
     */
    orderDiscounts?: DiscountPermission | null;
    /**
     * Gets or sets the organization ID.
     */
    organizationId?: string | null;
    /**
     * Gets or sets the organization sales representative ID.
     */
    organizationSalesRepId?: string | null;
    /**
     * Gets or sets whether the change was successful.
     */
    success?: boolean | null;
}
/**
 * A vendor line's discount, as a percentage of its subtotal.
 */
export interface SetVendorLineDiscountRequest extends AdditionalDataHolder, Parsable, VendorLineRequest {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * Between 0 and 100; null or 0 clears the discount.
     */
    discountPercent?: number | null;
}
/**
 * A vendor line's ship window: one of the vendor's named windows (its dates are used, whateverdates are sent), or a custom window with no name and the dates given.
 */
export interface SetVendorLineShipWindowRequest extends AdditionalDataHolder, Parsable, VendorLineRequest {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The custom cancel date (yyyy-MM-dd); not before the ship date. Ignored when a named window is chosen.
     */
    cancelDate?: DateOnly | null;
    /**
     * The custom ship date (yyyy-MM-dd). Ignored when a named window is chosen.
     */
    shipDate?: DateOnly | null;
    /**
     * The name of one of the vendor's ship windows, or null for a custom window.
     */
    shipWindowName?: string | null;
}
/**
 * Represents a request to turn a Sales Representative's org-wide customer visibility on or off.
 */
export interface SetViewAllCustomersRequest extends Parsable {
    /**
     * Gets or sets whether the rep may see every customer in the organization. When false therep sees only the customers carrying their RepNumber.
     */
    canViewAllCustomers?: boolean | null;
    /**
     * Gets or sets the organization sales representative ID.
     */
    organizationSalesRepId?: string | null;
}
/**
 * Represents the response after changing a Sales Representative's org-wide customer visibility.
 */
export interface SetViewAllCustomersResponse extends Parsable {
    /**
     * Gets or sets the rep's org-wide customer visibility after the change.
     */
    canViewAllCustomers?: boolean | null;
    /**
     * Gets or sets the organization ID.
     */
    organizationId?: string | null;
    /**
     * Gets or sets the organization sales representative ID.
     */
    organizationSalesRepId?: string | null;
    /**
     * Gets or sets whether the change was successful.
     */
    success?: boolean | null;
}
export interface ShippingDetails extends Parsable {
    /**
     * The method property
     */
    method?: string | null;
    /**
     * The total property
     */
    total?: number | null;
    /**
     * The totalFormatted property
     */
    totalFormatted?: string | null;
}
export interface ShippingDetailsDto extends Parsable {
    /**
     * The method property
     */
    method?: string | null;
    /**
     * The total property
     */
    total?: number | null;
    /**
     * The totalFormatted property
     */
    totalFormatted?: string | null;
}
/**
 * Freight cost and carrier for an invoice. Method is the carrier/service (e.g. "UPS Ground"),which is a different concept from FulfillmentMethod (Ship / Pickup / Delivery).
 */
export interface ShippingDetailsInput extends Parsable {
    /**
     * The method property
     */
    method?: string | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface ShoppingCart extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The appliedCode property
     */
    appliedCode?: string | null;
    /**
     * The appliedCodeSkip property
     */
    appliedCodeSkip?: PromotionSkip | null;
    /**
     * The appliedPromotions property
     */
    appliedPromotions?: AppliedPromotion[] | null;
    /**
     * The billingAddress property
     */
    billingAddress?: Address | null;
    /**
     * The cartItems property
     */
    cartItems?: CartItem[] | null;
    /**
     * The channel property
     */
    channel?: string | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The discount property
     */
    discount?: Discount | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The freeShipping property
     */
    freeShipping?: FreeShippingEntitlement | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The lastPriceRefresh property
     */
    lastPriceRefresh?: CartPriceRefreshSummary | null;
    /**
     * The lines property
     */
    lines?: CartLine[] | null;
    /**
     * The marketCode property
     */
    marketCode?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The orderStatus property
     */
    orderStatus?: string | null;
    /**
     * The orderTotal property
     */
    orderTotal?: number | null;
    /**
     * The orderType property
     */
    orderType?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The pricesRefreshedUtc property
     */
    pricesRefreshedUtc?: Date | null;
    /**
     * The priceTier property
     */
    priceTier?: string | null;
    /**
     * The primarySalesRep property
     */
    primarySalesRep?: Rep | null;
    /**
     * The receiptTo property
     */
    receiptTo?: string[] | null;
    /**
     * The review property
     */
    review?: CartReview | null;
    /**
     * The shipping property
     */
    shipping?: number | null;
    /**
     * The shippingAddress property
     */
    shippingAddress?: Address | null;
    /**
     * The shippingMethod property
     */
    shippingMethod?: string | null;
    /**
     * The shoppingCartId property
     */
    shoppingCartId?: string | null;
    /**
     * The subtotal property
     */
    subtotal?: number | null;
    /**
     * The takenBySalesRep property
     */
    takenBySalesRep?: Rep | null;
    /**
     * The tax property
     */
    tax?: number | null;
    /**
     * The taxItems property
     */
    taxItems?: TaxLineItem[] | null;
    /**
     * The terms property
     */
    terms?: string | null;
    /**
     * The user property
     */
    user?: User3 | null;
    /**
     * The vendorLineDiscountAmount property
     */
    vendorLineDiscountAmount?: number | null;
}
export interface SimulateRequest extends Parsable {
    /**
     * Optional: the campaign under test. It is evaluated alongside the organization's active campaignsas if it were active, so a campaign can be tried before it goes live. Must belong to the organization.
     */
    campaignId?: string | null;
    /**
     * Optional: evaluate as if this code were applied, instead of whatever the cart holds.
     */
    code?: string | null;
    /**
     * The cart to evaluate against the organization's active campaigns.
     */
    shoppingCartId?: string | null;
}
/**
 * What the evaluator would do with a cart right now, without saving anything: the cart as itwould look (lines, discounts, gifts, totals) and the plan with every reason something did notapply.
 */
export interface SimulateResponse extends Parsable {
    /**
     * The cart property
     */
    cart?: ShoppingCart | null;
    /**
     * The plan property
     */
    plan?: PromotionPlan | null;
}
/**
 * A line that was not placed and stays in the cart: TermsNeeded, UnderMinimum (with the amounts), saved for later, or not on the cart.
 */
export interface SkippedLine extends Parsable {
    /**
     * The reason property
     */
    reason?: string | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
}
/**
 * One month of actual sales for a SKU.
 */
export interface SkuHistoryPointDto extends Parsable {
    /**
     * The month property
     */
    month?: number | null;
    /**
     * Total units sold in this month. Null if no orders were placed.
     */
    unitsSold?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export type SourcingBasis = (typeof SourcingBasisObject)[keyof typeof SourcingBasisObject];
/**
 * The source cart without the vendor's line, and the new cart that holds it.
 */
export interface SplitVendorLineResponse extends Parsable {
    /**
     * The newCart property
     */
    newCart?: ShoppingCart | null;
    /**
     * The sourceCart property
     */
    sourceCart?: ShoppingCart | null;
}
export interface SqlConnectorStatus extends Parsable {
    /**
     * The connectorName property
     */
    connectorName?: string | null;
    /**
     * The hostName property
     */
    hostName?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The lastHeartbeatAt property
     */
    lastHeartbeatAt?: Date | null;
    /**
     * The metadata property
     */
    metadata?: SqlConnectorStatus_metadata | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The registeredAt property
     */
    registeredAt?: Date | null;
    /**
     * The state a connector last reported for itself. Nothing changes it on the connector's behalf, soa connector that has stopped calling home keeps its last reported value — judge liveness fromlastHeartbeatAt instead.
     */
    status?: ConnectorStatusType | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface SqlConnectorStatus_metadata extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * An entry in a statement's audit trail. Events are append-only and are never edited or removed,so the history is the full record of how a statement reached its current status.
 */
export interface StatementEventDto extends Parsable {
    /**
     * Identifies this event within the statement.
     */
    eventId?: string | null;
    /**
     * The status before the change, or null for the event recorded when the statement wasgenerated and for plain notes, which do not change status.
     */
    fromStatus?: string | null;
    /**
     * What happened. For a dispute this carries the reason the caller gave; for a payment it carriesthe payment reference when one was supplied.
     */
    message?: string | null;
    /**
     * When the event was recorded.
     */
    timestamp?: Date | null;
    /**
     * The status after the change, or null for events that did not change it.
     */
    toStatus?: string | null;
    /**
     * Whoever the caller identified as performing the action, taken from the user field on therequest that caused it.
     */
    user?: string | null;
}
export interface Step extends Parsable {
    /**
     * The isComplete property
     */
    isComplete?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The order property
     */
    order?: number | null;
    /**
     * The stepId property
     */
    stepId?: string | null;
}
export interface StorageStatsResponse extends Parsable {
    /**
     * How much of an organization's document allowance is in use. All sizes are in bytes.
     */
    stats?: DocumentStorageStatsDto | null;
}
/**
 * One customer a storefront user has access to.
 */
export interface StorefrontUserCustomerResponse extends Parsable {
    /**
     * When access to this customer was granted. Null when unknown — UserCustomer never stamps acreated-at, so this is null for every association written to date.
     */
    associatedAt?: Date | null;
    /**
     * The customer's company name, or null when the association points at a customer number with nomatching customer record. Not a reliable "record missing" test on its own — seeCustomerRecordFound.
     */
    companyName?: string | null;
    /**
     * Whether the customer record is active. Null when the customer record could not be resolved.Unlike the user side this genuinely is available, because Customers live in Couchbase.
     */
    customerActive?: boolean | null;
    /**
     * Always populated — it comes from the association itself.
     */
    customerNumber?: string | null;
    /**
     * False when the association points at a customer number with no matching customer record —access to a customer that no longer exists.
     */
    customerRecordFound?: boolean | null;
}
/**
 * A user who can sign into the storefront, with the customers they are allowed to shop for.One row per user — a user associated with three customers is one row carrying three entries inCustomers, not three rows.
 */
export interface StorefrontUserResponse extends Parsable {
    /**
     * The customers this user can shop for, ordered by customer number.
     */
    customers?: StorefrontUserCustomerResponse[] | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * Convenience for display; null when the user could not be resolved.
     */
    fullName?: string | null;
    /**
     * When the user joined the organization in Kinde. Null when unknown.
     */
    joinedOn?: Date | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * Kinde's avatar URL, where the user has one.
     */
    pictureUrl?: string | null;
    /**
     * The Kinde user id the UserCustomer association points at. Always populated, even when theuser could not be resolved.
     */
    userId?: string | null;
    /**
     * False when an association references a Kinde user id that is not a member of theorganization — a genuine orphan. The row is still returned so the listing does not silentlyunder-report who holds access; the name and email are null in that case and the UI shouldmark the row rather than render blanks.
     */
    userRecordFound?: boolean | null;
}
export interface StructuredFormatting extends Parsable {
    /**
     * The mainText property
     */
    mainText?: string | null;
    /**
     * The mainTextMatchedSubstrings property
     */
    mainTextMatchedSubstrings?: MatchedSubstring[] | null;
    /**
     * The secondaryText property
     */
    secondaryText?: string | null;
}
export interface SubmitForReviewRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
    /**
     * The user property
     */
    user?: string | null;
}
export interface SubmitForReviewRequest2 extends Parsable {
    /**
     * Optional note from the customer to their sales rep.
     */
    note?: string | null;
}
export interface Subscription extends Parsable {
    /**
     * The id property
     */
    id?: string | null;
    /**
     * e.g. active, in_trial, cancelled.
     */
    status?: string | null;
    /**
     * The subscription_items property
     */
    subscriptionItems?: SubscriptionItem[] | null;
}
export interface Subscription2 extends Parsable {
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The seatItemPriceId property
     */
    seatItemPriceId?: string | null;
    /**
     * The seats property
     */
    seats?: number | null;
    /**
     * The status property
     */
    status?: string | null;
}
/**
 * The webhook's customer stub. Named for the webhook rather than Customer so its schema nevershares a name with the Domain customer in the published document, where same-named types arenumbered by discovery order and the Kiota model names would swap meaning.
 */
export interface SubscriptionCreatedCustomer extends Parsable {
    /**
     * The organization id — checkout sets the Chargebee customer id to it.
     */
    id?: string | null;
}
/**
 * A Chargebee subscription webhook payload, modelling only the handful of fields we act on.            It deliberately does not mirror the event. Chargebee sends a large, evolving object — cards, invoices,line items, addresses, credit balances — and every field typed here is a field Chargebee can send in ashape that fails to bind, which rejects the whole delivery. That is not theoretical: this modelledresource_version as an Int32 when Chargebee sends a millisecond timestamp, so every webhook 400'd on avalue nothing reads. Postcodes and invoice ids were modelled as integers too, and card iin/last4, all ofwhich arrive as strings.            System.Text.Json ignores properties it doesn't know about, so anything omitted here is simply skipped.Add a field only when something actually reads it.
 */
export interface SubscriptionCreatedRequest extends Parsable {
    /**
     * The content property
     */
    content?: Content | null;
    /**
     * The event_type property
     */
    eventType?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * Milliseconds since the epoch — comfortably past Int32, hence the long.
     */
    occurredAt?: number | null;
}
/**
 * A coupon on the subscription, and what it takes off the next charge. Shown beside the plan lines so adiscounted total can be checked against the undiscounted one rather than looking like a mistake.
 */
export interface SubscriptionDiscountLine extends Parsable {
    /**
     * What it takes off the next charge, in the currency's minor unit. Zero when it ends before then.
     */
    amount?: number | null;
    /**
     * Fixed amount taken off each charge, in the subscription currency's minor unit. Null for apercentage coupon.
     */
    amountOff?: number | null;
    /**
     * The plans the coupon is limited to, by name. Empty when it applies to the whole subscription.
     */
    appliesTo?: string[] | null;
    /**
     * False for a coupon that is still running now but ends before the next charge — it is shown, so acustomer isn't surprised when the price goes up, but nothing is taken off for it.
     */
    appliesToNextCharge?: boolean | null;
    /**
     * The promotion code the customer entered, e.g. LAUNCH20. Null when the coupon was applied directly.
     */
    code?: string | null;
    /**
     * How long it lasts: once, repeating or forever.
     */
    duration?: string | null;
    /**
     * For a repeating coupon, how many months it runs for.
     */
    durationInMonths?: number | null;
    /**
     * When a repeating coupon stops applying. Null for once and forever.
     */
    endsAt?: Date | null;
    /**
     * The coupon's name, e.g. Launch offer. Falls back to the code, then the coupon id.
     */
    name?: string | null;
    /**
     * Percentage taken off, e.g. 20 for 20%. Null for a fixed-amount coupon.
     */
    percentOff?: number | null;
}
export interface SubscriptionEntitlement extends Parsable {
    /**
     * The featureId property
     */
    featureId?: string | null;
    /**
     * The featureName property
     */
    featureName?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The isOverridden property
     */
    isOverridden?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The subscriptionId property
     */
    subscriptionId?: string | null;
    /**
     * The value property
     */
    value?: string | null;
}
export interface SubscriptionItem extends Parsable {
    /**
     * The item_price_id property
     */
    itemPriceId?: string | null;
    /**
     * Seats, for a per-unit item. A genuine small integer, unlike the timestamps.
     */
    quantity?: number | null;
}
/**
 * One line of what an organization is billed for — a subscription can hold several, and a total with nobreakdown behind it is a number a customer cannot check.
 */
export interface SubscriptionPlanLine extends Parsable {
    /**
     * What this line costs per period — unit price times quantity.
     */
    amount?: number | null;
    /**
     * Whether the quantity is a number of sales rep seats.
     */
    isPerSeat?: boolean | null;
    /**
     * The price's lookup key, e.g. sales_monthly.
     */
    lookupKey?: string | null;
    /**
     * The product's name in the billing catalog, e.g. Nymble Sales.
     */
    name?: string | null;
    /**
     * Units bought. Always 1 for a flat-rate plan; the seat count for a per-seat one.
     */
    quantity?: number | null;
    /**
     * Price of one unit, in the currency's minor unit.
     */
    unitPrice?: number | null;
}
export interface SuggestMappingsRequest extends Parsable {
    /**
     * The uploaded sheet's columns, in sheet order. At most 500.
     */
    columns?: ImportColumnSample[] | null;
    /**
     * The import type the sheet was uploaded to, exactly as the Import Data page names it:Customers, Products, Images, Prices, Categories, Tags, Sort Order, Invoices, Orders or Customer Users.
     */
    importType?: string | null;
}
export interface SuggestMappingsResponse extends Parsable {
    /**
     * One entry per column in the request, in the same order.
     */
    columns?: ColumnMappingSuggestion[] | null;
    /**
     * True when no suggestions could be produced (the feature is not configured, or the evaluationfailed or timed out). Columns is then empty and the admin maps by hand.
     */
    degraded?: boolean | null;
    /**
     * Why the answer is degraded: not-configured or upstream-error. Null otherwise.
     */
    degradedReason?: string | null;
    /**
     * The importType property
     */
    importType?: string | null;
    /**
     * The model version that produced the suggestions, for the accept-versus-override telemetry.
     */
    model?: string | null;
    /**
     * Identifies this set of suggestions. Send it back with the admin's final mapping toPOST api/data-imports/suggest-mappings/{runId}/outcome when the import starts. Null whenthe response is degraded or the run could not be recorded; the suggestions still apply.
     */
    runId?: string | null;
    /**
     * Every mapping target that was offered for this import type and organization, named as the MapHeaders dropdown names them (e.g. sku, category1, Price:Wholesale,Attribute:Color). Lets the client check the two lists agree before applying suggestions.
     */
    targets?: string[] | null;
}
/**
 * Asks the research model to draft research settings for the caller's own organization. Nothing ispersisted — the suggestions are a starting point the admin edits and then saves throughPUT /api/organizations/research-settings.
 */
export interface SuggestResearchSettingsRequest extends Parsable {
    /**
     * If true, generate suggestions even when the organization already has research settings.Defaults to false so an already-configured tenant can never be charged for a pointless call.
     */
    forceRegenerate?: boolean | null;
}
/**
 * AI-drafted research settings for the caller's own organization. These are suggestions only —they are not stored until the admin saves them.
 */
export interface SuggestResearchSettingsResponse extends Parsable {
    /**
     * Suggested B2B approval criteria for the tenant's applicants.
     */
    approvalCriteria?: string | null;
    /**
     * Estimated cost of the generating call, in USD.
     */
    estimatedCostUsd?: number | null;
    /**
     * When the suggestions were generated.
     */
    generatedAt?: Date | null;
    /**
     * The model that produced the suggestions.
     */
    generatedBy?: string | null;
    /**
     * Suggested description of the tenant's industry and what they sell.
     */
    industryDescription?: string | null;
    /**
     * Total tokens consumed generating the suggestions.
     */
    tokensUsed?: number | null;
}
/**
 * The outcome of one batch within a sync run. A run can complete with some of these failed; thisis where a partial failure is traced to the batch that caused it.
 */
export interface SyncBatchResultDto extends Parsable {
    /**
     * The batch's position in the run, counting from 1.
     */
    batchNumber?: number | null;
    /**
     * How long the batch took, in seconds.
     */
    durationSeconds?: number | null;
    /**
     * Why the batch failed. Null for a batch that succeeded.
     */
    errorMessage?: string | null;
    /**
     * The status code the batch's request came back with.
     */
    httpStatusCode?: number | null;
    /**
     * Whether the batch was accepted.
     */
    isSuccess?: boolean | null;
    /**
     * How many rows this batch carried.
     */
    recordCount?: number | null;
    /**
     * How many times the connector retried this batch before giving up or succeeding.
     */
    retryAttempts?: number | null;
}
export interface SyncRunDocument extends Parsable {
    /**
     * The batchResults property
     */
    batchResults?: SyncBatchResultDto[] | null;
    /**
     * The completedAt property
     */
    completedAt?: Date | null;
    /**
     * The connectorId property
     */
    connectorId?: string | null;
    /**
     * The durationSeconds property
     */
    durationSeconds?: number | null;
    /**
     * The endpointId property
     */
    endpointId?: string | null;
    /**
     * The endpointName property
     */
    endpointName?: string | null;
    /**
     * The errorMessage property
     */
    errorMessage?: string | null;
    /**
     * The failedBatches property
     */
    failedBatches?: number | null;
    /**
     * The failedRecords property
     */
    failedRecords?: number | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The isManualTrigger property
     */
    isManualTrigger?: boolean | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The pushedAt property
     */
    pushedAt?: Date | null;
    /**
     * The startedAt property
     */
    startedAt?: Date | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The successfulBatches property
     */
    successfulBatches?: number | null;
    /**
     * The successfulRecords property
     */
    successfulRecords?: number | null;
    /**
     * The syncMode property
     */
    syncMode?: string | null;
    /**
     * The syncRunId property
     */
    syncRunId?: string | null;
    /**
     * The totalBatches property
     */
    totalBatches?: number | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface Tag extends Parsable {
    /**
     * The categoryPath property
     */
    categoryPath?: string | null;
    /**
     * The height property
     */
    height?: number | null;
    /**
     * The kind property
     */
    kind?: TagKind | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The width property
     */
    width?: number | null;
    /**
     * The x property
     */
    x?: number | null;
    /**
     * The y property
     */
    y?: number | null;
}
export interface TagInfo extends Parsable {
    /**
     * The linked category path, e.g. /Hair Care/Shampoos. Required for a Category tag, whichlists the products in that category and its subcategories; ignored for a Product tag. Onecategory per tag. Stored normalized (leading slash, no trailing slash) and not checked againstthe organization's category tree: a path with no products simply lists none.
     */
    categoryPath?: string | null;
    /**
     * The height property
     */
    height?: number | null;
    /**
     * What the hotspot links to: Product (the default, so clients that predate category tagskeep working unchanged) or Category.
     */
    kind?: TagKind | null;
    /**
     * The linked SKU. Required for a Product tag; ignored for a Category tag.
     */
    sku?: string | null;
    /**
     * The width property
     */
    width?: number | null;
    /**
     * The x property
     */
    x?: number | null;
    /**
     * The y property
     */
    y?: number | null;
}
export type TagKind = (typeof TagKindObject)[keyof typeof TagKindObject];
export interface TaskItem extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The completedAt property
     */
    completedAt?: Date | null;
    /**
     * The completedByIdentityProviderUserId property
     */
    completedByIdentityProviderUserId?: string | null;
    /**
     * The completedByName property
     */
    completedByName?: string | null;
    /**
     * The createdByIdentityProviderUserId property
     */
    createdByIdentityProviderUserId?: string | null;
    /**
     * The createdByName property
     */
    createdByName?: string | null;
    /**
     * The customerId property
     */
    customerId?: string | null;
    /**
     * The customerName property
     */
    customerName?: string | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The customerRepNumber property
     */
    customerRepNumber?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The dueAt property
     */
    dueAt?: Date | null;
    /**
     * The dueTimeZoneId property
     */
    dueTimeZoneId?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The organizationSalesRepId property
     */
    organizationSalesRepId?: string | null;
    /**
     * The priority property
     */
    priority?: TaskPriority | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
    /**
     * The salesRepName property
     */
    salesRepName?: string | null;
    /**
     * The salesRepRepNumber property
     */
    salesRepRepNumber?: string | null;
    /**
     * The sortOrder property
     */
    sortOrder?: number | null;
    /**
     * The status property
     */
    status?: TaskItemStatus | null;
    /**
     * The taskItemId property
     */
    taskItemId?: string | null;
    /**
     * The title property
     */
    title?: string | null;
}
export type TaskItemStatus = (typeof TaskItemStatusObject)[keyof typeof TaskItemStatusObject];
export type TaskPriority = (typeof TaskPriorityObject)[keyof typeof TaskPriorityObject];
/**
 * Counts over the organization's open tasks (not completed, cancelled or deleted) as the callersees them, with the instants the counts were taken against so a client can build matchinglist filters.
 */
export interface TasksSummaryResponse extends Parsable {
    /**
     * The instant the counts are as of.
     */
    asOf?: Date | null;
    /**
     * Open tasks due from today to the end of the caller's week (Sunday), today included.
     */
    dueThisWeek?: number | null;
    /**
     * Open tasks due today in the caller's zone, overdue ones included.
     */
    dueToday?: number | null;
    /**
     * Local midnight at the start of tomorrow, as an instant (exclusive).
     */
    endOfToday?: Date | null;
    /**
     * Local midnight at the start of next Monday, as an instant (exclusive).
     */
    endOfWeek?: Date | null;
    /**
     * Every open task, whatever its due date.
     */
    open?: number | null;
    /**
     * Open tasks due before AsOf.
     */
    overdue?: number | null;
    /**
     * Local midnight at the start of today, as an instant.
     */
    startOfToday?: Date | null;
    /**
     * The zone the windows were built in: the caller's, or UTC when none or an unknown one was sent.
     */
    timeZone?: string | null;
}
export interface TaxLineItem extends Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The jurisdiction property
     */
    jurisdiction?: string | null;
    /**
     * The ratePercent property
     */
    ratePercent?: number | null;
    /**
     * The taxableAmount property
     */
    taxableAmount?: number | null;
    /**
     * The taxName property
     */
    taxName?: string | null;
}
export interface TaxRule extends Parsable {
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The ratePercent property
     */
    ratePercent?: number | null;
    /**
     * The sourcingBasis property
     */
    sourcingBasis?: SourcingBasis | null;
    /**
     * The stateProvince property
     */
    stateProvince?: string | null;
    /**
     * The taxName property
     */
    taxName?: string | null;
}
export interface TaxSettings extends Parsable {
    /**
     * The isEnabled property
     */
    isEnabled?: boolean | null;
    /**
     * The nexusStates property
     */
    nexusStates?: string[] | null;
    /**
     * The provider property
     */
    provider?: string | null;
    /**
     * The ruleOverrides property
     */
    ruleOverrides?: TaxRule[] | null;
}
export interface TearSheet extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The productIds property
     */
    productIds?: string[] | null;
    /**
     * The salesRepId property
     */
    salesRepId?: string | null;
    /**
     * The salesRepName property
     */
    salesRepName?: string | null;
    /**
     * The sentAt property
     */
    sentAt?: Date | null;
    /**
     * The sentToEmail property
     */
    sentToEmail?: string | null;
    /**
     * The sentToPhoneNumber property
     */
    sentToPhoneNumber?: string | null;
    /**
     * The sentVia property
     */
    sentVia?: string | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The tearSheetId property
     */
    tearSheetId?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export type TemporaryPasswordMode = (typeof TemporaryPasswordModeObject)[keyof typeof TemporaryPasswordModeObject];
export interface Term extends Parsable {
    /**
     * The offset property
     */
    offset?: number | null;
    /**
     * The value property
     */
    value?: string | null;
}
export interface TestIntegrationResponse extends Parsable {
    /**
     * The integration that was tested.
     */
    integrationId?: string | null;
    /**
     * Whether the provider accepted the connection. A failed test still returns 200, so this isthe field to check rather than the status code.
     */
    isSuccessful?: boolean | null;
    /**
     * A short description of the outcome.
     */
    message?: string | null;
    /**
     * When the test ran. Also recorded on the integration as lastTestedAt.
     */
    testedAt?: Date | null;
}
export interface TestJobRequest extends Parsable {
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The productId property
     */
    productId?: string | null;
    /**
     * The productSku property
     */
    productSku?: string | null;
}
export interface TrainOrderVolumeForecastModelRequest extends Parsable {
    /**
     * End of the history to train on. The trained model knows nothing after this date.
     */
    endDate?: Date | null;
    /**
     * Start of the history to train on. Must be at least one month in the past and beforeEndDate. Two years or more is recommended so a full seasonal cycle is present.
     */
    startDate?: Date | null;
}
export interface TrainOrderVolumeForecastModelResponse extends Parsable {
    /**
     * The newly trained model. It is now the current one; its modelId can pin later forecasts to it.
     */
    model?: ForecastModelDto | null;
}
export interface TrainSkuForecastModelRequest extends Parsable {
    /**
     * End of the history to train on. The trained model knows nothing after this date.
     */
    endDate?: Date | null;
    /**
     * Start of the history to train on. Must be at least one month in the past and beforeEndDate. Two years or more is recommended so a full seasonal cycle is present.
     */
    startDate?: Date | null;
}
export interface TrainSkuForecastModelResponse extends Parsable {
    /**
     * The newly trained model. It is now the current one; its modelId can pin later forecasts to it.
     */
    model?: ForecastModelDto | null;
}
/**
 * Sets who is emailed when a new access request is submitted to the organization.
 */
export interface UpdateAccessRequestNotificationSettingsRequest extends Parsable {
    /**
     * The email address to notify. Send null or an empty value to clear it, after whichnotifications go to the organization's contact email instead.
     */
    notificationEmail?: string | null;
}
/**
 * Represents a request to update a shopping cart's PO number.
 */
export interface UpdateCartPoNumberRequest extends Parsable {
    /**
     * Gets or sets the PO number for the cart.
     */
    poNumber?: string | null;
}
/**
 * Updates the organization's cart pricing settings.
 */
export interface UpdateCartPricingSettingsRequest extends Parsable {
    /**
     * Allow or stop sales reps entering line quantities with up to two decimal places (1.5 kg,12.75 m). Omit (or send null) to leave the current setting unchanged. Turning it off stopsnew fractional quantities only; lines and orders that already carry one keep it. Turn it ononly once every reader of this organization's carts and orders, every rep device included,runs a build that understands fractional quantities.
     */
    allowDecimalQuantities?: boolean | null;
    /**
     * The organization-wide default for whether sales reps may apply discounts to individual linesin the sales app. Omit (or send null) to leave the current setting unchanged. Same semanticsas AllowOrderDiscounts.
     */
    allowLineItemDiscounts?: boolean | null;
    /**
     * The organization-wide default for whether sales reps may apply a discount to a whole order(the cart-level discount) in the sales app. Omit (or send null) to leave the current settingunchanged. A rep's own setting on the sales rep list overrides this either way. Turning it offstops new order discounts only; carts and orders that already carry one keep it.
     */
    allowOrderDiscounts?: boolean | null;
    /**
     * Allow or stop sales reps overriding a cart line's price by hand. Omit (or send null) to leavethe current setting unchanged, so a client that predates the field can't switch it off.Turning it off stops new overrides only; lines and orders that already carry one keep it.
     */
    allowPriceOverride?: boolean | null;
    /**
     * Turn stale cart price refresh on or off for this organization.
     */
    refreshStalePrices?: boolean | null;
    /**
     * How many days cart prices may age before they are refreshed. Minimum 1.
     */
    stalePriceAgeDays?: number | null;
}
/**
 * Who gets the receipts when an agency cart's lines are placed: one receipt per vendor order.
 */
export interface UpdateCartReceiptToRequest extends AdditionalDataHolder, Parsable, VendorCartRequest {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The addresses, replacing the cart's list. Empty sends receipts to the customer's company email, as before.
     */
    receiptTo?: string[] | null;
}
/**
 * Represents a request to update a shopping cart.
 */
export interface UpdateCartRequest extends Parsable {
    /**
     * Gets or sets the shopping cart with updated information.
     */
    cart?: ShoppingCart | null;
}
/**
 * Represents a request to update a shopping cart's shipping address.
 */
export interface UpdateCartShippingRequest extends Parsable {
    /**
     * Gets or sets the new shipping address for the cart.
     */
    shippingAddress?: Address | null;
}
export interface UpdateCommissionPlanRequest extends Parsable {
    /**
     * The defaultRate property
     */
    defaultRate?: number | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The effectiveEndDate property
     */
    effectiveEndDate?: Date | null;
    /**
     * The effectiveStartDate property
     */
    effectiveStartDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface UpdateCustomerNoteRequest extends Parsable {
    /**
     * The replacement note text, up to 4000 characters. It overwrites the previous body in full;there is no revision history to fall back on.
     */
    body?: string | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
export interface UpdateCustomerRequest extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The addresses property
     */
    addresses?: Address[] | null;
    /**
     * The companyEmail property
     */
    companyEmail?: string | null;
    /**
     * The companyFax property
     */
    companyFax?: string | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyPhone property
     */
    companyPhone?: string | null;
    /**
     * The contacts property
     */
    contacts?: Contact[] | null;
    /**
     * The customerId property
     */
    customerId?: string | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The pricing property
     */
    pricing?: string | null;
    /**
     * The repNumber property
     */
    repNumber?: string | null;
    /**
     * The terms property
     */
    terms?: string | null;
}
export interface UpdateCustomerResponse extends Parsable {
    /**
     * The customer property
     */
    customer?: Customer | null;
}
export interface UpdateFlipbookRequest extends Parsable {
    /**
     * The pages property
     */
    pages?: PageUpdateInfo[] | null;
    /**
     * The title property
     */
    title?: string | null;
}
/**
 * A partial update. At least one field must be supplied; anything omitted is left unchanged.
 */
export interface UpdateIntegrationRequest extends Parsable {
    /**
     * Non-secret settings, keyed as the provider's template names them. At most 50 entries, keys upto 100 characters and values up to 1000.
     */
    configuration?: UpdateIntegrationRequest_configuration | null;
    /**
     * New display name. Maximum 200 characters.
     */
    displayName?: string | null;
    /**
     * Switches the integration on or off. Sending false is how an integration is retired withoutlosing its configuration.
     */
    isEnabled?: boolean | null;
    /**
     * Replacement credentials, keyed as the provider's template names them. Write-only: they can beset here but are never returned by any endpoint. At most 20 entries, keys up to 100characters and values up to 2000; every value must be non-empty.
     */
    secrets?: UpdateIntegrationRequest_secrets | null;
}
/**
 * Non-secret settings, keyed as the provider's template names them. At most 50 entries, keys upto 100 characters and values up to 1000.
 */
export interface UpdateIntegrationRequest_configuration extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * Replacement credentials, keyed as the provider's template names them. Write-only: they can beset here but are never returned by any endpoint. At most 20 entries, keys up to 100characters and values up to 2000; every value must be non-empty.
 */
export interface UpdateIntegrationRequest_secrets extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface UpdateIntegrationResponse extends Parsable {
    /**
     * The non-secret settings as they now stand. Credentials are never returned.
     */
    configuration?: UpdateIntegrationResponse_configuration | null;
    /**
     * The display name for the integration
     */
    displayName?: string | null;
    /**
     * The unique identifier of the integration
     */
    integrationId?: string | null;
    /**
     * The type of integration (Payment, Accounting, etc.)
     */
    integrationType?: IntegrationType | null;
    /**
     * Whether the integration is enabled
     */
    isEnabled?: boolean | null;
    /**
     * The organization identifier
     */
    organizationId?: string | null;
    /**
     * The provider name (e.g., AuthorizeNet, QuickBooks)
     */
    provider?: string | null;
    /**
     * True when this update changed something the provider must be re-checked against — newcredentials, or a configuration key that decides which endpoint the provider is reached at.Nothing was verified during the update, so follow up withPOST /api/organizations/{organizationId}/integrations/{integrationId}/test.
     */
    testConnectionRequired?: boolean | null;
    /**
     * When the integration was last updated
     */
    updatedAt?: Date | null;
}
/**
 * The non-secret settings as they now stand. Credentials are never returned.
 */
export interface UpdateIntegrationResponse_configuration extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface UpdateInvoiceRequest extends Parsable {
    /**
     * The billingAddress property
     */
    billingAddress?: AddressInput | null;
    /**
     * The customer property
     */
    customer?: CustomerInput | null;
    /**
     * The dueDate property
     */
    dueDate?: Date | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The invoiceNumber property
     */
    invoiceNumber?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export interface UpdateItemQuantityRequest extends Parsable {
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * The new quantity, replacing whatever the line held. Must be greater than zero, with at most two decimal places.
     */
    quantity?: number | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
/**
 * Represents a request to update an item in a shopping cart.
 */
export interface UpdateItemRequest extends Parsable {
    /**
     * Gets or sets the new quantity of the product in the cart. Zero removes the line. Up to twodecimal places; a fractional quantity is accepted only when the organization allowsdecimal quantities.
     */
    quantity?: number | null;
}
/**
 * A request to change the quantity of one cart line, named by its id (CU-86bcpta0t): the onlyway to reach a line when its SKU is on several lines of the cart.
 */
export interface UpdateLineRequest extends Parsable {
    /**
     * Gets or sets the new quantity of the line. Zero removes the line. Up to two decimal places;a fractional quantity is accepted only when the organization allows decimal quantities.
     */
    quantity?: number | null;
}
/**
 * Replaces the set of custom export formats an organization may use.
 */
export interface UpdateOrderExportSettingsRequest extends Parsable {
    /**
     * The complete set of custom format keys to enable — this replaces whatever was set before, soan empty list disables every custom format and returns the organization to the built-inexport types. Every key must be one the platform implements; unknown keys are rejectedrather than stored, because a stored key that matches nothing would silently never appear.
     */
    enabledCustomFormats?: string[] | null;
}
/**
 * Replaces the order receipt subject templates for an organization. Send all three: null, emptyor a template identical to the platform default returns that audience to the default.
 */
export interface UpdateOrderReceiptSettingsRequest extends Parsable {
    /**
     * Subject template for the customer's copy of the receipt, e.g.{OrderType} Confirmation {OrderNumber} - {OrganizationName}. Placeholders must comefrom the read endpoint's availableTokens. Null or empty uses the platform default.
     */
    customerSubject?: string | null;
    /**
     * Subject template for the copy sent to the organization's own email address, e.g.New {OrderType} {OrderNumber} from {CustomerName} {CustomerNumber}. Null or emptyuses the platform default.
     */
    organizationSubject?: string | null;
    /**
     * Subject template for the copy sent to the sales rep(s) on the order, e.g.New {OrderType} {OrderNumber} from {CustomerName}. Null or empty uses the platform default.
     */
    salesRepSubject?: string | null;
}
export interface UpdateOrderStatusRequest extends Parsable {
    /**
     * The orderStatus property
     */
    orderStatus?: string | null;
}
/**
 * Replaces the organization's feature switches.
 */
export interface UpdateOrganizationFeaturesRequest extends Parsable {
    /**
     * Turn product variants (families, option registry, the variant grid) on or off. Off hidesthe feature everywhere without touching the data behind it.
     */
    productVariants?: boolean | null;
}
export interface UpdatePriceTierRequest extends Parsable {
    /**
     * The currencyCode property
     */
    currencyCode?: string | null;
    /**
     * The newName property
     */
    newName?: string | null;
    /**
     * The oldName property
     */
    oldName?: string | null;
}
export interface UpdateProductCategoriesRequest extends Parsable {
    /**
     * The categoryUpdates property
     */
    categoryUpdates?: UpdateProductCategoriesRequest_CategoryUpdate[] | null;
}
export interface UpdateProductCategoriesRequest_CategoryUpdate extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The category property
     */
    category?: string | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * For agency organizations: the code of the vendor (line) this product belongs to, e.g. "HAL".The row's SKU is then matched as "{vendorCode}-{sku}", the way the product import stores it;a value already carrying the prefix is left alone, so re-sending an exported SKU does notdouble it. Must name one of the organization's vendors. Omit for the organization's owncatalog, and the SKU is used exactly as given. Refused for a Supplier organization.
     */
    vendorCode?: string | null;
}
export interface UpdateProductImagesRequest extends Parsable {
    /**
     * The complete set of the product's images in the new display order, by image id. Omitting acurrently-assigned image removes it from the product; an empty list removes them all. Onlyimages already assigned to the product may appear — this endpoint arranges, it does not add.
     */
    imageIds?: string[] | null;
    /**
     * The SKU of the product whose images are being arranged.
     */
    sku?: string | null;
    /**
     * For agency organizations: the code of the vendor (line) this product belongs to, e.g. "HAL".The SKU is then matched as "{vendorCode}-{sku}", the way the product import stores it; avalue already carrying the prefix is left alone, so re-sending an exported SKU does notdouble it. Must name one of the organization's vendors. Omit for the organization's owncatalog, and the SKU is used exactly as given. Refused for a Supplier organization.
     */
    vendorCode?: string | null;
}
export interface UpdateProductPricesRequest extends Parsable {
    /**
     * The productUpdates property
     */
    productUpdates?: UpdateProductPricesRequest_ProductPriceUpdate[] | null;
}
export interface UpdateProductPricesRequest_ProductPriceDto extends Parsable {
    /**
     * The atQuantity property
     */
    atQuantity?: number | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The tier property
     */
    tier?: string | null;
}
export interface UpdateProductPricesRequest_ProductPriceUpdate extends Parsable {
    /**
     * The prices property
     */
    prices?: UpdateProductPricesRequest_ProductPriceDto[] | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * For agency organizations: the code of the vendor (line) this product belongs to, e.g. "HAL".The row's SKU is then matched as "{vendorCode}-{sku}", the way the product import stores it;a value already carrying the prefix is left alone, so re-sending an exported SKU does notdouble it. Must name one of the organization's vendors. Omit for the organization's owncatalog, and the SKU is used exactly as given. Refused for a Supplier organization.
     */
    vendorCode?: string | null;
}
export interface UpdateProductRequest extends Parsable {
    /**
     * The active property
     */
    active?: boolean | null;
    /**
     * The category property
     */
    category?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * True to return the product to a standalone SKU. Takes precedence overFamilyKey. Omit (or false) to leave its family membership as it is — an editthat says nothing about the family never detaches the product.
     */
    detachFromFamily?: boolean | null;
    /**
     * The dimensions property
     */
    dimensions?: string | null;
    /**
     * The dimensionsUnit property
     */
    dimensionsUnit?: string | null;
    /**
     * The externalId property
     */
    externalId?: string | null;
    /**
     * The family's description, used when the family is created from this row.
     */
    familyDescription?: string | null;
    /**
     * Group this product into a family (requires product variants to be enabled for theorganization). A stable key for the style — a style code, a source system's product id.The family is created from this row if it does not exist. Omit for a standalone product.
     */
    familyKey?: string | null;
    /**
     * The family's display name, used when the family is created from this row.
     */
    familyName?: string | null;
    /**
     * The imageName property
     */
    imageName?: string | null;
    /**
     * The images property
     */
    images?: string[] | null;
    /**
     * The minimumOrderQuantity property
     */
    minimumOrderQuantity?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * This variant's option values keyed by option, e.g. { "Color": "Solid Black", "Size": "2XL" }.Display names or slugs are accepted; options and values not yet in the organization'sproduct options are registered at the end of their order.
     */
    optionValues?: UpdateProductRequest_optionValues | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The prices property
     */
    prices?: UpdateProductRequest_ProductPriceDto[] | null;
    /**
     * The productAttributes property
     */
    productAttributes?: UpdateProductRequest_productAttributes | null;
    /**
     * The quantityIncrement property
     */
    quantityIncrement?: number | null;
    /**
     * The quantityOnHand property
     */
    quantityOnHand?: number | null;
    /**
     * Every add of this product to a cart creates a new line (CU-86bcpta0t). Omit it and theproduct keeps the flag it has, so a client built before the flag existed never resets it.
     */
    separateLines?: boolean | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * Optional replacement set of tags for this product. When null, the product's existingtags are left unchanged; when provided (including an empty list), tags are replacedwith the normalized form (trim / UPPERCASE / de-dupe). An empty list clears the tags.
     */
    tags?: string[] | null;
    /**
     * The upc property
     */
    upc?: string | null;
    /**
     * For agency organizations: moves the product to this vendor (line), or gives it one. The SKU isre-prefixed as "{vendorCode}-{vendor item number}" and the product keeps its identifier, soread it back by the new SKU. Must name one of the organization's vendors. Omit or leave blankto keep the stored code. Refused for a Supplier organization.
     */
    vendorCode?: string | null;
    /**
     * The weight property
     */
    weight?: number | null;
    /**
     * The weightUnit property
     */
    weightUnit?: string | null;
}
/**
 * This variant's option values keyed by option, e.g. { "Color": "Solid Black", "Size": "2XL" }.Display names or slugs are accepted; options and values not yet in the organization'sproduct options are registered at the end of their order.
 */
export interface UpdateProductRequest_optionValues extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface UpdateProductRequest_productAttributes extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface UpdateProductRequest_ProductPriceDto extends Parsable {
    /**
     * The atQuantity property
     */
    atQuantity?: number | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The tier property
     */
    tier?: string | null;
}
export interface UpdateProductSortOrdersRequest extends Parsable {
    /**
     * The sortOrderUpdates property
     */
    sortOrderUpdates?: UpdateProductSortOrdersRequest_SortOrderUpdate[] | null;
}
export interface UpdateProductSortOrdersRequest_SortOrderUpdate extends Parsable {
    /**
     * The category listing being arranged, as a path (e.g. "/Apparel/Shirts"). Required: aproduct holds an independent position in each category it sits in, so a rank naming nocategory names no listing to arrange.
     */
    category?: string | null;
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The product's display position within Category, low to high. Null clears therank in that one category, returning the product to that listing's unranked tail where itsorts by SKU after every ranked product. Every other category's position is untouched.
     */
    sortOrder?: number | null;
    /**
     * For agency organizations: the code of the vendor (line) this product belongs to, e.g. "HAL".The row's SKU is then matched as "{vendorCode}-{sku}", the way the product import stores it;a value already carrying the prefix is left alone, so re-sending an exported SKU does notdouble it. Omit for the organization's own catalog, and the SKU is used exactly as given.Refused for a Supplier organization; a code that is malformed or not one of theorganization's vendors skips the row, with the reason in the response, as an unknown SKU does.
     */
    vendorCode?: string | null;
}
/**
 * Summary of a bulk sort-order update: which distinct SKUs had their position applied and whichwere skipped because no matching product exists. Unknown SKUs never fail the batch — they arereported here instead, so an import can show what did not land rather than reporting a clean run.
 */
export interface UpdateProductSortOrdersResponse extends Parsable {
    /**
     * The distinct SKUs whose position was applied.
     */
    applied?: string[] | null;
    /**
     * Number of distinct SKUs whose position was applied.
     */
    appliedCount?: number | null;
    /**
     * The distinct SKUs skipped because no matching product exists.
     */
    skipped?: string[] | null;
    /**
     * Number of distinct SKUs skipped because no matching product exists.
     */
    skippedCount?: number | null;
    /**
     * Why each skipped SKU was skipped, keyed by SKU, so an import can show the reason rather thana bare count.
     */
    skipReasons?: UpdateProductSortOrdersResponse_skipReasons | null;
    /**
     * Total number of distinct (non-blank) SKUs in the request.
     */
    totalSkus?: number | null;
}
/**
 * Why each skipped SKU was skipped, keyed by SKU, so an import can show the reason rather thana bare count.
 */
export interface UpdateProductSortOrdersResponse_skipReasons extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface UpdateProductTagsRequest extends Parsable {
    /**
     * The tagUpdates property
     */
    tagUpdates?: UpdateProductTagsRequest_TagUpdate[] | null;
}
export interface UpdateProductTagsRequest_TagUpdate extends Parsable {
    /**
     * The sku property
     */
    sku?: string | null;
    /**
     * The tags property
     */
    tags?: string[] | null;
    /**
     * For agency organizations: the code of the vendor (line) this product belongs to, e.g. "HAL".The row's SKU is then matched as "{vendorCode}-{sku}", the way the product import stores it;a value already carrying the prefix is left alone, so re-sending an exported SKU does notdouble it. Must name one of the organization's vendors. Omit for the organization's owncatalog, and the SKU is used exactly as given. Refused for a Supplier organization.
     */
    vendorCode?: string | null;
}
/**
 * Summary of a bulk tag update: which distinct SKUs had their tags applied andwhich were skipped because no matching product exists. Unknown SKUs never failthe batch — they are reported here instead.
 */
export interface UpdateProductTagsResponse extends Parsable {
    /**
     * The distinct SKUs whose tags were applied.
     */
    applied?: string[] | null;
    /**
     * Number of distinct SKUs whose tags were applied.
     */
    appliedCount?: number | null;
    /**
     * The distinct SKUs skipped because no matching product exists.
     */
    skipped?: string[] | null;
    /**
     * Number of distinct SKUs skipped because no matching product exists.
     */
    skippedCount?: number | null;
    /**
     * Total number of distinct (non-blank) SKUs in the request.
     */
    totalSkus?: number | null;
}
/**
 * Updates the organization's AI access-request research settings. Both fields are optional freetext; sending null or an empty value clears the corresponding setting (research then falls backto graceful defaults).
 */
export interface UpdateResearchSettingsRequest extends Parsable {
    /**
     * The tenant's description of what types of businesses they approve as B2B customers.
     */
    approvalCriteria?: string | null;
    /**
     * The tenant's own description of their industry and what they sell.
     */
    industryDescription?: string | null;
}
/**
 * Represents a request to update a Sales Representative's RepNumber.
 */
export interface UpdateSalesRepRequest extends Parsable {
    /**
     * Gets or sets the new market code. Omit (or send null) to leave it unchanged; send an emptystring to clear it. A non-empty value is also remembered on the organization as a suggestionfor other reps.
     */
    marketCode?: string | null;
    /**
     * Gets or sets the organization sales representative ID.
     */
    organizationSalesRepId?: string | null;
    /**
     * Gets or sets the new representative number. Omit to leave it unchanged. Ignored whenRepNumbers is provided.
     */
    repNumber?: string | null;
    /**
     * Gets or sets the full ordered list of representative numbers. The first entry is thedefault. Omit to leave the list unchanged; when provided it replaces the whole list —channel grants move as a set diff, so a pure reorder only changes the default.
     */
    repNumbers?: string[] | null;
}
/**
 * Represents the response after updating a Sales Representative's RepNumber.
 */
export interface UpdateSalesRepResponse extends Parsable {
    /**
     * Gets or sets the email of the sales representative.
     */
    email?: string | null;
    /**
     * Gets or sets the first name of the sales representative.
     */
    firstName?: string | null;
    /**
     * Gets or sets the last name of the sales representative.
     */
    lastName?: string | null;
    /**
     * Gets or sets the updated market code, or null when the rep has none.
     */
    marketCode?: string | null;
    /**
     * Gets or sets the organization ID.
     */
    organizationId?: string | null;
    /**
     * Gets or sets the organization sales representative ID.
     */
    organizationSalesRepId?: string | null;
    /**
     * Gets or sets the updated representative number (the default — first entry of RepNumbers).
     */
    repNumber?: string | null;
    /**
     * Gets or sets the updated ordered representative numbers.
     */
    repNumbers?: string[] | null;
    /**
     * Gets or sets the sales representative ID.
     */
    salesRepId?: string | null;
    /**
     * Gets or sets whether the update was successful.
     */
    success?: boolean | null;
}
export interface UpdateSeatsRequest extends Parsable {
    /**
     * How many sales rep seats the organization should be paying for after this change.
     */
    seats?: number | null;
}
export interface UpdateSeatsResponse extends Parsable {
    /**
     * Reps currently holding one, so a caller can show "3 of 5 used" without a second call.
     */
    activeReps?: number | null;
    /**
     * Seats the organization now pays for.
     */
    seats?: number | null;
}
export interface UpdateTaskRequest extends Parsable {
    /**
     * The customer number the task is about, or null for none. Omitting it unlinks the customer.
     */
    customerNumber?: string | null;
    /**
     * Optional detail, plain text up to 4000 characters. Null clears it.
     */
    description?: string | null;
    /**
     * When the task is due, date and time, as an ISO 8601 instant with its offset.
     */
    dueAt?: Date | null;
    /**
     * Optional: the IANA time zone the due time was entered in, such as America/Toronto.
     */
    dueTimeZoneId?: string | null;
    /**
     * The organization sales rep id of the rep the task is assigned to, or null to leave itunassigned. The full desired state is sent every time: omitting it unassigns the task.
     */
    organizationSalesRepId?: string | null;
    /**
     * Optional: OrgCodes from header for sales rep organization switching.
     */
    orgCodes?: string[] | null;
    /**
     * Low, Normal, High or Urgent.
     */
    priority?: TaskPriority | null;
    /**
     * What needs doing, up to 200 characters.
     */
    title?: string | null;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string | null;
}
/**
 * A vendor line's editable header, replaced as a whole: a null or blank field clears it. Read theline first (GET .../vendor-lines) and send every field back with the ones you change.
 */
export interface UpdateVendorLineHeaderRequest extends AdditionalDataHolder, Parsable, VendorLineRequest {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * One of the fulfillment methods the vendor accepts.
     */
    fulfillmentMethod?: string | null;
    /**
     * The note to the brand: only this vendor's order carries it. At most 1000 characters.
     */
    noteToVendor?: string | null;
    /**
     * One of the vendor's order types.
     */
    orderType?: string | null;
    /**
     * The PO number for this vendor's order.
     */
    poNumber?: string | null;
    /**
     * One of the vendor's price levels. A change reprices the line's items, except the ones a rep overrode.
     */
    priceLevel?: string | null;
    /**
     * One of the vendor's terms options. Null leaves the line "Terms needed".
     */
    terms?: string | null;
}
export interface UpdateVendorRequest extends AdditionalDataHolder, Parsable, VendorFieldsRequest {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface UploadManyImagesRequest extends Parsable {
    /**
     * The images property
     */
    images?: ImageUploadItem[] | null;
}
export interface User extends Parsable {
    /**
     * Gets or sets the email of the sales representative.
     */
    email?: string | null;
    /**
     * Gets or sets the first name of the sales representative.
     */
    firstName?: string | null;
    /**
     * Gets or sets the last name of the sales representative.
     */
    lastName?: string | null;
    /**
     * Gets or sets the password of the sales representative, this will be ignored if they already have an existing identity account.
     */
    password?: string | null;
    /**
     * Gets or sets the phone number of the sales representative.
     */
    phoneNumber?: string | null;
}
export interface User2 extends Parsable {
    /**
     * The identityProviderUserId property
     */
    identityProviderUserId?: string | null;
    /**
     * The userId property
     */
    userId?: string | null;
    /**
     * The userType property
     */
    userType?: UserTypes | null;
}
export interface User3 extends Parsable {
    /**
     * The identityProviderUserId property
     */
    identityProviderUserId?: string | null;
    /**
     * The userId property
     */
    userId?: string | null;
    /**
     * The userType property
     */
    userType?: UserTypes | null;
}
export interface UserCustomer extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The userCustomerId property
     */
    userCustomerId?: string | null;
    /**
     * The userId property
     */
    userId?: string | null;
}
export interface UserDto extends Parsable {
    /**
     * The identityProviderUserId property
     */
    identityProviderUserId?: string | null;
    /**
     * The userId property
     */
    userId?: string | null;
    /**
     * The userType property
     */
    userType?: string | null;
}
export interface UserExistsResponse extends Parsable {
    /**
     * The userExists property
     */
    userExists?: boolean | null;
}
export interface UserOrganizationDto extends Parsable {
    /**
     * The organization display name
     */
    name?: string | null;
    /**
     * The internal organization id
     */
    organizationId?: string | null;
    /**
     * The organization code, used to switch organizations at login (passed as the org_code login parameter)
     */
    orgCode?: string | null;
    /**
     * The user's role keys in this organization (e.g. "admin", "salesrep"). Empty if the user has no roles.
     */
    roles?: string[] | null;
}
export type UserTypes = (typeof UserTypesObject)[keyof typeof UserTypesObject];
export interface ValidateConfig_ValidateConfigResponse extends Parsable {
    /**
     * The env property
     */
    env?: string | null;
    /**
     * The identityConfigured property
     */
    identityConfigured?: boolean | null;
    /**
     * The identityMessage property
     */
    identityMessage?: string | null;
    /**
     * The keyVaultConfigured property
     */
    keyVaultConfigured?: boolean | null;
    /**
     * The keyVaultMessage property
     */
    keyVaultMessage?: string | null;
    /**
     * The syncGatewayConfigured property
     */
    syncGatewayConfigured?: boolean | null;
    /**
     * The syncGatewayMessage property
     */
    syncGatewayMessage?: string | null;
}
export interface ValidateIntegrationTemplateRequest extends Parsable {
    /**
     * The proposed non-secret settings, keyed as the provider's template names them.
     */
    configuration?: ValidateIntegrationTemplateRequest_configuration | null;
    /**
     * The provider to validate against, named as the template catalogue reports it.
     */
    provider?: string | null;
    /**
     * The proposed credentials, keyed as the provider's template names them. Only checked forpresence — they are not stored, and not sent to the provider.
     */
    secrets?: ValidateIntegrationTemplateRequest_secrets | null;
    /**
     * The category the provider belongs to.
     */
    type?: IntegrationType | null;
}
/**
 * The proposed non-secret settings, keyed as the provider's template names them.
 */
export interface ValidateIntegrationTemplateRequest_configuration extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * The proposed credentials, keyed as the provider's template names them. Only checked forpresence — they are not stored, and not sent to the provider.
 */
export interface ValidateIntegrationTemplateRequest_secrets extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface ValidateIntegrationTemplateResponse extends Parsable {
    /**
     * What is missing or wrong, one message per problem, phrased for display next to a form.Empty when the configuration is valid.
     */
    errors?: string[] | null;
    /**
     * Whether the configuration would satisfy the template. False is still returned with 200, sothis is the field to check rather than the status code.
     */
    isValid?: boolean | null;
}
export interface Vendor extends AdditionalDataHolder, BaseEntity, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The categoryIds property
     */
    categoryIds?: string[] | null;
    /**
     * The defaultCommissionRate property
     */
    defaultCommissionRate?: number | null;
    /**
     * The defaultMinimum property
     */
    defaultMinimum?: VendorMinimum | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The fulfillmentMethodIds property
     */
    fulfillmentMethodIds?: string[] | null;
    /**
     * The lifestyleImageUrl property
     */
    lifestyleImageUrl?: string | null;
    /**
     * The linkedOrganizationId property
     */
    linkedOrganizationId?: string | null;
    /**
     * The logoUrl property
     */
    logoUrl?: string | null;
    /**
     * The merchandisingTags property
     */
    merchandisingTags?: string[] | null;
    /**
     * The minimumsByProductGroup property
     */
    minimumsByProductGroup?: VendorMinimum[] | null;
    /**
     * The mustHaves property
     */
    mustHaves?: string[] | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The orderDeskEmail property
     */
    orderDeskEmail?: string | null;
    /**
     * The orderDestination property
     */
    orderDestination?: VendorOrderDestination | null;
    /**
     * The orderTypes property
     */
    orderTypes?: string[] | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The phone property
     */
    phone?: string | null;
    /**
     * The priceLevelIds property
     */
    priceLevelIds?: string[] | null;
    /**
     * The shipWindows property
     */
    shipWindows?: VendorShipWindow[] | null;
    /**
     * The showOnLineCard property
     */
    showOnLineCard?: boolean | null;
    /**
     * The slug property
     */
    slug?: string | null;
    /**
     * The termsOptions property
     */
    termsOptions?: string[] | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
    /**
     * The vendorId property
     */
    vendorId?: string | null;
    /**
     * The website property
     */
    website?: string | null;
}
/**
 * A request about one agency cart (Order Hub, CU-86bcx7m4r). Organization-scoped throughAgencyScopedRequest, so the agency gate resolves the organization (honouring arep's UseOrganizationId switch) before the handler runs.
 */
export interface VendorCartRequest extends AdditionalDataHolder, AgencyScopedRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * One row of a vendor's customer list: the customer's account with the vendor, and the customeritself as the customer endpoints return it, so a listing can show the number, name, contactsand addresses without a read per row.
 */
export interface VendorCustomerDto extends Parsable {
    /**
     * The customer's account with the vendor; its customerNumber is filled in when the customer was found.
     */
    account?: CustomerVendorAccountDto | null;
    /**
     * The customer, the same document GET /api/customers/{customerNumber} returns; null only when the account outlived the customer.
     */
    customer?: Customer | null;
}
/**
 * Everything about a vendor that can be written, shared by create and update. A write replacesthe whole vendor: a list left out of the body is stored empty, and a field left out is cleared,so send the complete vendor every time. The vendor code is not here — it is in the key andcannot change once set.
 */
export interface VendorFieldsRequest extends AdditionalDataHolder, AgencyScopedRequest, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * Ids in the organization's category tree the vendor's products fall under.
     */
    categoryIds?: string[] | null;
    /**
     * The commission rate as a fraction between 0 and 1 (0.05 for 5%), or null when the commission plan decides.
     */
    defaultCommissionRate?: number | null;
    /**
     * The vendor's default opening-order and reorder minimums; its productGroup must be null. Omit for no minimum.
     */
    defaultMinimum?: VendorMinimum | null;
    /**
     * The brand paragraph shown on the line card.
     */
    description?: string | null;
    /**
     * The organization's fulfillment methods this vendor accepts.
     */
    fulfillmentMethodIds?: string[] | null;
    /**
     * A lifestyle shot that represents the line. Copied into storage on save like the logo; upload afile through POST /api/vendors/{vendorCode}/images/lifestyle.
     */
    lifestyleImageUrl?: string | null;
    /**
     * The manufacturer's own organization on the platform, when it has one. Required for a NymbleOrganization order destination.
     */
    linkedOrganizationId?: string | null;
    /**
     * The vendor's logo. A URL anywhere but the platform's image storage (the website prefill'ssuggestion) is copied into storage on save and the stored URL is kept; a URL that cannot becopied is refused with 400. Upload a file through POST /api/vendors/{vendorCode}/images/logo.
     */
    logoUrl?: string | null;
    /**
     * Merchandising tags such as "new-brand", "made-in-usa" or "ready-to-ship".
     */
    merchandisingTags?: string[] | null;
    /**
     * Minimums that apply to a named product group instead of the default.
     */
    minimumsByProductGroup?: VendorMinimum[] | null;
    /**
     * The vendor's must-have items, as free text.
     */
    mustHaves?: string[] | null;
    /**
     * The vendor's display name, up to 200 characters, e.g. "Halden & Co.".
     */
    name?: string | null;
    /**
     * The order desk email address.
     */
    orderDeskEmail?: string | null;
    /**
     * Where a placed order for this vendor goes. Omit for an email destination with no addresses yet.
     */
    orderDestination?: VendorOrderDestination | null;
    /**
     * The order type codes this vendor accepts.
     */
    orderTypes?: string[] | null;
    /**
     * The phone property
     */
    phone?: string | null;
    /**
     * The organization's price levels offered at this vendor; a customer's account picks one of these.
     */
    priceLevelIds?: string[] | null;
    /**
     * Named ship windows with ship and cancel dates. Names must be unique; at most one window is the default.
     */
    shipWindows?: VendorShipWindow[] | null;
    /**
     * Whether the vendor appears on the public line card. Defaults to true.
     */
    showOnLineCard?: boolean | null;
    /**
     * The line-card URL segment. Blank derives it from the name.
     */
    slug?: string | null;
    /**
     * The payment terms a customer can hold with this vendor, e.g. "NET30", "NET60", "PREPAY".
     */
    termsOptions?: string[] | null;
    /**
     * The website property
     */
    website?: string | null;
}
/**
 * One vendor's line: its header, its computed status and money, and the vendor's option listsfor the pickers. Options is null when the vendor's document cannot be read (avendor deleted since the line was opened); the line itself still shows.
 */
export interface VendorLineDto extends Parsable {
    /**
     * The cancelDate property
     */
    cancelDate?: DateOnly | null;
    /**
     * The discountAmount property
     */
    discountAmount?: number | null;
    /**
     * The discountPercent property
     */
    discountPercent?: number | null;
    /**
     * The fulfillmentMethod property
     */
    fulfillmentMethod?: string | null;
    /**
     * The isOpeningOrder property
     */
    isOpeningOrder?: boolean | null;
    /**
     * The itemCount property
     */
    itemCount?: number | null;
    /**
     * The itemLineIds property
     */
    itemLineIds?: string[] | null;
    /**
     * The minimumAmount property
     */
    minimumAmount?: number | null;
    /**
     * The noteToVendor property
     */
    noteToVendor?: string | null;
    /**
     * The options property
     */
    options?: VendorLineOptionsDto | null;
    /**
     * The orderType property
     */
    orderType?: string | null;
    /**
     * The poNumber property
     */
    poNumber?: string | null;
    /**
     * The priceLevel property
     */
    priceLevel?: string | null;
    /**
     * The savedForLater property
     */
    savedForLater?: boolean | null;
    /**
     * The shipDate property
     */
    shipDate?: DateOnly | null;
    /**
     * The shipWindowName property
     */
    shipWindowName?: string | null;
    /**
     * The status property
     */
    status?: CartLineStatus | null;
    /**
     * The subtotal property
     */
    subtotal?: number | null;
    /**
     * The terms property
     */
    terms?: string | null;
    /**
     * The total property
     */
    total?: number | null;
    /**
     * The vendorCode property
     */
    vendorCode?: string | null;
    /**
     * The vendorLogoUrl property
     */
    vendorLogoUrl?: string | null;
    /**
     * The vendorName property
     */
    vendorName?: string | null;
}
/**
 * The vendor's option lists a line's header picks from.
 */
export interface VendorLineOptionsDto extends Parsable {
    /**
     * The fulfillmentMethodIds property
     */
    fulfillmentMethodIds?: string[] | null;
    /**
     * The openingOrderMinimum property
     */
    openingOrderMinimum?: number | null;
    /**
     * The orderTypes property
     */
    orderTypes?: string[] | null;
    /**
     * The priceLevelIds property
     */
    priceLevelIds?: string[] | null;
    /**
     * The reorderMinimum property
     */
    reorderMinimum?: number | null;
    /**
     * The shipWindows property
     */
    shipWindows?: VendorShipWindow[] | null;
    /**
     * The termsOptions property
     */
    termsOptions?: string[] | null;
}
/**
 * A request about one vendor line of an agency cart, named by its vendor code (route).
 */
export interface VendorLineRequest extends AdditionalDataHolder, Parsable, VendorCartRequest {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * An agency cart's vendor lines with what the line cards' pickers offer (Order Hub, CU-86bcx7m4r).
 */
export interface VendorLinesResponse extends Parsable {
    /**
     * The customerNumber property
     */
    customerNumber?: string | null;
    /**
     * The lines property
     */
    lines?: VendorLineDto[] | null;
    /**
     * The receiptTo property
     */
    receiptTo?: string[] | null;
    /**
     * The shoppingCartId property
     */
    shoppingCartId?: string | null;
}
export interface VendorMinimum extends Parsable {
    /**
     * The openingOrder property
     */
    openingOrder?: number | null;
    /**
     * The productGroup property
     */
    productGroup?: string | null;
    /**
     * The reorder property
     */
    reorder?: number | null;
}
export interface VendorOrderDestination extends Parsable {
    /**
     * The ediDestination property
     */
    ediDestination?: string | null;
    /**
     * The ediFormat property
     */
    ediFormat?: string | null;
    /**
     * The emailTo property
     */
    emailTo?: string[] | null;
    /**
     * The pushUrl property
     */
    pushUrl?: string | null;
    /**
     * The type property
     */
    type?: OrderDestinationType | null;
}
export interface VendorPrefillHints extends Parsable {
    /**
     * The openingOrderMinimum property
     */
    openingOrderMinimum?: number | null;
    /**
     * The reorderMinimum property
     */
    reorderMinimum?: number | null;
    /**
     * The termsText property
     */
    termsText?: string | null;
}
/**
 * What the prefill suggests for the vendor form (CU-86bcx059z). Suggestions only: nothing issaved by producing them, and every field may be null or empty when the site did not say.fields says, per filled field, whether it came from the page's own metadata or from theAI pass, with a confidence and the page text behind it.
 */
export interface VendorPrefillSuggestions extends Parsable {
    /**
     * Ids of the organization's own categories the brand's products belong in, chosen from the category list.
     */
    categoryIds?: string[] | null;
    /**
     * Two to three sentences in the line-card house style, written by the AI pass; the page's own description when the AI pass did not run.
     */
    description?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * Per filled field: where it came from, how sure, and the page text behind it. Keys are the field names of this object.
     */
    fields?: VendorPrefillSuggestions_fields | null;
    /**
     * Commercial terms a wholesale or trade page states. For a person to read and confirm; never filled into the form automatically. Null when no page states them.
     */
    hints?: VendorPrefillHints | null;
    /**
     * A logo or icon URL as the site publishes it, from metadata only and verified: the first of thepage's declared candidates (structured-data logo, touch icon, og:image, icon, favicon) thatanswers with an image. Null when none does — never an unverified URL. Not re-hosted here.
     */
    logoUrl?: string | null;
    /**
     * Merchandising tags from the fixed vocabulary, only when the pages state the fact.
     */
    merchandisingTags?: string[] | null;
    /**
     * Up to three hero products or collections the pages name; empty when they name none.
     */
    mustHaves?: string[] | null;
    /**
     * The brand name. Structured data wins over the AI; the AI fills in when the page has none.
     */
    name?: string | null;
    /**
     * The pages that were read, in order, after redirects.
     */
    pagesRead?: string[] | null;
    /**
     * The phone property
     */
    phone?: string | null;
    /**
     * ai when the AI pass contributed, metadata when only the page's own data did, none when nothing was found.
     */
    source?: string | null;
    /**
     * A suggested vendor code: 2 to 8 upper-case letters or digits, not yet used by any vendor ofthe organization (active or deactivated). From the AI pass, or derived from the brand namewhen the AI pass gave none that is free. For a new vendor only; a code never changes afterwards.
     */
    vendorCode?: string | null;
    /**
     * Up to two further free candidates, in the AI pass's order of preference.
     */
    vendorCodeAlternatives?: string[] | null;
    /**
     * Why a suggestion set is thinner than expected: a slow site, an oversized page, an AI service that did not answer.
     */
    warnings?: string[] | null;
    /**
     * The homepage that was read, after redirects.
     */
    website?: string | null;
}
/**
 * Per filled field: where it came from, how sure, and the page text behind it. Keys are the field names of this object.
 */
export interface VendorPrefillSuggestions_fields extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
export interface VendorShipWindow extends Parsable {
    /**
     * The cancelDate property
     */
    cancelDate?: DateOnly | null;
    /**
     * The isDefault property
     */
    isDefault?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The shipDate property
     */
    shipDate?: DateOnly | null;
}
export interface ViewCartShareMessageResponse extends Parsable {
    /**
     * The rep's note to the customer.
     */
    body?: string | null;
    /**
     * The cart as it was when shared. Amounts are raw decimals in the cart's currency.
     */
    cart?: CartShareSnapshot | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The messageId property
     */
    messageId?: string | null;
    /**
     * The organization property
     */
    organization?: OrganizationInfo | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The senderEmail property
     */
    senderEmail?: string | null;
    /**
     * The senderName property
     */
    senderName?: string | null;
    /**
     * The sentAt property
     */
    sentAt?: Date | null;
    /**
     * The subject property
     */
    subject?: string | null;
    /**
     * The viewOnlineUrl property
     */
    viewOnlineUrl?: string | null;
}
export interface ViewCompanyDocsMessageResponse extends Parsable {
    /**
     * The attachments property
     */
    attachments?: MessageAttachment[] | null;
    /**
     * The body property
     */
    body?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The deliveryStatus property
     */
    deliveryStatus?: DeliveryStatus | null;
    /**
     * The messageId property
     */
    messageId?: string | null;
    /**
     * The metadata property
     */
    metadata?: MessageMetadata | null;
    /**
     * The organization property
     */
    organization?: OrganizationInfo | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The senderEmail property
     */
    senderEmail?: string | null;
    /**
     * The senderName property
     */
    senderName?: string | null;
    /**
     * The sentAt property
     */
    sentAt?: Date | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The subject property
     */
    subject?: string | null;
    /**
     * The viewOnlineUrl property
     */
    viewOnlineUrl?: string | null;
}
export interface ViewTearSheetsMessageResponse extends Parsable {
    /**
     * The body property
     */
    body?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The deliveryStatus property
     */
    deliveryStatus?: DeliveryStatus | null;
    /**
     * The messageId property
     */
    messageId?: string | null;
    /**
     * The metadata property
     */
    metadata?: MessageMetadata | null;
    /**
     * The organization property
     */
    organization?: OrganizationInfo | null;
    /**
     * The organizationId property
     */
    organizationId?: string | null;
    /**
     * The products property
     */
    products?: Product[] | null;
    /**
     * The senderEmail property
     */
    senderEmail?: string | null;
    /**
     * The senderName property
     */
    senderName?: string | null;
    /**
     * The sentAt property
     */
    sentAt?: Date | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The subject property
     */
    subject?: string | null;
    /**
     * The tearSheet property
     */
    tearSheet?: TearSheet | null;
    /**
     * The viewOnlineUrl property
     */
    viewOnlineUrl?: string | null;
}
export interface VoidInvoiceRequest extends Parsable {
    /**
     * The orgCodes property
     */
    orgCodes?: string[] | null;
    /**
     * The useOrganizationId property
     */
    useOrganizationId?: string | null;
}
export const AccessRequestStatusObject = {
    Pending: "Pending",
    Approved: "Approved",
    Declined: "Declined",
} as const;
export const AddressTypeObject = {
    Company: "Company",
    Billing: "Billing",
    Shipping: "Shipping",
} as const;
export const BenefitKindObject = {
    OrderDiscount: "OrderDiscount",
    LineDiscount: "LineDiscount",
    FreeGift: "FreeGift",
    FreeShipping: "FreeShipping",
} as const;
/**
 * What happened to a single row of a bulk customer-user import.
 */
export const BulkImportCustomerUserOutcomeObject = {
    Created: "Created",
    AlreadyExisted: "AlreadyExisted",
    Failed: "Failed",
} as const;
export const CampaignTriggerObject = {
    Automatic: "Automatic",
    Code: "Code",
} as const;
export const CartActorTypeObject = {
    Unknown: "Unknown",
    Customer: "Customer",
    Rep: "Rep",
    System: "System",
    Admin: "Admin",
} as const;
export const CartEventActionObject = {
    LineAdded: "LineAdded",
    LineQuantityChanged: "LineQuantityChanged",
    LineRemoved: "LineRemoved",
    LineNoteChanged: "LineNoteChanged",
    LinePriceOverridden: "LinePriceOverridden",
    LinePriceOverrideCleared: "LinePriceOverrideCleared",
    LineDiscountApplied: "LineDiscountApplied",
    LineDiscountRemoved: "LineDiscountRemoved",
    CartDiscountApplied: "CartDiscountApplied",
    CartDiscountRemoved: "CartDiscountRemoved",
    CodeApplied: "CodeApplied",
    CodeRemoved: "CodeRemoved",
    PricesRefreshed: "PricesRefreshed",
    ReviewRequested: "ReviewRequested",
    ReviewReturned: "ReviewReturned",
    ReviewRecalled: "ReviewRecalled",
    Transferred: "Transferred",
    Duplicated: "Duplicated",
    Submitted: "Submitted",
    Shared: "Shared",
    ShareOpened: "ShareOpened",
    VendorLineHeaderChanged: "VendorLineHeaderChanged",
    VendorLineShipWindowChanged: "VendorLineShipWindowChanged",
    VendorLineDiscountChanged: "VendorLineDiscountChanged",
    VendorLineSavedForLater: "VendorLineSavedForLater",
    VendorLineRestored: "VendorLineRestored",
    VendorLineRemoved: "VendorLineRemoved",
    VendorLineSplitOut: "VendorLineSplitOut",
    VendorLineSplitIn: "VendorLineSplitIn",
} as const;
export const CartLineStatusObject = {
    Ready: "Ready",
    TermsNeeded: "TermsNeeded",
    UnderMinimum: "UnderMinimum",
} as const;
/**
 * The state a connector last reported for itself. Nothing changes it on the connector's behalf, soa connector that has stopped calling home keeps its last reported value — judge liveness fromlastHeartbeatAt instead.
 */
export const ConnectorStatusTypeObject = {
    Online: "Online",
    Offline: "Offline",
    ErrorEscaped: "Error",
} as const;
export const ContactTypeObject = {
    Company: "Company",
    Billing: "Billing",
    Shipping: "Shipping",
    Buyer: "Buyer",
} as const;
export const CurrencyCodeObject = {
    USD: "USD",
    CAD: "CAD",
    MXN: "MXN",
    EUR: "EUR",
} as const;
export const DiscountPermissionObject = {
    Inherit: "Inherit",
    Allow: "Allow",
    Deny: "Deny",
} as const;
export const DiscountTypeObject = {
    Amount: "Amount",
    Percentage: "Percentage",
} as const;
export const ExportEntityObject = {
    None: "None",
    Order: "Order",
    Product: "Product",
    Customer: "Customer",
} as const;
export const ExportTypesObject = {
    None: "None",
    Json: "Json",
    Csv: "Csv",
    Sap: "Sap",
    TabDelimited: "TabDelimited",
    Custom: "Custom",
} as const;
/**
 * What kind of input a configuration field takes, so a setup form can render the right control.
 */
export const FieldTypeObject = {
    Text: "Text",
    Password: "Password",
    Boolean: "Boolean",
    Select: "Select",
    Url: "Url",
    Email: "Email",
    Number: "Number",
    TextArea: "TextArea",
} as const;
export const ImageFormatObject = {
    Unknown: "unknown",
    Jpg: "jpg",
    Png: "png",
    Jpeg: "jpeg",
    Webp: "webp",
    Gif: "gif",
    Svg: "svg",
} as const;
/**
 * How an integration fared the last time its connection was tested. Independent of whether theintegration is enabled: an enabled integration can still be failing.
 */
export const IntegrationTestStatusObject = {
    Unknown: "Unknown",
    Success: "Success",
    Failed: "Failed",
    InProgress: "InProgress",
} as const;
/**
 * What an integration is for. It groups the provider catalogue and, together with the providername, identifies which template an integration is created against.
 */
export const IntegrationTypeObject = {
    Payment: "Payment",
    Accounting: "Accounting",
    Shipping: "Shipping",
    Email: "Email",
    Sms: "Sms",
    Analytics: "Analytics",
    Crm: "Crm",
    Inventory: "Inventory",
} as const;
export const InvoiceStatusObject = {
    Draft: "Draft",
    Issued: "Issued",
    PartiallyPaid: "PartiallyPaid",
    Paid: "Paid",
    Voided: "Voided",
    Cancelled: "Cancelled",
} as const;
export const OrderDestinationTypeObject = {
    Email: "Email",
    Edi: "Edi",
    ApiPush: "ApiPush",
    NymbleOrganization: "NymbleOrganization",
} as const;
export const OrderKindObject = {
    Order: "Order",
    Quote: "Quote",
    Sample: "Sample",
    NoCharge: "NoCharge",
    PreBook: "PreBook",
    DropShip: "DropShip",
    SpecialOrder: "SpecialOrder",
    Rma: "Rma",
    CreditMemo: "CreditMemo",
    Exchange: "Exchange",
    InventoryCount: "InventoryCount",
} as const;
export const OrganizationTypeObject = {
    Supplier: "Supplier",
    Agency: "Agency",
} as const;
export const PaymentMethod2Object = {
    CreditCard: "CreditCard",
    DebitCard: "DebitCard",
    Ach: "Ach",
    Wire: "Wire",
    Check: "Check",
    Cash: "Cash",
    StoreCredit: "StoreCredit",
    Other: "Other",
} as const;
export const PaymentStatusObject = {
    Pending: "Pending",
    Completed: "Completed",
    Failed: "Failed",
    PartiallyRefunded: "PartiallyRefunded",
    Refunded: "Refunded",
} as const;
export const ProductOptionDisplayStyleObject = {
    Pill: "Pill",
    Swatch: "Swatch",
} as const;
export const ProductTypeObject = {
    DefaultEscaped: "Default",
} as const;
export const PromotionMeasureObject = {
    Subtotal: "Subtotal",
    Quantity: "Quantity",
} as const;
export const PromotionSkipReasonObject = {
    NotFound: "NotFound",
    Inactive: "Inactive",
    NotStarted: "NotStarted",
    Expired: "Expired",
    Exhausted: "Exhausted",
    CustomerLimitReached: "CustomerLimitReached",
    CustomerNotEligible: "CustomerNotEligible",
    ChannelNotAllowed: "ChannelNotAllowed",
    MarketNotEligible: "MarketNotEligible",
    OrderTypeNotEligible: "OrderTypeNotEligible",
    NoEligibleLines: "NoEligibleLines",
    ConditionNotMet: "ConditionNotMet",
    SlotOccupied: "SlotOccupied",
    GiftUnavailable: "GiftUnavailable",
    Superseded: "Superseded",
} as const;
export const QueryFilter_OperatorTypeObject = {
    StartsWith: "StartsWith",
    Contains: "Contains",
    NotContains: "NotContains",
    EndsWith: "EndsWith",
    Equals: "Equals",
    NotEquals: "NotEquals",
    Lt: "Lt",
    Lte: "Lte",
    Gt: "Gt",
    Gte: "Gte",
} as const;
export const SourcingBasisObject = {
    Destination: "Destination",
    Origin: "Origin",
} as const;
export const TagKindObject = {
    Product: "Product",
    Category: "Category",
} as const;
export const TaskItemStatusObject = {
    Open: "Open",
    InProgress: "InProgress",
    Completed: "Completed",
    Cancelled: "Cancelled",
} as const;
export const TaskPriorityObject = {
    Low: "Low",
    Normal: "Normal",
    High: "High",
    Urgent: "Urgent",
} as const;
/**
 * How an import provisions passwords for the users it creates.Whichever mode is used, the password is never delivered to the user — distributing it isthe operator's job.
 */
export const TemporaryPasswordModeObject = {
    None: "None",
    Supplied: "Supplied",
    Generated: "Generated",
} as const;
export const UserTypesObject = {
    None: "None",
    SalesRep: "SalesRep",
    Customer: "Customer",
    Employee: "Employee",
} as const;
/* tslint:enable */
/* eslint-enable */
